/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateClientInput = {
  id?: string | null,
  status?: boolean | null,
  business_name: string,
  comertial_name: string,
  logo?: FileInput | null,
  grayLogo?: FileInput | null,
  contact?: ContactInput | null,
  address?: AddressInput | null,
  buyerInfo?: OrderBuyerInput | null,
  buyersInfo?: Array< OrderBuyerInput | null > | null,
  biography?: string | null,
  plan?: string | null,
  fee?: number | null,
  increment?: number | null,
  mercadoFee?: number | null,
  mercadoIncrement?: number | null,
  popFee?: number | null,
  popIncrement?: number | null,
  printedFee?: number | null,
  printedIncrement?: number | null,
  users?: Array< string | null > | null,
  restrictedUsers?: Array< string | null > | null,
  nonRestrictedUsers?: Array< string | null > | null,
  regions?: Array< string | null > | null,
  providers?: Array< string | null > | null,
  popProviders?: Array< string | null > | null,
  printedProviders?: Array< string | null > | null,
  logisticFrequency?: number | null,
  agents?: Array< AgentInput | null > | null,
  administrators?: Array< AgentInput | null > | null,
  signDocument?: Array< SignInput | null > | null,
  legal_representative?: string | null,
  legal_representative_email?: string | null,
  legal_representative_address?: string | null,
  tcdUsers?: Array< string | null > | null,
  billingUsers?: Array< AgentInput | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type FileInput = {
  key?: string | null,
  url?: string | null,
  color?: string | null,
  palette?: string | null,
  colorName?: string | null,
};

export type ContactInput = {
  first_name?: string | null,
  last_name?: string | null,
  email?: string | null,
  mobile_phone?: string | null,
  local_phone?: string | null,
};

export type AddressInput = {
  street?: string | null,
  outdoor_number?: string | null,
  inside_number?: string | null,
  colony?: string | null,
  delegation?: string | null,
  state?: string | null,
  city?: string | null,
  postal_code?: string | null,
  chain?: string | null,
  name?: string | null,
  description?: string | null,
};

export type OrderBuyerInput = {
  name: string,
  email: string,
  authorized?: boolean | null,
};

export type AgentInput = {
  id?: string | null,
  name?: string | null,
  email?: string | null,
  phoneNumber?: string | null,
};

export type SignInput = {
  url?: string | null,
  enabled?: boolean | null,
};

export type ModelClientConditionInput = {
  status?: ModelBooleanInput | null,
  business_name?: ModelStringInput | null,
  comertial_name?: ModelStringInput | null,
  biography?: ModelStringInput | null,
  plan?: ModelStringInput | null,
  fee?: ModelFloatInput | null,
  increment?: ModelFloatInput | null,
  mercadoFee?: ModelFloatInput | null,
  mercadoIncrement?: ModelFloatInput | null,
  popFee?: ModelFloatInput | null,
  popIncrement?: ModelFloatInput | null,
  printedFee?: ModelFloatInput | null,
  printedIncrement?: ModelFloatInput | null,
  users?: ModelStringInput | null,
  restrictedUsers?: ModelStringInput | null,
  nonRestrictedUsers?: ModelStringInput | null,
  regions?: ModelStringInput | null,
  providers?: ModelStringInput | null,
  popProviders?: ModelStringInput | null,
  printedProviders?: ModelStringInput | null,
  logisticFrequency?: ModelIntInput | null,
  legal_representative?: ModelStringInput | null,
  legal_representative_email?: ModelStringInput | null,
  legal_representative_address?: ModelStringInput | null,
  tcdUsers?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelClientConditionInput | null > | null,
  or?: Array< ModelClientConditionInput | null > | null,
  not?: ModelClientConditionInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type Client = {
  __typename: "Client",
  id: string,
  status?: boolean | null,
  business_name: string,
  comertial_name: string,
  logo?: File | null,
  grayLogo?: File | null,
  contact?: Contact | null,
  address?: Address | null,
  buyerInfo?: OrderBuyer | null,
  buyersInfo?:  Array<OrderBuyer | null > | null,
  biography?: string | null,
  plan?: string | null,
  fee?: number | null,
  increment?: number | null,
  mercadoFee?: number | null,
  mercadoIncrement?: number | null,
  popFee?: number | null,
  popIncrement?: number | null,
  printedFee?: number | null,
  printedIncrement?: number | null,
  users?: Array< string | null > | null,
  restrictedUsers?: Array< string | null > | null,
  nonRestrictedUsers?: Array< string | null > | null,
  regions?: Array< string | null > | null,
  providers?: Array< string | null > | null,
  popProviders?: Array< string | null > | null,
  printedProviders?: Array< string | null > | null,
  logisticFrequency?: number | null,
  agents?:  Array<Agent | null > | null,
  administrators?:  Array<Agent | null > | null,
  signDocument?:  Array<Sign | null > | null,
  legal_representative?: string | null,
  legal_representative_email?: string | null,
  legal_representative_address?: string | null,
  tcdUsers?: Array< string | null > | null,
  billingUsers?:  Array<Agent | null > | null,
  createdAt: string,
  updatedAt?: string | null,
};

export type File = {
  __typename: "File",
  key?: string | null,
  url?: string | null,
  color?: string | null,
  palette?: string | null,
  colorName?: string | null,
};

export type Contact = {
  __typename: "Contact",
  first_name?: string | null,
  last_name?: string | null,
  email?: string | null,
  mobile_phone?: string | null,
  local_phone?: string | null,
};

export type Address = {
  __typename: "Address",
  street?: string | null,
  outdoor_number?: string | null,
  inside_number?: string | null,
  colony?: string | null,
  delegation?: string | null,
  state?: string | null,
  city?: string | null,
  postal_code?: string | null,
  chain?: string | null,
  name?: string | null,
  description?: string | null,
};

export type OrderBuyer = {
  __typename: "OrderBuyer",
  name: string,
  email: string,
  authorized?: boolean | null,
};

export type Agent = {
  __typename: "Agent",
  id?: string | null,
  name?: string | null,
  email?: string | null,
  phoneNumber?: string | null,
};

export type Sign = {
  __typename: "Sign",
  url?: string | null,
  enabled?: boolean | null,
};

export type UpdateClientInput = {
  id: string,
  status?: boolean | null,
  business_name?: string | null,
  comertial_name?: string | null,
  logo?: FileInput | null,
  grayLogo?: FileInput | null,
  contact?: ContactInput | null,
  address?: AddressInput | null,
  buyerInfo?: OrderBuyerInput | null,
  buyersInfo?: Array< OrderBuyerInput | null > | null,
  biography?: string | null,
  plan?: string | null,
  fee?: number | null,
  increment?: number | null,
  mercadoFee?: number | null,
  mercadoIncrement?: number | null,
  popFee?: number | null,
  popIncrement?: number | null,
  printedFee?: number | null,
  printedIncrement?: number | null,
  users?: Array< string | null > | null,
  restrictedUsers?: Array< string | null > | null,
  nonRestrictedUsers?: Array< string | null > | null,
  regions?: Array< string | null > | null,
  providers?: Array< string | null > | null,
  popProviders?: Array< string | null > | null,
  printedProviders?: Array< string | null > | null,
  logisticFrequency?: number | null,
  agents?: Array< AgentInput | null > | null,
  administrators?: Array< AgentInput | null > | null,
  signDocument?: Array< SignInput | null > | null,
  legal_representative?: string | null,
  legal_representative_email?: string | null,
  legal_representative_address?: string | null,
  tcdUsers?: Array< string | null > | null,
  billingUsers?: Array< AgentInput | null > | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteClientInput = {
  id: string,
};

export type CreateClientSettingInput = {
  id?: string | null,
  crmJiraId?: string | null,
  orderBudget?: number | null,
  domain?: string | null,
  filterColors?: Array< string | null > | null,
  primaryColors?: Array< string | null > | null,
  accentColors?: Array< string | null > | null,
  createdAt?: string | null,
};

export type ModelClientSettingConditionInput = {
  crmJiraId?: ModelStringInput | null,
  orderBudget?: ModelFloatInput | null,
  domain?: ModelStringInput | null,
  filterColors?: ModelStringInput | null,
  primaryColors?: ModelStringInput | null,
  accentColors?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelClientSettingConditionInput | null > | null,
  or?: Array< ModelClientSettingConditionInput | null > | null,
  not?: ModelClientSettingConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ClientSetting = {
  __typename: "ClientSetting",
  id: string,
  crmJiraId?: string | null,
  orderBudget?: number | null,
  domain?: string | null,
  filterColors?: Array< string | null > | null,
  primaryColors?: Array< string | null > | null,
  accentColors?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateClientSettingInput = {
  id: string,
  crmJiraId?: string | null,
  orderBudget?: number | null,
  domain?: string | null,
  filterColors?: Array< string | null > | null,
  primaryColors?: Array< string | null > | null,
  accentColors?: Array< string | null > | null,
  createdAt?: string | null,
};

export type DeleteClientSettingInput = {
  id: string,
};

export type CreateClientOptionInput = {
  id?: string | null,
  pakmail?: boolean | null,
  orderVat?: boolean | null,
  hasMercado?: boolean | null,
  hasAmazon?: boolean | null,
  hasAutomobiles?: boolean | null,
  publicDashboards?: boolean | null,
  printPrices?: boolean | null,
  logisticPrices?: boolean | null,
  hidePricesAndFlow?: boolean | null,
  showPhones?: boolean | null,
  fullCoupaDescriptions?: boolean | null,
  isPremium?: boolean | null,
  isPop?: boolean | null,
  isPrinted?: boolean | null,
  allPremiumRfqs?: boolean | null,
  allPopRfqs?: boolean | null,
  allPrintedRfqs?: boolean | null,
  autoUpdateHomePage?: boolean | null,
  showVat?: boolean | null,
  requiredDeliveryInfo?: boolean | null,
  restrictedCatalogue?: boolean | null,
  excludeCoupa?: boolean | null,
  tcdPayment?: boolean | null,
  automaticLogisticGuides?: boolean | null,
  transferencePayment?: boolean | null,
  customCatalogue?: boolean | null,
  disableProjectDescriptions?: boolean | null,
  showBranding?: boolean | null,
  customCostCenter?: boolean | null,
  couponsEnabled?: boolean | null,
  showChat?: boolean | null,
  hasCrmSync?: boolean | null,
  onlyQuotes?: boolean | null,
  autoSaveDeliveryInfo?: boolean | null,
  limitMaxRequestOnDiscounts?: boolean | null,
  freeLocalShipping?: boolean | null,
  discountShipping?: boolean | null,
  printingBreakdown?: boolean | null,
  skipAlendum?: boolean | null,
  skipFMS?: boolean | null,
  clientReminders?: boolean | null,
};

export type ModelClientOptionConditionInput = {
  pakmail?: ModelBooleanInput | null,
  orderVat?: ModelBooleanInput | null,
  hasMercado?: ModelBooleanInput | null,
  hasAmazon?: ModelBooleanInput | null,
  hasAutomobiles?: ModelBooleanInput | null,
  publicDashboards?: ModelBooleanInput | null,
  printPrices?: ModelBooleanInput | null,
  logisticPrices?: ModelBooleanInput | null,
  hidePricesAndFlow?: ModelBooleanInput | null,
  showPhones?: ModelBooleanInput | null,
  fullCoupaDescriptions?: ModelBooleanInput | null,
  isPremium?: ModelBooleanInput | null,
  isPop?: ModelBooleanInput | null,
  isPrinted?: ModelBooleanInput | null,
  allPremiumRfqs?: ModelBooleanInput | null,
  allPopRfqs?: ModelBooleanInput | null,
  allPrintedRfqs?: ModelBooleanInput | null,
  autoUpdateHomePage?: ModelBooleanInput | null,
  showVat?: ModelBooleanInput | null,
  requiredDeliveryInfo?: ModelBooleanInput | null,
  restrictedCatalogue?: ModelBooleanInput | null,
  excludeCoupa?: ModelBooleanInput | null,
  tcdPayment?: ModelBooleanInput | null,
  automaticLogisticGuides?: ModelBooleanInput | null,
  transferencePayment?: ModelBooleanInput | null,
  customCatalogue?: ModelBooleanInput | null,
  disableProjectDescriptions?: ModelBooleanInput | null,
  showBranding?: ModelBooleanInput | null,
  customCostCenter?: ModelBooleanInput | null,
  couponsEnabled?: ModelBooleanInput | null,
  showChat?: ModelBooleanInput | null,
  hasCrmSync?: ModelBooleanInput | null,
  onlyQuotes?: ModelBooleanInput | null,
  autoSaveDeliveryInfo?: ModelBooleanInput | null,
  limitMaxRequestOnDiscounts?: ModelBooleanInput | null,
  freeLocalShipping?: ModelBooleanInput | null,
  discountShipping?: ModelBooleanInput | null,
  printingBreakdown?: ModelBooleanInput | null,
  skipAlendum?: ModelBooleanInput | null,
  skipFMS?: ModelBooleanInput | null,
  clientReminders?: ModelBooleanInput | null,
  and?: Array< ModelClientOptionConditionInput | null > | null,
  or?: Array< ModelClientOptionConditionInput | null > | null,
  not?: ModelClientOptionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ClientOption = {
  __typename: "ClientOption",
  id: string,
  pakmail?: boolean | null,
  orderVat?: boolean | null,
  hasMercado?: boolean | null,
  hasAmazon?: boolean | null,
  hasAutomobiles?: boolean | null,
  publicDashboards?: boolean | null,
  printPrices?: boolean | null,
  logisticPrices?: boolean | null,
  hidePricesAndFlow?: boolean | null,
  showPhones?: boolean | null,
  fullCoupaDescriptions?: boolean | null,
  isPremium?: boolean | null,
  isPop?: boolean | null,
  isPrinted?: boolean | null,
  allPremiumRfqs?: boolean | null,
  allPopRfqs?: boolean | null,
  allPrintedRfqs?: boolean | null,
  autoUpdateHomePage?: boolean | null,
  showVat?: boolean | null,
  requiredDeliveryInfo?: boolean | null,
  restrictedCatalogue?: boolean | null,
  excludeCoupa?: boolean | null,
  tcdPayment?: boolean | null,
  automaticLogisticGuides?: boolean | null,
  transferencePayment?: boolean | null,
  customCatalogue?: boolean | null,
  disableProjectDescriptions?: boolean | null,
  showBranding?: boolean | null,
  customCostCenter?: boolean | null,
  couponsEnabled?: boolean | null,
  showChat?: boolean | null,
  hasCrmSync?: boolean | null,
  onlyQuotes?: boolean | null,
  autoSaveDeliveryInfo?: boolean | null,
  limitMaxRequestOnDiscounts?: boolean | null,
  freeLocalShipping?: boolean | null,
  discountShipping?: boolean | null,
  printingBreakdown?: boolean | null,
  skipAlendum?: boolean | null,
  skipFMS?: boolean | null,
  clientReminders?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateClientOptionInput = {
  id: string,
  pakmail?: boolean | null,
  orderVat?: boolean | null,
  hasMercado?: boolean | null,
  hasAmazon?: boolean | null,
  hasAutomobiles?: boolean | null,
  publicDashboards?: boolean | null,
  printPrices?: boolean | null,
  logisticPrices?: boolean | null,
  hidePricesAndFlow?: boolean | null,
  showPhones?: boolean | null,
  fullCoupaDescriptions?: boolean | null,
  isPremium?: boolean | null,
  isPop?: boolean | null,
  isPrinted?: boolean | null,
  allPremiumRfqs?: boolean | null,
  allPopRfqs?: boolean | null,
  allPrintedRfqs?: boolean | null,
  autoUpdateHomePage?: boolean | null,
  showVat?: boolean | null,
  requiredDeliveryInfo?: boolean | null,
  restrictedCatalogue?: boolean | null,
  excludeCoupa?: boolean | null,
  tcdPayment?: boolean | null,
  automaticLogisticGuides?: boolean | null,
  transferencePayment?: boolean | null,
  customCatalogue?: boolean | null,
  disableProjectDescriptions?: boolean | null,
  showBranding?: boolean | null,
  customCostCenter?: boolean | null,
  couponsEnabled?: boolean | null,
  showChat?: boolean | null,
  hasCrmSync?: boolean | null,
  onlyQuotes?: boolean | null,
  autoSaveDeliveryInfo?: boolean | null,
  limitMaxRequestOnDiscounts?: boolean | null,
  freeLocalShipping?: boolean | null,
  discountShipping?: boolean | null,
  printingBreakdown?: boolean | null,
  skipAlendum?: boolean | null,
  skipFMS?: boolean | null,
  clientReminders?: boolean | null,
};

export type DeleteClientOptionInput = {
  id: string,
};

export type CreateProviderInput = {
  id?: string | null,
  isApproved?: boolean | null,
  logo?: FileInput | null,
  grayLogo?: FileInput | null,
  comertial_name?: string | null,
  bussiness_name?: BusinessNameInput | null,
  idProcter?: string | null,
  image?: FileInput | null,
  contact?: ContactInput | null,
  address?: AddressInput | null,
  biography?: string | null,
  constancia?: FileInput | null,
  comprobante?: FileInput | null,
  experience?: string | null,
  pros?: Array< string | null > | null,
  cons?: Array< string | null > | null,
  cte_rating?: Array< RatingInput | null > | null,
  shopping_rating?: Array< RatingInput | null > | null,
  video?: string | null,
  tags?: Array< string | null > | null,
  money_filter_c?: boolean | null,
  money_filter_d?: boolean | null,
  users?: Array< string | null > | null,
  bank?: string | null,
  account?: string | null,
  clabe?: string | null,
  cuenta_correo?: string | null,
  edocuenta?: FileInput | null,
  ife?: FileInput | null,
  poderes?: FileInput | null,
  acta?: FileInput | null,
  isProvider?: boolean | null,
  sameAddress?: boolean | null,
  isPop?: boolean | null,
  isPrinted?: boolean | null,
  hasLogistic?: boolean | null,
  created?: number | null,
  updated?: number | null,
  addFiles?: Array< SignFileInput | null > | null,
  signFiles?: Array< SignFileInput | null > | null,
  representante_legal?: string | null,
  escritura_constitucion?: string | null,
  notario_a?: string | null,
  constituido_down_edo?: string | null,
  rrpp?: string | null,
  isPremium?: boolean | null,
  isTrustProvider?: boolean | null,
};

export type BusinessNameInput = {
  tax_residence?: AddressInput | null,
  rfc?: string | null,
  name?: string | null,
};

export type RatingInput = {
  name?: string | null,
  rating?: number | null,
};

export type SignFileInput = {
  key?: string | null,
  url?: string | null,
  sign?: string | null,
  status?: string | null,
};

export type ModelProviderConditionInput = {
  isApproved?: ModelBooleanInput | null,
  comertial_name?: ModelStringInput | null,
  idProcter?: ModelStringInput | null,
  biography?: ModelStringInput | null,
  experience?: ModelStringInput | null,
  pros?: ModelStringInput | null,
  cons?: ModelStringInput | null,
  video?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  money_filter_c?: ModelBooleanInput | null,
  money_filter_d?: ModelBooleanInput | null,
  users?: ModelStringInput | null,
  bank?: ModelStringInput | null,
  account?: ModelStringInput | null,
  clabe?: ModelStringInput | null,
  cuenta_correo?: ModelStringInput | null,
  isProvider?: ModelBooleanInput | null,
  sameAddress?: ModelBooleanInput | null,
  isPop?: ModelBooleanInput | null,
  isPrinted?: ModelBooleanInput | null,
  hasLogistic?: ModelBooleanInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  representante_legal?: ModelStringInput | null,
  escritura_constitucion?: ModelStringInput | null,
  notario_a?: ModelStringInput | null,
  constituido_down_edo?: ModelStringInput | null,
  rrpp?: ModelStringInput | null,
  isPremium?: ModelBooleanInput | null,
  isTrustProvider?: ModelBooleanInput | null,
  and?: Array< ModelProviderConditionInput | null > | null,
  or?: Array< ModelProviderConditionInput | null > | null,
  not?: ModelProviderConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Provider = {
  __typename: "Provider",
  id: string,
  isApproved?: boolean | null,
  logo?: File | null,
  grayLogo?: File | null,
  comertial_name?: string | null,
  bussiness_name?: BusinessName | null,
  idProcter?: string | null,
  image?: File | null,
  contact?: Contact | null,
  address?: Address | null,
  biography?: string | null,
  constancia?: File | null,
  comprobante?: File | null,
  experience?: string | null,
  pros?: Array< string | null > | null,
  cons?: Array< string | null > | null,
  cte_rating?:  Array<Rating | null > | null,
  shopping_rating?:  Array<Rating | null > | null,
  video?: string | null,
  tags?: Array< string | null > | null,
  money_filter_c?: boolean | null,
  money_filter_d?: boolean | null,
  users?: Array< string | null > | null,
  bank?: string | null,
  account?: string | null,
  clabe?: string | null,
  cuenta_correo?: string | null,
  edocuenta?: File | null,
  ife?: File | null,
  poderes?: File | null,
  acta?: File | null,
  isProvider?: boolean | null,
  sameAddress?: boolean | null,
  isPop?: boolean | null,
  isPrinted?: boolean | null,
  hasLogistic?: boolean | null,
  created?: number | null,
  updated?: number | null,
  addFiles?:  Array<SignFile | null > | null,
  signFiles?:  Array<SignFile | null > | null,
  representante_legal?: string | null,
  escritura_constitucion?: string | null,
  notario_a?: string | null,
  constituido_down_edo?: string | null,
  rrpp?: string | null,
  isPremium?: boolean | null,
  isTrustProvider?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type BusinessName = {
  __typename: "BusinessName",
  tax_residence?: Address | null,
  rfc?: string | null,
  name?: string | null,
};

export type Rating = {
  __typename: "Rating",
  name?: string | null,
  rating?: number | null,
};

export type SignFile = {
  __typename: "SignFile",
  key?: string | null,
  url?: string | null,
  sign?: string | null,
  status?: string | null,
};

export type UpdateProviderInput = {
  id: string,
  isApproved?: boolean | null,
  logo?: FileInput | null,
  grayLogo?: FileInput | null,
  comertial_name?: string | null,
  bussiness_name?: BusinessNameInput | null,
  idProcter?: string | null,
  image?: FileInput | null,
  contact?: ContactInput | null,
  address?: AddressInput | null,
  biography?: string | null,
  constancia?: FileInput | null,
  comprobante?: FileInput | null,
  experience?: string | null,
  pros?: Array< string | null > | null,
  cons?: Array< string | null > | null,
  cte_rating?: Array< RatingInput | null > | null,
  shopping_rating?: Array< RatingInput | null > | null,
  video?: string | null,
  tags?: Array< string | null > | null,
  money_filter_c?: boolean | null,
  money_filter_d?: boolean | null,
  users?: Array< string | null > | null,
  bank?: string | null,
  account?: string | null,
  clabe?: string | null,
  cuenta_correo?: string | null,
  edocuenta?: FileInput | null,
  ife?: FileInput | null,
  poderes?: FileInput | null,
  acta?: FileInput | null,
  isProvider?: boolean | null,
  sameAddress?: boolean | null,
  isPop?: boolean | null,
  isPrinted?: boolean | null,
  hasLogistic?: boolean | null,
  created?: number | null,
  updated?: number | null,
  addFiles?: Array< SignFileInput | null > | null,
  signFiles?: Array< SignFileInput | null > | null,
  representante_legal?: string | null,
  escritura_constitucion?: string | null,
  notario_a?: string | null,
  constituido_down_edo?: string | null,
  rrpp?: string | null,
  isPremium?: boolean | null,
  isTrustProvider?: boolean | null,
};

export type DeleteProviderInput = {
  id: string,
};

export type CreateProviderSettingInput = {
  id?: string | null,
  primaryColors?: Array< string | null > | null,
  accentColors?: Array< string | null > | null,
  categories?: Array< string | null > | null,
  createdAt?: string | null,
};

export type ModelProviderSettingConditionInput = {
  primaryColors?: ModelStringInput | null,
  accentColors?: ModelStringInput | null,
  categories?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelProviderSettingConditionInput | null > | null,
  or?: Array< ModelProviderSettingConditionInput | null > | null,
  not?: ModelProviderSettingConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ProviderSetting = {
  __typename: "ProviderSetting",
  id: string,
  primaryColors?: Array< string | null > | null,
  accentColors?: Array< string | null > | null,
  categories?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateProviderSettingInput = {
  id: string,
  primaryColors?: Array< string | null > | null,
  accentColors?: Array< string | null > | null,
  categories?: Array< string | null > | null,
  createdAt?: string | null,
};

export type DeleteProviderSettingInput = {
  id: string,
};

export type CreateProviderFileInput = {
  id?: string | null,
  acta?: FileInput | null,
  constancia?: FileInput | null,
  comprobante?: FileInput | null,
  edocuenta?: FileInput | null,
  ife?: FileInput | null,
  poderes?: FileInput | null,
  createdAt?: string | null,
};

export type ModelProviderFileConditionInput = {
  createdAt?: ModelStringInput | null,
  and?: Array< ModelProviderFileConditionInput | null > | null,
  or?: Array< ModelProviderFileConditionInput | null > | null,
  not?: ModelProviderFileConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ProviderFile = {
  __typename: "ProviderFile",
  id: string,
  acta?: File | null,
  constancia?: File | null,
  comprobante?: File | null,
  edocuenta?: File | null,
  ife?: File | null,
  poderes?: File | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateProviderFileInput = {
  id: string,
  acta?: FileInput | null,
  constancia?: FileInput | null,
  comprobante?: FileInput | null,
  edocuenta?: FileInput | null,
  ife?: FileInput | null,
  poderes?: FileInput | null,
  createdAt?: string | null,
};

export type DeleteProviderFileInput = {
  id: string,
};

export type CreateColorsInput = {
  id?: string | null,
  status: string,
  name: string,
  rgb: string,
  hex: string,
  position?: number | null,
  variantNames?: Array< string | null > | null,
};

export type ModelColorsConditionInput = {
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  rgb?: ModelStringInput | null,
  hex?: ModelStringInput | null,
  position?: ModelIntInput | null,
  variantNames?: ModelStringInput | null,
  and?: Array< ModelColorsConditionInput | null > | null,
  or?: Array< ModelColorsConditionInput | null > | null,
  not?: ModelColorsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Colors = {
  __typename: "Colors",
  id: string,
  status: string,
  name: string,
  rgb: string,
  hex: string,
  position?: number | null,
  variantNames?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateColorsInput = {
  id: string,
  status?: string | null,
  name?: string | null,
  rgb?: string | null,
  hex?: string | null,
  position?: number | null,
  variantNames?: Array< string | null > | null,
};

export type DeleteColorsInput = {
  id: string,
};

export type CreateHomePageCarouselBannerInput = {
  id?: string | null,
  status?: boolean | null,
  isPublic?: boolean | null,
  title?: string | null,
  subtitle?: string | null,
  copy?: string | null,
  path?: string | null,
  bgImage?: Array< FileInput | null > | null,
  position?: number | null,
  visibleFor?: Array< string | null > | null,
  createdAt?: string | null,
};

export type ModelHomePageCarouselBannerConditionInput = {
  status?: ModelBooleanInput | null,
  isPublic?: ModelBooleanInput | null,
  title?: ModelStringInput | null,
  subtitle?: ModelStringInput | null,
  copy?: ModelStringInput | null,
  path?: ModelStringInput | null,
  position?: ModelIntInput | null,
  visibleFor?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelHomePageCarouselBannerConditionInput | null > | null,
  or?: Array< ModelHomePageCarouselBannerConditionInput | null > | null,
  not?: ModelHomePageCarouselBannerConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type HomePageCarouselBanner = {
  __typename: "HomePageCarouselBanner",
  id: string,
  status?: boolean | null,
  isPublic?: boolean | null,
  title?: string | null,
  subtitle?: string | null,
  copy?: string | null,
  path?: string | null,
  bgImage?:  Array<File | null > | null,
  position?: number | null,
  visibleFor?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateHomePageCarouselBannerInput = {
  id: string,
  status?: boolean | null,
  isPublic?: boolean | null,
  title?: string | null,
  subtitle?: string | null,
  copy?: string | null,
  path?: string | null,
  bgImage?: Array< FileInput | null > | null,
  position?: number | null,
  visibleFor?: Array< string | null > | null,
  createdAt?: string | null,
};

export type DeleteHomePageCarouselBannerInput = {
  id: string,
};

export type CreateHomePageInput = {
  id?: string | null,
  status?: boolean | null,
  isPublic?: boolean | null,
  showArrow?: boolean | null,
  showNumeration?: boolean | null,
  icon?: string | null,
  title?: string | null,
  subtitle?: string | null,
  body?: string | null,
  route?: string | null,
  titlePosition?: string | null,
  textAlign?: string | null,
  bgImage?: FileInput | null,
  bgColor?: string | null,
  borderColor?: string | null,
  textColor?: string | null,
  position?: number | null,
  verticalLine?: boolean | null,
  browseButton?: boolean | null,
  visibleFor?: Array< string | null > | null,
  visibleForUserBrand?: Array< string | null > | null,
  createdAt?: string | null,
};

export type ModelHomePageConditionInput = {
  status?: ModelBooleanInput | null,
  isPublic?: ModelBooleanInput | null,
  showArrow?: ModelBooleanInput | null,
  showNumeration?: ModelBooleanInput | null,
  icon?: ModelStringInput | null,
  title?: ModelStringInput | null,
  subtitle?: ModelStringInput | null,
  body?: ModelStringInput | null,
  route?: ModelStringInput | null,
  titlePosition?: ModelStringInput | null,
  textAlign?: ModelStringInput | null,
  bgColor?: ModelStringInput | null,
  borderColor?: ModelStringInput | null,
  textColor?: ModelStringInput | null,
  position?: ModelIntInput | null,
  verticalLine?: ModelBooleanInput | null,
  browseButton?: ModelBooleanInput | null,
  visibleFor?: ModelStringInput | null,
  visibleForUserBrand?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelHomePageConditionInput | null > | null,
  or?: Array< ModelHomePageConditionInput | null > | null,
  not?: ModelHomePageConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type HomePage = {
  __typename: "HomePage",
  id: string,
  status?: boolean | null,
  isPublic?: boolean | null,
  showArrow?: boolean | null,
  showNumeration?: boolean | null,
  icon?: string | null,
  title?: string | null,
  subtitle?: string | null,
  body?: string | null,
  route?: string | null,
  titlePosition?: string | null,
  textAlign?: string | null,
  bgImage?: File | null,
  bgColor?: string | null,
  borderColor?: string | null,
  textColor?: string | null,
  position?: number | null,
  verticalLine?: boolean | null,
  browseButton?: boolean | null,
  visibleFor?: Array< string | null > | null,
  visibleForUserBrand?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateHomePageInput = {
  id: string,
  status?: boolean | null,
  isPublic?: boolean | null,
  showArrow?: boolean | null,
  showNumeration?: boolean | null,
  icon?: string | null,
  title?: string | null,
  subtitle?: string | null,
  body?: string | null,
  route?: string | null,
  titlePosition?: string | null,
  textAlign?: string | null,
  bgImage?: FileInput | null,
  bgColor?: string | null,
  borderColor?: string | null,
  textColor?: string | null,
  position?: number | null,
  verticalLine?: boolean | null,
  browseButton?: boolean | null,
  visibleFor?: Array< string | null > | null,
  visibleForUserBrand?: Array< string | null > | null,
  createdAt?: string | null,
};

export type DeleteHomePageInput = {
  id: string,
};

export type CreateHomePageBottomBannerInput = {
  id?: string | null,
  status?: boolean | null,
  isPublic?: boolean | null,
  title?: string | null,
  subtitle?: string | null,
  icon?: string | null,
  route?: string | null,
  showArrow?: boolean | null,
  bannerImage?: FileInput | null,
  bgColor?: string | null,
  visibleFor?: Array< string | null > | null,
  createdAt?: string | null,
};

export type ModelHomePageBottomBannerConditionInput = {
  status?: ModelBooleanInput | null,
  isPublic?: ModelBooleanInput | null,
  title?: ModelStringInput | null,
  subtitle?: ModelStringInput | null,
  icon?: ModelStringInput | null,
  route?: ModelStringInput | null,
  showArrow?: ModelBooleanInput | null,
  bgColor?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelHomePageBottomBannerConditionInput | null > | null,
  or?: Array< ModelHomePageBottomBannerConditionInput | null > | null,
  not?: ModelHomePageBottomBannerConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type HomePageBottomBanner = {
  __typename: "HomePageBottomBanner",
  id: string,
  status?: boolean | null,
  isPublic?: boolean | null,
  title?: string | null,
  subtitle?: string | null,
  icon?: string | null,
  route?: string | null,
  showArrow?: boolean | null,
  bannerImage?: File | null,
  bgColor?: string | null,
  visibleFor?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateHomePageBottomBannerInput = {
  id: string,
  status?: boolean | null,
  isPublic?: boolean | null,
  title?: string | null,
  subtitle?: string | null,
  icon?: string | null,
  route?: string | null,
  showArrow?: boolean | null,
  bannerImage?: FileInput | null,
  bgColor?: string | null,
  visibleFor?: Array< string | null > | null,
  createdAt?: string | null,
};

export type DeleteHomePageBottomBannerInput = {
  id: string,
};

export type CreateProductoInput = {
  id?: string | null,
  providerId: string,
  categoryId: string,
  name: string,
  status?: string | null,
  bestSeller?: string | null,
  images: Array< FileInput >,
  order?: number | null,
  sku: string,
  brand?: string | null,
  colors?: Array< string | null > | null,
  pgClasitication?: string | null,
  delivery_time?: string | null,
  delivery_time_units?: string | null,
  stock?: number | null,
  minRequest?: number | null,
  maxRequest?: number | null,
  article_of_clothing?: boolean | null,
  size?: string | null,
  price: number,
  long_description: string,
  short_description: string,
  creator?: string | null,
  isExternal?: boolean | null,
  isAllowable?: boolean | null,
  isRestricted?: boolean | null,
  isAutoSkipped?: string | null,
  isAutoAllowed?: string | null,
  isPurse?: boolean | null,
  massiveLayout?: string | null,
  hasBaseAmmount?: boolean | null,
  isFreeAmmount?: boolean | null,
  isCard?: boolean | null,
  isByRequest?: boolean | null,
  isMultiPrice?: boolean | null,
  cardBaseAmmount?: number | null,
  minCardBaseAmmount?: number | null,
  maxCardBaseAmmount?: number | null,
  nameExternal?: string | null,
  unspsc?: string | null,
  variants?: Array< VariantsInput | null > | null,
  visibleFor?: Array< string | null > | null,
  filterColors?: Array< string | null > | null,
  regions?: Array< string | null > | null,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientIncrements?: Array< ClientIncrementPercentsInput | null > | null,
  productDescriptionItem?: Array< ProductDescriptionItemInput | null > | null,
  source?: string | null,
  trazoProductId?: string | null,
  trazoCategoryId?: string | null,
  stockUpdatedAt?: string | null,
  priceUpdatedAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type VariantsInput = {
  sku?: string | null,
  name?: string | null,
  description?: string | null,
  colors?: Array< string | null > | null,
  filterColors?: Array< string | null > | null,
  image?: Array< FileInput | null > | null,
  stock_available?: number | null,
  price?: number | null,
  size?: string | null,
  logoType?: string | null,
};

export type ClientDiscountPercentsInput = {
  index?: number | null,
  clientId?: string | null,
  minUnits?: number | null,
  maxUnits?: number | null,
  percent?: number | null,
};

export type ClientIncrementPercentsInput = {
  index?: number | null,
  clientId?: string | null,
  minUnits?: number | null,
  maxUnits?: number | null,
  percent?: number | null,
};

export type ProductDescriptionItemInput = {
  index?: number | null,
  status?: boolean | null,
  key?: string | null,
  description?: string | null,
};

export type ModelProductoConditionInput = {
  providerId?: ModelIDInput | null,
  categoryId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  bestSeller?: ModelStringInput | null,
  order?: ModelIntInput | null,
  sku?: ModelStringInput | null,
  brand?: ModelStringInput | null,
  colors?: ModelStringInput | null,
  pgClasitication?: ModelStringInput | null,
  delivery_time?: ModelStringInput | null,
  delivery_time_units?: ModelStringInput | null,
  stock?: ModelIntInput | null,
  minRequest?: ModelIntInput | null,
  maxRequest?: ModelIntInput | null,
  article_of_clothing?: ModelBooleanInput | null,
  size?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  long_description?: ModelStringInput | null,
  short_description?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  isExternal?: ModelBooleanInput | null,
  isAllowable?: ModelBooleanInput | null,
  isRestricted?: ModelBooleanInput | null,
  isAutoSkipped?: ModelStringInput | null,
  isAutoAllowed?: ModelStringInput | null,
  isPurse?: ModelBooleanInput | null,
  massiveLayout?: ModelStringInput | null,
  hasBaseAmmount?: ModelBooleanInput | null,
  isFreeAmmount?: ModelBooleanInput | null,
  isCard?: ModelBooleanInput | null,
  isByRequest?: ModelBooleanInput | null,
  isMultiPrice?: ModelBooleanInput | null,
  cardBaseAmmount?: ModelFloatInput | null,
  minCardBaseAmmount?: ModelFloatInput | null,
  maxCardBaseAmmount?: ModelFloatInput | null,
  nameExternal?: ModelStringInput | null,
  unspsc?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  filterColors?: ModelStringInput | null,
  regions?: ModelStringInput | null,
  source?: ModelStringInput | null,
  trazoProductId?: ModelIDInput | null,
  trazoCategoryId?: ModelIDInput | null,
  stockUpdatedAt?: ModelStringInput | null,
  priceUpdatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProductoConditionInput | null > | null,
  or?: Array< ModelProductoConditionInput | null > | null,
  not?: ModelProductoConditionInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type Producto = {
  __typename: "Producto",
  id: string,
  providerId: string,
  categoryId: string,
  name: string,
  status?: string | null,
  bestSeller?: string | null,
  images:  Array<File >,
  order?: number | null,
  sku: string,
  brand?: string | null,
  colors?: Array< string | null > | null,
  pgClasitication?: string | null,
  delivery_time?: string | null,
  delivery_time_units?: string | null,
  stock?: number | null,
  minRequest?: number | null,
  maxRequest?: number | null,
  article_of_clothing?: boolean | null,
  size?: string | null,
  price: number,
  long_description: string,
  short_description: string,
  creator?: string | null,
  provider: Provider,
  category: Category,
  isExternal?: boolean | null,
  isAllowable?: boolean | null,
  isRestricted?: boolean | null,
  isAutoSkipped?: string | null,
  isAutoAllowed?: string | null,
  isPurse?: boolean | null,
  massiveLayout?: string | null,
  hasBaseAmmount?: boolean | null,
  isFreeAmmount?: boolean | null,
  isCard?: boolean | null,
  isByRequest?: boolean | null,
  isMultiPrice?: boolean | null,
  cardBaseAmmount?: number | null,
  minCardBaseAmmount?: number | null,
  maxCardBaseAmmount?: number | null,
  nameExternal?: string | null,
  unspsc?: string | null,
  variants?:  Array<Variants | null > | null,
  visibleFor?: Array< string | null > | null,
  filterColors?: Array< string | null > | null,
  regions?: Array< string | null > | null,
  clientDiscounts?:  Array<ClientDiscountPercents | null > | null,
  clientIncrements?:  Array<ClientIncrementPercents | null > | null,
  productDescriptionItem?:  Array<ProductDescriptionItem | null > | null,
  source?: string | null,
  trazoProductId?: string | null,
  trazoCategoryId?: string | null,
  stockUpdatedAt?: string | null,
  priceUpdatedAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type Category = {
  __typename: "Category",
  id: string,
  name: string,
  description?: string | null,
  unspsc?: string | null,
  image: File,
  imageMobile?: File | null,
  visibleFor?: Array< string | null > | null,
  visibleForUserBrand?: Array< string | null > | null,
  region?: Array< string | null > | null,
  tags?: Array< string | null > | null,
  clientDiscounts?:  Array<ClientDiscountPercents | null > | null,
  clientFeeIncrements?:  Array<ClientFeePercents | null > | null,
  clientIncrements?:  Array<ClientFeePercents | null > | null,
  hasAllowables?: boolean | null,
  hasPreapproveds?: boolean | null,
  hasRestricted?: boolean | null,
  isPublic?: boolean | null,
  isTop?: boolean | null,
  createdAt?: string | null,
  slug?: string | null,
  parentId?: string | null,
  rootId?: string | null,
  path?: string | null,
  status?: string | null,
  pathIds?: Array< string | null > | null,
  source?: string | null,
  trazoCategoryId?: string | null,
  nameExternal?: string | null,
  depth?: number | null,
  childrenCount?: number | null,
  isLeaf?: boolean | null,
  oldVersion?: string | null,
  productLine?: string | null,
  updatedAt: string,
};

export type ClientDiscountPercents = {
  __typename: "ClientDiscountPercents",
  index?: number | null,
  clientId?: string | null,
  minUnits?: number | null,
  maxUnits?: number | null,
  percent?: number | null,
};

export type ClientFeePercents = {
  __typename: "ClientFeePercents",
  index?: number | null,
  clientId?: string | null,
  percent?: number | null,
};

export type Variants = {
  __typename: "Variants",
  sku?: string | null,
  name?: string | null,
  description?: string | null,
  colors?: Array< string | null > | null,
  filterColors?: Array< string | null > | null,
  image?:  Array<File | null > | null,
  stock_available?: number | null,
  price?: number | null,
  size?: string | null,
  logoType?: string | null,
};

export type ClientIncrementPercents = {
  __typename: "ClientIncrementPercents",
  index?: number | null,
  clientId?: string | null,
  minUnits?: number | null,
  maxUnits?: number | null,
  percent?: number | null,
};

export type ProductDescriptionItem = {
  __typename: "ProductDescriptionItem",
  index?: number | null,
  status?: boolean | null,
  key?: string | null,
  description?: string | null,
};

export type UpdateProductoInput = {
  id: string,
  providerId?: string | null,
  categoryId?: string | null,
  name?: string | null,
  status?: string | null,
  bestSeller?: string | null,
  images?: Array< FileInput > | null,
  order?: number | null,
  sku?: string | null,
  brand?: string | null,
  colors?: Array< string | null > | null,
  pgClasitication?: string | null,
  delivery_time?: string | null,
  delivery_time_units?: string | null,
  stock?: number | null,
  minRequest?: number | null,
  maxRequest?: number | null,
  article_of_clothing?: boolean | null,
  size?: string | null,
  price?: number | null,
  long_description?: string | null,
  short_description?: string | null,
  creator?: string | null,
  isExternal?: boolean | null,
  isAllowable?: boolean | null,
  isRestricted?: boolean | null,
  isAutoSkipped?: string | null,
  isAutoAllowed?: string | null,
  isPurse?: boolean | null,
  massiveLayout?: string | null,
  hasBaseAmmount?: boolean | null,
  isFreeAmmount?: boolean | null,
  isCard?: boolean | null,
  isByRequest?: boolean | null,
  isMultiPrice?: boolean | null,
  cardBaseAmmount?: number | null,
  minCardBaseAmmount?: number | null,
  maxCardBaseAmmount?: number | null,
  nameExternal?: string | null,
  unspsc?: string | null,
  variants?: Array< VariantsInput | null > | null,
  visibleFor?: Array< string | null > | null,
  filterColors?: Array< string | null > | null,
  regions?: Array< string | null > | null,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientIncrements?: Array< ClientIncrementPercentsInput | null > | null,
  productDescriptionItem?: Array< ProductDescriptionItemInput | null > | null,
  source?: string | null,
  trazoProductId?: string | null,
  trazoCategoryId?: string | null,
  stockUpdatedAt?: string | null,
  priceUpdatedAt?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteProductoInput = {
  id: string,
};

export type CreateProductVariantInput = {
  id?: string | null,
  productId?: string | null,
  sku?: string | null,
  name?: string | null,
  description?: string | null,
  colors?: Array< string | null > | null,
  filterColors?: Array< string | null > | null,
  image?: Array< FileInput | null > | null,
  stock_available?: number | null,
  price?: number | null,
  createdAt?: string | null,
};

export type ModelProductVariantConditionInput = {
  productId?: ModelStringInput | null,
  sku?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  colors?: ModelStringInput | null,
  filterColors?: ModelStringInput | null,
  stock_available?: ModelIntInput | null,
  price?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelProductVariantConditionInput | null > | null,
  or?: Array< ModelProductVariantConditionInput | null > | null,
  not?: ModelProductVariantConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ProductVariant = {
  __typename: "ProductVariant",
  id: string,
  productId?: string | null,
  sku?: string | null,
  name?: string | null,
  description?: string | null,
  colors?: Array< string | null > | null,
  filterColors?: Array< string | null > | null,
  image?:  Array<File | null > | null,
  stock_available?: number | null,
  price?: number | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateProductVariantInput = {
  id: string,
  productId?: string | null,
  sku?: string | null,
  name?: string | null,
  description?: string | null,
  colors?: Array< string | null > | null,
  filterColors?: Array< string | null > | null,
  image?: Array< FileInput | null > | null,
  stock_available?: number | null,
  price?: number | null,
  createdAt?: string | null,
};

export type DeleteProductVariantInput = {
  id: string,
};

export type CreateProductOptionInput = {
  id?: string | null,
  ownOrder?: string | null,
  isPangga?: string | null,
  volumetricWeight?: string | null,
  isEvaluated?: string | null,
  createdAt?: string | null,
};

export type ModelProductOptionConditionInput = {
  ownOrder?: ModelStringInput | null,
  isPangga?: ModelStringInput | null,
  volumetricWeight?: ModelStringInput | null,
  isEvaluated?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelProductOptionConditionInput | null > | null,
  or?: Array< ModelProductOptionConditionInput | null > | null,
  not?: ModelProductOptionConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ProductOption = {
  __typename: "ProductOption",
  id: string,
  ownOrder?: string | null,
  isPangga?: string | null,
  volumetricWeight?: string | null,
  isEvaluated?: string | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateProductOptionInput = {
  id: string,
  ownOrder?: string | null,
  isPangga?: string | null,
  volumetricWeight?: string | null,
  isEvaluated?: string | null,
  createdAt?: string | null,
};

export type DeleteProductOptionInput = {
  id: string,
};

export type CreateProductDimentionInput = {
  id?: string | null,
  width?: number | null,
  height?: number | null,
  depth?: number | null,
  weight?: number | null,
  boxWidth?: number | null,
  boxHeight?: number | null,
  boxDepth?: number | null,
  boxWeight?: number | null,
  boxQuantity?: number | null,
  createdAt?: string | null,
};

export type ModelProductDimentionConditionInput = {
  width?: ModelFloatInput | null,
  height?: ModelFloatInput | null,
  depth?: ModelFloatInput | null,
  weight?: ModelFloatInput | null,
  boxWidth?: ModelFloatInput | null,
  boxHeight?: ModelFloatInput | null,
  boxDepth?: ModelFloatInput | null,
  boxWeight?: ModelFloatInput | null,
  boxQuantity?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelProductDimentionConditionInput | null > | null,
  or?: Array< ModelProductDimentionConditionInput | null > | null,
  not?: ModelProductDimentionConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ProductDimention = {
  __typename: "ProductDimention",
  id: string,
  width?: number | null,
  height?: number | null,
  depth?: number | null,
  weight?: number | null,
  boxWidth?: number | null,
  boxHeight?: number | null,
  boxDepth?: number | null,
  boxWeight?: number | null,
  boxQuantity?: number | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateProductDimentionInput = {
  id: string,
  width?: number | null,
  height?: number | null,
  depth?: number | null,
  weight?: number | null,
  boxWidth?: number | null,
  boxHeight?: number | null,
  boxDepth?: number | null,
  boxWeight?: number | null,
  boxQuantity?: number | null,
  createdAt?: string | null,
};

export type DeleteProductDimentionInput = {
  id: string,
};

export type CreateMassiveChangeLayoutsInput = {
  id?: string | null,
  type?: string | null,
  status?: string | null,
  providerId?: string | null,
  creatorId?: string | null,
  creatorRole?: string | null,
  productsNumber?: number | null,
  file?: FileInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelMassiveChangeLayoutsConditionInput = {
  type?: ModelStringInput | null,
  status?: ModelStringInput | null,
  providerId?: ModelIDInput | null,
  creatorId?: ModelStringInput | null,
  creatorRole?: ModelStringInput | null,
  productsNumber?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMassiveChangeLayoutsConditionInput | null > | null,
  or?: Array< ModelMassiveChangeLayoutsConditionInput | null > | null,
  not?: ModelMassiveChangeLayoutsConditionInput | null,
};

export type MassiveChangeLayouts = {
  __typename: "MassiveChangeLayouts",
  id: string,
  type?: string | null,
  status?: string | null,
  providerId?: string | null,
  creatorId?: string | null,
  creatorRole?: string | null,
  productsNumber?: number | null,
  file?: File | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateMassiveChangeLayoutsInput = {
  id: string,
  type?: string | null,
  status?: string | null,
  providerId?: string | null,
  creatorId?: string | null,
  creatorRole?: string | null,
  productsNumber?: number | null,
  file?: FileInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteMassiveChangeLayoutsInput = {
  id: string,
};

export type CreateCategoryInput = {
  id?: string | null,
  name: string,
  description?: string | null,
  unspsc?: string | null,
  image: FileInput,
  imageMobile?: FileInput | null,
  visibleFor?: Array< string | null > | null,
  visibleForUserBrand?: Array< string | null > | null,
  region?: Array< string | null > | null,
  tags?: Array< string | null > | null,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  hasAllowables?: boolean | null,
  hasPreapproveds?: boolean | null,
  hasRestricted?: boolean | null,
  isPublic?: boolean | null,
  isTop?: boolean | null,
  createdAt?: string | null,
  slug?: string | null,
  parentId?: string | null,
  rootId?: string | null,
  path?: string | null,
  status?: string | null,
  pathIds?: Array< string | null > | null,
  source?: string | null,
  trazoCategoryId?: string | null,
  nameExternal?: string | null,
  depth?: number | null,
  childrenCount?: number | null,
  isLeaf?: boolean | null,
  oldVersion?: string | null,
  productLine?: string | null,
};

export type ClientFeePercentsInput = {
  index?: number | null,
  clientId?: string | null,
  percent?: number | null,
};

export type ModelCategoryConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  unspsc?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  visibleForUserBrand?: ModelStringInput | null,
  region?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  hasAllowables?: ModelBooleanInput | null,
  hasPreapproveds?: ModelBooleanInput | null,
  hasRestricted?: ModelBooleanInput | null,
  isPublic?: ModelBooleanInput | null,
  isTop?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  parentId?: ModelIDInput | null,
  rootId?: ModelIDInput | null,
  path?: ModelStringInput | null,
  status?: ModelStringInput | null,
  pathIds?: ModelIDInput | null,
  source?: ModelStringInput | null,
  trazoCategoryId?: ModelIDInput | null,
  nameExternal?: ModelStringInput | null,
  depth?: ModelIntInput | null,
  childrenCount?: ModelIntInput | null,
  isLeaf?: ModelBooleanInput | null,
  oldVersion?: ModelStringInput | null,
  productLine?: ModelStringInput | null,
  and?: Array< ModelCategoryConditionInput | null > | null,
  or?: Array< ModelCategoryConditionInput | null > | null,
  not?: ModelCategoryConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateCategoryInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  unspsc?: string | null,
  image?: FileInput | null,
  imageMobile?: FileInput | null,
  visibleFor?: Array< string | null > | null,
  visibleForUserBrand?: Array< string | null > | null,
  region?: Array< string | null > | null,
  tags?: Array< string | null > | null,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  hasAllowables?: boolean | null,
  hasPreapproveds?: boolean | null,
  hasRestricted?: boolean | null,
  isPublic?: boolean | null,
  isTop?: boolean | null,
  createdAt?: string | null,
  slug?: string | null,
  parentId?: string | null,
  rootId?: string | null,
  path?: string | null,
  status?: string | null,
  pathIds?: Array< string | null > | null,
  source?: string | null,
  trazoCategoryId?: string | null,
  nameExternal?: string | null,
  depth?: number | null,
  childrenCount?: number | null,
  isLeaf?: boolean | null,
  oldVersion?: string | null,
  productLine?: string | null,
};

export type DeleteCategoryInput = {
  id: string,
};

export type CreateProductBrandInput = {
  id?: string | null,
  name: string,
  status?: string | null,
  description?: string | null,
  route: string,
  unspsc?: string | null,
  image?: FileInput | null,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  hasAllowables?: boolean | null,
  hasPreapproveds?: boolean | null,
  hasRestricted?: boolean | null,
  isTop?: boolean | null,
  createdAt?: string | null,
};

export type ModelProductBrandConditionInput = {
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  description?: ModelStringInput | null,
  route?: ModelStringInput | null,
  unspsc?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  region?: ModelStringInput | null,
  hasAllowables?: ModelBooleanInput | null,
  hasPreapproveds?: ModelBooleanInput | null,
  hasRestricted?: ModelBooleanInput | null,
  isTop?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelProductBrandConditionInput | null > | null,
  or?: Array< ModelProductBrandConditionInput | null > | null,
  not?: ModelProductBrandConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ProductBrand = {
  __typename: "ProductBrand",
  id: string,
  name: string,
  status?: string | null,
  description?: string | null,
  route: string,
  unspsc?: string | null,
  image?: File | null,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
  clientDiscounts?:  Array<ClientDiscountPercents | null > | null,
  clientFeeIncrements?:  Array<ClientFeePercents | null > | null,
  clientIncrements?:  Array<ClientFeePercents | null > | null,
  hasAllowables?: boolean | null,
  hasPreapproveds?: boolean | null,
  hasRestricted?: boolean | null,
  isTop?: boolean | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateProductBrandInput = {
  id: string,
  name?: string | null,
  status?: string | null,
  description?: string | null,
  route?: string | null,
  unspsc?: string | null,
  image?: FileInput | null,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  hasAllowables?: boolean | null,
  hasPreapproveds?: boolean | null,
  hasRestricted?: boolean | null,
  isTop?: boolean | null,
  createdAt?: string | null,
};

export type DeleteProductBrandInput = {
  id: string,
};

export type CreateCartInput = {
  id?: string | null,
  requirement?: string | null,
  comments?: Array< CommentInput | null > | null,
  delivery_addresses?: Array< AddressInput | null > | null,
  files?: Array< ListFilesInput | null > | null,
  products: Array< ProductInOrderInput >,
  creator: string,
  contact?: OrderContactInput | null,
};

export type CommentInput = {
  text: string,
  created: number,
  creator_id: string,
  creator_name: string,
  creator_email: string,
  isSourceDataUser: boolean,
  creator_avatar?: FileInput | null,
  company?: CompanyInput | null,
  replyTo?: string | null,
  role?: string | null,
  text_request?: string | null,
  nameUserReply?: string | null,
  files?: Array< FileInput | null > | null,
  jiraKey?: string | null,
};

export type CompanyInput = {
  comertial_name: string,
  id: string,
};

export type ListFilesInput = {
  created: number,
  creator_id: string,
  file: FileInput,
  status?: string | null,
  statusFile?: string | null,
  name: string,
  provider_id?: string | null,
  product_id?: string | null,
  tracking_code?: string | null,
  gr_code?: string | null,
  coupa_order?: string | null,
  description?: string | null,
};

export type ProductInOrderInput = {
  product_id: string,
  provider_id?: string | null,
  index?: number | null,
  print?: number | null,
  printPrice?: number | null,
  product_name: string,
  description?: string | null,
  category?: string | null,
  unspsc?: string | null,
  price?: number | null,
  originalPrice?: number | null,
  sample_requested?: boolean | null,
  sample_request?: boolean | null,
  sample_authorize?: boolean | null,
  sample_authorized?: boolean | null,
  quality_requested?: boolean | null,
  quality_request?: boolean | null,
  uploadedSample?: boolean | null,
  quantity: number,
  isExternal?: boolean | null,
  variant?: VariantsInput | null,
  image?: Array< FileInput | null > | null,
  sku?: string | null,
  qualityForm?: ProductInOrderQualityPGFormInput | null,
  fee?: number | null,
  increment?: number | null,
  discount?: number | null,
  logs?: Array< ProductInOrderLogInput | null > | null,
  sellMode?: ProductMaskSellMode | null,
  kitPieces?: number | null,
};

export type ProductInOrderQualityPGFormInput = {
  initiativeDescription?: string | null,
  targetUser?: string | null,
  retailBrandName?: string | null,
  itemCategory?: string | null,
  itemPicture?: string | null,
  originCountry?: string | null,
  quantityPerCountryOfDist?: string | null,
  initiativeDates?: string | null,
  isPartOfAnMSOCustOrSpecPack?: string | null,
  incluesClientLogo?: string | null,
  isAReorderWithinTwelveMonths?: string | null,
  isReorder?: string | null,
  PGPLContactName?: string | null,
  ulTracking?: string | null,
  PLContactName?: string | null,
  contactEmailAddress?: string | null,
  PGPurchaseOrderNumber?: string | null,
  EBBSorSupplierProvidedProjectNumber?: string | null,
  vendorCompanyName?: string | null,
  vendorContactName?: string | null,
  vendorEmailAddress?: string | null,
  vendorJobTitle?: string | null,
  vendorTelephone?: string | null,
  vendorMailingAddress?: string | null,
  vendorCity?: string | null,
  vendorState?: string | null,
  vendorCountry?: string | null,
  vendorPC?: string | null,
  physicalItemDescription?: string | null,
  SampleOrMaterialComponentSubmitted?: string | null,
  toWhom?: string | null,
  descriptionOfItemPackagingAndArtwork?: string | null,
  regulatoryAndLegislativeProductCertification?: string | null,
  dateFinalApprovalRequestedSubmittedToPG?: string | null,
  DateOfDeclarationOfConformity?: string | null,
  dateOfApprovalExpirationOfPremiumItem?: string | null,
  itemClasification?: string | null,
  PGRepresentativeMarketingDesign?: string | null,
  PGProjectLeaderRequestor?: string | null,
  PGRestrictedItemsLocalPGLegal?: string | null,
  PGLocalCategoryGM?: string | null,
  PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
  idProduct?: string | null,
  pathDocument?: string | null,
};

export type ProductInOrderLogInput = {
  product_id: string,
  user_id: string,
  text: string,
  files?: Array< FileInput | null > | null,
  created: string,
};

export enum ProductMaskSellMode {
  UNIT = "UNIT",
  KIT = "KIT",
  BOTH = "BOTH",
}


export type OrderContactInput = {
  name: string,
  tel: string,
};

export type ModelCartConditionInput = {
  id?: ModelStringInput | null,
  requirement?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  and?: Array< ModelCartConditionInput | null > | null,
  or?: Array< ModelCartConditionInput | null > | null,
  not?: ModelCartConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Cart = {
  __typename: "Cart",
  id: string,
  requirement?: string | null,
  comments?:  Array<Comment | null > | null,
  delivery_addresses?:  Array<Address | null > | null,
  files?:  Array<ListFiles | null > | null,
  products:  Array<ProductInOrder >,
  creator: string,
  contact?: OrderContact | null,
  createdAt: string,
  updatedAt: string,
};

export type Comment = {
  __typename: "Comment",
  text: string,
  created: number,
  creator_id: string,
  creator_name: string,
  creator_email: string,
  isSourceDataUser: boolean,
  creator_avatar?: File | null,
  company?: Company | null,
  replyTo?: string | null,
  role?: string | null,
  text_request?: string | null,
  nameUserReply?: string | null,
  files?:  Array<File | null > | null,
  jiraKey?: string | null,
};

export type Company = {
  __typename: "Company",
  comertial_name: string,
  id: string,
};

export type ListFiles = {
  __typename: "ListFiles",
  created: number,
  creator_id: string,
  file: File,
  status?: string | null,
  statusFile?: string | null,
  name: string,
  provider_id?: string | null,
  product_id?: string | null,
  tracking_code?: string | null,
  gr_code?: string | null,
  coupa_order?: string | null,
  description?: string | null,
};

export type ProductInOrder = {
  __typename: "ProductInOrder",
  product_id: string,
  provider_id?: string | null,
  index?: number | null,
  print?: number | null,
  printPrice?: number | null,
  product_name: string,
  description?: string | null,
  category?: string | null,
  unspsc?: string | null,
  price?: number | null,
  originalPrice?: number | null,
  sample_requested?: boolean | null,
  sample_request?: boolean | null,
  sample_authorize?: boolean | null,
  sample_authorized?: boolean | null,
  quality_requested?: boolean | null,
  quality_request?: boolean | null,
  uploadedSample?: boolean | null,
  quantity: number,
  isExternal?: boolean | null,
  variant?: Variants | null,
  image?:  Array<File | null > | null,
  sku?: string | null,
  qualityForm?: ProductInOrderQualityPGForm | null,
  fee?: number | null,
  increment?: number | null,
  discount?: number | null,
  logs?:  Array<ProductInOrderLog | null > | null,
  sellMode?: ProductMaskSellMode | null,
  kitPieces?: number | null,
};

export type ProductInOrderQualityPGForm = {
  __typename: "ProductInOrderQualityPGForm",
  initiativeDescription?: string | null,
  targetUser?: string | null,
  retailBrandName?: string | null,
  itemCategory?: string | null,
  itemPicture?: string | null,
  originCountry?: string | null,
  quantityPerCountryOfDist?: string | null,
  initiativeDates?: string | null,
  isPartOfAnMSOCustOrSpecPack?: string | null,
  incluesClientLogo?: string | null,
  isAReorderWithinTwelveMonths?: string | null,
  isReorder?: string | null,
  PGPLContactName?: string | null,
  ulTracking?: string | null,
  PLContactName?: string | null,
  contactEmailAddress?: string | null,
  PGPurchaseOrderNumber?: string | null,
  EBBSorSupplierProvidedProjectNumber?: string | null,
  vendorCompanyName?: string | null,
  vendorContactName?: string | null,
  vendorEmailAddress?: string | null,
  vendorJobTitle?: string | null,
  vendorTelephone?: string | null,
  vendorMailingAddress?: string | null,
  vendorCity?: string | null,
  vendorState?: string | null,
  vendorCountry?: string | null,
  vendorPC?: string | null,
  physicalItemDescription?: string | null,
  SampleOrMaterialComponentSubmitted?: string | null,
  toWhom?: string | null,
  descriptionOfItemPackagingAndArtwork?: string | null,
  regulatoryAndLegislativeProductCertification?: string | null,
  dateFinalApprovalRequestedSubmittedToPG?: string | null,
  DateOfDeclarationOfConformity?: string | null,
  dateOfApprovalExpirationOfPremiumItem?: string | null,
  itemClasification?: string | null,
  PGRepresentativeMarketingDesign?: string | null,
  PGProjectLeaderRequestor?: string | null,
  PGRestrictedItemsLocalPGLegal?: string | null,
  PGLocalCategoryGM?: string | null,
  PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
  idProduct?: string | null,
  pathDocument?: string | null,
};

export type ProductInOrderLog = {
  __typename: "ProductInOrderLog",
  product_id: string,
  user_id: string,
  text: string,
  files?:  Array<File | null > | null,
  created: string,
};

export type OrderContact = {
  __typename: "OrderContact",
  name: string,
  tel: string,
};

export type UpdateCartInput = {
  id: string,
  requirement?: string | null,
  comments?: Array< CommentInput | null > | null,
  delivery_addresses?: Array< AddressInput | null > | null,
  files?: Array< ListFilesInput | null > | null,
  products?: Array< ProductInOrderInput > | null,
  creator?: string | null,
  contact?: OrderContactInput | null,
};

export type DeleteCartInput = {
  id: string,
};

export type CreateUserInput = {
  id?: string | null,
  name: string,
  role: string,
  email: string,
  jiraId?: string | null,
  phoneNumber?: string | null,
  avatar?: FileInput | null,
  companyId?: string | null,
  brandId?: string | null,
  failedLogins?: number | null,
  agents?: Array< AgentInput | null > | null,
  notificationsOf?: Array< string | null > | null,
  status?: boolean | null,
  isLogistic?: boolean | null,
  isCoupa?: boolean | null,
  isManagement?: boolean | null,
  isAdministration?: boolean | null,
  hasNotifications?: boolean | null,
  createdAt?: string | null,
};

export type ModelUserConditionInput = {
  name?: ModelStringInput | null,
  role?: ModelStringInput | null,
  email?: ModelStringInput | null,
  jiraId?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  brandId?: ModelStringInput | null,
  failedLogins?: ModelIntInput | null,
  notificationsOf?: ModelStringInput | null,
  status?: ModelBooleanInput | null,
  isLogistic?: ModelBooleanInput | null,
  isCoupa?: ModelBooleanInput | null,
  isManagement?: ModelBooleanInput | null,
  isAdministration?: ModelBooleanInput | null,
  hasNotifications?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type User = {
  __typename: "User",
  id: string,
  name: string,
  role: string,
  email: string,
  jiraId?: string | null,
  phoneNumber?: string | null,
  avatar?: File | null,
  companyId?: string | null,
  brandId?: string | null,
  failedLogins?: number | null,
  agents?:  Array<Agent | null > | null,
  notificationsOf?: Array< string | null > | null,
  status?: boolean | null,
  isLogistic?: boolean | null,
  isCoupa?: boolean | null,
  isManagement?: boolean | null,
  isAdministration?: boolean | null,
  hasNotifications?: boolean | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateUserInput = {
  id: string,
  name?: string | null,
  role?: string | null,
  email?: string | null,
  jiraId?: string | null,
  phoneNumber?: string | null,
  avatar?: FileInput | null,
  companyId?: string | null,
  brandId?: string | null,
  failedLogins?: number | null,
  agents?: Array< AgentInput | null > | null,
  notificationsOf?: Array< string | null > | null,
  status?: boolean | null,
  isLogistic?: boolean | null,
  isCoupa?: boolean | null,
  isManagement?: boolean | null,
  isAdministration?: boolean | null,
  hasNotifications?: boolean | null,
  createdAt?: string | null,
};

export type DeleteUserInput = {
  id: string,
};

export type CreateAutomobileInput = {
  id?: string | null,
  clientId?: string | null,
  status?: boolean | null,
  bought?: boolean | null,
  buyerId?: string | null,
  buyerName?: string | null,
  price: number,
  brand: string,
  brandId?: string | null,
  model?: string | null,
  version: string,
  year: number,
  color?: string | null,
  km: number,
  transmission?: string | null,
  motor?: string | null,
  passengers?: number | null,
  state: string,
  objeto?: string | null,
  placa?: string | null,
  serialNumber?: string | null,
  images: Array< FileInput >,
  star_time?: number | null,
  end_time?: number | null,
  usersInteresting?: Array< ListUsersInput | null > | null,
  comentario?: string | null,
  penalizacion?: string | null,
  haveWinner?: boolean | null,
  ppostulacion?: boolean | null,
  created: number,
  updated?: number | null,
};

export type ListUsersInput = {
  iduser?: string | null,
  nombre?: string | null,
  email?: string | null,
  fecha_compra?: string | null,
  veces_rechazo?: string | null,
  winner?: boolean | null,
  fecha_notificacion?: string | null,
  buyer?: boolean | null,
  process_buyer?: boolean | null,
  d_winner_date?: number | null,
  created?: number | null,
};

export type ModelAutomobileConditionInput = {
  clientId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  bought?: ModelBooleanInput | null,
  buyerId?: ModelIDInput | null,
  buyerName?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  brand?: ModelStringInput | null,
  brandId?: ModelStringInput | null,
  model?: ModelStringInput | null,
  version?: ModelStringInput | null,
  year?: ModelIntInput | null,
  color?: ModelStringInput | null,
  km?: ModelIntInput | null,
  transmission?: ModelStringInput | null,
  motor?: ModelStringInput | null,
  passengers?: ModelIntInput | null,
  state?: ModelStringInput | null,
  objeto?: ModelStringInput | null,
  placa?: ModelStringInput | null,
  serialNumber?: ModelStringInput | null,
  star_time?: ModelIntInput | null,
  end_time?: ModelIntInput | null,
  comentario?: ModelStringInput | null,
  penalizacion?: ModelStringInput | null,
  haveWinner?: ModelBooleanInput | null,
  ppostulacion?: ModelBooleanInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelAutomobileConditionInput | null > | null,
  or?: Array< ModelAutomobileConditionInput | null > | null,
  not?: ModelAutomobileConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Automobile = {
  __typename: "Automobile",
  id: string,
  clientId?: string | null,
  status?: boolean | null,
  bought?: boolean | null,
  buyerId?: string | null,
  buyerName?: string | null,
  price: number,
  brand: string,
  brandId?: string | null,
  model?: string | null,
  version: string,
  year: number,
  color?: string | null,
  km: number,
  transmission?: string | null,
  motor?: string | null,
  passengers?: number | null,
  state: string,
  objeto?: string | null,
  placa?: string | null,
  serialNumber?: string | null,
  images:  Array<File >,
  star_time?: number | null,
  end_time?: number | null,
  usersInteresting?:  Array<ListUsers | null > | null,
  comentario?: string | null,
  penalizacion?: string | null,
  haveWinner?: boolean | null,
  ppostulacion?: boolean | null,
  logsGanadoresAutos?: ModelLogGanadorAutoConnection | null,
  created: number,
  updated?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type ListUsers = {
  __typename: "ListUsers",
  iduser?: string | null,
  nombre?: string | null,
  email?: string | null,
  fecha_compra?: string | null,
  veces_rechazo?: string | null,
  winner?: boolean | null,
  fecha_notificacion?: string | null,
  buyer?: boolean | null,
  process_buyer?: boolean | null,
  d_winner_date?: number | null,
  created?: number | null,
};

export type ModelLogGanadorAutoConnection = {
  __typename: "ModelLogGanadorAutoConnection",
  items:  Array<LogGanadorAuto | null >,
  nextToken?: string | null,
};

export type LogGanadorAuto = {
  __typename: "LogGanadorAuto",
  id: string,
  id_auto?: string | null,
  id_user?: string | null,
  fecha_rifa?: number | null,
  email?: string | null,
  nombre?: string | null,
  a_paterno?: string | null,
  a_materno?: string | null,
  status_buyer?: boolean | null,
  date_buyer?: number | null,
  winner?: number | null,
  refused?: number | null,
  since?: string | null,
  process_buyer?: boolean | null,
  reactive?: boolean | null,
  created: number,
  updated?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateAutomobileInput = {
  id: string,
  clientId?: string | null,
  status?: boolean | null,
  bought?: boolean | null,
  buyerId?: string | null,
  buyerName?: string | null,
  price?: number | null,
  brand?: string | null,
  brandId?: string | null,
  model?: string | null,
  version?: string | null,
  year?: number | null,
  color?: string | null,
  km?: number | null,
  transmission?: string | null,
  motor?: string | null,
  passengers?: number | null,
  state?: string | null,
  objeto?: string | null,
  placa?: string | null,
  serialNumber?: string | null,
  images?: Array< FileInput > | null,
  star_time?: number | null,
  end_time?: number | null,
  usersInteresting?: Array< ListUsersInput | null > | null,
  comentario?: string | null,
  penalizacion?: string | null,
  haveWinner?: boolean | null,
  ppostulacion?: boolean | null,
  created?: number | null,
  updated?: number | null,
};

export type DeleteAutomobileInput = {
  id: string,
};

export type CreateBrandInput = {
  id?: string | null,
  name: string,
};

export type ModelBrandConditionInput = {
  id?: ModelStringInput | null,
  name?: ModelStringInput | null,
  and?: Array< ModelBrandConditionInput | null > | null,
  or?: Array< ModelBrandConditionInput | null > | null,
  not?: ModelBrandConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Brand = {
  __typename: "Brand",
  id: string,
  name: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateBrandInput = {
  id: string,
  name?: string | null,
};

export type DeleteBrandInput = {
  id: string,
};

export type CreateRfqInput = {
  id?: string | null,
  nombre: string,
  requerimiento: string,
  files?: Array< FileInput | null > | null,
  compras?: ContactInput | null,
  cantidad: number,
  limit_time: number,
  creator?: string | null,
  creatorInfo?: OrderCreatorInput | null,
  clientId: string,
  winner?: WinnerInput | null,
  logs?: Array< LogsInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  orderAgents?: Array< OrderAgentInput | null > | null,
  orderAgentIds?: Array< string | null > | null,
  premiumOrderId?: string | null,
  estatus: string,
  orderId?: number | null,
  start_time: number,
  delivery_time?: number | null,
  created: number,
  saving?: number | null,
  saving_percentage?: number | null,
  saving_real?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  updated?: number | null,
  multipleProducts?: boolean | null,
  providers?: Array< string | null > | null,
  productsRfq?: Array< ProductUnitRfqInput | null > | null,
};

export type OrderCreatorInput = {
  name: string,
  email: string,
  avatar?: FileInput | null,
  user_id: string,
};

export type WinnerInput = {
  proveeedor_id: string,
  date: number,
};

export type LogsInput = {
  creatorId: string,
  description: string,
  date: number,
  status?: string | null,
  provider_id?: string | null,
};

export type RfqChatInput = {
  role: string,
  is_reply?: boolean | null,
  to_user_id?: string | null,
  user_id: string,
  text: string,
  files?: Array< FileInput | null > | null,
  created: string,
};

export type OrderAgentInput = {
  name?: string | null,
  email?: string | null,
  phoneNumber?: string | null,
  avatar?: FileInput | null,
  user_id?: string | null,
};

export type ProductUnitRfqInput = {
  name?: string | null,
  description?: string | null,
  pieces?: number | null,
  createdId?: number | null,
};

export type ModelRfqConditionInput = {
  nombre?: ModelStringInput | null,
  requerimiento?: ModelStringInput | null,
  cantidad?: ModelIntInput | null,
  limit_time?: ModelIntInput | null,
  creator?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  orderAgentIds?: ModelStringInput | null,
  premiumOrderId?: ModelStringInput | null,
  estatus?: ModelStringInput | null,
  orderId?: ModelIntInput | null,
  start_time?: ModelIntInput | null,
  delivery_time?: ModelIntInput | null,
  created?: ModelIntInput | null,
  saving?: ModelFloatInput | null,
  saving_percentage?: ModelFloatInput | null,
  saving_real?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  updated?: ModelIntInput | null,
  multipleProducts?: ModelBooleanInput | null,
  providers?: ModelStringInput | null,
  and?: Array< ModelRfqConditionInput | null > | null,
  or?: Array< ModelRfqConditionInput | null > | null,
  not?: ModelRfqConditionInput | null,
};

export type Rfq = {
  __typename: "Rfq",
  id: string,
  nombre: string,
  requerimiento: string,
  files?:  Array<File | null > | null,
  compras?: Contact | null,
  cantidad: number,
  limit_time: number,
  proposals?: ModelProposalsConnection | null,
  creator?: string | null,
  creatorInfo?: OrderCreator | null,
  clientId: string,
  winner?: Winner | null,
  logs?:  Array<Logs | null > | null,
  chat?:  Array<RfqChat | null > | null,
  orderAgents?:  Array<OrderAgent | null > | null,
  orderAgentIds?: Array< string | null > | null,
  premiumOrderId?: string | null,
  estatus: string,
  orderId?: number | null,
  start_time: number,
  delivery_time?: number | null,
  created: number,
  saving?: number | null,
  saving_percentage?: number | null,
  saving_real?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  updated?: number | null,
  multipleProducts?: boolean | null,
  providers?: Array< string | null > | null,
  productsRfq?:  Array<ProductUnitRfq | null > | null,
};

export type ModelProposalsConnection = {
  __typename: "ModelProposalsConnection",
  items:  Array<Proposals | null >,
  nextToken?: string | null,
};

export type Proposals = {
  __typename: "Proposals",
  id: string,
  provider_id: string,
  delivery_time: Range,
  priceUnit?: number | null,
  pieces?: number | null,
  price: number,
  validity_days?: number | null,
  description?: string | null,
  comments?:  Array<Comment | null > | null,
  created: number,
  updated?: number | null,
  files?:  Array<File | null > | null,
  chat?:  Array<RfqChat | null > | null,
  products?:  Array<ProductsProposals | null > | null,
  multipleProducts?: boolean | null,
  hidden?: boolean | null,
  rfq?: Rfq | null,
  proposalsRfqId?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type Range = {
  __typename: "Range",
  lower: number,
  upper: number,
};

export type RfqChat = {
  __typename: "RfqChat",
  role: string,
  is_reply?: boolean | null,
  to_user_id?: string | null,
  user_id: string,
  text: string,
  files?:  Array<File | null > | null,
  created: string,
};

export type ProductsProposals = {
  __typename: "ProductsProposals",
  productUnitRfqIndex?: number | null,
  selected?: boolean | null,
  name?: string | null,
  description?: string | null,
  priceUnit?: number | null,
  pieces?: number | null,
  total?: number | null,
  idProducto?: number | null,
  files?:  Array<File | null > | null,
};

export type OrderCreator = {
  __typename: "OrderCreator",
  name: string,
  email: string,
  avatar?: File | null,
  user_id: string,
};

export type Winner = {
  __typename: "Winner",
  proveeedor_id: string,
  date: number,
};

export type Logs = {
  __typename: "Logs",
  creatorId: string,
  description: string,
  date: number,
  status?: string | null,
  provider_id?: string | null,
};

export type OrderAgent = {
  __typename: "OrderAgent",
  name?: string | null,
  email?: string | null,
  phoneNumber?: string | null,
  avatar?: File | null,
  user_id?: string | null,
};

export type ProductUnitRfq = {
  __typename: "ProductUnitRfq",
  name?: string | null,
  description?: string | null,
  pieces?: number | null,
  createdId?: number | null,
};

export type UpdateRfqInput = {
  id: string,
  nombre?: string | null,
  requerimiento?: string | null,
  files?: Array< FileInput | null > | null,
  compras?: ContactInput | null,
  cantidad?: number | null,
  limit_time?: number | null,
  creator?: string | null,
  creatorInfo?: OrderCreatorInput | null,
  clientId?: string | null,
  winner?: WinnerInput | null,
  logs?: Array< LogsInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  orderAgents?: Array< OrderAgentInput | null > | null,
  orderAgentIds?: Array< string | null > | null,
  premiumOrderId?: string | null,
  estatus?: string | null,
  orderId?: number | null,
  start_time?: number | null,
  delivery_time?: number | null,
  created?: number | null,
  saving?: number | null,
  saving_percentage?: number | null,
  saving_real?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  updated?: number | null,
  multipleProducts?: boolean | null,
  providers?: Array< string | null > | null,
  productsRfq?: Array< ProductUnitRfqInput | null > | null,
};

export type DeleteRfqInput = {
  id: string,
};

export type CreateRfqAmazonInput = {
  id?: string | null,
  nombre: string,
  requerimiento: string,
  files?: Array< FileInput | null > | null,
  compras?: ContactInput | null,
  cantidad: number,
  limit_time: number,
  creator?: string | null,
  creatorInfo?: OrderCreatorInput | null,
  clientId: string,
  winner?: WinnerInput | null,
  logs?: Array< LogsInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  estatus: string,
  orderId?: number | null,
  start_time: number,
  delivery_time?: number | null,
  created: number,
  saving?: number | null,
  saving_percentage?: number | null,
  saving_real?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  updated?: number | null,
  multipleProducts?: boolean | null,
  providers?: Array< string | null > | null,
  productsRfq?: Array< ProductUnitRfqInput | null > | null,
};

export type ModelRfqAmazonConditionInput = {
  nombre?: ModelStringInput | null,
  requerimiento?: ModelStringInput | null,
  cantidad?: ModelIntInput | null,
  limit_time?: ModelIntInput | null,
  creator?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  estatus?: ModelStringInput | null,
  orderId?: ModelIntInput | null,
  start_time?: ModelIntInput | null,
  delivery_time?: ModelIntInput | null,
  created?: ModelIntInput | null,
  saving?: ModelFloatInput | null,
  saving_percentage?: ModelFloatInput | null,
  saving_real?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  updated?: ModelIntInput | null,
  multipleProducts?: ModelBooleanInput | null,
  providers?: ModelStringInput | null,
  and?: Array< ModelRfqAmazonConditionInput | null > | null,
  or?: Array< ModelRfqAmazonConditionInput | null > | null,
  not?: ModelRfqAmazonConditionInput | null,
};

export type RfqAmazon = {
  __typename: "RfqAmazon",
  id: string,
  nombre: string,
  requerimiento: string,
  files?:  Array<File | null > | null,
  compras?: Contact | null,
  cantidad: number,
  limit_time: number,
  proposals?: ModelProposalsAmazonConnection | null,
  creator?: string | null,
  creatorInfo?: OrderCreator | null,
  clientId: string,
  winner?: Winner | null,
  logs?:  Array<Logs | null > | null,
  chat?:  Array<RfqChat | null > | null,
  estatus: string,
  orderId?: number | null,
  start_time: number,
  delivery_time?: number | null,
  created: number,
  saving?: number | null,
  saving_percentage?: number | null,
  saving_real?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  updated?: number | null,
  multipleProducts?: boolean | null,
  providers?: Array< string | null > | null,
  productsRfq?:  Array<ProductUnitRfq | null > | null,
};

export type ModelProposalsAmazonConnection = {
  __typename: "ModelProposalsAmazonConnection",
  items:  Array<ProposalsAmazon | null >,
  nextToken?: string | null,
};

export type ProposalsAmazon = {
  __typename: "ProposalsAmazon",
  id: string,
  provider_id: string,
  delivery_time: Range,
  priceUnit?: number | null,
  pieces?: number | null,
  price: number,
  validity_days?: number | null,
  description?: string | null,
  comments?:  Array<Comment | null > | null,
  created: number,
  updated?: number | null,
  files?:  Array<File | null > | null,
  chat?:  Array<RfqChat | null > | null,
  products?:  Array<ProductsProposals | null > | null,
  multipleProducts?: boolean | null,
  hidden?: boolean | null,
  rfq?: RfqAmazon | null,
  proposalsRfqId?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateRfqAmazonInput = {
  id: string,
  nombre?: string | null,
  requerimiento?: string | null,
  files?: Array< FileInput | null > | null,
  compras?: ContactInput | null,
  cantidad?: number | null,
  limit_time?: number | null,
  creator?: string | null,
  creatorInfo?: OrderCreatorInput | null,
  clientId?: string | null,
  winner?: WinnerInput | null,
  logs?: Array< LogsInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  estatus?: string | null,
  orderId?: number | null,
  start_time?: number | null,
  delivery_time?: number | null,
  created?: number | null,
  saving?: number | null,
  saving_percentage?: number | null,
  saving_real?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  updated?: number | null,
  multipleProducts?: boolean | null,
  providers?: Array< string | null > | null,
  productsRfq?: Array< ProductUnitRfqInput | null > | null,
};

export type DeleteRfqAmazonInput = {
  id: string,
};

export type CreateProposalsInput = {
  id?: string | null,
  provider_id: string,
  delivery_time: RangeInput,
  priceUnit?: number | null,
  pieces?: number | null,
  price: number,
  validity_days?: number | null,
  description?: string | null,
  comments?: Array< CommentInput | null > | null,
  created: number,
  updated?: number | null,
  files?: Array< FileInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  products?: Array< ProductsProposalsInput | null > | null,
  multipleProducts?: boolean | null,
  hidden?: boolean | null,
  proposalsRfqId?: string | null,
};

export type RangeInput = {
  lower: number,
  upper: number,
};

export type ProductsProposalsInput = {
  productUnitRfqIndex?: number | null,
  selected?: boolean | null,
  name?: string | null,
  description?: string | null,
  priceUnit?: number | null,
  pieces?: number | null,
  total?: number | null,
  idProducto?: number | null,
  files?: Array< FileInput | null > | null,
};

export type ModelProposalsConditionInput = {
  provider_id?: ModelStringInput | null,
  priceUnit?: ModelFloatInput | null,
  pieces?: ModelIntInput | null,
  price?: ModelFloatInput | null,
  validity_days?: ModelIntInput | null,
  description?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  multipleProducts?: ModelBooleanInput | null,
  hidden?: ModelBooleanInput | null,
  proposalsRfqId?: ModelIDInput | null,
  and?: Array< ModelProposalsConditionInput | null > | null,
  or?: Array< ModelProposalsConditionInput | null > | null,
  not?: ModelProposalsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateProposalsInput = {
  id: string,
  provider_id?: string | null,
  delivery_time?: RangeInput | null,
  priceUnit?: number | null,
  pieces?: number | null,
  price?: number | null,
  validity_days?: number | null,
  description?: string | null,
  comments?: Array< CommentInput | null > | null,
  created?: number | null,
  updated?: number | null,
  files?: Array< FileInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  products?: Array< ProductsProposalsInput | null > | null,
  multipleProducts?: boolean | null,
  hidden?: boolean | null,
  proposalsRfqId?: string | null,
};

export type DeleteProposalsInput = {
  id: string,
};

export type CreateProposalsAmazonInput = {
  id?: string | null,
  provider_id: string,
  delivery_time: RangeInput,
  priceUnit?: number | null,
  pieces?: number | null,
  price: number,
  validity_days?: number | null,
  description?: string | null,
  comments?: Array< CommentInput | null > | null,
  created: number,
  updated?: number | null,
  files?: Array< FileInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  products?: Array< ProductsProposalsInput | null > | null,
  multipleProducts?: boolean | null,
  hidden?: boolean | null,
  proposalsRfqId?: string | null,
};

export type ModelProposalsAmazonConditionInput = {
  provider_id?: ModelStringInput | null,
  priceUnit?: ModelFloatInput | null,
  pieces?: ModelIntInput | null,
  price?: ModelFloatInput | null,
  validity_days?: ModelIntInput | null,
  description?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  multipleProducts?: ModelBooleanInput | null,
  hidden?: ModelBooleanInput | null,
  proposalsRfqId?: ModelIDInput | null,
  and?: Array< ModelProposalsAmazonConditionInput | null > | null,
  or?: Array< ModelProposalsAmazonConditionInput | null > | null,
  not?: ModelProposalsAmazonConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateProposalsAmazonInput = {
  id: string,
  provider_id?: string | null,
  delivery_time?: RangeInput | null,
  priceUnit?: number | null,
  pieces?: number | null,
  price?: number | null,
  validity_days?: number | null,
  description?: string | null,
  comments?: Array< CommentInput | null > | null,
  created?: number | null,
  updated?: number | null,
  files?: Array< FileInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  products?: Array< ProductsProposalsInput | null > | null,
  multipleProducts?: boolean | null,
  hidden?: boolean | null,
  proposalsRfqId?: string | null,
};

export type DeleteProposalsAmazonInput = {
  id: string,
};

export type CreateProductoRfqInput = {
  id?: string | null,
  name: string,
  request: string,
  category_id: string,
  provider_id: string,
  price?: number | null,
  images?: Array< FileInput | null > | null,
  estatus?: string | null,
  created: number,
  updated?: number | null,
};

export type ModelProductoRfqConditionInput = {
  name?: ModelStringInput | null,
  request?: ModelStringInput | null,
  category_id?: ModelIDInput | null,
  provider_id?: ModelIDInput | null,
  price?: ModelFloatInput | null,
  estatus?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelProductoRfqConditionInput | null > | null,
  or?: Array< ModelProductoRfqConditionInput | null > | null,
  not?: ModelProductoRfqConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ProductoRfq = {
  __typename: "ProductoRfq",
  id: string,
  name: string,
  request: string,
  category_id: string,
  provider_id: string,
  price?: number | null,
  category?: Category | null,
  provider: Provider,
  images?:  Array<File | null > | null,
  estatus?: string | null,
  created: number,
  updated?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateProductoRfqInput = {
  id: string,
  name?: string | null,
  request?: string | null,
  category_id?: string | null,
  provider_id?: string | null,
  price?: number | null,
  images?: Array< FileInput | null > | null,
  estatus?: string | null,
  created?: number | null,
  updated?: number | null,
};

export type DeleteProductoRfqInput = {
  id: string,
};

export type CreateOrderProvidersInput = {
  id?: string | null,
  provider_id: string,
  clientId?: string | null,
  orderId?: number | null,
  orderProvidersPremiumOrderId: string,
  payment_date?: number | null,
  gr_code?: string | null,
  invoice?: boolean | null,
  invoiceRequested?: boolean | null,
  uploadedGr?: boolean | null,
  uploadedBill?: boolean | null,
};

export type ModelOrderProvidersConditionInput = {
  provider_id?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  orderId?: ModelIntInput | null,
  orderProvidersPremiumOrderId?: ModelIDInput | null,
  payment_date?: ModelIntInput | null,
  gr_code?: ModelStringInput | null,
  invoice?: ModelBooleanInput | null,
  invoiceRequested?: ModelBooleanInput | null,
  uploadedGr?: ModelBooleanInput | null,
  uploadedBill?: ModelBooleanInput | null,
  and?: Array< ModelOrderProvidersConditionInput | null > | null,
  or?: Array< ModelOrderProvidersConditionInput | null > | null,
  not?: ModelOrderProvidersConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type OrderProviders = {
  __typename: "OrderProviders",
  id: string,
  provider_id: string,
  clientId?: string | null,
  orderId?: number | null,
  orderProvidersPremiumOrderId: string,
  payment_date?: number | null,
  gr_code?: string | null,
  invoice?: boolean | null,
  invoiceRequested?: boolean | null,
  uploadedGr?: boolean | null,
  uploadedBill?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateOrderProvidersInput = {
  id: string,
  provider_id?: string | null,
  clientId?: string | null,
  orderId?: number | null,
  orderProvidersPremiumOrderId?: string | null,
  payment_date?: number | null,
  gr_code?: string | null,
  invoice?: boolean | null,
  invoiceRequested?: boolean | null,
  uploadedGr?: boolean | null,
  uploadedBill?: boolean | null,
};

export type DeleteOrderProvidersInput = {
  id: string,
};

export type CreatePopMaterialInput = {
  id?: string | null,
  name: string,
  route: string,
  image?: FileInput | null,
  visibleFor?: Array< string | null > | null,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  year?: string | null,
};

export type ModelPopMaterialConditionInput = {
  name?: ModelStringInput | null,
  route?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  year?: ModelStringInput | null,
  and?: Array< ModelPopMaterialConditionInput | null > | null,
  or?: Array< ModelPopMaterialConditionInput | null > | null,
  not?: ModelPopMaterialConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PopMaterial = {
  __typename: "PopMaterial",
  id: string,
  name: string,
  route: string,
  image?: File | null,
  visibleFor?: Array< string | null > | null,
  clientDiscounts?:  Array<ClientDiscountPercents | null > | null,
  clientFeeIncrements?:  Array<ClientFeePercents | null > | null,
  clientIncrements?:  Array<ClientFeePercents | null > | null,
  year?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePopMaterialInput = {
  id: string,
  name?: string | null,
  route?: string | null,
  image?: FileInput | null,
  visibleFor?: Array< string | null > | null,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  year?: string | null,
};

export type DeletePopMaterialInput = {
  id: string,
};

export type CreateVehicleTypeInput = {
  id?: string | null,
  name: string,
  popMaterialId: string,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
};

export type ModelVehicleTypeConditionInput = {
  name?: ModelStringInput | null,
  popMaterialId?: ModelIDInput | null,
  visibleFor?: ModelStringInput | null,
  region?: ModelStringInput | null,
  and?: Array< ModelVehicleTypeConditionInput | null > | null,
  or?: Array< ModelVehicleTypeConditionInput | null > | null,
  not?: ModelVehicleTypeConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type VehicleType = {
  __typename: "VehicleType",
  id: string,
  name: string,
  popMaterialId: string,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
  clientDiscounts?:  Array<ClientDiscountPercents | null > | null,
  clientFeeIncrements?:  Array<ClientFeePercents | null > | null,
  clientIncrements?:  Array<ClientFeePercents | null > | null,
  popMaterial?: PopMaterial | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateVehicleTypeInput = {
  id: string,
  name?: string | null,
  popMaterialId?: string | null,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
};

export type DeleteVehicleTypeInput = {
  id: string,
};

export type CreateVehicleInput = {
  id?: string | null,
  status?: string | null,
  isSustainable?: boolean | null,
  multiProvider?: boolean | null,
  itemName?: string | null,
  bestSeller?: string | null,
  name: string,
  brand: string,
  channel: string,
  images: Array< FileInput >,
  description: string,
  size: string,
  materialDetail?: string | null,
  print?: string | null,
  finish?: string | null,
  packaging?: string | null,
  quantity: number,
  unitPrice: number,
  prototypePrice: number,
  productionTime: string,
  vehicleTypeId: string,
  popMaterialId: string,
  popCategoryId?: string | null,
  providerId: string,
  isRfq?: boolean | null,
  historicCost?: string | null,
  historicTime?: string | null,
  contact?: string | null,
  providerName?: string | null,
  variantsUnits?: Array< VariantsUnitsInput | null > | null,
  visibleFor?: Array< string | null > | null,
  filterColors?: Array< string | null > | null,
  providers?: Array< string | null > | null,
  massiveLayout?: string | null,
  created: number,
  updated?: number | null,
};

export type VariantsUnitsInput = {
  min_units?: number | null,
  max_units?: number | null,
  price?: number | null,
  production_time?: number | null,
};

export type ModelVehicleConditionInput = {
  status?: ModelStringInput | null,
  isSustainable?: ModelBooleanInput | null,
  multiProvider?: ModelBooleanInput | null,
  itemName?: ModelStringInput | null,
  bestSeller?: ModelStringInput | null,
  name?: ModelStringInput | null,
  brand?: ModelStringInput | null,
  channel?: ModelStringInput | null,
  description?: ModelStringInput | null,
  size?: ModelStringInput | null,
  materialDetail?: ModelStringInput | null,
  print?: ModelStringInput | null,
  finish?: ModelStringInput | null,
  packaging?: ModelStringInput | null,
  quantity?: ModelIntInput | null,
  unitPrice?: ModelFloatInput | null,
  prototypePrice?: ModelFloatInput | null,
  productionTime?: ModelStringInput | null,
  vehicleTypeId?: ModelIDInput | null,
  popMaterialId?: ModelIDInput | null,
  popCategoryId?: ModelIDInput | null,
  providerId?: ModelIDInput | null,
  isRfq?: ModelBooleanInput | null,
  historicCost?: ModelStringInput | null,
  historicTime?: ModelStringInput | null,
  contact?: ModelStringInput | null,
  providerName?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  filterColors?: ModelStringInput | null,
  providers?: ModelStringInput | null,
  massiveLayout?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelVehicleConditionInput | null > | null,
  or?: Array< ModelVehicleConditionInput | null > | null,
  not?: ModelVehicleConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Vehicle = {
  __typename: "Vehicle",
  id: string,
  status?: string | null,
  isSustainable?: boolean | null,
  multiProvider?: boolean | null,
  itemName?: string | null,
  bestSeller?: string | null,
  name: string,
  brand: string,
  channel: string,
  images:  Array<File >,
  description: string,
  size: string,
  materialDetail?: string | null,
  print?: string | null,
  finish?: string | null,
  packaging?: string | null,
  quantity: number,
  unitPrice: number,
  prototypePrice: number,
  productionTime: string,
  vehicleTypeId: string,
  popMaterialId: string,
  popCategoryId?: string | null,
  providerId: string,
  isRfq?: boolean | null,
  historicCost?: string | null,
  historicTime?: string | null,
  contact?: string | null,
  providerName?: string | null,
  variantsUnits?:  Array<VariantsUnits | null > | null,
  visibleFor?: Array< string | null > | null,
  filterColors?: Array< string | null > | null,
  providers?: Array< string | null > | null,
  massiveLayout?: string | null,
  created: number,
  updated?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type VariantsUnits = {
  __typename: "VariantsUnits",
  min_units?: number | null,
  max_units?: number | null,
  price?: number | null,
  production_time?: number | null,
};

export type UpdateVehicleInput = {
  id: string,
  status?: string | null,
  isSustainable?: boolean | null,
  multiProvider?: boolean | null,
  itemName?: string | null,
  bestSeller?: string | null,
  name?: string | null,
  brand?: string | null,
  channel?: string | null,
  images?: Array< FileInput > | null,
  description?: string | null,
  size?: string | null,
  materialDetail?: string | null,
  print?: string | null,
  finish?: string | null,
  packaging?: string | null,
  quantity?: number | null,
  unitPrice?: number | null,
  prototypePrice?: number | null,
  productionTime?: string | null,
  vehicleTypeId?: string | null,
  popMaterialId?: string | null,
  popCategoryId?: string | null,
  providerId?: string | null,
  isRfq?: boolean | null,
  historicCost?: string | null,
  historicTime?: string | null,
  contact?: string | null,
  providerName?: string | null,
  variantsUnits?: Array< VariantsUnitsInput | null > | null,
  visibleFor?: Array< string | null > | null,
  filterColors?: Array< string | null > | null,
  providers?: Array< string | null > | null,
  massiveLayout?: string | null,
  created?: number | null,
  updated?: number | null,
};

export type DeleteVehicleInput = {
  id: string,
};

export type CreatePopOrderInput = {
  id?: string | null,
  estatus: string,
  comments?: Array< CommentInput | null > | null,
  orderId?: number | null,
  requirement?: string | null,
  budget?: number | null,
  delivery_addresses?: Array< AddressInput | null > | null,
  delivery_cost?: number | null,
  delivery_time?: number | null,
  files?: Array< ListFilesInput | null > | null,
  contact?: OrderContactInput | null,
  subtotal?: number | null,
  total?: number | null,
  isCoupa: boolean,
  sentToCoupa?: boolean | null,
  coupaOrder?: string | null,
  active?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  orderAgents?: Array< OrderAgentInput | null > | null,
  orderAgentIds?: Array< string | null > | null,
  buyerInfo?: OrderBuyerInput | null,
  buyersInfo?: Array< OrderBuyerInput | null > | null,
  gr?: string | null,
  orderCreatorId: string,
  creator?: OrderCreatorInput | null,
  prequoteApproved?: boolean | null,
  quoteApproved?: boolean | null,
  prototypeApproved?: boolean | null,
  samplesDocsUploaded?: boolean | null,
  samplesApproved?: boolean | null,
  auditRequired?: boolean | null,
  drivePath?: string | null,
  auditDocsUploaded?: boolean | null,
  deliveryDateRequested?: boolean | null,
  deliveryDate?: number | null,
  deliveryCode?: string | null,
  deliveryFilesUploaded?: boolean | null,
  deliveryDocsApproved?: boolean | null,
  grUploaded?: boolean | null,
  grApproved?: boolean | null,
  grCode?: string | null,
  qrCode?: boolean | null,
  brandfactoryCheck?: boolean | null,
  step?: number | null,
  prototype?: boolean | null,
  dateKickoff?: number | null,
  paymentDate?: number | null,
  currentProcess?: string | null,
  currentSubprocess?: string | null,
  clientId?: string | null,
};

export type ModelPopOrderConditionInput = {
  estatus?: ModelStringInput | null,
  orderId?: ModelIntInput | null,
  requirement?: ModelStringInput | null,
  budget?: ModelFloatInput | null,
  delivery_cost?: ModelFloatInput | null,
  delivery_time?: ModelIntInput | null,
  subtotal?: ModelFloatInput | null,
  total?: ModelFloatInput | null,
  isCoupa?: ModelBooleanInput | null,
  sentToCoupa?: ModelBooleanInput | null,
  coupaOrder?: ModelStringInput | null,
  active?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  orderAgentIds?: ModelStringInput | null,
  gr?: ModelStringInput | null,
  orderCreatorId?: ModelIDInput | null,
  prequoteApproved?: ModelBooleanInput | null,
  quoteApproved?: ModelBooleanInput | null,
  prototypeApproved?: ModelBooleanInput | null,
  samplesDocsUploaded?: ModelBooleanInput | null,
  samplesApproved?: ModelBooleanInput | null,
  auditRequired?: ModelBooleanInput | null,
  drivePath?: ModelStringInput | null,
  auditDocsUploaded?: ModelBooleanInput | null,
  deliveryDateRequested?: ModelBooleanInput | null,
  deliveryDate?: ModelIntInput | null,
  deliveryCode?: ModelStringInput | null,
  deliveryFilesUploaded?: ModelBooleanInput | null,
  deliveryDocsApproved?: ModelBooleanInput | null,
  grUploaded?: ModelBooleanInput | null,
  grApproved?: ModelBooleanInput | null,
  grCode?: ModelStringInput | null,
  qrCode?: ModelBooleanInput | null,
  brandfactoryCheck?: ModelBooleanInput | null,
  step?: ModelIntInput | null,
  prototype?: ModelBooleanInput | null,
  dateKickoff?: ModelIntInput | null,
  paymentDate?: ModelIntInput | null,
  currentProcess?: ModelStringInput | null,
  currentSubprocess?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  and?: Array< ModelPopOrderConditionInput | null > | null,
  or?: Array< ModelPopOrderConditionInput | null > | null,
  not?: ModelPopOrderConditionInput | null,
};

export type PopOrder = {
  __typename: "PopOrder",
  id: string,
  estatus: string,
  comments?:  Array<Comment | null > | null,
  orderId?: number | null,
  requirement?: string | null,
  budget?: number | null,
  delivery_addresses?:  Array<Address | null > | null,
  delivery_cost?: number | null,
  delivery_time?: number | null,
  files?:  Array<ListFiles | null > | null,
  contact?: OrderContact | null,
  subtotal?: number | null,
  total?: number | null,
  isCoupa: boolean,
  sentToCoupa?: boolean | null,
  coupaOrder?: string | null,
  active?: string | null,
  vehicles?: ModelPopOrderVehicleConnection | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  orderAgents?:  Array<OrderAgent | null > | null,
  orderAgentIds?: Array< string | null > | null,
  buyerInfo?: OrderBuyer | null,
  buyersInfo?:  Array<OrderBuyer | null > | null,
  gr?: string | null,
  orderCreatorId: string,
  providers?: ModelPopOrderProviderConnection | null,
  creator?: OrderCreator | null,
  prequoteApproved?: boolean | null,
  quoteApproved?: boolean | null,
  prototypeApproved?: boolean | null,
  samplesDocsUploaded?: boolean | null,
  samplesApproved?: boolean | null,
  auditRequired?: boolean | null,
  drivePath?: string | null,
  auditDocsUploaded?: boolean | null,
  deliveryDateRequested?: boolean | null,
  deliveryDate?: number | null,
  deliveryCode?: string | null,
  deliveryFilesUploaded?: boolean | null,
  deliveryDocsApproved?: boolean | null,
  grUploaded?: boolean | null,
  grApproved?: boolean | null,
  grCode?: string | null,
  qrCode?: boolean | null,
  brandfactoryCheck?: boolean | null,
  step?: number | null,
  prototype?: boolean | null,
  dateKickoff?: number | null,
  paymentDate?: number | null,
  currentProcess?: string | null,
  currentSubprocess?: string | null,
  clientId?: string | null,
};

export type ModelPopOrderVehicleConnection = {
  __typename: "ModelPopOrderVehicleConnection",
  items:  Array<PopOrderVehicle | null >,
  nextToken?: string | null,
};

export type PopOrderVehicle = {
  __typename: "PopOrderVehicle",
  id: string,
  orderId: string,
  vehicleId: string,
  providerId: string,
  unitPrice: number,
  prototypePrice: number,
  quantity: number,
  approved: boolean,
  hasQrCode?: boolean | null,
  vehicle: Vehicle,
  order: PopOrder,
  provider: Provider,
  sampleTestDate?: number | null,
  sampleTestDateApproved?: boolean | null,
  prototypeDate?: number | null,
  prototypeDateApproved?: boolean | null,
  logs?:  Array<ProductInOrderLog | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelPopOrderProviderConnection = {
  __typename: "ModelPopOrderProviderConnection",
  items:  Array<PopOrderProvider | null >,
  nextToken?: string | null,
};

export type PopOrderProvider = {
  __typename: "PopOrderProvider",
  id: string,
  orderId: string,
  providerId: string,
  deliveryDateRequested?: boolean | null,
  grRequested?: boolean | null,
  invoiceUploaded?: boolean | null,
  order: PopOrder,
  provider: Provider,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdatePopOrderInput = {
  id: string,
  estatus?: string | null,
  comments?: Array< CommentInput | null > | null,
  orderId?: number | null,
  requirement?: string | null,
  budget?: number | null,
  delivery_addresses?: Array< AddressInput | null > | null,
  delivery_cost?: number | null,
  delivery_time?: number | null,
  files?: Array< ListFilesInput | null > | null,
  contact?: OrderContactInput | null,
  subtotal?: number | null,
  total?: number | null,
  isCoupa?: boolean | null,
  sentToCoupa?: boolean | null,
  coupaOrder?: string | null,
  active?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  orderAgents?: Array< OrderAgentInput | null > | null,
  orderAgentIds?: Array< string | null > | null,
  buyerInfo?: OrderBuyerInput | null,
  buyersInfo?: Array< OrderBuyerInput | null > | null,
  gr?: string | null,
  orderCreatorId?: string | null,
  creator?: OrderCreatorInput | null,
  prequoteApproved?: boolean | null,
  quoteApproved?: boolean | null,
  prototypeApproved?: boolean | null,
  samplesDocsUploaded?: boolean | null,
  samplesApproved?: boolean | null,
  auditRequired?: boolean | null,
  drivePath?: string | null,
  auditDocsUploaded?: boolean | null,
  deliveryDateRequested?: boolean | null,
  deliveryDate?: number | null,
  deliveryCode?: string | null,
  deliveryFilesUploaded?: boolean | null,
  deliveryDocsApproved?: boolean | null,
  grUploaded?: boolean | null,
  grApproved?: boolean | null,
  grCode?: string | null,
  qrCode?: boolean | null,
  brandfactoryCheck?: boolean | null,
  step?: number | null,
  prototype?: boolean | null,
  dateKickoff?: number | null,
  paymentDate?: number | null,
  currentProcess?: string | null,
  currentSubprocess?: string | null,
  clientId?: string | null,
};

export type DeletePopOrderInput = {
  id: string,
};

export type CreateOrderFileInput = {
  id?: string | null,
  createdAt?: string | null,
  creatorId: string,
  orderId: string,
  key?: string | null,
  url?: string | null,
  orderStatus: string,
};

export type ModelOrderFileConditionInput = {
  createdAt?: ModelStringInput | null,
  creatorId?: ModelIDInput | null,
  orderId?: ModelIDInput | null,
  key?: ModelStringInput | null,
  url?: ModelStringInput | null,
  orderStatus?: ModelStringInput | null,
  and?: Array< ModelOrderFileConditionInput | null > | null,
  or?: Array< ModelOrderFileConditionInput | null > | null,
  not?: ModelOrderFileConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type OrderFile = {
  __typename: "OrderFile",
  id: string,
  createdAt?: string | null,
  creatorId: string,
  orderId: string,
  key?: string | null,
  url?: string | null,
  orderStatus: string,
  updatedAt: string,
};

export type UpdateOrderFileInput = {
  id: string,
  createdAt?: string | null,
  creatorId?: string | null,
  orderId?: string | null,
  key?: string | null,
  url?: string | null,
  orderStatus?: string | null,
};

export type DeleteOrderFileInput = {
  id: string,
};

export type CreatePopOrderVehicleInput = {
  id?: string | null,
  orderId: string,
  vehicleId: string,
  providerId: string,
  unitPrice: number,
  prototypePrice: number,
  quantity: number,
  approved: boolean,
  hasQrCode?: boolean | null,
  sampleTestDate?: number | null,
  sampleTestDateApproved?: boolean | null,
  prototypeDate?: number | null,
  prototypeDateApproved?: boolean | null,
  logs?: Array< ProductInOrderLogInput | null > | null,
};

export type ModelPopOrderVehicleConditionInput = {
  orderId?: ModelIDInput | null,
  vehicleId?: ModelIDInput | null,
  providerId?: ModelIDInput | null,
  unitPrice?: ModelFloatInput | null,
  prototypePrice?: ModelFloatInput | null,
  quantity?: ModelIntInput | null,
  approved?: ModelBooleanInput | null,
  hasQrCode?: ModelBooleanInput | null,
  sampleTestDate?: ModelIntInput | null,
  sampleTestDateApproved?: ModelBooleanInput | null,
  prototypeDate?: ModelIntInput | null,
  prototypeDateApproved?: ModelBooleanInput | null,
  and?: Array< ModelPopOrderVehicleConditionInput | null > | null,
  or?: Array< ModelPopOrderVehicleConditionInput | null > | null,
  not?: ModelPopOrderVehicleConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdatePopOrderVehicleInput = {
  id: string,
  orderId?: string | null,
  vehicleId?: string | null,
  providerId?: string | null,
  unitPrice?: number | null,
  prototypePrice?: number | null,
  quantity?: number | null,
  approved?: boolean | null,
  hasQrCode?: boolean | null,
  sampleTestDate?: number | null,
  sampleTestDateApproved?: boolean | null,
  prototypeDate?: number | null,
  prototypeDateApproved?: boolean | null,
  logs?: Array< ProductInOrderLogInput | null > | null,
};

export type DeletePopOrderVehicleInput = {
  id: string,
};

export type CreatePopOrderAuthorizerInput = {
  id?: string | null,
  userId: string,
};

export type ModelPopOrderAuthorizerConditionInput = {
  userId?: ModelIDInput | null,
  and?: Array< ModelPopOrderAuthorizerConditionInput | null > | null,
  or?: Array< ModelPopOrderAuthorizerConditionInput | null > | null,
  not?: ModelPopOrderAuthorizerConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PopOrderAuthorizer = {
  __typename: "PopOrderAuthorizer",
  id: string,
  userId: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePopOrderAuthorizerInput = {
  id: string,
  userId?: string | null,
};

export type DeletePopOrderAuthorizerInput = {
  id: string,
};

export type CreatePopOrderProviderInput = {
  id?: string | null,
  orderId: string,
  providerId: string,
  deliveryDateRequested?: boolean | null,
  grRequested?: boolean | null,
  invoiceUploaded?: boolean | null,
  createdAt?: string | null,
};

export type ModelPopOrderProviderConditionInput = {
  orderId?: ModelIDInput | null,
  providerId?: ModelIDInput | null,
  deliveryDateRequested?: ModelBooleanInput | null,
  grRequested?: ModelBooleanInput | null,
  invoiceUploaded?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPopOrderProviderConditionInput | null > | null,
  or?: Array< ModelPopOrderProviderConditionInput | null > | null,
  not?: ModelPopOrderProviderConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdatePopOrderProviderInput = {
  id: string,
  orderId?: string | null,
  providerId?: string | null,
  deliveryDateRequested?: boolean | null,
  grRequested?: boolean | null,
  invoiceUploaded?: boolean | null,
  createdAt?: string | null,
};

export type DeletePopOrderProviderInput = {
  id: string,
};

export type CreatePopOrderLogInput = {
  id?: string | null,
  orderId: string,
  creatorId: string,
  createdAt?: string | null,
  text: string,
  orderStatus: string,
};

export type ModelPopOrderLogConditionInput = {
  orderId?: ModelIDInput | null,
  creatorId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  text?: ModelStringInput | null,
  orderStatus?: ModelStringInput | null,
  and?: Array< ModelPopOrderLogConditionInput | null > | null,
  or?: Array< ModelPopOrderLogConditionInput | null > | null,
  not?: ModelPopOrderLogConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PopOrderLog = {
  __typename: "PopOrderLog",
  id: string,
  orderId: string,
  creatorId: string,
  order?: PopOrder | null,
  createdAt?: string | null,
  text: string,
  orderStatus: string,
  updatedAt: string,
};

export type UpdatePopOrderLogInput = {
  id: string,
  orderId?: string | null,
  creatorId?: string | null,
  createdAt?: string | null,
  text?: string | null,
  orderStatus?: string | null,
};

export type DeletePopOrderLogInput = {
  id: string,
};

export type CreateRfqPopInput = {
  id?: string | null,
  nombre: string,
  requerimiento: string,
  vehicleTypeId?: string | null,
  popMaterialId?: string | null,
  vehiclesRfq?: Array< VehicleUnitRfqInput | null > | null,
  files?: Array< FileInput | null > | null,
  compras?: ContactInput | null,
  cantidad: number,
  limit_time: number,
  creatorInfo?: OrderCreatorInput | null,
  chat?: Array< RfqChatInput | null > | null,
  creator?: string | null,
  clientId?: string | null,
  winner?: WinnerInput | null,
  logs?: Array< LogsInput | null > | null,
  providers?: Array< RfqPopProvidersInput | null > | null,
  orderAgents?: Array< OrderAgentInput | null > | null,
  orderAgentIds?: Array< string | null > | null,
  popOrderId?: string | null,
  orderId?: number | null,
  estatus: string,
  start_time: number,
  delivery_time?: number | null,
  saving?: number | null,
  saving_percentage?: number | null,
  saving_real?: number | null,
  budget?: number | null,
  hasQrCode?: boolean | null,
  created: number,
  createdAt?: string | null,
  updated?: number | null,
};

export type VehicleUnitRfqInput = {
  vehicleTypeId?: string | null,
  popMaterialId?: string | null,
  name?: string | null,
  description?: string | null,
  pieces?: number | null,
  createdId?: number | null,
};

export type RfqPopProvidersInput = {
  idProvider?: string | null,
};

export type ModelRfqPopConditionInput = {
  nombre?: ModelStringInput | null,
  requerimiento?: ModelStringInput | null,
  vehicleTypeId?: ModelIDInput | null,
  popMaterialId?: ModelIDInput | null,
  cantidad?: ModelIntInput | null,
  limit_time?: ModelIntInput | null,
  creator?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  orderAgentIds?: ModelStringInput | null,
  popOrderId?: ModelStringInput | null,
  orderId?: ModelIntInput | null,
  estatus?: ModelStringInput | null,
  start_time?: ModelIntInput | null,
  delivery_time?: ModelIntInput | null,
  saving?: ModelFloatInput | null,
  saving_percentage?: ModelFloatInput | null,
  saving_real?: ModelFloatInput | null,
  budget?: ModelFloatInput | null,
  hasQrCode?: ModelBooleanInput | null,
  created?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelRfqPopConditionInput | null > | null,
  or?: Array< ModelRfqPopConditionInput | null > | null,
  not?: ModelRfqPopConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type RfqPop = {
  __typename: "RfqPop",
  id: string,
  nombre: string,
  requerimiento: string,
  vehicleTypeId?: string | null,
  popMaterialId?: string | null,
  vehiclesRfq?:  Array<VehicleUnitRfq | null > | null,
  files?:  Array<File | null > | null,
  compras?: Contact | null,
  cantidad: number,
  limit_time: number,
  creatorInfo?: OrderCreator | null,
  chat?:  Array<RfqChat | null > | null,
  proposals?: ModelProposalsPopConnection | null,
  creator?: string | null,
  clientId?: string | null,
  winner?: Winner | null,
  logs?:  Array<Logs | null > | null,
  providers?:  Array<RfqPopProviders | null > | null,
  orderAgents?:  Array<OrderAgent | null > | null,
  orderAgentIds?: Array< string | null > | null,
  popOrderId?: string | null,
  orderId?: number | null,
  estatus: string,
  start_time: number,
  delivery_time?: number | null,
  saving?: number | null,
  saving_percentage?: number | null,
  saving_real?: number | null,
  budget?: number | null,
  hasQrCode?: boolean | null,
  created: number,
  createdAt?: string | null,
  updated?: number | null,
  updatedAt: string,
};

export type VehicleUnitRfq = {
  __typename: "VehicleUnitRfq",
  vehicleTypeId?: string | null,
  popMaterialId?: string | null,
  name?: string | null,
  description?: string | null,
  pieces?: number | null,
  createdId?: number | null,
};

export type ModelProposalsPopConnection = {
  __typename: "ModelProposalsPopConnection",
  items:  Array<ProposalsPop | null >,
  nextToken?: string | null,
};

export type ProposalsPop = {
  __typename: "ProposalsPop",
  id: string,
  provider_id: string,
  delivery_time: Range,
  price: number,
  created: number,
  validity_days?: number | null,
  description?: string | null,
  comments?:  Array<Comment | null > | null,
  chat?:  Array<RfqChat | null > | null,
  vehicles?:  Array<VehiclesProposalsPop | null > | null,
  updated?: number | null,
  files?:  Array<File | null > | null,
  rfq?: RfqPop | null,
  proposalsPopRfqId?: string | null,
  prototypePrice: number,
  hidden?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type VehiclesProposalsPop = {
  __typename: "VehiclesProposalsPop",
  productUnitRfqIndex?: number | null,
  selected?: boolean | null,
  name?: string | null,
  popMaterialId?: string | null,
  vehicleTypeId?: string | null,
  brand?: string | null,
  size?: string | null,
  description?: string | null,
  quantity?: number | null,
  packaging?: string | null,
  materialDetail?: string | null,
  print?: string | null,
  unitPrice?: number | null,
  pieces?: number | null,
  priceUnit?: number | null,
  total?: number | null,
  idProducto?: number | null,
  files?:  Array<File | null > | null,
};

export type RfqPopProviders = {
  __typename: "RfqPopProviders",
  idProvider?: string | null,
};

export type UpdateRfqPopInput = {
  id: string,
  nombre?: string | null,
  requerimiento?: string | null,
  vehicleTypeId?: string | null,
  popMaterialId?: string | null,
  vehiclesRfq?: Array< VehicleUnitRfqInput | null > | null,
  files?: Array< FileInput | null > | null,
  compras?: ContactInput | null,
  cantidad?: number | null,
  limit_time?: number | null,
  creatorInfo?: OrderCreatorInput | null,
  chat?: Array< RfqChatInput | null > | null,
  creator?: string | null,
  clientId?: string | null,
  winner?: WinnerInput | null,
  logs?: Array< LogsInput | null > | null,
  providers?: Array< RfqPopProvidersInput | null > | null,
  orderAgents?: Array< OrderAgentInput | null > | null,
  orderAgentIds?: Array< string | null > | null,
  popOrderId?: string | null,
  orderId?: number | null,
  estatus?: string | null,
  start_time?: number | null,
  delivery_time?: number | null,
  saving?: number | null,
  saving_percentage?: number | null,
  saving_real?: number | null,
  budget?: number | null,
  hasQrCode?: boolean | null,
  created?: number | null,
  createdAt?: string | null,
  updated?: number | null,
};

export type DeleteRfqPopInput = {
  id: string,
};

export type CreateProposalsPopInput = {
  id?: string | null,
  provider_id: string,
  delivery_time: RangeInput,
  price: number,
  created: number,
  validity_days?: number | null,
  description?: string | null,
  comments?: Array< CommentInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  vehicles?: Array< VehiclesProposalsPopInput | null > | null,
  updated?: number | null,
  files?: Array< FileInput | null > | null,
  proposalsPopRfqId?: string | null,
  prototypePrice: number,
  hidden?: boolean | null,
};

export type VehiclesProposalsPopInput = {
  productUnitRfqIndex?: number | null,
  selected?: boolean | null,
  name?: string | null,
  popMaterialId?: string | null,
  vehicleTypeId?: string | null,
  brand?: string | null,
  size?: string | null,
  description?: string | null,
  quantity?: number | null,
  packaging?: string | null,
  materialDetail?: string | null,
  print?: string | null,
  unitPrice?: number | null,
  pieces?: number | null,
  priceUnit?: number | null,
  total?: number | null,
  idProducto?: number | null,
  files?: Array< FileInput | null > | null,
};

export type ModelProposalsPopConditionInput = {
  provider_id?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  created?: ModelIntInput | null,
  validity_days?: ModelIntInput | null,
  description?: ModelStringInput | null,
  updated?: ModelIntInput | null,
  proposalsPopRfqId?: ModelIDInput | null,
  prototypePrice?: ModelFloatInput | null,
  hidden?: ModelBooleanInput | null,
  and?: Array< ModelProposalsPopConditionInput | null > | null,
  or?: Array< ModelProposalsPopConditionInput | null > | null,
  not?: ModelProposalsPopConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateProposalsPopInput = {
  id: string,
  provider_id?: string | null,
  delivery_time?: RangeInput | null,
  price?: number | null,
  created?: number | null,
  validity_days?: number | null,
  description?: string | null,
  comments?: Array< CommentInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  vehicles?: Array< VehiclesProposalsPopInput | null > | null,
  updated?: number | null,
  files?: Array< FileInput | null > | null,
  proposalsPopRfqId?: string | null,
  prototypePrice?: number | null,
  hidden?: boolean | null,
};

export type DeleteProposalsPopInput = {
  id: string,
};

export type CreateUsersBrandsInput = {
  id?: string | null,
  name: string,
  description?: string | null,
  logo?: FileInput | null,
  status?: string | null,
  clientId?: string | null,
};

export type ModelUsersBrandsConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  status?: ModelStringInput | null,
  clientId?: ModelIDInput | null,
  and?: Array< ModelUsersBrandsConditionInput | null > | null,
  or?: Array< ModelUsersBrandsConditionInput | null > | null,
  not?: ModelUsersBrandsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UsersBrands = {
  __typename: "UsersBrands",
  id: string,
  name: string,
  description?: string | null,
  logo?: File | null,
  status?: string | null,
  clientId?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateUsersBrandsInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  logo?: FileInput | null,
  status?: string | null,
  clientId?: string | null,
};

export type DeleteUsersBrandsInput = {
  id: string,
};

export type CreateUserBrandSettingInput = {
  id?: string | null,
  categories?: Array< string | null > | null,
  subcategories?: Array< string | null > | null,
  createdAt?: string | null,
};

export type ModelUserBrandSettingConditionInput = {
  categories?: ModelStringInput | null,
  subcategories?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelUserBrandSettingConditionInput | null > | null,
  or?: Array< ModelUserBrandSettingConditionInput | null > | null,
  not?: ModelUserBrandSettingConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UserBrandSetting = {
  __typename: "UserBrandSetting",
  id: string,
  categories?: Array< string | null > | null,
  subcategories?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateUserBrandSettingInput = {
  id: string,
  categories?: Array< string | null > | null,
  subcategories?: Array< string | null > | null,
  createdAt?: string | null,
};

export type DeleteUserBrandSettingInput = {
  id: string,
};

export type CreateLogsPUsersInput = {
  id?: string | null,
  user?: string | null,
  keyword?: string | null,
  createdAt?: string | null,
};

export type ModelLogsPUsersConditionInput = {
  user?: ModelStringInput | null,
  keyword?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelLogsPUsersConditionInput | null > | null,
  or?: Array< ModelLogsPUsersConditionInput | null > | null,
  not?: ModelLogsPUsersConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LogsPUsers = {
  __typename: "LogsPUsers",
  id: string,
  user?: string | null,
  keyword?: string | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateLogsPUsersInput = {
  id: string,
  user?: string | null,
  keyword?: string | null,
  createdAt?: string | null,
};

export type DeleteLogsPUsersInput = {
  id: string,
};

export type CreateClipPaymentInput = {
  id?: string | null,
  status?: string | null,
  requestsCount?: number | null,
  payment_request_id?: string | null,
  purchase_description?: string | null,
  orderId: string,
  clientId: string,
  userId: string,
  creator?: OrderCreatorInput | null,
  created: number,
  updated?: number | null,
};

export type ModelClipPaymentConditionInput = {
  status?: ModelStringInput | null,
  requestsCount?: ModelIntInput | null,
  payment_request_id?: ModelStringInput | null,
  purchase_description?: ModelStringInput | null,
  orderId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelClipPaymentConditionInput | null > | null,
  or?: Array< ModelClipPaymentConditionInput | null > | null,
  not?: ModelClipPaymentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ClipPayment = {
  __typename: "ClipPayment",
  id: string,
  status?: string | null,
  requestsCount?: number | null,
  payment_request_id?: string | null,
  purchase_description?: string | null,
  orderId: string,
  clientId: string,
  userId: string,
  creator?: OrderCreator | null,
  created: number,
  updated?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateClipPaymentInput = {
  id: string,
  status?: string | null,
  requestsCount?: number | null,
  payment_request_id?: string | null,
  purchase_description?: string | null,
  orderId?: string | null,
  clientId?: string | null,
  userId?: string | null,
  creator?: OrderCreatorInput | null,
  created?: number | null,
  updated?: number | null,
};

export type DeleteClipPaymentInput = {
  id: string,
};

export type CreateOrderProcessInput = {
  id?: string | null,
  type?: string | null,
  status?: boolean | null,
  tcdPayment?: boolean | null,
  name: string,
  duration?: string | null,
  descripcion?: string | null,
  position: number,
  responsible?: number | null,
  image?: FileInput | null,
  cards?: Array< OrderCardsInput | null > | null,
  clientId?: string | null,
  createdAt?: string | null,
};

export type OrderCardsInput = {
  id?: string | null,
  name?: string | null,
  permissions?: Array< OrderCardPermissionsInput | null > | null,
};

export type OrderCardPermissionsInput = {
  idCard: string,
  rol: string,
  thirdContent?: boolean | null,
  visible?: boolean | null,
};

export type ModelOrderProcessConditionInput = {
  type?: ModelStringInput | null,
  status?: ModelBooleanInput | null,
  tcdPayment?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  duration?: ModelStringInput | null,
  descripcion?: ModelStringInput | null,
  position?: ModelIntInput | null,
  responsible?: ModelIntInput | null,
  clientId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelOrderProcessConditionInput | null > | null,
  or?: Array< ModelOrderProcessConditionInput | null > | null,
  not?: ModelOrderProcessConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type OrderProcess = {
  __typename: "OrderProcess",
  id: string,
  type?: string | null,
  status?: boolean | null,
  tcdPayment?: boolean | null,
  name: string,
  duration?: string | null,
  descripcion?: string | null,
  position: number,
  responsible?: number | null,
  image?: File | null,
  cards?:  Array<OrderCards | null > | null,
  subprocesses?: ModelOrderSubprocessConnection | null,
  clientId?: string | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type OrderCards = {
  __typename: "OrderCards",
  id?: string | null,
  name?: string | null,
  permissions?:  Array<OrderCardPermissions | null > | null,
};

export type OrderCardPermissions = {
  __typename: "OrderCardPermissions",
  idCard: string,
  rol: string,
  thirdContent?: boolean | null,
  visible?: boolean | null,
};

export type ModelOrderSubprocessConnection = {
  __typename: "ModelOrderSubprocessConnection",
  items:  Array<OrderSubprocess | null >,
  nextToken?: string | null,
};

export type OrderSubprocess = {
  __typename: "OrderSubprocess",
  id: string,
  type?: string | null,
  status?: boolean | null,
  name: string,
  position: number,
  descripcion: string,
  action: number,
  process?: OrderProcess | null,
  processId: string,
  clientId: string,
  messages?:  Array<MessageSubprocess | null > | null,
  notifications?:  Array<NotificationSubprocesses | null > | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type MessageSubprocess = {
  __typename: "MessageSubprocess",
  description?: string | null,
  rol?: string | null,
  visibleAction?: boolean | null,
};

export type NotificationSubprocesses = {
  __typename: "NotificationSubprocesses",
  group?: string | null,
  enabledEmail?: boolean | null,
  enabledPopUp?: boolean | null,
};

export type UpdateOrderProcessInput = {
  id: string,
  type?: string | null,
  status?: boolean | null,
  tcdPayment?: boolean | null,
  name?: string | null,
  duration?: string | null,
  descripcion?: string | null,
  position?: number | null,
  responsible?: number | null,
  image?: FileInput | null,
  cards?: Array< OrderCardsInput | null > | null,
  clientId?: string | null,
  createdAt?: string | null,
};

export type DeleteOrderProcessInput = {
  id: string,
};

export type CreateOrderSubprocessInput = {
  id?: string | null,
  type?: string | null,
  status?: boolean | null,
  name: string,
  position: number,
  descripcion: string,
  action: number,
  processId: string,
  clientId: string,
  messages?: Array< MessageSubprocessInput | null > | null,
  notifications?: Array< NotificationSubprocessesInput | null > | null,
  createdAt?: string | null,
};

export type MessageSubprocessInput = {
  description?: string | null,
  rol?: string | null,
  visibleAction?: boolean | null,
};

export type NotificationSubprocessesInput = {
  group?: string | null,
  enabledEmail?: boolean | null,
  enabledPopUp?: boolean | null,
};

export type ModelOrderSubprocessConditionInput = {
  type?: ModelStringInput | null,
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  position?: ModelIntInput | null,
  descripcion?: ModelStringInput | null,
  action?: ModelIntInput | null,
  processId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelOrderSubprocessConditionInput | null > | null,
  or?: Array< ModelOrderSubprocessConditionInput | null > | null,
  not?: ModelOrderSubprocessConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateOrderSubprocessInput = {
  id: string,
  type?: string | null,
  status?: boolean | null,
  name?: string | null,
  position?: number | null,
  descripcion?: string | null,
  action?: number | null,
  processId?: string | null,
  clientId?: string | null,
  messages?: Array< MessageSubprocessInput | null > | null,
  notifications?: Array< NotificationSubprocessesInput | null > | null,
  createdAt?: string | null,
};

export type DeleteOrderSubprocessInput = {
  id: string,
};

export type CreatePremiumOrderInput = {
  id?: string | null,
  requirement?: string | null,
  bank_reference?: string | null,
  hasVat?: boolean | null,
  billingData?: BillingDataInput | null,
  orderId: number,
  comments?: Array< CommentInput | null > | null,
  logs?: Array< LogInput | null > | null,
  delivery_addresses?: Array< AddressInput | null > | null,
  delivery_cost?: number | null,
  delivery_fee?: number | null,
  delivery_discount?: number | null,
  delivery_time?: number | null,
  delivery_date?: string | null,
  files?: Array< ListFilesInput | null > | null,
  taxSituationFile?: FileInput | null,
  clipUrl?: string | null,
  clipStatus?: string | null,
  listProviders?: Array< ListProvidersOrderInput | null > | null,
  listsProducts: Array< ProductInOrderInput >,
  cotizationsList: Array< PremiumOrderCotizationsLogInput | null >,
  orderCreatorId: string,
  creator: OrderCreatorInput,
  orderAgents?: Array< OrderAgentInput | null > | null,
  orderAgentIds?: Array< string | null > | null,
  buyerInfo?: OrderBuyerInput | null,
  buyersInfo?: Array< OrderBuyerInput | null > | null,
  invoiceContact?: OrderBuyerInput | null,
  contact?: OrderContactInput | null,
  premiumOrderClientId?: string | null,
  userBrandId?: string | null,
  subtotal?: number | null,
  fee?: number | null,
  printedPrice?: number | null,
  total?: number | null,
  discountAmount?: number | null,
  syncWithCrm?: boolean | null,
  crmIssueKey?: string | null,
  sentToAlendum?: boolean | null,
  alendumProjectId?: string | null,
  syncWithFms?: string | null,
  fmsInvoiceId?: string | null,
  syncWithWms?: boolean | null,
  wmsProjectId?: string | null,
  isCoupa?: boolean | null,
  sentToCoupa?: boolean | null,
  isRfq?: boolean | null,
  requireSamples?: boolean | null,
  requestedSamples?: boolean | null,
  approvedSamples?: boolean | null,
  authorizedQA?: boolean | null,
  active?: string | null,
  currentProcess?: string | null,
  currentSubprocess?: string | null,
  processes?: Array< OrderProcessStructureInput | null > | null,
  updatedAt?: string | null,
  created: number,
  updated?: number | null,
  logistic?: Array< LogisticPremiumOrderInput | null > | null,
};

export type BillingDataInput = {
  name?: string | null,
  rfc?: string | null,
  regimen?: string | null,
  cfdi_use?: string | null,
  cp?: string | null,
  email?: string | null,
  address?: AddressInput | null,
};

export type LogInput = {
  text: string,
  created: number,
  creator_id: string,
  creator_name: string,
  creator_email: string,
  isSourceDataUser: boolean,
  role?: string | null,
};

export type ListProvidersOrderInput = {
  provider_id: string,
  order_id: string,
  payment_date?: number | null,
  gr_code?: string | null,
  order_confirmation?: boolean | null,
  invoice?: boolean | null,
  invoiceRequested?: boolean | null,
  uploadedGr?: boolean | null,
  uploadedBill?: boolean | null,
  delivered?: boolean | null,
  deliveredFormat?: boolean | null,
};

export type PremiumOrderCotizationsLogInput = {
  id: number,
  created: number,
  createdBy: string,
  products: Array< ProductInOrderInput >,
};

export type OrderProcessStructureInput = {
  id?: string | null,
  name?: string | null,
  descripcion?: string | null,
  duration?: string | null,
  position?: number | null,
  responsible?: number | null,
  image?: FileInput | null,
  madeBy?: string | null,
  madeAt?: number | null,
  cards?: Array< OrderCardsInput | null > | null,
  subprocesses?: Array< OrderSubprocessStructureInput | null > | null,
};

export type OrderSubprocessStructureInput = {
  id?: string | null,
  name?: string | null,
  position?: number | null,
  descripcion?: string | null,
  action?: number | null,
  process?: string | null,
  madeBy?: string | null,
  madeAt?: number | null,
  messages?: Array< MessageSubprocessInput | null > | null,
  notifications?: Array< NotificationSubprocessesInput | null > | null,
};

export type LogisticPremiumOrderInput = {
  premiumOrderId?: string | null,
  tracking_number?: string | null,
  destiny_latitude?: string | null,
  destiny_longitude?: string | null,
  status?: string | null,
  status_activity?: string | null,
  status_description?: string | null,
  origin_latitude?: string | null,
  origin_longitude?: string | null,
  carrier?: string | null,
  clave_sat?: string | null,
  customer_delivery_start_date?: string | null,
  customer_email?: string | null,
  customer_external_number?: string | null,
  customer_first_name?: string | null,
  customer_last_name?: string | null,
  customer_mobile_number?: string | null,
  customer_postcode?: string | null,
  customer_settlement?: string | null,
  customer_street?: string | null,
  descripcion_sat?: string | null,
  peligroso?: string | null,
  primary_client?: string | null,
  purchase_order_number?: string | null,
  shipping_method?: string | null,
  shipping_option?: string | null,
  created: number,
};

export type ModelPremiumOrderConditionInput = {
  requirement?: ModelStringInput | null,
  bank_reference?: ModelStringInput | null,
  hasVat?: ModelBooleanInput | null,
  orderId?: ModelIntInput | null,
  delivery_cost?: ModelFloatInput | null,
  delivery_fee?: ModelFloatInput | null,
  delivery_discount?: ModelFloatInput | null,
  delivery_time?: ModelIntInput | null,
  delivery_date?: ModelStringInput | null,
  clipUrl?: ModelStringInput | null,
  clipStatus?: ModelStringInput | null,
  orderCreatorId?: ModelStringInput | null,
  orderAgentIds?: ModelStringInput | null,
  premiumOrderClientId?: ModelIDInput | null,
  userBrandId?: ModelIDInput | null,
  subtotal?: ModelFloatInput | null,
  fee?: ModelFloatInput | null,
  printedPrice?: ModelFloatInput | null,
  total?: ModelFloatInput | null,
  discountAmount?: ModelFloatInput | null,
  syncWithCrm?: ModelBooleanInput | null,
  crmIssueKey?: ModelStringInput | null,
  sentToAlendum?: ModelBooleanInput | null,
  alendumProjectId?: ModelStringInput | null,
  syncWithFms?: ModelStringInput | null,
  fmsInvoiceId?: ModelStringInput | null,
  syncWithWms?: ModelBooleanInput | null,
  wmsProjectId?: ModelStringInput | null,
  isCoupa?: ModelBooleanInput | null,
  sentToCoupa?: ModelBooleanInput | null,
  isRfq?: ModelBooleanInput | null,
  requireSamples?: ModelBooleanInput | null,
  requestedSamples?: ModelBooleanInput | null,
  approvedSamples?: ModelBooleanInput | null,
  authorizedQA?: ModelBooleanInput | null,
  active?: ModelStringInput | null,
  currentProcess?: ModelStringInput | null,
  currentSubprocess?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelPremiumOrderConditionInput | null > | null,
  or?: Array< ModelPremiumOrderConditionInput | null > | null,
  not?: ModelPremiumOrderConditionInput | null,
  createdAt?: ModelStringInput | null,
};

export type PremiumOrder = {
  __typename: "PremiumOrder",
  id: string,
  requirement?: string | null,
  bank_reference?: string | null,
  hasVat?: boolean | null,
  billingData?: BillingData | null,
  orderId: number,
  comments?:  Array<Comment | null > | null,
  logs?:  Array<Log | null > | null,
  delivery_addresses?:  Array<Address | null > | null,
  delivery_cost?: number | null,
  delivery_fee?: number | null,
  delivery_discount?: number | null,
  delivery_time?: number | null,
  delivery_date?: string | null,
  files?:  Array<ListFiles | null > | null,
  taxSituationFile?: File | null,
  clipUrl?: string | null,
  clipStatus?: string | null,
  listProviders?:  Array<ListProvidersOrder | null > | null,
  providers?: ModelOrderProvidersConnection | null,
  listsProducts:  Array<ProductInOrder >,
  cotizationsList:  Array<PremiumOrderCotizationsLog | null >,
  orderCreatorId: string,
  creator: OrderCreator,
  orderAgents?:  Array<OrderAgent | null > | null,
  orderAgentIds?: Array< string | null > | null,
  buyerInfo?: OrderBuyer | null,
  buyersInfo?:  Array<OrderBuyer | null > | null,
  invoiceContact?: OrderBuyer | null,
  contact?: OrderContact | null,
  premiumOrderClientId?: string | null,
  client?: Client | null,
  userBrandId?: string | null,
  userBrand?: UsersBrands | null,
  subtotal?: number | null,
  fee?: number | null,
  printedPrice?: number | null,
  total?: number | null,
  discountAmount?: number | null,
  syncWithCrm?: boolean | null,
  crmIssueKey?: string | null,
  sentToAlendum?: boolean | null,
  alendumProjectId?: string | null,
  syncWithFms?: string | null,
  fmsInvoiceId?: string | null,
  syncWithWms?: boolean | null,
  wmsProjectId?: string | null,
  isCoupa?: boolean | null,
  sentToCoupa?: boolean | null,
  isRfq?: boolean | null,
  requireSamples?: boolean | null,
  requestedSamples?: boolean | null,
  approvedSamples?: boolean | null,
  authorizedQA?: boolean | null,
  active?: string | null,
  currentProcess?: string | null,
  currentSubprocess?: string | null,
  processes?:  Array<OrderProcessStructure | null > | null,
  updatedAt?: string | null,
  created: number,
  updated?: number | null,
  logistic?:  Array<LogisticPremiumOrder | null > | null,
  createdAt: string,
};

export type BillingData = {
  __typename: "BillingData",
  name?: string | null,
  rfc?: string | null,
  regimen?: string | null,
  cfdi_use?: string | null,
  cp?: string | null,
  email?: string | null,
  address?: Address | null,
};

export type Log = {
  __typename: "Log",
  text: string,
  created: number,
  creator_id: string,
  creator_name: string,
  creator_email: string,
  isSourceDataUser: boolean,
  role?: string | null,
};

export type ListProvidersOrder = {
  __typename: "ListProvidersOrder",
  provider_id: string,
  order_id: string,
  payment_date?: number | null,
  gr_code?: string | null,
  order_confirmation?: boolean | null,
  invoice?: boolean | null,
  invoiceRequested?: boolean | null,
  uploadedGr?: boolean | null,
  uploadedBill?: boolean | null,
  delivered?: boolean | null,
  deliveredFormat?: boolean | null,
};

export type ModelOrderProvidersConnection = {
  __typename: "ModelOrderProvidersConnection",
  items:  Array<OrderProviders | null >,
  nextToken?: string | null,
};

export type PremiumOrderCotizationsLog = {
  __typename: "PremiumOrderCotizationsLog",
  id: number,
  created: number,
  createdBy: string,
  products:  Array<ProductInOrder >,
};

export type OrderProcessStructure = {
  __typename: "OrderProcessStructure",
  id?: string | null,
  name?: string | null,
  descripcion?: string | null,
  duration?: string | null,
  position?: number | null,
  responsible?: number | null,
  image?: File | null,
  madeBy?: string | null,
  madeAt?: number | null,
  cards?:  Array<OrderCards | null > | null,
  subprocesses?:  Array<OrderSubprocessStructure | null > | null,
};

export type OrderSubprocessStructure = {
  __typename: "OrderSubprocessStructure",
  id?: string | null,
  name?: string | null,
  position?: number | null,
  descripcion?: string | null,
  action?: number | null,
  process?: string | null,
  madeBy?: string | null,
  madeAt?: number | null,
  messages?:  Array<MessageSubprocess | null > | null,
  notifications?:  Array<NotificationSubprocesses | null > | null,
};

export type LogisticPremiumOrder = {
  __typename: "LogisticPremiumOrder",
  premiumOrderId?: string | null,
  tracking_number?: string | null,
  destiny_latitude?: string | null,
  destiny_longitude?: string | null,
  status?: string | null,
  status_activity?: string | null,
  status_description?: string | null,
  origin_latitude?: string | null,
  origin_longitude?: string | null,
  carrier?: string | null,
  clave_sat?: string | null,
  customer_delivery_start_date?: string | null,
  customer_email?: string | null,
  customer_external_number?: string | null,
  customer_first_name?: string | null,
  customer_last_name?: string | null,
  customer_mobile_number?: string | null,
  customer_postcode?: string | null,
  customer_settlement?: string | null,
  customer_street?: string | null,
  descripcion_sat?: string | null,
  peligroso?: string | null,
  primary_client?: string | null,
  purchase_order_number?: string | null,
  shipping_method?: string | null,
  shipping_option?: string | null,
  created: number,
};

export type UpdatePremiumOrderInput = {
  id: string,
  requirement?: string | null,
  bank_reference?: string | null,
  hasVat?: boolean | null,
  billingData?: BillingDataInput | null,
  orderId?: number | null,
  comments?: Array< CommentInput | null > | null,
  logs?: Array< LogInput | null > | null,
  delivery_addresses?: Array< AddressInput | null > | null,
  delivery_cost?: number | null,
  delivery_fee?: number | null,
  delivery_discount?: number | null,
  delivery_time?: number | null,
  delivery_date?: string | null,
  files?: Array< ListFilesInput | null > | null,
  taxSituationFile?: FileInput | null,
  clipUrl?: string | null,
  clipStatus?: string | null,
  listProviders?: Array< ListProvidersOrderInput | null > | null,
  listsProducts?: Array< ProductInOrderInput > | null,
  cotizationsList?: Array< PremiumOrderCotizationsLogInput | null > | null,
  orderCreatorId?: string | null,
  creator?: OrderCreatorInput | null,
  orderAgents?: Array< OrderAgentInput | null > | null,
  orderAgentIds?: Array< string | null > | null,
  buyerInfo?: OrderBuyerInput | null,
  buyersInfo?: Array< OrderBuyerInput | null > | null,
  invoiceContact?: OrderBuyerInput | null,
  contact?: OrderContactInput | null,
  premiumOrderClientId?: string | null,
  userBrandId?: string | null,
  subtotal?: number | null,
  fee?: number | null,
  printedPrice?: number | null,
  total?: number | null,
  discountAmount?: number | null,
  syncWithCrm?: boolean | null,
  crmIssueKey?: string | null,
  sentToAlendum?: boolean | null,
  alendumProjectId?: string | null,
  syncWithFms?: string | null,
  fmsInvoiceId?: string | null,
  syncWithWms?: boolean | null,
  wmsProjectId?: string | null,
  isCoupa?: boolean | null,
  sentToCoupa?: boolean | null,
  isRfq?: boolean | null,
  requireSamples?: boolean | null,
  requestedSamples?: boolean | null,
  approvedSamples?: boolean | null,
  authorizedQA?: boolean | null,
  active?: string | null,
  currentProcess?: string | null,
  currentSubprocess?: string | null,
  processes?: Array< OrderProcessStructureInput | null > | null,
  updatedAt?: string | null,
  created?: number | null,
  updated?: number | null,
  logistic?: Array< LogisticPremiumOrderInput | null > | null,
};

export type DeletePremiumOrderInput = {
  id: string,
};

export type CreatePrintedCartInput = {
  id?: string | null,
  comments?: Array< CommentInput | null > | null,
  delivery_addresses?: Array< AddressInput | null > | null,
  files?: Array< PrintedListFilesInput | null > | null,
  printedProducts?: Array< PrintedProductInOrderInput | null > | null,
  creator: string,
  created?: number | null,
  updated?: number | null,
};

export type PrintedListFilesInput = {
  created?: number | null,
  creator_id?: string | null,
  file?: FileInput | null,
  status?: string | null,
  name?: string | null,
  type?: string | null,
  tracking_code?: string | null,
  provider_id?: string | null,
  product_id?: string | null,
  description?: string | null,
};

export type PrintedProductInOrderInput = {
  product_id: string,
  provider_id?: string | null,
  visible?: boolean | null,
  product_name: string,
  price?: number | null,
  image?: FileInput | null,
  sample_requested?: boolean | null,
  sample_request?: boolean | null,
  uploadedSample?: boolean | null,
  quantity: number,
  variant?: VariantsInput | null,
  logs?: Array< ProductInOrderLogInput | null > | null,
};

export type ModelPrintedCartConditionInput = {
  id?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelPrintedCartConditionInput | null > | null,
  or?: Array< ModelPrintedCartConditionInput | null > | null,
  not?: ModelPrintedCartConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PrintedCart = {
  __typename: "PrintedCart",
  id: string,
  comments?:  Array<Comment | null > | null,
  delivery_addresses?:  Array<Address | null > | null,
  files?:  Array<PrintedListFiles | null > | null,
  printedProducts?:  Array<PrintedProductInOrder | null > | null,
  creator: string,
  created?: number | null,
  updated?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type PrintedListFiles = {
  __typename: "PrintedListFiles",
  created?: number | null,
  creator_id?: string | null,
  file?: File | null,
  status?: string | null,
  name?: string | null,
  type?: string | null,
  tracking_code?: string | null,
  provider_id?: string | null,
  product_id?: string | null,
  description?: string | null,
};

export type PrintedProductInOrder = {
  __typename: "PrintedProductInOrder",
  product_id: string,
  provider_id?: string | null,
  visible?: boolean | null,
  product_name: string,
  price?: number | null,
  image?: File | null,
  sample_requested?: boolean | null,
  sample_request?: boolean | null,
  uploadedSample?: boolean | null,
  quantity: number,
  variant?: Variants | null,
  logs?:  Array<ProductInOrderLog | null > | null,
};

export type UpdatePrintedCartInput = {
  id: string,
  comments?: Array< CommentInput | null > | null,
  delivery_addresses?: Array< AddressInput | null > | null,
  files?: Array< PrintedListFilesInput | null > | null,
  printedProducts?: Array< PrintedProductInOrderInput | null > | null,
  creator?: string | null,
  created?: number | null,
  updated?: number | null,
};

export type DeletePrintedCartInput = {
  id: string,
};

export type CreatePrintedCategoryInput = {
  id?: string | null,
  name: string,
  image: FileInput,
  route: string,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  created: number,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
};

export type ModelPrintedCategoryConditionInput = {
  name?: ModelStringInput | null,
  route?: ModelStringInput | null,
  created?: ModelIntInput | null,
  visibleFor?: ModelStringInput | null,
  region?: ModelStringInput | null,
  and?: Array< ModelPrintedCategoryConditionInput | null > | null,
  or?: Array< ModelPrintedCategoryConditionInput | null > | null,
  not?: ModelPrintedCategoryConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PrintedCategory = {
  __typename: "PrintedCategory",
  id: string,
  name: string,
  image: File,
  route: string,
  clientDiscounts?:  Array<ClientDiscountPercents | null > | null,
  clientFeeIncrements?:  Array<ClientFeePercents | null > | null,
  clientIncrements?:  Array<ClientFeePercents | null > | null,
  printedSubcategories?: ModelPrintedSubcategoryConnection | null,
  printedProducts?: ModelPrintedProductsConnection | null,
  created: number,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelPrintedSubcategoryConnection = {
  __typename: "ModelPrintedSubcategoryConnection",
  items:  Array<PrintedSubcategory | null >,
  nextToken?: string | null,
};

export type PrintedSubcategory = {
  __typename: "PrintedSubcategory",
  id: string,
  name: string,
  printedCategoryId: string,
  clientDiscounts?:  Array<ClientDiscountPercents | null > | null,
  clientFeeIncrements?:  Array<ClientFeePercents | null > | null,
  clientIncrements?:  Array<ClientFeePercents | null > | null,
  parent: PrintedCategory,
  created: number,
  printedProducts?: ModelPrintedProductsConnection | null,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelPrintedProductsConnection = {
  __typename: "ModelPrintedProductsConnection",
  items:  Array<PrintedProducts | null >,
  nextToken?: string | null,
};

export type PrintedProducts = {
  __typename: "PrintedProducts",
  id: string,
  status: string,
  position: string,
  name: string,
  width: number,
  height: number,
  images:  Array<File >,
  price: number,
  long_description?: string | null,
  short_description?: string | null,
  creator?: string | null,
  providerId: string,
  finalDimensions?: number | null,
  pagesNumber?: number | null,
  finishes?: string | null,
  inksFourByCero?: string | null,
  inksFourByFour?: string | null,
  paperKind?: string | null,
  grammage?: string | null,
  hasBarniz?: boolean | null,
  hasRebase?: boolean | null,
  orientation?: string | null,
  specialInstructions?: string | null,
  PrintedSubcategoryId: string,
  printedCategoryId: string,
  created: number,
  variants?:  Array<Variants | null > | null,
  visibleFor?: Array< string | null > | null,
  filterColors?: Array< string | null > | null,
  regions?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePrintedCategoryInput = {
  id: string,
  name?: string | null,
  image?: FileInput | null,
  route?: string | null,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  created?: number | null,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
};

export type DeletePrintedCategoryInput = {
  id: string,
};

export type CreatePrintedSubcategoryInput = {
  id?: string | null,
  name: string,
  printedCategoryId: string,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  created: number,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
};

export type ModelPrintedSubcategoryConditionInput = {
  name?: ModelStringInput | null,
  printedCategoryId?: ModelIDInput | null,
  created?: ModelIntInput | null,
  visibleFor?: ModelStringInput | null,
  region?: ModelStringInput | null,
  and?: Array< ModelPrintedSubcategoryConditionInput | null > | null,
  or?: Array< ModelPrintedSubcategoryConditionInput | null > | null,
  not?: ModelPrintedSubcategoryConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdatePrintedSubcategoryInput = {
  id: string,
  name?: string | null,
  printedCategoryId?: string | null,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  created?: number | null,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
};

export type DeletePrintedSubcategoryInput = {
  id: string,
};

export type CreatePrintedProductsInput = {
  id?: string | null,
  status: string,
  position: string,
  name: string,
  width: number,
  height: number,
  images: Array< FileInput >,
  price: number,
  long_description?: string | null,
  short_description?: string | null,
  creator?: string | null,
  providerId: string,
  finalDimensions?: number | null,
  pagesNumber?: number | null,
  finishes?: string | null,
  inksFourByCero?: string | null,
  inksFourByFour?: string | null,
  paperKind?: string | null,
  grammage?: string | null,
  hasBarniz?: boolean | null,
  hasRebase?: boolean | null,
  orientation?: string | null,
  specialInstructions?: string | null,
  PrintedSubcategoryId: string,
  printedCategoryId: string,
  created: number,
  variants?: Array< VariantsInput | null > | null,
  visibleFor?: Array< string | null > | null,
  filterColors?: Array< string | null > | null,
  regions?: Array< string | null > | null,
};

export type ModelPrintedProductsConditionInput = {
  status?: ModelStringInput | null,
  position?: ModelStringInput | null,
  name?: ModelStringInput | null,
  width?: ModelFloatInput | null,
  height?: ModelFloatInput | null,
  price?: ModelFloatInput | null,
  long_description?: ModelStringInput | null,
  short_description?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  providerId?: ModelIDInput | null,
  finalDimensions?: ModelFloatInput | null,
  pagesNumber?: ModelIntInput | null,
  finishes?: ModelStringInput | null,
  inksFourByCero?: ModelStringInput | null,
  inksFourByFour?: ModelStringInput | null,
  paperKind?: ModelStringInput | null,
  grammage?: ModelStringInput | null,
  hasBarniz?: ModelBooleanInput | null,
  hasRebase?: ModelBooleanInput | null,
  orientation?: ModelStringInput | null,
  specialInstructions?: ModelStringInput | null,
  PrintedSubcategoryId?: ModelIDInput | null,
  printedCategoryId?: ModelIDInput | null,
  created?: ModelIntInput | null,
  visibleFor?: ModelStringInput | null,
  filterColors?: ModelStringInput | null,
  regions?: ModelStringInput | null,
  and?: Array< ModelPrintedProductsConditionInput | null > | null,
  or?: Array< ModelPrintedProductsConditionInput | null > | null,
  not?: ModelPrintedProductsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdatePrintedProductsInput = {
  id: string,
  status?: string | null,
  position?: string | null,
  name?: string | null,
  width?: number | null,
  height?: number | null,
  images?: Array< FileInput > | null,
  price?: number | null,
  long_description?: string | null,
  short_description?: string | null,
  creator?: string | null,
  providerId?: string | null,
  finalDimensions?: number | null,
  pagesNumber?: number | null,
  finishes?: string | null,
  inksFourByCero?: string | null,
  inksFourByFour?: string | null,
  paperKind?: string | null,
  grammage?: string | null,
  hasBarniz?: boolean | null,
  hasRebase?: boolean | null,
  orientation?: string | null,
  specialInstructions?: string | null,
  PrintedSubcategoryId?: string | null,
  printedCategoryId?: string | null,
  created?: number | null,
  variants?: Array< VariantsInput | null > | null,
  visibleFor?: Array< string | null > | null,
  filterColors?: Array< string | null > | null,
  regions?: Array< string | null > | null,
};

export type DeletePrintedProductsInput = {
  id: string,
};

export type CreatePrintedRfqInput = {
  id?: string | null,
  nombre: string,
  requerimiento: string,
  files?: Array< FileInput | null > | null,
  compras?: ContactInput | null,
  limit_time: number,
  creator?: string | null,
  creatorInfo?: OrderCreatorInput | null,
  clientId: string,
  winner?: WinnerInput | null,
  logs?: Array< LogsInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  estatus: string,
  printedOrderId?: number | null,
  start_time: number,
  delivery_time?: number | null,
  created: number,
  saving?: number | null,
  saving_percentage?: number | null,
  saving_real?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  updated?: number | null,
  providers?: Array< RfqPrintedProvidersInput | null > | null,
  printedProductsRfq: Array< PrintedProductUnitRfqInput | null >,
};

export type RfqPrintedProvidersInput = {
  idProvider?: string | null,
};

export type PrintedProductUnitRfqInput = {
  name: string,
  description: string,
  pieces: number,
  createdId: number,
};

export type ModelPrintedRfqConditionInput = {
  nombre?: ModelStringInput | null,
  requerimiento?: ModelStringInput | null,
  limit_time?: ModelIntInput | null,
  creator?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  estatus?: ModelStringInput | null,
  printedOrderId?: ModelIntInput | null,
  start_time?: ModelIntInput | null,
  delivery_time?: ModelIntInput | null,
  created?: ModelIntInput | null,
  saving?: ModelFloatInput | null,
  saving_percentage?: ModelFloatInput | null,
  saving_real?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelPrintedRfqConditionInput | null > | null,
  or?: Array< ModelPrintedRfqConditionInput | null > | null,
  not?: ModelPrintedRfqConditionInput | null,
};

export type PrintedRfq = {
  __typename: "PrintedRfq",
  id: string,
  nombre: string,
  requerimiento: string,
  files?:  Array<File | null > | null,
  compras?: Contact | null,
  limit_time: number,
  proposals?: ModelPrintedProposalConnection | null,
  creator?: string | null,
  creatorInfo?: OrderCreator | null,
  clientId: string,
  winner?: Winner | null,
  logs?:  Array<Logs | null > | null,
  chat?:  Array<RfqChat | null > | null,
  estatus: string,
  printedOrderId?: number | null,
  start_time: number,
  delivery_time?: number | null,
  created: number,
  saving?: number | null,
  saving_percentage?: number | null,
  saving_real?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  updated?: number | null,
  providers?:  Array<RfqPrintedProviders | null > | null,
  printedProductsRfq:  Array<PrintedProductUnitRfq | null >,
};

export type ModelPrintedProposalConnection = {
  __typename: "ModelPrintedProposalConnection",
  items:  Array<PrintedProposal | null >,
  nextToken?: string | null,
};

export type PrintedProposal = {
  __typename: "PrintedProposal",
  id: string,
  provider_id: string,
  delivery_time: Range,
  price: number,
  validity_days?: number | null,
  description?: string | null,
  comments?:  Array<Comment | null > | null,
  chat?:  Array<RfqChat | null > | null,
  created: number,
  updated?: number | null,
  files?:  Array<File | null > | null,
  products?:  Array<PrintedProductsProposals | null > | null,
  hidden?: boolean | null,
  rfq?: PrintedRfq | null,
  printedProposalRfqId?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type PrintedProductsProposals = {
  __typename: "PrintedProductsProposals",
  productUnitRfqIndex?: number | null,
  selected?: boolean | null,
  name: string,
  description: string,
  priceUnit: number,
  pieces: number,
  total: number,
  idProducto: number,
  files?:  Array<File | null > | null,
};

export type RfqPrintedProviders = {
  __typename: "RfqPrintedProviders",
  idProvider?: string | null,
};

export type PrintedProductUnitRfq = {
  __typename: "PrintedProductUnitRfq",
  name: string,
  description: string,
  pieces: number,
  createdId: number,
};

export type UpdatePrintedRfqInput = {
  id: string,
  nombre?: string | null,
  requerimiento?: string | null,
  files?: Array< FileInput | null > | null,
  compras?: ContactInput | null,
  limit_time?: number | null,
  creator?: string | null,
  creatorInfo?: OrderCreatorInput | null,
  clientId?: string | null,
  winner?: WinnerInput | null,
  logs?: Array< LogsInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  estatus?: string | null,
  printedOrderId?: number | null,
  start_time?: number | null,
  delivery_time?: number | null,
  created?: number | null,
  saving?: number | null,
  saving_percentage?: number | null,
  saving_real?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  updated?: number | null,
  providers?: Array< RfqPrintedProvidersInput | null > | null,
  printedProductsRfq?: Array< PrintedProductUnitRfqInput | null > | null,
};

export type DeletePrintedRfqInput = {
  id: string,
};

export type CreatePrintedProductoRfqInput = {
  id?: string | null,
  name: string,
  description: string,
  category_id: string,
  provider_id: string,
  price?: number | null,
  category?: string | null,
  images?: Array< FileInput | null > | null,
  estatus?: string | null,
  created: number,
  updated?: number | null,
};

export type ModelPrintedProductoRfqConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  category_id?: ModelIDInput | null,
  provider_id?: ModelIDInput | null,
  price?: ModelFloatInput | null,
  category?: ModelStringInput | null,
  estatus?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelPrintedProductoRfqConditionInput | null > | null,
  or?: Array< ModelPrintedProductoRfqConditionInput | null > | null,
  not?: ModelPrintedProductoRfqConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PrintedProductoRfq = {
  __typename: "PrintedProductoRfq",
  id: string,
  name: string,
  description: string,
  category_id: string,
  provider_id: string,
  price?: number | null,
  category?: string | null,
  images?:  Array<File | null > | null,
  estatus?: string | null,
  created: number,
  updated?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePrintedProductoRfqInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  category_id?: string | null,
  provider_id?: string | null,
  price?: number | null,
  category?: string | null,
  images?: Array< FileInput | null > | null,
  estatus?: string | null,
  created?: number | null,
  updated?: number | null,
};

export type DeletePrintedProductoRfqInput = {
  id: string,
};

export type CreatePrintedProposalInput = {
  id?: string | null,
  provider_id: string,
  delivery_time: RangeInput,
  price: number,
  validity_days?: number | null,
  description?: string | null,
  comments?: Array< CommentInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  created: number,
  updated?: number | null,
  files?: Array< FileInput | null > | null,
  products?: Array< PrintedProductsProposalsInput | null > | null,
  hidden?: boolean | null,
  printedProposalRfqId?: string | null,
};

export type PrintedProductsProposalsInput = {
  productUnitRfqIndex?: number | null,
  selected?: boolean | null,
  name: string,
  description: string,
  priceUnit: number,
  pieces: number,
  total: number,
  idProducto: number,
  files?: Array< FileInput | null > | null,
};

export type ModelPrintedProposalConditionInput = {
  provider_id?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  validity_days?: ModelIntInput | null,
  description?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  hidden?: ModelBooleanInput | null,
  printedProposalRfqId?: ModelIDInput | null,
  and?: Array< ModelPrintedProposalConditionInput | null > | null,
  or?: Array< ModelPrintedProposalConditionInput | null > | null,
  not?: ModelPrintedProposalConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdatePrintedProposalInput = {
  id: string,
  provider_id?: string | null,
  delivery_time?: RangeInput | null,
  price?: number | null,
  validity_days?: number | null,
  description?: string | null,
  comments?: Array< CommentInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  created?: number | null,
  updated?: number | null,
  files?: Array< FileInput | null > | null,
  products?: Array< PrintedProductsProposalsInput | null > | null,
  hidden?: boolean | null,
  printedProposalRfqId?: string | null,
};

export type DeletePrintedProposalInput = {
  id: string,
};

export type CreatePrintedOrderInput = {
  id?: string | null,
  orderId: number,
  comments?: Array< CommentInput | null > | null,
  delivery_addresses?: Array< AddressInput | null > | null,
  delivery_cost?: number | null,
  delivery_time?: number | null,
  files?: Array< ListFilesInput | null > | null,
  listProviders?: Array< ListProvidersOrderInput | null > | null,
  listProvidersKey?: Array< string | null > | null,
  orderAgents?: Array< OrderAgentInput | null > | null,
  orderAgentIds?: Array< string | null > | null,
  listPrintedProducts: Array< PrintedProductInOrderInput >,
  cotizationsList: Array< PrintedOrderCotizationsLogInput | null >,
  orderCreatorId: string,
  creator: OrderCreatorInput,
  buyerInfo?: OrderBuyerInput | null,
  buyersInfo?: Array< OrderBuyerInput | null > | null,
  contact?: OrderContactInput | null,
  printedOrderClientId?: string | null,
  subtotal?: number | null,
  total?: number | null,
  isCoupa?: boolean | null,
  sentToCoupa?: boolean | null,
  isRfq?: boolean | null,
  status?: string | null,
  currentProcess?: string | null,
  currentSubprocess?: string | null,
  updatedAt?: string | null,
  created: number,
  updated?: number | null,
};

export type PrintedOrderCotizationsLogInput = {
  id: number,
  created: number,
  createdBy: string,
  products: Array< PrintedProductInOrderInput >,
};

export type ModelPrintedOrderConditionInput = {
  orderId?: ModelIntInput | null,
  delivery_cost?: ModelFloatInput | null,
  delivery_time?: ModelIntInput | null,
  listProvidersKey?: ModelStringInput | null,
  orderAgentIds?: ModelStringInput | null,
  orderCreatorId?: ModelStringInput | null,
  printedOrderClientId?: ModelIDInput | null,
  subtotal?: ModelFloatInput | null,
  total?: ModelFloatInput | null,
  isCoupa?: ModelBooleanInput | null,
  sentToCoupa?: ModelBooleanInput | null,
  isRfq?: ModelBooleanInput | null,
  status?: ModelStringInput | null,
  currentProcess?: ModelStringInput | null,
  currentSubprocess?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelPrintedOrderConditionInput | null > | null,
  or?: Array< ModelPrintedOrderConditionInput | null > | null,
  not?: ModelPrintedOrderConditionInput | null,
  createdAt?: ModelStringInput | null,
};

export type PrintedOrder = {
  __typename: "PrintedOrder",
  id: string,
  orderId: number,
  comments?:  Array<Comment | null > | null,
  delivery_addresses?:  Array<Address | null > | null,
  delivery_cost?: number | null,
  delivery_time?: number | null,
  files?:  Array<ListFiles | null > | null,
  listProviders?:  Array<ListProvidersOrder | null > | null,
  listProvidersKey?: Array< string | null > | null,
  orderAgents?:  Array<OrderAgent | null > | null,
  orderAgentIds?: Array< string | null > | null,
  listPrintedProducts:  Array<PrintedProductInOrder >,
  cotizationsList:  Array<PrintedOrderCotizationsLog | null >,
  orderCreatorId: string,
  creator: OrderCreator,
  buyerInfo?: OrderBuyer | null,
  buyersInfo?:  Array<OrderBuyer | null > | null,
  contact?: OrderContact | null,
  printedOrderClientId?: string | null,
  subtotal?: number | null,
  total?: number | null,
  isCoupa?: boolean | null,
  sentToCoupa?: boolean | null,
  isRfq?: boolean | null,
  status?: string | null,
  currentProcess?: string | null,
  currentSubprocess?: string | null,
  updatedAt?: string | null,
  created: number,
  updated?: number | null,
  createdAt: string,
};

export type PrintedOrderCotizationsLog = {
  __typename: "PrintedOrderCotizationsLog",
  id: number,
  created: number,
  createdBy: string,
  products:  Array<PrintedProductInOrder >,
};

export type UpdatePrintedOrderInput = {
  id: string,
  orderId?: number | null,
  comments?: Array< CommentInput | null > | null,
  delivery_addresses?: Array< AddressInput | null > | null,
  delivery_cost?: number | null,
  delivery_time?: number | null,
  files?: Array< ListFilesInput | null > | null,
  listProviders?: Array< ListProvidersOrderInput | null > | null,
  listProvidersKey?: Array< string | null > | null,
  orderAgents?: Array< OrderAgentInput | null > | null,
  orderAgentIds?: Array< string | null > | null,
  listPrintedProducts?: Array< PrintedProductInOrderInput > | null,
  cotizationsList?: Array< PrintedOrderCotizationsLogInput | null > | null,
  orderCreatorId?: string | null,
  creator?: OrderCreatorInput | null,
  buyerInfo?: OrderBuyerInput | null,
  buyersInfo?: Array< OrderBuyerInput | null > | null,
  contact?: OrderContactInput | null,
  printedOrderClientId?: string | null,
  subtotal?: number | null,
  total?: number | null,
  isCoupa?: boolean | null,
  sentToCoupa?: boolean | null,
  isRfq?: boolean | null,
  status?: string | null,
  currentProcess?: string | null,
  currentSubprocess?: string | null,
  updatedAt?: string | null,
  created?: number | null,
  updated?: number | null,
};

export type DeletePrintedOrderInput = {
  id: string,
};

export type CreatePrintedOrderProvidersInput = {
  id?: string | null,
  provider_id: string,
  orderId?: number | null,
  printedOrderProvidersPrintedOrderId: string,
  payment_date?: number | null,
  gr_code?: string | null,
  invoice?: boolean | null,
  invoiceRequested?: boolean | null,
  uploadedGr?: boolean | null,
  uploadedBill?: boolean | null,
};

export type ModelPrintedOrderProvidersConditionInput = {
  provider_id?: ModelStringInput | null,
  orderId?: ModelIntInput | null,
  printedOrderProvidersPrintedOrderId?: ModelIDInput | null,
  payment_date?: ModelIntInput | null,
  gr_code?: ModelStringInput | null,
  invoice?: ModelBooleanInput | null,
  invoiceRequested?: ModelBooleanInput | null,
  uploadedGr?: ModelBooleanInput | null,
  uploadedBill?: ModelBooleanInput | null,
  and?: Array< ModelPrintedOrderProvidersConditionInput | null > | null,
  or?: Array< ModelPrintedOrderProvidersConditionInput | null > | null,
  not?: ModelPrintedOrderProvidersConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PrintedOrderProviders = {
  __typename: "PrintedOrderProviders",
  id: string,
  provider_id: string,
  orderId?: number | null,
  printedOrderProvidersPrintedOrderId: string,
  payment_date?: number | null,
  gr_code?: string | null,
  invoice?: boolean | null,
  invoiceRequested?: boolean | null,
  uploadedGr?: boolean | null,
  uploadedBill?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePrintedOrderProvidersInput = {
  id: string,
  provider_id?: string | null,
  orderId?: number | null,
  printedOrderProvidersPrintedOrderId?: string | null,
  payment_date?: number | null,
  gr_code?: string | null,
  invoice?: boolean | null,
  invoiceRequested?: boolean | null,
  uploadedGr?: boolean | null,
  uploadedBill?: boolean | null,
};

export type DeletePrintedOrderProvidersInput = {
  id: string,
};

export type CreatePayOnBehalfRequestsInput = {
  id?: string | null,
  clientId?: string | null,
  companyName?: string | null,
  purchaseOrder?: string | null,
  paymentTerms?: string | null,
  currency?: string | null,
  amount?: number | null,
  selectedVa?: boolean | null,
  iva?: number | null,
  vat?: number | null,
  total?: number | null,
  rfc?: FileInput | null,
  bankStatement?: FileInput | null,
  supplierQuote?: FileInput | null,
  created: number,
};

export type ModelPayOnBehalfRequestsConditionInput = {
  clientId?: ModelStringInput | null,
  companyName?: ModelStringInput | null,
  purchaseOrder?: ModelStringInput | null,
  paymentTerms?: ModelStringInput | null,
  currency?: ModelStringInput | null,
  amount?: ModelFloatInput | null,
  selectedVa?: ModelBooleanInput | null,
  iva?: ModelFloatInput | null,
  vat?: ModelFloatInput | null,
  total?: ModelFloatInput | null,
  created?: ModelIntInput | null,
  and?: Array< ModelPayOnBehalfRequestsConditionInput | null > | null,
  or?: Array< ModelPayOnBehalfRequestsConditionInput | null > | null,
  not?: ModelPayOnBehalfRequestsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PayOnBehalfRequests = {
  __typename: "PayOnBehalfRequests",
  id: string,
  clientId?: string | null,
  companyName?: string | null,
  purchaseOrder?: string | null,
  paymentTerms?: string | null,
  currency?: string | null,
  amount?: number | null,
  selectedVa?: boolean | null,
  iva?: number | null,
  vat?: number | null,
  total?: number | null,
  rfc?: File | null,
  bankStatement?: File | null,
  supplierQuote?: File | null,
  created: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePayOnBehalfRequestsInput = {
  id: string,
  clientId?: string | null,
  companyName?: string | null,
  purchaseOrder?: string | null,
  paymentTerms?: string | null,
  currency?: string | null,
  amount?: number | null,
  selectedVa?: boolean | null,
  iva?: number | null,
  vat?: number | null,
  total?: number | null,
  rfc?: FileInput | null,
  bankStatement?: FileInput | null,
  supplierQuote?: FileInput | null,
  created?: number | null,
};

export type DeletePayOnBehalfRequestsInput = {
  id: string,
};

export type CreateBuyerContactClientInput = {
  id?: string | null,
  companyId: string,
  status?: boolean | null,
  defaultContact?: boolean | null,
  name?: string | null,
  email?: string | null,
  createdAt?: string | null,
};

export type ModelBuyerContactClientConditionInput = {
  companyId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  defaultContact?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelBuyerContactClientConditionInput | null > | null,
  or?: Array< ModelBuyerContactClientConditionInput | null > | null,
  not?: ModelBuyerContactClientConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type BuyerContactClient = {
  __typename: "BuyerContactClient",
  id: string,
  companyId: string,
  status?: boolean | null,
  defaultContact?: boolean | null,
  name?: string | null,
  email?: string | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateBuyerContactClientInput = {
  id: string,
  companyId?: string | null,
  status?: boolean | null,
  defaultContact?: boolean | null,
  name?: string | null,
  email?: string | null,
  createdAt?: string | null,
};

export type DeleteBuyerContactClientInput = {
  id: string,
};

export type CreateBrandFactoryRfqEmailsInput = {
  id?: string | null,
  status: boolean,
  name: string,
  email: string,
  created: number,
};

export type ModelBrandFactoryRfqEmailsConditionInput = {
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  created?: ModelIntInput | null,
  and?: Array< ModelBrandFactoryRfqEmailsConditionInput | null > | null,
  or?: Array< ModelBrandFactoryRfqEmailsConditionInput | null > | null,
  not?: ModelBrandFactoryRfqEmailsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type BrandFactoryRfqEmails = {
  __typename: "BrandFactoryRfqEmails",
  id: string,
  status: boolean,
  name: string,
  email: string,
  created: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateBrandFactoryRfqEmailsInput = {
  id: string,
  status?: boolean | null,
  name?: string | null,
  email?: string | null,
  created?: number | null,
};

export type DeleteBrandFactoryRfqEmailsInput = {
  id: string,
};

export type CreateAutomobilesEmailsInput = {
  id?: string | null,
  companyId: string,
  status: boolean,
  name: string,
  email: string,
  created: number,
};

export type ModelAutomobilesEmailsConditionInput = {
  companyId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  created?: ModelIntInput | null,
  and?: Array< ModelAutomobilesEmailsConditionInput | null > | null,
  or?: Array< ModelAutomobilesEmailsConditionInput | null > | null,
  not?: ModelAutomobilesEmailsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type AutomobilesEmails = {
  __typename: "AutomobilesEmails",
  id: string,
  companyId: string,
  status: boolean,
  name: string,
  email: string,
  created: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateAutomobilesEmailsInput = {
  id: string,
  companyId?: string | null,
  status?: boolean | null,
  name?: string | null,
  email?: string | null,
  created?: number | null,
};

export type DeleteAutomobilesEmailsInput = {
  id: string,
};

export type CreateQAEmailsInput = {
  id?: string | null,
  companyId: string,
  status: boolean,
  name: string,
  email: string,
  created: number,
};

export type ModelQAEmailsConditionInput = {
  companyId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  created?: ModelIntInput | null,
  and?: Array< ModelQAEmailsConditionInput | null > | null,
  or?: Array< ModelQAEmailsConditionInput | null > | null,
  not?: ModelQAEmailsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type QAEmails = {
  __typename: "QAEmails",
  id: string,
  companyId: string,
  status: boolean,
  name: string,
  email: string,
  created: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateQAEmailsInput = {
  id: string,
  companyId?: string | null,
  status?: boolean | null,
  name?: string | null,
  email?: string | null,
  created?: number | null,
};

export type DeleteQAEmailsInput = {
  id: string,
};

export type CreateOrderPopAdminEmailsInput = {
  id?: string | null,
  companyId: string,
  status: boolean,
  name: string,
  email: string,
  created: number,
};

export type ModelOrderPopAdminEmailsConditionInput = {
  companyId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  created?: ModelIntInput | null,
  and?: Array< ModelOrderPopAdminEmailsConditionInput | null > | null,
  or?: Array< ModelOrderPopAdminEmailsConditionInput | null > | null,
  not?: ModelOrderPopAdminEmailsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type OrderPopAdminEmails = {
  __typename: "OrderPopAdminEmails",
  id: string,
  companyId: string,
  status: boolean,
  name: string,
  email: string,
  created: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateOrderPopAdminEmailsInput = {
  id: string,
  companyId?: string | null,
  status?: boolean | null,
  name?: string | null,
  email?: string | null,
  created?: number | null,
};

export type DeleteOrderPopAdminEmailsInput = {
  id: string,
};

export type CreateOrderPopCheckoutEmailsInput = {
  id?: string | null,
  companyId: string,
  status: boolean,
  name: string,
  email: string,
  created: number,
};

export type ModelOrderPopCheckoutEmailsConditionInput = {
  companyId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  created?: ModelIntInput | null,
  and?: Array< ModelOrderPopCheckoutEmailsConditionInput | null > | null,
  or?: Array< ModelOrderPopCheckoutEmailsConditionInput | null > | null,
  not?: ModelOrderPopCheckoutEmailsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type OrderPopCheckoutEmails = {
  __typename: "OrderPopCheckoutEmails",
  id: string,
  companyId: string,
  status: boolean,
  name: string,
  email: string,
  created: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateOrderPopCheckoutEmailsInput = {
  id: string,
  companyId?: string | null,
  status?: boolean | null,
  name?: string | null,
  email?: string | null,
  created?: number | null,
};

export type DeleteOrderPopCheckoutEmailsInput = {
  id: string,
};

export type CreateGREmailsInput = {
  id?: string | null,
  companyId: string,
  status: boolean,
  name: string,
  email: string,
  created: number,
};

export type ModelGREmailsConditionInput = {
  companyId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  created?: ModelIntInput | null,
  and?: Array< ModelGREmailsConditionInput | null > | null,
  or?: Array< ModelGREmailsConditionInput | null > | null,
  not?: ModelGREmailsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type GREmails = {
  __typename: "GREmails",
  id: string,
  companyId: string,
  status: boolean,
  name: string,
  email: string,
  created: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateGREmailsInput = {
  id: string,
  companyId?: string | null,
  status?: boolean | null,
  name?: string | null,
  email?: string | null,
  created?: number | null,
};

export type DeleteGREmailsInput = {
  id: string,
};

export type CreateRegionsInput = {
  id?: string | null,
  status: boolean,
  name: string,
};

export type ModelRegionsConditionInput = {
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  and?: Array< ModelRegionsConditionInput | null > | null,
  or?: Array< ModelRegionsConditionInput | null > | null,
  not?: ModelRegionsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Regions = {
  __typename: "Regions",
  id: string,
  status: boolean,
  name: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateRegionsInput = {
  id: string,
  status?: boolean | null,
  name?: string | null,
};

export type DeleteRegionsInput = {
  id: string,
};

export type CreateDefaultAddressInput = {
  id?: string | null,
  companyId: string,
  userId?: string | null,
  status: boolean,
  address: AddressInput,
  createdAt?: string | null,
};

export type ModelDefaultAddressConditionInput = {
  companyId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelDefaultAddressConditionInput | null > | null,
  or?: Array< ModelDefaultAddressConditionInput | null > | null,
  not?: ModelDefaultAddressConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type DefaultAddress = {
  __typename: "DefaultAddress",
  id: string,
  companyId: string,
  userId?: string | null,
  status: boolean,
  address: Address,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateDefaultAddressInput = {
  id: string,
  companyId?: string | null,
  userId?: string | null,
  status?: boolean | null,
  address?: AddressInput | null,
  createdAt?: string | null,
};

export type DeleteDefaultAddressInput = {
  id: string,
};

export type CreateDefaultDeliveryContactInput = {
  id?: string | null,
  companyId?: string | null,
  userId?: string | null,
  status?: boolean | null,
  name?: string | null,
  phoneNumber?: string | null,
  createdAt?: string | null,
};

export type ModelDefaultDeliveryContactConditionInput = {
  companyId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelDefaultDeliveryContactConditionInput | null > | null,
  or?: Array< ModelDefaultDeliveryContactConditionInput | null > | null,
  not?: ModelDefaultDeliveryContactConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type DefaultDeliveryContact = {
  __typename: "DefaultDeliveryContact",
  id: string,
  companyId?: string | null,
  userId?: string | null,
  status?: boolean | null,
  name?: string | null,
  phoneNumber?: string | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateDefaultDeliveryContactInput = {
  id: string,
  companyId?: string | null,
  userId?: string | null,
  status?: boolean | null,
  name?: string | null,
  phoneNumber?: string | null,
  createdAt?: string | null,
};

export type DeleteDefaultDeliveryContactInput = {
  id: string,
};

export type CreatePopCategoriesInput = {
  id?: string | null,
  materialId: string,
  name: string,
  visibleFor?: Array< string | null > | null,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  created: number,
};

export type ModelPopCategoriesConditionInput = {
  materialId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  created?: ModelIntInput | null,
  and?: Array< ModelPopCategoriesConditionInput | null > | null,
  or?: Array< ModelPopCategoriesConditionInput | null > | null,
  not?: ModelPopCategoriesConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PopCategories = {
  __typename: "PopCategories",
  id: string,
  materialId: string,
  name: string,
  visibleFor?: Array< string | null > | null,
  clientDiscounts?:  Array<ClientDiscountPercents | null > | null,
  clientFeeIncrements?:  Array<ClientFeePercents | null > | null,
  clientIncrements?:  Array<ClientFeePercents | null > | null,
  created: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePopCategoriesInput = {
  id: string,
  materialId?: string | null,
  name?: string | null,
  visibleFor?: Array< string | null > | null,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  created?: number | null,
};

export type DeletePopCategoriesInput = {
  id: string,
};

export type CreateRfpInput = {
  id?: string | null,
  clientId?: string | null,
  status?: string | null,
  name?: string | null,
  nombre?: string | null,
  requerimiento?: string | null,
  estatus?: string | null,
  descripcion?: string | null,
  files?: Array< FileInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  url?: string | null,
  creatorInfo?: OrderCreatorInput | null,
  compras?: ContactInput | null,
  limit_time: number,
  creator?: string | null,
  winner?: WinnerInput | null,
  logs?: Array< LogsInput | null > | null,
  providers?: Array< RfpProvidersInput | null > | null,
  start_time: number,
  delivery_time?: number | null,
  saving?: number | null,
  saving_percentage?: number | null,
  saving_real?: number | null,
  created: number,
  createdAt?: string | null,
  updated?: number | null,
};

export type RfpProvidersInput = {
  idProvider?: string | null,
};

export type ModelRfpConditionInput = {
  clientId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  nombre?: ModelStringInput | null,
  requerimiento?: ModelStringInput | null,
  estatus?: ModelStringInput | null,
  descripcion?: ModelStringInput | null,
  url?: ModelStringInput | null,
  limit_time?: ModelIntInput | null,
  creator?: ModelStringInput | null,
  start_time?: ModelIntInput | null,
  delivery_time?: ModelIntInput | null,
  saving?: ModelFloatInput | null,
  saving_percentage?: ModelFloatInput | null,
  saving_real?: ModelFloatInput | null,
  created?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelRfpConditionInput | null > | null,
  or?: Array< ModelRfpConditionInput | null > | null,
  not?: ModelRfpConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Rfp = {
  __typename: "Rfp",
  id: string,
  clientId?: string | null,
  status?: string | null,
  name?: string | null,
  nombre?: string | null,
  requerimiento?: string | null,
  estatus?: string | null,
  descripcion?: string | null,
  files?:  Array<File | null > | null,
  chat?:  Array<RfqChat | null > | null,
  url?: string | null,
  creatorInfo?: OrderCreator | null,
  proposals?: ModelRfpProposalsConnection | null,
  compras?: Contact | null,
  limit_time: number,
  creator?: string | null,
  winner?: Winner | null,
  logs?:  Array<Logs | null > | null,
  providers?:  Array<RfpProviders | null > | null,
  start_time: number,
  delivery_time?: number | null,
  saving?: number | null,
  saving_percentage?: number | null,
  saving_real?: number | null,
  created: number,
  createdAt?: string | null,
  updated?: number | null,
  updatedAt: string,
};

export type ModelRfpProposalsConnection = {
  __typename: "ModelRfpProposalsConnection",
  items:  Array<RfpProposals | null >,
  nextToken?: string | null,
};

export type RfpProposals = {
  __typename: "RfpProposals",
  id: string,
  provider_id: string,
  delivery_time: Range,
  price: number,
  name?: string | null,
  description?: string | null,
  validity_days?: number | null,
  comments?:  Array<Comment | null > | null,
  chat?:  Array<RfqChat | null > | null,
  created: number,
  updated?: number | null,
  files?:  Array<File | null > | null,
  products?:  Array<ProductsProposals | null > | null,
  multipleProducts?: boolean | null,
  hidden?: boolean | null,
  rfp?: Rfp | null,
  rfpProposalsRfpId?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type RfpProviders = {
  __typename: "RfpProviders",
  idProvider?: string | null,
};

export type UpdateRfpInput = {
  id: string,
  clientId?: string | null,
  status?: string | null,
  name?: string | null,
  nombre?: string | null,
  requerimiento?: string | null,
  estatus?: string | null,
  descripcion?: string | null,
  files?: Array< FileInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  url?: string | null,
  creatorInfo?: OrderCreatorInput | null,
  compras?: ContactInput | null,
  limit_time?: number | null,
  creator?: string | null,
  winner?: WinnerInput | null,
  logs?: Array< LogsInput | null > | null,
  providers?: Array< RfpProvidersInput | null > | null,
  start_time?: number | null,
  delivery_time?: number | null,
  saving?: number | null,
  saving_percentage?: number | null,
  saving_real?: number | null,
  created?: number | null,
  createdAt?: string | null,
  updated?: number | null,
};

export type DeleteRfpInput = {
  id: string,
};

export type CreateRfpProposalsInput = {
  id?: string | null,
  provider_id: string,
  delivery_time: RangeInput,
  price: number,
  name?: string | null,
  description?: string | null,
  validity_days?: number | null,
  comments?: Array< CommentInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  created: number,
  updated?: number | null,
  files?: Array< FileInput | null > | null,
  products?: Array< ProductsProposalsInput | null > | null,
  multipleProducts?: boolean | null,
  hidden?: boolean | null,
  rfpProposalsRfpId?: string | null,
};

export type ModelRfpProposalsConditionInput = {
  provider_id?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  validity_days?: ModelIntInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  multipleProducts?: ModelBooleanInput | null,
  hidden?: ModelBooleanInput | null,
  rfpProposalsRfpId?: ModelIDInput | null,
  and?: Array< ModelRfpProposalsConditionInput | null > | null,
  or?: Array< ModelRfpProposalsConditionInput | null > | null,
  not?: ModelRfpProposalsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateRfpProposalsInput = {
  id: string,
  provider_id?: string | null,
  delivery_time?: RangeInput | null,
  price?: number | null,
  name?: string | null,
  description?: string | null,
  validity_days?: number | null,
  comments?: Array< CommentInput | null > | null,
  chat?: Array< RfqChatInput | null > | null,
  created?: number | null,
  updated?: number | null,
  files?: Array< FileInput | null > | null,
  products?: Array< ProductsProposalsInput | null > | null,
  multipleProducts?: boolean | null,
  hidden?: boolean | null,
  rfpProposalsRfpId?: string | null,
};

export type DeleteRfpProposalsInput = {
  id: string,
};

export type CreateEvaluationProvidersInput = {
  id?: string | null,
  providerId?: string | null,
  creratorId?: string | null,
  orderId?: string | null,
  time?: number | null,
  price?: number | null,
  quality?: number | null,
  att?: number | null,
  comments?: string | null,
};

export type ModelEvaluationProvidersConditionInput = {
  providerId?: ModelIDInput | null,
  creratorId?: ModelIDInput | null,
  orderId?: ModelIDInput | null,
  time?: ModelFloatInput | null,
  price?: ModelFloatInput | null,
  quality?: ModelFloatInput | null,
  att?: ModelFloatInput | null,
  comments?: ModelStringInput | null,
  and?: Array< ModelEvaluationProvidersConditionInput | null > | null,
  or?: Array< ModelEvaluationProvidersConditionInput | null > | null,
  not?: ModelEvaluationProvidersConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type EvaluationProviders = {
  __typename: "EvaluationProviders",
  id: string,
  providerId?: string | null,
  creratorId?: string | null,
  orderId?: string | null,
  time?: number | null,
  price?: number | null,
  quality?: number | null,
  att?: number | null,
  comments?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateEvaluationProvidersInput = {
  id: string,
  providerId?: string | null,
  creratorId?: string | null,
  orderId?: string | null,
  time?: number | null,
  price?: number | null,
  quality?: number | null,
  att?: number | null,
  comments?: string | null,
};

export type DeleteEvaluationProvidersInput = {
  id: string,
};

export type CreateLogProductInput = {
  id?: string | null,
  status?: string | null,
  creator?: string | null,
  created?: string | null,
  productId?: string | null,
  description?: string | null,
};

export type ModelLogProductConditionInput = {
  status?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  created?: ModelStringInput | null,
  productId?: ModelIDInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelLogProductConditionInput | null > | null,
  or?: Array< ModelLogProductConditionInput | null > | null,
  not?: ModelLogProductConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LogProduct = {
  __typename: "LogProduct",
  id: string,
  status?: string | null,
  creator?: string | null,
  created?: string | null,
  productId?: string | null,
  description?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLogProductInput = {
  id: string,
  status?: string | null,
  creator?: string | null,
  created?: string | null,
  productId?: string | null,
  description?: string | null,
};

export type DeleteLogProductInput = {
  id: string,
};

export type CreateLogRfqInput = {
  id?: string | null,
  status?: string | null,
  creator?: string | null,
  rfqId: string,
  description?: string | null,
  provider_id?: string | null,
  createdAt?: string | null,
};

export type ModelLogRfqConditionInput = {
  status?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  rfqId?: ModelIDInput | null,
  description?: ModelStringInput | null,
  provider_id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelLogRfqConditionInput | null > | null,
  or?: Array< ModelLogRfqConditionInput | null > | null,
  not?: ModelLogRfqConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LogRfq = {
  __typename: "LogRfq",
  id: string,
  status?: string | null,
  creator?: string | null,
  rfqId: string,
  description?: string | null,
  provider_id?: string | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateLogRfqInput = {
  id: string,
  status?: string | null,
  creator?: string | null,
  rfqId?: string | null,
  description?: string | null,
  provider_id?: string | null,
  createdAt?: string | null,
};

export type DeleteLogRfqInput = {
  id: string,
};

export type CreateLogProductLabelInput = {
  id?: string | null,
  status?: string | null,
  creator?: string | null,
  created?: string | null,
  productLabelId?: string | null,
  description?: string | null,
};

export type ModelLogProductLabelConditionInput = {
  status?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  created?: ModelStringInput | null,
  productLabelId?: ModelIDInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelLogProductLabelConditionInput | null > | null,
  or?: Array< ModelLogProductLabelConditionInput | null > | null,
  not?: ModelLogProductLabelConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LogProductLabel = {
  __typename: "LogProductLabel",
  id: string,
  status?: string | null,
  creator?: string | null,
  created?: string | null,
  productLabelId?: string | null,
  description?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLogProductLabelInput = {
  id: string,
  status?: string | null,
  creator?: string | null,
  created?: string | null,
  productLabelId?: string | null,
  description?: string | null,
};

export type DeleteLogProductLabelInput = {
  id: string,
};

export type CreateLogGanadorAutoInput = {
  id?: string | null,
  id_auto?: string | null,
  id_user?: string | null,
  fecha_rifa?: number | null,
  email?: string | null,
  nombre?: string | null,
  a_paterno?: string | null,
  a_materno?: string | null,
  status_buyer?: boolean | null,
  date_buyer?: number | null,
  winner?: number | null,
  refused?: number | null,
  since?: string | null,
  process_buyer?: boolean | null,
  reactive?: boolean | null,
  created: number,
  updated?: number | null,
};

export type ModelLogGanadorAutoConditionInput = {
  id_auto?: ModelIDInput | null,
  id_user?: ModelIDInput | null,
  fecha_rifa?: ModelIntInput | null,
  email?: ModelStringInput | null,
  nombre?: ModelStringInput | null,
  a_paterno?: ModelStringInput | null,
  a_materno?: ModelStringInput | null,
  status_buyer?: ModelBooleanInput | null,
  date_buyer?: ModelIntInput | null,
  winner?: ModelIntInput | null,
  refused?: ModelIntInput | null,
  since?: ModelStringInput | null,
  process_buyer?: ModelBooleanInput | null,
  reactive?: ModelBooleanInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelLogGanadorAutoConditionInput | null > | null,
  or?: Array< ModelLogGanadorAutoConditionInput | null > | null,
  not?: ModelLogGanadorAutoConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateLogGanadorAutoInput = {
  id: string,
  id_auto?: string | null,
  id_user?: string | null,
  fecha_rifa?: number | null,
  email?: string | null,
  nombre?: string | null,
  a_paterno?: string | null,
  a_materno?: string | null,
  status_buyer?: boolean | null,
  date_buyer?: number | null,
  winner?: number | null,
  refused?: number | null,
  since?: string | null,
  process_buyer?: boolean | null,
  reactive?: boolean | null,
  created?: number | null,
  updated?: number | null,
};

export type DeleteLogGanadorAutoInput = {
  id: string,
};

export type CreateNotificationInput = {
  id?: string | null,
  type: string,
  remember?: string | null,
  stared?: string | null,
  important?: string | null,
  status?: string | null,
  isChat?: string | null,
  creatorName: string,
  creatorEmail: string,
  creatorRole?: string | null,
  creatorId: string,
  receipentName: string,
  receipentRole?: string | null,
  receipentEmail?: string | null,
  receipentId: string,
  showPopUp?: boolean | null,
  sendEmail?: boolean | null,
  title: string,
  subtitle: string,
  description: string,
  files?: Array< FileInput | null > | null,
  path?: string | null,
  idParent?: string | null,
  createdAt?: string | null,
  seenAt?: number | null,
};

export type ModelNotificationConditionInput = {
  type?: ModelStringInput | null,
  remember?: ModelStringInput | null,
  stared?: ModelStringInput | null,
  important?: ModelStringInput | null,
  status?: ModelStringInput | null,
  isChat?: ModelStringInput | null,
  creatorName?: ModelStringInput | null,
  creatorEmail?: ModelStringInput | null,
  creatorRole?: ModelStringInput | null,
  creatorId?: ModelIDInput | null,
  receipentName?: ModelStringInput | null,
  receipentRole?: ModelStringInput | null,
  receipentEmail?: ModelStringInput | null,
  receipentId?: ModelIDInput | null,
  showPopUp?: ModelBooleanInput | null,
  sendEmail?: ModelBooleanInput | null,
  title?: ModelStringInput | null,
  subtitle?: ModelStringInput | null,
  description?: ModelStringInput | null,
  path?: ModelStringInput | null,
  idParent?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  seenAt?: ModelIntInput | null,
  and?: Array< ModelNotificationConditionInput | null > | null,
  or?: Array< ModelNotificationConditionInput | null > | null,
  not?: ModelNotificationConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Notification = {
  __typename: "Notification",
  id: string,
  type: string,
  remember?: string | null,
  stared?: string | null,
  important?: string | null,
  status?: string | null,
  isChat?: string | null,
  creatorName: string,
  creatorEmail: string,
  creatorRole?: string | null,
  creatorId: string,
  receipentName: string,
  receipentRole?: string | null,
  receipentEmail?: string | null,
  receipentId: string,
  showPopUp?: boolean | null,
  sendEmail?: boolean | null,
  title: string,
  subtitle: string,
  description: string,
  files?:  Array<File | null > | null,
  path?: string | null,
  idParent?: string | null,
  createdAt?: string | null,
  seenAt?: number | null,
  updatedAt: string,
};

export type UpdateNotificationInput = {
  id: string,
  type?: string | null,
  remember?: string | null,
  stared?: string | null,
  important?: string | null,
  status?: string | null,
  isChat?: string | null,
  creatorName?: string | null,
  creatorEmail?: string | null,
  creatorRole?: string | null,
  creatorId?: string | null,
  receipentName?: string | null,
  receipentRole?: string | null,
  receipentEmail?: string | null,
  receipentId?: string | null,
  showPopUp?: boolean | null,
  sendEmail?: boolean | null,
  title?: string | null,
  subtitle?: string | null,
  description?: string | null,
  files?: Array< FileInput | null > | null,
  path?: string | null,
  idParent?: string | null,
  createdAt?: string | null,
  seenAt?: number | null,
};

export type DeleteNotificationInput = {
  id: string,
};

export type CreateMercadoCategoriesInput = {
  id?: string | null,
  idMercado?: string | null,
  status?: string | null,
  name?: string | null,
  rulesClients?: Array< MercadoCategoryClientRuleInput | null > | null,
  image?: FileInput | null,
  parentCategory?: string | null,
  childrenCategories?: Array< string | null > | null,
  items?: Array< string | null > | null,
};

export type MercadoCategoryClientRuleInput = {
  clientID?: string | null,
  enabled?: boolean | null,
  isUnrestricted?: boolean | null,
  isRestricted?: boolean | null,
  increment?: number | null,
  fee?: number | null,
};

export type ModelMercadoCategoriesConditionInput = {
  idMercado?: ModelStringInput | null,
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  parentCategory?: ModelStringInput | null,
  childrenCategories?: ModelStringInput | null,
  items?: ModelStringInput | null,
  and?: Array< ModelMercadoCategoriesConditionInput | null > | null,
  or?: Array< ModelMercadoCategoriesConditionInput | null > | null,
  not?: ModelMercadoCategoriesConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type MercadoCategories = {
  __typename: "MercadoCategories",
  id: string,
  idMercado?: string | null,
  status?: string | null,
  name?: string | null,
  rulesClients?:  Array<MercadoCategoryClientRule | null > | null,
  image?: File | null,
  parentCategory?: string | null,
  childrenCategories?: Array< string | null > | null,
  items?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type MercadoCategoryClientRule = {
  __typename: "MercadoCategoryClientRule",
  clientID?: string | null,
  enabled?: boolean | null,
  isUnrestricted?: boolean | null,
  isRestricted?: boolean | null,
  increment?: number | null,
  fee?: number | null,
};

export type UpdateMercadoCategoriesInput = {
  id: string,
  idMercado?: string | null,
  status?: string | null,
  name?: string | null,
  rulesClients?: Array< MercadoCategoryClientRuleInput | null > | null,
  image?: FileInput | null,
  parentCategory?: string | null,
  childrenCategories?: Array< string | null > | null,
  items?: Array< string | null > | null,
};

export type DeleteMercadoCategoriesInput = {
  id: string,
};

export type CreateMercadoProductCategoryClientInput = {
  id?: string | null,
  idClient?: string | null,
  idMercadoCategory?: string | null,
  unrestrictedProducts?: Array< string | null > | null,
  restrictedProducts?: Array< string | null > | null,
  created: number,
  updated?: number | null,
};

export type ModelMercadoProductCategoryClientConditionInput = {
  idClient?: ModelIDInput | null,
  idMercadoCategory?: ModelIDInput | null,
  unrestrictedProducts?: ModelStringInput | null,
  restrictedProducts?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelMercadoProductCategoryClientConditionInput | null > | null,
  or?: Array< ModelMercadoProductCategoryClientConditionInput | null > | null,
  not?: ModelMercadoProductCategoryClientConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type MercadoProductCategoryClient = {
  __typename: "MercadoProductCategoryClient",
  id: string,
  idClient?: string | null,
  idMercadoCategory?: string | null,
  unrestrictedProducts?: Array< string | null > | null,
  restrictedProducts?: Array< string | null > | null,
  created: number,
  updated?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateMercadoProductCategoryClientInput = {
  id: string,
  idClient?: string | null,
  idMercadoCategory?: string | null,
  unrestrictedProducts?: Array< string | null > | null,
  restrictedProducts?: Array< string | null > | null,
  created?: number | null,
  updated?: number | null,
};

export type DeleteMercadoProductCategoryClientInput = {
  id: string,
};

export type CreateExternalApisInput = {
  id?: string | null,
  status?: string | null,
  name?: string | null,
  nameExternal?: string | null,
  region?: Array< string | null > | null,
  increment?: number | null,
  discount?: number | null,
  visibleFor?: Array< string | null > | null,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  created: number,
  updated?: number | null,
};

export type ModelExternalApisConditionInput = {
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  nameExternal?: ModelStringInput | null,
  region?: ModelStringInput | null,
  increment?: ModelFloatInput | null,
  discount?: ModelFloatInput | null,
  visibleFor?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelExternalApisConditionInput | null > | null,
  or?: Array< ModelExternalApisConditionInput | null > | null,
  not?: ModelExternalApisConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ExternalApis = {
  __typename: "ExternalApis",
  id: string,
  status?: string | null,
  name?: string | null,
  nameExternal?: string | null,
  region?: Array< string | null > | null,
  increment?: number | null,
  discount?: number | null,
  visibleFor?: Array< string | null > | null,
  clientDiscounts?:  Array<ClientDiscountPercents | null > | null,
  clientFeeIncrements?:  Array<ClientFeePercents | null > | null,
  clientIncrements?:  Array<ClientFeePercents | null > | null,
  created: number,
  updated?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateExternalApisInput = {
  id: string,
  status?: string | null,
  name?: string | null,
  nameExternal?: string | null,
  region?: Array< string | null > | null,
  increment?: number | null,
  discount?: number | null,
  visibleFor?: Array< string | null > | null,
  clientDiscounts?: Array< ClientDiscountPercentsInput | null > | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  created?: number | null,
  updated?: number | null,
};

export type DeleteExternalApisInput = {
  id: string,
};

export type CreatePrintPricesInput = {
  id?: string | null,
  identifier?: number | null,
  status?: string | null,
  creator?: string | null,
  description?: string | null,
  price?: number | null,
  minUnits?: number | null,
  maxUnits?: number | null,
  ranges?: Array< PrintPriceRangeInput | null > | null,
  clientPrintPrices?: Array< ClientPrintPriceInput | null > | null,
  created: number,
  updated?: number | null,
};

export type PrintPriceRangeInput = {
  price?: number | null,
  minUnits?: number | null,
  maxUnits?: number | null,
};

export type ClientPrintPriceInput = {
  clientId?: string | null,
  price?: number | null,
  minUnits?: number | null,
  maxUnits?: number | null,
};

export type ModelPrintPricesConditionInput = {
  identifier?: ModelIntInput | null,
  status?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  description?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  minUnits?: ModelIntInput | null,
  maxUnits?: ModelIntInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelPrintPricesConditionInput | null > | null,
  or?: Array< ModelPrintPricesConditionInput | null > | null,
  not?: ModelPrintPricesConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PrintPrices = {
  __typename: "PrintPrices",
  id: string,
  identifier?: number | null,
  status?: string | null,
  creator?: string | null,
  description?: string | null,
  price?: number | null,
  minUnits?: number | null,
  maxUnits?: number | null,
  ranges?:  Array<PrintPriceRange | null > | null,
  clientPrintPrices?:  Array<ClientPrintPrice | null > | null,
  created: number,
  updated?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type PrintPriceRange = {
  __typename: "PrintPriceRange",
  price?: number | null,
  minUnits?: number | null,
  maxUnits?: number | null,
};

export type ClientPrintPrice = {
  __typename: "ClientPrintPrice",
  clientId?: string | null,
  price?: number | null,
  minUnits?: number | null,
  maxUnits?: number | null,
};

export type UpdatePrintPricesInput = {
  id: string,
  identifier?: number | null,
  status?: string | null,
  creator?: string | null,
  description?: string | null,
  price?: number | null,
  minUnits?: number | null,
  maxUnits?: number | null,
  ranges?: Array< PrintPriceRangeInput | null > | null,
  clientPrintPrices?: Array< ClientPrintPriceInput | null > | null,
  created?: number | null,
  updated?: number | null,
};

export type DeletePrintPricesInput = {
  id: string,
};

export type CreatePrintLogosInput = {
  id?: string | null,
  status?: string | null,
  creator?: string | null,
  description?: string | null,
  identifier?: number | null,
  clientId?: string | null,
  image?: FileInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelPrintLogosConditionInput = {
  status?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  description?: ModelStringInput | null,
  identifier?: ModelIntInput | null,
  clientId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPrintLogosConditionInput | null > | null,
  or?: Array< ModelPrintLogosConditionInput | null > | null,
  not?: ModelPrintLogosConditionInput | null,
};

export type PrintLogos = {
  __typename: "PrintLogos",
  id: string,
  status?: string | null,
  creator?: string | null,
  description?: string | null,
  identifier?: number | null,
  clientId?: string | null,
  image?: File | null,
  createdAt: string,
  updatedAt?: string | null,
};

export type UpdatePrintLogosInput = {
  id: string,
  status?: string | null,
  creator?: string | null,
  description?: string | null,
  identifier?: number | null,
  clientId?: string | null,
  image?: FileInput | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeletePrintLogosInput = {
  id: string,
};

export type CreateLogisticPostalCodeInput = {
  id?: string | null,
  cpFrom: string,
  cpTo: string,
  zone: number,
  state: string,
};

export type ModelLogisticPostalCodeConditionInput = {
  cpFrom?: ModelStringInput | null,
  cpTo?: ModelStringInput | null,
  zone?: ModelIntInput | null,
  state?: ModelStringInput | null,
  and?: Array< ModelLogisticPostalCodeConditionInput | null > | null,
  or?: Array< ModelLogisticPostalCodeConditionInput | null > | null,
  not?: ModelLogisticPostalCodeConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LogisticPostalCode = {
  __typename: "LogisticPostalCode",
  id: string,
  cpFrom: string,
  cpTo: string,
  zone: number,
  state: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLogisticPostalCodeInput = {
  id: string,
  cpFrom?: string | null,
  cpTo?: string | null,
  zone?: number | null,
  state?: string | null,
};

export type DeleteLogisticPostalCodeInput = {
  id: string,
};

export type CreateLogisticPieceRangeInput = {
  id?: string | null,
  piecesRange: number,
  min: number,
  max: number,
};

export type ModelLogisticPieceRangeConditionInput = {
  piecesRange?: ModelIntInput | null,
  min?: ModelIntInput | null,
  max?: ModelIntInput | null,
  and?: Array< ModelLogisticPieceRangeConditionInput | null > | null,
  or?: Array< ModelLogisticPieceRangeConditionInput | null > | null,
  not?: ModelLogisticPieceRangeConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LogisticPieceRange = {
  __typename: "LogisticPieceRange",
  id: string,
  piecesRange: number,
  min: number,
  max: number,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLogisticPieceRangeInput = {
  id: string,
  piecesRange?: number | null,
  min?: number | null,
  max?: number | null,
};

export type DeleteLogisticPieceRangeInput = {
  id: string,
};

export type CreateLogisticWeightRangeInput = {
  id?: string | null,
  weightRange: number,
  min: number,
  max: number,
  created: number,
  updated?: number | null,
};

export type ModelLogisticWeightRangeConditionInput = {
  weightRange?: ModelIntInput | null,
  min?: ModelIntInput | null,
  max?: ModelIntInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelLogisticWeightRangeConditionInput | null > | null,
  or?: Array< ModelLogisticWeightRangeConditionInput | null > | null,
  not?: ModelLogisticWeightRangeConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LogisticWeightRange = {
  __typename: "LogisticWeightRange",
  id: string,
  weightRange: number,
  min: number,
  max: number,
  created: number,
  updated?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLogisticWeightRangeInput = {
  id: string,
  weightRange?: number | null,
  min?: number | null,
  max?: number | null,
  created?: number | null,
  updated?: number | null,
};

export type DeleteLogisticWeightRangeInput = {
  id: string,
};

export type CreateLogisticWeightBoxInput = {
  id?: string | null,
  boxId?: string | null,
  shippingPrices?: Array< LogisticWeightPriceInput | null > | null,
  created: number,
  updated?: number | null,
};

export type LogisticWeightPriceInput = {
  weightRangeId?: string | null,
  price: number,
};

export type ModelLogisticWeightBoxConditionInput = {
  boxId?: ModelIDInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelLogisticWeightBoxConditionInput | null > | null,
  or?: Array< ModelLogisticWeightBoxConditionInput | null > | null,
  not?: ModelLogisticWeightBoxConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LogisticWeightBox = {
  __typename: "LogisticWeightBox",
  id: string,
  boxId?: string | null,
  shippingPrices?:  Array<LogisticWeightPrice | null > | null,
  created: number,
  updated?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type LogisticWeightPrice = {
  __typename: "LogisticWeightPrice",
  weightRangeId?: string | null,
  price: number,
};

export type UpdateLogisticWeightBoxInput = {
  id: string,
  boxId?: string | null,
  shippingPrices?: Array< LogisticWeightPriceInput | null > | null,
  created?: number | null,
  updated?: number | null,
};

export type DeleteLogisticWeightBoxInput = {
  id: string,
};

export type CreateLogisticZoneInput = {
  id?: string | null,
  zoneName: string,
  shippingPrices?: Array< LogisticShippingPriceInput | null > | null,
  clientsRanges?: Array< LogisticPieceRangeClientInput | null > | null,
  created: number,
  updated?: number | null,
};

export type LogisticShippingPriceInput = {
  piecesRangeId?: string | null,
  price: number,
};

export type LogisticPieceRangeClientInput = {
  id: string,
  clientId: string,
  piecesRange: string,
  price: number,
};

export type ModelLogisticZoneConditionInput = {
  zoneName?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelLogisticZoneConditionInput | null > | null,
  or?: Array< ModelLogisticZoneConditionInput | null > | null,
  not?: ModelLogisticZoneConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LogisticZone = {
  __typename: "LogisticZone",
  id: string,
  zoneName: string,
  shippingPrices?:  Array<LogisticShippingPrice | null > | null,
  clientsRanges?:  Array<LogisticPieceRangeClient | null > | null,
  created: number,
  updated?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type LogisticShippingPrice = {
  __typename: "LogisticShippingPrice",
  piecesRangeId?: string | null,
  price: number,
};

export type LogisticPieceRangeClient = {
  __typename: "LogisticPieceRangeClient",
  id: string,
  clientId: string,
  piecesRange: string,
  price: number,
};

export type UpdateLogisticZoneInput = {
  id: string,
  zoneName?: string | null,
  shippingPrices?: Array< LogisticShippingPriceInput | null > | null,
  clientsRanges?: Array< LogisticPieceRangeClientInput | null > | null,
  created?: number | null,
  updated?: number | null,
};

export type DeleteLogisticZoneInput = {
  id: string,
};

export type CreateLogisticBoxInput = {
  id?: string | null,
  status?: string | null,
  name?: string | null,
  description?: string | null,
  price?: number | null,
  width?: number | null,
  height?: number | null,
  depth?: number | null,
  volumetricWeight?: number | null,
  maxWeight?: number | null,
  maxPayload?: number | null,
  createdAt?: string | null,
};

export type ModelLogisticBoxConditionInput = {
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  width?: ModelFloatInput | null,
  height?: ModelFloatInput | null,
  depth?: ModelFloatInput | null,
  volumetricWeight?: ModelFloatInput | null,
  maxWeight?: ModelFloatInput | null,
  maxPayload?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelLogisticBoxConditionInput | null > | null,
  or?: Array< ModelLogisticBoxConditionInput | null > | null,
  not?: ModelLogisticBoxConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LogisticBox = {
  __typename: "LogisticBox",
  id: string,
  status?: string | null,
  name?: string | null,
  description?: string | null,
  price?: number | null,
  width?: number | null,
  height?: number | null,
  depth?: number | null,
  volumetricWeight?: number | null,
  maxWeight?: number | null,
  maxPayload?: number | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateLogisticBoxInput = {
  id: string,
  status?: string | null,
  name?: string | null,
  description?: string | null,
  price?: number | null,
  width?: number | null,
  height?: number | null,
  depth?: number | null,
  volumetricWeight?: number | null,
  maxWeight?: number | null,
  maxPayload?: number | null,
  createdAt?: string | null,
};

export type DeleteLogisticBoxInput = {
  id: string,
};

export type CreateLogisticVehiclesInput = {
  id?: string | null,
  status?: string | null,
  licensePlate?: string | null,
  hasInsurancePolicy?: string | null,
  fuelCapacity?: number | null,
  width?: number | null,
  height?: number | null,
  depth?: number | null,
  maxWeight?: number | null,
  created: number,
  updated?: number | null,
};

export type ModelLogisticVehiclesConditionInput = {
  status?: ModelStringInput | null,
  licensePlate?: ModelStringInput | null,
  hasInsurancePolicy?: ModelStringInput | null,
  fuelCapacity?: ModelFloatInput | null,
  width?: ModelFloatInput | null,
  height?: ModelFloatInput | null,
  depth?: ModelFloatInput | null,
  maxWeight?: ModelFloatInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelLogisticVehiclesConditionInput | null > | null,
  or?: Array< ModelLogisticVehiclesConditionInput | null > | null,
  not?: ModelLogisticVehiclesConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LogisticVehicles = {
  __typename: "LogisticVehicles",
  id: string,
  status?: string | null,
  licensePlate?: string | null,
  hasInsurancePolicy?: string | null,
  fuelCapacity?: number | null,
  width?: number | null,
  height?: number | null,
  depth?: number | null,
  maxWeight?: number | null,
  created: number,
  updated?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLogisticVehiclesInput = {
  id: string,
  status?: string | null,
  licensePlate?: string | null,
  hasInsurancePolicy?: string | null,
  fuelCapacity?: number | null,
  width?: number | null,
  height?: number | null,
  depth?: number | null,
  maxWeight?: number | null,
  created?: number | null,
  updated?: number | null,
};

export type DeleteLogisticVehiclesInput = {
  id: string,
};

export type CreatePakmailCarrierInput = {
  id?: string | null,
  status?: string | null,
  identifier?: number | null,
  image?: FileInput | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
  createdAt?: string | null,
};

export type ModelPakmailCarrierConditionInput = {
  status?: ModelStringInput | null,
  identifier?: ModelIntInput | null,
  visibleFor?: ModelStringInput | null,
  region?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPakmailCarrierConditionInput | null > | null,
  or?: Array< ModelPakmailCarrierConditionInput | null > | null,
  not?: ModelPakmailCarrierConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PakmailCarrier = {
  __typename: "PakmailCarrier",
  id: string,
  status?: string | null,
  identifier?: number | null,
  image?: File | null,
  clientFeeIncrements?:  Array<ClientFeePercents | null > | null,
  clientIncrements?:  Array<ClientFeePercents | null > | null,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdatePakmailCarrierInput = {
  id: string,
  status?: string | null,
  identifier?: number | null,
  image?: FileInput | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
  createdAt?: string | null,
};

export type DeletePakmailCarrierInput = {
  id: string,
};

export type CreatePakmailServiceInput = {
  id?: string | null,
  status?: string | null,
  identifier?: string | null,
  image?: FileInput | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
  isNational?: boolean | null,
  createdAt?: string | null,
};

export type ModelPakmailServiceConditionInput = {
  status?: ModelStringInput | null,
  identifier?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  region?: ModelStringInput | null,
  isNational?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPakmailServiceConditionInput | null > | null,
  or?: Array< ModelPakmailServiceConditionInput | null > | null,
  not?: ModelPakmailServiceConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PakmailService = {
  __typename: "PakmailService",
  id: string,
  status?: string | null,
  identifier?: string | null,
  image?: File | null,
  clientFeeIncrements?:  Array<ClientFeePercents | null > | null,
  clientIncrements?:  Array<ClientFeePercents | null > | null,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
  isNational?: boolean | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdatePakmailServiceInput = {
  id: string,
  status?: string | null,
  identifier?: string | null,
  image?: FileInput | null,
  clientFeeIncrements?: Array< ClientFeePercentsInput | null > | null,
  clientIncrements?: Array< ClientFeePercentsInput | null > | null,
  visibleFor?: Array< string | null > | null,
  region?: Array< string | null > | null,
  isNational?: boolean | null,
  createdAt?: string | null,
};

export type DeletePakmailServiceInput = {
  id: string,
};

export type CreatePakmailShipmentStatusInput = {
  id?: string | null,
  status?: string | null,
  identifier?: number | null,
  image?: FileInput | null,
  visibleFor?: Array< string | null > | null,
  notifications?: Array< NotificationSubprocessesInput | null > | null,
  createdAt?: string | null,
};

export type ModelPakmailShipmentStatusConditionInput = {
  status?: ModelStringInput | null,
  identifier?: ModelIntInput | null,
  visibleFor?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPakmailShipmentStatusConditionInput | null > | null,
  or?: Array< ModelPakmailShipmentStatusConditionInput | null > | null,
  not?: ModelPakmailShipmentStatusConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PakmailShipmentStatus = {
  __typename: "PakmailShipmentStatus",
  id: string,
  status?: string | null,
  identifier?: number | null,
  image?: File | null,
  visibleFor?: Array< string | null > | null,
  notifications?:  Array<NotificationSubprocesses | null > | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdatePakmailShipmentStatusInput = {
  id: string,
  status?: string | null,
  identifier?: number | null,
  image?: FileInput | null,
  visibleFor?: Array< string | null > | null,
  notifications?: Array< NotificationSubprocessesInput | null > | null,
  createdAt?: string | null,
};

export type DeletePakmailShipmentStatusInput = {
  id: string,
};

export type CreatePakmailShipmentEventInput = {
  id?: string | null,
  status?: string | null,
  identifier?: string | null,
  visibleFor?: Array< string | null > | null,
  color?: string | null,
  notifications?: Array< NotificationSubprocessesInput | null > | null,
  createdAt?: string | null,
};

export type ModelPakmailShipmentEventConditionInput = {
  status?: ModelStringInput | null,
  identifier?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  color?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPakmailShipmentEventConditionInput | null > | null,
  or?: Array< ModelPakmailShipmentEventConditionInput | null > | null,
  not?: ModelPakmailShipmentEventConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PakmailShipmentEvent = {
  __typename: "PakmailShipmentEvent",
  id: string,
  status?: string | null,
  identifier?: string | null,
  visibleFor?: Array< string | null > | null,
  color?: string | null,
  notifications?:  Array<NotificationSubprocesses | null > | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdatePakmailShipmentEventInput = {
  id: string,
  status?: string | null,
  identifier?: string | null,
  visibleFor?: Array< string | null > | null,
  color?: string | null,
  notifications?: Array< NotificationSubprocessesInput | null > | null,
  createdAt?: string | null,
};

export type DeletePakmailShipmentEventInput = {
  id: string,
};

export type CreatePakmailPickupStatusInput = {
  id?: string | null,
  status?: string | null,
  identifier?: number | null,
  visibleFor?: Array< string | null > | null,
  notifications?: Array< NotificationSubprocessesInput | null > | null,
  createdAt?: string | null,
};

export type ModelPakmailPickupStatusConditionInput = {
  status?: ModelStringInput | null,
  identifier?: ModelIntInput | null,
  visibleFor?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPakmailPickupStatusConditionInput | null > | null,
  or?: Array< ModelPakmailPickupStatusConditionInput | null > | null,
  not?: ModelPakmailPickupStatusConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type PakmailPickupStatus = {
  __typename: "PakmailPickupStatus",
  id: string,
  status?: string | null,
  identifier?: number | null,
  visibleFor?: Array< string | null > | null,
  notifications?:  Array<NotificationSubprocesses | null > | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdatePakmailPickupStatusInput = {
  id: string,
  status?: string | null,
  identifier?: number | null,
  visibleFor?: Array< string | null > | null,
  notifications?: Array< NotificationSubprocessesInput | null > | null,
  createdAt?: string | null,
};

export type DeletePakmailPickupStatusInput = {
  id: string,
};

export type CreatePremiumOrderLogisticGuideInput = {
  id?: string | null,
  type: LogisticGuideType,
  pakmailId?: string | null,
  premiumOrderId: string,
  clientId: string,
  creatorId: string,
  originAddressId?: string | null,
  destinationAddressId?: string | null,
  originAddress?: string | null,
  destinationAddress?: string | null,
  products?: Array< LogisticGuideProductInput | null > | null,
  price?: number | null,
  increment?: number | null,
  fee?: number | null,
  createdAt?: string | null,
};

export enum LogisticGuideType {
  guide = "guide",
  draft = "draft",
}


export type LogisticGuideProductInput = {
  indexProduct: number,
  productId: string,
  quantity: number,
  unitWidth: number,
  unitHeight: number,
  unitDepth: number,
  unitWeight: number,
};

export type ModelPremiumOrderLogisticGuideConditionInput = {
  type?: ModelLogisticGuideTypeInput | null,
  pakmailId?: ModelStringInput | null,
  premiumOrderId?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  creatorId?: ModelStringInput | null,
  originAddressId?: ModelStringInput | null,
  destinationAddressId?: ModelStringInput | null,
  originAddress?: ModelStringInput | null,
  destinationAddress?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  increment?: ModelFloatInput | null,
  fee?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPremiumOrderLogisticGuideConditionInput | null > | null,
  or?: Array< ModelPremiumOrderLogisticGuideConditionInput | null > | null,
  not?: ModelPremiumOrderLogisticGuideConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLogisticGuideTypeInput = {
  eq?: LogisticGuideType | null,
  ne?: LogisticGuideType | null,
};

export type PremiumOrderLogisticGuide = {
  __typename: "PremiumOrderLogisticGuide",
  id: string,
  type: LogisticGuideType,
  pakmailId?: string | null,
  premiumOrderId: string,
  clientId: string,
  creatorId: string,
  originAddressId?: string | null,
  destinationAddressId?: string | null,
  originAddress?: string | null,
  destinationAddress?: string | null,
  products?:  Array<LogisticGuideProduct | null > | null,
  price?: number | null,
  increment?: number | null,
  fee?: number | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type LogisticGuideProduct = {
  __typename: "LogisticGuideProduct",
  indexProduct: number,
  productId: string,
  quantity: number,
  unitWidth: number,
  unitHeight: number,
  unitDepth: number,
  unitWeight: number,
};

export type UpdatePremiumOrderLogisticGuideInput = {
  id: string,
  type?: LogisticGuideType | null,
  pakmailId?: string | null,
  premiumOrderId?: string | null,
  clientId?: string | null,
  creatorId?: string | null,
  originAddressId?: string | null,
  destinationAddressId?: string | null,
  originAddress?: string | null,
  destinationAddress?: string | null,
  products?: Array< LogisticGuideProductInput | null > | null,
  price?: number | null,
  increment?: number | null,
  fee?: number | null,
  createdAt?: string | null,
};

export type DeletePremiumOrderLogisticGuideInput = {
  id: string,
};

export type CreateProductLabelItemInput = {
  id?: string | null,
  productId?: string | null,
  productLabelId?: string | null,
  createdAt?: string | null,
};

export type ModelProductLabelItemConditionInput = {
  productId?: ModelIDInput | null,
  productLabelId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelProductLabelItemConditionInput | null > | null,
  or?: Array< ModelProductLabelItemConditionInput | null > | null,
  not?: ModelProductLabelItemConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ProductLabelItem = {
  __typename: "ProductLabelItem",
  id: string,
  productId?: string | null,
  productLabelId?: string | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateProductLabelItemInput = {
  id: string,
  productId?: string | null,
  productLabelId?: string | null,
  createdAt?: string | null,
};

export type DeleteProductLabelItemInput = {
  id: string,
};

export type CreateProductLabelInput = {
  id?: string | null,
  name?: string | null,
  translation?: string | null,
  status?: string | null,
  visibleFor?: Array< string | null > | null,
  createdAt?: string | null,
};

export type ModelProductLabelConditionInput = {
  name?: ModelStringInput | null,
  translation?: ModelStringInput | null,
  status?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelProductLabelConditionInput | null > | null,
  or?: Array< ModelProductLabelConditionInput | null > | null,
  not?: ModelProductLabelConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ProductLabel = {
  __typename: "ProductLabel",
  id: string,
  name?: string | null,
  translation?: string | null,
  status?: string | null,
  visibleFor?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateProductLabelInput = {
  id: string,
  name?: string | null,
  translation?: string | null,
  status?: string | null,
  visibleFor?: Array< string | null > | null,
  createdAt?: string | null,
};

export type DeleteProductLabelInput = {
  id: string,
};

export type CreateProductTextItemInput = {
  id?: string | null,
  productId?: string | null,
  productTextId?: string | null,
  createdAt?: string | null,
};

export type ModelProductTextItemConditionInput = {
  productId?: ModelIDInput | null,
  productTextId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelProductTextItemConditionInput | null > | null,
  or?: Array< ModelProductTextItemConditionInput | null > | null,
  not?: ModelProductTextItemConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ProductTextItem = {
  __typename: "ProductTextItem",
  id: string,
  productId?: string | null,
  productTextId?: string | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateProductTextItemInput = {
  id: string,
  productId?: string | null,
  productTextId?: string | null,
  createdAt?: string | null,
};

export type DeleteProductTextItemInput = {
  id: string,
};

export type CreateProductTextInput = {
  id?: string | null,
  name?: string | null,
  status?: string | null,
  visibleFor?: Array< string | null > | null,
  createdAt?: string | null,
};

export type ModelProductTextConditionInput = {
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelProductTextConditionInput | null > | null,
  or?: Array< ModelProductTextConditionInput | null > | null,
  not?: ModelProductTextConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ProductText = {
  __typename: "ProductText",
  id: string,
  name?: string | null,
  status?: string | null,
  visibleFor?: Array< string | null > | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateProductTextInput = {
  id: string,
  name?: string | null,
  status?: string | null,
  visibleFor?: Array< string | null > | null,
  createdAt?: string | null,
};

export type DeleteProductTextInput = {
  id: string,
};

export type CreateProductMaskInput = {
  id?: string | null,
  name?: string | null,
  sku?: string | null,
  productId?: string | null,
  clientId?: string | null,
  filterColors?: Array< string | null > | null,
  mainImage?: FileInput | null,
  increment?: number | null,
  fee?: number | null,
  discount?: number | null,
  stock?: number | null,
  categoryId?: string | null,
  sellMode?: ProductMaskSellMode | null,
  kitPieces?: number | null,
  kitIncrement?: number | null,
  kitFee?: number | null,
  stockMode?: ProductMaskStockMode | null,
  createdAt?: string | null,
};

export enum ProductMaskStockMode {
  SUM = "SUM",
  INDEPENDENT = "INDEPENDENT",
  PARENT = "PARENT",
}


export type ModelProductMaskConditionInput = {
  name?: ModelStringInput | null,
  sku?: ModelStringInput | null,
  productId?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  filterColors?: ModelStringInput | null,
  increment?: ModelFloatInput | null,
  fee?: ModelFloatInput | null,
  discount?: ModelFloatInput | null,
  stock?: ModelIntInput | null,
  categoryId?: ModelStringInput | null,
  sellMode?: ModelProductMaskSellModeInput | null,
  kitPieces?: ModelIntInput | null,
  kitIncrement?: ModelFloatInput | null,
  kitFee?: ModelFloatInput | null,
  stockMode?: ModelProductMaskStockModeInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelProductMaskConditionInput | null > | null,
  or?: Array< ModelProductMaskConditionInput | null > | null,
  not?: ModelProductMaskConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelProductMaskSellModeInput = {
  eq?: ProductMaskSellMode | null,
  ne?: ProductMaskSellMode | null,
};

export type ModelProductMaskStockModeInput = {
  eq?: ProductMaskStockMode | null,
  ne?: ProductMaskStockMode | null,
};

export type ProductMask = {
  __typename: "ProductMask",
  id: string,
  name?: string | null,
  sku?: string | null,
  productId?: string | null,
  clientId?: string | null,
  filterColors?: Array< string | null > | null,
  mainImage?: File | null,
  increment?: number | null,
  fee?: number | null,
  discount?: number | null,
  stock?: number | null,
  categoryId?: string | null,
  sellMode?: ProductMaskSellMode | null,
  kitPieces?: number | null,
  kitIncrement?: number | null,
  kitFee?: number | null,
  stockMode?: ProductMaskStockMode | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateProductMaskInput = {
  id: string,
  name?: string | null,
  sku?: string | null,
  productId?: string | null,
  clientId?: string | null,
  filterColors?: Array< string | null > | null,
  mainImage?: FileInput | null,
  increment?: number | null,
  fee?: number | null,
  discount?: number | null,
  stock?: number | null,
  categoryId?: string | null,
  sellMode?: ProductMaskSellMode | null,
  kitPieces?: number | null,
  kitIncrement?: number | null,
  kitFee?: number | null,
  stockMode?: ProductMaskStockMode | null,
  createdAt?: string | null,
};

export type DeleteProductMaskInput = {
  id: string,
};

export type CreateVariantMaskInput = {
  id?: string | null,
  filterColors?: Array< string | null > | null,
  images?: Array< FileInput | null > | null,
  stock?: number | null,
  stockMode?: VariantMaskStockMode | null,
  productMaskId?: string | null,
  createdAt?: string | null,
};

export enum VariantMaskStockMode {
  PARENT = "PARENT",
  SUM = "SUM",
  INDEPENDENT = "INDEPENDENT",
}


export type ModelVariantMaskConditionInput = {
  filterColors?: ModelStringInput | null,
  stock?: ModelIntInput | null,
  stockMode?: ModelVariantMaskStockModeInput | null,
  productMaskId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelVariantMaskConditionInput | null > | null,
  or?: Array< ModelVariantMaskConditionInput | null > | null,
  not?: ModelVariantMaskConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelVariantMaskStockModeInput = {
  eq?: VariantMaskStockMode | null,
  ne?: VariantMaskStockMode | null,
};

export type VariantMask = {
  __typename: "VariantMask",
  id: string,
  filterColors?: Array< string | null > | null,
  images?:  Array<File | null > | null,
  stock?: number | null,
  stockMode?: VariantMaskStockMode | null,
  productMaskId?: string | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateVariantMaskInput = {
  id: string,
  filterColors?: Array< string | null > | null,
  images?: Array< FileInput | null > | null,
  stock?: number | null,
  stockMode?: VariantMaskStockMode | null,
  productMaskId?: string | null,
  createdAt?: string | null,
};

export type DeleteVariantMaskInput = {
  id: string,
};

export type CreateProductMaskDescriptionInput = {
  id?: string | null,
  long_description?: string | null,
  short_description?: string | null,
  productDescriptionItem?: Array< ProductDescriptionItemInput | null > | null,
  createdAt?: string | null,
};

export type ModelProductMaskDescriptionConditionInput = {
  long_description?: ModelStringInput | null,
  short_description?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelProductMaskDescriptionConditionInput | null > | null,
  or?: Array< ModelProductMaskDescriptionConditionInput | null > | null,
  not?: ModelProductMaskDescriptionConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ProductMaskDescription = {
  __typename: "ProductMaskDescription",
  id: string,
  long_description?: string | null,
  short_description?: string | null,
  productDescriptionItem?:  Array<ProductDescriptionItem | null > | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateProductMaskDescriptionInput = {
  id: string,
  long_description?: string | null,
  short_description?: string | null,
  productDescriptionItem?: Array< ProductDescriptionItemInput | null > | null,
  createdAt?: string | null,
};

export type DeleteProductMaskDescriptionInput = {
  id: string,
};

export type CreateCouponInput = {
  id?: string | null,
  code: string,
  name: string,
  description?: string | null,
  discountAmount?: number | null,
  discountPercentage?: number | null,
  minAmount?: number | null,
  maxAmount?: number | null,
  startDate: string,
  endDate: string,
  maxRedemptions?: number | null,
  maxRedemptionsPerUser?: number | null,
  applicableProducts?: Array< string | null > | null,
  applicableCategories?: Array< string | null > | null,
  excludedProducts?: Array< string | null > | null,
  status: string,
  createdBy: string,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelCouponConditionInput = {
  code?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  discountAmount?: ModelFloatInput | null,
  discountPercentage?: ModelFloatInput | null,
  minAmount?: ModelFloatInput | null,
  maxAmount?: ModelFloatInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  maxRedemptions?: ModelIntInput | null,
  maxRedemptionsPerUser?: ModelIntInput | null,
  applicableProducts?: ModelStringInput | null,
  applicableCategories?: ModelStringInput | null,
  excludedProducts?: ModelStringInput | null,
  status?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCouponConditionInput | null > | null,
  or?: Array< ModelCouponConditionInput | null > | null,
  not?: ModelCouponConditionInput | null,
};

export type Coupon = {
  __typename: "Coupon",
  id: string,
  code: string,
  name: string,
  description?: string | null,
  discountAmount?: number | null,
  discountPercentage?: number | null,
  minAmount?: number | null,
  maxAmount?: number | null,
  startDate: string,
  endDate: string,
  maxRedemptions?: number | null,
  maxRedemptionsPerUser?: number | null,
  applicableProducts?: Array< string | null > | null,
  applicableCategories?: Array< string | null > | null,
  excludedProducts?: Array< string | null > | null,
  status: string,
  createdBy: string,
  redemptions?: ModelCouponRedemptionConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelCouponRedemptionConnection = {
  __typename: "ModelCouponRedemptionConnection",
  items:  Array<CouponRedemption | null >,
  nextToken?: string | null,
};

export type CouponRedemption = {
  __typename: "CouponRedemption",
  id: string,
  couponId: string,
  couponCode: string,
  userId: string,
  clientId?: string | null,
  orderId?: string | null,
  cartId?: string | null,
  discountApplied: number,
  originalAmount: number,
  finalAmount: number,
  appliedAt: string,
  ipAddress?: string | null,
  userAgent?: string | null,
  coupon: Coupon,
  createdAt: string,
  updatedAt: string,
};

export type UpdateCouponInput = {
  id: string,
  code?: string | null,
  name?: string | null,
  description?: string | null,
  discountAmount?: number | null,
  discountPercentage?: number | null,
  minAmount?: number | null,
  maxAmount?: number | null,
  startDate?: string | null,
  endDate?: string | null,
  maxRedemptions?: number | null,
  maxRedemptionsPerUser?: number | null,
  applicableProducts?: Array< string | null > | null,
  applicableCategories?: Array< string | null > | null,
  excludedProducts?: Array< string | null > | null,
  status?: string | null,
  createdBy?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteCouponInput = {
  id: string,
};

export type CreateCouponRedemptionInput = {
  id?: string | null,
  couponId: string,
  couponCode: string,
  userId: string,
  clientId?: string | null,
  orderId?: string | null,
  cartId?: string | null,
  discountApplied: number,
  originalAmount: number,
  finalAmount: number,
  appliedAt: string,
  ipAddress?: string | null,
  userAgent?: string | null,
};

export type ModelCouponRedemptionConditionInput = {
  couponId?: ModelIDInput | null,
  couponCode?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  orderId?: ModelStringInput | null,
  cartId?: ModelStringInput | null,
  discountApplied?: ModelFloatInput | null,
  originalAmount?: ModelFloatInput | null,
  finalAmount?: ModelFloatInput | null,
  appliedAt?: ModelStringInput | null,
  ipAddress?: ModelStringInput | null,
  userAgent?: ModelStringInput | null,
  and?: Array< ModelCouponRedemptionConditionInput | null > | null,
  or?: Array< ModelCouponRedemptionConditionInput | null > | null,
  not?: ModelCouponRedemptionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateCouponRedemptionInput = {
  id: string,
  couponId?: string | null,
  couponCode?: string | null,
  userId?: string | null,
  clientId?: string | null,
  orderId?: string | null,
  cartId?: string | null,
  discountApplied?: number | null,
  originalAmount?: number | null,
  finalAmount?: number | null,
  appliedAt?: string | null,
  ipAddress?: string | null,
  userAgent?: string | null,
};

export type DeleteCouponRedemptionInput = {
  id: string,
};

export type CreatePromotionInput = {
  id?: string | null,
  name: string,
  description?: string | null,
  triggerProductIds: Array< string | null >,
  minQuantity: number,
  minAmount?: number | null,
  triggerRule: PromotionTriggerRule,
  giftProductId: string,
  giftQuantity: number,
  isStackable?: boolean | null,
  applicableClientIds?: Array< string | null > | null,
  startDate: string,
  endDate: string,
  maxRedemptions?: number | null,
  maxRedemptionsPerUser?: number | null,
  status: string,
  createdBy: string,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export enum PromotionTriggerRule {
  SUM_ACROSS_TRIGGER_PRODUCTS = "SUM_ACROSS_TRIGGER_PRODUCTS",
  PER_TRIGGER_PRODUCT = "PER_TRIGGER_PRODUCT",
  ANY_SINGLE_TRIGGER_PRODUCT = "ANY_SINGLE_TRIGGER_PRODUCT",
  CART_AMOUNT_THRESHOLD = "CART_AMOUNT_THRESHOLD",
}


export type ModelPromotionConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  triggerProductIds?: ModelStringInput | null,
  minQuantity?: ModelIntInput | null,
  minAmount?: ModelFloatInput | null,
  triggerRule?: ModelPromotionTriggerRuleInput | null,
  giftProductId?: ModelStringInput | null,
  giftQuantity?: ModelIntInput | null,
  isStackable?: ModelBooleanInput | null,
  applicableClientIds?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  maxRedemptions?: ModelIntInput | null,
  maxRedemptionsPerUser?: ModelIntInput | null,
  status?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPromotionConditionInput | null > | null,
  or?: Array< ModelPromotionConditionInput | null > | null,
  not?: ModelPromotionConditionInput | null,
};

export type ModelPromotionTriggerRuleInput = {
  eq?: PromotionTriggerRule | null,
  ne?: PromotionTriggerRule | null,
};

export type Promotion = {
  __typename: "Promotion",
  id: string,
  name: string,
  description?: string | null,
  triggerProductIds: Array< string | null >,
  minQuantity: number,
  minAmount?: number | null,
  triggerRule: PromotionTriggerRule,
  giftProductId: string,
  giftQuantity: number,
  isStackable?: boolean | null,
  applicableClientIds?: Array< string | null > | null,
  startDate: string,
  endDate: string,
  maxRedemptions?: number | null,
  maxRedemptionsPerUser?: number | null,
  status: string,
  createdBy: string,
  redemptions?: ModelPromotionRedemptionConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelPromotionRedemptionConnection = {
  __typename: "ModelPromotionRedemptionConnection",
  items:  Array<PromotionRedemption | null >,
  nextToken?: string | null,
};

export type PromotionRedemption = {
  __typename: "PromotionRedemption",
  id: string,
  promotionId: string,
  userId: string,
  clientId?: string | null,
  orderId?: string | null,
  cartId?: string | null,
  triggerQuantity: number,
  giftQuantityApplied: number,
  appliedAt: string,
  ipAddress?: string | null,
  userAgent?: string | null,
  promotion: Promotion,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePromotionInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  triggerProductIds?: Array< string | null > | null,
  minQuantity?: number | null,
  minAmount?: number | null,
  triggerRule?: PromotionTriggerRule | null,
  giftProductId?: string | null,
  giftQuantity?: number | null,
  isStackable?: boolean | null,
  applicableClientIds?: Array< string | null > | null,
  startDate?: string | null,
  endDate?: string | null,
  maxRedemptions?: number | null,
  maxRedemptionsPerUser?: number | null,
  status?: string | null,
  createdBy?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeletePromotionInput = {
  id: string,
};

export type CreatePromotionRedemptionInput = {
  id?: string | null,
  promotionId: string,
  userId: string,
  clientId?: string | null,
  orderId?: string | null,
  cartId?: string | null,
  triggerQuantity: number,
  giftQuantityApplied: number,
  appliedAt: string,
  ipAddress?: string | null,
  userAgent?: string | null,
};

export type ModelPromotionRedemptionConditionInput = {
  promotionId?: ModelIDInput | null,
  userId?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  orderId?: ModelStringInput | null,
  cartId?: ModelStringInput | null,
  triggerQuantity?: ModelIntInput | null,
  giftQuantityApplied?: ModelIntInput | null,
  appliedAt?: ModelStringInput | null,
  ipAddress?: ModelStringInput | null,
  userAgent?: ModelStringInput | null,
  and?: Array< ModelPromotionRedemptionConditionInput | null > | null,
  or?: Array< ModelPromotionRedemptionConditionInput | null > | null,
  not?: ModelPromotionRedemptionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdatePromotionRedemptionInput = {
  id: string,
  promotionId?: string | null,
  userId?: string | null,
  clientId?: string | null,
  orderId?: string | null,
  cartId?: string | null,
  triggerQuantity?: number | null,
  giftQuantityApplied?: number | null,
  appliedAt?: string | null,
  ipAddress?: string | null,
  userAgent?: string | null,
};

export type DeletePromotionRedemptionInput = {
  id: string,
};

export type CreateWalletBalanceInput = {
  id?: string | null,
  balance?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type ModelWalletBalanceConditionInput = {
  balance?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelWalletBalanceConditionInput | null > | null,
  or?: Array< ModelWalletBalanceConditionInput | null > | null,
  not?: ModelWalletBalanceConditionInput | null,
};

export type WalletBalance = {
  __typename: "WalletBalance",
  id: string,
  balance?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type UpdateWalletBalanceInput = {
  id: string,
  balance?: number | null,
  createdAt?: string | null,
  updatedAt?: string | null,
};

export type DeleteWalletBalanceInput = {
  id: string,
};

export type CreateWalletMovementInput = {
  id?: string | null,
  userId: string,
  type: WalletMovementType,
  amount: number,
  orderId?: string | null,
  createdByUserId?: string | null,
  couponId?: string | null,
  couponCode?: string | null,
  availableUntil?: string | null,
  isValidated?: boolean | null,
  validatedAt?: string | null,
  validatedBy?: string | null,
  createdAt?: string | null,
};

export enum WalletMovementType {
  IN = "IN",
  OUT = "OUT",
}


export type ModelWalletMovementConditionInput = {
  userId?: ModelIDInput | null,
  type?: ModelWalletMovementTypeInput | null,
  amount?: ModelFloatInput | null,
  orderId?: ModelIDInput | null,
  createdByUserId?: ModelIDInput | null,
  couponId?: ModelIDInput | null,
  couponCode?: ModelStringInput | null,
  availableUntil?: ModelStringInput | null,
  isValidated?: ModelBooleanInput | null,
  validatedAt?: ModelStringInput | null,
  validatedBy?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelWalletMovementConditionInput | null > | null,
  or?: Array< ModelWalletMovementConditionInput | null > | null,
  not?: ModelWalletMovementConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelWalletMovementTypeInput = {
  eq?: WalletMovementType | null,
  ne?: WalletMovementType | null,
};

export type WalletMovement = {
  __typename: "WalletMovement",
  id: string,
  userId: string,
  type: WalletMovementType,
  amount: number,
  orderId?: string | null,
  createdByUserId?: string | null,
  couponId?: string | null,
  couponCode?: string | null,
  availableUntil?: string | null,
  isValidated?: boolean | null,
  validatedAt?: string | null,
  validatedBy?: string | null,
  createdAt?: string | null,
  updatedAt: string,
};

export type UpdateWalletMovementInput = {
  id: string,
  userId?: string | null,
  type?: WalletMovementType | null,
  amount?: number | null,
  orderId?: string | null,
  createdByUserId?: string | null,
  couponId?: string | null,
  couponCode?: string | null,
  availableUntil?: string | null,
  isValidated?: boolean | null,
  validatedAt?: string | null,
  validatedBy?: string | null,
  createdAt?: string | null,
};

export type DeleteWalletMovementInput = {
  id: string,
};

export type ModelClientFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  business_name?: ModelStringInput | null,
  comertial_name?: ModelStringInput | null,
  biography?: ModelStringInput | null,
  plan?: ModelStringInput | null,
  fee?: ModelFloatInput | null,
  increment?: ModelFloatInput | null,
  mercadoFee?: ModelFloatInput | null,
  mercadoIncrement?: ModelFloatInput | null,
  popFee?: ModelFloatInput | null,
  popIncrement?: ModelFloatInput | null,
  printedFee?: ModelFloatInput | null,
  printedIncrement?: ModelFloatInput | null,
  users?: ModelStringInput | null,
  restrictedUsers?: ModelStringInput | null,
  nonRestrictedUsers?: ModelStringInput | null,
  regions?: ModelStringInput | null,
  providers?: ModelStringInput | null,
  popProviders?: ModelStringInput | null,
  printedProviders?: ModelStringInput | null,
  logisticFrequency?: ModelIntInput | null,
  legal_representative?: ModelStringInput | null,
  legal_representative_email?: ModelStringInput | null,
  legal_representative_address?: ModelStringInput | null,
  tcdUsers?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelClientFilterInput | null > | null,
  or?: Array< ModelClientFilterInput | null > | null,
  not?: ModelClientFilterInput | null,
};

export type ModelClientConnection = {
  __typename: "ModelClientConnection",
  items:  Array<Client | null >,
  nextToken?: string | null,
};

export type ModelClientSettingFilterInput = {
  id?: ModelIDInput | null,
  crmJiraId?: ModelStringInput | null,
  orderBudget?: ModelFloatInput | null,
  domain?: ModelStringInput | null,
  filterColors?: ModelStringInput | null,
  primaryColors?: ModelStringInput | null,
  accentColors?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelClientSettingFilterInput | null > | null,
  or?: Array< ModelClientSettingFilterInput | null > | null,
  not?: ModelClientSettingFilterInput | null,
};

export type ModelClientSettingConnection = {
  __typename: "ModelClientSettingConnection",
  items:  Array<ClientSetting | null >,
  nextToken?: string | null,
};

export type ModelClientOptionFilterInput = {
  id?: ModelIDInput | null,
  pakmail?: ModelBooleanInput | null,
  orderVat?: ModelBooleanInput | null,
  hasMercado?: ModelBooleanInput | null,
  hasAmazon?: ModelBooleanInput | null,
  hasAutomobiles?: ModelBooleanInput | null,
  publicDashboards?: ModelBooleanInput | null,
  printPrices?: ModelBooleanInput | null,
  logisticPrices?: ModelBooleanInput | null,
  hidePricesAndFlow?: ModelBooleanInput | null,
  showPhones?: ModelBooleanInput | null,
  fullCoupaDescriptions?: ModelBooleanInput | null,
  isPremium?: ModelBooleanInput | null,
  isPop?: ModelBooleanInput | null,
  isPrinted?: ModelBooleanInput | null,
  allPremiumRfqs?: ModelBooleanInput | null,
  allPopRfqs?: ModelBooleanInput | null,
  allPrintedRfqs?: ModelBooleanInput | null,
  autoUpdateHomePage?: ModelBooleanInput | null,
  showVat?: ModelBooleanInput | null,
  requiredDeliveryInfo?: ModelBooleanInput | null,
  restrictedCatalogue?: ModelBooleanInput | null,
  excludeCoupa?: ModelBooleanInput | null,
  tcdPayment?: ModelBooleanInput | null,
  automaticLogisticGuides?: ModelBooleanInput | null,
  transferencePayment?: ModelBooleanInput | null,
  customCatalogue?: ModelBooleanInput | null,
  disableProjectDescriptions?: ModelBooleanInput | null,
  showBranding?: ModelBooleanInput | null,
  customCostCenter?: ModelBooleanInput | null,
  couponsEnabled?: ModelBooleanInput | null,
  showChat?: ModelBooleanInput | null,
  hasCrmSync?: ModelBooleanInput | null,
  onlyQuotes?: ModelBooleanInput | null,
  autoSaveDeliveryInfo?: ModelBooleanInput | null,
  limitMaxRequestOnDiscounts?: ModelBooleanInput | null,
  freeLocalShipping?: ModelBooleanInput | null,
  discountShipping?: ModelBooleanInput | null,
  printingBreakdown?: ModelBooleanInput | null,
  skipAlendum?: ModelBooleanInput | null,
  skipFMS?: ModelBooleanInput | null,
  clientReminders?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelClientOptionFilterInput | null > | null,
  or?: Array< ModelClientOptionFilterInput | null > | null,
  not?: ModelClientOptionFilterInput | null,
};

export type ModelClientOptionConnection = {
  __typename: "ModelClientOptionConnection",
  items:  Array<ClientOption | null >,
  nextToken?: string | null,
};

export type ModelProviderFilterInput = {
  id?: ModelIDInput | null,
  isApproved?: ModelBooleanInput | null,
  comertial_name?: ModelStringInput | null,
  idProcter?: ModelStringInput | null,
  biography?: ModelStringInput | null,
  experience?: ModelStringInput | null,
  pros?: ModelStringInput | null,
  cons?: ModelStringInput | null,
  video?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  money_filter_c?: ModelBooleanInput | null,
  money_filter_d?: ModelBooleanInput | null,
  users?: ModelStringInput | null,
  bank?: ModelStringInput | null,
  account?: ModelStringInput | null,
  clabe?: ModelStringInput | null,
  cuenta_correo?: ModelStringInput | null,
  isProvider?: ModelBooleanInput | null,
  sameAddress?: ModelBooleanInput | null,
  isPop?: ModelBooleanInput | null,
  isPrinted?: ModelBooleanInput | null,
  hasLogistic?: ModelBooleanInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  representante_legal?: ModelStringInput | null,
  escritura_constitucion?: ModelStringInput | null,
  notario_a?: ModelStringInput | null,
  constituido_down_edo?: ModelStringInput | null,
  rrpp?: ModelStringInput | null,
  isPremium?: ModelBooleanInput | null,
  isTrustProvider?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProviderFilterInput | null > | null,
  or?: Array< ModelProviderFilterInput | null > | null,
  not?: ModelProviderFilterInput | null,
};

export type ModelProviderConnection = {
  __typename: "ModelProviderConnection",
  items:  Array<Provider | null >,
  nextToken?: string | null,
};

export type ModelProviderSettingFilterInput = {
  id?: ModelIDInput | null,
  primaryColors?: ModelStringInput | null,
  accentColors?: ModelStringInput | null,
  categories?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProviderSettingFilterInput | null > | null,
  or?: Array< ModelProviderSettingFilterInput | null > | null,
  not?: ModelProviderSettingFilterInput | null,
};

export type ModelProviderSettingConnection = {
  __typename: "ModelProviderSettingConnection",
  items:  Array<ProviderSetting | null >,
  nextToken?: string | null,
};

export type ModelProviderFileFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProviderFileFilterInput | null > | null,
  or?: Array< ModelProviderFileFilterInput | null > | null,
  not?: ModelProviderFileFilterInput | null,
};

export type ModelProviderFileConnection = {
  __typename: "ModelProviderFileConnection",
  items:  Array<ProviderFile | null >,
  nextToken?: string | null,
};

export type ModelColorsFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  rgb?: ModelStringInput | null,
  hex?: ModelStringInput | null,
  position?: ModelIntInput | null,
  variantNames?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelColorsFilterInput | null > | null,
  or?: Array< ModelColorsFilterInput | null > | null,
  not?: ModelColorsFilterInput | null,
};

export type ModelColorsConnection = {
  __typename: "ModelColorsConnection",
  items:  Array<Colors | null >,
  nextToken?: string | null,
};

export type ModelHomePageCarouselBannerFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  isPublic?: ModelBooleanInput | null,
  title?: ModelStringInput | null,
  subtitle?: ModelStringInput | null,
  copy?: ModelStringInput | null,
  path?: ModelStringInput | null,
  position?: ModelIntInput | null,
  visibleFor?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelHomePageCarouselBannerFilterInput | null > | null,
  or?: Array< ModelHomePageCarouselBannerFilterInput | null > | null,
  not?: ModelHomePageCarouselBannerFilterInput | null,
};

export type ModelHomePageCarouselBannerConnection = {
  __typename: "ModelHomePageCarouselBannerConnection",
  items:  Array<HomePageCarouselBanner | null >,
  nextToken?: string | null,
};

export type ModelHomePageFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  isPublic?: ModelBooleanInput | null,
  showArrow?: ModelBooleanInput | null,
  showNumeration?: ModelBooleanInput | null,
  icon?: ModelStringInput | null,
  title?: ModelStringInput | null,
  subtitle?: ModelStringInput | null,
  body?: ModelStringInput | null,
  route?: ModelStringInput | null,
  titlePosition?: ModelStringInput | null,
  textAlign?: ModelStringInput | null,
  bgColor?: ModelStringInput | null,
  borderColor?: ModelStringInput | null,
  textColor?: ModelStringInput | null,
  position?: ModelIntInput | null,
  verticalLine?: ModelBooleanInput | null,
  browseButton?: ModelBooleanInput | null,
  visibleFor?: ModelStringInput | null,
  visibleForUserBrand?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelHomePageFilterInput | null > | null,
  or?: Array< ModelHomePageFilterInput | null > | null,
  not?: ModelHomePageFilterInput | null,
};

export type ModelHomePageConnection = {
  __typename: "ModelHomePageConnection",
  items:  Array<HomePage | null >,
  nextToken?: string | null,
};

export type ModelHomePageBottomBannerFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  isPublic?: ModelBooleanInput | null,
  title?: ModelStringInput | null,
  subtitle?: ModelStringInput | null,
  icon?: ModelStringInput | null,
  route?: ModelStringInput | null,
  showArrow?: ModelBooleanInput | null,
  bgColor?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelHomePageBottomBannerFilterInput | null > | null,
  or?: Array< ModelHomePageBottomBannerFilterInput | null > | null,
  not?: ModelHomePageBottomBannerFilterInput | null,
};

export type ModelHomePageBottomBannerConnection = {
  __typename: "ModelHomePageBottomBannerConnection",
  items:  Array<HomePageBottomBanner | null >,
  nextToken?: string | null,
};

export type ModelProductoFilterInput = {
  id?: ModelIDInput | null,
  providerId?: ModelIDInput | null,
  categoryId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  bestSeller?: ModelStringInput | null,
  order?: ModelIntInput | null,
  sku?: ModelStringInput | null,
  brand?: ModelStringInput | null,
  colors?: ModelStringInput | null,
  pgClasitication?: ModelStringInput | null,
  delivery_time?: ModelStringInput | null,
  delivery_time_units?: ModelStringInput | null,
  stock?: ModelIntInput | null,
  minRequest?: ModelIntInput | null,
  maxRequest?: ModelIntInput | null,
  article_of_clothing?: ModelBooleanInput | null,
  size?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  long_description?: ModelStringInput | null,
  short_description?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  isExternal?: ModelBooleanInput | null,
  isAllowable?: ModelBooleanInput | null,
  isRestricted?: ModelBooleanInput | null,
  isAutoSkipped?: ModelStringInput | null,
  isAutoAllowed?: ModelStringInput | null,
  isPurse?: ModelBooleanInput | null,
  massiveLayout?: ModelStringInput | null,
  hasBaseAmmount?: ModelBooleanInput | null,
  isFreeAmmount?: ModelBooleanInput | null,
  isCard?: ModelBooleanInput | null,
  isByRequest?: ModelBooleanInput | null,
  isMultiPrice?: ModelBooleanInput | null,
  cardBaseAmmount?: ModelFloatInput | null,
  minCardBaseAmmount?: ModelFloatInput | null,
  maxCardBaseAmmount?: ModelFloatInput | null,
  nameExternal?: ModelStringInput | null,
  unspsc?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  filterColors?: ModelStringInput | null,
  regions?: ModelStringInput | null,
  source?: ModelStringInput | null,
  trazoProductId?: ModelIDInput | null,
  trazoCategoryId?: ModelIDInput | null,
  stockUpdatedAt?: ModelStringInput | null,
  priceUpdatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProductoFilterInput | null > | null,
  or?: Array< ModelProductoFilterInput | null > | null,
  not?: ModelProductoFilterInput | null,
};

export type ModelProductoConnection = {
  __typename: "ModelProductoConnection",
  items:  Array<Producto | null >,
  nextToken?: string | null,
};

export type ModelProductVariantFilterInput = {
  id?: ModelIDInput | null,
  productId?: ModelStringInput | null,
  sku?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  colors?: ModelStringInput | null,
  filterColors?: ModelStringInput | null,
  stock_available?: ModelIntInput | null,
  price?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProductVariantFilterInput | null > | null,
  or?: Array< ModelProductVariantFilterInput | null > | null,
  not?: ModelProductVariantFilterInput | null,
};

export type ModelProductVariantConnection = {
  __typename: "ModelProductVariantConnection",
  items:  Array<ProductVariant | null >,
  nextToken?: string | null,
};

export type ModelProductOptionFilterInput = {
  id?: ModelIDInput | null,
  ownOrder?: ModelStringInput | null,
  isPangga?: ModelStringInput | null,
  volumetricWeight?: ModelStringInput | null,
  isEvaluated?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProductOptionFilterInput | null > | null,
  or?: Array< ModelProductOptionFilterInput | null > | null,
  not?: ModelProductOptionFilterInput | null,
};

export type ModelProductOptionConnection = {
  __typename: "ModelProductOptionConnection",
  items:  Array<ProductOption | null >,
  nextToken?: string | null,
};

export type ModelProductDimentionFilterInput = {
  id?: ModelIDInput | null,
  width?: ModelFloatInput | null,
  height?: ModelFloatInput | null,
  depth?: ModelFloatInput | null,
  weight?: ModelFloatInput | null,
  boxWidth?: ModelFloatInput | null,
  boxHeight?: ModelFloatInput | null,
  boxDepth?: ModelFloatInput | null,
  boxWeight?: ModelFloatInput | null,
  boxQuantity?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProductDimentionFilterInput | null > | null,
  or?: Array< ModelProductDimentionFilterInput | null > | null,
  not?: ModelProductDimentionFilterInput | null,
};

export type ModelProductDimentionConnection = {
  __typename: "ModelProductDimentionConnection",
  items:  Array<ProductDimention | null >,
  nextToken?: string | null,
};

export type ModelMassiveChangeLayoutsFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelStringInput | null,
  status?: ModelStringInput | null,
  providerId?: ModelIDInput | null,
  creatorId?: ModelStringInput | null,
  creatorRole?: ModelStringInput | null,
  productsNumber?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMassiveChangeLayoutsFilterInput | null > | null,
  or?: Array< ModelMassiveChangeLayoutsFilterInput | null > | null,
  not?: ModelMassiveChangeLayoutsFilterInput | null,
};

export type ModelMassiveChangeLayoutsConnection = {
  __typename: "ModelMassiveChangeLayoutsConnection",
  items:  Array<MassiveChangeLayouts | null >,
  nextToken?: string | null,
};

export type ModelCategoryFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  unspsc?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  visibleForUserBrand?: ModelStringInput | null,
  region?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  hasAllowables?: ModelBooleanInput | null,
  hasPreapproveds?: ModelBooleanInput | null,
  hasRestricted?: ModelBooleanInput | null,
  isPublic?: ModelBooleanInput | null,
  isTop?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  parentId?: ModelIDInput | null,
  rootId?: ModelIDInput | null,
  path?: ModelStringInput | null,
  status?: ModelStringInput | null,
  pathIds?: ModelIDInput | null,
  source?: ModelStringInput | null,
  trazoCategoryId?: ModelIDInput | null,
  nameExternal?: ModelStringInput | null,
  depth?: ModelIntInput | null,
  childrenCount?: ModelIntInput | null,
  isLeaf?: ModelBooleanInput | null,
  oldVersion?: ModelStringInput | null,
  productLine?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCategoryFilterInput | null > | null,
  or?: Array< ModelCategoryFilterInput | null > | null,
  not?: ModelCategoryFilterInput | null,
};

export type ModelCategoryConnection = {
  __typename: "ModelCategoryConnection",
  items:  Array<Category | null >,
  nextToken?: string | null,
};

export type ModelProductBrandFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  description?: ModelStringInput | null,
  route?: ModelStringInput | null,
  unspsc?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  region?: ModelStringInput | null,
  hasAllowables?: ModelBooleanInput | null,
  hasPreapproveds?: ModelBooleanInput | null,
  hasRestricted?: ModelBooleanInput | null,
  isTop?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProductBrandFilterInput | null > | null,
  or?: Array< ModelProductBrandFilterInput | null > | null,
  not?: ModelProductBrandFilterInput | null,
};

export type ModelProductBrandConnection = {
  __typename: "ModelProductBrandConnection",
  items:  Array<ProductBrand | null >,
  nextToken?: string | null,
};

export type ModelCartFilterInput = {
  id?: ModelStringInput | null,
  requirement?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCartFilterInput | null > | null,
  or?: Array< ModelCartFilterInput | null > | null,
  not?: ModelCartFilterInput | null,
};

export type ModelCartConnection = {
  __typename: "ModelCartConnection",
  items:  Array<Cart | null >,
  nextToken?: string | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  role?: ModelStringInput | null,
  email?: ModelStringInput | null,
  jiraId?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  companyId?: ModelStringInput | null,
  brandId?: ModelStringInput | null,
  failedLogins?: ModelIntInput | null,
  notificationsOf?: ModelStringInput | null,
  status?: ModelBooleanInput | null,
  isLogistic?: ModelBooleanInput | null,
  isCoupa?: ModelBooleanInput | null,
  isManagement?: ModelBooleanInput | null,
  isAdministration?: ModelBooleanInput | null,
  hasNotifications?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type ModelAutomobileFilterInput = {
  id?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  bought?: ModelBooleanInput | null,
  buyerId?: ModelIDInput | null,
  buyerName?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  brand?: ModelStringInput | null,
  brandId?: ModelStringInput | null,
  model?: ModelStringInput | null,
  version?: ModelStringInput | null,
  year?: ModelIntInput | null,
  color?: ModelStringInput | null,
  km?: ModelIntInput | null,
  transmission?: ModelStringInput | null,
  motor?: ModelStringInput | null,
  passengers?: ModelIntInput | null,
  state?: ModelStringInput | null,
  objeto?: ModelStringInput | null,
  placa?: ModelStringInput | null,
  serialNumber?: ModelStringInput | null,
  star_time?: ModelIntInput | null,
  end_time?: ModelIntInput | null,
  comentario?: ModelStringInput | null,
  penalizacion?: ModelStringInput | null,
  haveWinner?: ModelBooleanInput | null,
  ppostulacion?: ModelBooleanInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAutomobileFilterInput | null > | null,
  or?: Array< ModelAutomobileFilterInput | null > | null,
  not?: ModelAutomobileFilterInput | null,
};

export type ModelAutomobileConnection = {
  __typename: "ModelAutomobileConnection",
  items:  Array<Automobile | null >,
  nextToken?: string | null,
};

export type ModelBrandFilterInput = {
  id?: ModelStringInput | null,
  name?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBrandFilterInput | null > | null,
  or?: Array< ModelBrandFilterInput | null > | null,
  not?: ModelBrandFilterInput | null,
};

export type ModelBrandConnection = {
  __typename: "ModelBrandConnection",
  items:  Array<Brand | null >,
  nextToken?: string | null,
};

export type ModelRfqFilterInput = {
  id?: ModelIDInput | null,
  nombre?: ModelStringInput | null,
  requerimiento?: ModelStringInput | null,
  cantidad?: ModelIntInput | null,
  limit_time?: ModelIntInput | null,
  creator?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  orderAgentIds?: ModelStringInput | null,
  premiumOrderId?: ModelStringInput | null,
  estatus?: ModelStringInput | null,
  orderId?: ModelIntInput | null,
  start_time?: ModelIntInput | null,
  delivery_time?: ModelIntInput | null,
  created?: ModelIntInput | null,
  saving?: ModelFloatInput | null,
  saving_percentage?: ModelFloatInput | null,
  saving_real?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  updated?: ModelIntInput | null,
  multipleProducts?: ModelBooleanInput | null,
  providers?: ModelStringInput | null,
  and?: Array< ModelRfqFilterInput | null > | null,
  or?: Array< ModelRfqFilterInput | null > | null,
  not?: ModelRfqFilterInput | null,
};

export type ModelRfqConnection = {
  __typename: "ModelRfqConnection",
  items:  Array<Rfq | null >,
  nextToken?: string | null,
};

export type ModelRfqAmazonFilterInput = {
  id?: ModelIDInput | null,
  nombre?: ModelStringInput | null,
  requerimiento?: ModelStringInput | null,
  cantidad?: ModelIntInput | null,
  limit_time?: ModelIntInput | null,
  creator?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  estatus?: ModelStringInput | null,
  orderId?: ModelIntInput | null,
  start_time?: ModelIntInput | null,
  delivery_time?: ModelIntInput | null,
  created?: ModelIntInput | null,
  saving?: ModelFloatInput | null,
  saving_percentage?: ModelFloatInput | null,
  saving_real?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  updated?: ModelIntInput | null,
  multipleProducts?: ModelBooleanInput | null,
  providers?: ModelStringInput | null,
  and?: Array< ModelRfqAmazonFilterInput | null > | null,
  or?: Array< ModelRfqAmazonFilterInput | null > | null,
  not?: ModelRfqAmazonFilterInput | null,
};

export type ModelRfqAmazonConnection = {
  __typename: "ModelRfqAmazonConnection",
  items:  Array<RfqAmazon | null >,
  nextToken?: string | null,
};

export type ModelProposalsFilterInput = {
  id?: ModelIDInput | null,
  provider_id?: ModelStringInput | null,
  priceUnit?: ModelFloatInput | null,
  pieces?: ModelIntInput | null,
  price?: ModelFloatInput | null,
  validity_days?: ModelIntInput | null,
  description?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  multipleProducts?: ModelBooleanInput | null,
  hidden?: ModelBooleanInput | null,
  proposalsRfqId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProposalsFilterInput | null > | null,
  or?: Array< ModelProposalsFilterInput | null > | null,
  not?: ModelProposalsFilterInput | null,
};

export type ModelProposalsAmazonFilterInput = {
  id?: ModelIDInput | null,
  provider_id?: ModelStringInput | null,
  priceUnit?: ModelFloatInput | null,
  pieces?: ModelIntInput | null,
  price?: ModelFloatInput | null,
  validity_days?: ModelIntInput | null,
  description?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  multipleProducts?: ModelBooleanInput | null,
  hidden?: ModelBooleanInput | null,
  proposalsRfqId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProposalsAmazonFilterInput | null > | null,
  or?: Array< ModelProposalsAmazonFilterInput | null > | null,
  not?: ModelProposalsAmazonFilterInput | null,
};

export type ModelProductoRfqFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  request?: ModelStringInput | null,
  category_id?: ModelIDInput | null,
  provider_id?: ModelIDInput | null,
  price?: ModelFloatInput | null,
  estatus?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProductoRfqFilterInput | null > | null,
  or?: Array< ModelProductoRfqFilterInput | null > | null,
  not?: ModelProductoRfqFilterInput | null,
};

export type ModelProductoRfqConnection = {
  __typename: "ModelProductoRfqConnection",
  items:  Array<ProductoRfq | null >,
  nextToken?: string | null,
};

export type ModelOrderProvidersFilterInput = {
  id?: ModelIDInput | null,
  provider_id?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  orderId?: ModelIntInput | null,
  orderProvidersPremiumOrderId?: ModelIDInput | null,
  payment_date?: ModelIntInput | null,
  gr_code?: ModelStringInput | null,
  invoice?: ModelBooleanInput | null,
  invoiceRequested?: ModelBooleanInput | null,
  uploadedGr?: ModelBooleanInput | null,
  uploadedBill?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOrderProvidersFilterInput | null > | null,
  or?: Array< ModelOrderProvidersFilterInput | null > | null,
  not?: ModelOrderProvidersFilterInput | null,
};

export type ModelPopMaterialFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  route?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  year?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPopMaterialFilterInput | null > | null,
  or?: Array< ModelPopMaterialFilterInput | null > | null,
  not?: ModelPopMaterialFilterInput | null,
};

export type ModelPopMaterialConnection = {
  __typename: "ModelPopMaterialConnection",
  items:  Array<PopMaterial | null >,
  nextToken?: string | null,
};

export type ModelVehicleTypeFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  popMaterialId?: ModelIDInput | null,
  visibleFor?: ModelStringInput | null,
  region?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelVehicleTypeFilterInput | null > | null,
  or?: Array< ModelVehicleTypeFilterInput | null > | null,
  not?: ModelVehicleTypeFilterInput | null,
};

export type ModelVehicleTypeConnection = {
  __typename: "ModelVehicleTypeConnection",
  items:  Array<VehicleType | null >,
  nextToken?: string | null,
};

export type ModelVehicleFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  isSustainable?: ModelBooleanInput | null,
  multiProvider?: ModelBooleanInput | null,
  itemName?: ModelStringInput | null,
  bestSeller?: ModelStringInput | null,
  name?: ModelStringInput | null,
  brand?: ModelStringInput | null,
  channel?: ModelStringInput | null,
  description?: ModelStringInput | null,
  size?: ModelStringInput | null,
  materialDetail?: ModelStringInput | null,
  print?: ModelStringInput | null,
  finish?: ModelStringInput | null,
  packaging?: ModelStringInput | null,
  quantity?: ModelIntInput | null,
  unitPrice?: ModelFloatInput | null,
  prototypePrice?: ModelFloatInput | null,
  productionTime?: ModelStringInput | null,
  vehicleTypeId?: ModelIDInput | null,
  popMaterialId?: ModelIDInput | null,
  popCategoryId?: ModelIDInput | null,
  providerId?: ModelIDInput | null,
  isRfq?: ModelBooleanInput | null,
  historicCost?: ModelStringInput | null,
  historicTime?: ModelStringInput | null,
  contact?: ModelStringInput | null,
  providerName?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  filterColors?: ModelStringInput | null,
  providers?: ModelStringInput | null,
  massiveLayout?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelVehicleFilterInput | null > | null,
  or?: Array< ModelVehicleFilterInput | null > | null,
  not?: ModelVehicleFilterInput | null,
};

export type ModelVehicleConnection = {
  __typename: "ModelVehicleConnection",
  items:  Array<Vehicle | null >,
  nextToken?: string | null,
};

export type ModelPopOrderFilterInput = {
  id?: ModelIDInput | null,
  estatus?: ModelStringInput | null,
  orderId?: ModelIntInput | null,
  requirement?: ModelStringInput | null,
  budget?: ModelFloatInput | null,
  delivery_cost?: ModelFloatInput | null,
  delivery_time?: ModelIntInput | null,
  subtotal?: ModelFloatInput | null,
  total?: ModelFloatInput | null,
  isCoupa?: ModelBooleanInput | null,
  sentToCoupa?: ModelBooleanInput | null,
  coupaOrder?: ModelStringInput | null,
  active?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  orderAgentIds?: ModelStringInput | null,
  gr?: ModelStringInput | null,
  orderCreatorId?: ModelIDInput | null,
  prequoteApproved?: ModelBooleanInput | null,
  quoteApproved?: ModelBooleanInput | null,
  prototypeApproved?: ModelBooleanInput | null,
  samplesDocsUploaded?: ModelBooleanInput | null,
  samplesApproved?: ModelBooleanInput | null,
  auditRequired?: ModelBooleanInput | null,
  drivePath?: ModelStringInput | null,
  auditDocsUploaded?: ModelBooleanInput | null,
  deliveryDateRequested?: ModelBooleanInput | null,
  deliveryDate?: ModelIntInput | null,
  deliveryCode?: ModelStringInput | null,
  deliveryFilesUploaded?: ModelBooleanInput | null,
  deliveryDocsApproved?: ModelBooleanInput | null,
  grUploaded?: ModelBooleanInput | null,
  grApproved?: ModelBooleanInput | null,
  grCode?: ModelStringInput | null,
  qrCode?: ModelBooleanInput | null,
  brandfactoryCheck?: ModelBooleanInput | null,
  step?: ModelIntInput | null,
  prototype?: ModelBooleanInput | null,
  dateKickoff?: ModelIntInput | null,
  paymentDate?: ModelIntInput | null,
  currentProcess?: ModelStringInput | null,
  currentSubprocess?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  and?: Array< ModelPopOrderFilterInput | null > | null,
  or?: Array< ModelPopOrderFilterInput | null > | null,
  not?: ModelPopOrderFilterInput | null,
};

export type ModelPopOrderConnection = {
  __typename: "ModelPopOrderConnection",
  items:  Array<PopOrder | null >,
  nextToken?: string | null,
};

export type ModelOrderFileFilterInput = {
  id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  creatorId?: ModelIDInput | null,
  orderId?: ModelIDInput | null,
  key?: ModelStringInput | null,
  url?: ModelStringInput | null,
  orderStatus?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOrderFileFilterInput | null > | null,
  or?: Array< ModelOrderFileFilterInput | null > | null,
  not?: ModelOrderFileFilterInput | null,
};

export type ModelOrderFileConnection = {
  __typename: "ModelOrderFileConnection",
  items:  Array<OrderFile | null >,
  nextToken?: string | null,
};

export type ModelPopOrderVehicleFilterInput = {
  id?: ModelIDInput | null,
  orderId?: ModelIDInput | null,
  vehicleId?: ModelIDInput | null,
  providerId?: ModelIDInput | null,
  unitPrice?: ModelFloatInput | null,
  prototypePrice?: ModelFloatInput | null,
  quantity?: ModelIntInput | null,
  approved?: ModelBooleanInput | null,
  hasQrCode?: ModelBooleanInput | null,
  sampleTestDate?: ModelIntInput | null,
  sampleTestDateApproved?: ModelBooleanInput | null,
  prototypeDate?: ModelIntInput | null,
  prototypeDateApproved?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPopOrderVehicleFilterInput | null > | null,
  or?: Array< ModelPopOrderVehicleFilterInput | null > | null,
  not?: ModelPopOrderVehicleFilterInput | null,
};

export type ModelPopOrderAuthorizerFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPopOrderAuthorizerFilterInput | null > | null,
  or?: Array< ModelPopOrderAuthorizerFilterInput | null > | null,
  not?: ModelPopOrderAuthorizerFilterInput | null,
};

export type ModelPopOrderAuthorizerConnection = {
  __typename: "ModelPopOrderAuthorizerConnection",
  items:  Array<PopOrderAuthorizer | null >,
  nextToken?: string | null,
};

export type ModelPopOrderProviderFilterInput = {
  id?: ModelIDInput | null,
  orderId?: ModelIDInput | null,
  providerId?: ModelIDInput | null,
  deliveryDateRequested?: ModelBooleanInput | null,
  grRequested?: ModelBooleanInput | null,
  invoiceUploaded?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPopOrderProviderFilterInput | null > | null,
  or?: Array< ModelPopOrderProviderFilterInput | null > | null,
  not?: ModelPopOrderProviderFilterInput | null,
};

export type ModelPopOrderLogFilterInput = {
  id?: ModelIDInput | null,
  orderId?: ModelIDInput | null,
  creatorId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  text?: ModelStringInput | null,
  orderStatus?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPopOrderLogFilterInput | null > | null,
  or?: Array< ModelPopOrderLogFilterInput | null > | null,
  not?: ModelPopOrderLogFilterInput | null,
};

export type ModelPopOrderLogConnection = {
  __typename: "ModelPopOrderLogConnection",
  items:  Array<PopOrderLog | null >,
  nextToken?: string | null,
};

export type ModelRfqPopFilterInput = {
  id?: ModelIDInput | null,
  nombre?: ModelStringInput | null,
  requerimiento?: ModelStringInput | null,
  vehicleTypeId?: ModelIDInput | null,
  popMaterialId?: ModelIDInput | null,
  cantidad?: ModelIntInput | null,
  limit_time?: ModelIntInput | null,
  creator?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  orderAgentIds?: ModelStringInput | null,
  popOrderId?: ModelStringInput | null,
  orderId?: ModelIntInput | null,
  estatus?: ModelStringInput | null,
  start_time?: ModelIntInput | null,
  delivery_time?: ModelIntInput | null,
  saving?: ModelFloatInput | null,
  saving_percentage?: ModelFloatInput | null,
  saving_real?: ModelFloatInput | null,
  budget?: ModelFloatInput | null,
  hasQrCode?: ModelBooleanInput | null,
  created?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updated?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelRfqPopFilterInput | null > | null,
  or?: Array< ModelRfqPopFilterInput | null > | null,
  not?: ModelRfqPopFilterInput | null,
};

export type ModelRfqPopConnection = {
  __typename: "ModelRfqPopConnection",
  items:  Array<RfqPop | null >,
  nextToken?: string | null,
};

export type ModelProposalsPopFilterInput = {
  id?: ModelIDInput | null,
  provider_id?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  created?: ModelIntInput | null,
  validity_days?: ModelIntInput | null,
  description?: ModelStringInput | null,
  updated?: ModelIntInput | null,
  proposalsPopRfqId?: ModelIDInput | null,
  prototypePrice?: ModelFloatInput | null,
  hidden?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProposalsPopFilterInput | null > | null,
  or?: Array< ModelProposalsPopFilterInput | null > | null,
  not?: ModelProposalsPopFilterInput | null,
};

export type ModelUsersBrandsFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  status?: ModelStringInput | null,
  clientId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUsersBrandsFilterInput | null > | null,
  or?: Array< ModelUsersBrandsFilterInput | null > | null,
  not?: ModelUsersBrandsFilterInput | null,
};

export type ModelUsersBrandsConnection = {
  __typename: "ModelUsersBrandsConnection",
  items:  Array<UsersBrands | null >,
  nextToken?: string | null,
};

export type ModelUserBrandSettingFilterInput = {
  id?: ModelIDInput | null,
  categories?: ModelStringInput | null,
  subcategories?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserBrandSettingFilterInput | null > | null,
  or?: Array< ModelUserBrandSettingFilterInput | null > | null,
  not?: ModelUserBrandSettingFilterInput | null,
};

export type ModelUserBrandSettingConnection = {
  __typename: "ModelUserBrandSettingConnection",
  items:  Array<UserBrandSetting | null >,
  nextToken?: string | null,
};

export type ModelLogsPUsersFilterInput = {
  id?: ModelIDInput | null,
  user?: ModelStringInput | null,
  keyword?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLogsPUsersFilterInput | null > | null,
  or?: Array< ModelLogsPUsersFilterInput | null > | null,
  not?: ModelLogsPUsersFilterInput | null,
};

export type ModelLogsPUsersConnection = {
  __typename: "ModelLogsPUsersConnection",
  items:  Array<LogsPUsers | null >,
  nextToken?: string | null,
};

export type ModelClipPaymentFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  requestsCount?: ModelIntInput | null,
  payment_request_id?: ModelStringInput | null,
  purchase_description?: ModelStringInput | null,
  orderId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelClipPaymentFilterInput | null > | null,
  or?: Array< ModelClipPaymentFilterInput | null > | null,
  not?: ModelClipPaymentFilterInput | null,
};

export type ModelClipPaymentConnection = {
  __typename: "ModelClipPaymentConnection",
  items:  Array<ClipPayment | null >,
  nextToken?: string | null,
};

export type ModelOrderProcessFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelStringInput | null,
  status?: ModelBooleanInput | null,
  tcdPayment?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  duration?: ModelStringInput | null,
  descripcion?: ModelStringInput | null,
  position?: ModelIntInput | null,
  responsible?: ModelIntInput | null,
  clientId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOrderProcessFilterInput | null > | null,
  or?: Array< ModelOrderProcessFilterInput | null > | null,
  not?: ModelOrderProcessFilterInput | null,
};

export type ModelOrderProcessConnection = {
  __typename: "ModelOrderProcessConnection",
  items:  Array<OrderProcess | null >,
  nextToken?: string | null,
};

export type ModelOrderSubprocessFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelStringInput | null,
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  position?: ModelIntInput | null,
  descripcion?: ModelStringInput | null,
  action?: ModelIntInput | null,
  processId?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOrderSubprocessFilterInput | null > | null,
  or?: Array< ModelOrderSubprocessFilterInput | null > | null,
  not?: ModelOrderSubprocessFilterInput | null,
};

export type ModelPremiumOrderFilterInput = {
  id?: ModelIDInput | null,
  requirement?: ModelStringInput | null,
  bank_reference?: ModelStringInput | null,
  hasVat?: ModelBooleanInput | null,
  orderId?: ModelIntInput | null,
  delivery_cost?: ModelFloatInput | null,
  delivery_fee?: ModelFloatInput | null,
  delivery_discount?: ModelFloatInput | null,
  delivery_time?: ModelIntInput | null,
  delivery_date?: ModelStringInput | null,
  clipUrl?: ModelStringInput | null,
  clipStatus?: ModelStringInput | null,
  orderCreatorId?: ModelStringInput | null,
  orderAgentIds?: ModelStringInput | null,
  premiumOrderClientId?: ModelIDInput | null,
  userBrandId?: ModelIDInput | null,
  subtotal?: ModelFloatInput | null,
  fee?: ModelFloatInput | null,
  printedPrice?: ModelFloatInput | null,
  total?: ModelFloatInput | null,
  discountAmount?: ModelFloatInput | null,
  syncWithCrm?: ModelBooleanInput | null,
  crmIssueKey?: ModelStringInput | null,
  sentToAlendum?: ModelBooleanInput | null,
  alendumProjectId?: ModelStringInput | null,
  syncWithFms?: ModelStringInput | null,
  fmsInvoiceId?: ModelStringInput | null,
  syncWithWms?: ModelBooleanInput | null,
  wmsProjectId?: ModelStringInput | null,
  isCoupa?: ModelBooleanInput | null,
  sentToCoupa?: ModelBooleanInput | null,
  isRfq?: ModelBooleanInput | null,
  requireSamples?: ModelBooleanInput | null,
  requestedSamples?: ModelBooleanInput | null,
  approvedSamples?: ModelBooleanInput | null,
  authorizedQA?: ModelBooleanInput | null,
  active?: ModelStringInput | null,
  currentProcess?: ModelStringInput | null,
  currentSubprocess?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPremiumOrderFilterInput | null > | null,
  or?: Array< ModelPremiumOrderFilterInput | null > | null,
  not?: ModelPremiumOrderFilterInput | null,
};

export type ModelPremiumOrderConnection = {
  __typename: "ModelPremiumOrderConnection",
  items:  Array<PremiumOrder | null >,
  nextToken?: string | null,
};

export type ModelPrintedCartFilterInput = {
  id?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPrintedCartFilterInput | null > | null,
  or?: Array< ModelPrintedCartFilterInput | null > | null,
  not?: ModelPrintedCartFilterInput | null,
};

export type ModelPrintedCartConnection = {
  __typename: "ModelPrintedCartConnection",
  items:  Array<PrintedCart | null >,
  nextToken?: string | null,
};

export type ModelPrintedCategoryFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  route?: ModelStringInput | null,
  created?: ModelIntInput | null,
  visibleFor?: ModelStringInput | null,
  region?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPrintedCategoryFilterInput | null > | null,
  or?: Array< ModelPrintedCategoryFilterInput | null > | null,
  not?: ModelPrintedCategoryFilterInput | null,
};

export type ModelPrintedCategoryConnection = {
  __typename: "ModelPrintedCategoryConnection",
  items:  Array<PrintedCategory | null >,
  nextToken?: string | null,
};

export type ModelPrintedSubcategoryFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  printedCategoryId?: ModelIDInput | null,
  created?: ModelIntInput | null,
  visibleFor?: ModelStringInput | null,
  region?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPrintedSubcategoryFilterInput | null > | null,
  or?: Array< ModelPrintedSubcategoryFilterInput | null > | null,
  not?: ModelPrintedSubcategoryFilterInput | null,
};

export type ModelPrintedProductsFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  position?: ModelStringInput | null,
  name?: ModelStringInput | null,
  width?: ModelFloatInput | null,
  height?: ModelFloatInput | null,
  price?: ModelFloatInput | null,
  long_description?: ModelStringInput | null,
  short_description?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  providerId?: ModelIDInput | null,
  finalDimensions?: ModelFloatInput | null,
  pagesNumber?: ModelIntInput | null,
  finishes?: ModelStringInput | null,
  inksFourByCero?: ModelStringInput | null,
  inksFourByFour?: ModelStringInput | null,
  paperKind?: ModelStringInput | null,
  grammage?: ModelStringInput | null,
  hasBarniz?: ModelBooleanInput | null,
  hasRebase?: ModelBooleanInput | null,
  orientation?: ModelStringInput | null,
  specialInstructions?: ModelStringInput | null,
  PrintedSubcategoryId?: ModelIDInput | null,
  printedCategoryId?: ModelIDInput | null,
  created?: ModelIntInput | null,
  visibleFor?: ModelStringInput | null,
  filterColors?: ModelStringInput | null,
  regions?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPrintedProductsFilterInput | null > | null,
  or?: Array< ModelPrintedProductsFilterInput | null > | null,
  not?: ModelPrintedProductsFilterInput | null,
};

export type ModelPrintedRfqFilterInput = {
  id?: ModelIDInput | null,
  nombre?: ModelStringInput | null,
  requerimiento?: ModelStringInput | null,
  limit_time?: ModelIntInput | null,
  creator?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  estatus?: ModelStringInput | null,
  printedOrderId?: ModelIntInput | null,
  start_time?: ModelIntInput | null,
  delivery_time?: ModelIntInput | null,
  created?: ModelIntInput | null,
  saving?: ModelFloatInput | null,
  saving_percentage?: ModelFloatInput | null,
  saving_real?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  updated?: ModelIntInput | null,
  and?: Array< ModelPrintedRfqFilterInput | null > | null,
  or?: Array< ModelPrintedRfqFilterInput | null > | null,
  not?: ModelPrintedRfqFilterInput | null,
};

export type ModelPrintedRfqConnection = {
  __typename: "ModelPrintedRfqConnection",
  items:  Array<PrintedRfq | null >,
  nextToken?: string | null,
};

export type ModelPrintedProductoRfqFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  category_id?: ModelIDInput | null,
  provider_id?: ModelIDInput | null,
  price?: ModelFloatInput | null,
  category?: ModelStringInput | null,
  estatus?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPrintedProductoRfqFilterInput | null > | null,
  or?: Array< ModelPrintedProductoRfqFilterInput | null > | null,
  not?: ModelPrintedProductoRfqFilterInput | null,
};

export type ModelPrintedProductoRfqConnection = {
  __typename: "ModelPrintedProductoRfqConnection",
  items:  Array<PrintedProductoRfq | null >,
  nextToken?: string | null,
};

export type ModelPrintedProposalFilterInput = {
  id?: ModelIDInput | null,
  provider_id?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  validity_days?: ModelIntInput | null,
  description?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  hidden?: ModelBooleanInput | null,
  printedProposalRfqId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPrintedProposalFilterInput | null > | null,
  or?: Array< ModelPrintedProposalFilterInput | null > | null,
  not?: ModelPrintedProposalFilterInput | null,
};

export type ModelPrintedOrderFilterInput = {
  id?: ModelIDInput | null,
  orderId?: ModelIntInput | null,
  delivery_cost?: ModelFloatInput | null,
  delivery_time?: ModelIntInput | null,
  listProvidersKey?: ModelStringInput | null,
  orderAgentIds?: ModelStringInput | null,
  orderCreatorId?: ModelStringInput | null,
  printedOrderClientId?: ModelIDInput | null,
  subtotal?: ModelFloatInput | null,
  total?: ModelFloatInput | null,
  isCoupa?: ModelBooleanInput | null,
  sentToCoupa?: ModelBooleanInput | null,
  isRfq?: ModelBooleanInput | null,
  status?: ModelStringInput | null,
  currentProcess?: ModelStringInput | null,
  currentSubprocess?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPrintedOrderFilterInput | null > | null,
  or?: Array< ModelPrintedOrderFilterInput | null > | null,
  not?: ModelPrintedOrderFilterInput | null,
};

export type ModelPrintedOrderConnection = {
  __typename: "ModelPrintedOrderConnection",
  items:  Array<PrintedOrder | null >,
  nextToken?: string | null,
};

export type ModelPrintedOrderProvidersFilterInput = {
  id?: ModelIDInput | null,
  provider_id?: ModelStringInput | null,
  orderId?: ModelIntInput | null,
  printedOrderProvidersPrintedOrderId?: ModelIDInput | null,
  payment_date?: ModelIntInput | null,
  gr_code?: ModelStringInput | null,
  invoice?: ModelBooleanInput | null,
  invoiceRequested?: ModelBooleanInput | null,
  uploadedGr?: ModelBooleanInput | null,
  uploadedBill?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPrintedOrderProvidersFilterInput | null > | null,
  or?: Array< ModelPrintedOrderProvidersFilterInput | null > | null,
  not?: ModelPrintedOrderProvidersFilterInput | null,
};

export type ModelPrintedOrderProvidersConnection = {
  __typename: "ModelPrintedOrderProvidersConnection",
  items:  Array<PrintedOrderProviders | null >,
  nextToken?: string | null,
};

export type ModelPayOnBehalfRequestsFilterInput = {
  id?: ModelIDInput | null,
  clientId?: ModelStringInput | null,
  companyName?: ModelStringInput | null,
  purchaseOrder?: ModelStringInput | null,
  paymentTerms?: ModelStringInput | null,
  currency?: ModelStringInput | null,
  amount?: ModelFloatInput | null,
  selectedVa?: ModelBooleanInput | null,
  iva?: ModelFloatInput | null,
  vat?: ModelFloatInput | null,
  total?: ModelFloatInput | null,
  created?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPayOnBehalfRequestsFilterInput | null > | null,
  or?: Array< ModelPayOnBehalfRequestsFilterInput | null > | null,
  not?: ModelPayOnBehalfRequestsFilterInput | null,
};

export type ModelPayOnBehalfRequestsConnection = {
  __typename: "ModelPayOnBehalfRequestsConnection",
  items:  Array<PayOnBehalfRequests | null >,
  nextToken?: string | null,
};

export type ModelBuyerContactClientFilterInput = {
  id?: ModelIDInput | null,
  companyId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  defaultContact?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBuyerContactClientFilterInput | null > | null,
  or?: Array< ModelBuyerContactClientFilterInput | null > | null,
  not?: ModelBuyerContactClientFilterInput | null,
};

export type ModelBuyerContactClientConnection = {
  __typename: "ModelBuyerContactClientConnection",
  items:  Array<BuyerContactClient | null >,
  nextToken?: string | null,
};

export type ModelBrandFactoryRfqEmailsFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  created?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBrandFactoryRfqEmailsFilterInput | null > | null,
  or?: Array< ModelBrandFactoryRfqEmailsFilterInput | null > | null,
  not?: ModelBrandFactoryRfqEmailsFilterInput | null,
};

export type ModelBrandFactoryRfqEmailsConnection = {
  __typename: "ModelBrandFactoryRfqEmailsConnection",
  items:  Array<BrandFactoryRfqEmails | null >,
  nextToken?: string | null,
};

export type ModelAutomobilesEmailsFilterInput = {
  id?: ModelIDInput | null,
  companyId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  created?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAutomobilesEmailsFilterInput | null > | null,
  or?: Array< ModelAutomobilesEmailsFilterInput | null > | null,
  not?: ModelAutomobilesEmailsFilterInput | null,
};

export type ModelAutomobilesEmailsConnection = {
  __typename: "ModelAutomobilesEmailsConnection",
  items:  Array<AutomobilesEmails | null >,
  nextToken?: string | null,
};

export type ModelQAEmailsFilterInput = {
  id?: ModelIDInput | null,
  companyId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  created?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelQAEmailsFilterInput | null > | null,
  or?: Array< ModelQAEmailsFilterInput | null > | null,
  not?: ModelQAEmailsFilterInput | null,
};

export type ModelQAEmailsConnection = {
  __typename: "ModelQAEmailsConnection",
  items:  Array<QAEmails | null >,
  nextToken?: string | null,
};

export type ModelOrderPopAdminEmailsFilterInput = {
  id?: ModelIDInput | null,
  companyId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  created?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOrderPopAdminEmailsFilterInput | null > | null,
  or?: Array< ModelOrderPopAdminEmailsFilterInput | null > | null,
  not?: ModelOrderPopAdminEmailsFilterInput | null,
};

export type ModelOrderPopAdminEmailsConnection = {
  __typename: "ModelOrderPopAdminEmailsConnection",
  items:  Array<OrderPopAdminEmails | null >,
  nextToken?: string | null,
};

export type ModelOrderPopCheckoutEmailsFilterInput = {
  id?: ModelIDInput | null,
  companyId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  created?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelOrderPopCheckoutEmailsFilterInput | null > | null,
  or?: Array< ModelOrderPopCheckoutEmailsFilterInput | null > | null,
  not?: ModelOrderPopCheckoutEmailsFilterInput | null,
};

export type ModelOrderPopCheckoutEmailsConnection = {
  __typename: "ModelOrderPopCheckoutEmailsConnection",
  items:  Array<OrderPopCheckoutEmails | null >,
  nextToken?: string | null,
};

export type ModelGREmailsFilterInput = {
  id?: ModelIDInput | null,
  companyId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  created?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelGREmailsFilterInput | null > | null,
  or?: Array< ModelGREmailsFilterInput | null > | null,
  not?: ModelGREmailsFilterInput | null,
};

export type ModelGREmailsConnection = {
  __typename: "ModelGREmailsConnection",
  items:  Array<GREmails | null >,
  nextToken?: string | null,
};

export type ModelRegionsFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelRegionsFilterInput | null > | null,
  or?: Array< ModelRegionsFilterInput | null > | null,
  not?: ModelRegionsFilterInput | null,
};

export type ModelRegionsConnection = {
  __typename: "ModelRegionsConnection",
  items:  Array<Regions | null >,
  nextToken?: string | null,
};

export type ModelDefaultAddressFilterInput = {
  id?: ModelIDInput | null,
  companyId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDefaultAddressFilterInput | null > | null,
  or?: Array< ModelDefaultAddressFilterInput | null > | null,
  not?: ModelDefaultAddressFilterInput | null,
};

export type ModelDefaultAddressConnection = {
  __typename: "ModelDefaultAddressConnection",
  items:  Array<DefaultAddress | null >,
  nextToken?: string | null,
};

export type ModelDefaultDeliveryContactFilterInput = {
  id?: ModelIDInput | null,
  companyId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  status?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDefaultDeliveryContactFilterInput | null > | null,
  or?: Array< ModelDefaultDeliveryContactFilterInput | null > | null,
  not?: ModelDefaultDeliveryContactFilterInput | null,
};

export type ModelDefaultDeliveryContactConnection = {
  __typename: "ModelDefaultDeliveryContactConnection",
  items:  Array<DefaultDeliveryContact | null >,
  nextToken?: string | null,
};

export type ModelPopCategoriesFilterInput = {
  id?: ModelIDInput | null,
  materialId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  created?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPopCategoriesFilterInput | null > | null,
  or?: Array< ModelPopCategoriesFilterInput | null > | null,
  not?: ModelPopCategoriesFilterInput | null,
};

export type ModelPopCategoriesConnection = {
  __typename: "ModelPopCategoriesConnection",
  items:  Array<PopCategories | null >,
  nextToken?: string | null,
};

export type ModelRfpFilterInput = {
  id?: ModelIDInput | null,
  clientId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  nombre?: ModelStringInput | null,
  requerimiento?: ModelStringInput | null,
  estatus?: ModelStringInput | null,
  descripcion?: ModelStringInput | null,
  url?: ModelStringInput | null,
  limit_time?: ModelIntInput | null,
  creator?: ModelStringInput | null,
  start_time?: ModelIntInput | null,
  delivery_time?: ModelIntInput | null,
  saving?: ModelFloatInput | null,
  saving_percentage?: ModelFloatInput | null,
  saving_real?: ModelFloatInput | null,
  created?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updated?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelRfpFilterInput | null > | null,
  or?: Array< ModelRfpFilterInput | null > | null,
  not?: ModelRfpFilterInput | null,
};

export type ModelRfpConnection = {
  __typename: "ModelRfpConnection",
  items:  Array<Rfp | null >,
  nextToken?: string | null,
};

export type ModelRfpProposalsFilterInput = {
  id?: ModelIDInput | null,
  provider_id?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  validity_days?: ModelIntInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  multipleProducts?: ModelBooleanInput | null,
  hidden?: ModelBooleanInput | null,
  rfpProposalsRfpId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelRfpProposalsFilterInput | null > | null,
  or?: Array< ModelRfpProposalsFilterInput | null > | null,
  not?: ModelRfpProposalsFilterInput | null,
};

export type ModelEvaluationProvidersFilterInput = {
  id?: ModelIDInput | null,
  providerId?: ModelIDInput | null,
  creratorId?: ModelIDInput | null,
  orderId?: ModelIDInput | null,
  time?: ModelFloatInput | null,
  price?: ModelFloatInput | null,
  quality?: ModelFloatInput | null,
  att?: ModelFloatInput | null,
  comments?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEvaluationProvidersFilterInput | null > | null,
  or?: Array< ModelEvaluationProvidersFilterInput | null > | null,
  not?: ModelEvaluationProvidersFilterInput | null,
};

export type ModelEvaluationProvidersConnection = {
  __typename: "ModelEvaluationProvidersConnection",
  items:  Array<EvaluationProviders | null >,
  nextToken?: string | null,
};

export type ModelLogProductFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  created?: ModelStringInput | null,
  productId?: ModelIDInput | null,
  description?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLogProductFilterInput | null > | null,
  or?: Array< ModelLogProductFilterInput | null > | null,
  not?: ModelLogProductFilterInput | null,
};

export type ModelLogProductConnection = {
  __typename: "ModelLogProductConnection",
  items:  Array<LogProduct | null >,
  nextToken?: string | null,
};

export type ModelLogRfqFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  rfqId?: ModelIDInput | null,
  description?: ModelStringInput | null,
  provider_id?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLogRfqFilterInput | null > | null,
  or?: Array< ModelLogRfqFilterInput | null > | null,
  not?: ModelLogRfqFilterInput | null,
};

export type ModelLogRfqConnection = {
  __typename: "ModelLogRfqConnection",
  items:  Array<LogRfq | null >,
  nextToken?: string | null,
};

export type ModelLogProductLabelFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  created?: ModelStringInput | null,
  productLabelId?: ModelIDInput | null,
  description?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLogProductLabelFilterInput | null > | null,
  or?: Array< ModelLogProductLabelFilterInput | null > | null,
  not?: ModelLogProductLabelFilterInput | null,
};

export type ModelLogProductLabelConnection = {
  __typename: "ModelLogProductLabelConnection",
  items:  Array<LogProductLabel | null >,
  nextToken?: string | null,
};

export type ModelLogGanadorAutoFilterInput = {
  id?: ModelIDInput | null,
  id_auto?: ModelIDInput | null,
  id_user?: ModelIDInput | null,
  fecha_rifa?: ModelIntInput | null,
  email?: ModelStringInput | null,
  nombre?: ModelStringInput | null,
  a_paterno?: ModelStringInput | null,
  a_materno?: ModelStringInput | null,
  status_buyer?: ModelBooleanInput | null,
  date_buyer?: ModelIntInput | null,
  winner?: ModelIntInput | null,
  refused?: ModelIntInput | null,
  since?: ModelStringInput | null,
  process_buyer?: ModelBooleanInput | null,
  reactive?: ModelBooleanInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLogGanadorAutoFilterInput | null > | null,
  or?: Array< ModelLogGanadorAutoFilterInput | null > | null,
  not?: ModelLogGanadorAutoFilterInput | null,
};

export type ModelNotificationFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelStringInput | null,
  remember?: ModelStringInput | null,
  stared?: ModelStringInput | null,
  important?: ModelStringInput | null,
  status?: ModelStringInput | null,
  isChat?: ModelStringInput | null,
  creatorName?: ModelStringInput | null,
  creatorEmail?: ModelStringInput | null,
  creatorRole?: ModelStringInput | null,
  creatorId?: ModelIDInput | null,
  receipentName?: ModelStringInput | null,
  receipentRole?: ModelStringInput | null,
  receipentEmail?: ModelStringInput | null,
  receipentId?: ModelIDInput | null,
  showPopUp?: ModelBooleanInput | null,
  sendEmail?: ModelBooleanInput | null,
  title?: ModelStringInput | null,
  subtitle?: ModelStringInput | null,
  description?: ModelStringInput | null,
  path?: ModelStringInput | null,
  idParent?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  seenAt?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelNotificationFilterInput | null > | null,
  or?: Array< ModelNotificationFilterInput | null > | null,
  not?: ModelNotificationFilterInput | null,
};

export type ModelNotificationConnection = {
  __typename: "ModelNotificationConnection",
  items:  Array<Notification | null >,
  nextToken?: string | null,
};

export type ModelMercadoCategoriesFilterInput = {
  id?: ModelIDInput | null,
  idMercado?: ModelStringInput | null,
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  parentCategory?: ModelStringInput | null,
  childrenCategories?: ModelStringInput | null,
  items?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMercadoCategoriesFilterInput | null > | null,
  or?: Array< ModelMercadoCategoriesFilterInput | null > | null,
  not?: ModelMercadoCategoriesFilterInput | null,
};

export type ModelMercadoCategoriesConnection = {
  __typename: "ModelMercadoCategoriesConnection",
  items:  Array<MercadoCategories | null >,
  nextToken?: string | null,
};

export type ModelMercadoProductCategoryClientFilterInput = {
  id?: ModelIDInput | null,
  idClient?: ModelIDInput | null,
  idMercadoCategory?: ModelIDInput | null,
  unrestrictedProducts?: ModelStringInput | null,
  restrictedProducts?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMercadoProductCategoryClientFilterInput | null > | null,
  or?: Array< ModelMercadoProductCategoryClientFilterInput | null > | null,
  not?: ModelMercadoProductCategoryClientFilterInput | null,
};

export type ModelMercadoProductCategoryClientConnection = {
  __typename: "ModelMercadoProductCategoryClientConnection",
  items:  Array<MercadoProductCategoryClient | null >,
  nextToken?: string | null,
};

export type ModelExternalApisFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  nameExternal?: ModelStringInput | null,
  region?: ModelStringInput | null,
  increment?: ModelFloatInput | null,
  discount?: ModelFloatInput | null,
  visibleFor?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelExternalApisFilterInput | null > | null,
  or?: Array< ModelExternalApisFilterInput | null > | null,
  not?: ModelExternalApisFilterInput | null,
};

export type ModelExternalApisConnection = {
  __typename: "ModelExternalApisConnection",
  items:  Array<ExternalApis | null >,
  nextToken?: string | null,
};

export type ModelPrintPricesFilterInput = {
  id?: ModelIDInput | null,
  identifier?: ModelIntInput | null,
  status?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  description?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  minUnits?: ModelIntInput | null,
  maxUnits?: ModelIntInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPrintPricesFilterInput | null > | null,
  or?: Array< ModelPrintPricesFilterInput | null > | null,
  not?: ModelPrintPricesFilterInput | null,
};

export type ModelPrintPricesConnection = {
  __typename: "ModelPrintPricesConnection",
  items:  Array<PrintPrices | null >,
  nextToken?: string | null,
};

export type ModelPrintLogosFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  description?: ModelStringInput | null,
  identifier?: ModelIntInput | null,
  clientId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPrintLogosFilterInput | null > | null,
  or?: Array< ModelPrintLogosFilterInput | null > | null,
  not?: ModelPrintLogosFilterInput | null,
};

export type ModelPrintLogosConnection = {
  __typename: "ModelPrintLogosConnection",
  items:  Array<PrintLogos | null >,
  nextToken?: string | null,
};

export type ModelLogisticPostalCodeFilterInput = {
  id?: ModelIDInput | null,
  cpFrom?: ModelStringInput | null,
  cpTo?: ModelStringInput | null,
  zone?: ModelIntInput | null,
  state?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLogisticPostalCodeFilterInput | null > | null,
  or?: Array< ModelLogisticPostalCodeFilterInput | null > | null,
  not?: ModelLogisticPostalCodeFilterInput | null,
};

export type ModelLogisticPostalCodeConnection = {
  __typename: "ModelLogisticPostalCodeConnection",
  items:  Array<LogisticPostalCode | null >,
  nextToken?: string | null,
};

export type ModelLogisticPieceRangeFilterInput = {
  id?: ModelIDInput | null,
  piecesRange?: ModelIntInput | null,
  min?: ModelIntInput | null,
  max?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLogisticPieceRangeFilterInput | null > | null,
  or?: Array< ModelLogisticPieceRangeFilterInput | null > | null,
  not?: ModelLogisticPieceRangeFilterInput | null,
};

export type ModelLogisticPieceRangeConnection = {
  __typename: "ModelLogisticPieceRangeConnection",
  items:  Array<LogisticPieceRange | null >,
  nextToken?: string | null,
};

export type ModelLogisticWeightRangeFilterInput = {
  id?: ModelIDInput | null,
  weightRange?: ModelIntInput | null,
  min?: ModelIntInput | null,
  max?: ModelIntInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLogisticWeightRangeFilterInput | null > | null,
  or?: Array< ModelLogisticWeightRangeFilterInput | null > | null,
  not?: ModelLogisticWeightRangeFilterInput | null,
};

export type ModelLogisticWeightRangeConnection = {
  __typename: "ModelLogisticWeightRangeConnection",
  items:  Array<LogisticWeightRange | null >,
  nextToken?: string | null,
};

export type ModelLogisticWeightBoxFilterInput = {
  id?: ModelIDInput | null,
  boxId?: ModelIDInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLogisticWeightBoxFilterInput | null > | null,
  or?: Array< ModelLogisticWeightBoxFilterInput | null > | null,
  not?: ModelLogisticWeightBoxFilterInput | null,
};

export type ModelLogisticWeightBoxConnection = {
  __typename: "ModelLogisticWeightBoxConnection",
  items:  Array<LogisticWeightBox | null >,
  nextToken?: string | null,
};

export type ModelLogisticZoneFilterInput = {
  id?: ModelIDInput | null,
  zoneName?: ModelStringInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLogisticZoneFilterInput | null > | null,
  or?: Array< ModelLogisticZoneFilterInput | null > | null,
  not?: ModelLogisticZoneFilterInput | null,
};

export type ModelLogisticZoneConnection = {
  __typename: "ModelLogisticZoneConnection",
  items:  Array<LogisticZone | null >,
  nextToken?: string | null,
};

export type ModelLogisticBoxFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  width?: ModelFloatInput | null,
  height?: ModelFloatInput | null,
  depth?: ModelFloatInput | null,
  volumetricWeight?: ModelFloatInput | null,
  maxWeight?: ModelFloatInput | null,
  maxPayload?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLogisticBoxFilterInput | null > | null,
  or?: Array< ModelLogisticBoxFilterInput | null > | null,
  not?: ModelLogisticBoxFilterInput | null,
};

export type ModelLogisticBoxConnection = {
  __typename: "ModelLogisticBoxConnection",
  items:  Array<LogisticBox | null >,
  nextToken?: string | null,
};

export type ModelLogisticVehiclesFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  licensePlate?: ModelStringInput | null,
  hasInsurancePolicy?: ModelStringInput | null,
  fuelCapacity?: ModelFloatInput | null,
  width?: ModelFloatInput | null,
  height?: ModelFloatInput | null,
  depth?: ModelFloatInput | null,
  maxWeight?: ModelFloatInput | null,
  created?: ModelIntInput | null,
  updated?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLogisticVehiclesFilterInput | null > | null,
  or?: Array< ModelLogisticVehiclesFilterInput | null > | null,
  not?: ModelLogisticVehiclesFilterInput | null,
};

export type ModelLogisticVehiclesConnection = {
  __typename: "ModelLogisticVehiclesConnection",
  items:  Array<LogisticVehicles | null >,
  nextToken?: string | null,
};

export type ModelPakmailCarrierFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  identifier?: ModelIntInput | null,
  visibleFor?: ModelStringInput | null,
  region?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPakmailCarrierFilterInput | null > | null,
  or?: Array< ModelPakmailCarrierFilterInput | null > | null,
  not?: ModelPakmailCarrierFilterInput | null,
};

export type ModelPakmailCarrierConnection = {
  __typename: "ModelPakmailCarrierConnection",
  items:  Array<PakmailCarrier | null >,
  nextToken?: string | null,
};

export type ModelPakmailServiceFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  identifier?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  region?: ModelStringInput | null,
  isNational?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPakmailServiceFilterInput | null > | null,
  or?: Array< ModelPakmailServiceFilterInput | null > | null,
  not?: ModelPakmailServiceFilterInput | null,
};

export type ModelPakmailServiceConnection = {
  __typename: "ModelPakmailServiceConnection",
  items:  Array<PakmailService | null >,
  nextToken?: string | null,
};

export type ModelPakmailShipmentStatusFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  identifier?: ModelIntInput | null,
  visibleFor?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPakmailShipmentStatusFilterInput | null > | null,
  or?: Array< ModelPakmailShipmentStatusFilterInput | null > | null,
  not?: ModelPakmailShipmentStatusFilterInput | null,
};

export type ModelPakmailShipmentStatusConnection = {
  __typename: "ModelPakmailShipmentStatusConnection",
  items:  Array<PakmailShipmentStatus | null >,
  nextToken?: string | null,
};

export type ModelPakmailShipmentEventFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  identifier?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  color?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPakmailShipmentEventFilterInput | null > | null,
  or?: Array< ModelPakmailShipmentEventFilterInput | null > | null,
  not?: ModelPakmailShipmentEventFilterInput | null,
};

export type ModelPakmailShipmentEventConnection = {
  __typename: "ModelPakmailShipmentEventConnection",
  items:  Array<PakmailShipmentEvent | null >,
  nextToken?: string | null,
};

export type ModelPakmailPickupStatusFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  identifier?: ModelIntInput | null,
  visibleFor?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPakmailPickupStatusFilterInput | null > | null,
  or?: Array< ModelPakmailPickupStatusFilterInput | null > | null,
  not?: ModelPakmailPickupStatusFilterInput | null,
};

export type ModelPakmailPickupStatusConnection = {
  __typename: "ModelPakmailPickupStatusConnection",
  items:  Array<PakmailPickupStatus | null >,
  nextToken?: string | null,
};

export type ModelPremiumOrderLogisticGuideFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelLogisticGuideTypeInput | null,
  pakmailId?: ModelStringInput | null,
  premiumOrderId?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  creatorId?: ModelStringInput | null,
  originAddressId?: ModelStringInput | null,
  destinationAddressId?: ModelStringInput | null,
  originAddress?: ModelStringInput | null,
  destinationAddress?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  increment?: ModelFloatInput | null,
  fee?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPremiumOrderLogisticGuideFilterInput | null > | null,
  or?: Array< ModelPremiumOrderLogisticGuideFilterInput | null > | null,
  not?: ModelPremiumOrderLogisticGuideFilterInput | null,
};

export type ModelPremiumOrderLogisticGuideConnection = {
  __typename: "ModelPremiumOrderLogisticGuideConnection",
  items:  Array<PremiumOrderLogisticGuide | null >,
  nextToken?: string | null,
};

export type ModelProductLabelItemFilterInput = {
  id?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  productLabelId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProductLabelItemFilterInput | null > | null,
  or?: Array< ModelProductLabelItemFilterInput | null > | null,
  not?: ModelProductLabelItemFilterInput | null,
};

export type ModelProductLabelItemConnection = {
  __typename: "ModelProductLabelItemConnection",
  items:  Array<ProductLabelItem | null >,
  nextToken?: string | null,
};

export type ModelProductLabelFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  translation?: ModelStringInput | null,
  status?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProductLabelFilterInput | null > | null,
  or?: Array< ModelProductLabelFilterInput | null > | null,
  not?: ModelProductLabelFilterInput | null,
};

export type ModelProductLabelConnection = {
  __typename: "ModelProductLabelConnection",
  items:  Array<ProductLabel | null >,
  nextToken?: string | null,
};

export type ModelProductTextItemFilterInput = {
  id?: ModelIDInput | null,
  productId?: ModelIDInput | null,
  productTextId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProductTextItemFilterInput | null > | null,
  or?: Array< ModelProductTextItemFilterInput | null > | null,
  not?: ModelProductTextItemFilterInput | null,
};

export type ModelProductTextItemConnection = {
  __typename: "ModelProductTextItemConnection",
  items:  Array<ProductTextItem | null >,
  nextToken?: string | null,
};

export type ModelProductTextFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  visibleFor?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProductTextFilterInput | null > | null,
  or?: Array< ModelProductTextFilterInput | null > | null,
  not?: ModelProductTextFilterInput | null,
};

export type ModelProductTextConnection = {
  __typename: "ModelProductTextConnection",
  items:  Array<ProductText | null >,
  nextToken?: string | null,
};

export type ModelProductMaskFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  sku?: ModelStringInput | null,
  productId?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  filterColors?: ModelStringInput | null,
  increment?: ModelFloatInput | null,
  fee?: ModelFloatInput | null,
  discount?: ModelFloatInput | null,
  stock?: ModelIntInput | null,
  categoryId?: ModelStringInput | null,
  sellMode?: ModelProductMaskSellModeInput | null,
  kitPieces?: ModelIntInput | null,
  kitIncrement?: ModelFloatInput | null,
  kitFee?: ModelFloatInput | null,
  stockMode?: ModelProductMaskStockModeInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProductMaskFilterInput | null > | null,
  or?: Array< ModelProductMaskFilterInput | null > | null,
  not?: ModelProductMaskFilterInput | null,
};

export type ModelProductMaskConnection = {
  __typename: "ModelProductMaskConnection",
  items:  Array<ProductMask | null >,
  nextToken?: string | null,
};

export type ModelVariantMaskFilterInput = {
  id?: ModelIDInput | null,
  filterColors?: ModelStringInput | null,
  stock?: ModelIntInput | null,
  stockMode?: ModelVariantMaskStockModeInput | null,
  productMaskId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelVariantMaskFilterInput | null > | null,
  or?: Array< ModelVariantMaskFilterInput | null > | null,
  not?: ModelVariantMaskFilterInput | null,
};

export type ModelVariantMaskConnection = {
  __typename: "ModelVariantMaskConnection",
  items:  Array<VariantMask | null >,
  nextToken?: string | null,
};

export type ModelProductMaskDescriptionFilterInput = {
  id?: ModelIDInput | null,
  long_description?: ModelStringInput | null,
  short_description?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProductMaskDescriptionFilterInput | null > | null,
  or?: Array< ModelProductMaskDescriptionFilterInput | null > | null,
  not?: ModelProductMaskDescriptionFilterInput | null,
};

export type ModelProductMaskDescriptionConnection = {
  __typename: "ModelProductMaskDescriptionConnection",
  items:  Array<ProductMaskDescription | null >,
  nextToken?: string | null,
};

export type ModelCouponFilterInput = {
  id?: ModelIDInput | null,
  code?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  discountAmount?: ModelFloatInput | null,
  discountPercentage?: ModelFloatInput | null,
  minAmount?: ModelFloatInput | null,
  maxAmount?: ModelFloatInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  maxRedemptions?: ModelIntInput | null,
  maxRedemptionsPerUser?: ModelIntInput | null,
  applicableProducts?: ModelStringInput | null,
  applicableCategories?: ModelStringInput | null,
  excludedProducts?: ModelStringInput | null,
  status?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCouponFilterInput | null > | null,
  or?: Array< ModelCouponFilterInput | null > | null,
  not?: ModelCouponFilterInput | null,
};

export type ModelCouponConnection = {
  __typename: "ModelCouponConnection",
  items:  Array<Coupon | null >,
  nextToken?: string | null,
};

export type ModelCouponRedemptionFilterInput = {
  id?: ModelIDInput | null,
  couponId?: ModelIDInput | null,
  couponCode?: ModelStringInput | null,
  userId?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  orderId?: ModelStringInput | null,
  cartId?: ModelStringInput | null,
  discountApplied?: ModelFloatInput | null,
  originalAmount?: ModelFloatInput | null,
  finalAmount?: ModelFloatInput | null,
  appliedAt?: ModelStringInput | null,
  ipAddress?: ModelStringInput | null,
  userAgent?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelCouponRedemptionFilterInput | null > | null,
  or?: Array< ModelCouponRedemptionFilterInput | null > | null,
  not?: ModelCouponRedemptionFilterInput | null,
};

export type ModelPromotionFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  triggerProductIds?: ModelStringInput | null,
  minQuantity?: ModelIntInput | null,
  minAmount?: ModelFloatInput | null,
  triggerRule?: ModelPromotionTriggerRuleInput | null,
  giftProductId?: ModelStringInput | null,
  giftQuantity?: ModelIntInput | null,
  isStackable?: ModelBooleanInput | null,
  applicableClientIds?: ModelStringInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  maxRedemptions?: ModelIntInput | null,
  maxRedemptionsPerUser?: ModelIntInput | null,
  status?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPromotionFilterInput | null > | null,
  or?: Array< ModelPromotionFilterInput | null > | null,
  not?: ModelPromotionFilterInput | null,
};

export type ModelPromotionConnection = {
  __typename: "ModelPromotionConnection",
  items:  Array<Promotion | null >,
  nextToken?: string | null,
};

export type ModelPromotionRedemptionFilterInput = {
  id?: ModelIDInput | null,
  promotionId?: ModelIDInput | null,
  userId?: ModelStringInput | null,
  clientId?: ModelStringInput | null,
  orderId?: ModelStringInput | null,
  cartId?: ModelStringInput | null,
  triggerQuantity?: ModelIntInput | null,
  giftQuantityApplied?: ModelIntInput | null,
  appliedAt?: ModelStringInput | null,
  ipAddress?: ModelStringInput | null,
  userAgent?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPromotionRedemptionFilterInput | null > | null,
  or?: Array< ModelPromotionRedemptionFilterInput | null > | null,
  not?: ModelPromotionRedemptionFilterInput | null,
};

export type ModelWalletBalanceFilterInput = {
  id?: ModelIDInput | null,
  balance?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelWalletBalanceFilterInput | null > | null,
  or?: Array< ModelWalletBalanceFilterInput | null > | null,
  not?: ModelWalletBalanceFilterInput | null,
};

export type ModelWalletBalanceConnection = {
  __typename: "ModelWalletBalanceConnection",
  items:  Array<WalletBalance | null >,
  nextToken?: string | null,
};

export type ModelWalletMovementFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  type?: ModelWalletMovementTypeInput | null,
  amount?: ModelFloatInput | null,
  orderId?: ModelIDInput | null,
  createdByUserId?: ModelIDInput | null,
  couponId?: ModelIDInput | null,
  couponCode?: ModelStringInput | null,
  availableUntil?: ModelStringInput | null,
  isValidated?: ModelBooleanInput | null,
  validatedAt?: ModelStringInput | null,
  validatedBy?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelWalletMovementFilterInput | null > | null,
  or?: Array< ModelWalletMovementFilterInput | null > | null,
  not?: ModelWalletMovementFilterInput | null,
};

export type ModelWalletMovementConnection = {
  __typename: "ModelWalletMovementConnection",
  items:  Array<WalletMovement | null >,
  nextToken?: string | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelIntKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelIDKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelProductoByCategoryProviderPriceCompositeKeyConditionInput = {
  eq?: ModelProductoByCategoryProviderPriceCompositeKeyInput | null,
  le?: ModelProductoByCategoryProviderPriceCompositeKeyInput | null,
  lt?: ModelProductoByCategoryProviderPriceCompositeKeyInput | null,
  ge?: ModelProductoByCategoryProviderPriceCompositeKeyInput | null,
  gt?: ModelProductoByCategoryProviderPriceCompositeKeyInput | null,
  between?: Array< ModelProductoByCategoryProviderPriceCompositeKeyInput | null > | null,
  beginsWith?: ModelProductoByCategoryProviderPriceCompositeKeyInput | null,
};

export type ModelProductoByCategoryProviderPriceCompositeKeyInput = {
  providerId?: string | null,
  price?: number | null,
};

export type ModelFloatKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelRfqByEstatusClientCreatedCompositeKeyConditionInput = {
  eq?: ModelRfqByEstatusClientCreatedCompositeKeyInput | null,
  le?: ModelRfqByEstatusClientCreatedCompositeKeyInput | null,
  lt?: ModelRfqByEstatusClientCreatedCompositeKeyInput | null,
  ge?: ModelRfqByEstatusClientCreatedCompositeKeyInput | null,
  gt?: ModelRfqByEstatusClientCreatedCompositeKeyInput | null,
  between?: Array< ModelRfqByEstatusClientCreatedCompositeKeyInput | null > | null,
  beginsWith?: ModelRfqByEstatusClientCreatedCompositeKeyInput | null,
};

export type ModelRfqByEstatusClientCreatedCompositeKeyInput = {
  clientId?: string | null,
  created?: number | null,
};

export type ModelRfqAmazonByEstatusClientACreatedCompositeKeyConditionInput = {
  eq?: ModelRfqAmazonByEstatusClientACreatedCompositeKeyInput | null,
  le?: ModelRfqAmazonByEstatusClientACreatedCompositeKeyInput | null,
  lt?: ModelRfqAmazonByEstatusClientACreatedCompositeKeyInput | null,
  ge?: ModelRfqAmazonByEstatusClientACreatedCompositeKeyInput | null,
  gt?: ModelRfqAmazonByEstatusClientACreatedCompositeKeyInput | null,
  between?: Array< ModelRfqAmazonByEstatusClientACreatedCompositeKeyInput | null > | null,
  beginsWith?: ModelRfqAmazonByEstatusClientACreatedCompositeKeyInput | null,
};

export type ModelRfqAmazonByEstatusClientACreatedCompositeKeyInput = {
  clientId?: string | null,
  created?: number | null,
};

export type ModelSubscriptionClientFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  business_name?: ModelSubscriptionStringInput | null,
  comertial_name?: ModelSubscriptionStringInput | null,
  biography?: ModelSubscriptionStringInput | null,
  plan?: ModelSubscriptionStringInput | null,
  fee?: ModelSubscriptionFloatInput | null,
  increment?: ModelSubscriptionFloatInput | null,
  mercadoFee?: ModelSubscriptionFloatInput | null,
  mercadoIncrement?: ModelSubscriptionFloatInput | null,
  popFee?: ModelSubscriptionFloatInput | null,
  popIncrement?: ModelSubscriptionFloatInput | null,
  printedFee?: ModelSubscriptionFloatInput | null,
  printedIncrement?: ModelSubscriptionFloatInput | null,
  users?: ModelSubscriptionStringInput | null,
  restrictedUsers?: ModelSubscriptionStringInput | null,
  nonRestrictedUsers?: ModelSubscriptionStringInput | null,
  regions?: ModelSubscriptionStringInput | null,
  providers?: ModelSubscriptionStringInput | null,
  popProviders?: ModelSubscriptionStringInput | null,
  printedProviders?: ModelSubscriptionStringInput | null,
  logisticFrequency?: ModelSubscriptionIntInput | null,
  legal_representative?: ModelSubscriptionStringInput | null,
  legal_representative_email?: ModelSubscriptionStringInput | null,
  legal_representative_address?: ModelSubscriptionStringInput | null,
  tcdUsers?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionClientFilterInput | null > | null,
  or?: Array< ModelSubscriptionClientFilterInput | null > | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionClientSettingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  crmJiraId?: ModelSubscriptionStringInput | null,
  orderBudget?: ModelSubscriptionFloatInput | null,
  domain?: ModelSubscriptionStringInput | null,
  filterColors?: ModelSubscriptionStringInput | null,
  primaryColors?: ModelSubscriptionStringInput | null,
  accentColors?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionClientSettingFilterInput | null > | null,
  or?: Array< ModelSubscriptionClientSettingFilterInput | null > | null,
};

export type ModelSubscriptionClientOptionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  pakmail?: ModelSubscriptionBooleanInput | null,
  orderVat?: ModelSubscriptionBooleanInput | null,
  hasMercado?: ModelSubscriptionBooleanInput | null,
  hasAmazon?: ModelSubscriptionBooleanInput | null,
  hasAutomobiles?: ModelSubscriptionBooleanInput | null,
  publicDashboards?: ModelSubscriptionBooleanInput | null,
  printPrices?: ModelSubscriptionBooleanInput | null,
  logisticPrices?: ModelSubscriptionBooleanInput | null,
  hidePricesAndFlow?: ModelSubscriptionBooleanInput | null,
  showPhones?: ModelSubscriptionBooleanInput | null,
  fullCoupaDescriptions?: ModelSubscriptionBooleanInput | null,
  isPremium?: ModelSubscriptionBooleanInput | null,
  isPop?: ModelSubscriptionBooleanInput | null,
  isPrinted?: ModelSubscriptionBooleanInput | null,
  allPremiumRfqs?: ModelSubscriptionBooleanInput | null,
  allPopRfqs?: ModelSubscriptionBooleanInput | null,
  allPrintedRfqs?: ModelSubscriptionBooleanInput | null,
  autoUpdateHomePage?: ModelSubscriptionBooleanInput | null,
  showVat?: ModelSubscriptionBooleanInput | null,
  requiredDeliveryInfo?: ModelSubscriptionBooleanInput | null,
  restrictedCatalogue?: ModelSubscriptionBooleanInput | null,
  excludeCoupa?: ModelSubscriptionBooleanInput | null,
  tcdPayment?: ModelSubscriptionBooleanInput | null,
  automaticLogisticGuides?: ModelSubscriptionBooleanInput | null,
  transferencePayment?: ModelSubscriptionBooleanInput | null,
  customCatalogue?: ModelSubscriptionBooleanInput | null,
  disableProjectDescriptions?: ModelSubscriptionBooleanInput | null,
  showBranding?: ModelSubscriptionBooleanInput | null,
  customCostCenter?: ModelSubscriptionBooleanInput | null,
  couponsEnabled?: ModelSubscriptionBooleanInput | null,
  showChat?: ModelSubscriptionBooleanInput | null,
  hasCrmSync?: ModelSubscriptionBooleanInput | null,
  onlyQuotes?: ModelSubscriptionBooleanInput | null,
  autoSaveDeliveryInfo?: ModelSubscriptionBooleanInput | null,
  limitMaxRequestOnDiscounts?: ModelSubscriptionBooleanInput | null,
  freeLocalShipping?: ModelSubscriptionBooleanInput | null,
  discountShipping?: ModelSubscriptionBooleanInput | null,
  printingBreakdown?: ModelSubscriptionBooleanInput | null,
  skipAlendum?: ModelSubscriptionBooleanInput | null,
  skipFMS?: ModelSubscriptionBooleanInput | null,
  clientReminders?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionClientOptionFilterInput | null > | null,
  or?: Array< ModelSubscriptionClientOptionFilterInput | null > | null,
};

export type ModelSubscriptionProviderFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  isApproved?: ModelSubscriptionBooleanInput | null,
  comertial_name?: ModelSubscriptionStringInput | null,
  idProcter?: ModelSubscriptionStringInput | null,
  biography?: ModelSubscriptionStringInput | null,
  experience?: ModelSubscriptionStringInput | null,
  pros?: ModelSubscriptionStringInput | null,
  cons?: ModelSubscriptionStringInput | null,
  video?: ModelSubscriptionStringInput | null,
  tags?: ModelSubscriptionStringInput | null,
  money_filter_c?: ModelSubscriptionBooleanInput | null,
  money_filter_d?: ModelSubscriptionBooleanInput | null,
  users?: ModelSubscriptionStringInput | null,
  bank?: ModelSubscriptionStringInput | null,
  account?: ModelSubscriptionStringInput | null,
  clabe?: ModelSubscriptionStringInput | null,
  cuenta_correo?: ModelSubscriptionStringInput | null,
  isProvider?: ModelSubscriptionBooleanInput | null,
  sameAddress?: ModelSubscriptionBooleanInput | null,
  isPop?: ModelSubscriptionBooleanInput | null,
  isPrinted?: ModelSubscriptionBooleanInput | null,
  hasLogistic?: ModelSubscriptionBooleanInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  representante_legal?: ModelSubscriptionStringInput | null,
  escritura_constitucion?: ModelSubscriptionStringInput | null,
  notario_a?: ModelSubscriptionStringInput | null,
  constituido_down_edo?: ModelSubscriptionStringInput | null,
  rrpp?: ModelSubscriptionStringInput | null,
  isPremium?: ModelSubscriptionBooleanInput | null,
  isTrustProvider?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProviderFilterInput | null > | null,
  or?: Array< ModelSubscriptionProviderFilterInput | null > | null,
};

export type ModelSubscriptionProviderSettingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  primaryColors?: ModelSubscriptionStringInput | null,
  accentColors?: ModelSubscriptionStringInput | null,
  categories?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProviderSettingFilterInput | null > | null,
  or?: Array< ModelSubscriptionProviderSettingFilterInput | null > | null,
};

export type ModelSubscriptionProviderFileFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProviderFileFilterInput | null > | null,
  or?: Array< ModelSubscriptionProviderFileFilterInput | null > | null,
};

export type ModelSubscriptionColorsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  rgb?: ModelSubscriptionStringInput | null,
  hex?: ModelSubscriptionStringInput | null,
  position?: ModelSubscriptionIntInput | null,
  variantNames?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionColorsFilterInput | null > | null,
  or?: Array< ModelSubscriptionColorsFilterInput | null > | null,
};

export type ModelSubscriptionHomePageCarouselBannerFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  isPublic?: ModelSubscriptionBooleanInput | null,
  title?: ModelSubscriptionStringInput | null,
  subtitle?: ModelSubscriptionStringInput | null,
  copy?: ModelSubscriptionStringInput | null,
  path?: ModelSubscriptionStringInput | null,
  position?: ModelSubscriptionIntInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionHomePageCarouselBannerFilterInput | null > | null,
  or?: Array< ModelSubscriptionHomePageCarouselBannerFilterInput | null > | null,
};

export type ModelSubscriptionHomePageFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  isPublic?: ModelSubscriptionBooleanInput | null,
  showArrow?: ModelSubscriptionBooleanInput | null,
  showNumeration?: ModelSubscriptionBooleanInput | null,
  icon?: ModelSubscriptionStringInput | null,
  title?: ModelSubscriptionStringInput | null,
  subtitle?: ModelSubscriptionStringInput | null,
  body?: ModelSubscriptionStringInput | null,
  route?: ModelSubscriptionStringInput | null,
  titlePosition?: ModelSubscriptionStringInput | null,
  textAlign?: ModelSubscriptionStringInput | null,
  bgColor?: ModelSubscriptionStringInput | null,
  borderColor?: ModelSubscriptionStringInput | null,
  textColor?: ModelSubscriptionStringInput | null,
  position?: ModelSubscriptionIntInput | null,
  verticalLine?: ModelSubscriptionBooleanInput | null,
  browseButton?: ModelSubscriptionBooleanInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  visibleForUserBrand?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionHomePageFilterInput | null > | null,
  or?: Array< ModelSubscriptionHomePageFilterInput | null > | null,
};

export type ModelSubscriptionHomePageBottomBannerFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  isPublic?: ModelSubscriptionBooleanInput | null,
  title?: ModelSubscriptionStringInput | null,
  subtitle?: ModelSubscriptionStringInput | null,
  icon?: ModelSubscriptionStringInput | null,
  route?: ModelSubscriptionStringInput | null,
  showArrow?: ModelSubscriptionBooleanInput | null,
  bgColor?: ModelSubscriptionStringInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionHomePageBottomBannerFilterInput | null > | null,
  or?: Array< ModelSubscriptionHomePageBottomBannerFilterInput | null > | null,
};

export type ModelSubscriptionProductoFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  providerId?: ModelSubscriptionIDInput | null,
  categoryId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  bestSeller?: ModelSubscriptionStringInput | null,
  order?: ModelSubscriptionIntInput | null,
  sku?: ModelSubscriptionStringInput | null,
  brand?: ModelSubscriptionStringInput | null,
  colors?: ModelSubscriptionStringInput | null,
  pgClasitication?: ModelSubscriptionStringInput | null,
  delivery_time?: ModelSubscriptionStringInput | null,
  delivery_time_units?: ModelSubscriptionStringInput | null,
  stock?: ModelSubscriptionIntInput | null,
  minRequest?: ModelSubscriptionIntInput | null,
  maxRequest?: ModelSubscriptionIntInput | null,
  article_of_clothing?: ModelSubscriptionBooleanInput | null,
  size?: ModelSubscriptionStringInput | null,
  price?: ModelSubscriptionFloatInput | null,
  long_description?: ModelSubscriptionStringInput | null,
  short_description?: ModelSubscriptionStringInput | null,
  creator?: ModelSubscriptionStringInput | null,
  isExternal?: ModelSubscriptionBooleanInput | null,
  isAllowable?: ModelSubscriptionBooleanInput | null,
  isRestricted?: ModelSubscriptionBooleanInput | null,
  isAutoSkipped?: ModelSubscriptionStringInput | null,
  isAutoAllowed?: ModelSubscriptionStringInput | null,
  isPurse?: ModelSubscriptionBooleanInput | null,
  massiveLayout?: ModelSubscriptionStringInput | null,
  hasBaseAmmount?: ModelSubscriptionBooleanInput | null,
  isFreeAmmount?: ModelSubscriptionBooleanInput | null,
  isCard?: ModelSubscriptionBooleanInput | null,
  isByRequest?: ModelSubscriptionBooleanInput | null,
  isMultiPrice?: ModelSubscriptionBooleanInput | null,
  cardBaseAmmount?: ModelSubscriptionFloatInput | null,
  minCardBaseAmmount?: ModelSubscriptionFloatInput | null,
  maxCardBaseAmmount?: ModelSubscriptionFloatInput | null,
  nameExternal?: ModelSubscriptionStringInput | null,
  unspsc?: ModelSubscriptionStringInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  filterColors?: ModelSubscriptionStringInput | null,
  regions?: ModelSubscriptionStringInput | null,
  source?: ModelSubscriptionStringInput | null,
  trazoProductId?: ModelSubscriptionIDInput | null,
  trazoCategoryId?: ModelSubscriptionIDInput | null,
  stockUpdatedAt?: ModelSubscriptionStringInput | null,
  priceUpdatedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProductoFilterInput | null > | null,
  or?: Array< ModelSubscriptionProductoFilterInput | null > | null,
};

export type ModelSubscriptionProductVariantFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  productId?: ModelSubscriptionStringInput | null,
  sku?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  colors?: ModelSubscriptionStringInput | null,
  filterColors?: ModelSubscriptionStringInput | null,
  stock_available?: ModelSubscriptionIntInput | null,
  price?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProductVariantFilterInput | null > | null,
  or?: Array< ModelSubscriptionProductVariantFilterInput | null > | null,
};

export type ModelSubscriptionProductOptionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  ownOrder?: ModelSubscriptionStringInput | null,
  isPangga?: ModelSubscriptionStringInput | null,
  volumetricWeight?: ModelSubscriptionStringInput | null,
  isEvaluated?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProductOptionFilterInput | null > | null,
  or?: Array< ModelSubscriptionProductOptionFilterInput | null > | null,
};

export type ModelSubscriptionProductDimentionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  width?: ModelSubscriptionFloatInput | null,
  height?: ModelSubscriptionFloatInput | null,
  depth?: ModelSubscriptionFloatInput | null,
  weight?: ModelSubscriptionFloatInput | null,
  boxWidth?: ModelSubscriptionFloatInput | null,
  boxHeight?: ModelSubscriptionFloatInput | null,
  boxDepth?: ModelSubscriptionFloatInput | null,
  boxWeight?: ModelSubscriptionFloatInput | null,
  boxQuantity?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProductDimentionFilterInput | null > | null,
  or?: Array< ModelSubscriptionProductDimentionFilterInput | null > | null,
};

export type ModelSubscriptionMassiveChangeLayoutsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  providerId?: ModelSubscriptionIDInput | null,
  creatorId?: ModelSubscriptionStringInput | null,
  creatorRole?: ModelSubscriptionStringInput | null,
  productsNumber?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMassiveChangeLayoutsFilterInput | null > | null,
  or?: Array< ModelSubscriptionMassiveChangeLayoutsFilterInput | null > | null,
};

export type ModelSubscriptionCategoryFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  unspsc?: ModelSubscriptionStringInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  visibleForUserBrand?: ModelSubscriptionStringInput | null,
  region?: ModelSubscriptionStringInput | null,
  tags?: ModelSubscriptionStringInput | null,
  hasAllowables?: ModelSubscriptionBooleanInput | null,
  hasPreapproveds?: ModelSubscriptionBooleanInput | null,
  hasRestricted?: ModelSubscriptionBooleanInput | null,
  isPublic?: ModelSubscriptionBooleanInput | null,
  isTop?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  slug?: ModelSubscriptionStringInput | null,
  parentId?: ModelSubscriptionIDInput | null,
  rootId?: ModelSubscriptionIDInput | null,
  path?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  pathIds?: ModelSubscriptionIDInput | null,
  source?: ModelSubscriptionStringInput | null,
  trazoCategoryId?: ModelSubscriptionIDInput | null,
  nameExternal?: ModelSubscriptionStringInput | null,
  depth?: ModelSubscriptionIntInput | null,
  childrenCount?: ModelSubscriptionIntInput | null,
  isLeaf?: ModelSubscriptionBooleanInput | null,
  oldVersion?: ModelSubscriptionStringInput | null,
  productLine?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCategoryFilterInput | null > | null,
  or?: Array< ModelSubscriptionCategoryFilterInput | null > | null,
};

export type ModelSubscriptionProductBrandFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  route?: ModelSubscriptionStringInput | null,
  unspsc?: ModelSubscriptionStringInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  region?: ModelSubscriptionStringInput | null,
  hasAllowables?: ModelSubscriptionBooleanInput | null,
  hasPreapproveds?: ModelSubscriptionBooleanInput | null,
  hasRestricted?: ModelSubscriptionBooleanInput | null,
  isTop?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProductBrandFilterInput | null > | null,
  or?: Array< ModelSubscriptionProductBrandFilterInput | null > | null,
};

export type ModelSubscriptionCartFilterInput = {
  id?: ModelSubscriptionStringInput | null,
  requirement?: ModelSubscriptionStringInput | null,
  creator?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCartFilterInput | null > | null,
  or?: Array< ModelSubscriptionCartFilterInput | null > | null,
};

export type ModelSubscriptionUserFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  role?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  jiraId?: ModelSubscriptionStringInput | null,
  phoneNumber?: ModelSubscriptionStringInput | null,
  companyId?: ModelSubscriptionStringInput | null,
  brandId?: ModelSubscriptionStringInput | null,
  failedLogins?: ModelSubscriptionIntInput | null,
  notificationsOf?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  isLogistic?: ModelSubscriptionBooleanInput | null,
  isCoupa?: ModelSubscriptionBooleanInput | null,
  isManagement?: ModelSubscriptionBooleanInput | null,
  isAdministration?: ModelSubscriptionBooleanInput | null,
  hasNotifications?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFilterInput | null > | null,
};

export type ModelSubscriptionAutomobileFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  clientId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  bought?: ModelSubscriptionBooleanInput | null,
  buyerId?: ModelSubscriptionIDInput | null,
  buyerName?: ModelSubscriptionStringInput | null,
  price?: ModelSubscriptionFloatInput | null,
  brand?: ModelSubscriptionStringInput | null,
  brandId?: ModelSubscriptionStringInput | null,
  model?: ModelSubscriptionStringInput | null,
  version?: ModelSubscriptionStringInput | null,
  year?: ModelSubscriptionIntInput | null,
  color?: ModelSubscriptionStringInput | null,
  km?: ModelSubscriptionIntInput | null,
  transmission?: ModelSubscriptionStringInput | null,
  motor?: ModelSubscriptionStringInput | null,
  passengers?: ModelSubscriptionIntInput | null,
  state?: ModelSubscriptionStringInput | null,
  objeto?: ModelSubscriptionStringInput | null,
  placa?: ModelSubscriptionStringInput | null,
  serialNumber?: ModelSubscriptionStringInput | null,
  star_time?: ModelSubscriptionIntInput | null,
  end_time?: ModelSubscriptionIntInput | null,
  comentario?: ModelSubscriptionStringInput | null,
  penalizacion?: ModelSubscriptionStringInput | null,
  haveWinner?: ModelSubscriptionBooleanInput | null,
  ppostulacion?: ModelSubscriptionBooleanInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAutomobileFilterInput | null > | null,
  or?: Array< ModelSubscriptionAutomobileFilterInput | null > | null,
};

export type ModelSubscriptionBrandFilterInput = {
  id?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionBrandFilterInput | null > | null,
  or?: Array< ModelSubscriptionBrandFilterInput | null > | null,
};

export type ModelSubscriptionRfqFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  nombre?: ModelSubscriptionStringInput | null,
  requerimiento?: ModelSubscriptionStringInput | null,
  cantidad?: ModelSubscriptionIntInput | null,
  limit_time?: ModelSubscriptionIntInput | null,
  creator?: ModelSubscriptionStringInput | null,
  clientId?: ModelSubscriptionStringInput | null,
  orderAgentIds?: ModelSubscriptionStringInput | null,
  premiumOrderId?: ModelSubscriptionStringInput | null,
  estatus?: ModelSubscriptionStringInput | null,
  orderId?: ModelSubscriptionIntInput | null,
  start_time?: ModelSubscriptionIntInput | null,
  delivery_time?: ModelSubscriptionIntInput | null,
  created?: ModelSubscriptionIntInput | null,
  saving?: ModelSubscriptionFloatInput | null,
  saving_percentage?: ModelSubscriptionFloatInput | null,
  saving_real?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  updated?: ModelSubscriptionIntInput | null,
  multipleProducts?: ModelSubscriptionBooleanInput | null,
  providers?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionRfqFilterInput | null > | null,
  or?: Array< ModelSubscriptionRfqFilterInput | null > | null,
};

export type ModelSubscriptionRfqAmazonFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  nombre?: ModelSubscriptionStringInput | null,
  requerimiento?: ModelSubscriptionStringInput | null,
  cantidad?: ModelSubscriptionIntInput | null,
  limit_time?: ModelSubscriptionIntInput | null,
  creator?: ModelSubscriptionStringInput | null,
  clientId?: ModelSubscriptionStringInput | null,
  estatus?: ModelSubscriptionStringInput | null,
  orderId?: ModelSubscriptionIntInput | null,
  start_time?: ModelSubscriptionIntInput | null,
  delivery_time?: ModelSubscriptionIntInput | null,
  created?: ModelSubscriptionIntInput | null,
  saving?: ModelSubscriptionFloatInput | null,
  saving_percentage?: ModelSubscriptionFloatInput | null,
  saving_real?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  updated?: ModelSubscriptionIntInput | null,
  multipleProducts?: ModelSubscriptionBooleanInput | null,
  providers?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionRfqAmazonFilterInput | null > | null,
  or?: Array< ModelSubscriptionRfqAmazonFilterInput | null > | null,
};

export type ModelSubscriptionProposalsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  provider_id?: ModelSubscriptionStringInput | null,
  priceUnit?: ModelSubscriptionFloatInput | null,
  pieces?: ModelSubscriptionIntInput | null,
  price?: ModelSubscriptionFloatInput | null,
  validity_days?: ModelSubscriptionIntInput | null,
  description?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  multipleProducts?: ModelSubscriptionBooleanInput | null,
  hidden?: ModelSubscriptionBooleanInput | null,
  proposalsRfqId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProposalsFilterInput | null > | null,
  or?: Array< ModelSubscriptionProposalsFilterInput | null > | null,
};

export type ModelSubscriptionProposalsAmazonFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  provider_id?: ModelSubscriptionStringInput | null,
  priceUnit?: ModelSubscriptionFloatInput | null,
  pieces?: ModelSubscriptionIntInput | null,
  price?: ModelSubscriptionFloatInput | null,
  validity_days?: ModelSubscriptionIntInput | null,
  description?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  multipleProducts?: ModelSubscriptionBooleanInput | null,
  hidden?: ModelSubscriptionBooleanInput | null,
  proposalsRfqId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProposalsAmazonFilterInput | null > | null,
  or?: Array< ModelSubscriptionProposalsAmazonFilterInput | null > | null,
};

export type ModelSubscriptionProductoRfqFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  request?: ModelSubscriptionStringInput | null,
  category_id?: ModelSubscriptionIDInput | null,
  provider_id?: ModelSubscriptionIDInput | null,
  price?: ModelSubscriptionFloatInput | null,
  estatus?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProductoRfqFilterInput | null > | null,
  or?: Array< ModelSubscriptionProductoRfqFilterInput | null > | null,
};

export type ModelSubscriptionOrderProvidersFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  provider_id?: ModelSubscriptionStringInput | null,
  clientId?: ModelSubscriptionStringInput | null,
  orderId?: ModelSubscriptionIntInput | null,
  orderProvidersPremiumOrderId?: ModelSubscriptionIDInput | null,
  payment_date?: ModelSubscriptionIntInput | null,
  gr_code?: ModelSubscriptionStringInput | null,
  invoice?: ModelSubscriptionBooleanInput | null,
  invoiceRequested?: ModelSubscriptionBooleanInput | null,
  uploadedGr?: ModelSubscriptionBooleanInput | null,
  uploadedBill?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionOrderProvidersFilterInput | null > | null,
  or?: Array< ModelSubscriptionOrderProvidersFilterInput | null > | null,
};

export type ModelSubscriptionPopMaterialFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  route?: ModelSubscriptionStringInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  year?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPopMaterialFilterInput | null > | null,
  or?: Array< ModelSubscriptionPopMaterialFilterInput | null > | null,
};

export type ModelSubscriptionVehicleTypeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  popMaterialId?: ModelSubscriptionIDInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  region?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionVehicleTypeFilterInput | null > | null,
  or?: Array< ModelSubscriptionVehicleTypeFilterInput | null > | null,
};

export type ModelSubscriptionVehicleFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  isSustainable?: ModelSubscriptionBooleanInput | null,
  multiProvider?: ModelSubscriptionBooleanInput | null,
  itemName?: ModelSubscriptionStringInput | null,
  bestSeller?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  brand?: ModelSubscriptionStringInput | null,
  channel?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  size?: ModelSubscriptionStringInput | null,
  materialDetail?: ModelSubscriptionStringInput | null,
  print?: ModelSubscriptionStringInput | null,
  finish?: ModelSubscriptionStringInput | null,
  packaging?: ModelSubscriptionStringInput | null,
  quantity?: ModelSubscriptionIntInput | null,
  unitPrice?: ModelSubscriptionFloatInput | null,
  prototypePrice?: ModelSubscriptionFloatInput | null,
  productionTime?: ModelSubscriptionStringInput | null,
  vehicleTypeId?: ModelSubscriptionIDInput | null,
  popMaterialId?: ModelSubscriptionIDInput | null,
  popCategoryId?: ModelSubscriptionIDInput | null,
  providerId?: ModelSubscriptionIDInput | null,
  isRfq?: ModelSubscriptionBooleanInput | null,
  historicCost?: ModelSubscriptionStringInput | null,
  historicTime?: ModelSubscriptionStringInput | null,
  contact?: ModelSubscriptionStringInput | null,
  providerName?: ModelSubscriptionStringInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  filterColors?: ModelSubscriptionStringInput | null,
  providers?: ModelSubscriptionStringInput | null,
  massiveLayout?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionVehicleFilterInput | null > | null,
  or?: Array< ModelSubscriptionVehicleFilterInput | null > | null,
};

export type ModelSubscriptionPopOrderFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  estatus?: ModelSubscriptionStringInput | null,
  orderId?: ModelSubscriptionIntInput | null,
  requirement?: ModelSubscriptionStringInput | null,
  budget?: ModelSubscriptionFloatInput | null,
  delivery_cost?: ModelSubscriptionFloatInput | null,
  delivery_time?: ModelSubscriptionIntInput | null,
  subtotal?: ModelSubscriptionFloatInput | null,
  total?: ModelSubscriptionFloatInput | null,
  isCoupa?: ModelSubscriptionBooleanInput | null,
  sentToCoupa?: ModelSubscriptionBooleanInput | null,
  coupaOrder?: ModelSubscriptionStringInput | null,
  active?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  orderAgentIds?: ModelSubscriptionStringInput | null,
  gr?: ModelSubscriptionStringInput | null,
  orderCreatorId?: ModelSubscriptionIDInput | null,
  prequoteApproved?: ModelSubscriptionBooleanInput | null,
  quoteApproved?: ModelSubscriptionBooleanInput | null,
  prototypeApproved?: ModelSubscriptionBooleanInput | null,
  samplesDocsUploaded?: ModelSubscriptionBooleanInput | null,
  samplesApproved?: ModelSubscriptionBooleanInput | null,
  auditRequired?: ModelSubscriptionBooleanInput | null,
  drivePath?: ModelSubscriptionStringInput | null,
  auditDocsUploaded?: ModelSubscriptionBooleanInput | null,
  deliveryDateRequested?: ModelSubscriptionBooleanInput | null,
  deliveryDate?: ModelSubscriptionIntInput | null,
  deliveryCode?: ModelSubscriptionStringInput | null,
  deliveryFilesUploaded?: ModelSubscriptionBooleanInput | null,
  deliveryDocsApproved?: ModelSubscriptionBooleanInput | null,
  grUploaded?: ModelSubscriptionBooleanInput | null,
  grApproved?: ModelSubscriptionBooleanInput | null,
  grCode?: ModelSubscriptionStringInput | null,
  qrCode?: ModelSubscriptionBooleanInput | null,
  brandfactoryCheck?: ModelSubscriptionBooleanInput | null,
  step?: ModelSubscriptionIntInput | null,
  prototype?: ModelSubscriptionBooleanInput | null,
  dateKickoff?: ModelSubscriptionIntInput | null,
  paymentDate?: ModelSubscriptionIntInput | null,
  currentProcess?: ModelSubscriptionStringInput | null,
  currentSubprocess?: ModelSubscriptionStringInput | null,
  clientId?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPopOrderFilterInput | null > | null,
  or?: Array< ModelSubscriptionPopOrderFilterInput | null > | null,
};

export type ModelSubscriptionOrderFileFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  creatorId?: ModelSubscriptionIDInput | null,
  orderId?: ModelSubscriptionIDInput | null,
  key?: ModelSubscriptionStringInput | null,
  url?: ModelSubscriptionStringInput | null,
  orderStatus?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionOrderFileFilterInput | null > | null,
  or?: Array< ModelSubscriptionOrderFileFilterInput | null > | null,
};

export type ModelSubscriptionPopOrderVehicleFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  orderId?: ModelSubscriptionIDInput | null,
  vehicleId?: ModelSubscriptionIDInput | null,
  providerId?: ModelSubscriptionIDInput | null,
  unitPrice?: ModelSubscriptionFloatInput | null,
  prototypePrice?: ModelSubscriptionFloatInput | null,
  quantity?: ModelSubscriptionIntInput | null,
  approved?: ModelSubscriptionBooleanInput | null,
  hasQrCode?: ModelSubscriptionBooleanInput | null,
  sampleTestDate?: ModelSubscriptionIntInput | null,
  sampleTestDateApproved?: ModelSubscriptionBooleanInput | null,
  prototypeDate?: ModelSubscriptionIntInput | null,
  prototypeDateApproved?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPopOrderVehicleFilterInput | null > | null,
  or?: Array< ModelSubscriptionPopOrderVehicleFilterInput | null > | null,
};

export type ModelSubscriptionPopOrderAuthorizerFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPopOrderAuthorizerFilterInput | null > | null,
  or?: Array< ModelSubscriptionPopOrderAuthorizerFilterInput | null > | null,
};

export type ModelSubscriptionPopOrderProviderFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  orderId?: ModelSubscriptionIDInput | null,
  providerId?: ModelSubscriptionIDInput | null,
  deliveryDateRequested?: ModelSubscriptionBooleanInput | null,
  grRequested?: ModelSubscriptionBooleanInput | null,
  invoiceUploaded?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPopOrderProviderFilterInput | null > | null,
  or?: Array< ModelSubscriptionPopOrderProviderFilterInput | null > | null,
};

export type ModelSubscriptionPopOrderLogFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  orderId?: ModelSubscriptionIDInput | null,
  creatorId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  text?: ModelSubscriptionStringInput | null,
  orderStatus?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPopOrderLogFilterInput | null > | null,
  or?: Array< ModelSubscriptionPopOrderLogFilterInput | null > | null,
};

export type ModelSubscriptionRfqPopFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  nombre?: ModelSubscriptionStringInput | null,
  requerimiento?: ModelSubscriptionStringInput | null,
  vehicleTypeId?: ModelSubscriptionIDInput | null,
  popMaterialId?: ModelSubscriptionIDInput | null,
  cantidad?: ModelSubscriptionIntInput | null,
  limit_time?: ModelSubscriptionIntInput | null,
  creator?: ModelSubscriptionStringInput | null,
  clientId?: ModelSubscriptionStringInput | null,
  orderAgentIds?: ModelSubscriptionStringInput | null,
  popOrderId?: ModelSubscriptionStringInput | null,
  orderId?: ModelSubscriptionIntInput | null,
  estatus?: ModelSubscriptionStringInput | null,
  start_time?: ModelSubscriptionIntInput | null,
  delivery_time?: ModelSubscriptionIntInput | null,
  saving?: ModelSubscriptionFloatInput | null,
  saving_percentage?: ModelSubscriptionFloatInput | null,
  saving_real?: ModelSubscriptionFloatInput | null,
  budget?: ModelSubscriptionFloatInput | null,
  hasQrCode?: ModelSubscriptionBooleanInput | null,
  created?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updated?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionRfqPopFilterInput | null > | null,
  or?: Array< ModelSubscriptionRfqPopFilterInput | null > | null,
};

export type ModelSubscriptionProposalsPopFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  provider_id?: ModelSubscriptionStringInput | null,
  price?: ModelSubscriptionFloatInput | null,
  created?: ModelSubscriptionIntInput | null,
  validity_days?: ModelSubscriptionIntInput | null,
  description?: ModelSubscriptionStringInput | null,
  updated?: ModelSubscriptionIntInput | null,
  proposalsPopRfqId?: ModelSubscriptionIDInput | null,
  prototypePrice?: ModelSubscriptionFloatInput | null,
  hidden?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProposalsPopFilterInput | null > | null,
  or?: Array< ModelSubscriptionProposalsPopFilterInput | null > | null,
};

export type ModelSubscriptionUsersBrandsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  clientId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUsersBrandsFilterInput | null > | null,
  or?: Array< ModelSubscriptionUsersBrandsFilterInput | null > | null,
};

export type ModelSubscriptionUserBrandSettingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  categories?: ModelSubscriptionStringInput | null,
  subcategories?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserBrandSettingFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserBrandSettingFilterInput | null > | null,
};

export type ModelSubscriptionLogsPUsersFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  user?: ModelSubscriptionStringInput | null,
  keyword?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLogsPUsersFilterInput | null > | null,
  or?: Array< ModelSubscriptionLogsPUsersFilterInput | null > | null,
};

export type ModelSubscriptionClipPaymentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  requestsCount?: ModelSubscriptionIntInput | null,
  payment_request_id?: ModelSubscriptionStringInput | null,
  purchase_description?: ModelSubscriptionStringInput | null,
  orderId?: ModelSubscriptionIDInput | null,
  clientId?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionClipPaymentFilterInput | null > | null,
  or?: Array< ModelSubscriptionClipPaymentFilterInput | null > | null,
};

export type ModelSubscriptionOrderProcessFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  tcdPayment?: ModelSubscriptionBooleanInput | null,
  name?: ModelSubscriptionStringInput | null,
  duration?: ModelSubscriptionStringInput | null,
  descripcion?: ModelSubscriptionStringInput | null,
  position?: ModelSubscriptionIntInput | null,
  responsible?: ModelSubscriptionIntInput | null,
  clientId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionOrderProcessFilterInput | null > | null,
  or?: Array< ModelSubscriptionOrderProcessFilterInput | null > | null,
};

export type ModelSubscriptionOrderSubprocessFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  name?: ModelSubscriptionStringInput | null,
  position?: ModelSubscriptionIntInput | null,
  descripcion?: ModelSubscriptionStringInput | null,
  action?: ModelSubscriptionIntInput | null,
  processId?: ModelSubscriptionIDInput | null,
  clientId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionOrderSubprocessFilterInput | null > | null,
  or?: Array< ModelSubscriptionOrderSubprocessFilterInput | null > | null,
};

export type ModelSubscriptionPremiumOrderFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  requirement?: ModelSubscriptionStringInput | null,
  bank_reference?: ModelSubscriptionStringInput | null,
  hasVat?: ModelSubscriptionBooleanInput | null,
  orderId?: ModelSubscriptionIntInput | null,
  delivery_cost?: ModelSubscriptionFloatInput | null,
  delivery_fee?: ModelSubscriptionFloatInput | null,
  delivery_discount?: ModelSubscriptionFloatInput | null,
  delivery_time?: ModelSubscriptionIntInput | null,
  delivery_date?: ModelSubscriptionStringInput | null,
  clipUrl?: ModelSubscriptionStringInput | null,
  clipStatus?: ModelSubscriptionStringInput | null,
  orderCreatorId?: ModelSubscriptionStringInput | null,
  orderAgentIds?: ModelSubscriptionStringInput | null,
  premiumOrderClientId?: ModelSubscriptionIDInput | null,
  userBrandId?: ModelSubscriptionIDInput | null,
  subtotal?: ModelSubscriptionFloatInput | null,
  fee?: ModelSubscriptionFloatInput | null,
  printedPrice?: ModelSubscriptionFloatInput | null,
  total?: ModelSubscriptionFloatInput | null,
  discountAmount?: ModelSubscriptionFloatInput | null,
  syncWithCrm?: ModelSubscriptionBooleanInput | null,
  crmIssueKey?: ModelSubscriptionStringInput | null,
  sentToAlendum?: ModelSubscriptionBooleanInput | null,
  alendumProjectId?: ModelSubscriptionStringInput | null,
  syncWithFms?: ModelSubscriptionStringInput | null,
  fmsInvoiceId?: ModelSubscriptionStringInput | null,
  syncWithWms?: ModelSubscriptionBooleanInput | null,
  wmsProjectId?: ModelSubscriptionStringInput | null,
  isCoupa?: ModelSubscriptionBooleanInput | null,
  sentToCoupa?: ModelSubscriptionBooleanInput | null,
  isRfq?: ModelSubscriptionBooleanInput | null,
  requireSamples?: ModelSubscriptionBooleanInput | null,
  requestedSamples?: ModelSubscriptionBooleanInput | null,
  approvedSamples?: ModelSubscriptionBooleanInput | null,
  authorizedQA?: ModelSubscriptionBooleanInput | null,
  active?: ModelSubscriptionStringInput | null,
  currentProcess?: ModelSubscriptionStringInput | null,
  currentSubprocess?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPremiumOrderFilterInput | null > | null,
  or?: Array< ModelSubscriptionPremiumOrderFilterInput | null > | null,
};

export type ModelSubscriptionPrintedCartFilterInput = {
  id?: ModelSubscriptionStringInput | null,
  creator?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPrintedCartFilterInput | null > | null,
  or?: Array< ModelSubscriptionPrintedCartFilterInput | null > | null,
};

export type ModelSubscriptionPrintedCategoryFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  route?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  region?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPrintedCategoryFilterInput | null > | null,
  or?: Array< ModelSubscriptionPrintedCategoryFilterInput | null > | null,
};

export type ModelSubscriptionPrintedSubcategoryFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  printedCategoryId?: ModelSubscriptionIDInput | null,
  created?: ModelSubscriptionIntInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  region?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPrintedSubcategoryFilterInput | null > | null,
  or?: Array< ModelSubscriptionPrintedSubcategoryFilterInput | null > | null,
};

export type ModelSubscriptionPrintedProductsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  position?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  width?: ModelSubscriptionFloatInput | null,
  height?: ModelSubscriptionFloatInput | null,
  price?: ModelSubscriptionFloatInput | null,
  long_description?: ModelSubscriptionStringInput | null,
  short_description?: ModelSubscriptionStringInput | null,
  creator?: ModelSubscriptionStringInput | null,
  providerId?: ModelSubscriptionIDInput | null,
  finalDimensions?: ModelSubscriptionFloatInput | null,
  pagesNumber?: ModelSubscriptionIntInput | null,
  finishes?: ModelSubscriptionStringInput | null,
  inksFourByCero?: ModelSubscriptionStringInput | null,
  inksFourByFour?: ModelSubscriptionStringInput | null,
  paperKind?: ModelSubscriptionStringInput | null,
  grammage?: ModelSubscriptionStringInput | null,
  hasBarniz?: ModelSubscriptionBooleanInput | null,
  hasRebase?: ModelSubscriptionBooleanInput | null,
  orientation?: ModelSubscriptionStringInput | null,
  specialInstructions?: ModelSubscriptionStringInput | null,
  PrintedSubcategoryId?: ModelSubscriptionIDInput | null,
  printedCategoryId?: ModelSubscriptionIDInput | null,
  created?: ModelSubscriptionIntInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  filterColors?: ModelSubscriptionStringInput | null,
  regions?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPrintedProductsFilterInput | null > | null,
  or?: Array< ModelSubscriptionPrintedProductsFilterInput | null > | null,
};

export type ModelSubscriptionPrintedRfqFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  nombre?: ModelSubscriptionStringInput | null,
  requerimiento?: ModelSubscriptionStringInput | null,
  limit_time?: ModelSubscriptionIntInput | null,
  creator?: ModelSubscriptionStringInput | null,
  clientId?: ModelSubscriptionStringInput | null,
  estatus?: ModelSubscriptionStringInput | null,
  printedOrderId?: ModelSubscriptionIntInput | null,
  start_time?: ModelSubscriptionIntInput | null,
  delivery_time?: ModelSubscriptionIntInput | null,
  created?: ModelSubscriptionIntInput | null,
  saving?: ModelSubscriptionFloatInput | null,
  saving_percentage?: ModelSubscriptionFloatInput | null,
  saving_real?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  updated?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionPrintedRfqFilterInput | null > | null,
  or?: Array< ModelSubscriptionPrintedRfqFilterInput | null > | null,
};

export type ModelSubscriptionPrintedProductoRfqFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  category_id?: ModelSubscriptionIDInput | null,
  provider_id?: ModelSubscriptionIDInput | null,
  price?: ModelSubscriptionFloatInput | null,
  category?: ModelSubscriptionStringInput | null,
  estatus?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPrintedProductoRfqFilterInput | null > | null,
  or?: Array< ModelSubscriptionPrintedProductoRfqFilterInput | null > | null,
};

export type ModelSubscriptionPrintedProposalFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  provider_id?: ModelSubscriptionStringInput | null,
  price?: ModelSubscriptionFloatInput | null,
  validity_days?: ModelSubscriptionIntInput | null,
  description?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  hidden?: ModelSubscriptionBooleanInput | null,
  printedProposalRfqId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPrintedProposalFilterInput | null > | null,
  or?: Array< ModelSubscriptionPrintedProposalFilterInput | null > | null,
};

export type ModelSubscriptionPrintedOrderFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  orderId?: ModelSubscriptionIntInput | null,
  delivery_cost?: ModelSubscriptionFloatInput | null,
  delivery_time?: ModelSubscriptionIntInput | null,
  listProvidersKey?: ModelSubscriptionStringInput | null,
  orderAgentIds?: ModelSubscriptionStringInput | null,
  orderCreatorId?: ModelSubscriptionStringInput | null,
  printedOrderClientId?: ModelSubscriptionIDInput | null,
  subtotal?: ModelSubscriptionFloatInput | null,
  total?: ModelSubscriptionFloatInput | null,
  isCoupa?: ModelSubscriptionBooleanInput | null,
  sentToCoupa?: ModelSubscriptionBooleanInput | null,
  isRfq?: ModelSubscriptionBooleanInput | null,
  status?: ModelSubscriptionStringInput | null,
  currentProcess?: ModelSubscriptionStringInput | null,
  currentSubprocess?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPrintedOrderFilterInput | null > | null,
  or?: Array< ModelSubscriptionPrintedOrderFilterInput | null > | null,
};

export type ModelSubscriptionPrintedOrderProvidersFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  provider_id?: ModelSubscriptionStringInput | null,
  orderId?: ModelSubscriptionIntInput | null,
  printedOrderProvidersPrintedOrderId?: ModelSubscriptionIDInput | null,
  payment_date?: ModelSubscriptionIntInput | null,
  gr_code?: ModelSubscriptionStringInput | null,
  invoice?: ModelSubscriptionBooleanInput | null,
  invoiceRequested?: ModelSubscriptionBooleanInput | null,
  uploadedGr?: ModelSubscriptionBooleanInput | null,
  uploadedBill?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPrintedOrderProvidersFilterInput | null > | null,
  or?: Array< ModelSubscriptionPrintedOrderProvidersFilterInput | null > | null,
};

export type ModelSubscriptionPayOnBehalfRequestsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  clientId?: ModelSubscriptionStringInput | null,
  companyName?: ModelSubscriptionStringInput | null,
  purchaseOrder?: ModelSubscriptionStringInput | null,
  paymentTerms?: ModelSubscriptionStringInput | null,
  currency?: ModelSubscriptionStringInput | null,
  amount?: ModelSubscriptionFloatInput | null,
  selectedVa?: ModelSubscriptionBooleanInput | null,
  iva?: ModelSubscriptionFloatInput | null,
  vat?: ModelSubscriptionFloatInput | null,
  total?: ModelSubscriptionFloatInput | null,
  created?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPayOnBehalfRequestsFilterInput | null > | null,
  or?: Array< ModelSubscriptionPayOnBehalfRequestsFilterInput | null > | null,
};

export type ModelSubscriptionBuyerContactClientFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  companyId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  defaultContact?: ModelSubscriptionBooleanInput | null,
  name?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionBuyerContactClientFilterInput | null > | null,
  or?: Array< ModelSubscriptionBuyerContactClientFilterInput | null > | null,
};

export type ModelSubscriptionBrandFactoryRfqEmailsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  name?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionBrandFactoryRfqEmailsFilterInput | null > | null,
  or?: Array< ModelSubscriptionBrandFactoryRfqEmailsFilterInput | null > | null,
};

export type ModelSubscriptionAutomobilesEmailsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  companyId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  name?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAutomobilesEmailsFilterInput | null > | null,
  or?: Array< ModelSubscriptionAutomobilesEmailsFilterInput | null > | null,
};

export type ModelSubscriptionQAEmailsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  companyId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  name?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionQAEmailsFilterInput | null > | null,
  or?: Array< ModelSubscriptionQAEmailsFilterInput | null > | null,
};

export type ModelSubscriptionOrderPopAdminEmailsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  companyId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  name?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionOrderPopAdminEmailsFilterInput | null > | null,
  or?: Array< ModelSubscriptionOrderPopAdminEmailsFilterInput | null > | null,
};

export type ModelSubscriptionOrderPopCheckoutEmailsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  companyId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  name?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionOrderPopCheckoutEmailsFilterInput | null > | null,
  or?: Array< ModelSubscriptionOrderPopCheckoutEmailsFilterInput | null > | null,
};

export type ModelSubscriptionGREmailsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  companyId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  name?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionGREmailsFilterInput | null > | null,
  or?: Array< ModelSubscriptionGREmailsFilterInput | null > | null,
};

export type ModelSubscriptionRegionsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  name?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionRegionsFilterInput | null > | null,
  or?: Array< ModelSubscriptionRegionsFilterInput | null > | null,
};

export type ModelSubscriptionDefaultAddressFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  companyId?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDefaultAddressFilterInput | null > | null,
  or?: Array< ModelSubscriptionDefaultAddressFilterInput | null > | null,
};

export type ModelSubscriptionDefaultDeliveryContactFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  companyId?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionBooleanInput | null,
  name?: ModelSubscriptionStringInput | null,
  phoneNumber?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDefaultDeliveryContactFilterInput | null > | null,
  or?: Array< ModelSubscriptionDefaultDeliveryContactFilterInput | null > | null,
};

export type ModelSubscriptionPopCategoriesFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  materialId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPopCategoriesFilterInput | null > | null,
  or?: Array< ModelSubscriptionPopCategoriesFilterInput | null > | null,
};

export type ModelSubscriptionRfpFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  clientId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  nombre?: ModelSubscriptionStringInput | null,
  requerimiento?: ModelSubscriptionStringInput | null,
  estatus?: ModelSubscriptionStringInput | null,
  descripcion?: ModelSubscriptionStringInput | null,
  url?: ModelSubscriptionStringInput | null,
  limit_time?: ModelSubscriptionIntInput | null,
  creator?: ModelSubscriptionStringInput | null,
  start_time?: ModelSubscriptionIntInput | null,
  delivery_time?: ModelSubscriptionIntInput | null,
  saving?: ModelSubscriptionFloatInput | null,
  saving_percentage?: ModelSubscriptionFloatInput | null,
  saving_real?: ModelSubscriptionFloatInput | null,
  created?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updated?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionRfpFilterInput | null > | null,
  or?: Array< ModelSubscriptionRfpFilterInput | null > | null,
};

export type ModelSubscriptionRfpProposalsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  provider_id?: ModelSubscriptionStringInput | null,
  price?: ModelSubscriptionFloatInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  validity_days?: ModelSubscriptionIntInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  multipleProducts?: ModelSubscriptionBooleanInput | null,
  hidden?: ModelSubscriptionBooleanInput | null,
  rfpProposalsRfpId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionRfpProposalsFilterInput | null > | null,
  or?: Array< ModelSubscriptionRfpProposalsFilterInput | null > | null,
};

export type ModelSubscriptionEvaluationProvidersFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  providerId?: ModelSubscriptionIDInput | null,
  creratorId?: ModelSubscriptionIDInput | null,
  orderId?: ModelSubscriptionIDInput | null,
  time?: ModelSubscriptionFloatInput | null,
  price?: ModelSubscriptionFloatInput | null,
  quality?: ModelSubscriptionFloatInput | null,
  att?: ModelSubscriptionFloatInput | null,
  comments?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEvaluationProvidersFilterInput | null > | null,
  or?: Array< ModelSubscriptionEvaluationProvidersFilterInput | null > | null,
};

export type ModelSubscriptionLogProductFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  creator?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionStringInput | null,
  productId?: ModelSubscriptionIDInput | null,
  description?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLogProductFilterInput | null > | null,
  or?: Array< ModelSubscriptionLogProductFilterInput | null > | null,
};

export type ModelSubscriptionLogRfqFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  creator?: ModelSubscriptionStringInput | null,
  rfqId?: ModelSubscriptionIDInput | null,
  description?: ModelSubscriptionStringInput | null,
  provider_id?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLogRfqFilterInput | null > | null,
  or?: Array< ModelSubscriptionLogRfqFilterInput | null > | null,
};

export type ModelSubscriptionLogProductLabelFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  creator?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionStringInput | null,
  productLabelId?: ModelSubscriptionIDInput | null,
  description?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLogProductLabelFilterInput | null > | null,
  or?: Array< ModelSubscriptionLogProductLabelFilterInput | null > | null,
};

export type ModelSubscriptionLogGanadorAutoFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  id_auto?: ModelSubscriptionIDInput | null,
  id_user?: ModelSubscriptionIDInput | null,
  fecha_rifa?: ModelSubscriptionIntInput | null,
  email?: ModelSubscriptionStringInput | null,
  nombre?: ModelSubscriptionStringInput | null,
  a_paterno?: ModelSubscriptionStringInput | null,
  a_materno?: ModelSubscriptionStringInput | null,
  status_buyer?: ModelSubscriptionBooleanInput | null,
  date_buyer?: ModelSubscriptionIntInput | null,
  winner?: ModelSubscriptionIntInput | null,
  refused?: ModelSubscriptionIntInput | null,
  since?: ModelSubscriptionStringInput | null,
  process_buyer?: ModelSubscriptionBooleanInput | null,
  reactive?: ModelSubscriptionBooleanInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLogGanadorAutoFilterInput | null > | null,
  or?: Array< ModelSubscriptionLogGanadorAutoFilterInput | null > | null,
};

export type ModelSubscriptionNotificationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  remember?: ModelSubscriptionStringInput | null,
  stared?: ModelSubscriptionStringInput | null,
  important?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  isChat?: ModelSubscriptionStringInput | null,
  creatorName?: ModelSubscriptionStringInput | null,
  creatorEmail?: ModelSubscriptionStringInput | null,
  creatorRole?: ModelSubscriptionStringInput | null,
  creatorId?: ModelSubscriptionIDInput | null,
  receipentName?: ModelSubscriptionStringInput | null,
  receipentRole?: ModelSubscriptionStringInput | null,
  receipentEmail?: ModelSubscriptionStringInput | null,
  receipentId?: ModelSubscriptionIDInput | null,
  showPopUp?: ModelSubscriptionBooleanInput | null,
  sendEmail?: ModelSubscriptionBooleanInput | null,
  title?: ModelSubscriptionStringInput | null,
  subtitle?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  path?: ModelSubscriptionStringInput | null,
  idParent?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  seenAt?: ModelSubscriptionIntInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionNotificationFilterInput | null > | null,
  or?: Array< ModelSubscriptionNotificationFilterInput | null > | null,
};

export type ModelSubscriptionMercadoCategoriesFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  idMercado?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  parentCategory?: ModelSubscriptionStringInput | null,
  childrenCategories?: ModelSubscriptionStringInput | null,
  items?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMercadoCategoriesFilterInput | null > | null,
  or?: Array< ModelSubscriptionMercadoCategoriesFilterInput | null > | null,
};

export type ModelSubscriptionMercadoProductCategoryClientFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  idClient?: ModelSubscriptionIDInput | null,
  idMercadoCategory?: ModelSubscriptionIDInput | null,
  unrestrictedProducts?: ModelSubscriptionStringInput | null,
  restrictedProducts?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMercadoProductCategoryClientFilterInput | null > | null,
  or?: Array< ModelSubscriptionMercadoProductCategoryClientFilterInput | null > | null,
};

export type ModelSubscriptionExternalApisFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  nameExternal?: ModelSubscriptionStringInput | null,
  region?: ModelSubscriptionStringInput | null,
  increment?: ModelSubscriptionFloatInput | null,
  discount?: ModelSubscriptionFloatInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionExternalApisFilterInput | null > | null,
  or?: Array< ModelSubscriptionExternalApisFilterInput | null > | null,
};

export type ModelSubscriptionPrintPricesFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  identifier?: ModelSubscriptionIntInput | null,
  status?: ModelSubscriptionStringInput | null,
  creator?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  price?: ModelSubscriptionFloatInput | null,
  minUnits?: ModelSubscriptionIntInput | null,
  maxUnits?: ModelSubscriptionIntInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPrintPricesFilterInput | null > | null,
  or?: Array< ModelSubscriptionPrintPricesFilterInput | null > | null,
};

export type ModelSubscriptionPrintLogosFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  creator?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  identifier?: ModelSubscriptionIntInput | null,
  clientId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPrintLogosFilterInput | null > | null,
  or?: Array< ModelSubscriptionPrintLogosFilterInput | null > | null,
};

export type ModelSubscriptionLogisticPostalCodeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  cpFrom?: ModelSubscriptionStringInput | null,
  cpTo?: ModelSubscriptionStringInput | null,
  zone?: ModelSubscriptionIntInput | null,
  state?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLogisticPostalCodeFilterInput | null > | null,
  or?: Array< ModelSubscriptionLogisticPostalCodeFilterInput | null > | null,
};

export type ModelSubscriptionLogisticPieceRangeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  piecesRange?: ModelSubscriptionIntInput | null,
  min?: ModelSubscriptionIntInput | null,
  max?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLogisticPieceRangeFilterInput | null > | null,
  or?: Array< ModelSubscriptionLogisticPieceRangeFilterInput | null > | null,
};

export type ModelSubscriptionLogisticWeightRangeFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  weightRange?: ModelSubscriptionIntInput | null,
  min?: ModelSubscriptionIntInput | null,
  max?: ModelSubscriptionIntInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLogisticWeightRangeFilterInput | null > | null,
  or?: Array< ModelSubscriptionLogisticWeightRangeFilterInput | null > | null,
};

export type ModelSubscriptionLogisticWeightBoxFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  boxId?: ModelSubscriptionIDInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLogisticWeightBoxFilterInput | null > | null,
  or?: Array< ModelSubscriptionLogisticWeightBoxFilterInput | null > | null,
};

export type ModelSubscriptionLogisticZoneFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  zoneName?: ModelSubscriptionStringInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLogisticZoneFilterInput | null > | null,
  or?: Array< ModelSubscriptionLogisticZoneFilterInput | null > | null,
};

export type ModelSubscriptionLogisticBoxFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  price?: ModelSubscriptionFloatInput | null,
  width?: ModelSubscriptionFloatInput | null,
  height?: ModelSubscriptionFloatInput | null,
  depth?: ModelSubscriptionFloatInput | null,
  volumetricWeight?: ModelSubscriptionFloatInput | null,
  maxWeight?: ModelSubscriptionFloatInput | null,
  maxPayload?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLogisticBoxFilterInput | null > | null,
  or?: Array< ModelSubscriptionLogisticBoxFilterInput | null > | null,
};

export type ModelSubscriptionLogisticVehiclesFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  licensePlate?: ModelSubscriptionStringInput | null,
  hasInsurancePolicy?: ModelSubscriptionStringInput | null,
  fuelCapacity?: ModelSubscriptionFloatInput | null,
  width?: ModelSubscriptionFloatInput | null,
  height?: ModelSubscriptionFloatInput | null,
  depth?: ModelSubscriptionFloatInput | null,
  maxWeight?: ModelSubscriptionFloatInput | null,
  created?: ModelSubscriptionIntInput | null,
  updated?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLogisticVehiclesFilterInput | null > | null,
  or?: Array< ModelSubscriptionLogisticVehiclesFilterInput | null > | null,
};

export type ModelSubscriptionPakmailCarrierFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  identifier?: ModelSubscriptionIntInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  region?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPakmailCarrierFilterInput | null > | null,
  or?: Array< ModelSubscriptionPakmailCarrierFilterInput | null > | null,
};

export type ModelSubscriptionPakmailServiceFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  identifier?: ModelSubscriptionStringInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  region?: ModelSubscriptionStringInput | null,
  isNational?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPakmailServiceFilterInput | null > | null,
  or?: Array< ModelSubscriptionPakmailServiceFilterInput | null > | null,
};

export type ModelSubscriptionPakmailShipmentStatusFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  identifier?: ModelSubscriptionIntInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPakmailShipmentStatusFilterInput | null > | null,
  or?: Array< ModelSubscriptionPakmailShipmentStatusFilterInput | null > | null,
};

export type ModelSubscriptionPakmailShipmentEventFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  identifier?: ModelSubscriptionStringInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  color?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPakmailShipmentEventFilterInput | null > | null,
  or?: Array< ModelSubscriptionPakmailShipmentEventFilterInput | null > | null,
};

export type ModelSubscriptionPakmailPickupStatusFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  identifier?: ModelSubscriptionIntInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPakmailPickupStatusFilterInput | null > | null,
  or?: Array< ModelSubscriptionPakmailPickupStatusFilterInput | null > | null,
};

export type ModelSubscriptionPremiumOrderLogisticGuideFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  pakmailId?: ModelSubscriptionStringInput | null,
  premiumOrderId?: ModelSubscriptionStringInput | null,
  clientId?: ModelSubscriptionStringInput | null,
  creatorId?: ModelSubscriptionStringInput | null,
  originAddressId?: ModelSubscriptionStringInput | null,
  destinationAddressId?: ModelSubscriptionStringInput | null,
  originAddress?: ModelSubscriptionStringInput | null,
  destinationAddress?: ModelSubscriptionStringInput | null,
  price?: ModelSubscriptionFloatInput | null,
  increment?: ModelSubscriptionFloatInput | null,
  fee?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPremiumOrderLogisticGuideFilterInput | null > | null,
  or?: Array< ModelSubscriptionPremiumOrderLogisticGuideFilterInput | null > | null,
};

export type ModelSubscriptionProductLabelItemFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  productId?: ModelSubscriptionIDInput | null,
  productLabelId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProductLabelItemFilterInput | null > | null,
  or?: Array< ModelSubscriptionProductLabelItemFilterInput | null > | null,
};

export type ModelSubscriptionProductLabelFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  translation?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProductLabelFilterInput | null > | null,
  or?: Array< ModelSubscriptionProductLabelFilterInput | null > | null,
};

export type ModelSubscriptionProductTextItemFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  productId?: ModelSubscriptionIDInput | null,
  productTextId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProductTextItemFilterInput | null > | null,
  or?: Array< ModelSubscriptionProductTextItemFilterInput | null > | null,
};

export type ModelSubscriptionProductTextFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  visibleFor?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProductTextFilterInput | null > | null,
  or?: Array< ModelSubscriptionProductTextFilterInput | null > | null,
};

export type ModelSubscriptionProductMaskFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  sku?: ModelSubscriptionStringInput | null,
  productId?: ModelSubscriptionStringInput | null,
  clientId?: ModelSubscriptionStringInput | null,
  filterColors?: ModelSubscriptionStringInput | null,
  increment?: ModelSubscriptionFloatInput | null,
  fee?: ModelSubscriptionFloatInput | null,
  discount?: ModelSubscriptionFloatInput | null,
  stock?: ModelSubscriptionIntInput | null,
  categoryId?: ModelSubscriptionStringInput | null,
  sellMode?: ModelSubscriptionStringInput | null,
  kitPieces?: ModelSubscriptionIntInput | null,
  kitIncrement?: ModelSubscriptionFloatInput | null,
  kitFee?: ModelSubscriptionFloatInput | null,
  stockMode?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProductMaskFilterInput | null > | null,
  or?: Array< ModelSubscriptionProductMaskFilterInput | null > | null,
};

export type ModelSubscriptionVariantMaskFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  filterColors?: ModelSubscriptionStringInput | null,
  stock?: ModelSubscriptionIntInput | null,
  stockMode?: ModelSubscriptionStringInput | null,
  productMaskId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionVariantMaskFilterInput | null > | null,
  or?: Array< ModelSubscriptionVariantMaskFilterInput | null > | null,
};

export type ModelSubscriptionProductMaskDescriptionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  long_description?: ModelSubscriptionStringInput | null,
  short_description?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProductMaskDescriptionFilterInput | null > | null,
  or?: Array< ModelSubscriptionProductMaskDescriptionFilterInput | null > | null,
};

export type ModelSubscriptionCouponFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  code?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  discountAmount?: ModelSubscriptionFloatInput | null,
  discountPercentage?: ModelSubscriptionFloatInput | null,
  minAmount?: ModelSubscriptionFloatInput | null,
  maxAmount?: ModelSubscriptionFloatInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  maxRedemptions?: ModelSubscriptionIntInput | null,
  maxRedemptionsPerUser?: ModelSubscriptionIntInput | null,
  applicableProducts?: ModelSubscriptionStringInput | null,
  applicableCategories?: ModelSubscriptionStringInput | null,
  excludedProducts?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCouponFilterInput | null > | null,
  or?: Array< ModelSubscriptionCouponFilterInput | null > | null,
};

export type ModelSubscriptionCouponRedemptionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  couponId?: ModelSubscriptionIDInput | null,
  couponCode?: ModelSubscriptionStringInput | null,
  userId?: ModelSubscriptionStringInput | null,
  clientId?: ModelSubscriptionStringInput | null,
  orderId?: ModelSubscriptionStringInput | null,
  cartId?: ModelSubscriptionStringInput | null,
  discountApplied?: ModelSubscriptionFloatInput | null,
  originalAmount?: ModelSubscriptionFloatInput | null,
  finalAmount?: ModelSubscriptionFloatInput | null,
  appliedAt?: ModelSubscriptionStringInput | null,
  ipAddress?: ModelSubscriptionStringInput | null,
  userAgent?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionCouponRedemptionFilterInput | null > | null,
  or?: Array< ModelSubscriptionCouponRedemptionFilterInput | null > | null,
};

export type ModelSubscriptionPromotionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  triggerProductIds?: ModelSubscriptionStringInput | null,
  minQuantity?: ModelSubscriptionIntInput | null,
  minAmount?: ModelSubscriptionFloatInput | null,
  triggerRule?: ModelSubscriptionStringInput | null,
  giftProductId?: ModelSubscriptionStringInput | null,
  giftQuantity?: ModelSubscriptionIntInput | null,
  isStackable?: ModelSubscriptionBooleanInput | null,
  applicableClientIds?: ModelSubscriptionStringInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  maxRedemptions?: ModelSubscriptionIntInput | null,
  maxRedemptionsPerUser?: ModelSubscriptionIntInput | null,
  status?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPromotionFilterInput | null > | null,
  or?: Array< ModelSubscriptionPromotionFilterInput | null > | null,
};

export type ModelSubscriptionPromotionRedemptionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  promotionId?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionStringInput | null,
  clientId?: ModelSubscriptionStringInput | null,
  orderId?: ModelSubscriptionStringInput | null,
  cartId?: ModelSubscriptionStringInput | null,
  triggerQuantity?: ModelSubscriptionIntInput | null,
  giftQuantityApplied?: ModelSubscriptionIntInput | null,
  appliedAt?: ModelSubscriptionStringInput | null,
  ipAddress?: ModelSubscriptionStringInput | null,
  userAgent?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPromotionRedemptionFilterInput | null > | null,
  or?: Array< ModelSubscriptionPromotionRedemptionFilterInput | null > | null,
};

export type ModelSubscriptionWalletBalanceFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  balance?: ModelSubscriptionFloatInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionWalletBalanceFilterInput | null > | null,
  or?: Array< ModelSubscriptionWalletBalanceFilterInput | null > | null,
};

export type ModelSubscriptionWalletMovementFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  amount?: ModelSubscriptionFloatInput | null,
  orderId?: ModelSubscriptionIDInput | null,
  createdByUserId?: ModelSubscriptionIDInput | null,
  couponId?: ModelSubscriptionIDInput | null,
  couponCode?: ModelSubscriptionStringInput | null,
  availableUntil?: ModelSubscriptionStringInput | null,
  isValidated?: ModelSubscriptionBooleanInput | null,
  validatedAt?: ModelSubscriptionStringInput | null,
  validatedBy?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionWalletMovementFilterInput | null > | null,
  or?: Array< ModelSubscriptionWalletMovementFilterInput | null > | null,
};

export type CreateClientMutationVariables = {
  input: CreateClientInput,
  condition?: ModelClientConditionInput | null,
};

export type CreateClientMutation = {
  createClient?:  {
    __typename: "Client",
    id: string,
    status?: boolean | null,
    business_name: string,
    comertial_name: string,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    grayLogo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    contact?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    biography?: string | null,
    plan?: string | null,
    fee?: number | null,
    increment?: number | null,
    mercadoFee?: number | null,
    mercadoIncrement?: number | null,
    popFee?: number | null,
    popIncrement?: number | null,
    printedFee?: number | null,
    printedIncrement?: number | null,
    users?: Array< string | null > | null,
    restrictedUsers?: Array< string | null > | null,
    nonRestrictedUsers?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    providers?: Array< string | null > | null,
    popProviders?: Array< string | null > | null,
    printedProviders?: Array< string | null > | null,
    logisticFrequency?: number | null,
    agents?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    administrators?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    signDocument?:  Array< {
      __typename: "Sign",
      url?: string | null,
      enabled?: boolean | null,
    } | null > | null,
    legal_representative?: string | null,
    legal_representative_email?: string | null,
    legal_representative_address?: string | null,
    tcdUsers?: Array< string | null > | null,
    billingUsers?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type UpdateClientMutationVariables = {
  input: UpdateClientInput,
  condition?: ModelClientConditionInput | null,
};

export type UpdateClientMutation = {
  updateClient?:  {
    __typename: "Client",
    id: string,
    status?: boolean | null,
    business_name: string,
    comertial_name: string,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    grayLogo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    contact?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    biography?: string | null,
    plan?: string | null,
    fee?: number | null,
    increment?: number | null,
    mercadoFee?: number | null,
    mercadoIncrement?: number | null,
    popFee?: number | null,
    popIncrement?: number | null,
    printedFee?: number | null,
    printedIncrement?: number | null,
    users?: Array< string | null > | null,
    restrictedUsers?: Array< string | null > | null,
    nonRestrictedUsers?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    providers?: Array< string | null > | null,
    popProviders?: Array< string | null > | null,
    printedProviders?: Array< string | null > | null,
    logisticFrequency?: number | null,
    agents?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    administrators?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    signDocument?:  Array< {
      __typename: "Sign",
      url?: string | null,
      enabled?: boolean | null,
    } | null > | null,
    legal_representative?: string | null,
    legal_representative_email?: string | null,
    legal_representative_address?: string | null,
    tcdUsers?: Array< string | null > | null,
    billingUsers?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type DeleteClientMutationVariables = {
  input: DeleteClientInput,
  condition?: ModelClientConditionInput | null,
};

export type DeleteClientMutation = {
  deleteClient?:  {
    __typename: "Client",
    id: string,
    status?: boolean | null,
    business_name: string,
    comertial_name: string,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    grayLogo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    contact?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    biography?: string | null,
    plan?: string | null,
    fee?: number | null,
    increment?: number | null,
    mercadoFee?: number | null,
    mercadoIncrement?: number | null,
    popFee?: number | null,
    popIncrement?: number | null,
    printedFee?: number | null,
    printedIncrement?: number | null,
    users?: Array< string | null > | null,
    restrictedUsers?: Array< string | null > | null,
    nonRestrictedUsers?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    providers?: Array< string | null > | null,
    popProviders?: Array< string | null > | null,
    printedProviders?: Array< string | null > | null,
    logisticFrequency?: number | null,
    agents?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    administrators?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    signDocument?:  Array< {
      __typename: "Sign",
      url?: string | null,
      enabled?: boolean | null,
    } | null > | null,
    legal_representative?: string | null,
    legal_representative_email?: string | null,
    legal_representative_address?: string | null,
    tcdUsers?: Array< string | null > | null,
    billingUsers?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type CreateClientSettingMutationVariables = {
  input: CreateClientSettingInput,
  condition?: ModelClientSettingConditionInput | null,
};

export type CreateClientSettingMutation = {
  createClientSetting?:  {
    __typename: "ClientSetting",
    id: string,
    crmJiraId?: string | null,
    orderBudget?: number | null,
    domain?: string | null,
    filterColors?: Array< string | null > | null,
    primaryColors?: Array< string | null > | null,
    accentColors?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateClientSettingMutationVariables = {
  input: UpdateClientSettingInput,
  condition?: ModelClientSettingConditionInput | null,
};

export type UpdateClientSettingMutation = {
  updateClientSetting?:  {
    __typename: "ClientSetting",
    id: string,
    crmJiraId?: string | null,
    orderBudget?: number | null,
    domain?: string | null,
    filterColors?: Array< string | null > | null,
    primaryColors?: Array< string | null > | null,
    accentColors?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteClientSettingMutationVariables = {
  input: DeleteClientSettingInput,
  condition?: ModelClientSettingConditionInput | null,
};

export type DeleteClientSettingMutation = {
  deleteClientSetting?:  {
    __typename: "ClientSetting",
    id: string,
    crmJiraId?: string | null,
    orderBudget?: number | null,
    domain?: string | null,
    filterColors?: Array< string | null > | null,
    primaryColors?: Array< string | null > | null,
    accentColors?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateClientOptionMutationVariables = {
  input: CreateClientOptionInput,
  condition?: ModelClientOptionConditionInput | null,
};

export type CreateClientOptionMutation = {
  createClientOption?:  {
    __typename: "ClientOption",
    id: string,
    pakmail?: boolean | null,
    orderVat?: boolean | null,
    hasMercado?: boolean | null,
    hasAmazon?: boolean | null,
    hasAutomobiles?: boolean | null,
    publicDashboards?: boolean | null,
    printPrices?: boolean | null,
    logisticPrices?: boolean | null,
    hidePricesAndFlow?: boolean | null,
    showPhones?: boolean | null,
    fullCoupaDescriptions?: boolean | null,
    isPremium?: boolean | null,
    isPop?: boolean | null,
    isPrinted?: boolean | null,
    allPremiumRfqs?: boolean | null,
    allPopRfqs?: boolean | null,
    allPrintedRfqs?: boolean | null,
    autoUpdateHomePage?: boolean | null,
    showVat?: boolean | null,
    requiredDeliveryInfo?: boolean | null,
    restrictedCatalogue?: boolean | null,
    excludeCoupa?: boolean | null,
    tcdPayment?: boolean | null,
    automaticLogisticGuides?: boolean | null,
    transferencePayment?: boolean | null,
    customCatalogue?: boolean | null,
    disableProjectDescriptions?: boolean | null,
    showBranding?: boolean | null,
    customCostCenter?: boolean | null,
    couponsEnabled?: boolean | null,
    showChat?: boolean | null,
    hasCrmSync?: boolean | null,
    onlyQuotes?: boolean | null,
    autoSaveDeliveryInfo?: boolean | null,
    limitMaxRequestOnDiscounts?: boolean | null,
    freeLocalShipping?: boolean | null,
    discountShipping?: boolean | null,
    printingBreakdown?: boolean | null,
    skipAlendum?: boolean | null,
    skipFMS?: boolean | null,
    clientReminders?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateClientOptionMutationVariables = {
  input: UpdateClientOptionInput,
  condition?: ModelClientOptionConditionInput | null,
};

export type UpdateClientOptionMutation = {
  updateClientOption?:  {
    __typename: "ClientOption",
    id: string,
    pakmail?: boolean | null,
    orderVat?: boolean | null,
    hasMercado?: boolean | null,
    hasAmazon?: boolean | null,
    hasAutomobiles?: boolean | null,
    publicDashboards?: boolean | null,
    printPrices?: boolean | null,
    logisticPrices?: boolean | null,
    hidePricesAndFlow?: boolean | null,
    showPhones?: boolean | null,
    fullCoupaDescriptions?: boolean | null,
    isPremium?: boolean | null,
    isPop?: boolean | null,
    isPrinted?: boolean | null,
    allPremiumRfqs?: boolean | null,
    allPopRfqs?: boolean | null,
    allPrintedRfqs?: boolean | null,
    autoUpdateHomePage?: boolean | null,
    showVat?: boolean | null,
    requiredDeliveryInfo?: boolean | null,
    restrictedCatalogue?: boolean | null,
    excludeCoupa?: boolean | null,
    tcdPayment?: boolean | null,
    automaticLogisticGuides?: boolean | null,
    transferencePayment?: boolean | null,
    customCatalogue?: boolean | null,
    disableProjectDescriptions?: boolean | null,
    showBranding?: boolean | null,
    customCostCenter?: boolean | null,
    couponsEnabled?: boolean | null,
    showChat?: boolean | null,
    hasCrmSync?: boolean | null,
    onlyQuotes?: boolean | null,
    autoSaveDeliveryInfo?: boolean | null,
    limitMaxRequestOnDiscounts?: boolean | null,
    freeLocalShipping?: boolean | null,
    discountShipping?: boolean | null,
    printingBreakdown?: boolean | null,
    skipAlendum?: boolean | null,
    skipFMS?: boolean | null,
    clientReminders?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteClientOptionMutationVariables = {
  input: DeleteClientOptionInput,
  condition?: ModelClientOptionConditionInput | null,
};

export type DeleteClientOptionMutation = {
  deleteClientOption?:  {
    __typename: "ClientOption",
    id: string,
    pakmail?: boolean | null,
    orderVat?: boolean | null,
    hasMercado?: boolean | null,
    hasAmazon?: boolean | null,
    hasAutomobiles?: boolean | null,
    publicDashboards?: boolean | null,
    printPrices?: boolean | null,
    logisticPrices?: boolean | null,
    hidePricesAndFlow?: boolean | null,
    showPhones?: boolean | null,
    fullCoupaDescriptions?: boolean | null,
    isPremium?: boolean | null,
    isPop?: boolean | null,
    isPrinted?: boolean | null,
    allPremiumRfqs?: boolean | null,
    allPopRfqs?: boolean | null,
    allPrintedRfqs?: boolean | null,
    autoUpdateHomePage?: boolean | null,
    showVat?: boolean | null,
    requiredDeliveryInfo?: boolean | null,
    restrictedCatalogue?: boolean | null,
    excludeCoupa?: boolean | null,
    tcdPayment?: boolean | null,
    automaticLogisticGuides?: boolean | null,
    transferencePayment?: boolean | null,
    customCatalogue?: boolean | null,
    disableProjectDescriptions?: boolean | null,
    showBranding?: boolean | null,
    customCostCenter?: boolean | null,
    couponsEnabled?: boolean | null,
    showChat?: boolean | null,
    hasCrmSync?: boolean | null,
    onlyQuotes?: boolean | null,
    autoSaveDeliveryInfo?: boolean | null,
    limitMaxRequestOnDiscounts?: boolean | null,
    freeLocalShipping?: boolean | null,
    discountShipping?: boolean | null,
    printingBreakdown?: boolean | null,
    skipAlendum?: boolean | null,
    skipFMS?: boolean | null,
    clientReminders?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateProviderMutationVariables = {
  input: CreateProviderInput,
  condition?: ModelProviderConditionInput | null,
};

export type CreateProviderMutation = {
  createProvider?:  {
    __typename: "Provider",
    id: string,
    isApproved?: boolean | null,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    grayLogo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comertial_name?: string | null,
    bussiness_name?:  {
      __typename: "BusinessName",
      tax_residence?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      rfc?: string | null,
      name?: string | null,
    } | null,
    idProcter?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    contact?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null,
    biography?: string | null,
    constancia?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comprobante?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    experience?: string | null,
    pros?: Array< string | null > | null,
    cons?: Array< string | null > | null,
    cte_rating?:  Array< {
      __typename: "Rating",
      name?: string | null,
      rating?: number | null,
    } | null > | null,
    shopping_rating?:  Array< {
      __typename: "Rating",
      name?: string | null,
      rating?: number | null,
    } | null > | null,
    video?: string | null,
    tags?: Array< string | null > | null,
    money_filter_c?: boolean | null,
    money_filter_d?: boolean | null,
    users?: Array< string | null > | null,
    bank?: string | null,
    account?: string | null,
    clabe?: string | null,
    cuenta_correo?: string | null,
    edocuenta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    ife?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    poderes?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    acta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    isProvider?: boolean | null,
    sameAddress?: boolean | null,
    isPop?: boolean | null,
    isPrinted?: boolean | null,
    hasLogistic?: boolean | null,
    created?: number | null,
    updated?: number | null,
    addFiles?:  Array< {
      __typename: "SignFile",
      key?: string | null,
      url?: string | null,
      sign?: string | null,
      status?: string | null,
    } | null > | null,
    signFiles?:  Array< {
      __typename: "SignFile",
      key?: string | null,
      url?: string | null,
      sign?: string | null,
      status?: string | null,
    } | null > | null,
    representante_legal?: string | null,
    escritura_constitucion?: string | null,
    notario_a?: string | null,
    constituido_down_edo?: string | null,
    rrpp?: string | null,
    isPremium?: boolean | null,
    isTrustProvider?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateProviderMutationVariables = {
  input: UpdateProviderInput,
  condition?: ModelProviderConditionInput | null,
};

export type UpdateProviderMutation = {
  updateProvider?:  {
    __typename: "Provider",
    id: string,
    isApproved?: boolean | null,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    grayLogo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comertial_name?: string | null,
    bussiness_name?:  {
      __typename: "BusinessName",
      tax_residence?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      rfc?: string | null,
      name?: string | null,
    } | null,
    idProcter?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    contact?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null,
    biography?: string | null,
    constancia?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comprobante?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    experience?: string | null,
    pros?: Array< string | null > | null,
    cons?: Array< string | null > | null,
    cte_rating?:  Array< {
      __typename: "Rating",
      name?: string | null,
      rating?: number | null,
    } | null > | null,
    shopping_rating?:  Array< {
      __typename: "Rating",
      name?: string | null,
      rating?: number | null,
    } | null > | null,
    video?: string | null,
    tags?: Array< string | null > | null,
    money_filter_c?: boolean | null,
    money_filter_d?: boolean | null,
    users?: Array< string | null > | null,
    bank?: string | null,
    account?: string | null,
    clabe?: string | null,
    cuenta_correo?: string | null,
    edocuenta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    ife?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    poderes?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    acta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    isProvider?: boolean | null,
    sameAddress?: boolean | null,
    isPop?: boolean | null,
    isPrinted?: boolean | null,
    hasLogistic?: boolean | null,
    created?: number | null,
    updated?: number | null,
    addFiles?:  Array< {
      __typename: "SignFile",
      key?: string | null,
      url?: string | null,
      sign?: string | null,
      status?: string | null,
    } | null > | null,
    signFiles?:  Array< {
      __typename: "SignFile",
      key?: string | null,
      url?: string | null,
      sign?: string | null,
      status?: string | null,
    } | null > | null,
    representante_legal?: string | null,
    escritura_constitucion?: string | null,
    notario_a?: string | null,
    constituido_down_edo?: string | null,
    rrpp?: string | null,
    isPremium?: boolean | null,
    isTrustProvider?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteProviderMutationVariables = {
  input: DeleteProviderInput,
  condition?: ModelProviderConditionInput | null,
};

export type DeleteProviderMutation = {
  deleteProvider?:  {
    __typename: "Provider",
    id: string,
    isApproved?: boolean | null,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    grayLogo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comertial_name?: string | null,
    bussiness_name?:  {
      __typename: "BusinessName",
      tax_residence?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      rfc?: string | null,
      name?: string | null,
    } | null,
    idProcter?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    contact?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null,
    biography?: string | null,
    constancia?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comprobante?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    experience?: string | null,
    pros?: Array< string | null > | null,
    cons?: Array< string | null > | null,
    cte_rating?:  Array< {
      __typename: "Rating",
      name?: string | null,
      rating?: number | null,
    } | null > | null,
    shopping_rating?:  Array< {
      __typename: "Rating",
      name?: string | null,
      rating?: number | null,
    } | null > | null,
    video?: string | null,
    tags?: Array< string | null > | null,
    money_filter_c?: boolean | null,
    money_filter_d?: boolean | null,
    users?: Array< string | null > | null,
    bank?: string | null,
    account?: string | null,
    clabe?: string | null,
    cuenta_correo?: string | null,
    edocuenta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    ife?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    poderes?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    acta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    isProvider?: boolean | null,
    sameAddress?: boolean | null,
    isPop?: boolean | null,
    isPrinted?: boolean | null,
    hasLogistic?: boolean | null,
    created?: number | null,
    updated?: number | null,
    addFiles?:  Array< {
      __typename: "SignFile",
      key?: string | null,
      url?: string | null,
      sign?: string | null,
      status?: string | null,
    } | null > | null,
    signFiles?:  Array< {
      __typename: "SignFile",
      key?: string | null,
      url?: string | null,
      sign?: string | null,
      status?: string | null,
    } | null > | null,
    representante_legal?: string | null,
    escritura_constitucion?: string | null,
    notario_a?: string | null,
    constituido_down_edo?: string | null,
    rrpp?: string | null,
    isPremium?: boolean | null,
    isTrustProvider?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateProviderSettingMutationVariables = {
  input: CreateProviderSettingInput,
  condition?: ModelProviderSettingConditionInput | null,
};

export type CreateProviderSettingMutation = {
  createProviderSetting?:  {
    __typename: "ProviderSetting",
    id: string,
    primaryColors?: Array< string | null > | null,
    accentColors?: Array< string | null > | null,
    categories?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateProviderSettingMutationVariables = {
  input: UpdateProviderSettingInput,
  condition?: ModelProviderSettingConditionInput | null,
};

export type UpdateProviderSettingMutation = {
  updateProviderSetting?:  {
    __typename: "ProviderSetting",
    id: string,
    primaryColors?: Array< string | null > | null,
    accentColors?: Array< string | null > | null,
    categories?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteProviderSettingMutationVariables = {
  input: DeleteProviderSettingInput,
  condition?: ModelProviderSettingConditionInput | null,
};

export type DeleteProviderSettingMutation = {
  deleteProviderSetting?:  {
    __typename: "ProviderSetting",
    id: string,
    primaryColors?: Array< string | null > | null,
    accentColors?: Array< string | null > | null,
    categories?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateProviderFileMutationVariables = {
  input: CreateProviderFileInput,
  condition?: ModelProviderFileConditionInput | null,
};

export type CreateProviderFileMutation = {
  createProviderFile?:  {
    __typename: "ProviderFile",
    id: string,
    acta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    constancia?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comprobante?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    edocuenta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    ife?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    poderes?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateProviderFileMutationVariables = {
  input: UpdateProviderFileInput,
  condition?: ModelProviderFileConditionInput | null,
};

export type UpdateProviderFileMutation = {
  updateProviderFile?:  {
    __typename: "ProviderFile",
    id: string,
    acta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    constancia?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comprobante?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    edocuenta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    ife?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    poderes?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteProviderFileMutationVariables = {
  input: DeleteProviderFileInput,
  condition?: ModelProviderFileConditionInput | null,
};

export type DeleteProviderFileMutation = {
  deleteProviderFile?:  {
    __typename: "ProviderFile",
    id: string,
    acta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    constancia?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comprobante?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    edocuenta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    ife?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    poderes?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateColorsMutationVariables = {
  input: CreateColorsInput,
  condition?: ModelColorsConditionInput | null,
};

export type CreateColorsMutation = {
  createColors?:  {
    __typename: "Colors",
    id: string,
    status: string,
    name: string,
    rgb: string,
    hex: string,
    position?: number | null,
    variantNames?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateColorsMutationVariables = {
  input: UpdateColorsInput,
  condition?: ModelColorsConditionInput | null,
};

export type UpdateColorsMutation = {
  updateColors?:  {
    __typename: "Colors",
    id: string,
    status: string,
    name: string,
    rgb: string,
    hex: string,
    position?: number | null,
    variantNames?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteColorsMutationVariables = {
  input: DeleteColorsInput,
  condition?: ModelColorsConditionInput | null,
};

export type DeleteColorsMutation = {
  deleteColors?:  {
    __typename: "Colors",
    id: string,
    status: string,
    name: string,
    rgb: string,
    hex: string,
    position?: number | null,
    variantNames?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateHomePageCarouselBannerMutationVariables = {
  input: CreateHomePageCarouselBannerInput,
  condition?: ModelHomePageCarouselBannerConditionInput | null,
};

export type CreateHomePageCarouselBannerMutation = {
  createHomePageCarouselBanner?:  {
    __typename: "HomePageCarouselBanner",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    title?: string | null,
    subtitle?: string | null,
    copy?: string | null,
    path?: string | null,
    bgImage?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    position?: number | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateHomePageCarouselBannerMutationVariables = {
  input: UpdateHomePageCarouselBannerInput,
  condition?: ModelHomePageCarouselBannerConditionInput | null,
};

export type UpdateHomePageCarouselBannerMutation = {
  updateHomePageCarouselBanner?:  {
    __typename: "HomePageCarouselBanner",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    title?: string | null,
    subtitle?: string | null,
    copy?: string | null,
    path?: string | null,
    bgImage?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    position?: number | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteHomePageCarouselBannerMutationVariables = {
  input: DeleteHomePageCarouselBannerInput,
  condition?: ModelHomePageCarouselBannerConditionInput | null,
};

export type DeleteHomePageCarouselBannerMutation = {
  deleteHomePageCarouselBanner?:  {
    __typename: "HomePageCarouselBanner",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    title?: string | null,
    subtitle?: string | null,
    copy?: string | null,
    path?: string | null,
    bgImage?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    position?: number | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateHomePageMutationVariables = {
  input: CreateHomePageInput,
  condition?: ModelHomePageConditionInput | null,
};

export type CreateHomePageMutation = {
  createHomePage?:  {
    __typename: "HomePage",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    showArrow?: boolean | null,
    showNumeration?: boolean | null,
    icon?: string | null,
    title?: string | null,
    subtitle?: string | null,
    body?: string | null,
    route?: string | null,
    titlePosition?: string | null,
    textAlign?: string | null,
    bgImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bgColor?: string | null,
    borderColor?: string | null,
    textColor?: string | null,
    position?: number | null,
    verticalLine?: boolean | null,
    browseButton?: boolean | null,
    visibleFor?: Array< string | null > | null,
    visibleForUserBrand?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateHomePageMutationVariables = {
  input: UpdateHomePageInput,
  condition?: ModelHomePageConditionInput | null,
};

export type UpdateHomePageMutation = {
  updateHomePage?:  {
    __typename: "HomePage",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    showArrow?: boolean | null,
    showNumeration?: boolean | null,
    icon?: string | null,
    title?: string | null,
    subtitle?: string | null,
    body?: string | null,
    route?: string | null,
    titlePosition?: string | null,
    textAlign?: string | null,
    bgImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bgColor?: string | null,
    borderColor?: string | null,
    textColor?: string | null,
    position?: number | null,
    verticalLine?: boolean | null,
    browseButton?: boolean | null,
    visibleFor?: Array< string | null > | null,
    visibleForUserBrand?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteHomePageMutationVariables = {
  input: DeleteHomePageInput,
  condition?: ModelHomePageConditionInput | null,
};

export type DeleteHomePageMutation = {
  deleteHomePage?:  {
    __typename: "HomePage",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    showArrow?: boolean | null,
    showNumeration?: boolean | null,
    icon?: string | null,
    title?: string | null,
    subtitle?: string | null,
    body?: string | null,
    route?: string | null,
    titlePosition?: string | null,
    textAlign?: string | null,
    bgImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bgColor?: string | null,
    borderColor?: string | null,
    textColor?: string | null,
    position?: number | null,
    verticalLine?: boolean | null,
    browseButton?: boolean | null,
    visibleFor?: Array< string | null > | null,
    visibleForUserBrand?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateHomePageBottomBannerMutationVariables = {
  input: CreateHomePageBottomBannerInput,
  condition?: ModelHomePageBottomBannerConditionInput | null,
};

export type CreateHomePageBottomBannerMutation = {
  createHomePageBottomBanner?:  {
    __typename: "HomePageBottomBanner",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    title?: string | null,
    subtitle?: string | null,
    icon?: string | null,
    route?: string | null,
    showArrow?: boolean | null,
    bannerImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bgColor?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateHomePageBottomBannerMutationVariables = {
  input: UpdateHomePageBottomBannerInput,
  condition?: ModelHomePageBottomBannerConditionInput | null,
};

export type UpdateHomePageBottomBannerMutation = {
  updateHomePageBottomBanner?:  {
    __typename: "HomePageBottomBanner",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    title?: string | null,
    subtitle?: string | null,
    icon?: string | null,
    route?: string | null,
    showArrow?: boolean | null,
    bannerImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bgColor?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteHomePageBottomBannerMutationVariables = {
  input: DeleteHomePageBottomBannerInput,
  condition?: ModelHomePageBottomBannerConditionInput | null,
};

export type DeleteHomePageBottomBannerMutation = {
  deleteHomePageBottomBanner?:  {
    __typename: "HomePageBottomBanner",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    title?: string | null,
    subtitle?: string | null,
    icon?: string | null,
    route?: string | null,
    showArrow?: boolean | null,
    bannerImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bgColor?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateProductoMutationVariables = {
  input: CreateProductoInput,
  condition?: ModelProductoConditionInput | null,
};

export type CreateProductoMutation = {
  createProducto?:  {
    __typename: "Producto",
    id: string,
    providerId: string,
    categoryId: string,
    name: string,
    status?: string | null,
    bestSeller?: string | null,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    order?: number | null,
    sku: string,
    brand?: string | null,
    colors?: Array< string | null > | null,
    pgClasitication?: string | null,
    delivery_time?: string | null,
    delivery_time_units?: string | null,
    stock?: number | null,
    minRequest?: number | null,
    maxRequest?: number | null,
    article_of_clothing?: boolean | null,
    size?: string | null,
    price: number,
    long_description: string,
    short_description: string,
    creator?: string | null,
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    category:  {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    },
    isExternal?: boolean | null,
    isAllowable?: boolean | null,
    isRestricted?: boolean | null,
    isAutoSkipped?: string | null,
    isAutoAllowed?: string | null,
    isPurse?: boolean | null,
    massiveLayout?: string | null,
    hasBaseAmmount?: boolean | null,
    isFreeAmmount?: boolean | null,
    isCard?: boolean | null,
    isByRequest?: boolean | null,
    isMultiPrice?: boolean | null,
    cardBaseAmmount?: number | null,
    minCardBaseAmmount?: number | null,
    maxCardBaseAmmount?: number | null,
    nameExternal?: string | null,
    unspsc?: string | null,
    variants?:  Array< {
      __typename: "Variants",
      sku?: string | null,
      name?: string | null,
      description?: string | null,
      colors?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock_available?: number | null,
      price?: number | null,
      size?: string | null,
      logoType?: string | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientIncrementPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    productDescriptionItem?:  Array< {
      __typename: "ProductDescriptionItem",
      index?: number | null,
      status?: boolean | null,
      key?: string | null,
      description?: string | null,
    } | null > | null,
    source?: string | null,
    trazoProductId?: string | null,
    trazoCategoryId?: string | null,
    stockUpdatedAt?: string | null,
    priceUpdatedAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateProductoMutationVariables = {
  input: UpdateProductoInput,
  condition?: ModelProductoConditionInput | null,
};

export type UpdateProductoMutation = {
  updateProducto?:  {
    __typename: "Producto",
    id: string,
    providerId: string,
    categoryId: string,
    name: string,
    status?: string | null,
    bestSeller?: string | null,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    order?: number | null,
    sku: string,
    brand?: string | null,
    colors?: Array< string | null > | null,
    pgClasitication?: string | null,
    delivery_time?: string | null,
    delivery_time_units?: string | null,
    stock?: number | null,
    minRequest?: number | null,
    maxRequest?: number | null,
    article_of_clothing?: boolean | null,
    size?: string | null,
    price: number,
    long_description: string,
    short_description: string,
    creator?: string | null,
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    category:  {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    },
    isExternal?: boolean | null,
    isAllowable?: boolean | null,
    isRestricted?: boolean | null,
    isAutoSkipped?: string | null,
    isAutoAllowed?: string | null,
    isPurse?: boolean | null,
    massiveLayout?: string | null,
    hasBaseAmmount?: boolean | null,
    isFreeAmmount?: boolean | null,
    isCard?: boolean | null,
    isByRequest?: boolean | null,
    isMultiPrice?: boolean | null,
    cardBaseAmmount?: number | null,
    minCardBaseAmmount?: number | null,
    maxCardBaseAmmount?: number | null,
    nameExternal?: string | null,
    unspsc?: string | null,
    variants?:  Array< {
      __typename: "Variants",
      sku?: string | null,
      name?: string | null,
      description?: string | null,
      colors?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock_available?: number | null,
      price?: number | null,
      size?: string | null,
      logoType?: string | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientIncrementPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    productDescriptionItem?:  Array< {
      __typename: "ProductDescriptionItem",
      index?: number | null,
      status?: boolean | null,
      key?: string | null,
      description?: string | null,
    } | null > | null,
    source?: string | null,
    trazoProductId?: string | null,
    trazoCategoryId?: string | null,
    stockUpdatedAt?: string | null,
    priceUpdatedAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteProductoMutationVariables = {
  input: DeleteProductoInput,
  condition?: ModelProductoConditionInput | null,
};

export type DeleteProductoMutation = {
  deleteProducto?:  {
    __typename: "Producto",
    id: string,
    providerId: string,
    categoryId: string,
    name: string,
    status?: string | null,
    bestSeller?: string | null,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    order?: number | null,
    sku: string,
    brand?: string | null,
    colors?: Array< string | null > | null,
    pgClasitication?: string | null,
    delivery_time?: string | null,
    delivery_time_units?: string | null,
    stock?: number | null,
    minRequest?: number | null,
    maxRequest?: number | null,
    article_of_clothing?: boolean | null,
    size?: string | null,
    price: number,
    long_description: string,
    short_description: string,
    creator?: string | null,
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    category:  {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    },
    isExternal?: boolean | null,
    isAllowable?: boolean | null,
    isRestricted?: boolean | null,
    isAutoSkipped?: string | null,
    isAutoAllowed?: string | null,
    isPurse?: boolean | null,
    massiveLayout?: string | null,
    hasBaseAmmount?: boolean | null,
    isFreeAmmount?: boolean | null,
    isCard?: boolean | null,
    isByRequest?: boolean | null,
    isMultiPrice?: boolean | null,
    cardBaseAmmount?: number | null,
    minCardBaseAmmount?: number | null,
    maxCardBaseAmmount?: number | null,
    nameExternal?: string | null,
    unspsc?: string | null,
    variants?:  Array< {
      __typename: "Variants",
      sku?: string | null,
      name?: string | null,
      description?: string | null,
      colors?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock_available?: number | null,
      price?: number | null,
      size?: string | null,
      logoType?: string | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientIncrementPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    productDescriptionItem?:  Array< {
      __typename: "ProductDescriptionItem",
      index?: number | null,
      status?: boolean | null,
      key?: string | null,
      description?: string | null,
    } | null > | null,
    source?: string | null,
    trazoProductId?: string | null,
    trazoCategoryId?: string | null,
    stockUpdatedAt?: string | null,
    priceUpdatedAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateProductVariantMutationVariables = {
  input: CreateProductVariantInput,
  condition?: ModelProductVariantConditionInput | null,
};

export type CreateProductVariantMutation = {
  createProductVariant?:  {
    __typename: "ProductVariant",
    id: string,
    productId?: string | null,
    sku?: string | null,
    name?: string | null,
    description?: string | null,
    colors?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    image?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    stock_available?: number | null,
    price?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateProductVariantMutationVariables = {
  input: UpdateProductVariantInput,
  condition?: ModelProductVariantConditionInput | null,
};

export type UpdateProductVariantMutation = {
  updateProductVariant?:  {
    __typename: "ProductVariant",
    id: string,
    productId?: string | null,
    sku?: string | null,
    name?: string | null,
    description?: string | null,
    colors?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    image?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    stock_available?: number | null,
    price?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteProductVariantMutationVariables = {
  input: DeleteProductVariantInput,
  condition?: ModelProductVariantConditionInput | null,
};

export type DeleteProductVariantMutation = {
  deleteProductVariant?:  {
    __typename: "ProductVariant",
    id: string,
    productId?: string | null,
    sku?: string | null,
    name?: string | null,
    description?: string | null,
    colors?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    image?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    stock_available?: number | null,
    price?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateProductOptionMutationVariables = {
  input: CreateProductOptionInput,
  condition?: ModelProductOptionConditionInput | null,
};

export type CreateProductOptionMutation = {
  createProductOption?:  {
    __typename: "ProductOption",
    id: string,
    ownOrder?: string | null,
    isPangga?: string | null,
    volumetricWeight?: string | null,
    isEvaluated?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateProductOptionMutationVariables = {
  input: UpdateProductOptionInput,
  condition?: ModelProductOptionConditionInput | null,
};

export type UpdateProductOptionMutation = {
  updateProductOption?:  {
    __typename: "ProductOption",
    id: string,
    ownOrder?: string | null,
    isPangga?: string | null,
    volumetricWeight?: string | null,
    isEvaluated?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteProductOptionMutationVariables = {
  input: DeleteProductOptionInput,
  condition?: ModelProductOptionConditionInput | null,
};

export type DeleteProductOptionMutation = {
  deleteProductOption?:  {
    __typename: "ProductOption",
    id: string,
    ownOrder?: string | null,
    isPangga?: string | null,
    volumetricWeight?: string | null,
    isEvaluated?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateProductDimentionMutationVariables = {
  input: CreateProductDimentionInput,
  condition?: ModelProductDimentionConditionInput | null,
};

export type CreateProductDimentionMutation = {
  createProductDimention?:  {
    __typename: "ProductDimention",
    id: string,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    weight?: number | null,
    boxWidth?: number | null,
    boxHeight?: number | null,
    boxDepth?: number | null,
    boxWeight?: number | null,
    boxQuantity?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateProductDimentionMutationVariables = {
  input: UpdateProductDimentionInput,
  condition?: ModelProductDimentionConditionInput | null,
};

export type UpdateProductDimentionMutation = {
  updateProductDimention?:  {
    __typename: "ProductDimention",
    id: string,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    weight?: number | null,
    boxWidth?: number | null,
    boxHeight?: number | null,
    boxDepth?: number | null,
    boxWeight?: number | null,
    boxQuantity?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteProductDimentionMutationVariables = {
  input: DeleteProductDimentionInput,
  condition?: ModelProductDimentionConditionInput | null,
};

export type DeleteProductDimentionMutation = {
  deleteProductDimention?:  {
    __typename: "ProductDimention",
    id: string,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    weight?: number | null,
    boxWidth?: number | null,
    boxHeight?: number | null,
    boxDepth?: number | null,
    boxWeight?: number | null,
    boxQuantity?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateMassiveChangeLayoutsMutationVariables = {
  input: CreateMassiveChangeLayoutsInput,
  condition?: ModelMassiveChangeLayoutsConditionInput | null,
};

export type CreateMassiveChangeLayoutsMutation = {
  createMassiveChangeLayouts?:  {
    __typename: "MassiveChangeLayouts",
    id: string,
    type?: string | null,
    status?: string | null,
    providerId?: string | null,
    creatorId?: string | null,
    creatorRole?: string | null,
    productsNumber?: number | null,
    file?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateMassiveChangeLayoutsMutationVariables = {
  input: UpdateMassiveChangeLayoutsInput,
  condition?: ModelMassiveChangeLayoutsConditionInput | null,
};

export type UpdateMassiveChangeLayoutsMutation = {
  updateMassiveChangeLayouts?:  {
    __typename: "MassiveChangeLayouts",
    id: string,
    type?: string | null,
    status?: string | null,
    providerId?: string | null,
    creatorId?: string | null,
    creatorRole?: string | null,
    productsNumber?: number | null,
    file?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteMassiveChangeLayoutsMutationVariables = {
  input: DeleteMassiveChangeLayoutsInput,
  condition?: ModelMassiveChangeLayoutsConditionInput | null,
};

export type DeleteMassiveChangeLayoutsMutation = {
  deleteMassiveChangeLayouts?:  {
    __typename: "MassiveChangeLayouts",
    id: string,
    type?: string | null,
    status?: string | null,
    providerId?: string | null,
    creatorId?: string | null,
    creatorRole?: string | null,
    productsNumber?: number | null,
    file?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateCategoryMutationVariables = {
  input: CreateCategoryInput,
  condition?: ModelCategoryConditionInput | null,
};

export type CreateCategoryMutation = {
  createCategory?:  {
    __typename: "Category",
    id: string,
    name: string,
    description?: string | null,
    unspsc?: string | null,
    image:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    },
    imageMobile?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    visibleForUserBrand?: Array< string | null > | null,
    region?: Array< string | null > | null,
    tags?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    hasAllowables?: boolean | null,
    hasPreapproveds?: boolean | null,
    hasRestricted?: boolean | null,
    isPublic?: boolean | null,
    isTop?: boolean | null,
    createdAt?: string | null,
    slug?: string | null,
    parentId?: string | null,
    rootId?: string | null,
    path?: string | null,
    status?: string | null,
    pathIds?: Array< string | null > | null,
    source?: string | null,
    trazoCategoryId?: string | null,
    nameExternal?: string | null,
    depth?: number | null,
    childrenCount?: number | null,
    isLeaf?: boolean | null,
    oldVersion?: string | null,
    productLine?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateCategoryMutationVariables = {
  input: UpdateCategoryInput,
  condition?: ModelCategoryConditionInput | null,
};

export type UpdateCategoryMutation = {
  updateCategory?:  {
    __typename: "Category",
    id: string,
    name: string,
    description?: string | null,
    unspsc?: string | null,
    image:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    },
    imageMobile?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    visibleForUserBrand?: Array< string | null > | null,
    region?: Array< string | null > | null,
    tags?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    hasAllowables?: boolean | null,
    hasPreapproveds?: boolean | null,
    hasRestricted?: boolean | null,
    isPublic?: boolean | null,
    isTop?: boolean | null,
    createdAt?: string | null,
    slug?: string | null,
    parentId?: string | null,
    rootId?: string | null,
    path?: string | null,
    status?: string | null,
    pathIds?: Array< string | null > | null,
    source?: string | null,
    trazoCategoryId?: string | null,
    nameExternal?: string | null,
    depth?: number | null,
    childrenCount?: number | null,
    isLeaf?: boolean | null,
    oldVersion?: string | null,
    productLine?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteCategoryMutationVariables = {
  input: DeleteCategoryInput,
  condition?: ModelCategoryConditionInput | null,
};

export type DeleteCategoryMutation = {
  deleteCategory?:  {
    __typename: "Category",
    id: string,
    name: string,
    description?: string | null,
    unspsc?: string | null,
    image:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    },
    imageMobile?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    visibleForUserBrand?: Array< string | null > | null,
    region?: Array< string | null > | null,
    tags?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    hasAllowables?: boolean | null,
    hasPreapproveds?: boolean | null,
    hasRestricted?: boolean | null,
    isPublic?: boolean | null,
    isTop?: boolean | null,
    createdAt?: string | null,
    slug?: string | null,
    parentId?: string | null,
    rootId?: string | null,
    path?: string | null,
    status?: string | null,
    pathIds?: Array< string | null > | null,
    source?: string | null,
    trazoCategoryId?: string | null,
    nameExternal?: string | null,
    depth?: number | null,
    childrenCount?: number | null,
    isLeaf?: boolean | null,
    oldVersion?: string | null,
    productLine?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateProductBrandMutationVariables = {
  input: CreateProductBrandInput,
  condition?: ModelProductBrandConditionInput | null,
};

export type CreateProductBrandMutation = {
  createProductBrand?:  {
    __typename: "ProductBrand",
    id: string,
    name: string,
    status?: string | null,
    description?: string | null,
    route: string,
    unspsc?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    hasAllowables?: boolean | null,
    hasPreapproveds?: boolean | null,
    hasRestricted?: boolean | null,
    isTop?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateProductBrandMutationVariables = {
  input: UpdateProductBrandInput,
  condition?: ModelProductBrandConditionInput | null,
};

export type UpdateProductBrandMutation = {
  updateProductBrand?:  {
    __typename: "ProductBrand",
    id: string,
    name: string,
    status?: string | null,
    description?: string | null,
    route: string,
    unspsc?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    hasAllowables?: boolean | null,
    hasPreapproveds?: boolean | null,
    hasRestricted?: boolean | null,
    isTop?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteProductBrandMutationVariables = {
  input: DeleteProductBrandInput,
  condition?: ModelProductBrandConditionInput | null,
};

export type DeleteProductBrandMutation = {
  deleteProductBrand?:  {
    __typename: "ProductBrand",
    id: string,
    name: string,
    status?: string | null,
    description?: string | null,
    route: string,
    unspsc?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    hasAllowables?: boolean | null,
    hasPreapproveds?: boolean | null,
    hasRestricted?: boolean | null,
    isTop?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateCartMutationVariables = {
  input: CreateCartInput,
  condition?: ModelCartConditionInput | null,
};

export type CreateCartMutation = {
  createCart?:  {
    __typename: "Cart",
    id: string,
    requirement?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    products:  Array< {
      __typename: "ProductInOrder",
      product_id: string,
      provider_id?: string | null,
      index?: number | null,
      print?: number | null,
      printPrice?: number | null,
      product_name: string,
      description?: string | null,
      category?: string | null,
      unspsc?: string | null,
      price?: number | null,
      originalPrice?: number | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      sample_authorize?: boolean | null,
      sample_authorized?: boolean | null,
      quality_requested?: boolean | null,
      quality_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      isExternal?: boolean | null,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      sku?: string | null,
      qualityForm?:  {
        __typename: "ProductInOrderQualityPGForm",
        initiativeDescription?: string | null,
        targetUser?: string | null,
        retailBrandName?: string | null,
        itemCategory?: string | null,
        itemPicture?: string | null,
        originCountry?: string | null,
        quantityPerCountryOfDist?: string | null,
        initiativeDates?: string | null,
        isPartOfAnMSOCustOrSpecPack?: string | null,
        incluesClientLogo?: string | null,
        isAReorderWithinTwelveMonths?: string | null,
        isReorder?: string | null,
        PGPLContactName?: string | null,
        ulTracking?: string | null,
        PLContactName?: string | null,
        contactEmailAddress?: string | null,
        PGPurchaseOrderNumber?: string | null,
        EBBSorSupplierProvidedProjectNumber?: string | null,
        vendorCompanyName?: string | null,
        vendorContactName?: string | null,
        vendorEmailAddress?: string | null,
        vendorJobTitle?: string | null,
        vendorTelephone?: string | null,
        vendorMailingAddress?: string | null,
        vendorCity?: string | null,
        vendorState?: string | null,
        vendorCountry?: string | null,
        vendorPC?: string | null,
        physicalItemDescription?: string | null,
        SampleOrMaterialComponentSubmitted?: string | null,
        toWhom?: string | null,
        descriptionOfItemPackagingAndArtwork?: string | null,
        regulatoryAndLegislativeProductCertification?: string | null,
        dateFinalApprovalRequestedSubmittedToPG?: string | null,
        DateOfDeclarationOfConformity?: string | null,
        dateOfApprovalExpirationOfPremiumItem?: string | null,
        itemClasification?: string | null,
        PGRepresentativeMarketingDesign?: string | null,
        PGProjectLeaderRequestor?: string | null,
        PGRestrictedItemsLocalPGLegal?: string | null,
        PGLocalCategoryGM?: string | null,
        PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
        idProduct?: string | null,
        pathDocument?: string | null,
      } | null,
      fee?: number | null,
      increment?: number | null,
      discount?: number | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
    } >,
    creator: string,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCartMutationVariables = {
  input: UpdateCartInput,
  condition?: ModelCartConditionInput | null,
};

export type UpdateCartMutation = {
  updateCart?:  {
    __typename: "Cart",
    id: string,
    requirement?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    products:  Array< {
      __typename: "ProductInOrder",
      product_id: string,
      provider_id?: string | null,
      index?: number | null,
      print?: number | null,
      printPrice?: number | null,
      product_name: string,
      description?: string | null,
      category?: string | null,
      unspsc?: string | null,
      price?: number | null,
      originalPrice?: number | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      sample_authorize?: boolean | null,
      sample_authorized?: boolean | null,
      quality_requested?: boolean | null,
      quality_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      isExternal?: boolean | null,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      sku?: string | null,
      qualityForm?:  {
        __typename: "ProductInOrderQualityPGForm",
        initiativeDescription?: string | null,
        targetUser?: string | null,
        retailBrandName?: string | null,
        itemCategory?: string | null,
        itemPicture?: string | null,
        originCountry?: string | null,
        quantityPerCountryOfDist?: string | null,
        initiativeDates?: string | null,
        isPartOfAnMSOCustOrSpecPack?: string | null,
        incluesClientLogo?: string | null,
        isAReorderWithinTwelveMonths?: string | null,
        isReorder?: string | null,
        PGPLContactName?: string | null,
        ulTracking?: string | null,
        PLContactName?: string | null,
        contactEmailAddress?: string | null,
        PGPurchaseOrderNumber?: string | null,
        EBBSorSupplierProvidedProjectNumber?: string | null,
        vendorCompanyName?: string | null,
        vendorContactName?: string | null,
        vendorEmailAddress?: string | null,
        vendorJobTitle?: string | null,
        vendorTelephone?: string | null,
        vendorMailingAddress?: string | null,
        vendorCity?: string | null,
        vendorState?: string | null,
        vendorCountry?: string | null,
        vendorPC?: string | null,
        physicalItemDescription?: string | null,
        SampleOrMaterialComponentSubmitted?: string | null,
        toWhom?: string | null,
        descriptionOfItemPackagingAndArtwork?: string | null,
        regulatoryAndLegislativeProductCertification?: string | null,
        dateFinalApprovalRequestedSubmittedToPG?: string | null,
        DateOfDeclarationOfConformity?: string | null,
        dateOfApprovalExpirationOfPremiumItem?: string | null,
        itemClasification?: string | null,
        PGRepresentativeMarketingDesign?: string | null,
        PGProjectLeaderRequestor?: string | null,
        PGRestrictedItemsLocalPGLegal?: string | null,
        PGLocalCategoryGM?: string | null,
        PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
        idProduct?: string | null,
        pathDocument?: string | null,
      } | null,
      fee?: number | null,
      increment?: number | null,
      discount?: number | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
    } >,
    creator: string,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCartMutationVariables = {
  input: DeleteCartInput,
  condition?: ModelCartConditionInput | null,
};

export type DeleteCartMutation = {
  deleteCart?:  {
    __typename: "Cart",
    id: string,
    requirement?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    products:  Array< {
      __typename: "ProductInOrder",
      product_id: string,
      provider_id?: string | null,
      index?: number | null,
      print?: number | null,
      printPrice?: number | null,
      product_name: string,
      description?: string | null,
      category?: string | null,
      unspsc?: string | null,
      price?: number | null,
      originalPrice?: number | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      sample_authorize?: boolean | null,
      sample_authorized?: boolean | null,
      quality_requested?: boolean | null,
      quality_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      isExternal?: boolean | null,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      sku?: string | null,
      qualityForm?:  {
        __typename: "ProductInOrderQualityPGForm",
        initiativeDescription?: string | null,
        targetUser?: string | null,
        retailBrandName?: string | null,
        itemCategory?: string | null,
        itemPicture?: string | null,
        originCountry?: string | null,
        quantityPerCountryOfDist?: string | null,
        initiativeDates?: string | null,
        isPartOfAnMSOCustOrSpecPack?: string | null,
        incluesClientLogo?: string | null,
        isAReorderWithinTwelveMonths?: string | null,
        isReorder?: string | null,
        PGPLContactName?: string | null,
        ulTracking?: string | null,
        PLContactName?: string | null,
        contactEmailAddress?: string | null,
        PGPurchaseOrderNumber?: string | null,
        EBBSorSupplierProvidedProjectNumber?: string | null,
        vendorCompanyName?: string | null,
        vendorContactName?: string | null,
        vendorEmailAddress?: string | null,
        vendorJobTitle?: string | null,
        vendorTelephone?: string | null,
        vendorMailingAddress?: string | null,
        vendorCity?: string | null,
        vendorState?: string | null,
        vendorCountry?: string | null,
        vendorPC?: string | null,
        physicalItemDescription?: string | null,
        SampleOrMaterialComponentSubmitted?: string | null,
        toWhom?: string | null,
        descriptionOfItemPackagingAndArtwork?: string | null,
        regulatoryAndLegislativeProductCertification?: string | null,
        dateFinalApprovalRequestedSubmittedToPG?: string | null,
        DateOfDeclarationOfConformity?: string | null,
        dateOfApprovalExpirationOfPremiumItem?: string | null,
        itemClasification?: string | null,
        PGRepresentativeMarketingDesign?: string | null,
        PGProjectLeaderRequestor?: string | null,
        PGRestrictedItemsLocalPGLegal?: string | null,
        PGLocalCategoryGM?: string | null,
        PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
        idProduct?: string | null,
        pathDocument?: string | null,
      } | null,
      fee?: number | null,
      increment?: number | null,
      discount?: number | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
    } >,
    creator: string,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    name: string,
    role: string,
    email: string,
    jiraId?: string | null,
    phoneNumber?: string | null,
    avatar?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    companyId?: string | null,
    brandId?: string | null,
    failedLogins?: number | null,
    agents?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    notificationsOf?: Array< string | null > | null,
    status?: boolean | null,
    isLogistic?: boolean | null,
    isCoupa?: boolean | null,
    isManagement?: boolean | null,
    isAdministration?: boolean | null,
    hasNotifications?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    name: string,
    role: string,
    email: string,
    jiraId?: string | null,
    phoneNumber?: string | null,
    avatar?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    companyId?: string | null,
    brandId?: string | null,
    failedLogins?: number | null,
    agents?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    notificationsOf?: Array< string | null > | null,
    status?: boolean | null,
    isLogistic?: boolean | null,
    isCoupa?: boolean | null,
    isManagement?: boolean | null,
    isAdministration?: boolean | null,
    hasNotifications?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    name: string,
    role: string,
    email: string,
    jiraId?: string | null,
    phoneNumber?: string | null,
    avatar?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    companyId?: string | null,
    brandId?: string | null,
    failedLogins?: number | null,
    agents?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    notificationsOf?: Array< string | null > | null,
    status?: boolean | null,
    isLogistic?: boolean | null,
    isCoupa?: boolean | null,
    isManagement?: boolean | null,
    isAdministration?: boolean | null,
    hasNotifications?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateAutomobileMutationVariables = {
  input: CreateAutomobileInput,
  condition?: ModelAutomobileConditionInput | null,
};

export type CreateAutomobileMutation = {
  createAutomobile?:  {
    __typename: "Automobile",
    id: string,
    clientId?: string | null,
    status?: boolean | null,
    bought?: boolean | null,
    buyerId?: string | null,
    buyerName?: string | null,
    price: number,
    brand: string,
    brandId?: string | null,
    model?: string | null,
    version: string,
    year: number,
    color?: string | null,
    km: number,
    transmission?: string | null,
    motor?: string | null,
    passengers?: number | null,
    state: string,
    objeto?: string | null,
    placa?: string | null,
    serialNumber?: string | null,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    star_time?: number | null,
    end_time?: number | null,
    usersInteresting?:  Array< {
      __typename: "ListUsers",
      iduser?: string | null,
      nombre?: string | null,
      email?: string | null,
      fecha_compra?: string | null,
      veces_rechazo?: string | null,
      winner?: boolean | null,
      fecha_notificacion?: string | null,
      buyer?: boolean | null,
      process_buyer?: boolean | null,
      d_winner_date?: number | null,
      created?: number | null,
    } | null > | null,
    comentario?: string | null,
    penalizacion?: string | null,
    haveWinner?: boolean | null,
    ppostulacion?: boolean | null,
    logsGanadoresAutos?:  {
      __typename: "ModelLogGanadorAutoConnection",
      items:  Array< {
        __typename: "LogGanadorAuto",
        id: string,
        id_auto?: string | null,
        id_user?: string | null,
        fecha_rifa?: number | null,
        email?: string | null,
        nombre?: string | null,
        a_paterno?: string | null,
        a_materno?: string | null,
        status_buyer?: boolean | null,
        date_buyer?: number | null,
        winner?: number | null,
        refused?: number | null,
        since?: string | null,
        process_buyer?: boolean | null,
        reactive?: boolean | null,
        created: number,
        updated?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAutomobileMutationVariables = {
  input: UpdateAutomobileInput,
  condition?: ModelAutomobileConditionInput | null,
};

export type UpdateAutomobileMutation = {
  updateAutomobile?:  {
    __typename: "Automobile",
    id: string,
    clientId?: string | null,
    status?: boolean | null,
    bought?: boolean | null,
    buyerId?: string | null,
    buyerName?: string | null,
    price: number,
    brand: string,
    brandId?: string | null,
    model?: string | null,
    version: string,
    year: number,
    color?: string | null,
    km: number,
    transmission?: string | null,
    motor?: string | null,
    passengers?: number | null,
    state: string,
    objeto?: string | null,
    placa?: string | null,
    serialNumber?: string | null,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    star_time?: number | null,
    end_time?: number | null,
    usersInteresting?:  Array< {
      __typename: "ListUsers",
      iduser?: string | null,
      nombre?: string | null,
      email?: string | null,
      fecha_compra?: string | null,
      veces_rechazo?: string | null,
      winner?: boolean | null,
      fecha_notificacion?: string | null,
      buyer?: boolean | null,
      process_buyer?: boolean | null,
      d_winner_date?: number | null,
      created?: number | null,
    } | null > | null,
    comentario?: string | null,
    penalizacion?: string | null,
    haveWinner?: boolean | null,
    ppostulacion?: boolean | null,
    logsGanadoresAutos?:  {
      __typename: "ModelLogGanadorAutoConnection",
      items:  Array< {
        __typename: "LogGanadorAuto",
        id: string,
        id_auto?: string | null,
        id_user?: string | null,
        fecha_rifa?: number | null,
        email?: string | null,
        nombre?: string | null,
        a_paterno?: string | null,
        a_materno?: string | null,
        status_buyer?: boolean | null,
        date_buyer?: number | null,
        winner?: number | null,
        refused?: number | null,
        since?: string | null,
        process_buyer?: boolean | null,
        reactive?: boolean | null,
        created: number,
        updated?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAutomobileMutationVariables = {
  input: DeleteAutomobileInput,
  condition?: ModelAutomobileConditionInput | null,
};

export type DeleteAutomobileMutation = {
  deleteAutomobile?:  {
    __typename: "Automobile",
    id: string,
    clientId?: string | null,
    status?: boolean | null,
    bought?: boolean | null,
    buyerId?: string | null,
    buyerName?: string | null,
    price: number,
    brand: string,
    brandId?: string | null,
    model?: string | null,
    version: string,
    year: number,
    color?: string | null,
    km: number,
    transmission?: string | null,
    motor?: string | null,
    passengers?: number | null,
    state: string,
    objeto?: string | null,
    placa?: string | null,
    serialNumber?: string | null,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    star_time?: number | null,
    end_time?: number | null,
    usersInteresting?:  Array< {
      __typename: "ListUsers",
      iduser?: string | null,
      nombre?: string | null,
      email?: string | null,
      fecha_compra?: string | null,
      veces_rechazo?: string | null,
      winner?: boolean | null,
      fecha_notificacion?: string | null,
      buyer?: boolean | null,
      process_buyer?: boolean | null,
      d_winner_date?: number | null,
      created?: number | null,
    } | null > | null,
    comentario?: string | null,
    penalizacion?: string | null,
    haveWinner?: boolean | null,
    ppostulacion?: boolean | null,
    logsGanadoresAutos?:  {
      __typename: "ModelLogGanadorAutoConnection",
      items:  Array< {
        __typename: "LogGanadorAuto",
        id: string,
        id_auto?: string | null,
        id_user?: string | null,
        fecha_rifa?: number | null,
        email?: string | null,
        nombre?: string | null,
        a_paterno?: string | null,
        a_materno?: string | null,
        status_buyer?: boolean | null,
        date_buyer?: number | null,
        winner?: number | null,
        refused?: number | null,
        since?: string | null,
        process_buyer?: boolean | null,
        reactive?: boolean | null,
        created: number,
        updated?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateBrandMutationVariables = {
  input: CreateBrandInput,
  condition?: ModelBrandConditionInput | null,
};

export type CreateBrandMutation = {
  createBrand?:  {
    __typename: "Brand",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateBrandMutationVariables = {
  input: UpdateBrandInput,
  condition?: ModelBrandConditionInput | null,
};

export type UpdateBrandMutation = {
  updateBrand?:  {
    __typename: "Brand",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteBrandMutationVariables = {
  input: DeleteBrandInput,
  condition?: ModelBrandConditionInput | null,
};

export type DeleteBrandMutation = {
  deleteBrand?:  {
    __typename: "Brand",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRfqMutationVariables = {
  input: CreateRfqInput,
  condition?: ModelRfqConditionInput | null,
};

export type CreateRfqMutation = {
  createRfq?:  {
    __typename: "Rfq",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    proposals?:  {
      __typename: "ModelProposalsConnection",
      items:  Array< {
        __typename: "Proposals",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        priceUnit?: number | null,
        pieces?: number | null,
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "Rfq",
          id: string,
          nombre: string,
          requerimiento: string,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          orderAgentIds?: Array< string | null > | null,
          premiumOrderId?: string | null,
          estatus: string,
          orderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
          multipleProducts?: boolean | null,
          providers?: Array< string | null > | null,
        } | null,
        proposalsRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    premiumOrderId?: string | null,
    estatus: string,
    orderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    multipleProducts?: boolean | null,
    providers?: Array< string | null > | null,
    productsRfq?:  Array< {
      __typename: "ProductUnitRfq",
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
  } | null,
};

export type UpdateRfqMutationVariables = {
  input: UpdateRfqInput,
  condition?: ModelRfqConditionInput | null,
};

export type UpdateRfqMutation = {
  updateRfq?:  {
    __typename: "Rfq",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    proposals?:  {
      __typename: "ModelProposalsConnection",
      items:  Array< {
        __typename: "Proposals",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        priceUnit?: number | null,
        pieces?: number | null,
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "Rfq",
          id: string,
          nombre: string,
          requerimiento: string,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          orderAgentIds?: Array< string | null > | null,
          premiumOrderId?: string | null,
          estatus: string,
          orderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
          multipleProducts?: boolean | null,
          providers?: Array< string | null > | null,
        } | null,
        proposalsRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    premiumOrderId?: string | null,
    estatus: string,
    orderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    multipleProducts?: boolean | null,
    providers?: Array< string | null > | null,
    productsRfq?:  Array< {
      __typename: "ProductUnitRfq",
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
  } | null,
};

export type DeleteRfqMutationVariables = {
  input: DeleteRfqInput,
  condition?: ModelRfqConditionInput | null,
};

export type DeleteRfqMutation = {
  deleteRfq?:  {
    __typename: "Rfq",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    proposals?:  {
      __typename: "ModelProposalsConnection",
      items:  Array< {
        __typename: "Proposals",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        priceUnit?: number | null,
        pieces?: number | null,
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "Rfq",
          id: string,
          nombre: string,
          requerimiento: string,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          orderAgentIds?: Array< string | null > | null,
          premiumOrderId?: string | null,
          estatus: string,
          orderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
          multipleProducts?: boolean | null,
          providers?: Array< string | null > | null,
        } | null,
        proposalsRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    premiumOrderId?: string | null,
    estatus: string,
    orderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    multipleProducts?: boolean | null,
    providers?: Array< string | null > | null,
    productsRfq?:  Array< {
      __typename: "ProductUnitRfq",
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
  } | null,
};

export type CreateRfqAmazonMutationVariables = {
  input: CreateRfqAmazonInput,
  condition?: ModelRfqAmazonConditionInput | null,
};

export type CreateRfqAmazonMutation = {
  createRfqAmazon?:  {
    __typename: "RfqAmazon",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    proposals?:  {
      __typename: "ModelProposalsAmazonConnection",
      items:  Array< {
        __typename: "ProposalsAmazon",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        priceUnit?: number | null,
        pieces?: number | null,
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "RfqAmazon",
          id: string,
          nombre: string,
          requerimiento: string,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          estatus: string,
          orderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
          multipleProducts?: boolean | null,
          providers?: Array< string | null > | null,
        } | null,
        proposalsRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    estatus: string,
    orderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    multipleProducts?: boolean | null,
    providers?: Array< string | null > | null,
    productsRfq?:  Array< {
      __typename: "ProductUnitRfq",
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
  } | null,
};

export type UpdateRfqAmazonMutationVariables = {
  input: UpdateRfqAmazonInput,
  condition?: ModelRfqAmazonConditionInput | null,
};

export type UpdateRfqAmazonMutation = {
  updateRfqAmazon?:  {
    __typename: "RfqAmazon",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    proposals?:  {
      __typename: "ModelProposalsAmazonConnection",
      items:  Array< {
        __typename: "ProposalsAmazon",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        priceUnit?: number | null,
        pieces?: number | null,
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "RfqAmazon",
          id: string,
          nombre: string,
          requerimiento: string,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          estatus: string,
          orderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
          multipleProducts?: boolean | null,
          providers?: Array< string | null > | null,
        } | null,
        proposalsRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    estatus: string,
    orderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    multipleProducts?: boolean | null,
    providers?: Array< string | null > | null,
    productsRfq?:  Array< {
      __typename: "ProductUnitRfq",
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
  } | null,
};

export type DeleteRfqAmazonMutationVariables = {
  input: DeleteRfqAmazonInput,
  condition?: ModelRfqAmazonConditionInput | null,
};

export type DeleteRfqAmazonMutation = {
  deleteRfqAmazon?:  {
    __typename: "RfqAmazon",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    proposals?:  {
      __typename: "ModelProposalsAmazonConnection",
      items:  Array< {
        __typename: "ProposalsAmazon",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        priceUnit?: number | null,
        pieces?: number | null,
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "RfqAmazon",
          id: string,
          nombre: string,
          requerimiento: string,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          estatus: string,
          orderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
          multipleProducts?: boolean | null,
          providers?: Array< string | null > | null,
        } | null,
        proposalsRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    estatus: string,
    orderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    multipleProducts?: boolean | null,
    providers?: Array< string | null > | null,
    productsRfq?:  Array< {
      __typename: "ProductUnitRfq",
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
  } | null,
};

export type CreateProposalsMutationVariables = {
  input: CreateProposalsInput,
  condition?: ModelProposalsConditionInput | null,
};

export type CreateProposalsMutation = {
  createProposals?:  {
    __typename: "Proposals",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    priceUnit?: number | null,
    pieces?: number | null,
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "Rfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsConnection",
        items:  Array< {
          __typename: "Proposals",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      premiumOrderId?: string | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null,
    proposalsRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateProposalsMutationVariables = {
  input: UpdateProposalsInput,
  condition?: ModelProposalsConditionInput | null,
};

export type UpdateProposalsMutation = {
  updateProposals?:  {
    __typename: "Proposals",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    priceUnit?: number | null,
    pieces?: number | null,
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "Rfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsConnection",
        items:  Array< {
          __typename: "Proposals",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      premiumOrderId?: string | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null,
    proposalsRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteProposalsMutationVariables = {
  input: DeleteProposalsInput,
  condition?: ModelProposalsConditionInput | null,
};

export type DeleteProposalsMutation = {
  deleteProposals?:  {
    __typename: "Proposals",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    priceUnit?: number | null,
    pieces?: number | null,
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "Rfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsConnection",
        items:  Array< {
          __typename: "Proposals",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      premiumOrderId?: string | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null,
    proposalsRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateProposalsAmazonMutationVariables = {
  input: CreateProposalsAmazonInput,
  condition?: ModelProposalsAmazonConditionInput | null,
};

export type CreateProposalsAmazonMutation = {
  createProposalsAmazon?:  {
    __typename: "ProposalsAmazon",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    priceUnit?: number | null,
    pieces?: number | null,
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "RfqAmazon",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsAmazonConnection",
        items:  Array< {
          __typename: "ProposalsAmazon",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null,
    proposalsRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateProposalsAmazonMutationVariables = {
  input: UpdateProposalsAmazonInput,
  condition?: ModelProposalsAmazonConditionInput | null,
};

export type UpdateProposalsAmazonMutation = {
  updateProposalsAmazon?:  {
    __typename: "ProposalsAmazon",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    priceUnit?: number | null,
    pieces?: number | null,
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "RfqAmazon",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsAmazonConnection",
        items:  Array< {
          __typename: "ProposalsAmazon",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null,
    proposalsRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteProposalsAmazonMutationVariables = {
  input: DeleteProposalsAmazonInput,
  condition?: ModelProposalsAmazonConditionInput | null,
};

export type DeleteProposalsAmazonMutation = {
  deleteProposalsAmazon?:  {
    __typename: "ProposalsAmazon",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    priceUnit?: number | null,
    pieces?: number | null,
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "RfqAmazon",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsAmazonConnection",
        items:  Array< {
          __typename: "ProposalsAmazon",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null,
    proposalsRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateProductoRfqMutationVariables = {
  input: CreateProductoRfqInput,
  condition?: ModelProductoRfqConditionInput | null,
};

export type CreateProductoRfqMutation = {
  createProductoRfq?:  {
    __typename: "ProductoRfq",
    id: string,
    name: string,
    request: string,
    category_id: string,
    provider_id: string,
    price?: number | null,
    category?:  {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    } | null,
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    estatus?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateProductoRfqMutationVariables = {
  input: UpdateProductoRfqInput,
  condition?: ModelProductoRfqConditionInput | null,
};

export type UpdateProductoRfqMutation = {
  updateProductoRfq?:  {
    __typename: "ProductoRfq",
    id: string,
    name: string,
    request: string,
    category_id: string,
    provider_id: string,
    price?: number | null,
    category?:  {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    } | null,
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    estatus?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteProductoRfqMutationVariables = {
  input: DeleteProductoRfqInput,
  condition?: ModelProductoRfqConditionInput | null,
};

export type DeleteProductoRfqMutation = {
  deleteProductoRfq?:  {
    __typename: "ProductoRfq",
    id: string,
    name: string,
    request: string,
    category_id: string,
    provider_id: string,
    price?: number | null,
    category?:  {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    } | null,
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    estatus?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOrderProvidersMutationVariables = {
  input: CreateOrderProvidersInput,
  condition?: ModelOrderProvidersConditionInput | null,
};

export type CreateOrderProvidersMutation = {
  createOrderProviders?:  {
    __typename: "OrderProviders",
    id: string,
    provider_id: string,
    clientId?: string | null,
    orderId?: number | null,
    orderProvidersPremiumOrderId: string,
    payment_date?: number | null,
    gr_code?: string | null,
    invoice?: boolean | null,
    invoiceRequested?: boolean | null,
    uploadedGr?: boolean | null,
    uploadedBill?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateOrderProvidersMutationVariables = {
  input: UpdateOrderProvidersInput,
  condition?: ModelOrderProvidersConditionInput | null,
};

export type UpdateOrderProvidersMutation = {
  updateOrderProviders?:  {
    __typename: "OrderProviders",
    id: string,
    provider_id: string,
    clientId?: string | null,
    orderId?: number | null,
    orderProvidersPremiumOrderId: string,
    payment_date?: number | null,
    gr_code?: string | null,
    invoice?: boolean | null,
    invoiceRequested?: boolean | null,
    uploadedGr?: boolean | null,
    uploadedBill?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteOrderProvidersMutationVariables = {
  input: DeleteOrderProvidersInput,
  condition?: ModelOrderProvidersConditionInput | null,
};

export type DeleteOrderProvidersMutation = {
  deleteOrderProviders?:  {
    __typename: "OrderProviders",
    id: string,
    provider_id: string,
    clientId?: string | null,
    orderId?: number | null,
    orderProvidersPremiumOrderId: string,
    payment_date?: number | null,
    gr_code?: string | null,
    invoice?: boolean | null,
    invoiceRequested?: boolean | null,
    uploadedGr?: boolean | null,
    uploadedBill?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePopMaterialMutationVariables = {
  input: CreatePopMaterialInput,
  condition?: ModelPopMaterialConditionInput | null,
};

export type CreatePopMaterialMutation = {
  createPopMaterial?:  {
    __typename: "PopMaterial",
    id: string,
    name: string,
    route: string,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    year?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePopMaterialMutationVariables = {
  input: UpdatePopMaterialInput,
  condition?: ModelPopMaterialConditionInput | null,
};

export type UpdatePopMaterialMutation = {
  updatePopMaterial?:  {
    __typename: "PopMaterial",
    id: string,
    name: string,
    route: string,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    year?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePopMaterialMutationVariables = {
  input: DeletePopMaterialInput,
  condition?: ModelPopMaterialConditionInput | null,
};

export type DeletePopMaterialMutation = {
  deletePopMaterial?:  {
    __typename: "PopMaterial",
    id: string,
    name: string,
    route: string,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    year?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateVehicleTypeMutationVariables = {
  input: CreateVehicleTypeInput,
  condition?: ModelVehicleTypeConditionInput | null,
};

export type CreateVehicleTypeMutation = {
  createVehicleType?:  {
    __typename: "VehicleType",
    id: string,
    name: string,
    popMaterialId: string,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    popMaterial?:  {
      __typename: "PopMaterial",
      id: string,
      name: string,
      route: string,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      year?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateVehicleTypeMutationVariables = {
  input: UpdateVehicleTypeInput,
  condition?: ModelVehicleTypeConditionInput | null,
};

export type UpdateVehicleTypeMutation = {
  updateVehicleType?:  {
    __typename: "VehicleType",
    id: string,
    name: string,
    popMaterialId: string,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    popMaterial?:  {
      __typename: "PopMaterial",
      id: string,
      name: string,
      route: string,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      year?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteVehicleTypeMutationVariables = {
  input: DeleteVehicleTypeInput,
  condition?: ModelVehicleTypeConditionInput | null,
};

export type DeleteVehicleTypeMutation = {
  deleteVehicleType?:  {
    __typename: "VehicleType",
    id: string,
    name: string,
    popMaterialId: string,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    popMaterial?:  {
      __typename: "PopMaterial",
      id: string,
      name: string,
      route: string,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      year?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateVehicleMutationVariables = {
  input: CreateVehicleInput,
  condition?: ModelVehicleConditionInput | null,
};

export type CreateVehicleMutation = {
  createVehicle?:  {
    __typename: "Vehicle",
    id: string,
    status?: string | null,
    isSustainable?: boolean | null,
    multiProvider?: boolean | null,
    itemName?: string | null,
    bestSeller?: string | null,
    name: string,
    brand: string,
    channel: string,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    description: string,
    size: string,
    materialDetail?: string | null,
    print?: string | null,
    finish?: string | null,
    packaging?: string | null,
    quantity: number,
    unitPrice: number,
    prototypePrice: number,
    productionTime: string,
    vehicleTypeId: string,
    popMaterialId: string,
    popCategoryId?: string | null,
    providerId: string,
    isRfq?: boolean | null,
    historicCost?: string | null,
    historicTime?: string | null,
    contact?: string | null,
    providerName?: string | null,
    variantsUnits?:  Array< {
      __typename: "VariantsUnits",
      min_units?: number | null,
      max_units?: number | null,
      price?: number | null,
      production_time?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    providers?: Array< string | null > | null,
    massiveLayout?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateVehicleMutationVariables = {
  input: UpdateVehicleInput,
  condition?: ModelVehicleConditionInput | null,
};

export type UpdateVehicleMutation = {
  updateVehicle?:  {
    __typename: "Vehicle",
    id: string,
    status?: string | null,
    isSustainable?: boolean | null,
    multiProvider?: boolean | null,
    itemName?: string | null,
    bestSeller?: string | null,
    name: string,
    brand: string,
    channel: string,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    description: string,
    size: string,
    materialDetail?: string | null,
    print?: string | null,
    finish?: string | null,
    packaging?: string | null,
    quantity: number,
    unitPrice: number,
    prototypePrice: number,
    productionTime: string,
    vehicleTypeId: string,
    popMaterialId: string,
    popCategoryId?: string | null,
    providerId: string,
    isRfq?: boolean | null,
    historicCost?: string | null,
    historicTime?: string | null,
    contact?: string | null,
    providerName?: string | null,
    variantsUnits?:  Array< {
      __typename: "VariantsUnits",
      min_units?: number | null,
      max_units?: number | null,
      price?: number | null,
      production_time?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    providers?: Array< string | null > | null,
    massiveLayout?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteVehicleMutationVariables = {
  input: DeleteVehicleInput,
  condition?: ModelVehicleConditionInput | null,
};

export type DeleteVehicleMutation = {
  deleteVehicle?:  {
    __typename: "Vehicle",
    id: string,
    status?: string | null,
    isSustainable?: boolean | null,
    multiProvider?: boolean | null,
    itemName?: string | null,
    bestSeller?: string | null,
    name: string,
    brand: string,
    channel: string,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    description: string,
    size: string,
    materialDetail?: string | null,
    print?: string | null,
    finish?: string | null,
    packaging?: string | null,
    quantity: number,
    unitPrice: number,
    prototypePrice: number,
    productionTime: string,
    vehicleTypeId: string,
    popMaterialId: string,
    popCategoryId?: string | null,
    providerId: string,
    isRfq?: boolean | null,
    historicCost?: string | null,
    historicTime?: string | null,
    contact?: string | null,
    providerName?: string | null,
    variantsUnits?:  Array< {
      __typename: "VariantsUnits",
      min_units?: number | null,
      max_units?: number | null,
      price?: number | null,
      production_time?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    providers?: Array< string | null > | null,
    massiveLayout?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePopOrderMutationVariables = {
  input: CreatePopOrderInput,
  condition?: ModelPopOrderConditionInput | null,
};

export type CreatePopOrderMutation = {
  createPopOrder?:  {
    __typename: "PopOrder",
    id: string,
    estatus: string,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    orderId?: number | null,
    requirement?: string | null,
    budget?: number | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_time?: number | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    subtotal?: number | null,
    total?: number | null,
    isCoupa: boolean,
    sentToCoupa?: boolean | null,
    coupaOrder?: string | null,
    active?: string | null,
    vehicles?:  {
      __typename: "ModelPopOrderVehicleConnection",
      items:  Array< {
        __typename: "PopOrderVehicle",
        id: string,
        orderId: string,
        vehicleId: string,
        providerId: string,
        unitPrice: number,
        prototypePrice: number,
        quantity: number,
        approved: boolean,
        hasQrCode?: boolean | null,
        vehicle:  {
          __typename: "Vehicle",
          id: string,
          status?: string | null,
          isSustainable?: boolean | null,
          multiProvider?: boolean | null,
          itemName?: string | null,
          bestSeller?: string | null,
          name: string,
          brand: string,
          channel: string,
          description: string,
          size: string,
          materialDetail?: string | null,
          print?: string | null,
          finish?: string | null,
          packaging?: string | null,
          quantity: number,
          unitPrice: number,
          prototypePrice: number,
          productionTime: string,
          vehicleTypeId: string,
          popMaterialId: string,
          popCategoryId?: string | null,
          providerId: string,
          isRfq?: boolean | null,
          historicCost?: string | null,
          historicTime?: string | null,
          contact?: string | null,
          providerName?: string | null,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          providers?: Array< string | null > | null,
          massiveLayout?: string | null,
          created: number,
          updated?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        order:  {
          __typename: "PopOrder",
          id: string,
          estatus: string,
          orderId?: number | null,
          requirement?: string | null,
          budget?: number | null,
          delivery_cost?: number | null,
          delivery_time?: number | null,
          subtotal?: number | null,
          total?: number | null,
          isCoupa: boolean,
          sentToCoupa?: boolean | null,
          coupaOrder?: string | null,
          active?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          orderAgentIds?: Array< string | null > | null,
          gr?: string | null,
          orderCreatorId: string,
          prequoteApproved?: boolean | null,
          quoteApproved?: boolean | null,
          prototypeApproved?: boolean | null,
          samplesDocsUploaded?: boolean | null,
          samplesApproved?: boolean | null,
          auditRequired?: boolean | null,
          drivePath?: string | null,
          auditDocsUploaded?: boolean | null,
          deliveryDateRequested?: boolean | null,
          deliveryDate?: number | null,
          deliveryCode?: string | null,
          deliveryFilesUploaded?: boolean | null,
          deliveryDocsApproved?: boolean | null,
          grUploaded?: boolean | null,
          grApproved?: boolean | null,
          grCode?: string | null,
          qrCode?: boolean | null,
          brandfactoryCheck?: boolean | null,
          step?: number | null,
          prototype?: boolean | null,
          dateKickoff?: number | null,
          paymentDate?: number | null,
          currentProcess?: string | null,
          currentSubprocess?: string | null,
          clientId?: string | null,
        },
        provider:  {
          __typename: "Provider",
          id: string,
          isApproved?: boolean | null,
          comertial_name?: string | null,
          idProcter?: string | null,
          biography?: string | null,
          experience?: string | null,
          pros?: Array< string | null > | null,
          cons?: Array< string | null > | null,
          video?: string | null,
          tags?: Array< string | null > | null,
          money_filter_c?: boolean | null,
          money_filter_d?: boolean | null,
          users?: Array< string | null > | null,
          bank?: string | null,
          account?: string | null,
          clabe?: string | null,
          cuenta_correo?: string | null,
          isProvider?: boolean | null,
          sameAddress?: boolean | null,
          isPop?: boolean | null,
          isPrinted?: boolean | null,
          hasLogistic?: boolean | null,
          created?: number | null,
          updated?: number | null,
          representante_legal?: string | null,
          escritura_constitucion?: string | null,
          notario_a?: string | null,
          constituido_down_edo?: string | null,
          rrpp?: string | null,
          isPremium?: boolean | null,
          isTrustProvider?: boolean | null,
          createdAt: string,
          updatedAt: string,
        },
        sampleTestDate?: number | null,
        sampleTestDateApproved?: boolean | null,
        prototypeDate?: number | null,
        prototypeDateApproved?: boolean | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    gr?: string | null,
    orderCreatorId: string,
    providers?:  {
      __typename: "ModelPopOrderProviderConnection",
      items:  Array< {
        __typename: "PopOrderProvider",
        id: string,
        orderId: string,
        providerId: string,
        deliveryDateRequested?: boolean | null,
        grRequested?: boolean | null,
        invoiceUploaded?: boolean | null,
        order:  {
          __typename: "PopOrder",
          id: string,
          estatus: string,
          orderId?: number | null,
          requirement?: string | null,
          budget?: number | null,
          delivery_cost?: number | null,
          delivery_time?: number | null,
          subtotal?: number | null,
          total?: number | null,
          isCoupa: boolean,
          sentToCoupa?: boolean | null,
          coupaOrder?: string | null,
          active?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          orderAgentIds?: Array< string | null > | null,
          gr?: string | null,
          orderCreatorId: string,
          prequoteApproved?: boolean | null,
          quoteApproved?: boolean | null,
          prototypeApproved?: boolean | null,
          samplesDocsUploaded?: boolean | null,
          samplesApproved?: boolean | null,
          auditRequired?: boolean | null,
          drivePath?: string | null,
          auditDocsUploaded?: boolean | null,
          deliveryDateRequested?: boolean | null,
          deliveryDate?: number | null,
          deliveryCode?: string | null,
          deliveryFilesUploaded?: boolean | null,
          deliveryDocsApproved?: boolean | null,
          grUploaded?: boolean | null,
          grApproved?: boolean | null,
          grCode?: string | null,
          qrCode?: boolean | null,
          brandfactoryCheck?: boolean | null,
          step?: number | null,
          prototype?: boolean | null,
          dateKickoff?: number | null,
          paymentDate?: number | null,
          currentProcess?: string | null,
          currentSubprocess?: string | null,
          clientId?: string | null,
        },
        provider:  {
          __typename: "Provider",
          id: string,
          isApproved?: boolean | null,
          comertial_name?: string | null,
          idProcter?: string | null,
          biography?: string | null,
          experience?: string | null,
          pros?: Array< string | null > | null,
          cons?: Array< string | null > | null,
          video?: string | null,
          tags?: Array< string | null > | null,
          money_filter_c?: boolean | null,
          money_filter_d?: boolean | null,
          users?: Array< string | null > | null,
          bank?: string | null,
          account?: string | null,
          clabe?: string | null,
          cuenta_correo?: string | null,
          isProvider?: boolean | null,
          sameAddress?: boolean | null,
          isPop?: boolean | null,
          isPrinted?: boolean | null,
          hasLogistic?: boolean | null,
          created?: number | null,
          updated?: number | null,
          representante_legal?: string | null,
          escritura_constitucion?: string | null,
          notario_a?: string | null,
          constituido_down_edo?: string | null,
          rrpp?: string | null,
          isPremium?: boolean | null,
          isTrustProvider?: boolean | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    prequoteApproved?: boolean | null,
    quoteApproved?: boolean | null,
    prototypeApproved?: boolean | null,
    samplesDocsUploaded?: boolean | null,
    samplesApproved?: boolean | null,
    auditRequired?: boolean | null,
    drivePath?: string | null,
    auditDocsUploaded?: boolean | null,
    deliveryDateRequested?: boolean | null,
    deliveryDate?: number | null,
    deliveryCode?: string | null,
    deliveryFilesUploaded?: boolean | null,
    deliveryDocsApproved?: boolean | null,
    grUploaded?: boolean | null,
    grApproved?: boolean | null,
    grCode?: string | null,
    qrCode?: boolean | null,
    brandfactoryCheck?: boolean | null,
    step?: number | null,
    prototype?: boolean | null,
    dateKickoff?: number | null,
    paymentDate?: number | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    clientId?: string | null,
  } | null,
};

export type UpdatePopOrderMutationVariables = {
  input: UpdatePopOrderInput,
  condition?: ModelPopOrderConditionInput | null,
};

export type UpdatePopOrderMutation = {
  updatePopOrder?:  {
    __typename: "PopOrder",
    id: string,
    estatus: string,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    orderId?: number | null,
    requirement?: string | null,
    budget?: number | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_time?: number | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    subtotal?: number | null,
    total?: number | null,
    isCoupa: boolean,
    sentToCoupa?: boolean | null,
    coupaOrder?: string | null,
    active?: string | null,
    vehicles?:  {
      __typename: "ModelPopOrderVehicleConnection",
      items:  Array< {
        __typename: "PopOrderVehicle",
        id: string,
        orderId: string,
        vehicleId: string,
        providerId: string,
        unitPrice: number,
        prototypePrice: number,
        quantity: number,
        approved: boolean,
        hasQrCode?: boolean | null,
        vehicle:  {
          __typename: "Vehicle",
          id: string,
          status?: string | null,
          isSustainable?: boolean | null,
          multiProvider?: boolean | null,
          itemName?: string | null,
          bestSeller?: string | null,
          name: string,
          brand: string,
          channel: string,
          description: string,
          size: string,
          materialDetail?: string | null,
          print?: string | null,
          finish?: string | null,
          packaging?: string | null,
          quantity: number,
          unitPrice: number,
          prototypePrice: number,
          productionTime: string,
          vehicleTypeId: string,
          popMaterialId: string,
          popCategoryId?: string | null,
          providerId: string,
          isRfq?: boolean | null,
          historicCost?: string | null,
          historicTime?: string | null,
          contact?: string | null,
          providerName?: string | null,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          providers?: Array< string | null > | null,
          massiveLayout?: string | null,
          created: number,
          updated?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        order:  {
          __typename: "PopOrder",
          id: string,
          estatus: string,
          orderId?: number | null,
          requirement?: string | null,
          budget?: number | null,
          delivery_cost?: number | null,
          delivery_time?: number | null,
          subtotal?: number | null,
          total?: number | null,
          isCoupa: boolean,
          sentToCoupa?: boolean | null,
          coupaOrder?: string | null,
          active?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          orderAgentIds?: Array< string | null > | null,
          gr?: string | null,
          orderCreatorId: string,
          prequoteApproved?: boolean | null,
          quoteApproved?: boolean | null,
          prototypeApproved?: boolean | null,
          samplesDocsUploaded?: boolean | null,
          samplesApproved?: boolean | null,
          auditRequired?: boolean | null,
          drivePath?: string | null,
          auditDocsUploaded?: boolean | null,
          deliveryDateRequested?: boolean | null,
          deliveryDate?: number | null,
          deliveryCode?: string | null,
          deliveryFilesUploaded?: boolean | null,
          deliveryDocsApproved?: boolean | null,
          grUploaded?: boolean | null,
          grApproved?: boolean | null,
          grCode?: string | null,
          qrCode?: boolean | null,
          brandfactoryCheck?: boolean | null,
          step?: number | null,
          prototype?: boolean | null,
          dateKickoff?: number | null,
          paymentDate?: number | null,
          currentProcess?: string | null,
          currentSubprocess?: string | null,
          clientId?: string | null,
        },
        provider:  {
          __typename: "Provider",
          id: string,
          isApproved?: boolean | null,
          comertial_name?: string | null,
          idProcter?: string | null,
          biography?: string | null,
          experience?: string | null,
          pros?: Array< string | null > | null,
          cons?: Array< string | null > | null,
          video?: string | null,
          tags?: Array< string | null > | null,
          money_filter_c?: boolean | null,
          money_filter_d?: boolean | null,
          users?: Array< string | null > | null,
          bank?: string | null,
          account?: string | null,
          clabe?: string | null,
          cuenta_correo?: string | null,
          isProvider?: boolean | null,
          sameAddress?: boolean | null,
          isPop?: boolean | null,
          isPrinted?: boolean | null,
          hasLogistic?: boolean | null,
          created?: number | null,
          updated?: number | null,
          representante_legal?: string | null,
          escritura_constitucion?: string | null,
          notario_a?: string | null,
          constituido_down_edo?: string | null,
          rrpp?: string | null,
          isPremium?: boolean | null,
          isTrustProvider?: boolean | null,
          createdAt: string,
          updatedAt: string,
        },
        sampleTestDate?: number | null,
        sampleTestDateApproved?: boolean | null,
        prototypeDate?: number | null,
        prototypeDateApproved?: boolean | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    gr?: string | null,
    orderCreatorId: string,
    providers?:  {
      __typename: "ModelPopOrderProviderConnection",
      items:  Array< {
        __typename: "PopOrderProvider",
        id: string,
        orderId: string,
        providerId: string,
        deliveryDateRequested?: boolean | null,
        grRequested?: boolean | null,
        invoiceUploaded?: boolean | null,
        order:  {
          __typename: "PopOrder",
          id: string,
          estatus: string,
          orderId?: number | null,
          requirement?: string | null,
          budget?: number | null,
          delivery_cost?: number | null,
          delivery_time?: number | null,
          subtotal?: number | null,
          total?: number | null,
          isCoupa: boolean,
          sentToCoupa?: boolean | null,
          coupaOrder?: string | null,
          active?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          orderAgentIds?: Array< string | null > | null,
          gr?: string | null,
          orderCreatorId: string,
          prequoteApproved?: boolean | null,
          quoteApproved?: boolean | null,
          prototypeApproved?: boolean | null,
          samplesDocsUploaded?: boolean | null,
          samplesApproved?: boolean | null,
          auditRequired?: boolean | null,
          drivePath?: string | null,
          auditDocsUploaded?: boolean | null,
          deliveryDateRequested?: boolean | null,
          deliveryDate?: number | null,
          deliveryCode?: string | null,
          deliveryFilesUploaded?: boolean | null,
          deliveryDocsApproved?: boolean | null,
          grUploaded?: boolean | null,
          grApproved?: boolean | null,
          grCode?: string | null,
          qrCode?: boolean | null,
          brandfactoryCheck?: boolean | null,
          step?: number | null,
          prototype?: boolean | null,
          dateKickoff?: number | null,
          paymentDate?: number | null,
          currentProcess?: string | null,
          currentSubprocess?: string | null,
          clientId?: string | null,
        },
        provider:  {
          __typename: "Provider",
          id: string,
          isApproved?: boolean | null,
          comertial_name?: string | null,
          idProcter?: string | null,
          biography?: string | null,
          experience?: string | null,
          pros?: Array< string | null > | null,
          cons?: Array< string | null > | null,
          video?: string | null,
          tags?: Array< string | null > | null,
          money_filter_c?: boolean | null,
          money_filter_d?: boolean | null,
          users?: Array< string | null > | null,
          bank?: string | null,
          account?: string | null,
          clabe?: string | null,
          cuenta_correo?: string | null,
          isProvider?: boolean | null,
          sameAddress?: boolean | null,
          isPop?: boolean | null,
          isPrinted?: boolean | null,
          hasLogistic?: boolean | null,
          created?: number | null,
          updated?: number | null,
          representante_legal?: string | null,
          escritura_constitucion?: string | null,
          notario_a?: string | null,
          constituido_down_edo?: string | null,
          rrpp?: string | null,
          isPremium?: boolean | null,
          isTrustProvider?: boolean | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    prequoteApproved?: boolean | null,
    quoteApproved?: boolean | null,
    prototypeApproved?: boolean | null,
    samplesDocsUploaded?: boolean | null,
    samplesApproved?: boolean | null,
    auditRequired?: boolean | null,
    drivePath?: string | null,
    auditDocsUploaded?: boolean | null,
    deliveryDateRequested?: boolean | null,
    deliveryDate?: number | null,
    deliveryCode?: string | null,
    deliveryFilesUploaded?: boolean | null,
    deliveryDocsApproved?: boolean | null,
    grUploaded?: boolean | null,
    grApproved?: boolean | null,
    grCode?: string | null,
    qrCode?: boolean | null,
    brandfactoryCheck?: boolean | null,
    step?: number | null,
    prototype?: boolean | null,
    dateKickoff?: number | null,
    paymentDate?: number | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    clientId?: string | null,
  } | null,
};

export type DeletePopOrderMutationVariables = {
  input: DeletePopOrderInput,
  condition?: ModelPopOrderConditionInput | null,
};

export type DeletePopOrderMutation = {
  deletePopOrder?:  {
    __typename: "PopOrder",
    id: string,
    estatus: string,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    orderId?: number | null,
    requirement?: string | null,
    budget?: number | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_time?: number | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    subtotal?: number | null,
    total?: number | null,
    isCoupa: boolean,
    sentToCoupa?: boolean | null,
    coupaOrder?: string | null,
    active?: string | null,
    vehicles?:  {
      __typename: "ModelPopOrderVehicleConnection",
      items:  Array< {
        __typename: "PopOrderVehicle",
        id: string,
        orderId: string,
        vehicleId: string,
        providerId: string,
        unitPrice: number,
        prototypePrice: number,
        quantity: number,
        approved: boolean,
        hasQrCode?: boolean | null,
        vehicle:  {
          __typename: "Vehicle",
          id: string,
          status?: string | null,
          isSustainable?: boolean | null,
          multiProvider?: boolean | null,
          itemName?: string | null,
          bestSeller?: string | null,
          name: string,
          brand: string,
          channel: string,
          description: string,
          size: string,
          materialDetail?: string | null,
          print?: string | null,
          finish?: string | null,
          packaging?: string | null,
          quantity: number,
          unitPrice: number,
          prototypePrice: number,
          productionTime: string,
          vehicleTypeId: string,
          popMaterialId: string,
          popCategoryId?: string | null,
          providerId: string,
          isRfq?: boolean | null,
          historicCost?: string | null,
          historicTime?: string | null,
          contact?: string | null,
          providerName?: string | null,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          providers?: Array< string | null > | null,
          massiveLayout?: string | null,
          created: number,
          updated?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        order:  {
          __typename: "PopOrder",
          id: string,
          estatus: string,
          orderId?: number | null,
          requirement?: string | null,
          budget?: number | null,
          delivery_cost?: number | null,
          delivery_time?: number | null,
          subtotal?: number | null,
          total?: number | null,
          isCoupa: boolean,
          sentToCoupa?: boolean | null,
          coupaOrder?: string | null,
          active?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          orderAgentIds?: Array< string | null > | null,
          gr?: string | null,
          orderCreatorId: string,
          prequoteApproved?: boolean | null,
          quoteApproved?: boolean | null,
          prototypeApproved?: boolean | null,
          samplesDocsUploaded?: boolean | null,
          samplesApproved?: boolean | null,
          auditRequired?: boolean | null,
          drivePath?: string | null,
          auditDocsUploaded?: boolean | null,
          deliveryDateRequested?: boolean | null,
          deliveryDate?: number | null,
          deliveryCode?: string | null,
          deliveryFilesUploaded?: boolean | null,
          deliveryDocsApproved?: boolean | null,
          grUploaded?: boolean | null,
          grApproved?: boolean | null,
          grCode?: string | null,
          qrCode?: boolean | null,
          brandfactoryCheck?: boolean | null,
          step?: number | null,
          prototype?: boolean | null,
          dateKickoff?: number | null,
          paymentDate?: number | null,
          currentProcess?: string | null,
          currentSubprocess?: string | null,
          clientId?: string | null,
        },
        provider:  {
          __typename: "Provider",
          id: string,
          isApproved?: boolean | null,
          comertial_name?: string | null,
          idProcter?: string | null,
          biography?: string | null,
          experience?: string | null,
          pros?: Array< string | null > | null,
          cons?: Array< string | null > | null,
          video?: string | null,
          tags?: Array< string | null > | null,
          money_filter_c?: boolean | null,
          money_filter_d?: boolean | null,
          users?: Array< string | null > | null,
          bank?: string | null,
          account?: string | null,
          clabe?: string | null,
          cuenta_correo?: string | null,
          isProvider?: boolean | null,
          sameAddress?: boolean | null,
          isPop?: boolean | null,
          isPrinted?: boolean | null,
          hasLogistic?: boolean | null,
          created?: number | null,
          updated?: number | null,
          representante_legal?: string | null,
          escritura_constitucion?: string | null,
          notario_a?: string | null,
          constituido_down_edo?: string | null,
          rrpp?: string | null,
          isPremium?: boolean | null,
          isTrustProvider?: boolean | null,
          createdAt: string,
          updatedAt: string,
        },
        sampleTestDate?: number | null,
        sampleTestDateApproved?: boolean | null,
        prototypeDate?: number | null,
        prototypeDateApproved?: boolean | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    gr?: string | null,
    orderCreatorId: string,
    providers?:  {
      __typename: "ModelPopOrderProviderConnection",
      items:  Array< {
        __typename: "PopOrderProvider",
        id: string,
        orderId: string,
        providerId: string,
        deliveryDateRequested?: boolean | null,
        grRequested?: boolean | null,
        invoiceUploaded?: boolean | null,
        order:  {
          __typename: "PopOrder",
          id: string,
          estatus: string,
          orderId?: number | null,
          requirement?: string | null,
          budget?: number | null,
          delivery_cost?: number | null,
          delivery_time?: number | null,
          subtotal?: number | null,
          total?: number | null,
          isCoupa: boolean,
          sentToCoupa?: boolean | null,
          coupaOrder?: string | null,
          active?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          orderAgentIds?: Array< string | null > | null,
          gr?: string | null,
          orderCreatorId: string,
          prequoteApproved?: boolean | null,
          quoteApproved?: boolean | null,
          prototypeApproved?: boolean | null,
          samplesDocsUploaded?: boolean | null,
          samplesApproved?: boolean | null,
          auditRequired?: boolean | null,
          drivePath?: string | null,
          auditDocsUploaded?: boolean | null,
          deliveryDateRequested?: boolean | null,
          deliveryDate?: number | null,
          deliveryCode?: string | null,
          deliveryFilesUploaded?: boolean | null,
          deliveryDocsApproved?: boolean | null,
          grUploaded?: boolean | null,
          grApproved?: boolean | null,
          grCode?: string | null,
          qrCode?: boolean | null,
          brandfactoryCheck?: boolean | null,
          step?: number | null,
          prototype?: boolean | null,
          dateKickoff?: number | null,
          paymentDate?: number | null,
          currentProcess?: string | null,
          currentSubprocess?: string | null,
          clientId?: string | null,
        },
        provider:  {
          __typename: "Provider",
          id: string,
          isApproved?: boolean | null,
          comertial_name?: string | null,
          idProcter?: string | null,
          biography?: string | null,
          experience?: string | null,
          pros?: Array< string | null > | null,
          cons?: Array< string | null > | null,
          video?: string | null,
          tags?: Array< string | null > | null,
          money_filter_c?: boolean | null,
          money_filter_d?: boolean | null,
          users?: Array< string | null > | null,
          bank?: string | null,
          account?: string | null,
          clabe?: string | null,
          cuenta_correo?: string | null,
          isProvider?: boolean | null,
          sameAddress?: boolean | null,
          isPop?: boolean | null,
          isPrinted?: boolean | null,
          hasLogistic?: boolean | null,
          created?: number | null,
          updated?: number | null,
          representante_legal?: string | null,
          escritura_constitucion?: string | null,
          notario_a?: string | null,
          constituido_down_edo?: string | null,
          rrpp?: string | null,
          isPremium?: boolean | null,
          isTrustProvider?: boolean | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    prequoteApproved?: boolean | null,
    quoteApproved?: boolean | null,
    prototypeApproved?: boolean | null,
    samplesDocsUploaded?: boolean | null,
    samplesApproved?: boolean | null,
    auditRequired?: boolean | null,
    drivePath?: string | null,
    auditDocsUploaded?: boolean | null,
    deliveryDateRequested?: boolean | null,
    deliveryDate?: number | null,
    deliveryCode?: string | null,
    deliveryFilesUploaded?: boolean | null,
    deliveryDocsApproved?: boolean | null,
    grUploaded?: boolean | null,
    grApproved?: boolean | null,
    grCode?: string | null,
    qrCode?: boolean | null,
    brandfactoryCheck?: boolean | null,
    step?: number | null,
    prototype?: boolean | null,
    dateKickoff?: number | null,
    paymentDate?: number | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    clientId?: string | null,
  } | null,
};

export type CreateOrderFileMutationVariables = {
  input: CreateOrderFileInput,
  condition?: ModelOrderFileConditionInput | null,
};

export type CreateOrderFileMutation = {
  createOrderFile?:  {
    __typename: "OrderFile",
    id: string,
    createdAt?: string | null,
    creatorId: string,
    orderId: string,
    key?: string | null,
    url?: string | null,
    orderStatus: string,
    updatedAt: string,
  } | null,
};

export type UpdateOrderFileMutationVariables = {
  input: UpdateOrderFileInput,
  condition?: ModelOrderFileConditionInput | null,
};

export type UpdateOrderFileMutation = {
  updateOrderFile?:  {
    __typename: "OrderFile",
    id: string,
    createdAt?: string | null,
    creatorId: string,
    orderId: string,
    key?: string | null,
    url?: string | null,
    orderStatus: string,
    updatedAt: string,
  } | null,
};

export type DeleteOrderFileMutationVariables = {
  input: DeleteOrderFileInput,
  condition?: ModelOrderFileConditionInput | null,
};

export type DeleteOrderFileMutation = {
  deleteOrderFile?:  {
    __typename: "OrderFile",
    id: string,
    createdAt?: string | null,
    creatorId: string,
    orderId: string,
    key?: string | null,
    url?: string | null,
    orderStatus: string,
    updatedAt: string,
  } | null,
};

export type CreatePopOrderVehicleMutationVariables = {
  input: CreatePopOrderVehicleInput,
  condition?: ModelPopOrderVehicleConditionInput | null,
};

export type CreatePopOrderVehicleMutation = {
  createPopOrderVehicle?:  {
    __typename: "PopOrderVehicle",
    id: string,
    orderId: string,
    vehicleId: string,
    providerId: string,
    unitPrice: number,
    prototypePrice: number,
    quantity: number,
    approved: boolean,
    hasQrCode?: boolean | null,
    vehicle:  {
      __typename: "Vehicle",
      id: string,
      status?: string | null,
      isSustainable?: boolean | null,
      multiProvider?: boolean | null,
      itemName?: string | null,
      bestSeller?: string | null,
      name: string,
      brand: string,
      channel: string,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      description: string,
      size: string,
      materialDetail?: string | null,
      print?: string | null,
      finish?: string | null,
      packaging?: string | null,
      quantity: number,
      unitPrice: number,
      prototypePrice: number,
      productionTime: string,
      vehicleTypeId: string,
      popMaterialId: string,
      popCategoryId?: string | null,
      providerId: string,
      isRfq?: boolean | null,
      historicCost?: string | null,
      historicTime?: string | null,
      contact?: string | null,
      providerName?: string | null,
      variantsUnits?:  Array< {
        __typename: "VariantsUnits",
        min_units?: number | null,
        max_units?: number | null,
        price?: number | null,
        production_time?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      massiveLayout?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    order:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    },
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    sampleTestDate?: number | null,
    sampleTestDateApproved?: boolean | null,
    prototypeDate?: number | null,
    prototypeDateApproved?: boolean | null,
    logs?:  Array< {
      __typename: "ProductInOrderLog",
      product_id: string,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePopOrderVehicleMutationVariables = {
  input: UpdatePopOrderVehicleInput,
  condition?: ModelPopOrderVehicleConditionInput | null,
};

export type UpdatePopOrderVehicleMutation = {
  updatePopOrderVehicle?:  {
    __typename: "PopOrderVehicle",
    id: string,
    orderId: string,
    vehicleId: string,
    providerId: string,
    unitPrice: number,
    prototypePrice: number,
    quantity: number,
    approved: boolean,
    hasQrCode?: boolean | null,
    vehicle:  {
      __typename: "Vehicle",
      id: string,
      status?: string | null,
      isSustainable?: boolean | null,
      multiProvider?: boolean | null,
      itemName?: string | null,
      bestSeller?: string | null,
      name: string,
      brand: string,
      channel: string,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      description: string,
      size: string,
      materialDetail?: string | null,
      print?: string | null,
      finish?: string | null,
      packaging?: string | null,
      quantity: number,
      unitPrice: number,
      prototypePrice: number,
      productionTime: string,
      vehicleTypeId: string,
      popMaterialId: string,
      popCategoryId?: string | null,
      providerId: string,
      isRfq?: boolean | null,
      historicCost?: string | null,
      historicTime?: string | null,
      contact?: string | null,
      providerName?: string | null,
      variantsUnits?:  Array< {
        __typename: "VariantsUnits",
        min_units?: number | null,
        max_units?: number | null,
        price?: number | null,
        production_time?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      massiveLayout?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    order:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    },
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    sampleTestDate?: number | null,
    sampleTestDateApproved?: boolean | null,
    prototypeDate?: number | null,
    prototypeDateApproved?: boolean | null,
    logs?:  Array< {
      __typename: "ProductInOrderLog",
      product_id: string,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePopOrderVehicleMutationVariables = {
  input: DeletePopOrderVehicleInput,
  condition?: ModelPopOrderVehicleConditionInput | null,
};

export type DeletePopOrderVehicleMutation = {
  deletePopOrderVehicle?:  {
    __typename: "PopOrderVehicle",
    id: string,
    orderId: string,
    vehicleId: string,
    providerId: string,
    unitPrice: number,
    prototypePrice: number,
    quantity: number,
    approved: boolean,
    hasQrCode?: boolean | null,
    vehicle:  {
      __typename: "Vehicle",
      id: string,
      status?: string | null,
      isSustainable?: boolean | null,
      multiProvider?: boolean | null,
      itemName?: string | null,
      bestSeller?: string | null,
      name: string,
      brand: string,
      channel: string,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      description: string,
      size: string,
      materialDetail?: string | null,
      print?: string | null,
      finish?: string | null,
      packaging?: string | null,
      quantity: number,
      unitPrice: number,
      prototypePrice: number,
      productionTime: string,
      vehicleTypeId: string,
      popMaterialId: string,
      popCategoryId?: string | null,
      providerId: string,
      isRfq?: boolean | null,
      historicCost?: string | null,
      historicTime?: string | null,
      contact?: string | null,
      providerName?: string | null,
      variantsUnits?:  Array< {
        __typename: "VariantsUnits",
        min_units?: number | null,
        max_units?: number | null,
        price?: number | null,
        production_time?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      massiveLayout?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    order:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    },
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    sampleTestDate?: number | null,
    sampleTestDateApproved?: boolean | null,
    prototypeDate?: number | null,
    prototypeDateApproved?: boolean | null,
    logs?:  Array< {
      __typename: "ProductInOrderLog",
      product_id: string,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePopOrderAuthorizerMutationVariables = {
  input: CreatePopOrderAuthorizerInput,
  condition?: ModelPopOrderAuthorizerConditionInput | null,
};

export type CreatePopOrderAuthorizerMutation = {
  createPopOrderAuthorizer?:  {
    __typename: "PopOrderAuthorizer",
    id: string,
    userId: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePopOrderAuthorizerMutationVariables = {
  input: UpdatePopOrderAuthorizerInput,
  condition?: ModelPopOrderAuthorizerConditionInput | null,
};

export type UpdatePopOrderAuthorizerMutation = {
  updatePopOrderAuthorizer?:  {
    __typename: "PopOrderAuthorizer",
    id: string,
    userId: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePopOrderAuthorizerMutationVariables = {
  input: DeletePopOrderAuthorizerInput,
  condition?: ModelPopOrderAuthorizerConditionInput | null,
};

export type DeletePopOrderAuthorizerMutation = {
  deletePopOrderAuthorizer?:  {
    __typename: "PopOrderAuthorizer",
    id: string,
    userId: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePopOrderProviderMutationVariables = {
  input: CreatePopOrderProviderInput,
  condition?: ModelPopOrderProviderConditionInput | null,
};

export type CreatePopOrderProviderMutation = {
  createPopOrderProvider?:  {
    __typename: "PopOrderProvider",
    id: string,
    orderId: string,
    providerId: string,
    deliveryDateRequested?: boolean | null,
    grRequested?: boolean | null,
    invoiceUploaded?: boolean | null,
    order:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    },
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdatePopOrderProviderMutationVariables = {
  input: UpdatePopOrderProviderInput,
  condition?: ModelPopOrderProviderConditionInput | null,
};

export type UpdatePopOrderProviderMutation = {
  updatePopOrderProvider?:  {
    __typename: "PopOrderProvider",
    id: string,
    orderId: string,
    providerId: string,
    deliveryDateRequested?: boolean | null,
    grRequested?: boolean | null,
    invoiceUploaded?: boolean | null,
    order:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    },
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeletePopOrderProviderMutationVariables = {
  input: DeletePopOrderProviderInput,
  condition?: ModelPopOrderProviderConditionInput | null,
};

export type DeletePopOrderProviderMutation = {
  deletePopOrderProvider?:  {
    __typename: "PopOrderProvider",
    id: string,
    orderId: string,
    providerId: string,
    deliveryDateRequested?: boolean | null,
    grRequested?: boolean | null,
    invoiceUploaded?: boolean | null,
    order:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    },
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreatePopOrderLogMutationVariables = {
  input: CreatePopOrderLogInput,
  condition?: ModelPopOrderLogConditionInput | null,
};

export type CreatePopOrderLogMutation = {
  createPopOrderLog?:  {
    __typename: "PopOrderLog",
    id: string,
    orderId: string,
    creatorId: string,
    order?:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    } | null,
    createdAt?: string | null,
    text: string,
    orderStatus: string,
    updatedAt: string,
  } | null,
};

export type UpdatePopOrderLogMutationVariables = {
  input: UpdatePopOrderLogInput,
  condition?: ModelPopOrderLogConditionInput | null,
};

export type UpdatePopOrderLogMutation = {
  updatePopOrderLog?:  {
    __typename: "PopOrderLog",
    id: string,
    orderId: string,
    creatorId: string,
    order?:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    } | null,
    createdAt?: string | null,
    text: string,
    orderStatus: string,
    updatedAt: string,
  } | null,
};

export type DeletePopOrderLogMutationVariables = {
  input: DeletePopOrderLogInput,
  condition?: ModelPopOrderLogConditionInput | null,
};

export type DeletePopOrderLogMutation = {
  deletePopOrderLog?:  {
    __typename: "PopOrderLog",
    id: string,
    orderId: string,
    creatorId: string,
    order?:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    } | null,
    createdAt?: string | null,
    text: string,
    orderStatus: string,
    updatedAt: string,
  } | null,
};

export type CreateRfqPopMutationVariables = {
  input: CreateRfqPopInput,
  condition?: ModelRfqPopConditionInput | null,
};

export type CreateRfqPopMutation = {
  createRfqPop?:  {
    __typename: "RfqPop",
    id: string,
    nombre: string,
    requerimiento: string,
    vehicleTypeId?: string | null,
    popMaterialId?: string | null,
    vehiclesRfq?:  Array< {
      __typename: "VehicleUnitRfq",
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    proposals?:  {
      __typename: "ModelProposalsPopConnection",
      items:  Array< {
        __typename: "ProposalsPop",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        created: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        vehicles?:  Array< {
          __typename: "VehiclesProposalsPop",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          popMaterialId?: string | null,
          vehicleTypeId?: string | null,
          brand?: string | null,
          size?: string | null,
          description?: string | null,
          quantity?: number | null,
          packaging?: string | null,
          materialDetail?: string | null,
          print?: string | null,
          unitPrice?: number | null,
          pieces?: number | null,
          priceUnit?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        rfq?:  {
          __typename: "RfqPop",
          id: string,
          nombre: string,
          requerimiento: string,
          vehicleTypeId?: string | null,
          popMaterialId?: string | null,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId?: string | null,
          orderAgentIds?: Array< string | null > | null,
          popOrderId?: string | null,
          orderId?: number | null,
          estatus: string,
          start_time: number,
          delivery_time?: number | null,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          budget?: number | null,
          hasQrCode?: boolean | null,
          created: number,
          createdAt?: string | null,
          updated?: number | null,
          updatedAt: string,
        } | null,
        proposalsPopRfqId?: string | null,
        prototypePrice: number,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    clientId?: string | null,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    providers?:  Array< {
      __typename: "RfqPopProviders",
      idProvider?: string | null,
    } | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    popOrderId?: string | null,
    orderId?: number | null,
    estatus: string,
    start_time: number,
    delivery_time?: number | null,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    budget?: number | null,
    hasQrCode?: boolean | null,
    created: number,
    createdAt?: string | null,
    updated?: number | null,
    updatedAt: string,
  } | null,
};

export type UpdateRfqPopMutationVariables = {
  input: UpdateRfqPopInput,
  condition?: ModelRfqPopConditionInput | null,
};

export type UpdateRfqPopMutation = {
  updateRfqPop?:  {
    __typename: "RfqPop",
    id: string,
    nombre: string,
    requerimiento: string,
    vehicleTypeId?: string | null,
    popMaterialId?: string | null,
    vehiclesRfq?:  Array< {
      __typename: "VehicleUnitRfq",
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    proposals?:  {
      __typename: "ModelProposalsPopConnection",
      items:  Array< {
        __typename: "ProposalsPop",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        created: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        vehicles?:  Array< {
          __typename: "VehiclesProposalsPop",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          popMaterialId?: string | null,
          vehicleTypeId?: string | null,
          brand?: string | null,
          size?: string | null,
          description?: string | null,
          quantity?: number | null,
          packaging?: string | null,
          materialDetail?: string | null,
          print?: string | null,
          unitPrice?: number | null,
          pieces?: number | null,
          priceUnit?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        rfq?:  {
          __typename: "RfqPop",
          id: string,
          nombre: string,
          requerimiento: string,
          vehicleTypeId?: string | null,
          popMaterialId?: string | null,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId?: string | null,
          orderAgentIds?: Array< string | null > | null,
          popOrderId?: string | null,
          orderId?: number | null,
          estatus: string,
          start_time: number,
          delivery_time?: number | null,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          budget?: number | null,
          hasQrCode?: boolean | null,
          created: number,
          createdAt?: string | null,
          updated?: number | null,
          updatedAt: string,
        } | null,
        proposalsPopRfqId?: string | null,
        prototypePrice: number,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    clientId?: string | null,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    providers?:  Array< {
      __typename: "RfqPopProviders",
      idProvider?: string | null,
    } | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    popOrderId?: string | null,
    orderId?: number | null,
    estatus: string,
    start_time: number,
    delivery_time?: number | null,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    budget?: number | null,
    hasQrCode?: boolean | null,
    created: number,
    createdAt?: string | null,
    updated?: number | null,
    updatedAt: string,
  } | null,
};

export type DeleteRfqPopMutationVariables = {
  input: DeleteRfqPopInput,
  condition?: ModelRfqPopConditionInput | null,
};

export type DeleteRfqPopMutation = {
  deleteRfqPop?:  {
    __typename: "RfqPop",
    id: string,
    nombre: string,
    requerimiento: string,
    vehicleTypeId?: string | null,
    popMaterialId?: string | null,
    vehiclesRfq?:  Array< {
      __typename: "VehicleUnitRfq",
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    proposals?:  {
      __typename: "ModelProposalsPopConnection",
      items:  Array< {
        __typename: "ProposalsPop",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        created: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        vehicles?:  Array< {
          __typename: "VehiclesProposalsPop",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          popMaterialId?: string | null,
          vehicleTypeId?: string | null,
          brand?: string | null,
          size?: string | null,
          description?: string | null,
          quantity?: number | null,
          packaging?: string | null,
          materialDetail?: string | null,
          print?: string | null,
          unitPrice?: number | null,
          pieces?: number | null,
          priceUnit?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        rfq?:  {
          __typename: "RfqPop",
          id: string,
          nombre: string,
          requerimiento: string,
          vehicleTypeId?: string | null,
          popMaterialId?: string | null,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId?: string | null,
          orderAgentIds?: Array< string | null > | null,
          popOrderId?: string | null,
          orderId?: number | null,
          estatus: string,
          start_time: number,
          delivery_time?: number | null,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          budget?: number | null,
          hasQrCode?: boolean | null,
          created: number,
          createdAt?: string | null,
          updated?: number | null,
          updatedAt: string,
        } | null,
        proposalsPopRfqId?: string | null,
        prototypePrice: number,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    clientId?: string | null,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    providers?:  Array< {
      __typename: "RfqPopProviders",
      idProvider?: string | null,
    } | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    popOrderId?: string | null,
    orderId?: number | null,
    estatus: string,
    start_time: number,
    delivery_time?: number | null,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    budget?: number | null,
    hasQrCode?: boolean | null,
    created: number,
    createdAt?: string | null,
    updated?: number | null,
    updatedAt: string,
  } | null,
};

export type CreateProposalsPopMutationVariables = {
  input: CreateProposalsPopInput,
  condition?: ModelProposalsPopConditionInput | null,
};

export type CreateProposalsPopMutation = {
  createProposalsPop?:  {
    __typename: "ProposalsPop",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    created: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    vehicles?:  Array< {
      __typename: "VehiclesProposalsPop",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      popMaterialId?: string | null,
      vehicleTypeId?: string | null,
      brand?: string | null,
      size?: string | null,
      description?: string | null,
      quantity?: number | null,
      packaging?: string | null,
      materialDetail?: string | null,
      print?: string | null,
      unitPrice?: number | null,
      pieces?: number | null,
      priceUnit?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    rfq?:  {
      __typename: "RfqPop",
      id: string,
      nombre: string,
      requerimiento: string,
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      vehiclesRfq?:  Array< {
        __typename: "VehicleUnitRfq",
        vehicleTypeId?: string | null,
        popMaterialId?: string | null,
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      proposals?:  {
        __typename: "ModelProposalsPopConnection",
        items:  Array< {
          __typename: "ProposalsPop",
          id: string,
          provider_id: string,
          price: number,
          created: number,
          validity_days?: number | null,
          description?: string | null,
          updated?: number | null,
          proposalsPopRfqId?: string | null,
          prototypePrice: number,
          hidden?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      clientId?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfqPopProviders",
        idProvider?: string | null,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      popOrderId?: string | null,
      orderId?: number | null,
      estatus: string,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      budget?: number | null,
      hasQrCode?: boolean | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null,
    proposalsPopRfqId?: string | null,
    prototypePrice: number,
    hidden?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateProposalsPopMutationVariables = {
  input: UpdateProposalsPopInput,
  condition?: ModelProposalsPopConditionInput | null,
};

export type UpdateProposalsPopMutation = {
  updateProposalsPop?:  {
    __typename: "ProposalsPop",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    created: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    vehicles?:  Array< {
      __typename: "VehiclesProposalsPop",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      popMaterialId?: string | null,
      vehicleTypeId?: string | null,
      brand?: string | null,
      size?: string | null,
      description?: string | null,
      quantity?: number | null,
      packaging?: string | null,
      materialDetail?: string | null,
      print?: string | null,
      unitPrice?: number | null,
      pieces?: number | null,
      priceUnit?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    rfq?:  {
      __typename: "RfqPop",
      id: string,
      nombre: string,
      requerimiento: string,
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      vehiclesRfq?:  Array< {
        __typename: "VehicleUnitRfq",
        vehicleTypeId?: string | null,
        popMaterialId?: string | null,
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      proposals?:  {
        __typename: "ModelProposalsPopConnection",
        items:  Array< {
          __typename: "ProposalsPop",
          id: string,
          provider_id: string,
          price: number,
          created: number,
          validity_days?: number | null,
          description?: string | null,
          updated?: number | null,
          proposalsPopRfqId?: string | null,
          prototypePrice: number,
          hidden?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      clientId?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfqPopProviders",
        idProvider?: string | null,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      popOrderId?: string | null,
      orderId?: number | null,
      estatus: string,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      budget?: number | null,
      hasQrCode?: boolean | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null,
    proposalsPopRfqId?: string | null,
    prototypePrice: number,
    hidden?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteProposalsPopMutationVariables = {
  input: DeleteProposalsPopInput,
  condition?: ModelProposalsPopConditionInput | null,
};

export type DeleteProposalsPopMutation = {
  deleteProposalsPop?:  {
    __typename: "ProposalsPop",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    created: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    vehicles?:  Array< {
      __typename: "VehiclesProposalsPop",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      popMaterialId?: string | null,
      vehicleTypeId?: string | null,
      brand?: string | null,
      size?: string | null,
      description?: string | null,
      quantity?: number | null,
      packaging?: string | null,
      materialDetail?: string | null,
      print?: string | null,
      unitPrice?: number | null,
      pieces?: number | null,
      priceUnit?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    rfq?:  {
      __typename: "RfqPop",
      id: string,
      nombre: string,
      requerimiento: string,
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      vehiclesRfq?:  Array< {
        __typename: "VehicleUnitRfq",
        vehicleTypeId?: string | null,
        popMaterialId?: string | null,
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      proposals?:  {
        __typename: "ModelProposalsPopConnection",
        items:  Array< {
          __typename: "ProposalsPop",
          id: string,
          provider_id: string,
          price: number,
          created: number,
          validity_days?: number | null,
          description?: string | null,
          updated?: number | null,
          proposalsPopRfqId?: string | null,
          prototypePrice: number,
          hidden?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      clientId?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfqPopProviders",
        idProvider?: string | null,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      popOrderId?: string | null,
      orderId?: number | null,
      estatus: string,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      budget?: number | null,
      hasQrCode?: boolean | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null,
    proposalsPopRfqId?: string | null,
    prototypePrice: number,
    hidden?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUsersBrandsMutationVariables = {
  input: CreateUsersBrandsInput,
  condition?: ModelUsersBrandsConditionInput | null,
};

export type CreateUsersBrandsMutation = {
  createUsersBrands?:  {
    __typename: "UsersBrands",
    id: string,
    name: string,
    description?: string | null,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    status?: string | null,
    clientId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUsersBrandsMutationVariables = {
  input: UpdateUsersBrandsInput,
  condition?: ModelUsersBrandsConditionInput | null,
};

export type UpdateUsersBrandsMutation = {
  updateUsersBrands?:  {
    __typename: "UsersBrands",
    id: string,
    name: string,
    description?: string | null,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    status?: string | null,
    clientId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUsersBrandsMutationVariables = {
  input: DeleteUsersBrandsInput,
  condition?: ModelUsersBrandsConditionInput | null,
};

export type DeleteUsersBrandsMutation = {
  deleteUsersBrands?:  {
    __typename: "UsersBrands",
    id: string,
    name: string,
    description?: string | null,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    status?: string | null,
    clientId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserBrandSettingMutationVariables = {
  input: CreateUserBrandSettingInput,
  condition?: ModelUserBrandSettingConditionInput | null,
};

export type CreateUserBrandSettingMutation = {
  createUserBrandSetting?:  {
    __typename: "UserBrandSetting",
    id: string,
    categories?: Array< string | null > | null,
    subcategories?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateUserBrandSettingMutationVariables = {
  input: UpdateUserBrandSettingInput,
  condition?: ModelUserBrandSettingConditionInput | null,
};

export type UpdateUserBrandSettingMutation = {
  updateUserBrandSetting?:  {
    __typename: "UserBrandSetting",
    id: string,
    categories?: Array< string | null > | null,
    subcategories?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteUserBrandSettingMutationVariables = {
  input: DeleteUserBrandSettingInput,
  condition?: ModelUserBrandSettingConditionInput | null,
};

export type DeleteUserBrandSettingMutation = {
  deleteUserBrandSetting?:  {
    __typename: "UserBrandSetting",
    id: string,
    categories?: Array< string | null > | null,
    subcategories?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateLogsPUsersMutationVariables = {
  input: CreateLogsPUsersInput,
  condition?: ModelLogsPUsersConditionInput | null,
};

export type CreateLogsPUsersMutation = {
  createLogsPUsers?:  {
    __typename: "LogsPUsers",
    id: string,
    user?: string | null,
    keyword?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateLogsPUsersMutationVariables = {
  input: UpdateLogsPUsersInput,
  condition?: ModelLogsPUsersConditionInput | null,
};

export type UpdateLogsPUsersMutation = {
  updateLogsPUsers?:  {
    __typename: "LogsPUsers",
    id: string,
    user?: string | null,
    keyword?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteLogsPUsersMutationVariables = {
  input: DeleteLogsPUsersInput,
  condition?: ModelLogsPUsersConditionInput | null,
};

export type DeleteLogsPUsersMutation = {
  deleteLogsPUsers?:  {
    __typename: "LogsPUsers",
    id: string,
    user?: string | null,
    keyword?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateClipPaymentMutationVariables = {
  input: CreateClipPaymentInput,
  condition?: ModelClipPaymentConditionInput | null,
};

export type CreateClipPaymentMutation = {
  createClipPayment?:  {
    __typename: "ClipPayment",
    id: string,
    status?: string | null,
    requestsCount?: number | null,
    payment_request_id?: string | null,
    purchase_description?: string | null,
    orderId: string,
    clientId: string,
    userId: string,
    creator?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateClipPaymentMutationVariables = {
  input: UpdateClipPaymentInput,
  condition?: ModelClipPaymentConditionInput | null,
};

export type UpdateClipPaymentMutation = {
  updateClipPayment?:  {
    __typename: "ClipPayment",
    id: string,
    status?: string | null,
    requestsCount?: number | null,
    payment_request_id?: string | null,
    purchase_description?: string | null,
    orderId: string,
    clientId: string,
    userId: string,
    creator?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteClipPaymentMutationVariables = {
  input: DeleteClipPaymentInput,
  condition?: ModelClipPaymentConditionInput | null,
};

export type DeleteClipPaymentMutation = {
  deleteClipPayment?:  {
    __typename: "ClipPayment",
    id: string,
    status?: string | null,
    requestsCount?: number | null,
    payment_request_id?: string | null,
    purchase_description?: string | null,
    orderId: string,
    clientId: string,
    userId: string,
    creator?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOrderProcessMutationVariables = {
  input: CreateOrderProcessInput,
  condition?: ModelOrderProcessConditionInput | null,
};

export type CreateOrderProcessMutation = {
  createOrderProcess?:  {
    __typename: "OrderProcess",
    id: string,
    type?: string | null,
    status?: boolean | null,
    tcdPayment?: boolean | null,
    name: string,
    duration?: string | null,
    descripcion?: string | null,
    position: number,
    responsible?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    cards?:  Array< {
      __typename: "OrderCards",
      id?: string | null,
      name?: string | null,
      permissions?:  Array< {
        __typename: "OrderCardPermissions",
        idCard: string,
        rol: string,
        thirdContent?: boolean | null,
        visible?: boolean | null,
      } | null > | null,
    } | null > | null,
    subprocesses?:  {
      __typename: "ModelOrderSubprocessConnection",
      items:  Array< {
        __typename: "OrderSubprocess",
        id: string,
        type?: string | null,
        status?: boolean | null,
        name: string,
        position: number,
        descripcion: string,
        action: number,
        process?:  {
          __typename: "OrderProcess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          tcdPayment?: boolean | null,
          name: string,
          duration?: string | null,
          descripcion?: string | null,
          position: number,
          responsible?: number | null,
          clientId?: string | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null,
        processId: string,
        clientId: string,
        messages?:  Array< {
          __typename: "MessageSubprocess",
          description?: string | null,
          rol?: string | null,
          visibleAction?: boolean | null,
        } | null > | null,
        notifications?:  Array< {
          __typename: "NotificationSubprocesses",
          group?: string | null,
          enabledEmail?: boolean | null,
          enabledPopUp?: boolean | null,
        } | null > | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    clientId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateOrderProcessMutationVariables = {
  input: UpdateOrderProcessInput,
  condition?: ModelOrderProcessConditionInput | null,
};

export type UpdateOrderProcessMutation = {
  updateOrderProcess?:  {
    __typename: "OrderProcess",
    id: string,
    type?: string | null,
    status?: boolean | null,
    tcdPayment?: boolean | null,
    name: string,
    duration?: string | null,
    descripcion?: string | null,
    position: number,
    responsible?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    cards?:  Array< {
      __typename: "OrderCards",
      id?: string | null,
      name?: string | null,
      permissions?:  Array< {
        __typename: "OrderCardPermissions",
        idCard: string,
        rol: string,
        thirdContent?: boolean | null,
        visible?: boolean | null,
      } | null > | null,
    } | null > | null,
    subprocesses?:  {
      __typename: "ModelOrderSubprocessConnection",
      items:  Array< {
        __typename: "OrderSubprocess",
        id: string,
        type?: string | null,
        status?: boolean | null,
        name: string,
        position: number,
        descripcion: string,
        action: number,
        process?:  {
          __typename: "OrderProcess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          tcdPayment?: boolean | null,
          name: string,
          duration?: string | null,
          descripcion?: string | null,
          position: number,
          responsible?: number | null,
          clientId?: string | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null,
        processId: string,
        clientId: string,
        messages?:  Array< {
          __typename: "MessageSubprocess",
          description?: string | null,
          rol?: string | null,
          visibleAction?: boolean | null,
        } | null > | null,
        notifications?:  Array< {
          __typename: "NotificationSubprocesses",
          group?: string | null,
          enabledEmail?: boolean | null,
          enabledPopUp?: boolean | null,
        } | null > | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    clientId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteOrderProcessMutationVariables = {
  input: DeleteOrderProcessInput,
  condition?: ModelOrderProcessConditionInput | null,
};

export type DeleteOrderProcessMutation = {
  deleteOrderProcess?:  {
    __typename: "OrderProcess",
    id: string,
    type?: string | null,
    status?: boolean | null,
    tcdPayment?: boolean | null,
    name: string,
    duration?: string | null,
    descripcion?: string | null,
    position: number,
    responsible?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    cards?:  Array< {
      __typename: "OrderCards",
      id?: string | null,
      name?: string | null,
      permissions?:  Array< {
        __typename: "OrderCardPermissions",
        idCard: string,
        rol: string,
        thirdContent?: boolean | null,
        visible?: boolean | null,
      } | null > | null,
    } | null > | null,
    subprocesses?:  {
      __typename: "ModelOrderSubprocessConnection",
      items:  Array< {
        __typename: "OrderSubprocess",
        id: string,
        type?: string | null,
        status?: boolean | null,
        name: string,
        position: number,
        descripcion: string,
        action: number,
        process?:  {
          __typename: "OrderProcess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          tcdPayment?: boolean | null,
          name: string,
          duration?: string | null,
          descripcion?: string | null,
          position: number,
          responsible?: number | null,
          clientId?: string | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null,
        processId: string,
        clientId: string,
        messages?:  Array< {
          __typename: "MessageSubprocess",
          description?: string | null,
          rol?: string | null,
          visibleAction?: boolean | null,
        } | null > | null,
        notifications?:  Array< {
          __typename: "NotificationSubprocesses",
          group?: string | null,
          enabledEmail?: boolean | null,
          enabledPopUp?: boolean | null,
        } | null > | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    clientId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateOrderSubprocessMutationVariables = {
  input: CreateOrderSubprocessInput,
  condition?: ModelOrderSubprocessConditionInput | null,
};

export type CreateOrderSubprocessMutation = {
  createOrderSubprocess?:  {
    __typename: "OrderSubprocess",
    id: string,
    type?: string | null,
    status?: boolean | null,
    name: string,
    position: number,
    descripcion: string,
    action: number,
    process?:  {
      __typename: "OrderProcess",
      id: string,
      type?: string | null,
      status?: boolean | null,
      tcdPayment?: boolean | null,
      name: string,
      duration?: string | null,
      descripcion?: string | null,
      position: number,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  {
        __typename: "ModelOrderSubprocessConnection",
        items:  Array< {
          __typename: "OrderSubprocess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          name: string,
          position: number,
          descripcion: string,
          action: number,
          processId: string,
          clientId: string,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      clientId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null,
    processId: string,
    clientId: string,
    messages?:  Array< {
      __typename: "MessageSubprocess",
      description?: string | null,
      rol?: string | null,
      visibleAction?: boolean | null,
    } | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateOrderSubprocessMutationVariables = {
  input: UpdateOrderSubprocessInput,
  condition?: ModelOrderSubprocessConditionInput | null,
};

export type UpdateOrderSubprocessMutation = {
  updateOrderSubprocess?:  {
    __typename: "OrderSubprocess",
    id: string,
    type?: string | null,
    status?: boolean | null,
    name: string,
    position: number,
    descripcion: string,
    action: number,
    process?:  {
      __typename: "OrderProcess",
      id: string,
      type?: string | null,
      status?: boolean | null,
      tcdPayment?: boolean | null,
      name: string,
      duration?: string | null,
      descripcion?: string | null,
      position: number,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  {
        __typename: "ModelOrderSubprocessConnection",
        items:  Array< {
          __typename: "OrderSubprocess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          name: string,
          position: number,
          descripcion: string,
          action: number,
          processId: string,
          clientId: string,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      clientId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null,
    processId: string,
    clientId: string,
    messages?:  Array< {
      __typename: "MessageSubprocess",
      description?: string | null,
      rol?: string | null,
      visibleAction?: boolean | null,
    } | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteOrderSubprocessMutationVariables = {
  input: DeleteOrderSubprocessInput,
  condition?: ModelOrderSubprocessConditionInput | null,
};

export type DeleteOrderSubprocessMutation = {
  deleteOrderSubprocess?:  {
    __typename: "OrderSubprocess",
    id: string,
    type?: string | null,
    status?: boolean | null,
    name: string,
    position: number,
    descripcion: string,
    action: number,
    process?:  {
      __typename: "OrderProcess",
      id: string,
      type?: string | null,
      status?: boolean | null,
      tcdPayment?: boolean | null,
      name: string,
      duration?: string | null,
      descripcion?: string | null,
      position: number,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  {
        __typename: "ModelOrderSubprocessConnection",
        items:  Array< {
          __typename: "OrderSubprocess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          name: string,
          position: number,
          descripcion: string,
          action: number,
          processId: string,
          clientId: string,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      clientId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null,
    processId: string,
    clientId: string,
    messages?:  Array< {
      __typename: "MessageSubprocess",
      description?: string | null,
      rol?: string | null,
      visibleAction?: boolean | null,
    } | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreatePremiumOrderMutationVariables = {
  input: CreatePremiumOrderInput,
  condition?: ModelPremiumOrderConditionInput | null,
};

export type CreatePremiumOrderMutation = {
  createPremiumOrder?:  {
    __typename: "PremiumOrder",
    id: string,
    requirement?: string | null,
    bank_reference?: string | null,
    hasVat?: boolean | null,
    billingData?:  {
      __typename: "BillingData",
      name?: string | null,
      rfc?: string | null,
      regimen?: string | null,
      cfdi_use?: string | null,
      cp?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
    } | null,
    orderId: number,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    logs?:  Array< {
      __typename: "Log",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      role?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_fee?: number | null,
    delivery_discount?: number | null,
    delivery_time?: number | null,
    delivery_date?: string | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    taxSituationFile?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clipUrl?: string | null,
    clipStatus?: string | null,
    listProviders?:  Array< {
      __typename: "ListProvidersOrder",
      provider_id: string,
      order_id: string,
      payment_date?: number | null,
      gr_code?: string | null,
      order_confirmation?: boolean | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      delivered?: boolean | null,
      deliveredFormat?: boolean | null,
    } | null > | null,
    providers?:  {
      __typename: "ModelOrderProvidersConnection",
      items:  Array< {
        __typename: "OrderProviders",
        id: string,
        provider_id: string,
        clientId?: string | null,
        orderId?: number | null,
        orderProvidersPremiumOrderId: string,
        payment_date?: number | null,
        gr_code?: string | null,
        invoice?: boolean | null,
        invoiceRequested?: boolean | null,
        uploadedGr?: boolean | null,
        uploadedBill?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    listsProducts:  Array< {
      __typename: "ProductInOrder",
      product_id: string,
      provider_id?: string | null,
      index?: number | null,
      print?: number | null,
      printPrice?: number | null,
      product_name: string,
      description?: string | null,
      category?: string | null,
      unspsc?: string | null,
      price?: number | null,
      originalPrice?: number | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      sample_authorize?: boolean | null,
      sample_authorized?: boolean | null,
      quality_requested?: boolean | null,
      quality_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      isExternal?: boolean | null,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      sku?: string | null,
      qualityForm?:  {
        __typename: "ProductInOrderQualityPGForm",
        initiativeDescription?: string | null,
        targetUser?: string | null,
        retailBrandName?: string | null,
        itemCategory?: string | null,
        itemPicture?: string | null,
        originCountry?: string | null,
        quantityPerCountryOfDist?: string | null,
        initiativeDates?: string | null,
        isPartOfAnMSOCustOrSpecPack?: string | null,
        incluesClientLogo?: string | null,
        isAReorderWithinTwelveMonths?: string | null,
        isReorder?: string | null,
        PGPLContactName?: string | null,
        ulTracking?: string | null,
        PLContactName?: string | null,
        contactEmailAddress?: string | null,
        PGPurchaseOrderNumber?: string | null,
        EBBSorSupplierProvidedProjectNumber?: string | null,
        vendorCompanyName?: string | null,
        vendorContactName?: string | null,
        vendorEmailAddress?: string | null,
        vendorJobTitle?: string | null,
        vendorTelephone?: string | null,
        vendorMailingAddress?: string | null,
        vendorCity?: string | null,
        vendorState?: string | null,
        vendorCountry?: string | null,
        vendorPC?: string | null,
        physicalItemDescription?: string | null,
        SampleOrMaterialComponentSubmitted?: string | null,
        toWhom?: string | null,
        descriptionOfItemPackagingAndArtwork?: string | null,
        regulatoryAndLegislativeProductCertification?: string | null,
        dateFinalApprovalRequestedSubmittedToPG?: string | null,
        DateOfDeclarationOfConformity?: string | null,
        dateOfApprovalExpirationOfPremiumItem?: string | null,
        itemClasification?: string | null,
        PGRepresentativeMarketingDesign?: string | null,
        PGProjectLeaderRequestor?: string | null,
        PGRestrictedItemsLocalPGLegal?: string | null,
        PGLocalCategoryGM?: string | null,
        PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
        idProduct?: string | null,
        pathDocument?: string | null,
      } | null,
      fee?: number | null,
      increment?: number | null,
      discount?: number | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
    } >,
    cotizationsList:  Array< {
      __typename: "PremiumOrderCotizationsLog",
      id: number,
      created: number,
      createdBy: string,
      products:  Array< {
        __typename: "ProductInOrder",
        product_id: string,
        provider_id?: string | null,
        index?: number | null,
        print?: number | null,
        printPrice?: number | null,
        product_name: string,
        description?: string | null,
        category?: string | null,
        unspsc?: string | null,
        price?: number | null,
        originalPrice?: number | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        sample_authorize?: boolean | null,
        sample_authorized?: boolean | null,
        quality_requested?: boolean | null,
        quality_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        isExternal?: boolean | null,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        sku?: string | null,
        qualityForm?:  {
          __typename: "ProductInOrderQualityPGForm",
          initiativeDescription?: string | null,
          targetUser?: string | null,
          retailBrandName?: string | null,
          itemCategory?: string | null,
          itemPicture?: string | null,
          originCountry?: string | null,
          quantityPerCountryOfDist?: string | null,
          initiativeDates?: string | null,
          isPartOfAnMSOCustOrSpecPack?: string | null,
          incluesClientLogo?: string | null,
          isAReorderWithinTwelveMonths?: string | null,
          isReorder?: string | null,
          PGPLContactName?: string | null,
          ulTracking?: string | null,
          PLContactName?: string | null,
          contactEmailAddress?: string | null,
          PGPurchaseOrderNumber?: string | null,
          EBBSorSupplierProvidedProjectNumber?: string | null,
          vendorCompanyName?: string | null,
          vendorContactName?: string | null,
          vendorEmailAddress?: string | null,
          vendorJobTitle?: string | null,
          vendorTelephone?: string | null,
          vendorMailingAddress?: string | null,
          vendorCity?: string | null,
          vendorState?: string | null,
          vendorCountry?: string | null,
          vendorPC?: string | null,
          physicalItemDescription?: string | null,
          SampleOrMaterialComponentSubmitted?: string | null,
          toWhom?: string | null,
          descriptionOfItemPackagingAndArtwork?: string | null,
          regulatoryAndLegislativeProductCertification?: string | null,
          dateFinalApprovalRequestedSubmittedToPG?: string | null,
          DateOfDeclarationOfConformity?: string | null,
          dateOfApprovalExpirationOfPremiumItem?: string | null,
          itemClasification?: string | null,
          PGRepresentativeMarketingDesign?: string | null,
          PGProjectLeaderRequestor?: string | null,
          PGRestrictedItemsLocalPGLegal?: string | null,
          PGLocalCategoryGM?: string | null,
          PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
          idProduct?: string | null,
          pathDocument?: string | null,
        } | null,
        fee?: number | null,
        increment?: number | null,
        discount?: number | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        sellMode?: ProductMaskSellMode | null,
        kitPieces?: number | null,
      } >,
    } | null >,
    orderCreatorId: string,
    creator:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    },
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    invoiceContact?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    premiumOrderClientId?: string | null,
    client?:  {
      __typename: "Client",
      id: string,
      status?: boolean | null,
      business_name: string,
      comertial_name: string,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      biography?: string | null,
      plan?: string | null,
      fee?: number | null,
      increment?: number | null,
      mercadoFee?: number | null,
      mercadoIncrement?: number | null,
      popFee?: number | null,
      popIncrement?: number | null,
      printedFee?: number | null,
      printedIncrement?: number | null,
      users?: Array< string | null > | null,
      restrictedUsers?: Array< string | null > | null,
      nonRestrictedUsers?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      popProviders?: Array< string | null > | null,
      printedProviders?: Array< string | null > | null,
      logisticFrequency?: number | null,
      agents?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      administrators?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      signDocument?:  Array< {
        __typename: "Sign",
        url?: string | null,
        enabled?: boolean | null,
      } | null > | null,
      legal_representative?: string | null,
      legal_representative_email?: string | null,
      legal_representative_address?: string | null,
      tcdUsers?: Array< string | null > | null,
      billingUsers?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt?: string | null,
    } | null,
    userBrandId?: string | null,
    userBrand?:  {
      __typename: "UsersBrands",
      id: string,
      name: string,
      description?: string | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      status?: string | null,
      clientId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subtotal?: number | null,
    fee?: number | null,
    printedPrice?: number | null,
    total?: number | null,
    discountAmount?: number | null,
    syncWithCrm?: boolean | null,
    crmIssueKey?: string | null,
    sentToAlendum?: boolean | null,
    alendumProjectId?: string | null,
    syncWithFms?: string | null,
    fmsInvoiceId?: string | null,
    syncWithWms?: boolean | null,
    wmsProjectId?: string | null,
    isCoupa?: boolean | null,
    sentToCoupa?: boolean | null,
    isRfq?: boolean | null,
    requireSamples?: boolean | null,
    requestedSamples?: boolean | null,
    approvedSamples?: boolean | null,
    authorizedQA?: boolean | null,
    active?: string | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    processes?:  Array< {
      __typename: "OrderProcessStructure",
      id?: string | null,
      name?: string | null,
      descripcion?: string | null,
      duration?: string | null,
      position?: number | null,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      madeBy?: string | null,
      madeAt?: number | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  Array< {
        __typename: "OrderSubprocessStructure",
        id?: string | null,
        name?: string | null,
        position?: number | null,
        descripcion?: string | null,
        action?: number | null,
        process?: string | null,
        madeBy?: string | null,
        madeAt?: number | null,
        messages?:  Array< {
          __typename: "MessageSubprocess",
          description?: string | null,
          rol?: string | null,
          visibleAction?: boolean | null,
        } | null > | null,
        notifications?:  Array< {
          __typename: "NotificationSubprocesses",
          group?: string | null,
          enabledEmail?: boolean | null,
          enabledPopUp?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    updatedAt?: string | null,
    created: number,
    updated?: number | null,
    logistic?:  Array< {
      __typename: "LogisticPremiumOrder",
      premiumOrderId?: string | null,
      tracking_number?: string | null,
      destiny_latitude?: string | null,
      destiny_longitude?: string | null,
      status?: string | null,
      status_activity?: string | null,
      status_description?: string | null,
      origin_latitude?: string | null,
      origin_longitude?: string | null,
      carrier?: string | null,
      clave_sat?: string | null,
      customer_delivery_start_date?: string | null,
      customer_email?: string | null,
      customer_external_number?: string | null,
      customer_first_name?: string | null,
      customer_last_name?: string | null,
      customer_mobile_number?: string | null,
      customer_postcode?: string | null,
      customer_settlement?: string | null,
      customer_street?: string | null,
      descripcion_sat?: string | null,
      peligroso?: string | null,
      primary_client?: string | null,
      purchase_order_number?: string | null,
      shipping_method?: string | null,
      shipping_option?: string | null,
      created: number,
    } | null > | null,
    createdAt: string,
  } | null,
};

export type UpdatePremiumOrderMutationVariables = {
  input: UpdatePremiumOrderInput,
  condition?: ModelPremiumOrderConditionInput | null,
};

export type UpdatePremiumOrderMutation = {
  updatePremiumOrder?:  {
    __typename: "PremiumOrder",
    id: string,
    requirement?: string | null,
    bank_reference?: string | null,
    hasVat?: boolean | null,
    billingData?:  {
      __typename: "BillingData",
      name?: string | null,
      rfc?: string | null,
      regimen?: string | null,
      cfdi_use?: string | null,
      cp?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
    } | null,
    orderId: number,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    logs?:  Array< {
      __typename: "Log",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      role?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_fee?: number | null,
    delivery_discount?: number | null,
    delivery_time?: number | null,
    delivery_date?: string | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    taxSituationFile?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clipUrl?: string | null,
    clipStatus?: string | null,
    listProviders?:  Array< {
      __typename: "ListProvidersOrder",
      provider_id: string,
      order_id: string,
      payment_date?: number | null,
      gr_code?: string | null,
      order_confirmation?: boolean | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      delivered?: boolean | null,
      deliveredFormat?: boolean | null,
    } | null > | null,
    providers?:  {
      __typename: "ModelOrderProvidersConnection",
      items:  Array< {
        __typename: "OrderProviders",
        id: string,
        provider_id: string,
        clientId?: string | null,
        orderId?: number | null,
        orderProvidersPremiumOrderId: string,
        payment_date?: number | null,
        gr_code?: string | null,
        invoice?: boolean | null,
        invoiceRequested?: boolean | null,
        uploadedGr?: boolean | null,
        uploadedBill?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    listsProducts:  Array< {
      __typename: "ProductInOrder",
      product_id: string,
      provider_id?: string | null,
      index?: number | null,
      print?: number | null,
      printPrice?: number | null,
      product_name: string,
      description?: string | null,
      category?: string | null,
      unspsc?: string | null,
      price?: number | null,
      originalPrice?: number | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      sample_authorize?: boolean | null,
      sample_authorized?: boolean | null,
      quality_requested?: boolean | null,
      quality_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      isExternal?: boolean | null,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      sku?: string | null,
      qualityForm?:  {
        __typename: "ProductInOrderQualityPGForm",
        initiativeDescription?: string | null,
        targetUser?: string | null,
        retailBrandName?: string | null,
        itemCategory?: string | null,
        itemPicture?: string | null,
        originCountry?: string | null,
        quantityPerCountryOfDist?: string | null,
        initiativeDates?: string | null,
        isPartOfAnMSOCustOrSpecPack?: string | null,
        incluesClientLogo?: string | null,
        isAReorderWithinTwelveMonths?: string | null,
        isReorder?: string | null,
        PGPLContactName?: string | null,
        ulTracking?: string | null,
        PLContactName?: string | null,
        contactEmailAddress?: string | null,
        PGPurchaseOrderNumber?: string | null,
        EBBSorSupplierProvidedProjectNumber?: string | null,
        vendorCompanyName?: string | null,
        vendorContactName?: string | null,
        vendorEmailAddress?: string | null,
        vendorJobTitle?: string | null,
        vendorTelephone?: string | null,
        vendorMailingAddress?: string | null,
        vendorCity?: string | null,
        vendorState?: string | null,
        vendorCountry?: string | null,
        vendorPC?: string | null,
        physicalItemDescription?: string | null,
        SampleOrMaterialComponentSubmitted?: string | null,
        toWhom?: string | null,
        descriptionOfItemPackagingAndArtwork?: string | null,
        regulatoryAndLegislativeProductCertification?: string | null,
        dateFinalApprovalRequestedSubmittedToPG?: string | null,
        DateOfDeclarationOfConformity?: string | null,
        dateOfApprovalExpirationOfPremiumItem?: string | null,
        itemClasification?: string | null,
        PGRepresentativeMarketingDesign?: string | null,
        PGProjectLeaderRequestor?: string | null,
        PGRestrictedItemsLocalPGLegal?: string | null,
        PGLocalCategoryGM?: string | null,
        PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
        idProduct?: string | null,
        pathDocument?: string | null,
      } | null,
      fee?: number | null,
      increment?: number | null,
      discount?: number | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
    } >,
    cotizationsList:  Array< {
      __typename: "PremiumOrderCotizationsLog",
      id: number,
      created: number,
      createdBy: string,
      products:  Array< {
        __typename: "ProductInOrder",
        product_id: string,
        provider_id?: string | null,
        index?: number | null,
        print?: number | null,
        printPrice?: number | null,
        product_name: string,
        description?: string | null,
        category?: string | null,
        unspsc?: string | null,
        price?: number | null,
        originalPrice?: number | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        sample_authorize?: boolean | null,
        sample_authorized?: boolean | null,
        quality_requested?: boolean | null,
        quality_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        isExternal?: boolean | null,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        sku?: string | null,
        qualityForm?:  {
          __typename: "ProductInOrderQualityPGForm",
          initiativeDescription?: string | null,
          targetUser?: string | null,
          retailBrandName?: string | null,
          itemCategory?: string | null,
          itemPicture?: string | null,
          originCountry?: string | null,
          quantityPerCountryOfDist?: string | null,
          initiativeDates?: string | null,
          isPartOfAnMSOCustOrSpecPack?: string | null,
          incluesClientLogo?: string | null,
          isAReorderWithinTwelveMonths?: string | null,
          isReorder?: string | null,
          PGPLContactName?: string | null,
          ulTracking?: string | null,
          PLContactName?: string | null,
          contactEmailAddress?: string | null,
          PGPurchaseOrderNumber?: string | null,
          EBBSorSupplierProvidedProjectNumber?: string | null,
          vendorCompanyName?: string | null,
          vendorContactName?: string | null,
          vendorEmailAddress?: string | null,
          vendorJobTitle?: string | null,
          vendorTelephone?: string | null,
          vendorMailingAddress?: string | null,
          vendorCity?: string | null,
          vendorState?: string | null,
          vendorCountry?: string | null,
          vendorPC?: string | null,
          physicalItemDescription?: string | null,
          SampleOrMaterialComponentSubmitted?: string | null,
          toWhom?: string | null,
          descriptionOfItemPackagingAndArtwork?: string | null,
          regulatoryAndLegislativeProductCertification?: string | null,
          dateFinalApprovalRequestedSubmittedToPG?: string | null,
          DateOfDeclarationOfConformity?: string | null,
          dateOfApprovalExpirationOfPremiumItem?: string | null,
          itemClasification?: string | null,
          PGRepresentativeMarketingDesign?: string | null,
          PGProjectLeaderRequestor?: string | null,
          PGRestrictedItemsLocalPGLegal?: string | null,
          PGLocalCategoryGM?: string | null,
          PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
          idProduct?: string | null,
          pathDocument?: string | null,
        } | null,
        fee?: number | null,
        increment?: number | null,
        discount?: number | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        sellMode?: ProductMaskSellMode | null,
        kitPieces?: number | null,
      } >,
    } | null >,
    orderCreatorId: string,
    creator:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    },
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    invoiceContact?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    premiumOrderClientId?: string | null,
    client?:  {
      __typename: "Client",
      id: string,
      status?: boolean | null,
      business_name: string,
      comertial_name: string,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      biography?: string | null,
      plan?: string | null,
      fee?: number | null,
      increment?: number | null,
      mercadoFee?: number | null,
      mercadoIncrement?: number | null,
      popFee?: number | null,
      popIncrement?: number | null,
      printedFee?: number | null,
      printedIncrement?: number | null,
      users?: Array< string | null > | null,
      restrictedUsers?: Array< string | null > | null,
      nonRestrictedUsers?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      popProviders?: Array< string | null > | null,
      printedProviders?: Array< string | null > | null,
      logisticFrequency?: number | null,
      agents?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      administrators?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      signDocument?:  Array< {
        __typename: "Sign",
        url?: string | null,
        enabled?: boolean | null,
      } | null > | null,
      legal_representative?: string | null,
      legal_representative_email?: string | null,
      legal_representative_address?: string | null,
      tcdUsers?: Array< string | null > | null,
      billingUsers?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt?: string | null,
    } | null,
    userBrandId?: string | null,
    userBrand?:  {
      __typename: "UsersBrands",
      id: string,
      name: string,
      description?: string | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      status?: string | null,
      clientId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subtotal?: number | null,
    fee?: number | null,
    printedPrice?: number | null,
    total?: number | null,
    discountAmount?: number | null,
    syncWithCrm?: boolean | null,
    crmIssueKey?: string | null,
    sentToAlendum?: boolean | null,
    alendumProjectId?: string | null,
    syncWithFms?: string | null,
    fmsInvoiceId?: string | null,
    syncWithWms?: boolean | null,
    wmsProjectId?: string | null,
    isCoupa?: boolean | null,
    sentToCoupa?: boolean | null,
    isRfq?: boolean | null,
    requireSamples?: boolean | null,
    requestedSamples?: boolean | null,
    approvedSamples?: boolean | null,
    authorizedQA?: boolean | null,
    active?: string | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    processes?:  Array< {
      __typename: "OrderProcessStructure",
      id?: string | null,
      name?: string | null,
      descripcion?: string | null,
      duration?: string | null,
      position?: number | null,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      madeBy?: string | null,
      madeAt?: number | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  Array< {
        __typename: "OrderSubprocessStructure",
        id?: string | null,
        name?: string | null,
        position?: number | null,
        descripcion?: string | null,
        action?: number | null,
        process?: string | null,
        madeBy?: string | null,
        madeAt?: number | null,
        messages?:  Array< {
          __typename: "MessageSubprocess",
          description?: string | null,
          rol?: string | null,
          visibleAction?: boolean | null,
        } | null > | null,
        notifications?:  Array< {
          __typename: "NotificationSubprocesses",
          group?: string | null,
          enabledEmail?: boolean | null,
          enabledPopUp?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    updatedAt?: string | null,
    created: number,
    updated?: number | null,
    logistic?:  Array< {
      __typename: "LogisticPremiumOrder",
      premiumOrderId?: string | null,
      tracking_number?: string | null,
      destiny_latitude?: string | null,
      destiny_longitude?: string | null,
      status?: string | null,
      status_activity?: string | null,
      status_description?: string | null,
      origin_latitude?: string | null,
      origin_longitude?: string | null,
      carrier?: string | null,
      clave_sat?: string | null,
      customer_delivery_start_date?: string | null,
      customer_email?: string | null,
      customer_external_number?: string | null,
      customer_first_name?: string | null,
      customer_last_name?: string | null,
      customer_mobile_number?: string | null,
      customer_postcode?: string | null,
      customer_settlement?: string | null,
      customer_street?: string | null,
      descripcion_sat?: string | null,
      peligroso?: string | null,
      primary_client?: string | null,
      purchase_order_number?: string | null,
      shipping_method?: string | null,
      shipping_option?: string | null,
      created: number,
    } | null > | null,
    createdAt: string,
  } | null,
};

export type DeletePremiumOrderMutationVariables = {
  input: DeletePremiumOrderInput,
  condition?: ModelPremiumOrderConditionInput | null,
};

export type DeletePremiumOrderMutation = {
  deletePremiumOrder?:  {
    __typename: "PremiumOrder",
    id: string,
    requirement?: string | null,
    bank_reference?: string | null,
    hasVat?: boolean | null,
    billingData?:  {
      __typename: "BillingData",
      name?: string | null,
      rfc?: string | null,
      regimen?: string | null,
      cfdi_use?: string | null,
      cp?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
    } | null,
    orderId: number,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    logs?:  Array< {
      __typename: "Log",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      role?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_fee?: number | null,
    delivery_discount?: number | null,
    delivery_time?: number | null,
    delivery_date?: string | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    taxSituationFile?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clipUrl?: string | null,
    clipStatus?: string | null,
    listProviders?:  Array< {
      __typename: "ListProvidersOrder",
      provider_id: string,
      order_id: string,
      payment_date?: number | null,
      gr_code?: string | null,
      order_confirmation?: boolean | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      delivered?: boolean | null,
      deliveredFormat?: boolean | null,
    } | null > | null,
    providers?:  {
      __typename: "ModelOrderProvidersConnection",
      items:  Array< {
        __typename: "OrderProviders",
        id: string,
        provider_id: string,
        clientId?: string | null,
        orderId?: number | null,
        orderProvidersPremiumOrderId: string,
        payment_date?: number | null,
        gr_code?: string | null,
        invoice?: boolean | null,
        invoiceRequested?: boolean | null,
        uploadedGr?: boolean | null,
        uploadedBill?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    listsProducts:  Array< {
      __typename: "ProductInOrder",
      product_id: string,
      provider_id?: string | null,
      index?: number | null,
      print?: number | null,
      printPrice?: number | null,
      product_name: string,
      description?: string | null,
      category?: string | null,
      unspsc?: string | null,
      price?: number | null,
      originalPrice?: number | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      sample_authorize?: boolean | null,
      sample_authorized?: boolean | null,
      quality_requested?: boolean | null,
      quality_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      isExternal?: boolean | null,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      sku?: string | null,
      qualityForm?:  {
        __typename: "ProductInOrderQualityPGForm",
        initiativeDescription?: string | null,
        targetUser?: string | null,
        retailBrandName?: string | null,
        itemCategory?: string | null,
        itemPicture?: string | null,
        originCountry?: string | null,
        quantityPerCountryOfDist?: string | null,
        initiativeDates?: string | null,
        isPartOfAnMSOCustOrSpecPack?: string | null,
        incluesClientLogo?: string | null,
        isAReorderWithinTwelveMonths?: string | null,
        isReorder?: string | null,
        PGPLContactName?: string | null,
        ulTracking?: string | null,
        PLContactName?: string | null,
        contactEmailAddress?: string | null,
        PGPurchaseOrderNumber?: string | null,
        EBBSorSupplierProvidedProjectNumber?: string | null,
        vendorCompanyName?: string | null,
        vendorContactName?: string | null,
        vendorEmailAddress?: string | null,
        vendorJobTitle?: string | null,
        vendorTelephone?: string | null,
        vendorMailingAddress?: string | null,
        vendorCity?: string | null,
        vendorState?: string | null,
        vendorCountry?: string | null,
        vendorPC?: string | null,
        physicalItemDescription?: string | null,
        SampleOrMaterialComponentSubmitted?: string | null,
        toWhom?: string | null,
        descriptionOfItemPackagingAndArtwork?: string | null,
        regulatoryAndLegislativeProductCertification?: string | null,
        dateFinalApprovalRequestedSubmittedToPG?: string | null,
        DateOfDeclarationOfConformity?: string | null,
        dateOfApprovalExpirationOfPremiumItem?: string | null,
        itemClasification?: string | null,
        PGRepresentativeMarketingDesign?: string | null,
        PGProjectLeaderRequestor?: string | null,
        PGRestrictedItemsLocalPGLegal?: string | null,
        PGLocalCategoryGM?: string | null,
        PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
        idProduct?: string | null,
        pathDocument?: string | null,
      } | null,
      fee?: number | null,
      increment?: number | null,
      discount?: number | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
    } >,
    cotizationsList:  Array< {
      __typename: "PremiumOrderCotizationsLog",
      id: number,
      created: number,
      createdBy: string,
      products:  Array< {
        __typename: "ProductInOrder",
        product_id: string,
        provider_id?: string | null,
        index?: number | null,
        print?: number | null,
        printPrice?: number | null,
        product_name: string,
        description?: string | null,
        category?: string | null,
        unspsc?: string | null,
        price?: number | null,
        originalPrice?: number | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        sample_authorize?: boolean | null,
        sample_authorized?: boolean | null,
        quality_requested?: boolean | null,
        quality_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        isExternal?: boolean | null,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        sku?: string | null,
        qualityForm?:  {
          __typename: "ProductInOrderQualityPGForm",
          initiativeDescription?: string | null,
          targetUser?: string | null,
          retailBrandName?: string | null,
          itemCategory?: string | null,
          itemPicture?: string | null,
          originCountry?: string | null,
          quantityPerCountryOfDist?: string | null,
          initiativeDates?: string | null,
          isPartOfAnMSOCustOrSpecPack?: string | null,
          incluesClientLogo?: string | null,
          isAReorderWithinTwelveMonths?: string | null,
          isReorder?: string | null,
          PGPLContactName?: string | null,
          ulTracking?: string | null,
          PLContactName?: string | null,
          contactEmailAddress?: string | null,
          PGPurchaseOrderNumber?: string | null,
          EBBSorSupplierProvidedProjectNumber?: string | null,
          vendorCompanyName?: string | null,
          vendorContactName?: string | null,
          vendorEmailAddress?: string | null,
          vendorJobTitle?: string | null,
          vendorTelephone?: string | null,
          vendorMailingAddress?: string | null,
          vendorCity?: string | null,
          vendorState?: string | null,
          vendorCountry?: string | null,
          vendorPC?: string | null,
          physicalItemDescription?: string | null,
          SampleOrMaterialComponentSubmitted?: string | null,
          toWhom?: string | null,
          descriptionOfItemPackagingAndArtwork?: string | null,
          regulatoryAndLegislativeProductCertification?: string | null,
          dateFinalApprovalRequestedSubmittedToPG?: string | null,
          DateOfDeclarationOfConformity?: string | null,
          dateOfApprovalExpirationOfPremiumItem?: string | null,
          itemClasification?: string | null,
          PGRepresentativeMarketingDesign?: string | null,
          PGProjectLeaderRequestor?: string | null,
          PGRestrictedItemsLocalPGLegal?: string | null,
          PGLocalCategoryGM?: string | null,
          PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
          idProduct?: string | null,
          pathDocument?: string | null,
        } | null,
        fee?: number | null,
        increment?: number | null,
        discount?: number | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        sellMode?: ProductMaskSellMode | null,
        kitPieces?: number | null,
      } >,
    } | null >,
    orderCreatorId: string,
    creator:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    },
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    invoiceContact?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    premiumOrderClientId?: string | null,
    client?:  {
      __typename: "Client",
      id: string,
      status?: boolean | null,
      business_name: string,
      comertial_name: string,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      biography?: string | null,
      plan?: string | null,
      fee?: number | null,
      increment?: number | null,
      mercadoFee?: number | null,
      mercadoIncrement?: number | null,
      popFee?: number | null,
      popIncrement?: number | null,
      printedFee?: number | null,
      printedIncrement?: number | null,
      users?: Array< string | null > | null,
      restrictedUsers?: Array< string | null > | null,
      nonRestrictedUsers?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      popProviders?: Array< string | null > | null,
      printedProviders?: Array< string | null > | null,
      logisticFrequency?: number | null,
      agents?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      administrators?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      signDocument?:  Array< {
        __typename: "Sign",
        url?: string | null,
        enabled?: boolean | null,
      } | null > | null,
      legal_representative?: string | null,
      legal_representative_email?: string | null,
      legal_representative_address?: string | null,
      tcdUsers?: Array< string | null > | null,
      billingUsers?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt?: string | null,
    } | null,
    userBrandId?: string | null,
    userBrand?:  {
      __typename: "UsersBrands",
      id: string,
      name: string,
      description?: string | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      status?: string | null,
      clientId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subtotal?: number | null,
    fee?: number | null,
    printedPrice?: number | null,
    total?: number | null,
    discountAmount?: number | null,
    syncWithCrm?: boolean | null,
    crmIssueKey?: string | null,
    sentToAlendum?: boolean | null,
    alendumProjectId?: string | null,
    syncWithFms?: string | null,
    fmsInvoiceId?: string | null,
    syncWithWms?: boolean | null,
    wmsProjectId?: string | null,
    isCoupa?: boolean | null,
    sentToCoupa?: boolean | null,
    isRfq?: boolean | null,
    requireSamples?: boolean | null,
    requestedSamples?: boolean | null,
    approvedSamples?: boolean | null,
    authorizedQA?: boolean | null,
    active?: string | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    processes?:  Array< {
      __typename: "OrderProcessStructure",
      id?: string | null,
      name?: string | null,
      descripcion?: string | null,
      duration?: string | null,
      position?: number | null,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      madeBy?: string | null,
      madeAt?: number | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  Array< {
        __typename: "OrderSubprocessStructure",
        id?: string | null,
        name?: string | null,
        position?: number | null,
        descripcion?: string | null,
        action?: number | null,
        process?: string | null,
        madeBy?: string | null,
        madeAt?: number | null,
        messages?:  Array< {
          __typename: "MessageSubprocess",
          description?: string | null,
          rol?: string | null,
          visibleAction?: boolean | null,
        } | null > | null,
        notifications?:  Array< {
          __typename: "NotificationSubprocesses",
          group?: string | null,
          enabledEmail?: boolean | null,
          enabledPopUp?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    updatedAt?: string | null,
    created: number,
    updated?: number | null,
    logistic?:  Array< {
      __typename: "LogisticPremiumOrder",
      premiumOrderId?: string | null,
      tracking_number?: string | null,
      destiny_latitude?: string | null,
      destiny_longitude?: string | null,
      status?: string | null,
      status_activity?: string | null,
      status_description?: string | null,
      origin_latitude?: string | null,
      origin_longitude?: string | null,
      carrier?: string | null,
      clave_sat?: string | null,
      customer_delivery_start_date?: string | null,
      customer_email?: string | null,
      customer_external_number?: string | null,
      customer_first_name?: string | null,
      customer_last_name?: string | null,
      customer_mobile_number?: string | null,
      customer_postcode?: string | null,
      customer_settlement?: string | null,
      customer_street?: string | null,
      descripcion_sat?: string | null,
      peligroso?: string | null,
      primary_client?: string | null,
      purchase_order_number?: string | null,
      shipping_method?: string | null,
      shipping_option?: string | null,
      created: number,
    } | null > | null,
    createdAt: string,
  } | null,
};

export type CreatePrintedCartMutationVariables = {
  input: CreatePrintedCartInput,
  condition?: ModelPrintedCartConditionInput | null,
};

export type CreatePrintedCartMutation = {
  createPrintedCart?:  {
    __typename: "PrintedCart",
    id: string,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    files?:  Array< {
      __typename: "PrintedListFiles",
      created?: number | null,
      creator_id?: string | null,
      file?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      status?: string | null,
      name?: string | null,
      type?: string | null,
      tracking_code?: string | null,
      provider_id?: string | null,
      product_id?: string | null,
      description?: string | null,
    } | null > | null,
    printedProducts?:  Array< {
      __typename: "PrintedProductInOrder",
      product_id: string,
      provider_id?: string | null,
      visible?: boolean | null,
      product_name: string,
      price?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
    } | null > | null,
    creator: string,
    created?: number | null,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePrintedCartMutationVariables = {
  input: UpdatePrintedCartInput,
  condition?: ModelPrintedCartConditionInput | null,
};

export type UpdatePrintedCartMutation = {
  updatePrintedCart?:  {
    __typename: "PrintedCart",
    id: string,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    files?:  Array< {
      __typename: "PrintedListFiles",
      created?: number | null,
      creator_id?: string | null,
      file?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      status?: string | null,
      name?: string | null,
      type?: string | null,
      tracking_code?: string | null,
      provider_id?: string | null,
      product_id?: string | null,
      description?: string | null,
    } | null > | null,
    printedProducts?:  Array< {
      __typename: "PrintedProductInOrder",
      product_id: string,
      provider_id?: string | null,
      visible?: boolean | null,
      product_name: string,
      price?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
    } | null > | null,
    creator: string,
    created?: number | null,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePrintedCartMutationVariables = {
  input: DeletePrintedCartInput,
  condition?: ModelPrintedCartConditionInput | null,
};

export type DeletePrintedCartMutation = {
  deletePrintedCart?:  {
    __typename: "PrintedCart",
    id: string,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    files?:  Array< {
      __typename: "PrintedListFiles",
      created?: number | null,
      creator_id?: string | null,
      file?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      status?: string | null,
      name?: string | null,
      type?: string | null,
      tracking_code?: string | null,
      provider_id?: string | null,
      product_id?: string | null,
      description?: string | null,
    } | null > | null,
    printedProducts?:  Array< {
      __typename: "PrintedProductInOrder",
      product_id: string,
      provider_id?: string | null,
      visible?: boolean | null,
      product_name: string,
      price?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
    } | null > | null,
    creator: string,
    created?: number | null,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePrintedCategoryMutationVariables = {
  input: CreatePrintedCategoryInput,
  condition?: ModelPrintedCategoryConditionInput | null,
};

export type CreatePrintedCategoryMutation = {
  createPrintedCategory?:  {
    __typename: "PrintedCategory",
    id: string,
    name: string,
    image:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    },
    route: string,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    printedSubcategories?:  {
      __typename: "ModelPrintedSubcategoryConnection",
      items:  Array< {
        __typename: "PrintedSubcategory",
        id: string,
        name: string,
        printedCategoryId: string,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        parent:  {
          __typename: "PrintedCategory",
          id: string,
          name: string,
          route: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          region?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        },
        created: number,
        printedProducts?:  {
          __typename: "ModelPrintedProductsConnection",
          nextToken?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        region?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    printedProducts?:  {
      __typename: "ModelPrintedProductsConnection",
      items:  Array< {
        __typename: "PrintedProducts",
        id: string,
        status: string,
        position: string,
        name: string,
        width: number,
        height: number,
        images:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } >,
        price: number,
        long_description?: string | null,
        short_description?: string | null,
        creator?: string | null,
        providerId: string,
        finalDimensions?: number | null,
        pagesNumber?: number | null,
        finishes?: string | null,
        inksFourByCero?: string | null,
        inksFourByFour?: string | null,
        paperKind?: string | null,
        grammage?: string | null,
        hasBarniz?: boolean | null,
        hasRebase?: boolean | null,
        orientation?: string | null,
        specialInstructions?: string | null,
        PrintedSubcategoryId: string,
        printedCategoryId: string,
        created: number,
        variants?:  Array< {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null > | null,
        visibleFor?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    created: number,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePrintedCategoryMutationVariables = {
  input: UpdatePrintedCategoryInput,
  condition?: ModelPrintedCategoryConditionInput | null,
};

export type UpdatePrintedCategoryMutation = {
  updatePrintedCategory?:  {
    __typename: "PrintedCategory",
    id: string,
    name: string,
    image:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    },
    route: string,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    printedSubcategories?:  {
      __typename: "ModelPrintedSubcategoryConnection",
      items:  Array< {
        __typename: "PrintedSubcategory",
        id: string,
        name: string,
        printedCategoryId: string,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        parent:  {
          __typename: "PrintedCategory",
          id: string,
          name: string,
          route: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          region?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        },
        created: number,
        printedProducts?:  {
          __typename: "ModelPrintedProductsConnection",
          nextToken?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        region?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    printedProducts?:  {
      __typename: "ModelPrintedProductsConnection",
      items:  Array< {
        __typename: "PrintedProducts",
        id: string,
        status: string,
        position: string,
        name: string,
        width: number,
        height: number,
        images:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } >,
        price: number,
        long_description?: string | null,
        short_description?: string | null,
        creator?: string | null,
        providerId: string,
        finalDimensions?: number | null,
        pagesNumber?: number | null,
        finishes?: string | null,
        inksFourByCero?: string | null,
        inksFourByFour?: string | null,
        paperKind?: string | null,
        grammage?: string | null,
        hasBarniz?: boolean | null,
        hasRebase?: boolean | null,
        orientation?: string | null,
        specialInstructions?: string | null,
        PrintedSubcategoryId: string,
        printedCategoryId: string,
        created: number,
        variants?:  Array< {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null > | null,
        visibleFor?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    created: number,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePrintedCategoryMutationVariables = {
  input: DeletePrintedCategoryInput,
  condition?: ModelPrintedCategoryConditionInput | null,
};

export type DeletePrintedCategoryMutation = {
  deletePrintedCategory?:  {
    __typename: "PrintedCategory",
    id: string,
    name: string,
    image:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    },
    route: string,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    printedSubcategories?:  {
      __typename: "ModelPrintedSubcategoryConnection",
      items:  Array< {
        __typename: "PrintedSubcategory",
        id: string,
        name: string,
        printedCategoryId: string,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        parent:  {
          __typename: "PrintedCategory",
          id: string,
          name: string,
          route: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          region?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        },
        created: number,
        printedProducts?:  {
          __typename: "ModelPrintedProductsConnection",
          nextToken?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        region?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    printedProducts?:  {
      __typename: "ModelPrintedProductsConnection",
      items:  Array< {
        __typename: "PrintedProducts",
        id: string,
        status: string,
        position: string,
        name: string,
        width: number,
        height: number,
        images:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } >,
        price: number,
        long_description?: string | null,
        short_description?: string | null,
        creator?: string | null,
        providerId: string,
        finalDimensions?: number | null,
        pagesNumber?: number | null,
        finishes?: string | null,
        inksFourByCero?: string | null,
        inksFourByFour?: string | null,
        paperKind?: string | null,
        grammage?: string | null,
        hasBarniz?: boolean | null,
        hasRebase?: boolean | null,
        orientation?: string | null,
        specialInstructions?: string | null,
        PrintedSubcategoryId: string,
        printedCategoryId: string,
        created: number,
        variants?:  Array< {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null > | null,
        visibleFor?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    created: number,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePrintedSubcategoryMutationVariables = {
  input: CreatePrintedSubcategoryInput,
  condition?: ModelPrintedSubcategoryConditionInput | null,
};

export type CreatePrintedSubcategoryMutation = {
  createPrintedSubcategory?:  {
    __typename: "PrintedSubcategory",
    id: string,
    name: string,
    printedCategoryId: string,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    parent:  {
      __typename: "PrintedCategory",
      id: string,
      name: string,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      route: string,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      printedSubcategories?:  {
        __typename: "ModelPrintedSubcategoryConnection",
        items:  Array< {
          __typename: "PrintedSubcategory",
          id: string,
          name: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          region?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      printedProducts?:  {
        __typename: "ModelPrintedProductsConnection",
        items:  Array< {
          __typename: "PrintedProducts",
          id: string,
          status: string,
          position: string,
          name: string,
          width: number,
          height: number,
          price: number,
          long_description?: string | null,
          short_description?: string | null,
          creator?: string | null,
          providerId: string,
          finalDimensions?: number | null,
          pagesNumber?: number | null,
          finishes?: string | null,
          inksFourByCero?: string | null,
          inksFourByFour?: string | null,
          paperKind?: string | null,
          grammage?: string | null,
          hasBarniz?: boolean | null,
          hasRebase?: boolean | null,
          orientation?: string | null,
          specialInstructions?: string | null,
          PrintedSubcategoryId: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          regions?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      created: number,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    },
    created: number,
    printedProducts?:  {
      __typename: "ModelPrintedProductsConnection",
      items:  Array< {
        __typename: "PrintedProducts",
        id: string,
        status: string,
        position: string,
        name: string,
        width: number,
        height: number,
        images:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } >,
        price: number,
        long_description?: string | null,
        short_description?: string | null,
        creator?: string | null,
        providerId: string,
        finalDimensions?: number | null,
        pagesNumber?: number | null,
        finishes?: string | null,
        inksFourByCero?: string | null,
        inksFourByFour?: string | null,
        paperKind?: string | null,
        grammage?: string | null,
        hasBarniz?: boolean | null,
        hasRebase?: boolean | null,
        orientation?: string | null,
        specialInstructions?: string | null,
        PrintedSubcategoryId: string,
        printedCategoryId: string,
        created: number,
        variants?:  Array< {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null > | null,
        visibleFor?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePrintedSubcategoryMutationVariables = {
  input: UpdatePrintedSubcategoryInput,
  condition?: ModelPrintedSubcategoryConditionInput | null,
};

export type UpdatePrintedSubcategoryMutation = {
  updatePrintedSubcategory?:  {
    __typename: "PrintedSubcategory",
    id: string,
    name: string,
    printedCategoryId: string,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    parent:  {
      __typename: "PrintedCategory",
      id: string,
      name: string,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      route: string,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      printedSubcategories?:  {
        __typename: "ModelPrintedSubcategoryConnection",
        items:  Array< {
          __typename: "PrintedSubcategory",
          id: string,
          name: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          region?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      printedProducts?:  {
        __typename: "ModelPrintedProductsConnection",
        items:  Array< {
          __typename: "PrintedProducts",
          id: string,
          status: string,
          position: string,
          name: string,
          width: number,
          height: number,
          price: number,
          long_description?: string | null,
          short_description?: string | null,
          creator?: string | null,
          providerId: string,
          finalDimensions?: number | null,
          pagesNumber?: number | null,
          finishes?: string | null,
          inksFourByCero?: string | null,
          inksFourByFour?: string | null,
          paperKind?: string | null,
          grammage?: string | null,
          hasBarniz?: boolean | null,
          hasRebase?: boolean | null,
          orientation?: string | null,
          specialInstructions?: string | null,
          PrintedSubcategoryId: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          regions?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      created: number,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    },
    created: number,
    printedProducts?:  {
      __typename: "ModelPrintedProductsConnection",
      items:  Array< {
        __typename: "PrintedProducts",
        id: string,
        status: string,
        position: string,
        name: string,
        width: number,
        height: number,
        images:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } >,
        price: number,
        long_description?: string | null,
        short_description?: string | null,
        creator?: string | null,
        providerId: string,
        finalDimensions?: number | null,
        pagesNumber?: number | null,
        finishes?: string | null,
        inksFourByCero?: string | null,
        inksFourByFour?: string | null,
        paperKind?: string | null,
        grammage?: string | null,
        hasBarniz?: boolean | null,
        hasRebase?: boolean | null,
        orientation?: string | null,
        specialInstructions?: string | null,
        PrintedSubcategoryId: string,
        printedCategoryId: string,
        created: number,
        variants?:  Array< {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null > | null,
        visibleFor?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePrintedSubcategoryMutationVariables = {
  input: DeletePrintedSubcategoryInput,
  condition?: ModelPrintedSubcategoryConditionInput | null,
};

export type DeletePrintedSubcategoryMutation = {
  deletePrintedSubcategory?:  {
    __typename: "PrintedSubcategory",
    id: string,
    name: string,
    printedCategoryId: string,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    parent:  {
      __typename: "PrintedCategory",
      id: string,
      name: string,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      route: string,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      printedSubcategories?:  {
        __typename: "ModelPrintedSubcategoryConnection",
        items:  Array< {
          __typename: "PrintedSubcategory",
          id: string,
          name: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          region?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      printedProducts?:  {
        __typename: "ModelPrintedProductsConnection",
        items:  Array< {
          __typename: "PrintedProducts",
          id: string,
          status: string,
          position: string,
          name: string,
          width: number,
          height: number,
          price: number,
          long_description?: string | null,
          short_description?: string | null,
          creator?: string | null,
          providerId: string,
          finalDimensions?: number | null,
          pagesNumber?: number | null,
          finishes?: string | null,
          inksFourByCero?: string | null,
          inksFourByFour?: string | null,
          paperKind?: string | null,
          grammage?: string | null,
          hasBarniz?: boolean | null,
          hasRebase?: boolean | null,
          orientation?: string | null,
          specialInstructions?: string | null,
          PrintedSubcategoryId: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          regions?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      created: number,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    },
    created: number,
    printedProducts?:  {
      __typename: "ModelPrintedProductsConnection",
      items:  Array< {
        __typename: "PrintedProducts",
        id: string,
        status: string,
        position: string,
        name: string,
        width: number,
        height: number,
        images:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } >,
        price: number,
        long_description?: string | null,
        short_description?: string | null,
        creator?: string | null,
        providerId: string,
        finalDimensions?: number | null,
        pagesNumber?: number | null,
        finishes?: string | null,
        inksFourByCero?: string | null,
        inksFourByFour?: string | null,
        paperKind?: string | null,
        grammage?: string | null,
        hasBarniz?: boolean | null,
        hasRebase?: boolean | null,
        orientation?: string | null,
        specialInstructions?: string | null,
        PrintedSubcategoryId: string,
        printedCategoryId: string,
        created: number,
        variants?:  Array< {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null > | null,
        visibleFor?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePrintedProductsMutationVariables = {
  input: CreatePrintedProductsInput,
  condition?: ModelPrintedProductsConditionInput | null,
};

export type CreatePrintedProductsMutation = {
  createPrintedProducts?:  {
    __typename: "PrintedProducts",
    id: string,
    status: string,
    position: string,
    name: string,
    width: number,
    height: number,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    price: number,
    long_description?: string | null,
    short_description?: string | null,
    creator?: string | null,
    providerId: string,
    finalDimensions?: number | null,
    pagesNumber?: number | null,
    finishes?: string | null,
    inksFourByCero?: string | null,
    inksFourByFour?: string | null,
    paperKind?: string | null,
    grammage?: string | null,
    hasBarniz?: boolean | null,
    hasRebase?: boolean | null,
    orientation?: string | null,
    specialInstructions?: string | null,
    PrintedSubcategoryId: string,
    printedCategoryId: string,
    created: number,
    variants?:  Array< {
      __typename: "Variants",
      sku?: string | null,
      name?: string | null,
      description?: string | null,
      colors?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock_available?: number | null,
      price?: number | null,
      size?: string | null,
      logoType?: string | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePrintedProductsMutationVariables = {
  input: UpdatePrintedProductsInput,
  condition?: ModelPrintedProductsConditionInput | null,
};

export type UpdatePrintedProductsMutation = {
  updatePrintedProducts?:  {
    __typename: "PrintedProducts",
    id: string,
    status: string,
    position: string,
    name: string,
    width: number,
    height: number,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    price: number,
    long_description?: string | null,
    short_description?: string | null,
    creator?: string | null,
    providerId: string,
    finalDimensions?: number | null,
    pagesNumber?: number | null,
    finishes?: string | null,
    inksFourByCero?: string | null,
    inksFourByFour?: string | null,
    paperKind?: string | null,
    grammage?: string | null,
    hasBarniz?: boolean | null,
    hasRebase?: boolean | null,
    orientation?: string | null,
    specialInstructions?: string | null,
    PrintedSubcategoryId: string,
    printedCategoryId: string,
    created: number,
    variants?:  Array< {
      __typename: "Variants",
      sku?: string | null,
      name?: string | null,
      description?: string | null,
      colors?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock_available?: number | null,
      price?: number | null,
      size?: string | null,
      logoType?: string | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePrintedProductsMutationVariables = {
  input: DeletePrintedProductsInput,
  condition?: ModelPrintedProductsConditionInput | null,
};

export type DeletePrintedProductsMutation = {
  deletePrintedProducts?:  {
    __typename: "PrintedProducts",
    id: string,
    status: string,
    position: string,
    name: string,
    width: number,
    height: number,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    price: number,
    long_description?: string | null,
    short_description?: string | null,
    creator?: string | null,
    providerId: string,
    finalDimensions?: number | null,
    pagesNumber?: number | null,
    finishes?: string | null,
    inksFourByCero?: string | null,
    inksFourByFour?: string | null,
    paperKind?: string | null,
    grammage?: string | null,
    hasBarniz?: boolean | null,
    hasRebase?: boolean | null,
    orientation?: string | null,
    specialInstructions?: string | null,
    PrintedSubcategoryId: string,
    printedCategoryId: string,
    created: number,
    variants?:  Array< {
      __typename: "Variants",
      sku?: string | null,
      name?: string | null,
      description?: string | null,
      colors?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock_available?: number | null,
      price?: number | null,
      size?: string | null,
      logoType?: string | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePrintedRfqMutationVariables = {
  input: CreatePrintedRfqInput,
  condition?: ModelPrintedRfqConditionInput | null,
};

export type CreatePrintedRfqMutation = {
  createPrintedRfq?:  {
    __typename: "PrintedRfq",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    limit_time: number,
    proposals?:  {
      __typename: "ModelPrintedProposalConnection",
      items:  Array< {
        __typename: "PrintedProposal",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        products?:  Array< {
          __typename: "PrintedProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name: string,
          description: string,
          priceUnit: number,
          pieces: number,
          total: number,
          idProducto: number,
        } | null > | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "PrintedRfq",
          id: string,
          nombre: string,
          requerimiento: string,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          estatus: string,
          printedOrderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
        } | null,
        printedProposalRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    estatus: string,
    printedOrderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    providers?:  Array< {
      __typename: "RfqPrintedProviders",
      idProvider?: string | null,
    } | null > | null,
    printedProductsRfq:  Array< {
      __typename: "PrintedProductUnitRfq",
      name: string,
      description: string,
      pieces: number,
      createdId: number,
    } | null >,
  } | null,
};

export type UpdatePrintedRfqMutationVariables = {
  input: UpdatePrintedRfqInput,
  condition?: ModelPrintedRfqConditionInput | null,
};

export type UpdatePrintedRfqMutation = {
  updatePrintedRfq?:  {
    __typename: "PrintedRfq",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    limit_time: number,
    proposals?:  {
      __typename: "ModelPrintedProposalConnection",
      items:  Array< {
        __typename: "PrintedProposal",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        products?:  Array< {
          __typename: "PrintedProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name: string,
          description: string,
          priceUnit: number,
          pieces: number,
          total: number,
          idProducto: number,
        } | null > | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "PrintedRfq",
          id: string,
          nombre: string,
          requerimiento: string,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          estatus: string,
          printedOrderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
        } | null,
        printedProposalRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    estatus: string,
    printedOrderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    providers?:  Array< {
      __typename: "RfqPrintedProviders",
      idProvider?: string | null,
    } | null > | null,
    printedProductsRfq:  Array< {
      __typename: "PrintedProductUnitRfq",
      name: string,
      description: string,
      pieces: number,
      createdId: number,
    } | null >,
  } | null,
};

export type DeletePrintedRfqMutationVariables = {
  input: DeletePrintedRfqInput,
  condition?: ModelPrintedRfqConditionInput | null,
};

export type DeletePrintedRfqMutation = {
  deletePrintedRfq?:  {
    __typename: "PrintedRfq",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    limit_time: number,
    proposals?:  {
      __typename: "ModelPrintedProposalConnection",
      items:  Array< {
        __typename: "PrintedProposal",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        products?:  Array< {
          __typename: "PrintedProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name: string,
          description: string,
          priceUnit: number,
          pieces: number,
          total: number,
          idProducto: number,
        } | null > | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "PrintedRfq",
          id: string,
          nombre: string,
          requerimiento: string,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          estatus: string,
          printedOrderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
        } | null,
        printedProposalRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    estatus: string,
    printedOrderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    providers?:  Array< {
      __typename: "RfqPrintedProviders",
      idProvider?: string | null,
    } | null > | null,
    printedProductsRfq:  Array< {
      __typename: "PrintedProductUnitRfq",
      name: string,
      description: string,
      pieces: number,
      createdId: number,
    } | null >,
  } | null,
};

export type CreatePrintedProductoRfqMutationVariables = {
  input: CreatePrintedProductoRfqInput,
  condition?: ModelPrintedProductoRfqConditionInput | null,
};

export type CreatePrintedProductoRfqMutation = {
  createPrintedProductoRfq?:  {
    __typename: "PrintedProductoRfq",
    id: string,
    name: string,
    description: string,
    category_id: string,
    provider_id: string,
    price?: number | null,
    category?: string | null,
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    estatus?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePrintedProductoRfqMutationVariables = {
  input: UpdatePrintedProductoRfqInput,
  condition?: ModelPrintedProductoRfqConditionInput | null,
};

export type UpdatePrintedProductoRfqMutation = {
  updatePrintedProductoRfq?:  {
    __typename: "PrintedProductoRfq",
    id: string,
    name: string,
    description: string,
    category_id: string,
    provider_id: string,
    price?: number | null,
    category?: string | null,
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    estatus?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePrintedProductoRfqMutationVariables = {
  input: DeletePrintedProductoRfqInput,
  condition?: ModelPrintedProductoRfqConditionInput | null,
};

export type DeletePrintedProductoRfqMutation = {
  deletePrintedProductoRfq?:  {
    __typename: "PrintedProductoRfq",
    id: string,
    name: string,
    description: string,
    category_id: string,
    provider_id: string,
    price?: number | null,
    category?: string | null,
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    estatus?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePrintedProposalMutationVariables = {
  input: CreatePrintedProposalInput,
  condition?: ModelPrintedProposalConditionInput | null,
};

export type CreatePrintedProposalMutation = {
  createPrintedProposal?:  {
    __typename: "PrintedProposal",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    products?:  Array< {
      __typename: "PrintedProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name: string,
      description: string,
      priceUnit: number,
      pieces: number,
      total: number,
      idProducto: number,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "PrintedRfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      proposals?:  {
        __typename: "ModelPrintedProposalConnection",
        items:  Array< {
          __typename: "PrintedProposal",
          id: string,
          provider_id: string,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          hidden?: boolean | null,
          printedProposalRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      printedOrderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      providers?:  Array< {
        __typename: "RfqPrintedProviders",
        idProvider?: string | null,
      } | null > | null,
      printedProductsRfq:  Array< {
        __typename: "PrintedProductUnitRfq",
        name: string,
        description: string,
        pieces: number,
        createdId: number,
      } | null >,
    } | null,
    printedProposalRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePrintedProposalMutationVariables = {
  input: UpdatePrintedProposalInput,
  condition?: ModelPrintedProposalConditionInput | null,
};

export type UpdatePrintedProposalMutation = {
  updatePrintedProposal?:  {
    __typename: "PrintedProposal",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    products?:  Array< {
      __typename: "PrintedProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name: string,
      description: string,
      priceUnit: number,
      pieces: number,
      total: number,
      idProducto: number,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "PrintedRfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      proposals?:  {
        __typename: "ModelPrintedProposalConnection",
        items:  Array< {
          __typename: "PrintedProposal",
          id: string,
          provider_id: string,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          hidden?: boolean | null,
          printedProposalRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      printedOrderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      providers?:  Array< {
        __typename: "RfqPrintedProviders",
        idProvider?: string | null,
      } | null > | null,
      printedProductsRfq:  Array< {
        __typename: "PrintedProductUnitRfq",
        name: string,
        description: string,
        pieces: number,
        createdId: number,
      } | null >,
    } | null,
    printedProposalRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePrintedProposalMutationVariables = {
  input: DeletePrintedProposalInput,
  condition?: ModelPrintedProposalConditionInput | null,
};

export type DeletePrintedProposalMutation = {
  deletePrintedProposal?:  {
    __typename: "PrintedProposal",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    products?:  Array< {
      __typename: "PrintedProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name: string,
      description: string,
      priceUnit: number,
      pieces: number,
      total: number,
      idProducto: number,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "PrintedRfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      proposals?:  {
        __typename: "ModelPrintedProposalConnection",
        items:  Array< {
          __typename: "PrintedProposal",
          id: string,
          provider_id: string,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          hidden?: boolean | null,
          printedProposalRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      printedOrderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      providers?:  Array< {
        __typename: "RfqPrintedProviders",
        idProvider?: string | null,
      } | null > | null,
      printedProductsRfq:  Array< {
        __typename: "PrintedProductUnitRfq",
        name: string,
        description: string,
        pieces: number,
        createdId: number,
      } | null >,
    } | null,
    printedProposalRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePrintedOrderMutationVariables = {
  input: CreatePrintedOrderInput,
  condition?: ModelPrintedOrderConditionInput | null,
};

export type CreatePrintedOrderMutation = {
  createPrintedOrder?:  {
    __typename: "PrintedOrder",
    id: string,
    orderId: number,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_time?: number | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    listProviders?:  Array< {
      __typename: "ListProvidersOrder",
      provider_id: string,
      order_id: string,
      payment_date?: number | null,
      gr_code?: string | null,
      order_confirmation?: boolean | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      delivered?: boolean | null,
      deliveredFormat?: boolean | null,
    } | null > | null,
    listProvidersKey?: Array< string | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    listPrintedProducts:  Array< {
      __typename: "PrintedProductInOrder",
      product_id: string,
      provider_id?: string | null,
      visible?: boolean | null,
      product_name: string,
      price?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
    } >,
    cotizationsList:  Array< {
      __typename: "PrintedOrderCotizationsLog",
      id: number,
      created: number,
      createdBy: string,
      products:  Array< {
        __typename: "PrintedProductInOrder",
        product_id: string,
        provider_id?: string | null,
        visible?: boolean | null,
        product_name: string,
        price?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
      } >,
    } | null >,
    orderCreatorId: string,
    creator:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    },
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    printedOrderClientId?: string | null,
    subtotal?: number | null,
    total?: number | null,
    isCoupa?: boolean | null,
    sentToCoupa?: boolean | null,
    isRfq?: boolean | null,
    status?: string | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    updatedAt?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
  } | null,
};

export type UpdatePrintedOrderMutationVariables = {
  input: UpdatePrintedOrderInput,
  condition?: ModelPrintedOrderConditionInput | null,
};

export type UpdatePrintedOrderMutation = {
  updatePrintedOrder?:  {
    __typename: "PrintedOrder",
    id: string,
    orderId: number,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_time?: number | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    listProviders?:  Array< {
      __typename: "ListProvidersOrder",
      provider_id: string,
      order_id: string,
      payment_date?: number | null,
      gr_code?: string | null,
      order_confirmation?: boolean | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      delivered?: boolean | null,
      deliveredFormat?: boolean | null,
    } | null > | null,
    listProvidersKey?: Array< string | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    listPrintedProducts:  Array< {
      __typename: "PrintedProductInOrder",
      product_id: string,
      provider_id?: string | null,
      visible?: boolean | null,
      product_name: string,
      price?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
    } >,
    cotizationsList:  Array< {
      __typename: "PrintedOrderCotizationsLog",
      id: number,
      created: number,
      createdBy: string,
      products:  Array< {
        __typename: "PrintedProductInOrder",
        product_id: string,
        provider_id?: string | null,
        visible?: boolean | null,
        product_name: string,
        price?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
      } >,
    } | null >,
    orderCreatorId: string,
    creator:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    },
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    printedOrderClientId?: string | null,
    subtotal?: number | null,
    total?: number | null,
    isCoupa?: boolean | null,
    sentToCoupa?: boolean | null,
    isRfq?: boolean | null,
    status?: string | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    updatedAt?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
  } | null,
};

export type DeletePrintedOrderMutationVariables = {
  input: DeletePrintedOrderInput,
  condition?: ModelPrintedOrderConditionInput | null,
};

export type DeletePrintedOrderMutation = {
  deletePrintedOrder?:  {
    __typename: "PrintedOrder",
    id: string,
    orderId: number,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_time?: number | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    listProviders?:  Array< {
      __typename: "ListProvidersOrder",
      provider_id: string,
      order_id: string,
      payment_date?: number | null,
      gr_code?: string | null,
      order_confirmation?: boolean | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      delivered?: boolean | null,
      deliveredFormat?: boolean | null,
    } | null > | null,
    listProvidersKey?: Array< string | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    listPrintedProducts:  Array< {
      __typename: "PrintedProductInOrder",
      product_id: string,
      provider_id?: string | null,
      visible?: boolean | null,
      product_name: string,
      price?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
    } >,
    cotizationsList:  Array< {
      __typename: "PrintedOrderCotizationsLog",
      id: number,
      created: number,
      createdBy: string,
      products:  Array< {
        __typename: "PrintedProductInOrder",
        product_id: string,
        provider_id?: string | null,
        visible?: boolean | null,
        product_name: string,
        price?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
      } >,
    } | null >,
    orderCreatorId: string,
    creator:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    },
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    printedOrderClientId?: string | null,
    subtotal?: number | null,
    total?: number | null,
    isCoupa?: boolean | null,
    sentToCoupa?: boolean | null,
    isRfq?: boolean | null,
    status?: string | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    updatedAt?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
  } | null,
};

export type CreatePrintedOrderProvidersMutationVariables = {
  input: CreatePrintedOrderProvidersInput,
  condition?: ModelPrintedOrderProvidersConditionInput | null,
};

export type CreatePrintedOrderProvidersMutation = {
  createPrintedOrderProviders?:  {
    __typename: "PrintedOrderProviders",
    id: string,
    provider_id: string,
    orderId?: number | null,
    printedOrderProvidersPrintedOrderId: string,
    payment_date?: number | null,
    gr_code?: string | null,
    invoice?: boolean | null,
    invoiceRequested?: boolean | null,
    uploadedGr?: boolean | null,
    uploadedBill?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePrintedOrderProvidersMutationVariables = {
  input: UpdatePrintedOrderProvidersInput,
  condition?: ModelPrintedOrderProvidersConditionInput | null,
};

export type UpdatePrintedOrderProvidersMutation = {
  updatePrintedOrderProviders?:  {
    __typename: "PrintedOrderProviders",
    id: string,
    provider_id: string,
    orderId?: number | null,
    printedOrderProvidersPrintedOrderId: string,
    payment_date?: number | null,
    gr_code?: string | null,
    invoice?: boolean | null,
    invoiceRequested?: boolean | null,
    uploadedGr?: boolean | null,
    uploadedBill?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePrintedOrderProvidersMutationVariables = {
  input: DeletePrintedOrderProvidersInput,
  condition?: ModelPrintedOrderProvidersConditionInput | null,
};

export type DeletePrintedOrderProvidersMutation = {
  deletePrintedOrderProviders?:  {
    __typename: "PrintedOrderProviders",
    id: string,
    provider_id: string,
    orderId?: number | null,
    printedOrderProvidersPrintedOrderId: string,
    payment_date?: number | null,
    gr_code?: string | null,
    invoice?: boolean | null,
    invoiceRequested?: boolean | null,
    uploadedGr?: boolean | null,
    uploadedBill?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePayOnBehalfRequestsMutationVariables = {
  input: CreatePayOnBehalfRequestsInput,
  condition?: ModelPayOnBehalfRequestsConditionInput | null,
};

export type CreatePayOnBehalfRequestsMutation = {
  createPayOnBehalfRequests?:  {
    __typename: "PayOnBehalfRequests",
    id: string,
    clientId?: string | null,
    companyName?: string | null,
    purchaseOrder?: string | null,
    paymentTerms?: string | null,
    currency?: string | null,
    amount?: number | null,
    selectedVa?: boolean | null,
    iva?: number | null,
    vat?: number | null,
    total?: number | null,
    rfc?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bankStatement?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    supplierQuote?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePayOnBehalfRequestsMutationVariables = {
  input: UpdatePayOnBehalfRequestsInput,
  condition?: ModelPayOnBehalfRequestsConditionInput | null,
};

export type UpdatePayOnBehalfRequestsMutation = {
  updatePayOnBehalfRequests?:  {
    __typename: "PayOnBehalfRequests",
    id: string,
    clientId?: string | null,
    companyName?: string | null,
    purchaseOrder?: string | null,
    paymentTerms?: string | null,
    currency?: string | null,
    amount?: number | null,
    selectedVa?: boolean | null,
    iva?: number | null,
    vat?: number | null,
    total?: number | null,
    rfc?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bankStatement?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    supplierQuote?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePayOnBehalfRequestsMutationVariables = {
  input: DeletePayOnBehalfRequestsInput,
  condition?: ModelPayOnBehalfRequestsConditionInput | null,
};

export type DeletePayOnBehalfRequestsMutation = {
  deletePayOnBehalfRequests?:  {
    __typename: "PayOnBehalfRequests",
    id: string,
    clientId?: string | null,
    companyName?: string | null,
    purchaseOrder?: string | null,
    paymentTerms?: string | null,
    currency?: string | null,
    amount?: number | null,
    selectedVa?: boolean | null,
    iva?: number | null,
    vat?: number | null,
    total?: number | null,
    rfc?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bankStatement?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    supplierQuote?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateBuyerContactClientMutationVariables = {
  input: CreateBuyerContactClientInput,
  condition?: ModelBuyerContactClientConditionInput | null,
};

export type CreateBuyerContactClientMutation = {
  createBuyerContactClient?:  {
    __typename: "BuyerContactClient",
    id: string,
    companyId: string,
    status?: boolean | null,
    defaultContact?: boolean | null,
    name?: string | null,
    email?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateBuyerContactClientMutationVariables = {
  input: UpdateBuyerContactClientInput,
  condition?: ModelBuyerContactClientConditionInput | null,
};

export type UpdateBuyerContactClientMutation = {
  updateBuyerContactClient?:  {
    __typename: "BuyerContactClient",
    id: string,
    companyId: string,
    status?: boolean | null,
    defaultContact?: boolean | null,
    name?: string | null,
    email?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteBuyerContactClientMutationVariables = {
  input: DeleteBuyerContactClientInput,
  condition?: ModelBuyerContactClientConditionInput | null,
};

export type DeleteBuyerContactClientMutation = {
  deleteBuyerContactClient?:  {
    __typename: "BuyerContactClient",
    id: string,
    companyId: string,
    status?: boolean | null,
    defaultContact?: boolean | null,
    name?: string | null,
    email?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateBrandFactoryRfqEmailsMutationVariables = {
  input: CreateBrandFactoryRfqEmailsInput,
  condition?: ModelBrandFactoryRfqEmailsConditionInput | null,
};

export type CreateBrandFactoryRfqEmailsMutation = {
  createBrandFactoryRfqEmails?:  {
    __typename: "BrandFactoryRfqEmails",
    id: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateBrandFactoryRfqEmailsMutationVariables = {
  input: UpdateBrandFactoryRfqEmailsInput,
  condition?: ModelBrandFactoryRfqEmailsConditionInput | null,
};

export type UpdateBrandFactoryRfqEmailsMutation = {
  updateBrandFactoryRfqEmails?:  {
    __typename: "BrandFactoryRfqEmails",
    id: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteBrandFactoryRfqEmailsMutationVariables = {
  input: DeleteBrandFactoryRfqEmailsInput,
  condition?: ModelBrandFactoryRfqEmailsConditionInput | null,
};

export type DeleteBrandFactoryRfqEmailsMutation = {
  deleteBrandFactoryRfqEmails?:  {
    __typename: "BrandFactoryRfqEmails",
    id: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAutomobilesEmailsMutationVariables = {
  input: CreateAutomobilesEmailsInput,
  condition?: ModelAutomobilesEmailsConditionInput | null,
};

export type CreateAutomobilesEmailsMutation = {
  createAutomobilesEmails?:  {
    __typename: "AutomobilesEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAutomobilesEmailsMutationVariables = {
  input: UpdateAutomobilesEmailsInput,
  condition?: ModelAutomobilesEmailsConditionInput | null,
};

export type UpdateAutomobilesEmailsMutation = {
  updateAutomobilesEmails?:  {
    __typename: "AutomobilesEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAutomobilesEmailsMutationVariables = {
  input: DeleteAutomobilesEmailsInput,
  condition?: ModelAutomobilesEmailsConditionInput | null,
};

export type DeleteAutomobilesEmailsMutation = {
  deleteAutomobilesEmails?:  {
    __typename: "AutomobilesEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateQAEmailsMutationVariables = {
  input: CreateQAEmailsInput,
  condition?: ModelQAEmailsConditionInput | null,
};

export type CreateQAEmailsMutation = {
  createQAEmails?:  {
    __typename: "QAEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateQAEmailsMutationVariables = {
  input: UpdateQAEmailsInput,
  condition?: ModelQAEmailsConditionInput | null,
};

export type UpdateQAEmailsMutation = {
  updateQAEmails?:  {
    __typename: "QAEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteQAEmailsMutationVariables = {
  input: DeleteQAEmailsInput,
  condition?: ModelQAEmailsConditionInput | null,
};

export type DeleteQAEmailsMutation = {
  deleteQAEmails?:  {
    __typename: "QAEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOrderPopAdminEmailsMutationVariables = {
  input: CreateOrderPopAdminEmailsInput,
  condition?: ModelOrderPopAdminEmailsConditionInput | null,
};

export type CreateOrderPopAdminEmailsMutation = {
  createOrderPopAdminEmails?:  {
    __typename: "OrderPopAdminEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateOrderPopAdminEmailsMutationVariables = {
  input: UpdateOrderPopAdminEmailsInput,
  condition?: ModelOrderPopAdminEmailsConditionInput | null,
};

export type UpdateOrderPopAdminEmailsMutation = {
  updateOrderPopAdminEmails?:  {
    __typename: "OrderPopAdminEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteOrderPopAdminEmailsMutationVariables = {
  input: DeleteOrderPopAdminEmailsInput,
  condition?: ModelOrderPopAdminEmailsConditionInput | null,
};

export type DeleteOrderPopAdminEmailsMutation = {
  deleteOrderPopAdminEmails?:  {
    __typename: "OrderPopAdminEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOrderPopCheckoutEmailsMutationVariables = {
  input: CreateOrderPopCheckoutEmailsInput,
  condition?: ModelOrderPopCheckoutEmailsConditionInput | null,
};

export type CreateOrderPopCheckoutEmailsMutation = {
  createOrderPopCheckoutEmails?:  {
    __typename: "OrderPopCheckoutEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateOrderPopCheckoutEmailsMutationVariables = {
  input: UpdateOrderPopCheckoutEmailsInput,
  condition?: ModelOrderPopCheckoutEmailsConditionInput | null,
};

export type UpdateOrderPopCheckoutEmailsMutation = {
  updateOrderPopCheckoutEmails?:  {
    __typename: "OrderPopCheckoutEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteOrderPopCheckoutEmailsMutationVariables = {
  input: DeleteOrderPopCheckoutEmailsInput,
  condition?: ModelOrderPopCheckoutEmailsConditionInput | null,
};

export type DeleteOrderPopCheckoutEmailsMutation = {
  deleteOrderPopCheckoutEmails?:  {
    __typename: "OrderPopCheckoutEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateGREmailsMutationVariables = {
  input: CreateGREmailsInput,
  condition?: ModelGREmailsConditionInput | null,
};

export type CreateGREmailsMutation = {
  createGREmails?:  {
    __typename: "GREmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateGREmailsMutationVariables = {
  input: UpdateGREmailsInput,
  condition?: ModelGREmailsConditionInput | null,
};

export type UpdateGREmailsMutation = {
  updateGREmails?:  {
    __typename: "GREmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteGREmailsMutationVariables = {
  input: DeleteGREmailsInput,
  condition?: ModelGREmailsConditionInput | null,
};

export type DeleteGREmailsMutation = {
  deleteGREmails?:  {
    __typename: "GREmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRegionsMutationVariables = {
  input: CreateRegionsInput,
  condition?: ModelRegionsConditionInput | null,
};

export type CreateRegionsMutation = {
  createRegions?:  {
    __typename: "Regions",
    id: string,
    status: boolean,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRegionsMutationVariables = {
  input: UpdateRegionsInput,
  condition?: ModelRegionsConditionInput | null,
};

export type UpdateRegionsMutation = {
  updateRegions?:  {
    __typename: "Regions",
    id: string,
    status: boolean,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRegionsMutationVariables = {
  input: DeleteRegionsInput,
  condition?: ModelRegionsConditionInput | null,
};

export type DeleteRegionsMutation = {
  deleteRegions?:  {
    __typename: "Regions",
    id: string,
    status: boolean,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateDefaultAddressMutationVariables = {
  input: CreateDefaultAddressInput,
  condition?: ModelDefaultAddressConditionInput | null,
};

export type CreateDefaultAddressMutation = {
  createDefaultAddress?:  {
    __typename: "DefaultAddress",
    id: string,
    companyId: string,
    userId?: string | null,
    status: boolean,
    address:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    },
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateDefaultAddressMutationVariables = {
  input: UpdateDefaultAddressInput,
  condition?: ModelDefaultAddressConditionInput | null,
};

export type UpdateDefaultAddressMutation = {
  updateDefaultAddress?:  {
    __typename: "DefaultAddress",
    id: string,
    companyId: string,
    userId?: string | null,
    status: boolean,
    address:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    },
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteDefaultAddressMutationVariables = {
  input: DeleteDefaultAddressInput,
  condition?: ModelDefaultAddressConditionInput | null,
};

export type DeleteDefaultAddressMutation = {
  deleteDefaultAddress?:  {
    __typename: "DefaultAddress",
    id: string,
    companyId: string,
    userId?: string | null,
    status: boolean,
    address:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    },
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateDefaultDeliveryContactMutationVariables = {
  input: CreateDefaultDeliveryContactInput,
  condition?: ModelDefaultDeliveryContactConditionInput | null,
};

export type CreateDefaultDeliveryContactMutation = {
  createDefaultDeliveryContact?:  {
    __typename: "DefaultDeliveryContact",
    id: string,
    companyId?: string | null,
    userId?: string | null,
    status?: boolean | null,
    name?: string | null,
    phoneNumber?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateDefaultDeliveryContactMutationVariables = {
  input: UpdateDefaultDeliveryContactInput,
  condition?: ModelDefaultDeliveryContactConditionInput | null,
};

export type UpdateDefaultDeliveryContactMutation = {
  updateDefaultDeliveryContact?:  {
    __typename: "DefaultDeliveryContact",
    id: string,
    companyId?: string | null,
    userId?: string | null,
    status?: boolean | null,
    name?: string | null,
    phoneNumber?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteDefaultDeliveryContactMutationVariables = {
  input: DeleteDefaultDeliveryContactInput,
  condition?: ModelDefaultDeliveryContactConditionInput | null,
};

export type DeleteDefaultDeliveryContactMutation = {
  deleteDefaultDeliveryContact?:  {
    __typename: "DefaultDeliveryContact",
    id: string,
    companyId?: string | null,
    userId?: string | null,
    status?: boolean | null,
    name?: string | null,
    phoneNumber?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreatePopCategoriesMutationVariables = {
  input: CreatePopCategoriesInput,
  condition?: ModelPopCategoriesConditionInput | null,
};

export type CreatePopCategoriesMutation = {
  createPopCategories?:  {
    __typename: "PopCategories",
    id: string,
    materialId: string,
    name: string,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePopCategoriesMutationVariables = {
  input: UpdatePopCategoriesInput,
  condition?: ModelPopCategoriesConditionInput | null,
};

export type UpdatePopCategoriesMutation = {
  updatePopCategories?:  {
    __typename: "PopCategories",
    id: string,
    materialId: string,
    name: string,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePopCategoriesMutationVariables = {
  input: DeletePopCategoriesInput,
  condition?: ModelPopCategoriesConditionInput | null,
};

export type DeletePopCategoriesMutation = {
  deletePopCategories?:  {
    __typename: "PopCategories",
    id: string,
    materialId: string,
    name: string,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRfpMutationVariables = {
  input: CreateRfpInput,
  condition?: ModelRfpConditionInput | null,
};

export type CreateRfpMutation = {
  createRfp?:  {
    __typename: "Rfp",
    id: string,
    clientId?: string | null,
    status?: string | null,
    name?: string | null,
    nombre?: string | null,
    requerimiento?: string | null,
    estatus?: string | null,
    descripcion?: string | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    url?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    proposals?:  {
      __typename: "ModelRfpProposalsConnection",
      items:  Array< {
        __typename: "RfpProposals",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        name?: string | null,
        description?: string | null,
        validity_days?: number | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfp?:  {
          __typename: "Rfp",
          id: string,
          clientId?: string | null,
          status?: string | null,
          name?: string | null,
          nombre?: string | null,
          requerimiento?: string | null,
          estatus?: string | null,
          descripcion?: string | null,
          url?: string | null,
          limit_time: number,
          creator?: string | null,
          start_time: number,
          delivery_time?: number | null,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          created: number,
          createdAt?: string | null,
          updated?: number | null,
          updatedAt: string,
        } | null,
        rfpProposalsRfpId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    limit_time: number,
    creator?: string | null,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    providers?:  Array< {
      __typename: "RfpProviders",
      idProvider?: string | null,
    } | null > | null,
    start_time: number,
    delivery_time?: number | null,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    created: number,
    createdAt?: string | null,
    updated?: number | null,
    updatedAt: string,
  } | null,
};

export type UpdateRfpMutationVariables = {
  input: UpdateRfpInput,
  condition?: ModelRfpConditionInput | null,
};

export type UpdateRfpMutation = {
  updateRfp?:  {
    __typename: "Rfp",
    id: string,
    clientId?: string | null,
    status?: string | null,
    name?: string | null,
    nombre?: string | null,
    requerimiento?: string | null,
    estatus?: string | null,
    descripcion?: string | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    url?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    proposals?:  {
      __typename: "ModelRfpProposalsConnection",
      items:  Array< {
        __typename: "RfpProposals",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        name?: string | null,
        description?: string | null,
        validity_days?: number | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfp?:  {
          __typename: "Rfp",
          id: string,
          clientId?: string | null,
          status?: string | null,
          name?: string | null,
          nombre?: string | null,
          requerimiento?: string | null,
          estatus?: string | null,
          descripcion?: string | null,
          url?: string | null,
          limit_time: number,
          creator?: string | null,
          start_time: number,
          delivery_time?: number | null,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          created: number,
          createdAt?: string | null,
          updated?: number | null,
          updatedAt: string,
        } | null,
        rfpProposalsRfpId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    limit_time: number,
    creator?: string | null,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    providers?:  Array< {
      __typename: "RfpProviders",
      idProvider?: string | null,
    } | null > | null,
    start_time: number,
    delivery_time?: number | null,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    created: number,
    createdAt?: string | null,
    updated?: number | null,
    updatedAt: string,
  } | null,
};

export type DeleteRfpMutationVariables = {
  input: DeleteRfpInput,
  condition?: ModelRfpConditionInput | null,
};

export type DeleteRfpMutation = {
  deleteRfp?:  {
    __typename: "Rfp",
    id: string,
    clientId?: string | null,
    status?: string | null,
    name?: string | null,
    nombre?: string | null,
    requerimiento?: string | null,
    estatus?: string | null,
    descripcion?: string | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    url?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    proposals?:  {
      __typename: "ModelRfpProposalsConnection",
      items:  Array< {
        __typename: "RfpProposals",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        name?: string | null,
        description?: string | null,
        validity_days?: number | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfp?:  {
          __typename: "Rfp",
          id: string,
          clientId?: string | null,
          status?: string | null,
          name?: string | null,
          nombre?: string | null,
          requerimiento?: string | null,
          estatus?: string | null,
          descripcion?: string | null,
          url?: string | null,
          limit_time: number,
          creator?: string | null,
          start_time: number,
          delivery_time?: number | null,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          created: number,
          createdAt?: string | null,
          updated?: number | null,
          updatedAt: string,
        } | null,
        rfpProposalsRfpId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    limit_time: number,
    creator?: string | null,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    providers?:  Array< {
      __typename: "RfpProviders",
      idProvider?: string | null,
    } | null > | null,
    start_time: number,
    delivery_time?: number | null,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    created: number,
    createdAt?: string | null,
    updated?: number | null,
    updatedAt: string,
  } | null,
};

export type CreateRfpProposalsMutationVariables = {
  input: CreateRfpProposalsInput,
  condition?: ModelRfpProposalsConditionInput | null,
};

export type CreateRfpProposalsMutation = {
  createRfpProposals?:  {
    __typename: "RfpProposals",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    name?: string | null,
    description?: string | null,
    validity_days?: number | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfp?:  {
      __typename: "Rfp",
      id: string,
      clientId?: string | null,
      status?: string | null,
      name?: string | null,
      nombre?: string | null,
      requerimiento?: string | null,
      estatus?: string | null,
      descripcion?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      url?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      proposals?:  {
        __typename: "ModelRfpProposalsConnection",
        items:  Array< {
          __typename: "RfpProposals",
          id: string,
          provider_id: string,
          price: number,
          name?: string | null,
          description?: string | null,
          validity_days?: number | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          rfpProposalsRfpId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      creator?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfpProviders",
        idProvider?: string | null,
      } | null > | null,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null,
    rfpProposalsRfpId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRfpProposalsMutationVariables = {
  input: UpdateRfpProposalsInput,
  condition?: ModelRfpProposalsConditionInput | null,
};

export type UpdateRfpProposalsMutation = {
  updateRfpProposals?:  {
    __typename: "RfpProposals",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    name?: string | null,
    description?: string | null,
    validity_days?: number | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfp?:  {
      __typename: "Rfp",
      id: string,
      clientId?: string | null,
      status?: string | null,
      name?: string | null,
      nombre?: string | null,
      requerimiento?: string | null,
      estatus?: string | null,
      descripcion?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      url?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      proposals?:  {
        __typename: "ModelRfpProposalsConnection",
        items:  Array< {
          __typename: "RfpProposals",
          id: string,
          provider_id: string,
          price: number,
          name?: string | null,
          description?: string | null,
          validity_days?: number | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          rfpProposalsRfpId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      creator?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfpProviders",
        idProvider?: string | null,
      } | null > | null,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null,
    rfpProposalsRfpId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRfpProposalsMutationVariables = {
  input: DeleteRfpProposalsInput,
  condition?: ModelRfpProposalsConditionInput | null,
};

export type DeleteRfpProposalsMutation = {
  deleteRfpProposals?:  {
    __typename: "RfpProposals",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    name?: string | null,
    description?: string | null,
    validity_days?: number | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfp?:  {
      __typename: "Rfp",
      id: string,
      clientId?: string | null,
      status?: string | null,
      name?: string | null,
      nombre?: string | null,
      requerimiento?: string | null,
      estatus?: string | null,
      descripcion?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      url?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      proposals?:  {
        __typename: "ModelRfpProposalsConnection",
        items:  Array< {
          __typename: "RfpProposals",
          id: string,
          provider_id: string,
          price: number,
          name?: string | null,
          description?: string | null,
          validity_days?: number | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          rfpProposalsRfpId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      creator?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfpProviders",
        idProvider?: string | null,
      } | null > | null,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null,
    rfpProposalsRfpId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEvaluationProvidersMutationVariables = {
  input: CreateEvaluationProvidersInput,
  condition?: ModelEvaluationProvidersConditionInput | null,
};

export type CreateEvaluationProvidersMutation = {
  createEvaluationProviders?:  {
    __typename: "EvaluationProviders",
    id: string,
    providerId?: string | null,
    creratorId?: string | null,
    orderId?: string | null,
    time?: number | null,
    price?: number | null,
    quality?: number | null,
    att?: number | null,
    comments?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEvaluationProvidersMutationVariables = {
  input: UpdateEvaluationProvidersInput,
  condition?: ModelEvaluationProvidersConditionInput | null,
};

export type UpdateEvaluationProvidersMutation = {
  updateEvaluationProviders?:  {
    __typename: "EvaluationProviders",
    id: string,
    providerId?: string | null,
    creratorId?: string | null,
    orderId?: string | null,
    time?: number | null,
    price?: number | null,
    quality?: number | null,
    att?: number | null,
    comments?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEvaluationProvidersMutationVariables = {
  input: DeleteEvaluationProvidersInput,
  condition?: ModelEvaluationProvidersConditionInput | null,
};

export type DeleteEvaluationProvidersMutation = {
  deleteEvaluationProviders?:  {
    __typename: "EvaluationProviders",
    id: string,
    providerId?: string | null,
    creratorId?: string | null,
    orderId?: string | null,
    time?: number | null,
    price?: number | null,
    quality?: number | null,
    att?: number | null,
    comments?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLogProductMutationVariables = {
  input: CreateLogProductInput,
  condition?: ModelLogProductConditionInput | null,
};

export type CreateLogProductMutation = {
  createLogProduct?:  {
    __typename: "LogProduct",
    id: string,
    status?: string | null,
    creator?: string | null,
    created?: string | null,
    productId?: string | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLogProductMutationVariables = {
  input: UpdateLogProductInput,
  condition?: ModelLogProductConditionInput | null,
};

export type UpdateLogProductMutation = {
  updateLogProduct?:  {
    __typename: "LogProduct",
    id: string,
    status?: string | null,
    creator?: string | null,
    created?: string | null,
    productId?: string | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLogProductMutationVariables = {
  input: DeleteLogProductInput,
  condition?: ModelLogProductConditionInput | null,
};

export type DeleteLogProductMutation = {
  deleteLogProduct?:  {
    __typename: "LogProduct",
    id: string,
    status?: string | null,
    creator?: string | null,
    created?: string | null,
    productId?: string | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLogRfqMutationVariables = {
  input: CreateLogRfqInput,
  condition?: ModelLogRfqConditionInput | null,
};

export type CreateLogRfqMutation = {
  createLogRfq?:  {
    __typename: "LogRfq",
    id: string,
    status?: string | null,
    creator?: string | null,
    rfqId: string,
    description?: string | null,
    provider_id?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateLogRfqMutationVariables = {
  input: UpdateLogRfqInput,
  condition?: ModelLogRfqConditionInput | null,
};

export type UpdateLogRfqMutation = {
  updateLogRfq?:  {
    __typename: "LogRfq",
    id: string,
    status?: string | null,
    creator?: string | null,
    rfqId: string,
    description?: string | null,
    provider_id?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteLogRfqMutationVariables = {
  input: DeleteLogRfqInput,
  condition?: ModelLogRfqConditionInput | null,
};

export type DeleteLogRfqMutation = {
  deleteLogRfq?:  {
    __typename: "LogRfq",
    id: string,
    status?: string | null,
    creator?: string | null,
    rfqId: string,
    description?: string | null,
    provider_id?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateLogProductLabelMutationVariables = {
  input: CreateLogProductLabelInput,
  condition?: ModelLogProductLabelConditionInput | null,
};

export type CreateLogProductLabelMutation = {
  createLogProductLabel?:  {
    __typename: "LogProductLabel",
    id: string,
    status?: string | null,
    creator?: string | null,
    created?: string | null,
    productLabelId?: string | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLogProductLabelMutationVariables = {
  input: UpdateLogProductLabelInput,
  condition?: ModelLogProductLabelConditionInput | null,
};

export type UpdateLogProductLabelMutation = {
  updateLogProductLabel?:  {
    __typename: "LogProductLabel",
    id: string,
    status?: string | null,
    creator?: string | null,
    created?: string | null,
    productLabelId?: string | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLogProductLabelMutationVariables = {
  input: DeleteLogProductLabelInput,
  condition?: ModelLogProductLabelConditionInput | null,
};

export type DeleteLogProductLabelMutation = {
  deleteLogProductLabel?:  {
    __typename: "LogProductLabel",
    id: string,
    status?: string | null,
    creator?: string | null,
    created?: string | null,
    productLabelId?: string | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLogGanadorAutoMutationVariables = {
  input: CreateLogGanadorAutoInput,
  condition?: ModelLogGanadorAutoConditionInput | null,
};

export type CreateLogGanadorAutoMutation = {
  createLogGanadorAuto?:  {
    __typename: "LogGanadorAuto",
    id: string,
    id_auto?: string | null,
    id_user?: string | null,
    fecha_rifa?: number | null,
    email?: string | null,
    nombre?: string | null,
    a_paterno?: string | null,
    a_materno?: string | null,
    status_buyer?: boolean | null,
    date_buyer?: number | null,
    winner?: number | null,
    refused?: number | null,
    since?: string | null,
    process_buyer?: boolean | null,
    reactive?: boolean | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLogGanadorAutoMutationVariables = {
  input: UpdateLogGanadorAutoInput,
  condition?: ModelLogGanadorAutoConditionInput | null,
};

export type UpdateLogGanadorAutoMutation = {
  updateLogGanadorAuto?:  {
    __typename: "LogGanadorAuto",
    id: string,
    id_auto?: string | null,
    id_user?: string | null,
    fecha_rifa?: number | null,
    email?: string | null,
    nombre?: string | null,
    a_paterno?: string | null,
    a_materno?: string | null,
    status_buyer?: boolean | null,
    date_buyer?: number | null,
    winner?: number | null,
    refused?: number | null,
    since?: string | null,
    process_buyer?: boolean | null,
    reactive?: boolean | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLogGanadorAutoMutationVariables = {
  input: DeleteLogGanadorAutoInput,
  condition?: ModelLogGanadorAutoConditionInput | null,
};

export type DeleteLogGanadorAutoMutation = {
  deleteLogGanadorAuto?:  {
    __typename: "LogGanadorAuto",
    id: string,
    id_auto?: string | null,
    id_user?: string | null,
    fecha_rifa?: number | null,
    email?: string | null,
    nombre?: string | null,
    a_paterno?: string | null,
    a_materno?: string | null,
    status_buyer?: boolean | null,
    date_buyer?: number | null,
    winner?: number | null,
    refused?: number | null,
    since?: string | null,
    process_buyer?: boolean | null,
    reactive?: boolean | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateNotificationMutationVariables = {
  input: CreateNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type CreateNotificationMutation = {
  createNotification?:  {
    __typename: "Notification",
    id: string,
    type: string,
    remember?: string | null,
    stared?: string | null,
    important?: string | null,
    status?: string | null,
    isChat?: string | null,
    creatorName: string,
    creatorEmail: string,
    creatorRole?: string | null,
    creatorId: string,
    receipentName: string,
    receipentRole?: string | null,
    receipentEmail?: string | null,
    receipentId: string,
    showPopUp?: boolean | null,
    sendEmail?: boolean | null,
    title: string,
    subtitle: string,
    description: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    path?: string | null,
    idParent?: string | null,
    createdAt?: string | null,
    seenAt?: number | null,
    updatedAt: string,
  } | null,
};

export type UpdateNotificationMutationVariables = {
  input: UpdateNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type UpdateNotificationMutation = {
  updateNotification?:  {
    __typename: "Notification",
    id: string,
    type: string,
    remember?: string | null,
    stared?: string | null,
    important?: string | null,
    status?: string | null,
    isChat?: string | null,
    creatorName: string,
    creatorEmail: string,
    creatorRole?: string | null,
    creatorId: string,
    receipentName: string,
    receipentRole?: string | null,
    receipentEmail?: string | null,
    receipentId: string,
    showPopUp?: boolean | null,
    sendEmail?: boolean | null,
    title: string,
    subtitle: string,
    description: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    path?: string | null,
    idParent?: string | null,
    createdAt?: string | null,
    seenAt?: number | null,
    updatedAt: string,
  } | null,
};

export type DeleteNotificationMutationVariables = {
  input: DeleteNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type DeleteNotificationMutation = {
  deleteNotification?:  {
    __typename: "Notification",
    id: string,
    type: string,
    remember?: string | null,
    stared?: string | null,
    important?: string | null,
    status?: string | null,
    isChat?: string | null,
    creatorName: string,
    creatorEmail: string,
    creatorRole?: string | null,
    creatorId: string,
    receipentName: string,
    receipentRole?: string | null,
    receipentEmail?: string | null,
    receipentId: string,
    showPopUp?: boolean | null,
    sendEmail?: boolean | null,
    title: string,
    subtitle: string,
    description: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    path?: string | null,
    idParent?: string | null,
    createdAt?: string | null,
    seenAt?: number | null,
    updatedAt: string,
  } | null,
};

export type CreateMercadoCategoriesMutationVariables = {
  input: CreateMercadoCategoriesInput,
  condition?: ModelMercadoCategoriesConditionInput | null,
};

export type CreateMercadoCategoriesMutation = {
  createMercadoCategories?:  {
    __typename: "MercadoCategories",
    id: string,
    idMercado?: string | null,
    status?: string | null,
    name?: string | null,
    rulesClients?:  Array< {
      __typename: "MercadoCategoryClientRule",
      clientID?: string | null,
      enabled?: boolean | null,
      isUnrestricted?: boolean | null,
      isRestricted?: boolean | null,
      increment?: number | null,
      fee?: number | null,
    } | null > | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    parentCategory?: string | null,
    childrenCategories?: Array< string | null > | null,
    items?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMercadoCategoriesMutationVariables = {
  input: UpdateMercadoCategoriesInput,
  condition?: ModelMercadoCategoriesConditionInput | null,
};

export type UpdateMercadoCategoriesMutation = {
  updateMercadoCategories?:  {
    __typename: "MercadoCategories",
    id: string,
    idMercado?: string | null,
    status?: string | null,
    name?: string | null,
    rulesClients?:  Array< {
      __typename: "MercadoCategoryClientRule",
      clientID?: string | null,
      enabled?: boolean | null,
      isUnrestricted?: boolean | null,
      isRestricted?: boolean | null,
      increment?: number | null,
      fee?: number | null,
    } | null > | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    parentCategory?: string | null,
    childrenCategories?: Array< string | null > | null,
    items?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMercadoCategoriesMutationVariables = {
  input: DeleteMercadoCategoriesInput,
  condition?: ModelMercadoCategoriesConditionInput | null,
};

export type DeleteMercadoCategoriesMutation = {
  deleteMercadoCategories?:  {
    __typename: "MercadoCategories",
    id: string,
    idMercado?: string | null,
    status?: string | null,
    name?: string | null,
    rulesClients?:  Array< {
      __typename: "MercadoCategoryClientRule",
      clientID?: string | null,
      enabled?: boolean | null,
      isUnrestricted?: boolean | null,
      isRestricted?: boolean | null,
      increment?: number | null,
      fee?: number | null,
    } | null > | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    parentCategory?: string | null,
    childrenCategories?: Array< string | null > | null,
    items?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMercadoProductCategoryClientMutationVariables = {
  input: CreateMercadoProductCategoryClientInput,
  condition?: ModelMercadoProductCategoryClientConditionInput | null,
};

export type CreateMercadoProductCategoryClientMutation = {
  createMercadoProductCategoryClient?:  {
    __typename: "MercadoProductCategoryClient",
    id: string,
    idClient?: string | null,
    idMercadoCategory?: string | null,
    unrestrictedProducts?: Array< string | null > | null,
    restrictedProducts?: Array< string | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMercadoProductCategoryClientMutationVariables = {
  input: UpdateMercadoProductCategoryClientInput,
  condition?: ModelMercadoProductCategoryClientConditionInput | null,
};

export type UpdateMercadoProductCategoryClientMutation = {
  updateMercadoProductCategoryClient?:  {
    __typename: "MercadoProductCategoryClient",
    id: string,
    idClient?: string | null,
    idMercadoCategory?: string | null,
    unrestrictedProducts?: Array< string | null > | null,
    restrictedProducts?: Array< string | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMercadoProductCategoryClientMutationVariables = {
  input: DeleteMercadoProductCategoryClientInput,
  condition?: ModelMercadoProductCategoryClientConditionInput | null,
};

export type DeleteMercadoProductCategoryClientMutation = {
  deleteMercadoProductCategoryClient?:  {
    __typename: "MercadoProductCategoryClient",
    id: string,
    idClient?: string | null,
    idMercadoCategory?: string | null,
    unrestrictedProducts?: Array< string | null > | null,
    restrictedProducts?: Array< string | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateExternalApisMutationVariables = {
  input: CreateExternalApisInput,
  condition?: ModelExternalApisConditionInput | null,
};

export type CreateExternalApisMutation = {
  createExternalApis?:  {
    __typename: "ExternalApis",
    id: string,
    status?: string | null,
    name?: string | null,
    nameExternal?: string | null,
    region?: Array< string | null > | null,
    increment?: number | null,
    discount?: number | null,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateExternalApisMutationVariables = {
  input: UpdateExternalApisInput,
  condition?: ModelExternalApisConditionInput | null,
};

export type UpdateExternalApisMutation = {
  updateExternalApis?:  {
    __typename: "ExternalApis",
    id: string,
    status?: string | null,
    name?: string | null,
    nameExternal?: string | null,
    region?: Array< string | null > | null,
    increment?: number | null,
    discount?: number | null,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteExternalApisMutationVariables = {
  input: DeleteExternalApisInput,
  condition?: ModelExternalApisConditionInput | null,
};

export type DeleteExternalApisMutation = {
  deleteExternalApis?:  {
    __typename: "ExternalApis",
    id: string,
    status?: string | null,
    name?: string | null,
    nameExternal?: string | null,
    region?: Array< string | null > | null,
    increment?: number | null,
    discount?: number | null,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePrintPricesMutationVariables = {
  input: CreatePrintPricesInput,
  condition?: ModelPrintPricesConditionInput | null,
};

export type CreatePrintPricesMutation = {
  createPrintPrices?:  {
    __typename: "PrintPrices",
    id: string,
    identifier?: number | null,
    status?: string | null,
    creator?: string | null,
    description?: string | null,
    price?: number | null,
    minUnits?: number | null,
    maxUnits?: number | null,
    ranges?:  Array< {
      __typename: "PrintPriceRange",
      price?: number | null,
      minUnits?: number | null,
      maxUnits?: number | null,
    } | null > | null,
    clientPrintPrices?:  Array< {
      __typename: "ClientPrintPrice",
      clientId?: string | null,
      price?: number | null,
      minUnits?: number | null,
      maxUnits?: number | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePrintPricesMutationVariables = {
  input: UpdatePrintPricesInput,
  condition?: ModelPrintPricesConditionInput | null,
};

export type UpdatePrintPricesMutation = {
  updatePrintPrices?:  {
    __typename: "PrintPrices",
    id: string,
    identifier?: number | null,
    status?: string | null,
    creator?: string | null,
    description?: string | null,
    price?: number | null,
    minUnits?: number | null,
    maxUnits?: number | null,
    ranges?:  Array< {
      __typename: "PrintPriceRange",
      price?: number | null,
      minUnits?: number | null,
      maxUnits?: number | null,
    } | null > | null,
    clientPrintPrices?:  Array< {
      __typename: "ClientPrintPrice",
      clientId?: string | null,
      price?: number | null,
      minUnits?: number | null,
      maxUnits?: number | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePrintPricesMutationVariables = {
  input: DeletePrintPricesInput,
  condition?: ModelPrintPricesConditionInput | null,
};

export type DeletePrintPricesMutation = {
  deletePrintPrices?:  {
    __typename: "PrintPrices",
    id: string,
    identifier?: number | null,
    status?: string | null,
    creator?: string | null,
    description?: string | null,
    price?: number | null,
    minUnits?: number | null,
    maxUnits?: number | null,
    ranges?:  Array< {
      __typename: "PrintPriceRange",
      price?: number | null,
      minUnits?: number | null,
      maxUnits?: number | null,
    } | null > | null,
    clientPrintPrices?:  Array< {
      __typename: "ClientPrintPrice",
      clientId?: string | null,
      price?: number | null,
      minUnits?: number | null,
      maxUnits?: number | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePrintLogosMutationVariables = {
  input: CreatePrintLogosInput,
  condition?: ModelPrintLogosConditionInput | null,
};

export type CreatePrintLogosMutation = {
  createPrintLogos?:  {
    __typename: "PrintLogos",
    id: string,
    status?: string | null,
    creator?: string | null,
    description?: string | null,
    identifier?: number | null,
    clientId?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type UpdatePrintLogosMutationVariables = {
  input: UpdatePrintLogosInput,
  condition?: ModelPrintLogosConditionInput | null,
};

export type UpdatePrintLogosMutation = {
  updatePrintLogos?:  {
    __typename: "PrintLogos",
    id: string,
    status?: string | null,
    creator?: string | null,
    description?: string | null,
    identifier?: number | null,
    clientId?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type DeletePrintLogosMutationVariables = {
  input: DeletePrintLogosInput,
  condition?: ModelPrintLogosConditionInput | null,
};

export type DeletePrintLogosMutation = {
  deletePrintLogos?:  {
    __typename: "PrintLogos",
    id: string,
    status?: string | null,
    creator?: string | null,
    description?: string | null,
    identifier?: number | null,
    clientId?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type CreateLogisticPostalCodeMutationVariables = {
  input: CreateLogisticPostalCodeInput,
  condition?: ModelLogisticPostalCodeConditionInput | null,
};

export type CreateLogisticPostalCodeMutation = {
  createLogisticPostalCode?:  {
    __typename: "LogisticPostalCode",
    id: string,
    cpFrom: string,
    cpTo: string,
    zone: number,
    state: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLogisticPostalCodeMutationVariables = {
  input: UpdateLogisticPostalCodeInput,
  condition?: ModelLogisticPostalCodeConditionInput | null,
};

export type UpdateLogisticPostalCodeMutation = {
  updateLogisticPostalCode?:  {
    __typename: "LogisticPostalCode",
    id: string,
    cpFrom: string,
    cpTo: string,
    zone: number,
    state: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLogisticPostalCodeMutationVariables = {
  input: DeleteLogisticPostalCodeInput,
  condition?: ModelLogisticPostalCodeConditionInput | null,
};

export type DeleteLogisticPostalCodeMutation = {
  deleteLogisticPostalCode?:  {
    __typename: "LogisticPostalCode",
    id: string,
    cpFrom: string,
    cpTo: string,
    zone: number,
    state: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLogisticPieceRangeMutationVariables = {
  input: CreateLogisticPieceRangeInput,
  condition?: ModelLogisticPieceRangeConditionInput | null,
};

export type CreateLogisticPieceRangeMutation = {
  createLogisticPieceRange?:  {
    __typename: "LogisticPieceRange",
    id: string,
    piecesRange: number,
    min: number,
    max: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLogisticPieceRangeMutationVariables = {
  input: UpdateLogisticPieceRangeInput,
  condition?: ModelLogisticPieceRangeConditionInput | null,
};

export type UpdateLogisticPieceRangeMutation = {
  updateLogisticPieceRange?:  {
    __typename: "LogisticPieceRange",
    id: string,
    piecesRange: number,
    min: number,
    max: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLogisticPieceRangeMutationVariables = {
  input: DeleteLogisticPieceRangeInput,
  condition?: ModelLogisticPieceRangeConditionInput | null,
};

export type DeleteLogisticPieceRangeMutation = {
  deleteLogisticPieceRange?:  {
    __typename: "LogisticPieceRange",
    id: string,
    piecesRange: number,
    min: number,
    max: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLogisticWeightRangeMutationVariables = {
  input: CreateLogisticWeightRangeInput,
  condition?: ModelLogisticWeightRangeConditionInput | null,
};

export type CreateLogisticWeightRangeMutation = {
  createLogisticWeightRange?:  {
    __typename: "LogisticWeightRange",
    id: string,
    weightRange: number,
    min: number,
    max: number,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLogisticWeightRangeMutationVariables = {
  input: UpdateLogisticWeightRangeInput,
  condition?: ModelLogisticWeightRangeConditionInput | null,
};

export type UpdateLogisticWeightRangeMutation = {
  updateLogisticWeightRange?:  {
    __typename: "LogisticWeightRange",
    id: string,
    weightRange: number,
    min: number,
    max: number,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLogisticWeightRangeMutationVariables = {
  input: DeleteLogisticWeightRangeInput,
  condition?: ModelLogisticWeightRangeConditionInput | null,
};

export type DeleteLogisticWeightRangeMutation = {
  deleteLogisticWeightRange?:  {
    __typename: "LogisticWeightRange",
    id: string,
    weightRange: number,
    min: number,
    max: number,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLogisticWeightBoxMutationVariables = {
  input: CreateLogisticWeightBoxInput,
  condition?: ModelLogisticWeightBoxConditionInput | null,
};

export type CreateLogisticWeightBoxMutation = {
  createLogisticWeightBox?:  {
    __typename: "LogisticWeightBox",
    id: string,
    boxId?: string | null,
    shippingPrices?:  Array< {
      __typename: "LogisticWeightPrice",
      weightRangeId?: string | null,
      price: number,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLogisticWeightBoxMutationVariables = {
  input: UpdateLogisticWeightBoxInput,
  condition?: ModelLogisticWeightBoxConditionInput | null,
};

export type UpdateLogisticWeightBoxMutation = {
  updateLogisticWeightBox?:  {
    __typename: "LogisticWeightBox",
    id: string,
    boxId?: string | null,
    shippingPrices?:  Array< {
      __typename: "LogisticWeightPrice",
      weightRangeId?: string | null,
      price: number,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLogisticWeightBoxMutationVariables = {
  input: DeleteLogisticWeightBoxInput,
  condition?: ModelLogisticWeightBoxConditionInput | null,
};

export type DeleteLogisticWeightBoxMutation = {
  deleteLogisticWeightBox?:  {
    __typename: "LogisticWeightBox",
    id: string,
    boxId?: string | null,
    shippingPrices?:  Array< {
      __typename: "LogisticWeightPrice",
      weightRangeId?: string | null,
      price: number,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLogisticZoneMutationVariables = {
  input: CreateLogisticZoneInput,
  condition?: ModelLogisticZoneConditionInput | null,
};

export type CreateLogisticZoneMutation = {
  createLogisticZone?:  {
    __typename: "LogisticZone",
    id: string,
    zoneName: string,
    shippingPrices?:  Array< {
      __typename: "LogisticShippingPrice",
      piecesRangeId?: string | null,
      price: number,
    } | null > | null,
    clientsRanges?:  Array< {
      __typename: "LogisticPieceRangeClient",
      id: string,
      clientId: string,
      piecesRange: string,
      price: number,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLogisticZoneMutationVariables = {
  input: UpdateLogisticZoneInput,
  condition?: ModelLogisticZoneConditionInput | null,
};

export type UpdateLogisticZoneMutation = {
  updateLogisticZone?:  {
    __typename: "LogisticZone",
    id: string,
    zoneName: string,
    shippingPrices?:  Array< {
      __typename: "LogisticShippingPrice",
      piecesRangeId?: string | null,
      price: number,
    } | null > | null,
    clientsRanges?:  Array< {
      __typename: "LogisticPieceRangeClient",
      id: string,
      clientId: string,
      piecesRange: string,
      price: number,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLogisticZoneMutationVariables = {
  input: DeleteLogisticZoneInput,
  condition?: ModelLogisticZoneConditionInput | null,
};

export type DeleteLogisticZoneMutation = {
  deleteLogisticZone?:  {
    __typename: "LogisticZone",
    id: string,
    zoneName: string,
    shippingPrices?:  Array< {
      __typename: "LogisticShippingPrice",
      piecesRangeId?: string | null,
      price: number,
    } | null > | null,
    clientsRanges?:  Array< {
      __typename: "LogisticPieceRangeClient",
      id: string,
      clientId: string,
      piecesRange: string,
      price: number,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLogisticBoxMutationVariables = {
  input: CreateLogisticBoxInput,
  condition?: ModelLogisticBoxConditionInput | null,
};

export type CreateLogisticBoxMutation = {
  createLogisticBox?:  {
    __typename: "LogisticBox",
    id: string,
    status?: string | null,
    name?: string | null,
    description?: string | null,
    price?: number | null,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    volumetricWeight?: number | null,
    maxWeight?: number | null,
    maxPayload?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateLogisticBoxMutationVariables = {
  input: UpdateLogisticBoxInput,
  condition?: ModelLogisticBoxConditionInput | null,
};

export type UpdateLogisticBoxMutation = {
  updateLogisticBox?:  {
    __typename: "LogisticBox",
    id: string,
    status?: string | null,
    name?: string | null,
    description?: string | null,
    price?: number | null,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    volumetricWeight?: number | null,
    maxWeight?: number | null,
    maxPayload?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteLogisticBoxMutationVariables = {
  input: DeleteLogisticBoxInput,
  condition?: ModelLogisticBoxConditionInput | null,
};

export type DeleteLogisticBoxMutation = {
  deleteLogisticBox?:  {
    __typename: "LogisticBox",
    id: string,
    status?: string | null,
    name?: string | null,
    description?: string | null,
    price?: number | null,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    volumetricWeight?: number | null,
    maxWeight?: number | null,
    maxPayload?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateLogisticVehiclesMutationVariables = {
  input: CreateLogisticVehiclesInput,
  condition?: ModelLogisticVehiclesConditionInput | null,
};

export type CreateLogisticVehiclesMutation = {
  createLogisticVehicles?:  {
    __typename: "LogisticVehicles",
    id: string,
    status?: string | null,
    licensePlate?: string | null,
    hasInsurancePolicy?: string | null,
    fuelCapacity?: number | null,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    maxWeight?: number | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLogisticVehiclesMutationVariables = {
  input: UpdateLogisticVehiclesInput,
  condition?: ModelLogisticVehiclesConditionInput | null,
};

export type UpdateLogisticVehiclesMutation = {
  updateLogisticVehicles?:  {
    __typename: "LogisticVehicles",
    id: string,
    status?: string | null,
    licensePlate?: string | null,
    hasInsurancePolicy?: string | null,
    fuelCapacity?: number | null,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    maxWeight?: number | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLogisticVehiclesMutationVariables = {
  input: DeleteLogisticVehiclesInput,
  condition?: ModelLogisticVehiclesConditionInput | null,
};

export type DeleteLogisticVehiclesMutation = {
  deleteLogisticVehicles?:  {
    __typename: "LogisticVehicles",
    id: string,
    status?: string | null,
    licensePlate?: string | null,
    hasInsurancePolicy?: string | null,
    fuelCapacity?: number | null,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    maxWeight?: number | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePakmailCarrierMutationVariables = {
  input: CreatePakmailCarrierInput,
  condition?: ModelPakmailCarrierConditionInput | null,
};

export type CreatePakmailCarrierMutation = {
  createPakmailCarrier?:  {
    __typename: "PakmailCarrier",
    id: string,
    status?: string | null,
    identifier?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdatePakmailCarrierMutationVariables = {
  input: UpdatePakmailCarrierInput,
  condition?: ModelPakmailCarrierConditionInput | null,
};

export type UpdatePakmailCarrierMutation = {
  updatePakmailCarrier?:  {
    __typename: "PakmailCarrier",
    id: string,
    status?: string | null,
    identifier?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeletePakmailCarrierMutationVariables = {
  input: DeletePakmailCarrierInput,
  condition?: ModelPakmailCarrierConditionInput | null,
};

export type DeletePakmailCarrierMutation = {
  deletePakmailCarrier?:  {
    __typename: "PakmailCarrier",
    id: string,
    status?: string | null,
    identifier?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreatePakmailServiceMutationVariables = {
  input: CreatePakmailServiceInput,
  condition?: ModelPakmailServiceConditionInput | null,
};

export type CreatePakmailServiceMutation = {
  createPakmailService?:  {
    __typename: "PakmailService",
    id: string,
    status?: string | null,
    identifier?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    isNational?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdatePakmailServiceMutationVariables = {
  input: UpdatePakmailServiceInput,
  condition?: ModelPakmailServiceConditionInput | null,
};

export type UpdatePakmailServiceMutation = {
  updatePakmailService?:  {
    __typename: "PakmailService",
    id: string,
    status?: string | null,
    identifier?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    isNational?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeletePakmailServiceMutationVariables = {
  input: DeletePakmailServiceInput,
  condition?: ModelPakmailServiceConditionInput | null,
};

export type DeletePakmailServiceMutation = {
  deletePakmailService?:  {
    __typename: "PakmailService",
    id: string,
    status?: string | null,
    identifier?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    isNational?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreatePakmailShipmentStatusMutationVariables = {
  input: CreatePakmailShipmentStatusInput,
  condition?: ModelPakmailShipmentStatusConditionInput | null,
};

export type CreatePakmailShipmentStatusMutation = {
  createPakmailShipmentStatus?:  {
    __typename: "PakmailShipmentStatus",
    id: string,
    status?: string | null,
    identifier?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdatePakmailShipmentStatusMutationVariables = {
  input: UpdatePakmailShipmentStatusInput,
  condition?: ModelPakmailShipmentStatusConditionInput | null,
};

export type UpdatePakmailShipmentStatusMutation = {
  updatePakmailShipmentStatus?:  {
    __typename: "PakmailShipmentStatus",
    id: string,
    status?: string | null,
    identifier?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeletePakmailShipmentStatusMutationVariables = {
  input: DeletePakmailShipmentStatusInput,
  condition?: ModelPakmailShipmentStatusConditionInput | null,
};

export type DeletePakmailShipmentStatusMutation = {
  deletePakmailShipmentStatus?:  {
    __typename: "PakmailShipmentStatus",
    id: string,
    status?: string | null,
    identifier?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreatePakmailShipmentEventMutationVariables = {
  input: CreatePakmailShipmentEventInput,
  condition?: ModelPakmailShipmentEventConditionInput | null,
};

export type CreatePakmailShipmentEventMutation = {
  createPakmailShipmentEvent?:  {
    __typename: "PakmailShipmentEvent",
    id: string,
    status?: string | null,
    identifier?: string | null,
    visibleFor?: Array< string | null > | null,
    color?: string | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdatePakmailShipmentEventMutationVariables = {
  input: UpdatePakmailShipmentEventInput,
  condition?: ModelPakmailShipmentEventConditionInput | null,
};

export type UpdatePakmailShipmentEventMutation = {
  updatePakmailShipmentEvent?:  {
    __typename: "PakmailShipmentEvent",
    id: string,
    status?: string | null,
    identifier?: string | null,
    visibleFor?: Array< string | null > | null,
    color?: string | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeletePakmailShipmentEventMutationVariables = {
  input: DeletePakmailShipmentEventInput,
  condition?: ModelPakmailShipmentEventConditionInput | null,
};

export type DeletePakmailShipmentEventMutation = {
  deletePakmailShipmentEvent?:  {
    __typename: "PakmailShipmentEvent",
    id: string,
    status?: string | null,
    identifier?: string | null,
    visibleFor?: Array< string | null > | null,
    color?: string | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreatePakmailPickupStatusMutationVariables = {
  input: CreatePakmailPickupStatusInput,
  condition?: ModelPakmailPickupStatusConditionInput | null,
};

export type CreatePakmailPickupStatusMutation = {
  createPakmailPickupStatus?:  {
    __typename: "PakmailPickupStatus",
    id: string,
    status?: string | null,
    identifier?: number | null,
    visibleFor?: Array< string | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdatePakmailPickupStatusMutationVariables = {
  input: UpdatePakmailPickupStatusInput,
  condition?: ModelPakmailPickupStatusConditionInput | null,
};

export type UpdatePakmailPickupStatusMutation = {
  updatePakmailPickupStatus?:  {
    __typename: "PakmailPickupStatus",
    id: string,
    status?: string | null,
    identifier?: number | null,
    visibleFor?: Array< string | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeletePakmailPickupStatusMutationVariables = {
  input: DeletePakmailPickupStatusInput,
  condition?: ModelPakmailPickupStatusConditionInput | null,
};

export type DeletePakmailPickupStatusMutation = {
  deletePakmailPickupStatus?:  {
    __typename: "PakmailPickupStatus",
    id: string,
    status?: string | null,
    identifier?: number | null,
    visibleFor?: Array< string | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreatePremiumOrderLogisticGuideMutationVariables = {
  input: CreatePremiumOrderLogisticGuideInput,
  condition?: ModelPremiumOrderLogisticGuideConditionInput | null,
};

export type CreatePremiumOrderLogisticGuideMutation = {
  createPremiumOrderLogisticGuide?:  {
    __typename: "PremiumOrderLogisticGuide",
    id: string,
    type: LogisticGuideType,
    pakmailId?: string | null,
    premiumOrderId: string,
    clientId: string,
    creatorId: string,
    originAddressId?: string | null,
    destinationAddressId?: string | null,
    originAddress?: string | null,
    destinationAddress?: string | null,
    products?:  Array< {
      __typename: "LogisticGuideProduct",
      indexProduct: number,
      productId: string,
      quantity: number,
      unitWidth: number,
      unitHeight: number,
      unitDepth: number,
      unitWeight: number,
    } | null > | null,
    price?: number | null,
    increment?: number | null,
    fee?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdatePremiumOrderLogisticGuideMutationVariables = {
  input: UpdatePremiumOrderLogisticGuideInput,
  condition?: ModelPremiumOrderLogisticGuideConditionInput | null,
};

export type UpdatePremiumOrderLogisticGuideMutation = {
  updatePremiumOrderLogisticGuide?:  {
    __typename: "PremiumOrderLogisticGuide",
    id: string,
    type: LogisticGuideType,
    pakmailId?: string | null,
    premiumOrderId: string,
    clientId: string,
    creatorId: string,
    originAddressId?: string | null,
    destinationAddressId?: string | null,
    originAddress?: string | null,
    destinationAddress?: string | null,
    products?:  Array< {
      __typename: "LogisticGuideProduct",
      indexProduct: number,
      productId: string,
      quantity: number,
      unitWidth: number,
      unitHeight: number,
      unitDepth: number,
      unitWeight: number,
    } | null > | null,
    price?: number | null,
    increment?: number | null,
    fee?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeletePremiumOrderLogisticGuideMutationVariables = {
  input: DeletePremiumOrderLogisticGuideInput,
  condition?: ModelPremiumOrderLogisticGuideConditionInput | null,
};

export type DeletePremiumOrderLogisticGuideMutation = {
  deletePremiumOrderLogisticGuide?:  {
    __typename: "PremiumOrderLogisticGuide",
    id: string,
    type: LogisticGuideType,
    pakmailId?: string | null,
    premiumOrderId: string,
    clientId: string,
    creatorId: string,
    originAddressId?: string | null,
    destinationAddressId?: string | null,
    originAddress?: string | null,
    destinationAddress?: string | null,
    products?:  Array< {
      __typename: "LogisticGuideProduct",
      indexProduct: number,
      productId: string,
      quantity: number,
      unitWidth: number,
      unitHeight: number,
      unitDepth: number,
      unitWeight: number,
    } | null > | null,
    price?: number | null,
    increment?: number | null,
    fee?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateProductLabelItemMutationVariables = {
  input: CreateProductLabelItemInput,
  condition?: ModelProductLabelItemConditionInput | null,
};

export type CreateProductLabelItemMutation = {
  createProductLabelItem?:  {
    __typename: "ProductLabelItem",
    id: string,
    productId?: string | null,
    productLabelId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateProductLabelItemMutationVariables = {
  input: UpdateProductLabelItemInput,
  condition?: ModelProductLabelItemConditionInput | null,
};

export type UpdateProductLabelItemMutation = {
  updateProductLabelItem?:  {
    __typename: "ProductLabelItem",
    id: string,
    productId?: string | null,
    productLabelId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteProductLabelItemMutationVariables = {
  input: DeleteProductLabelItemInput,
  condition?: ModelProductLabelItemConditionInput | null,
};

export type DeleteProductLabelItemMutation = {
  deleteProductLabelItem?:  {
    __typename: "ProductLabelItem",
    id: string,
    productId?: string | null,
    productLabelId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateProductLabelMutationVariables = {
  input: CreateProductLabelInput,
  condition?: ModelProductLabelConditionInput | null,
};

export type CreateProductLabelMutation = {
  createProductLabel?:  {
    __typename: "ProductLabel",
    id: string,
    name?: string | null,
    translation?: string | null,
    status?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateProductLabelMutationVariables = {
  input: UpdateProductLabelInput,
  condition?: ModelProductLabelConditionInput | null,
};

export type UpdateProductLabelMutation = {
  updateProductLabel?:  {
    __typename: "ProductLabel",
    id: string,
    name?: string | null,
    translation?: string | null,
    status?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteProductLabelMutationVariables = {
  input: DeleteProductLabelInput,
  condition?: ModelProductLabelConditionInput | null,
};

export type DeleteProductLabelMutation = {
  deleteProductLabel?:  {
    __typename: "ProductLabel",
    id: string,
    name?: string | null,
    translation?: string | null,
    status?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateProductTextItemMutationVariables = {
  input: CreateProductTextItemInput,
  condition?: ModelProductTextItemConditionInput | null,
};

export type CreateProductTextItemMutation = {
  createProductTextItem?:  {
    __typename: "ProductTextItem",
    id: string,
    productId?: string | null,
    productTextId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateProductTextItemMutationVariables = {
  input: UpdateProductTextItemInput,
  condition?: ModelProductTextItemConditionInput | null,
};

export type UpdateProductTextItemMutation = {
  updateProductTextItem?:  {
    __typename: "ProductTextItem",
    id: string,
    productId?: string | null,
    productTextId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteProductTextItemMutationVariables = {
  input: DeleteProductTextItemInput,
  condition?: ModelProductTextItemConditionInput | null,
};

export type DeleteProductTextItemMutation = {
  deleteProductTextItem?:  {
    __typename: "ProductTextItem",
    id: string,
    productId?: string | null,
    productTextId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateProductTextMutationVariables = {
  input: CreateProductTextInput,
  condition?: ModelProductTextConditionInput | null,
};

export type CreateProductTextMutation = {
  createProductText?:  {
    __typename: "ProductText",
    id: string,
    name?: string | null,
    status?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateProductTextMutationVariables = {
  input: UpdateProductTextInput,
  condition?: ModelProductTextConditionInput | null,
};

export type UpdateProductTextMutation = {
  updateProductText?:  {
    __typename: "ProductText",
    id: string,
    name?: string | null,
    status?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteProductTextMutationVariables = {
  input: DeleteProductTextInput,
  condition?: ModelProductTextConditionInput | null,
};

export type DeleteProductTextMutation = {
  deleteProductText?:  {
    __typename: "ProductText",
    id: string,
    name?: string | null,
    status?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateProductMaskMutationVariables = {
  input: CreateProductMaskInput,
  condition?: ModelProductMaskConditionInput | null,
};

export type CreateProductMaskMutation = {
  createProductMask?:  {
    __typename: "ProductMask",
    id: string,
    name?: string | null,
    sku?: string | null,
    productId?: string | null,
    clientId?: string | null,
    filterColors?: Array< string | null > | null,
    mainImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    increment?: number | null,
    fee?: number | null,
    discount?: number | null,
    stock?: number | null,
    categoryId?: string | null,
    sellMode?: ProductMaskSellMode | null,
    kitPieces?: number | null,
    kitIncrement?: number | null,
    kitFee?: number | null,
    stockMode?: ProductMaskStockMode | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateProductMaskMutationVariables = {
  input: UpdateProductMaskInput,
  condition?: ModelProductMaskConditionInput | null,
};

export type UpdateProductMaskMutation = {
  updateProductMask?:  {
    __typename: "ProductMask",
    id: string,
    name?: string | null,
    sku?: string | null,
    productId?: string | null,
    clientId?: string | null,
    filterColors?: Array< string | null > | null,
    mainImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    increment?: number | null,
    fee?: number | null,
    discount?: number | null,
    stock?: number | null,
    categoryId?: string | null,
    sellMode?: ProductMaskSellMode | null,
    kitPieces?: number | null,
    kitIncrement?: number | null,
    kitFee?: number | null,
    stockMode?: ProductMaskStockMode | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteProductMaskMutationVariables = {
  input: DeleteProductMaskInput,
  condition?: ModelProductMaskConditionInput | null,
};

export type DeleteProductMaskMutation = {
  deleteProductMask?:  {
    __typename: "ProductMask",
    id: string,
    name?: string | null,
    sku?: string | null,
    productId?: string | null,
    clientId?: string | null,
    filterColors?: Array< string | null > | null,
    mainImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    increment?: number | null,
    fee?: number | null,
    discount?: number | null,
    stock?: number | null,
    categoryId?: string | null,
    sellMode?: ProductMaskSellMode | null,
    kitPieces?: number | null,
    kitIncrement?: number | null,
    kitFee?: number | null,
    stockMode?: ProductMaskStockMode | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateVariantMaskMutationVariables = {
  input: CreateVariantMaskInput,
  condition?: ModelVariantMaskConditionInput | null,
};

export type CreateVariantMaskMutation = {
  createVariantMask?:  {
    __typename: "VariantMask",
    id: string,
    filterColors?: Array< string | null > | null,
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    stock?: number | null,
    stockMode?: VariantMaskStockMode | null,
    productMaskId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateVariantMaskMutationVariables = {
  input: UpdateVariantMaskInput,
  condition?: ModelVariantMaskConditionInput | null,
};

export type UpdateVariantMaskMutation = {
  updateVariantMask?:  {
    __typename: "VariantMask",
    id: string,
    filterColors?: Array< string | null > | null,
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    stock?: number | null,
    stockMode?: VariantMaskStockMode | null,
    productMaskId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteVariantMaskMutationVariables = {
  input: DeleteVariantMaskInput,
  condition?: ModelVariantMaskConditionInput | null,
};

export type DeleteVariantMaskMutation = {
  deleteVariantMask?:  {
    __typename: "VariantMask",
    id: string,
    filterColors?: Array< string | null > | null,
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    stock?: number | null,
    stockMode?: VariantMaskStockMode | null,
    productMaskId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateProductMaskDescriptionMutationVariables = {
  input: CreateProductMaskDescriptionInput,
  condition?: ModelProductMaskDescriptionConditionInput | null,
};

export type CreateProductMaskDescriptionMutation = {
  createProductMaskDescription?:  {
    __typename: "ProductMaskDescription",
    id: string,
    long_description?: string | null,
    short_description?: string | null,
    productDescriptionItem?:  Array< {
      __typename: "ProductDescriptionItem",
      index?: number | null,
      status?: boolean | null,
      key?: string | null,
      description?: string | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateProductMaskDescriptionMutationVariables = {
  input: UpdateProductMaskDescriptionInput,
  condition?: ModelProductMaskDescriptionConditionInput | null,
};

export type UpdateProductMaskDescriptionMutation = {
  updateProductMaskDescription?:  {
    __typename: "ProductMaskDescription",
    id: string,
    long_description?: string | null,
    short_description?: string | null,
    productDescriptionItem?:  Array< {
      __typename: "ProductDescriptionItem",
      index?: number | null,
      status?: boolean | null,
      key?: string | null,
      description?: string | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteProductMaskDescriptionMutationVariables = {
  input: DeleteProductMaskDescriptionInput,
  condition?: ModelProductMaskDescriptionConditionInput | null,
};

export type DeleteProductMaskDescriptionMutation = {
  deleteProductMaskDescription?:  {
    __typename: "ProductMaskDescription",
    id: string,
    long_description?: string | null,
    short_description?: string | null,
    productDescriptionItem?:  Array< {
      __typename: "ProductDescriptionItem",
      index?: number | null,
      status?: boolean | null,
      key?: string | null,
      description?: string | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateCouponMutationVariables = {
  input: CreateCouponInput,
  condition?: ModelCouponConditionInput | null,
};

export type CreateCouponMutation = {
  createCoupon?:  {
    __typename: "Coupon",
    id: string,
    code: string,
    name: string,
    description?: string | null,
    discountAmount?: number | null,
    discountPercentage?: number | null,
    minAmount?: number | null,
    maxAmount?: number | null,
    startDate: string,
    endDate: string,
    maxRedemptions?: number | null,
    maxRedemptionsPerUser?: number | null,
    applicableProducts?: Array< string | null > | null,
    applicableCategories?: Array< string | null > | null,
    excludedProducts?: Array< string | null > | null,
    status: string,
    createdBy: string,
    redemptions?:  {
      __typename: "ModelCouponRedemptionConnection",
      items:  Array< {
        __typename: "CouponRedemption",
        id: string,
        couponId: string,
        couponCode: string,
        userId: string,
        clientId?: string | null,
        orderId?: string | null,
        cartId?: string | null,
        discountApplied: number,
        originalAmount: number,
        finalAmount: number,
        appliedAt: string,
        ipAddress?: string | null,
        userAgent?: string | null,
        coupon:  {
          __typename: "Coupon",
          id: string,
          code: string,
          name: string,
          description?: string | null,
          discountAmount?: number | null,
          discountPercentage?: number | null,
          minAmount?: number | null,
          maxAmount?: number | null,
          startDate: string,
          endDate: string,
          maxRedemptions?: number | null,
          maxRedemptionsPerUser?: number | null,
          applicableProducts?: Array< string | null > | null,
          applicableCategories?: Array< string | null > | null,
          excludedProducts?: Array< string | null > | null,
          status: string,
          createdBy: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCouponMutationVariables = {
  input: UpdateCouponInput,
  condition?: ModelCouponConditionInput | null,
};

export type UpdateCouponMutation = {
  updateCoupon?:  {
    __typename: "Coupon",
    id: string,
    code: string,
    name: string,
    description?: string | null,
    discountAmount?: number | null,
    discountPercentage?: number | null,
    minAmount?: number | null,
    maxAmount?: number | null,
    startDate: string,
    endDate: string,
    maxRedemptions?: number | null,
    maxRedemptionsPerUser?: number | null,
    applicableProducts?: Array< string | null > | null,
    applicableCategories?: Array< string | null > | null,
    excludedProducts?: Array< string | null > | null,
    status: string,
    createdBy: string,
    redemptions?:  {
      __typename: "ModelCouponRedemptionConnection",
      items:  Array< {
        __typename: "CouponRedemption",
        id: string,
        couponId: string,
        couponCode: string,
        userId: string,
        clientId?: string | null,
        orderId?: string | null,
        cartId?: string | null,
        discountApplied: number,
        originalAmount: number,
        finalAmount: number,
        appliedAt: string,
        ipAddress?: string | null,
        userAgent?: string | null,
        coupon:  {
          __typename: "Coupon",
          id: string,
          code: string,
          name: string,
          description?: string | null,
          discountAmount?: number | null,
          discountPercentage?: number | null,
          minAmount?: number | null,
          maxAmount?: number | null,
          startDate: string,
          endDate: string,
          maxRedemptions?: number | null,
          maxRedemptionsPerUser?: number | null,
          applicableProducts?: Array< string | null > | null,
          applicableCategories?: Array< string | null > | null,
          excludedProducts?: Array< string | null > | null,
          status: string,
          createdBy: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCouponMutationVariables = {
  input: DeleteCouponInput,
  condition?: ModelCouponConditionInput | null,
};

export type DeleteCouponMutation = {
  deleteCoupon?:  {
    __typename: "Coupon",
    id: string,
    code: string,
    name: string,
    description?: string | null,
    discountAmount?: number | null,
    discountPercentage?: number | null,
    minAmount?: number | null,
    maxAmount?: number | null,
    startDate: string,
    endDate: string,
    maxRedemptions?: number | null,
    maxRedemptionsPerUser?: number | null,
    applicableProducts?: Array< string | null > | null,
    applicableCategories?: Array< string | null > | null,
    excludedProducts?: Array< string | null > | null,
    status: string,
    createdBy: string,
    redemptions?:  {
      __typename: "ModelCouponRedemptionConnection",
      items:  Array< {
        __typename: "CouponRedemption",
        id: string,
        couponId: string,
        couponCode: string,
        userId: string,
        clientId?: string | null,
        orderId?: string | null,
        cartId?: string | null,
        discountApplied: number,
        originalAmount: number,
        finalAmount: number,
        appliedAt: string,
        ipAddress?: string | null,
        userAgent?: string | null,
        coupon:  {
          __typename: "Coupon",
          id: string,
          code: string,
          name: string,
          description?: string | null,
          discountAmount?: number | null,
          discountPercentage?: number | null,
          minAmount?: number | null,
          maxAmount?: number | null,
          startDate: string,
          endDate: string,
          maxRedemptions?: number | null,
          maxRedemptionsPerUser?: number | null,
          applicableProducts?: Array< string | null > | null,
          applicableCategories?: Array< string | null > | null,
          excludedProducts?: Array< string | null > | null,
          status: string,
          createdBy: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCouponRedemptionMutationVariables = {
  input: CreateCouponRedemptionInput,
  condition?: ModelCouponRedemptionConditionInput | null,
};

export type CreateCouponRedemptionMutation = {
  createCouponRedemption?:  {
    __typename: "CouponRedemption",
    id: string,
    couponId: string,
    couponCode: string,
    userId: string,
    clientId?: string | null,
    orderId?: string | null,
    cartId?: string | null,
    discountApplied: number,
    originalAmount: number,
    finalAmount: number,
    appliedAt: string,
    ipAddress?: string | null,
    userAgent?: string | null,
    coupon:  {
      __typename: "Coupon",
      id: string,
      code: string,
      name: string,
      description?: string | null,
      discountAmount?: number | null,
      discountPercentage?: number | null,
      minAmount?: number | null,
      maxAmount?: number | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      applicableProducts?: Array< string | null > | null,
      applicableCategories?: Array< string | null > | null,
      excludedProducts?: Array< string | null > | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelCouponRedemptionConnection",
        items:  Array< {
          __typename: "CouponRedemption",
          id: string,
          couponId: string,
          couponCode: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          discountApplied: number,
          originalAmount: number,
          finalAmount: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCouponRedemptionMutationVariables = {
  input: UpdateCouponRedemptionInput,
  condition?: ModelCouponRedemptionConditionInput | null,
};

export type UpdateCouponRedemptionMutation = {
  updateCouponRedemption?:  {
    __typename: "CouponRedemption",
    id: string,
    couponId: string,
    couponCode: string,
    userId: string,
    clientId?: string | null,
    orderId?: string | null,
    cartId?: string | null,
    discountApplied: number,
    originalAmount: number,
    finalAmount: number,
    appliedAt: string,
    ipAddress?: string | null,
    userAgent?: string | null,
    coupon:  {
      __typename: "Coupon",
      id: string,
      code: string,
      name: string,
      description?: string | null,
      discountAmount?: number | null,
      discountPercentage?: number | null,
      minAmount?: number | null,
      maxAmount?: number | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      applicableProducts?: Array< string | null > | null,
      applicableCategories?: Array< string | null > | null,
      excludedProducts?: Array< string | null > | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelCouponRedemptionConnection",
        items:  Array< {
          __typename: "CouponRedemption",
          id: string,
          couponId: string,
          couponCode: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          discountApplied: number,
          originalAmount: number,
          finalAmount: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCouponRedemptionMutationVariables = {
  input: DeleteCouponRedemptionInput,
  condition?: ModelCouponRedemptionConditionInput | null,
};

export type DeleteCouponRedemptionMutation = {
  deleteCouponRedemption?:  {
    __typename: "CouponRedemption",
    id: string,
    couponId: string,
    couponCode: string,
    userId: string,
    clientId?: string | null,
    orderId?: string | null,
    cartId?: string | null,
    discountApplied: number,
    originalAmount: number,
    finalAmount: number,
    appliedAt: string,
    ipAddress?: string | null,
    userAgent?: string | null,
    coupon:  {
      __typename: "Coupon",
      id: string,
      code: string,
      name: string,
      description?: string | null,
      discountAmount?: number | null,
      discountPercentage?: number | null,
      minAmount?: number | null,
      maxAmount?: number | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      applicableProducts?: Array< string | null > | null,
      applicableCategories?: Array< string | null > | null,
      excludedProducts?: Array< string | null > | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelCouponRedemptionConnection",
        items:  Array< {
          __typename: "CouponRedemption",
          id: string,
          couponId: string,
          couponCode: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          discountApplied: number,
          originalAmount: number,
          finalAmount: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePromotionMutationVariables = {
  input: CreatePromotionInput,
  condition?: ModelPromotionConditionInput | null,
};

export type CreatePromotionMutation = {
  createPromotion?:  {
    __typename: "Promotion",
    id: string,
    name: string,
    description?: string | null,
    triggerProductIds: Array< string | null >,
    minQuantity: number,
    minAmount?: number | null,
    triggerRule: PromotionTriggerRule,
    giftProductId: string,
    giftQuantity: number,
    isStackable?: boolean | null,
    applicableClientIds?: Array< string | null > | null,
    startDate: string,
    endDate: string,
    maxRedemptions?: number | null,
    maxRedemptionsPerUser?: number | null,
    status: string,
    createdBy: string,
    redemptions?:  {
      __typename: "ModelPromotionRedemptionConnection",
      items:  Array< {
        __typename: "PromotionRedemption",
        id: string,
        promotionId: string,
        userId: string,
        clientId?: string | null,
        orderId?: string | null,
        cartId?: string | null,
        triggerQuantity: number,
        giftQuantityApplied: number,
        appliedAt: string,
        ipAddress?: string | null,
        userAgent?: string | null,
        promotion:  {
          __typename: "Promotion",
          id: string,
          name: string,
          description?: string | null,
          triggerProductIds: Array< string | null >,
          minQuantity: number,
          minAmount?: number | null,
          triggerRule: PromotionTriggerRule,
          giftProductId: string,
          giftQuantity: number,
          isStackable?: boolean | null,
          applicableClientIds?: Array< string | null > | null,
          startDate: string,
          endDate: string,
          maxRedemptions?: number | null,
          maxRedemptionsPerUser?: number | null,
          status: string,
          createdBy: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePromotionMutationVariables = {
  input: UpdatePromotionInput,
  condition?: ModelPromotionConditionInput | null,
};

export type UpdatePromotionMutation = {
  updatePromotion?:  {
    __typename: "Promotion",
    id: string,
    name: string,
    description?: string | null,
    triggerProductIds: Array< string | null >,
    minQuantity: number,
    minAmount?: number | null,
    triggerRule: PromotionTriggerRule,
    giftProductId: string,
    giftQuantity: number,
    isStackable?: boolean | null,
    applicableClientIds?: Array< string | null > | null,
    startDate: string,
    endDate: string,
    maxRedemptions?: number | null,
    maxRedemptionsPerUser?: number | null,
    status: string,
    createdBy: string,
    redemptions?:  {
      __typename: "ModelPromotionRedemptionConnection",
      items:  Array< {
        __typename: "PromotionRedemption",
        id: string,
        promotionId: string,
        userId: string,
        clientId?: string | null,
        orderId?: string | null,
        cartId?: string | null,
        triggerQuantity: number,
        giftQuantityApplied: number,
        appliedAt: string,
        ipAddress?: string | null,
        userAgent?: string | null,
        promotion:  {
          __typename: "Promotion",
          id: string,
          name: string,
          description?: string | null,
          triggerProductIds: Array< string | null >,
          minQuantity: number,
          minAmount?: number | null,
          triggerRule: PromotionTriggerRule,
          giftProductId: string,
          giftQuantity: number,
          isStackable?: boolean | null,
          applicableClientIds?: Array< string | null > | null,
          startDate: string,
          endDate: string,
          maxRedemptions?: number | null,
          maxRedemptionsPerUser?: number | null,
          status: string,
          createdBy: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePromotionMutationVariables = {
  input: DeletePromotionInput,
  condition?: ModelPromotionConditionInput | null,
};

export type DeletePromotionMutation = {
  deletePromotion?:  {
    __typename: "Promotion",
    id: string,
    name: string,
    description?: string | null,
    triggerProductIds: Array< string | null >,
    minQuantity: number,
    minAmount?: number | null,
    triggerRule: PromotionTriggerRule,
    giftProductId: string,
    giftQuantity: number,
    isStackable?: boolean | null,
    applicableClientIds?: Array< string | null > | null,
    startDate: string,
    endDate: string,
    maxRedemptions?: number | null,
    maxRedemptionsPerUser?: number | null,
    status: string,
    createdBy: string,
    redemptions?:  {
      __typename: "ModelPromotionRedemptionConnection",
      items:  Array< {
        __typename: "PromotionRedemption",
        id: string,
        promotionId: string,
        userId: string,
        clientId?: string | null,
        orderId?: string | null,
        cartId?: string | null,
        triggerQuantity: number,
        giftQuantityApplied: number,
        appliedAt: string,
        ipAddress?: string | null,
        userAgent?: string | null,
        promotion:  {
          __typename: "Promotion",
          id: string,
          name: string,
          description?: string | null,
          triggerProductIds: Array< string | null >,
          minQuantity: number,
          minAmount?: number | null,
          triggerRule: PromotionTriggerRule,
          giftProductId: string,
          giftQuantity: number,
          isStackable?: boolean | null,
          applicableClientIds?: Array< string | null > | null,
          startDate: string,
          endDate: string,
          maxRedemptions?: number | null,
          maxRedemptionsPerUser?: number | null,
          status: string,
          createdBy: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePromotionRedemptionMutationVariables = {
  input: CreatePromotionRedemptionInput,
  condition?: ModelPromotionRedemptionConditionInput | null,
};

export type CreatePromotionRedemptionMutation = {
  createPromotionRedemption?:  {
    __typename: "PromotionRedemption",
    id: string,
    promotionId: string,
    userId: string,
    clientId?: string | null,
    orderId?: string | null,
    cartId?: string | null,
    triggerQuantity: number,
    giftQuantityApplied: number,
    appliedAt: string,
    ipAddress?: string | null,
    userAgent?: string | null,
    promotion:  {
      __typename: "Promotion",
      id: string,
      name: string,
      description?: string | null,
      triggerProductIds: Array< string | null >,
      minQuantity: number,
      minAmount?: number | null,
      triggerRule: PromotionTriggerRule,
      giftProductId: string,
      giftQuantity: number,
      isStackable?: boolean | null,
      applicableClientIds?: Array< string | null > | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelPromotionRedemptionConnection",
        items:  Array< {
          __typename: "PromotionRedemption",
          id: string,
          promotionId: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          triggerQuantity: number,
          giftQuantityApplied: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePromotionRedemptionMutationVariables = {
  input: UpdatePromotionRedemptionInput,
  condition?: ModelPromotionRedemptionConditionInput | null,
};

export type UpdatePromotionRedemptionMutation = {
  updatePromotionRedemption?:  {
    __typename: "PromotionRedemption",
    id: string,
    promotionId: string,
    userId: string,
    clientId?: string | null,
    orderId?: string | null,
    cartId?: string | null,
    triggerQuantity: number,
    giftQuantityApplied: number,
    appliedAt: string,
    ipAddress?: string | null,
    userAgent?: string | null,
    promotion:  {
      __typename: "Promotion",
      id: string,
      name: string,
      description?: string | null,
      triggerProductIds: Array< string | null >,
      minQuantity: number,
      minAmount?: number | null,
      triggerRule: PromotionTriggerRule,
      giftProductId: string,
      giftQuantity: number,
      isStackable?: boolean | null,
      applicableClientIds?: Array< string | null > | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelPromotionRedemptionConnection",
        items:  Array< {
          __typename: "PromotionRedemption",
          id: string,
          promotionId: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          triggerQuantity: number,
          giftQuantityApplied: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePromotionRedemptionMutationVariables = {
  input: DeletePromotionRedemptionInput,
  condition?: ModelPromotionRedemptionConditionInput | null,
};

export type DeletePromotionRedemptionMutation = {
  deletePromotionRedemption?:  {
    __typename: "PromotionRedemption",
    id: string,
    promotionId: string,
    userId: string,
    clientId?: string | null,
    orderId?: string | null,
    cartId?: string | null,
    triggerQuantity: number,
    giftQuantityApplied: number,
    appliedAt: string,
    ipAddress?: string | null,
    userAgent?: string | null,
    promotion:  {
      __typename: "Promotion",
      id: string,
      name: string,
      description?: string | null,
      triggerProductIds: Array< string | null >,
      minQuantity: number,
      minAmount?: number | null,
      triggerRule: PromotionTriggerRule,
      giftProductId: string,
      giftQuantity: number,
      isStackable?: boolean | null,
      applicableClientIds?: Array< string | null > | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelPromotionRedemptionConnection",
        items:  Array< {
          __typename: "PromotionRedemption",
          id: string,
          promotionId: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          triggerQuantity: number,
          giftQuantityApplied: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateWalletBalanceMutationVariables = {
  input: CreateWalletBalanceInput,
  condition?: ModelWalletBalanceConditionInput | null,
};

export type CreateWalletBalanceMutation = {
  createWalletBalance?:  {
    __typename: "WalletBalance",
    id: string,
    balance?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type UpdateWalletBalanceMutationVariables = {
  input: UpdateWalletBalanceInput,
  condition?: ModelWalletBalanceConditionInput | null,
};

export type UpdateWalletBalanceMutation = {
  updateWalletBalance?:  {
    __typename: "WalletBalance",
    id: string,
    balance?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type DeleteWalletBalanceMutationVariables = {
  input: DeleteWalletBalanceInput,
  condition?: ModelWalletBalanceConditionInput | null,
};

export type DeleteWalletBalanceMutation = {
  deleteWalletBalance?:  {
    __typename: "WalletBalance",
    id: string,
    balance?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type CreateWalletMovementMutationVariables = {
  input: CreateWalletMovementInput,
  condition?: ModelWalletMovementConditionInput | null,
};

export type CreateWalletMovementMutation = {
  createWalletMovement?:  {
    __typename: "WalletMovement",
    id: string,
    userId: string,
    type: WalletMovementType,
    amount: number,
    orderId?: string | null,
    createdByUserId?: string | null,
    couponId?: string | null,
    couponCode?: string | null,
    availableUntil?: string | null,
    isValidated?: boolean | null,
    validatedAt?: string | null,
    validatedBy?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateWalletMovementMutationVariables = {
  input: UpdateWalletMovementInput,
  condition?: ModelWalletMovementConditionInput | null,
};

export type UpdateWalletMovementMutation = {
  updateWalletMovement?:  {
    __typename: "WalletMovement",
    id: string,
    userId: string,
    type: WalletMovementType,
    amount: number,
    orderId?: string | null,
    createdByUserId?: string | null,
    couponId?: string | null,
    couponCode?: string | null,
    availableUntil?: string | null,
    isValidated?: boolean | null,
    validatedAt?: string | null,
    validatedBy?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteWalletMovementMutationVariables = {
  input: DeleteWalletMovementInput,
  condition?: ModelWalletMovementConditionInput | null,
};

export type DeleteWalletMovementMutation = {
  deleteWalletMovement?:  {
    __typename: "WalletMovement",
    id: string,
    userId: string,
    type: WalletMovementType,
    amount: number,
    orderId?: string | null,
    createdByUserId?: string | null,
    couponId?: string | null,
    couponCode?: string | null,
    availableUntil?: string | null,
    isValidated?: boolean | null,
    validatedAt?: string | null,
    validatedBy?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type GetClientQueryVariables = {
  id: string,
};

export type GetClientQuery = {
  getClient?:  {
    __typename: "Client",
    id: string,
    status?: boolean | null,
    business_name: string,
    comertial_name: string,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    grayLogo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    contact?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    biography?: string | null,
    plan?: string | null,
    fee?: number | null,
    increment?: number | null,
    mercadoFee?: number | null,
    mercadoIncrement?: number | null,
    popFee?: number | null,
    popIncrement?: number | null,
    printedFee?: number | null,
    printedIncrement?: number | null,
    users?: Array< string | null > | null,
    restrictedUsers?: Array< string | null > | null,
    nonRestrictedUsers?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    providers?: Array< string | null > | null,
    popProviders?: Array< string | null > | null,
    printedProviders?: Array< string | null > | null,
    logisticFrequency?: number | null,
    agents?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    administrators?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    signDocument?:  Array< {
      __typename: "Sign",
      url?: string | null,
      enabled?: boolean | null,
    } | null > | null,
    legal_representative?: string | null,
    legal_representative_email?: string | null,
    legal_representative_address?: string | null,
    tcdUsers?: Array< string | null > | null,
    billingUsers?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type ListClientsQueryVariables = {
  filter?: ModelClientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListClientsQuery = {
  listClients?:  {
    __typename: "ModelClientConnection",
    items:  Array< {
      __typename: "Client",
      id: string,
      status?: boolean | null,
      business_name: string,
      comertial_name: string,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      biography?: string | null,
      plan?: string | null,
      fee?: number | null,
      increment?: number | null,
      mercadoFee?: number | null,
      mercadoIncrement?: number | null,
      popFee?: number | null,
      popIncrement?: number | null,
      printedFee?: number | null,
      printedIncrement?: number | null,
      users?: Array< string | null > | null,
      restrictedUsers?: Array< string | null > | null,
      nonRestrictedUsers?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      popProviders?: Array< string | null > | null,
      printedProviders?: Array< string | null > | null,
      logisticFrequency?: number | null,
      agents?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      administrators?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      signDocument?:  Array< {
        __typename: "Sign",
        url?: string | null,
        enabled?: boolean | null,
      } | null > | null,
      legal_representative?: string | null,
      legal_representative_email?: string | null,
      legal_representative_address?: string | null,
      tcdUsers?: Array< string | null > | null,
      billingUsers?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetClientSettingQueryVariables = {
  id: string,
};

export type GetClientSettingQuery = {
  getClientSetting?:  {
    __typename: "ClientSetting",
    id: string,
    crmJiraId?: string | null,
    orderBudget?: number | null,
    domain?: string | null,
    filterColors?: Array< string | null > | null,
    primaryColors?: Array< string | null > | null,
    accentColors?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListClientSettingsQueryVariables = {
  filter?: ModelClientSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListClientSettingsQuery = {
  listClientSettings?:  {
    __typename: "ModelClientSettingConnection",
    items:  Array< {
      __typename: "ClientSetting",
      id: string,
      crmJiraId?: string | null,
      orderBudget?: number | null,
      domain?: string | null,
      filterColors?: Array< string | null > | null,
      primaryColors?: Array< string | null > | null,
      accentColors?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetClientOptionQueryVariables = {
  id: string,
};

export type GetClientOptionQuery = {
  getClientOption?:  {
    __typename: "ClientOption",
    id: string,
    pakmail?: boolean | null,
    orderVat?: boolean | null,
    hasMercado?: boolean | null,
    hasAmazon?: boolean | null,
    hasAutomobiles?: boolean | null,
    publicDashboards?: boolean | null,
    printPrices?: boolean | null,
    logisticPrices?: boolean | null,
    hidePricesAndFlow?: boolean | null,
    showPhones?: boolean | null,
    fullCoupaDescriptions?: boolean | null,
    isPremium?: boolean | null,
    isPop?: boolean | null,
    isPrinted?: boolean | null,
    allPremiumRfqs?: boolean | null,
    allPopRfqs?: boolean | null,
    allPrintedRfqs?: boolean | null,
    autoUpdateHomePage?: boolean | null,
    showVat?: boolean | null,
    requiredDeliveryInfo?: boolean | null,
    restrictedCatalogue?: boolean | null,
    excludeCoupa?: boolean | null,
    tcdPayment?: boolean | null,
    automaticLogisticGuides?: boolean | null,
    transferencePayment?: boolean | null,
    customCatalogue?: boolean | null,
    disableProjectDescriptions?: boolean | null,
    showBranding?: boolean | null,
    customCostCenter?: boolean | null,
    couponsEnabled?: boolean | null,
    showChat?: boolean | null,
    hasCrmSync?: boolean | null,
    onlyQuotes?: boolean | null,
    autoSaveDeliveryInfo?: boolean | null,
    limitMaxRequestOnDiscounts?: boolean | null,
    freeLocalShipping?: boolean | null,
    discountShipping?: boolean | null,
    printingBreakdown?: boolean | null,
    skipAlendum?: boolean | null,
    skipFMS?: boolean | null,
    clientReminders?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListClientOptionsQueryVariables = {
  filter?: ModelClientOptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListClientOptionsQuery = {
  listClientOptions?:  {
    __typename: "ModelClientOptionConnection",
    items:  Array< {
      __typename: "ClientOption",
      id: string,
      pakmail?: boolean | null,
      orderVat?: boolean | null,
      hasMercado?: boolean | null,
      hasAmazon?: boolean | null,
      hasAutomobiles?: boolean | null,
      publicDashboards?: boolean | null,
      printPrices?: boolean | null,
      logisticPrices?: boolean | null,
      hidePricesAndFlow?: boolean | null,
      showPhones?: boolean | null,
      fullCoupaDescriptions?: boolean | null,
      isPremium?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      allPremiumRfqs?: boolean | null,
      allPopRfqs?: boolean | null,
      allPrintedRfqs?: boolean | null,
      autoUpdateHomePage?: boolean | null,
      showVat?: boolean | null,
      requiredDeliveryInfo?: boolean | null,
      restrictedCatalogue?: boolean | null,
      excludeCoupa?: boolean | null,
      tcdPayment?: boolean | null,
      automaticLogisticGuides?: boolean | null,
      transferencePayment?: boolean | null,
      customCatalogue?: boolean | null,
      disableProjectDescriptions?: boolean | null,
      showBranding?: boolean | null,
      customCostCenter?: boolean | null,
      couponsEnabled?: boolean | null,
      showChat?: boolean | null,
      hasCrmSync?: boolean | null,
      onlyQuotes?: boolean | null,
      autoSaveDeliveryInfo?: boolean | null,
      limitMaxRequestOnDiscounts?: boolean | null,
      freeLocalShipping?: boolean | null,
      discountShipping?: boolean | null,
      printingBreakdown?: boolean | null,
      skipAlendum?: boolean | null,
      skipFMS?: boolean | null,
      clientReminders?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProviderQueryVariables = {
  id: string,
};

export type GetProviderQuery = {
  getProvider?:  {
    __typename: "Provider",
    id: string,
    isApproved?: boolean | null,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    grayLogo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comertial_name?: string | null,
    bussiness_name?:  {
      __typename: "BusinessName",
      tax_residence?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      rfc?: string | null,
      name?: string | null,
    } | null,
    idProcter?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    contact?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null,
    biography?: string | null,
    constancia?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comprobante?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    experience?: string | null,
    pros?: Array< string | null > | null,
    cons?: Array< string | null > | null,
    cte_rating?:  Array< {
      __typename: "Rating",
      name?: string | null,
      rating?: number | null,
    } | null > | null,
    shopping_rating?:  Array< {
      __typename: "Rating",
      name?: string | null,
      rating?: number | null,
    } | null > | null,
    video?: string | null,
    tags?: Array< string | null > | null,
    money_filter_c?: boolean | null,
    money_filter_d?: boolean | null,
    users?: Array< string | null > | null,
    bank?: string | null,
    account?: string | null,
    clabe?: string | null,
    cuenta_correo?: string | null,
    edocuenta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    ife?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    poderes?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    acta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    isProvider?: boolean | null,
    sameAddress?: boolean | null,
    isPop?: boolean | null,
    isPrinted?: boolean | null,
    hasLogistic?: boolean | null,
    created?: number | null,
    updated?: number | null,
    addFiles?:  Array< {
      __typename: "SignFile",
      key?: string | null,
      url?: string | null,
      sign?: string | null,
      status?: string | null,
    } | null > | null,
    signFiles?:  Array< {
      __typename: "SignFile",
      key?: string | null,
      url?: string | null,
      sign?: string | null,
      status?: string | null,
    } | null > | null,
    representante_legal?: string | null,
    escritura_constitucion?: string | null,
    notario_a?: string | null,
    constituido_down_edo?: string | null,
    rrpp?: string | null,
    isPremium?: boolean | null,
    isTrustProvider?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListProvidersQueryVariables = {
  filter?: ModelProviderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProvidersQuery = {
  listProviders?:  {
    __typename: "ModelProviderConnection",
    items:  Array< {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProviderSettingQueryVariables = {
  id: string,
};

export type GetProviderSettingQuery = {
  getProviderSetting?:  {
    __typename: "ProviderSetting",
    id: string,
    primaryColors?: Array< string | null > | null,
    accentColors?: Array< string | null > | null,
    categories?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListProviderSettingsQueryVariables = {
  filter?: ModelProviderSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProviderSettingsQuery = {
  listProviderSettings?:  {
    __typename: "ModelProviderSettingConnection",
    items:  Array< {
      __typename: "ProviderSetting",
      id: string,
      primaryColors?: Array< string | null > | null,
      accentColors?: Array< string | null > | null,
      categories?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProviderFileQueryVariables = {
  id: string,
};

export type GetProviderFileQuery = {
  getProviderFile?:  {
    __typename: "ProviderFile",
    id: string,
    acta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    constancia?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comprobante?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    edocuenta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    ife?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    poderes?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListProviderFilesQueryVariables = {
  filter?: ModelProviderFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProviderFilesQuery = {
  listProviderFiles?:  {
    __typename: "ModelProviderFileConnection",
    items:  Array< {
      __typename: "ProviderFile",
      id: string,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetColorsQueryVariables = {
  id: string,
};

export type GetColorsQuery = {
  getColors?:  {
    __typename: "Colors",
    id: string,
    status: string,
    name: string,
    rgb: string,
    hex: string,
    position?: number | null,
    variantNames?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListColorsQueryVariables = {
  filter?: ModelColorsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListColorsQuery = {
  listColors?:  {
    __typename: "ModelColorsConnection",
    items:  Array< {
      __typename: "Colors",
      id: string,
      status: string,
      name: string,
      rgb: string,
      hex: string,
      position?: number | null,
      variantNames?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetHomePageCarouselBannerQueryVariables = {
  id: string,
};

export type GetHomePageCarouselBannerQuery = {
  getHomePageCarouselBanner?:  {
    __typename: "HomePageCarouselBanner",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    title?: string | null,
    subtitle?: string | null,
    copy?: string | null,
    path?: string | null,
    bgImage?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    position?: number | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListHomePageCarouselBannersQueryVariables = {
  filter?: ModelHomePageCarouselBannerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHomePageCarouselBannersQuery = {
  listHomePageCarouselBanners?:  {
    __typename: "ModelHomePageCarouselBannerConnection",
    items:  Array< {
      __typename: "HomePageCarouselBanner",
      id: string,
      status?: boolean | null,
      isPublic?: boolean | null,
      title?: string | null,
      subtitle?: string | null,
      copy?: string | null,
      path?: string | null,
      bgImage?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      position?: number | null,
      visibleFor?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetHomePageQueryVariables = {
  id: string,
};

export type GetHomePageQuery = {
  getHomePage?:  {
    __typename: "HomePage",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    showArrow?: boolean | null,
    showNumeration?: boolean | null,
    icon?: string | null,
    title?: string | null,
    subtitle?: string | null,
    body?: string | null,
    route?: string | null,
    titlePosition?: string | null,
    textAlign?: string | null,
    bgImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bgColor?: string | null,
    borderColor?: string | null,
    textColor?: string | null,
    position?: number | null,
    verticalLine?: boolean | null,
    browseButton?: boolean | null,
    visibleFor?: Array< string | null > | null,
    visibleForUserBrand?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListHomePagesQueryVariables = {
  filter?: ModelHomePageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHomePagesQuery = {
  listHomePages?:  {
    __typename: "ModelHomePageConnection",
    items:  Array< {
      __typename: "HomePage",
      id: string,
      status?: boolean | null,
      isPublic?: boolean | null,
      showArrow?: boolean | null,
      showNumeration?: boolean | null,
      icon?: string | null,
      title?: string | null,
      subtitle?: string | null,
      body?: string | null,
      route?: string | null,
      titlePosition?: string | null,
      textAlign?: string | null,
      bgImage?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      bgColor?: string | null,
      borderColor?: string | null,
      textColor?: string | null,
      position?: number | null,
      verticalLine?: boolean | null,
      browseButton?: boolean | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetHomePageBottomBannerQueryVariables = {
  id: string,
};

export type GetHomePageBottomBannerQuery = {
  getHomePageBottomBanner?:  {
    __typename: "HomePageBottomBanner",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    title?: string | null,
    subtitle?: string | null,
    icon?: string | null,
    route?: string | null,
    showArrow?: boolean | null,
    bannerImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bgColor?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListHomePageBottomBannersQueryVariables = {
  filter?: ModelHomePageBottomBannerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHomePageBottomBannersQuery = {
  listHomePageBottomBanners?:  {
    __typename: "ModelHomePageBottomBannerConnection",
    items:  Array< {
      __typename: "HomePageBottomBanner",
      id: string,
      status?: boolean | null,
      isPublic?: boolean | null,
      title?: string | null,
      subtitle?: string | null,
      icon?: string | null,
      route?: string | null,
      showArrow?: boolean | null,
      bannerImage?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      bgColor?: string | null,
      visibleFor?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProductoQueryVariables = {
  id: string,
};

export type GetProductoQuery = {
  getProducto?:  {
    __typename: "Producto",
    id: string,
    providerId: string,
    categoryId: string,
    name: string,
    status?: string | null,
    bestSeller?: string | null,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    order?: number | null,
    sku: string,
    brand?: string | null,
    colors?: Array< string | null > | null,
    pgClasitication?: string | null,
    delivery_time?: string | null,
    delivery_time_units?: string | null,
    stock?: number | null,
    minRequest?: number | null,
    maxRequest?: number | null,
    article_of_clothing?: boolean | null,
    size?: string | null,
    price: number,
    long_description: string,
    short_description: string,
    creator?: string | null,
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    category:  {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    },
    isExternal?: boolean | null,
    isAllowable?: boolean | null,
    isRestricted?: boolean | null,
    isAutoSkipped?: string | null,
    isAutoAllowed?: string | null,
    isPurse?: boolean | null,
    massiveLayout?: string | null,
    hasBaseAmmount?: boolean | null,
    isFreeAmmount?: boolean | null,
    isCard?: boolean | null,
    isByRequest?: boolean | null,
    isMultiPrice?: boolean | null,
    cardBaseAmmount?: number | null,
    minCardBaseAmmount?: number | null,
    maxCardBaseAmmount?: number | null,
    nameExternal?: string | null,
    unspsc?: string | null,
    variants?:  Array< {
      __typename: "Variants",
      sku?: string | null,
      name?: string | null,
      description?: string | null,
      colors?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock_available?: number | null,
      price?: number | null,
      size?: string | null,
      logoType?: string | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientIncrementPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    productDescriptionItem?:  Array< {
      __typename: "ProductDescriptionItem",
      index?: number | null,
      status?: boolean | null,
      key?: string | null,
      description?: string | null,
    } | null > | null,
    source?: string | null,
    trazoProductId?: string | null,
    trazoCategoryId?: string | null,
    stockUpdatedAt?: string | null,
    priceUpdatedAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListProductosQueryVariables = {
  filter?: ModelProductoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProductosQuery = {
  listProductos?:  {
    __typename: "ModelProductoConnection",
    items:  Array< {
      __typename: "Producto",
      id: string,
      providerId: string,
      categoryId: string,
      name: string,
      status?: string | null,
      bestSeller?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      order?: number | null,
      sku: string,
      brand?: string | null,
      colors?: Array< string | null > | null,
      pgClasitication?: string | null,
      delivery_time?: string | null,
      delivery_time_units?: string | null,
      stock?: number | null,
      minRequest?: number | null,
      maxRequest?: number | null,
      article_of_clothing?: boolean | null,
      size?: string | null,
      price: number,
      long_description: string,
      short_description: string,
      creator?: string | null,
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      category:  {
        __typename: "Category",
        id: string,
        name: string,
        description?: string | null,
        unspsc?: string | null,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        imageMobile?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        visibleForUserBrand?: Array< string | null > | null,
        region?: Array< string | null > | null,
        tags?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        hasAllowables?: boolean | null,
        hasPreapproveds?: boolean | null,
        hasRestricted?: boolean | null,
        isPublic?: boolean | null,
        isTop?: boolean | null,
        createdAt?: string | null,
        slug?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        path?: string | null,
        status?: string | null,
        pathIds?: Array< string | null > | null,
        source?: string | null,
        trazoCategoryId?: string | null,
        nameExternal?: string | null,
        depth?: number | null,
        childrenCount?: number | null,
        isLeaf?: boolean | null,
        oldVersion?: string | null,
        productLine?: string | null,
        updatedAt: string,
      },
      isExternal?: boolean | null,
      isAllowable?: boolean | null,
      isRestricted?: boolean | null,
      isAutoSkipped?: string | null,
      isAutoAllowed?: string | null,
      isPurse?: boolean | null,
      massiveLayout?: string | null,
      hasBaseAmmount?: boolean | null,
      isFreeAmmount?: boolean | null,
      isCard?: boolean | null,
      isByRequest?: boolean | null,
      isMultiPrice?: boolean | null,
      cardBaseAmmount?: number | null,
      minCardBaseAmmount?: number | null,
      maxCardBaseAmmount?: number | null,
      nameExternal?: string | null,
      unspsc?: string | null,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientIncrementPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      productDescriptionItem?:  Array< {
        __typename: "ProductDescriptionItem",
        index?: number | null,
        status?: boolean | null,
        key?: string | null,
        description?: string | null,
      } | null > | null,
      source?: string | null,
      trazoProductId?: string | null,
      trazoCategoryId?: string | null,
      stockUpdatedAt?: string | null,
      priceUpdatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProductVariantQueryVariables = {
  id: string,
};

export type GetProductVariantQuery = {
  getProductVariant?:  {
    __typename: "ProductVariant",
    id: string,
    productId?: string | null,
    sku?: string | null,
    name?: string | null,
    description?: string | null,
    colors?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    image?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    stock_available?: number | null,
    price?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListProductVariantsQueryVariables = {
  filter?: ModelProductVariantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProductVariantsQuery = {
  listProductVariants?:  {
    __typename: "ModelProductVariantConnection",
    items:  Array< {
      __typename: "ProductVariant",
      id: string,
      productId?: string | null,
      sku?: string | null,
      name?: string | null,
      description?: string | null,
      colors?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock_available?: number | null,
      price?: number | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProductOptionQueryVariables = {
  id: string,
};

export type GetProductOptionQuery = {
  getProductOption?:  {
    __typename: "ProductOption",
    id: string,
    ownOrder?: string | null,
    isPangga?: string | null,
    volumetricWeight?: string | null,
    isEvaluated?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListProductOptionsQueryVariables = {
  filter?: ModelProductOptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProductOptionsQuery = {
  listProductOptions?:  {
    __typename: "ModelProductOptionConnection",
    items:  Array< {
      __typename: "ProductOption",
      id: string,
      ownOrder?: string | null,
      isPangga?: string | null,
      volumetricWeight?: string | null,
      isEvaluated?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProductDimentionQueryVariables = {
  id: string,
};

export type GetProductDimentionQuery = {
  getProductDimention?:  {
    __typename: "ProductDimention",
    id: string,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    weight?: number | null,
    boxWidth?: number | null,
    boxHeight?: number | null,
    boxDepth?: number | null,
    boxWeight?: number | null,
    boxQuantity?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListProductDimentionsQueryVariables = {
  filter?: ModelProductDimentionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProductDimentionsQuery = {
  listProductDimentions?:  {
    __typename: "ModelProductDimentionConnection",
    items:  Array< {
      __typename: "ProductDimention",
      id: string,
      width?: number | null,
      height?: number | null,
      depth?: number | null,
      weight?: number | null,
      boxWidth?: number | null,
      boxHeight?: number | null,
      boxDepth?: number | null,
      boxWeight?: number | null,
      boxQuantity?: number | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMassiveChangeLayoutsQueryVariables = {
  id: string,
};

export type GetMassiveChangeLayoutsQuery = {
  getMassiveChangeLayouts?:  {
    __typename: "MassiveChangeLayouts",
    id: string,
    type?: string | null,
    status?: string | null,
    providerId?: string | null,
    creatorId?: string | null,
    creatorRole?: string | null,
    productsNumber?: number | null,
    file?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListMassiveChangeLayoutsQueryVariables = {
  filter?: ModelMassiveChangeLayoutsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMassiveChangeLayoutsQuery = {
  listMassiveChangeLayouts?:  {
    __typename: "ModelMassiveChangeLayoutsConnection",
    items:  Array< {
      __typename: "MassiveChangeLayouts",
      id: string,
      type?: string | null,
      status?: string | null,
      providerId?: string | null,
      creatorId?: string | null,
      creatorRole?: string | null,
      productsNumber?: number | null,
      file?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCategoryQueryVariables = {
  id: string,
};

export type GetCategoryQuery = {
  getCategory?:  {
    __typename: "Category",
    id: string,
    name: string,
    description?: string | null,
    unspsc?: string | null,
    image:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    },
    imageMobile?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    visibleForUserBrand?: Array< string | null > | null,
    region?: Array< string | null > | null,
    tags?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    hasAllowables?: boolean | null,
    hasPreapproveds?: boolean | null,
    hasRestricted?: boolean | null,
    isPublic?: boolean | null,
    isTop?: boolean | null,
    createdAt?: string | null,
    slug?: string | null,
    parentId?: string | null,
    rootId?: string | null,
    path?: string | null,
    status?: string | null,
    pathIds?: Array< string | null > | null,
    source?: string | null,
    trazoCategoryId?: string | null,
    nameExternal?: string | null,
    depth?: number | null,
    childrenCount?: number | null,
    isLeaf?: boolean | null,
    oldVersion?: string | null,
    productLine?: string | null,
    updatedAt: string,
  } | null,
};

export type ListCategoriesQueryVariables = {
  filter?: ModelCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCategoriesQuery = {
  listCategories?:  {
    __typename: "ModelCategoryConnection",
    items:  Array< {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProductBrandQueryVariables = {
  id: string,
};

export type GetProductBrandQuery = {
  getProductBrand?:  {
    __typename: "ProductBrand",
    id: string,
    name: string,
    status?: string | null,
    description?: string | null,
    route: string,
    unspsc?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    hasAllowables?: boolean | null,
    hasPreapproveds?: boolean | null,
    hasRestricted?: boolean | null,
    isTop?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListProductBrandsQueryVariables = {
  filter?: ModelProductBrandFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProductBrandsQuery = {
  listProductBrands?:  {
    __typename: "ModelProductBrandConnection",
    items:  Array< {
      __typename: "ProductBrand",
      id: string,
      name: string,
      status?: string | null,
      description?: string | null,
      route: string,
      unspsc?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCartQueryVariables = {
  id: string,
};

export type GetCartQuery = {
  getCart?:  {
    __typename: "Cart",
    id: string,
    requirement?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    products:  Array< {
      __typename: "ProductInOrder",
      product_id: string,
      provider_id?: string | null,
      index?: number | null,
      print?: number | null,
      printPrice?: number | null,
      product_name: string,
      description?: string | null,
      category?: string | null,
      unspsc?: string | null,
      price?: number | null,
      originalPrice?: number | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      sample_authorize?: boolean | null,
      sample_authorized?: boolean | null,
      quality_requested?: boolean | null,
      quality_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      isExternal?: boolean | null,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      sku?: string | null,
      qualityForm?:  {
        __typename: "ProductInOrderQualityPGForm",
        initiativeDescription?: string | null,
        targetUser?: string | null,
        retailBrandName?: string | null,
        itemCategory?: string | null,
        itemPicture?: string | null,
        originCountry?: string | null,
        quantityPerCountryOfDist?: string | null,
        initiativeDates?: string | null,
        isPartOfAnMSOCustOrSpecPack?: string | null,
        incluesClientLogo?: string | null,
        isAReorderWithinTwelveMonths?: string | null,
        isReorder?: string | null,
        PGPLContactName?: string | null,
        ulTracking?: string | null,
        PLContactName?: string | null,
        contactEmailAddress?: string | null,
        PGPurchaseOrderNumber?: string | null,
        EBBSorSupplierProvidedProjectNumber?: string | null,
        vendorCompanyName?: string | null,
        vendorContactName?: string | null,
        vendorEmailAddress?: string | null,
        vendorJobTitle?: string | null,
        vendorTelephone?: string | null,
        vendorMailingAddress?: string | null,
        vendorCity?: string | null,
        vendorState?: string | null,
        vendorCountry?: string | null,
        vendorPC?: string | null,
        physicalItemDescription?: string | null,
        SampleOrMaterialComponentSubmitted?: string | null,
        toWhom?: string | null,
        descriptionOfItemPackagingAndArtwork?: string | null,
        regulatoryAndLegislativeProductCertification?: string | null,
        dateFinalApprovalRequestedSubmittedToPG?: string | null,
        DateOfDeclarationOfConformity?: string | null,
        dateOfApprovalExpirationOfPremiumItem?: string | null,
        itemClasification?: string | null,
        PGRepresentativeMarketingDesign?: string | null,
        PGProjectLeaderRequestor?: string | null,
        PGRestrictedItemsLocalPGLegal?: string | null,
        PGLocalCategoryGM?: string | null,
        PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
        idProduct?: string | null,
        pathDocument?: string | null,
      } | null,
      fee?: number | null,
      increment?: number | null,
      discount?: number | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
    } >,
    creator: string,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCartsQueryVariables = {
  filter?: ModelCartFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCartsQuery = {
  listCarts?:  {
    __typename: "ModelCartConnection",
    items:  Array< {
      __typename: "Cart",
      id: string,
      requirement?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      products:  Array< {
        __typename: "ProductInOrder",
        product_id: string,
        provider_id?: string | null,
        index?: number | null,
        print?: number | null,
        printPrice?: number | null,
        product_name: string,
        description?: string | null,
        category?: string | null,
        unspsc?: string | null,
        price?: number | null,
        originalPrice?: number | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        sample_authorize?: boolean | null,
        sample_authorized?: boolean | null,
        quality_requested?: boolean | null,
        quality_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        isExternal?: boolean | null,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        sku?: string | null,
        qualityForm?:  {
          __typename: "ProductInOrderQualityPGForm",
          initiativeDescription?: string | null,
          targetUser?: string | null,
          retailBrandName?: string | null,
          itemCategory?: string | null,
          itemPicture?: string | null,
          originCountry?: string | null,
          quantityPerCountryOfDist?: string | null,
          initiativeDates?: string | null,
          isPartOfAnMSOCustOrSpecPack?: string | null,
          incluesClientLogo?: string | null,
          isAReorderWithinTwelveMonths?: string | null,
          isReorder?: string | null,
          PGPLContactName?: string | null,
          ulTracking?: string | null,
          PLContactName?: string | null,
          contactEmailAddress?: string | null,
          PGPurchaseOrderNumber?: string | null,
          EBBSorSupplierProvidedProjectNumber?: string | null,
          vendorCompanyName?: string | null,
          vendorContactName?: string | null,
          vendorEmailAddress?: string | null,
          vendorJobTitle?: string | null,
          vendorTelephone?: string | null,
          vendorMailingAddress?: string | null,
          vendorCity?: string | null,
          vendorState?: string | null,
          vendorCountry?: string | null,
          vendorPC?: string | null,
          physicalItemDescription?: string | null,
          SampleOrMaterialComponentSubmitted?: string | null,
          toWhom?: string | null,
          descriptionOfItemPackagingAndArtwork?: string | null,
          regulatoryAndLegislativeProductCertification?: string | null,
          dateFinalApprovalRequestedSubmittedToPG?: string | null,
          DateOfDeclarationOfConformity?: string | null,
          dateOfApprovalExpirationOfPremiumItem?: string | null,
          itemClasification?: string | null,
          PGRepresentativeMarketingDesign?: string | null,
          PGProjectLeaderRequestor?: string | null,
          PGRestrictedItemsLocalPGLegal?: string | null,
          PGLocalCategoryGM?: string | null,
          PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
          idProduct?: string | null,
          pathDocument?: string | null,
        } | null,
        fee?: number | null,
        increment?: number | null,
        discount?: number | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        sellMode?: ProductMaskSellMode | null,
        kitPieces?: number | null,
      } >,
      creator: string,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    name: string,
    role: string,
    email: string,
    jiraId?: string | null,
    phoneNumber?: string | null,
    avatar?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    companyId?: string | null,
    brandId?: string | null,
    failedLogins?: number | null,
    agents?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    notificationsOf?: Array< string | null > | null,
    status?: boolean | null,
    isLogistic?: boolean | null,
    isCoupa?: boolean | null,
    isManagement?: boolean | null,
    isAdministration?: boolean | null,
    hasNotifications?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      name: string,
      role: string,
      email: string,
      jiraId?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      companyId?: string | null,
      brandId?: string | null,
      failedLogins?: number | null,
      agents?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      notificationsOf?: Array< string | null > | null,
      status?: boolean | null,
      isLogistic?: boolean | null,
      isCoupa?: boolean | null,
      isManagement?: boolean | null,
      isAdministration?: boolean | null,
      hasNotifications?: boolean | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAutomobileQueryVariables = {
  id: string,
};

export type GetAutomobileQuery = {
  getAutomobile?:  {
    __typename: "Automobile",
    id: string,
    clientId?: string | null,
    status?: boolean | null,
    bought?: boolean | null,
    buyerId?: string | null,
    buyerName?: string | null,
    price: number,
    brand: string,
    brandId?: string | null,
    model?: string | null,
    version: string,
    year: number,
    color?: string | null,
    km: number,
    transmission?: string | null,
    motor?: string | null,
    passengers?: number | null,
    state: string,
    objeto?: string | null,
    placa?: string | null,
    serialNumber?: string | null,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    star_time?: number | null,
    end_time?: number | null,
    usersInteresting?:  Array< {
      __typename: "ListUsers",
      iduser?: string | null,
      nombre?: string | null,
      email?: string | null,
      fecha_compra?: string | null,
      veces_rechazo?: string | null,
      winner?: boolean | null,
      fecha_notificacion?: string | null,
      buyer?: boolean | null,
      process_buyer?: boolean | null,
      d_winner_date?: number | null,
      created?: number | null,
    } | null > | null,
    comentario?: string | null,
    penalizacion?: string | null,
    haveWinner?: boolean | null,
    ppostulacion?: boolean | null,
    logsGanadoresAutos?:  {
      __typename: "ModelLogGanadorAutoConnection",
      items:  Array< {
        __typename: "LogGanadorAuto",
        id: string,
        id_auto?: string | null,
        id_user?: string | null,
        fecha_rifa?: number | null,
        email?: string | null,
        nombre?: string | null,
        a_paterno?: string | null,
        a_materno?: string | null,
        status_buyer?: boolean | null,
        date_buyer?: number | null,
        winner?: number | null,
        refused?: number | null,
        since?: string | null,
        process_buyer?: boolean | null,
        reactive?: boolean | null,
        created: number,
        updated?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAutomobilesQueryVariables = {
  filter?: ModelAutomobileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAutomobilesQuery = {
  listAutomobiles?:  {
    __typename: "ModelAutomobileConnection",
    items:  Array< {
      __typename: "Automobile",
      id: string,
      clientId?: string | null,
      status?: boolean | null,
      bought?: boolean | null,
      buyerId?: string | null,
      buyerName?: string | null,
      price: number,
      brand: string,
      brandId?: string | null,
      model?: string | null,
      version: string,
      year: number,
      color?: string | null,
      km: number,
      transmission?: string | null,
      motor?: string | null,
      passengers?: number | null,
      state: string,
      objeto?: string | null,
      placa?: string | null,
      serialNumber?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      star_time?: number | null,
      end_time?: number | null,
      usersInteresting?:  Array< {
        __typename: "ListUsers",
        iduser?: string | null,
        nombre?: string | null,
        email?: string | null,
        fecha_compra?: string | null,
        veces_rechazo?: string | null,
        winner?: boolean | null,
        fecha_notificacion?: string | null,
        buyer?: boolean | null,
        process_buyer?: boolean | null,
        d_winner_date?: number | null,
        created?: number | null,
      } | null > | null,
      comentario?: string | null,
      penalizacion?: string | null,
      haveWinner?: boolean | null,
      ppostulacion?: boolean | null,
      logsGanadoresAutos?:  {
        __typename: "ModelLogGanadorAutoConnection",
        items:  Array< {
          __typename: "LogGanadorAuto",
          id: string,
          id_auto?: string | null,
          id_user?: string | null,
          fecha_rifa?: number | null,
          email?: string | null,
          nombre?: string | null,
          a_paterno?: string | null,
          a_materno?: string | null,
          status_buyer?: boolean | null,
          date_buyer?: number | null,
          winner?: number | null,
          refused?: number | null,
          since?: string | null,
          process_buyer?: boolean | null,
          reactive?: boolean | null,
          created: number,
          updated?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBrandQueryVariables = {
  id: string,
};

export type GetBrandQuery = {
  getBrand?:  {
    __typename: "Brand",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBrandsQueryVariables = {
  filter?: ModelBrandFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBrandsQuery = {
  listBrands?:  {
    __typename: "ModelBrandConnection",
    items:  Array< {
      __typename: "Brand",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRfqQueryVariables = {
  id: string,
};

export type GetRfqQuery = {
  getRfq?:  {
    __typename: "Rfq",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    proposals?:  {
      __typename: "ModelProposalsConnection",
      items:  Array< {
        __typename: "Proposals",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        priceUnit?: number | null,
        pieces?: number | null,
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "Rfq",
          id: string,
          nombre: string,
          requerimiento: string,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          orderAgentIds?: Array< string | null > | null,
          premiumOrderId?: string | null,
          estatus: string,
          orderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
          multipleProducts?: boolean | null,
          providers?: Array< string | null > | null,
        } | null,
        proposalsRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    premiumOrderId?: string | null,
    estatus: string,
    orderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    multipleProducts?: boolean | null,
    providers?: Array< string | null > | null,
    productsRfq?:  Array< {
      __typename: "ProductUnitRfq",
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
  } | null,
};

export type ListRfqsQueryVariables = {
  filter?: ModelRfqFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRfqsQuery = {
  listRfqs?:  {
    __typename: "ModelRfqConnection",
    items:  Array< {
      __typename: "Rfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsConnection",
        items:  Array< {
          __typename: "Proposals",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      premiumOrderId?: string | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRfqAmazonQueryVariables = {
  id: string,
};

export type GetRfqAmazonQuery = {
  getRfqAmazon?:  {
    __typename: "RfqAmazon",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    proposals?:  {
      __typename: "ModelProposalsAmazonConnection",
      items:  Array< {
        __typename: "ProposalsAmazon",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        priceUnit?: number | null,
        pieces?: number | null,
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "RfqAmazon",
          id: string,
          nombre: string,
          requerimiento: string,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          estatus: string,
          orderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
          multipleProducts?: boolean | null,
          providers?: Array< string | null > | null,
        } | null,
        proposalsRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    estatus: string,
    orderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    multipleProducts?: boolean | null,
    providers?: Array< string | null > | null,
    productsRfq?:  Array< {
      __typename: "ProductUnitRfq",
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
  } | null,
};

export type ListRfqAmazonsQueryVariables = {
  filter?: ModelRfqAmazonFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRfqAmazonsQuery = {
  listRfqAmazons?:  {
    __typename: "ModelRfqAmazonConnection",
    items:  Array< {
      __typename: "RfqAmazon",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsAmazonConnection",
        items:  Array< {
          __typename: "ProposalsAmazon",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProposalsQueryVariables = {
  id: string,
};

export type GetProposalsQuery = {
  getProposals?:  {
    __typename: "Proposals",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    priceUnit?: number | null,
    pieces?: number | null,
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "Rfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsConnection",
        items:  Array< {
          __typename: "Proposals",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      premiumOrderId?: string | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null,
    proposalsRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListProposalsQueryVariables = {
  filter?: ModelProposalsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProposalsQuery = {
  listProposals?:  {
    __typename: "ModelProposalsConnection",
    items:  Array< {
      __typename: "Proposals",
      id: string,
      provider_id: string,
      delivery_time:  {
        __typename: "Range",
        lower: number,
        upper: number,
      },
      priceUnit?: number | null,
      pieces?: number | null,
      price: number,
      validity_days?: number | null,
      description?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      created: number,
      updated?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      products?:  Array< {
        __typename: "ProductsProposals",
        productUnitRfqIndex?: number | null,
        selected?: boolean | null,
        name?: string | null,
        description?: string | null,
        priceUnit?: number | null,
        pieces?: number | null,
        total?: number | null,
        idProducto?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
      } | null > | null,
      multipleProducts?: boolean | null,
      hidden?: boolean | null,
      rfq?:  {
        __typename: "Rfq",
        id: string,
        nombre: string,
        requerimiento: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        compras?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        cantidad: number,
        limit_time: number,
        proposals?:  {
          __typename: "ModelProposalsConnection",
          nextToken?: string | null,
        } | null,
        creator?: string | null,
        creatorInfo?:  {
          __typename: "OrderCreator",
          name: string,
          email: string,
          user_id: string,
        } | null,
        clientId: string,
        winner?:  {
          __typename: "Winner",
          proveeedor_id: string,
          date: number,
        } | null,
        logs?:  Array< {
          __typename: "Logs",
          creatorId: string,
          description: string,
          date: number,
          status?: string | null,
          provider_id?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        orderAgents?:  Array< {
          __typename: "OrderAgent",
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
          user_id?: string | null,
        } | null > | null,
        orderAgentIds?: Array< string | null > | null,
        premiumOrderId?: string | null,
        estatus: string,
        orderId?: number | null,
        start_time: number,
        delivery_time?: number | null,
        created: number,
        saving?: number | null,
        saving_percentage?: number | null,
        saving_real?: number | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        updated?: number | null,
        multipleProducts?: boolean | null,
        providers?: Array< string | null > | null,
        productsRfq?:  Array< {
          __typename: "ProductUnitRfq",
          name?: string | null,
          description?: string | null,
          pieces?: number | null,
          createdId?: number | null,
        } | null > | null,
      } | null,
      proposalsRfqId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProposalsAmazonQueryVariables = {
  id: string,
};

export type GetProposalsAmazonQuery = {
  getProposalsAmazon?:  {
    __typename: "ProposalsAmazon",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    priceUnit?: number | null,
    pieces?: number | null,
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "RfqAmazon",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsAmazonConnection",
        items:  Array< {
          __typename: "ProposalsAmazon",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null,
    proposalsRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListProposalsAmazonsQueryVariables = {
  filter?: ModelProposalsAmazonFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProposalsAmazonsQuery = {
  listProposalsAmazons?:  {
    __typename: "ModelProposalsAmazonConnection",
    items:  Array< {
      __typename: "ProposalsAmazon",
      id: string,
      provider_id: string,
      delivery_time:  {
        __typename: "Range",
        lower: number,
        upper: number,
      },
      priceUnit?: number | null,
      pieces?: number | null,
      price: number,
      validity_days?: number | null,
      description?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      created: number,
      updated?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      products?:  Array< {
        __typename: "ProductsProposals",
        productUnitRfqIndex?: number | null,
        selected?: boolean | null,
        name?: string | null,
        description?: string | null,
        priceUnit?: number | null,
        pieces?: number | null,
        total?: number | null,
        idProducto?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
      } | null > | null,
      multipleProducts?: boolean | null,
      hidden?: boolean | null,
      rfq?:  {
        __typename: "RfqAmazon",
        id: string,
        nombre: string,
        requerimiento: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        compras?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        cantidad: number,
        limit_time: number,
        proposals?:  {
          __typename: "ModelProposalsAmazonConnection",
          nextToken?: string | null,
        } | null,
        creator?: string | null,
        creatorInfo?:  {
          __typename: "OrderCreator",
          name: string,
          email: string,
          user_id: string,
        } | null,
        clientId: string,
        winner?:  {
          __typename: "Winner",
          proveeedor_id: string,
          date: number,
        } | null,
        logs?:  Array< {
          __typename: "Logs",
          creatorId: string,
          description: string,
          date: number,
          status?: string | null,
          provider_id?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        estatus: string,
        orderId?: number | null,
        start_time: number,
        delivery_time?: number | null,
        created: number,
        saving?: number | null,
        saving_percentage?: number | null,
        saving_real?: number | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        updated?: number | null,
        multipleProducts?: boolean | null,
        providers?: Array< string | null > | null,
        productsRfq?:  Array< {
          __typename: "ProductUnitRfq",
          name?: string | null,
          description?: string | null,
          pieces?: number | null,
          createdId?: number | null,
        } | null > | null,
      } | null,
      proposalsRfqId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProductoRfqQueryVariables = {
  id: string,
};

export type GetProductoRfqQuery = {
  getProductoRfq?:  {
    __typename: "ProductoRfq",
    id: string,
    name: string,
    request: string,
    category_id: string,
    provider_id: string,
    price?: number | null,
    category?:  {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    } | null,
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    estatus?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListProductoRfqsQueryVariables = {
  filter?: ModelProductoRfqFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProductoRfqsQuery = {
  listProductoRfqs?:  {
    __typename: "ModelProductoRfqConnection",
    items:  Array< {
      __typename: "ProductoRfq",
      id: string,
      name: string,
      request: string,
      category_id: string,
      provider_id: string,
      price?: number | null,
      category?:  {
        __typename: "Category",
        id: string,
        name: string,
        description?: string | null,
        unspsc?: string | null,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        imageMobile?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        visibleForUserBrand?: Array< string | null > | null,
        region?: Array< string | null > | null,
        tags?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        hasAllowables?: boolean | null,
        hasPreapproveds?: boolean | null,
        hasRestricted?: boolean | null,
        isPublic?: boolean | null,
        isTop?: boolean | null,
        createdAt?: string | null,
        slug?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        path?: string | null,
        status?: string | null,
        pathIds?: Array< string | null > | null,
        source?: string | null,
        trazoCategoryId?: string | null,
        nameExternal?: string | null,
        depth?: number | null,
        childrenCount?: number | null,
        isLeaf?: boolean | null,
        oldVersion?: string | null,
        productLine?: string | null,
        updatedAt: string,
      } | null,
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      images?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      estatus?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOrderProvidersQueryVariables = {
  id: string,
};

export type GetOrderProvidersQuery = {
  getOrderProviders?:  {
    __typename: "OrderProviders",
    id: string,
    provider_id: string,
    clientId?: string | null,
    orderId?: number | null,
    orderProvidersPremiumOrderId: string,
    payment_date?: number | null,
    gr_code?: string | null,
    invoice?: boolean | null,
    invoiceRequested?: boolean | null,
    uploadedGr?: boolean | null,
    uploadedBill?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListOrderProvidersQueryVariables = {
  filter?: ModelOrderProvidersFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrderProvidersQuery = {
  listOrderProviders?:  {
    __typename: "ModelOrderProvidersConnection",
    items:  Array< {
      __typename: "OrderProviders",
      id: string,
      provider_id: string,
      clientId?: string | null,
      orderId?: number | null,
      orderProvidersPremiumOrderId: string,
      payment_date?: number | null,
      gr_code?: string | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPopMaterialQueryVariables = {
  id: string,
};

export type GetPopMaterialQuery = {
  getPopMaterial?:  {
    __typename: "PopMaterial",
    id: string,
    name: string,
    route: string,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    year?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPopMaterialsQueryVariables = {
  filter?: ModelPopMaterialFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPopMaterialsQuery = {
  listPopMaterials?:  {
    __typename: "ModelPopMaterialConnection",
    items:  Array< {
      __typename: "PopMaterial",
      id: string,
      name: string,
      route: string,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      year?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetVehicleTypeQueryVariables = {
  id: string,
};

export type GetVehicleTypeQuery = {
  getVehicleType?:  {
    __typename: "VehicleType",
    id: string,
    name: string,
    popMaterialId: string,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    popMaterial?:  {
      __typename: "PopMaterial",
      id: string,
      name: string,
      route: string,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      year?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListVehicleTypesQueryVariables = {
  filter?: ModelVehicleTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVehicleTypesQuery = {
  listVehicleTypes?:  {
    __typename: "ModelVehicleTypeConnection",
    items:  Array< {
      __typename: "VehicleType",
      id: string,
      name: string,
      popMaterialId: string,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      popMaterial?:  {
        __typename: "PopMaterial",
        id: string,
        name: string,
        route: string,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        year?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetVehicleQueryVariables = {
  id: string,
};

export type GetVehicleQuery = {
  getVehicle?:  {
    __typename: "Vehicle",
    id: string,
    status?: string | null,
    isSustainable?: boolean | null,
    multiProvider?: boolean | null,
    itemName?: string | null,
    bestSeller?: string | null,
    name: string,
    brand: string,
    channel: string,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    description: string,
    size: string,
    materialDetail?: string | null,
    print?: string | null,
    finish?: string | null,
    packaging?: string | null,
    quantity: number,
    unitPrice: number,
    prototypePrice: number,
    productionTime: string,
    vehicleTypeId: string,
    popMaterialId: string,
    popCategoryId?: string | null,
    providerId: string,
    isRfq?: boolean | null,
    historicCost?: string | null,
    historicTime?: string | null,
    contact?: string | null,
    providerName?: string | null,
    variantsUnits?:  Array< {
      __typename: "VariantsUnits",
      min_units?: number | null,
      max_units?: number | null,
      price?: number | null,
      production_time?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    providers?: Array< string | null > | null,
    massiveLayout?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListVehiclesQueryVariables = {
  filter?: ModelVehicleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVehiclesQuery = {
  listVehicles?:  {
    __typename: "ModelVehicleConnection",
    items:  Array< {
      __typename: "Vehicle",
      id: string,
      status?: string | null,
      isSustainable?: boolean | null,
      multiProvider?: boolean | null,
      itemName?: string | null,
      bestSeller?: string | null,
      name: string,
      brand: string,
      channel: string,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      description: string,
      size: string,
      materialDetail?: string | null,
      print?: string | null,
      finish?: string | null,
      packaging?: string | null,
      quantity: number,
      unitPrice: number,
      prototypePrice: number,
      productionTime: string,
      vehicleTypeId: string,
      popMaterialId: string,
      popCategoryId?: string | null,
      providerId: string,
      isRfq?: boolean | null,
      historicCost?: string | null,
      historicTime?: string | null,
      contact?: string | null,
      providerName?: string | null,
      variantsUnits?:  Array< {
        __typename: "VariantsUnits",
        min_units?: number | null,
        max_units?: number | null,
        price?: number | null,
        production_time?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      massiveLayout?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPopOrderQueryVariables = {
  id: string,
};

export type GetPopOrderQuery = {
  getPopOrder?:  {
    __typename: "PopOrder",
    id: string,
    estatus: string,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    orderId?: number | null,
    requirement?: string | null,
    budget?: number | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_time?: number | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    subtotal?: number | null,
    total?: number | null,
    isCoupa: boolean,
    sentToCoupa?: boolean | null,
    coupaOrder?: string | null,
    active?: string | null,
    vehicles?:  {
      __typename: "ModelPopOrderVehicleConnection",
      items:  Array< {
        __typename: "PopOrderVehicle",
        id: string,
        orderId: string,
        vehicleId: string,
        providerId: string,
        unitPrice: number,
        prototypePrice: number,
        quantity: number,
        approved: boolean,
        hasQrCode?: boolean | null,
        vehicle:  {
          __typename: "Vehicle",
          id: string,
          status?: string | null,
          isSustainable?: boolean | null,
          multiProvider?: boolean | null,
          itemName?: string | null,
          bestSeller?: string | null,
          name: string,
          brand: string,
          channel: string,
          description: string,
          size: string,
          materialDetail?: string | null,
          print?: string | null,
          finish?: string | null,
          packaging?: string | null,
          quantity: number,
          unitPrice: number,
          prototypePrice: number,
          productionTime: string,
          vehicleTypeId: string,
          popMaterialId: string,
          popCategoryId?: string | null,
          providerId: string,
          isRfq?: boolean | null,
          historicCost?: string | null,
          historicTime?: string | null,
          contact?: string | null,
          providerName?: string | null,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          providers?: Array< string | null > | null,
          massiveLayout?: string | null,
          created: number,
          updated?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        order:  {
          __typename: "PopOrder",
          id: string,
          estatus: string,
          orderId?: number | null,
          requirement?: string | null,
          budget?: number | null,
          delivery_cost?: number | null,
          delivery_time?: number | null,
          subtotal?: number | null,
          total?: number | null,
          isCoupa: boolean,
          sentToCoupa?: boolean | null,
          coupaOrder?: string | null,
          active?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          orderAgentIds?: Array< string | null > | null,
          gr?: string | null,
          orderCreatorId: string,
          prequoteApproved?: boolean | null,
          quoteApproved?: boolean | null,
          prototypeApproved?: boolean | null,
          samplesDocsUploaded?: boolean | null,
          samplesApproved?: boolean | null,
          auditRequired?: boolean | null,
          drivePath?: string | null,
          auditDocsUploaded?: boolean | null,
          deliveryDateRequested?: boolean | null,
          deliveryDate?: number | null,
          deliveryCode?: string | null,
          deliveryFilesUploaded?: boolean | null,
          deliveryDocsApproved?: boolean | null,
          grUploaded?: boolean | null,
          grApproved?: boolean | null,
          grCode?: string | null,
          qrCode?: boolean | null,
          brandfactoryCheck?: boolean | null,
          step?: number | null,
          prototype?: boolean | null,
          dateKickoff?: number | null,
          paymentDate?: number | null,
          currentProcess?: string | null,
          currentSubprocess?: string | null,
          clientId?: string | null,
        },
        provider:  {
          __typename: "Provider",
          id: string,
          isApproved?: boolean | null,
          comertial_name?: string | null,
          idProcter?: string | null,
          biography?: string | null,
          experience?: string | null,
          pros?: Array< string | null > | null,
          cons?: Array< string | null > | null,
          video?: string | null,
          tags?: Array< string | null > | null,
          money_filter_c?: boolean | null,
          money_filter_d?: boolean | null,
          users?: Array< string | null > | null,
          bank?: string | null,
          account?: string | null,
          clabe?: string | null,
          cuenta_correo?: string | null,
          isProvider?: boolean | null,
          sameAddress?: boolean | null,
          isPop?: boolean | null,
          isPrinted?: boolean | null,
          hasLogistic?: boolean | null,
          created?: number | null,
          updated?: number | null,
          representante_legal?: string | null,
          escritura_constitucion?: string | null,
          notario_a?: string | null,
          constituido_down_edo?: string | null,
          rrpp?: string | null,
          isPremium?: boolean | null,
          isTrustProvider?: boolean | null,
          createdAt: string,
          updatedAt: string,
        },
        sampleTestDate?: number | null,
        sampleTestDateApproved?: boolean | null,
        prototypeDate?: number | null,
        prototypeDateApproved?: boolean | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    gr?: string | null,
    orderCreatorId: string,
    providers?:  {
      __typename: "ModelPopOrderProviderConnection",
      items:  Array< {
        __typename: "PopOrderProvider",
        id: string,
        orderId: string,
        providerId: string,
        deliveryDateRequested?: boolean | null,
        grRequested?: boolean | null,
        invoiceUploaded?: boolean | null,
        order:  {
          __typename: "PopOrder",
          id: string,
          estatus: string,
          orderId?: number | null,
          requirement?: string | null,
          budget?: number | null,
          delivery_cost?: number | null,
          delivery_time?: number | null,
          subtotal?: number | null,
          total?: number | null,
          isCoupa: boolean,
          sentToCoupa?: boolean | null,
          coupaOrder?: string | null,
          active?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          orderAgentIds?: Array< string | null > | null,
          gr?: string | null,
          orderCreatorId: string,
          prequoteApproved?: boolean | null,
          quoteApproved?: boolean | null,
          prototypeApproved?: boolean | null,
          samplesDocsUploaded?: boolean | null,
          samplesApproved?: boolean | null,
          auditRequired?: boolean | null,
          drivePath?: string | null,
          auditDocsUploaded?: boolean | null,
          deliveryDateRequested?: boolean | null,
          deliveryDate?: number | null,
          deliveryCode?: string | null,
          deliveryFilesUploaded?: boolean | null,
          deliveryDocsApproved?: boolean | null,
          grUploaded?: boolean | null,
          grApproved?: boolean | null,
          grCode?: string | null,
          qrCode?: boolean | null,
          brandfactoryCheck?: boolean | null,
          step?: number | null,
          prototype?: boolean | null,
          dateKickoff?: number | null,
          paymentDate?: number | null,
          currentProcess?: string | null,
          currentSubprocess?: string | null,
          clientId?: string | null,
        },
        provider:  {
          __typename: "Provider",
          id: string,
          isApproved?: boolean | null,
          comertial_name?: string | null,
          idProcter?: string | null,
          biography?: string | null,
          experience?: string | null,
          pros?: Array< string | null > | null,
          cons?: Array< string | null > | null,
          video?: string | null,
          tags?: Array< string | null > | null,
          money_filter_c?: boolean | null,
          money_filter_d?: boolean | null,
          users?: Array< string | null > | null,
          bank?: string | null,
          account?: string | null,
          clabe?: string | null,
          cuenta_correo?: string | null,
          isProvider?: boolean | null,
          sameAddress?: boolean | null,
          isPop?: boolean | null,
          isPrinted?: boolean | null,
          hasLogistic?: boolean | null,
          created?: number | null,
          updated?: number | null,
          representante_legal?: string | null,
          escritura_constitucion?: string | null,
          notario_a?: string | null,
          constituido_down_edo?: string | null,
          rrpp?: string | null,
          isPremium?: boolean | null,
          isTrustProvider?: boolean | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    prequoteApproved?: boolean | null,
    quoteApproved?: boolean | null,
    prototypeApproved?: boolean | null,
    samplesDocsUploaded?: boolean | null,
    samplesApproved?: boolean | null,
    auditRequired?: boolean | null,
    drivePath?: string | null,
    auditDocsUploaded?: boolean | null,
    deliveryDateRequested?: boolean | null,
    deliveryDate?: number | null,
    deliveryCode?: string | null,
    deliveryFilesUploaded?: boolean | null,
    deliveryDocsApproved?: boolean | null,
    grUploaded?: boolean | null,
    grApproved?: boolean | null,
    grCode?: string | null,
    qrCode?: boolean | null,
    brandfactoryCheck?: boolean | null,
    step?: number | null,
    prototype?: boolean | null,
    dateKickoff?: number | null,
    paymentDate?: number | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    clientId?: string | null,
  } | null,
};

export type ListPopOrdersQueryVariables = {
  filter?: ModelPopOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPopOrdersQuery = {
  listPopOrders?:  {
    __typename: "ModelPopOrderConnection",
    items:  Array< {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOrderFileQueryVariables = {
  id: string,
};

export type GetOrderFileQuery = {
  getOrderFile?:  {
    __typename: "OrderFile",
    id: string,
    createdAt?: string | null,
    creatorId: string,
    orderId: string,
    key?: string | null,
    url?: string | null,
    orderStatus: string,
    updatedAt: string,
  } | null,
};

export type ListOrderFilesQueryVariables = {
  filter?: ModelOrderFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrderFilesQuery = {
  listOrderFiles?:  {
    __typename: "ModelOrderFileConnection",
    items:  Array< {
      __typename: "OrderFile",
      id: string,
      createdAt?: string | null,
      creatorId: string,
      orderId: string,
      key?: string | null,
      url?: string | null,
      orderStatus: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPopOrderVehicleQueryVariables = {
  id: string,
};

export type GetPopOrderVehicleQuery = {
  getPopOrderVehicle?:  {
    __typename: "PopOrderVehicle",
    id: string,
    orderId: string,
    vehicleId: string,
    providerId: string,
    unitPrice: number,
    prototypePrice: number,
    quantity: number,
    approved: boolean,
    hasQrCode?: boolean | null,
    vehicle:  {
      __typename: "Vehicle",
      id: string,
      status?: string | null,
      isSustainable?: boolean | null,
      multiProvider?: boolean | null,
      itemName?: string | null,
      bestSeller?: string | null,
      name: string,
      brand: string,
      channel: string,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      description: string,
      size: string,
      materialDetail?: string | null,
      print?: string | null,
      finish?: string | null,
      packaging?: string | null,
      quantity: number,
      unitPrice: number,
      prototypePrice: number,
      productionTime: string,
      vehicleTypeId: string,
      popMaterialId: string,
      popCategoryId?: string | null,
      providerId: string,
      isRfq?: boolean | null,
      historicCost?: string | null,
      historicTime?: string | null,
      contact?: string | null,
      providerName?: string | null,
      variantsUnits?:  Array< {
        __typename: "VariantsUnits",
        min_units?: number | null,
        max_units?: number | null,
        price?: number | null,
        production_time?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      massiveLayout?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    order:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    },
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    sampleTestDate?: number | null,
    sampleTestDateApproved?: boolean | null,
    prototypeDate?: number | null,
    prototypeDateApproved?: boolean | null,
    logs?:  Array< {
      __typename: "ProductInOrderLog",
      product_id: string,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPopOrderVehiclesQueryVariables = {
  filter?: ModelPopOrderVehicleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPopOrderVehiclesQuery = {
  listPopOrderVehicles?:  {
    __typename: "ModelPopOrderVehicleConnection",
    items:  Array< {
      __typename: "PopOrderVehicle",
      id: string,
      orderId: string,
      vehicleId: string,
      providerId: string,
      unitPrice: number,
      prototypePrice: number,
      quantity: number,
      approved: boolean,
      hasQrCode?: boolean | null,
      vehicle:  {
        __typename: "Vehicle",
        id: string,
        status?: string | null,
        isSustainable?: boolean | null,
        multiProvider?: boolean | null,
        itemName?: string | null,
        bestSeller?: string | null,
        name: string,
        brand: string,
        channel: string,
        images:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } >,
        description: string,
        size: string,
        materialDetail?: string | null,
        print?: string | null,
        finish?: string | null,
        packaging?: string | null,
        quantity: number,
        unitPrice: number,
        prototypePrice: number,
        productionTime: string,
        vehicleTypeId: string,
        popMaterialId: string,
        popCategoryId?: string | null,
        providerId: string,
        isRfq?: boolean | null,
        historicCost?: string | null,
        historicTime?: string | null,
        contact?: string | null,
        providerName?: string | null,
        variantsUnits?:  Array< {
          __typename: "VariantsUnits",
          min_units?: number | null,
          max_units?: number | null,
          price?: number | null,
          production_time?: number | null,
        } | null > | null,
        visibleFor?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        providers?: Array< string | null > | null,
        massiveLayout?: string | null,
        created: number,
        updated?: number | null,
        createdAt: string,
        updatedAt: string,
      },
      order:  {
        __typename: "PopOrder",
        id: string,
        estatus: string,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        orderId?: number | null,
        requirement?: string | null,
        budget?: number | null,
        delivery_addresses?:  Array< {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null > | null,
        delivery_cost?: number | null,
        delivery_time?: number | null,
        files?:  Array< {
          __typename: "ListFiles",
          created: number,
          creator_id: string,
          status?: string | null,
          statusFile?: string | null,
          name: string,
          provider_id?: string | null,
          product_id?: string | null,
          tracking_code?: string | null,
          gr_code?: string | null,
          coupa_order?: string | null,
          description?: string | null,
        } | null > | null,
        contact?:  {
          __typename: "OrderContact",
          name: string,
          tel: string,
        } | null,
        subtotal?: number | null,
        total?: number | null,
        isCoupa: boolean,
        sentToCoupa?: boolean | null,
        coupaOrder?: string | null,
        active?: string | null,
        vehicles?:  {
          __typename: "ModelPopOrderVehicleConnection",
          nextToken?: string | null,
        } | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        orderAgents?:  Array< {
          __typename: "OrderAgent",
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
          user_id?: string | null,
        } | null > | null,
        orderAgentIds?: Array< string | null > | null,
        buyerInfo?:  {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null,
        buyersInfo?:  Array< {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null > | null,
        gr?: string | null,
        orderCreatorId: string,
        providers?:  {
          __typename: "ModelPopOrderProviderConnection",
          nextToken?: string | null,
        } | null,
        creator?:  {
          __typename: "OrderCreator",
          name: string,
          email: string,
          user_id: string,
        } | null,
        prequoteApproved?: boolean | null,
        quoteApproved?: boolean | null,
        prototypeApproved?: boolean | null,
        samplesDocsUploaded?: boolean | null,
        samplesApproved?: boolean | null,
        auditRequired?: boolean | null,
        drivePath?: string | null,
        auditDocsUploaded?: boolean | null,
        deliveryDateRequested?: boolean | null,
        deliveryDate?: number | null,
        deliveryCode?: string | null,
        deliveryFilesUploaded?: boolean | null,
        deliveryDocsApproved?: boolean | null,
        grUploaded?: boolean | null,
        grApproved?: boolean | null,
        grCode?: string | null,
        qrCode?: boolean | null,
        brandfactoryCheck?: boolean | null,
        step?: number | null,
        prototype?: boolean | null,
        dateKickoff?: number | null,
        paymentDate?: number | null,
        currentProcess?: string | null,
        currentSubprocess?: string | null,
        clientId?: string | null,
      },
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      sampleTestDate?: number | null,
      sampleTestDateApproved?: boolean | null,
      prototypeDate?: number | null,
      prototypeDateApproved?: boolean | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPopOrderAuthorizerQueryVariables = {
  id: string,
};

export type GetPopOrderAuthorizerQuery = {
  getPopOrderAuthorizer?:  {
    __typename: "PopOrderAuthorizer",
    id: string,
    userId: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPopOrderAuthorizersQueryVariables = {
  filter?: ModelPopOrderAuthorizerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPopOrderAuthorizersQuery = {
  listPopOrderAuthorizers?:  {
    __typename: "ModelPopOrderAuthorizerConnection",
    items:  Array< {
      __typename: "PopOrderAuthorizer",
      id: string,
      userId: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPopOrderProviderQueryVariables = {
  id: string,
};

export type GetPopOrderProviderQuery = {
  getPopOrderProvider?:  {
    __typename: "PopOrderProvider",
    id: string,
    orderId: string,
    providerId: string,
    deliveryDateRequested?: boolean | null,
    grRequested?: boolean | null,
    invoiceUploaded?: boolean | null,
    order:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    },
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListPopOrderProvidersQueryVariables = {
  filter?: ModelPopOrderProviderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPopOrderProvidersQuery = {
  listPopOrderProviders?:  {
    __typename: "ModelPopOrderProviderConnection",
    items:  Array< {
      __typename: "PopOrderProvider",
      id: string,
      orderId: string,
      providerId: string,
      deliveryDateRequested?: boolean | null,
      grRequested?: boolean | null,
      invoiceUploaded?: boolean | null,
      order:  {
        __typename: "PopOrder",
        id: string,
        estatus: string,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        orderId?: number | null,
        requirement?: string | null,
        budget?: number | null,
        delivery_addresses?:  Array< {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null > | null,
        delivery_cost?: number | null,
        delivery_time?: number | null,
        files?:  Array< {
          __typename: "ListFiles",
          created: number,
          creator_id: string,
          status?: string | null,
          statusFile?: string | null,
          name: string,
          provider_id?: string | null,
          product_id?: string | null,
          tracking_code?: string | null,
          gr_code?: string | null,
          coupa_order?: string | null,
          description?: string | null,
        } | null > | null,
        contact?:  {
          __typename: "OrderContact",
          name: string,
          tel: string,
        } | null,
        subtotal?: number | null,
        total?: number | null,
        isCoupa: boolean,
        sentToCoupa?: boolean | null,
        coupaOrder?: string | null,
        active?: string | null,
        vehicles?:  {
          __typename: "ModelPopOrderVehicleConnection",
          nextToken?: string | null,
        } | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        orderAgents?:  Array< {
          __typename: "OrderAgent",
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
          user_id?: string | null,
        } | null > | null,
        orderAgentIds?: Array< string | null > | null,
        buyerInfo?:  {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null,
        buyersInfo?:  Array< {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null > | null,
        gr?: string | null,
        orderCreatorId: string,
        providers?:  {
          __typename: "ModelPopOrderProviderConnection",
          nextToken?: string | null,
        } | null,
        creator?:  {
          __typename: "OrderCreator",
          name: string,
          email: string,
          user_id: string,
        } | null,
        prequoteApproved?: boolean | null,
        quoteApproved?: boolean | null,
        prototypeApproved?: boolean | null,
        samplesDocsUploaded?: boolean | null,
        samplesApproved?: boolean | null,
        auditRequired?: boolean | null,
        drivePath?: string | null,
        auditDocsUploaded?: boolean | null,
        deliveryDateRequested?: boolean | null,
        deliveryDate?: number | null,
        deliveryCode?: string | null,
        deliveryFilesUploaded?: boolean | null,
        deliveryDocsApproved?: boolean | null,
        grUploaded?: boolean | null,
        grApproved?: boolean | null,
        grCode?: string | null,
        qrCode?: boolean | null,
        brandfactoryCheck?: boolean | null,
        step?: number | null,
        prototype?: boolean | null,
        dateKickoff?: number | null,
        paymentDate?: number | null,
        currentProcess?: string | null,
        currentSubprocess?: string | null,
        clientId?: string | null,
      },
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPopOrderLogQueryVariables = {
  id: string,
};

export type GetPopOrderLogQuery = {
  getPopOrderLog?:  {
    __typename: "PopOrderLog",
    id: string,
    orderId: string,
    creatorId: string,
    order?:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    } | null,
    createdAt?: string | null,
    text: string,
    orderStatus: string,
    updatedAt: string,
  } | null,
};

export type ListPopOrderLogsQueryVariables = {
  filter?: ModelPopOrderLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPopOrderLogsQuery = {
  listPopOrderLogs?:  {
    __typename: "ModelPopOrderLogConnection",
    items:  Array< {
      __typename: "PopOrderLog",
      id: string,
      orderId: string,
      creatorId: string,
      order?:  {
        __typename: "PopOrder",
        id: string,
        estatus: string,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        orderId?: number | null,
        requirement?: string | null,
        budget?: number | null,
        delivery_addresses?:  Array< {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null > | null,
        delivery_cost?: number | null,
        delivery_time?: number | null,
        files?:  Array< {
          __typename: "ListFiles",
          created: number,
          creator_id: string,
          status?: string | null,
          statusFile?: string | null,
          name: string,
          provider_id?: string | null,
          product_id?: string | null,
          tracking_code?: string | null,
          gr_code?: string | null,
          coupa_order?: string | null,
          description?: string | null,
        } | null > | null,
        contact?:  {
          __typename: "OrderContact",
          name: string,
          tel: string,
        } | null,
        subtotal?: number | null,
        total?: number | null,
        isCoupa: boolean,
        sentToCoupa?: boolean | null,
        coupaOrder?: string | null,
        active?: string | null,
        vehicles?:  {
          __typename: "ModelPopOrderVehicleConnection",
          nextToken?: string | null,
        } | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        orderAgents?:  Array< {
          __typename: "OrderAgent",
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
          user_id?: string | null,
        } | null > | null,
        orderAgentIds?: Array< string | null > | null,
        buyerInfo?:  {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null,
        buyersInfo?:  Array< {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null > | null,
        gr?: string | null,
        orderCreatorId: string,
        providers?:  {
          __typename: "ModelPopOrderProviderConnection",
          nextToken?: string | null,
        } | null,
        creator?:  {
          __typename: "OrderCreator",
          name: string,
          email: string,
          user_id: string,
        } | null,
        prequoteApproved?: boolean | null,
        quoteApproved?: boolean | null,
        prototypeApproved?: boolean | null,
        samplesDocsUploaded?: boolean | null,
        samplesApproved?: boolean | null,
        auditRequired?: boolean | null,
        drivePath?: string | null,
        auditDocsUploaded?: boolean | null,
        deliveryDateRequested?: boolean | null,
        deliveryDate?: number | null,
        deliveryCode?: string | null,
        deliveryFilesUploaded?: boolean | null,
        deliveryDocsApproved?: boolean | null,
        grUploaded?: boolean | null,
        grApproved?: boolean | null,
        grCode?: string | null,
        qrCode?: boolean | null,
        brandfactoryCheck?: boolean | null,
        step?: number | null,
        prototype?: boolean | null,
        dateKickoff?: number | null,
        paymentDate?: number | null,
        currentProcess?: string | null,
        currentSubprocess?: string | null,
        clientId?: string | null,
      } | null,
      createdAt?: string | null,
      text: string,
      orderStatus: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRfqPopQueryVariables = {
  id: string,
};

export type GetRfqPopQuery = {
  getRfqPop?:  {
    __typename: "RfqPop",
    id: string,
    nombre: string,
    requerimiento: string,
    vehicleTypeId?: string | null,
    popMaterialId?: string | null,
    vehiclesRfq?:  Array< {
      __typename: "VehicleUnitRfq",
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    proposals?:  {
      __typename: "ModelProposalsPopConnection",
      items:  Array< {
        __typename: "ProposalsPop",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        created: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        vehicles?:  Array< {
          __typename: "VehiclesProposalsPop",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          popMaterialId?: string | null,
          vehicleTypeId?: string | null,
          brand?: string | null,
          size?: string | null,
          description?: string | null,
          quantity?: number | null,
          packaging?: string | null,
          materialDetail?: string | null,
          print?: string | null,
          unitPrice?: number | null,
          pieces?: number | null,
          priceUnit?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        rfq?:  {
          __typename: "RfqPop",
          id: string,
          nombre: string,
          requerimiento: string,
          vehicleTypeId?: string | null,
          popMaterialId?: string | null,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId?: string | null,
          orderAgentIds?: Array< string | null > | null,
          popOrderId?: string | null,
          orderId?: number | null,
          estatus: string,
          start_time: number,
          delivery_time?: number | null,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          budget?: number | null,
          hasQrCode?: boolean | null,
          created: number,
          createdAt?: string | null,
          updated?: number | null,
          updatedAt: string,
        } | null,
        proposalsPopRfqId?: string | null,
        prototypePrice: number,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    clientId?: string | null,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    providers?:  Array< {
      __typename: "RfqPopProviders",
      idProvider?: string | null,
    } | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    popOrderId?: string | null,
    orderId?: number | null,
    estatus: string,
    start_time: number,
    delivery_time?: number | null,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    budget?: number | null,
    hasQrCode?: boolean | null,
    created: number,
    createdAt?: string | null,
    updated?: number | null,
    updatedAt: string,
  } | null,
};

export type ListRfqPopsQueryVariables = {
  filter?: ModelRfqPopFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRfqPopsQuery = {
  listRfqPops?:  {
    __typename: "ModelRfqPopConnection",
    items:  Array< {
      __typename: "RfqPop",
      id: string,
      nombre: string,
      requerimiento: string,
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      vehiclesRfq?:  Array< {
        __typename: "VehicleUnitRfq",
        vehicleTypeId?: string | null,
        popMaterialId?: string | null,
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      proposals?:  {
        __typename: "ModelProposalsPopConnection",
        items:  Array< {
          __typename: "ProposalsPop",
          id: string,
          provider_id: string,
          price: number,
          created: number,
          validity_days?: number | null,
          description?: string | null,
          updated?: number | null,
          proposalsPopRfqId?: string | null,
          prototypePrice: number,
          hidden?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      clientId?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfqPopProviders",
        idProvider?: string | null,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      popOrderId?: string | null,
      orderId?: number | null,
      estatus: string,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      budget?: number | null,
      hasQrCode?: boolean | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProposalsPopQueryVariables = {
  id: string,
};

export type GetProposalsPopQuery = {
  getProposalsPop?:  {
    __typename: "ProposalsPop",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    created: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    vehicles?:  Array< {
      __typename: "VehiclesProposalsPop",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      popMaterialId?: string | null,
      vehicleTypeId?: string | null,
      brand?: string | null,
      size?: string | null,
      description?: string | null,
      quantity?: number | null,
      packaging?: string | null,
      materialDetail?: string | null,
      print?: string | null,
      unitPrice?: number | null,
      pieces?: number | null,
      priceUnit?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    rfq?:  {
      __typename: "RfqPop",
      id: string,
      nombre: string,
      requerimiento: string,
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      vehiclesRfq?:  Array< {
        __typename: "VehicleUnitRfq",
        vehicleTypeId?: string | null,
        popMaterialId?: string | null,
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      proposals?:  {
        __typename: "ModelProposalsPopConnection",
        items:  Array< {
          __typename: "ProposalsPop",
          id: string,
          provider_id: string,
          price: number,
          created: number,
          validity_days?: number | null,
          description?: string | null,
          updated?: number | null,
          proposalsPopRfqId?: string | null,
          prototypePrice: number,
          hidden?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      clientId?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfqPopProviders",
        idProvider?: string | null,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      popOrderId?: string | null,
      orderId?: number | null,
      estatus: string,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      budget?: number | null,
      hasQrCode?: boolean | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null,
    proposalsPopRfqId?: string | null,
    prototypePrice: number,
    hidden?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListProposalsPopsQueryVariables = {
  filter?: ModelProposalsPopFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProposalsPopsQuery = {
  listProposalsPops?:  {
    __typename: "ModelProposalsPopConnection",
    items:  Array< {
      __typename: "ProposalsPop",
      id: string,
      provider_id: string,
      delivery_time:  {
        __typename: "Range",
        lower: number,
        upper: number,
      },
      price: number,
      created: number,
      validity_days?: number | null,
      description?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      vehicles?:  Array< {
        __typename: "VehiclesProposalsPop",
        productUnitRfqIndex?: number | null,
        selected?: boolean | null,
        name?: string | null,
        popMaterialId?: string | null,
        vehicleTypeId?: string | null,
        brand?: string | null,
        size?: string | null,
        description?: string | null,
        quantity?: number | null,
        packaging?: string | null,
        materialDetail?: string | null,
        print?: string | null,
        unitPrice?: number | null,
        pieces?: number | null,
        priceUnit?: number | null,
        total?: number | null,
        idProducto?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
      } | null > | null,
      updated?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      rfq?:  {
        __typename: "RfqPop",
        id: string,
        nombre: string,
        requerimiento: string,
        vehicleTypeId?: string | null,
        popMaterialId?: string | null,
        vehiclesRfq?:  Array< {
          __typename: "VehicleUnitRfq",
          vehicleTypeId?: string | null,
          popMaterialId?: string | null,
          name?: string | null,
          description?: string | null,
          pieces?: number | null,
          createdId?: number | null,
        } | null > | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        compras?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        cantidad: number,
        limit_time: number,
        creatorInfo?:  {
          __typename: "OrderCreator",
          name: string,
          email: string,
          user_id: string,
        } | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        proposals?:  {
          __typename: "ModelProposalsPopConnection",
          nextToken?: string | null,
        } | null,
        creator?: string | null,
        clientId?: string | null,
        winner?:  {
          __typename: "Winner",
          proveeedor_id: string,
          date: number,
        } | null,
        logs?:  Array< {
          __typename: "Logs",
          creatorId: string,
          description: string,
          date: number,
          status?: string | null,
          provider_id?: string | null,
        } | null > | null,
        providers?:  Array< {
          __typename: "RfqPopProviders",
          idProvider?: string | null,
        } | null > | null,
        orderAgents?:  Array< {
          __typename: "OrderAgent",
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
          user_id?: string | null,
        } | null > | null,
        orderAgentIds?: Array< string | null > | null,
        popOrderId?: string | null,
        orderId?: number | null,
        estatus: string,
        start_time: number,
        delivery_time?: number | null,
        saving?: number | null,
        saving_percentage?: number | null,
        saving_real?: number | null,
        budget?: number | null,
        hasQrCode?: boolean | null,
        created: number,
        createdAt?: string | null,
        updated?: number | null,
        updatedAt: string,
      } | null,
      proposalsPopRfqId?: string | null,
      prototypePrice: number,
      hidden?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUsersBrandsQueryVariables = {
  id: string,
};

export type GetUsersBrandsQuery = {
  getUsersBrands?:  {
    __typename: "UsersBrands",
    id: string,
    name: string,
    description?: string | null,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    status?: string | null,
    clientId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUsersBrandsQueryVariables = {
  filter?: ModelUsersBrandsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersBrandsQuery = {
  listUsersBrands?:  {
    __typename: "ModelUsersBrandsConnection",
    items:  Array< {
      __typename: "UsersBrands",
      id: string,
      name: string,
      description?: string | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      status?: string | null,
      clientId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserBrandSettingQueryVariables = {
  id: string,
};

export type GetUserBrandSettingQuery = {
  getUserBrandSetting?:  {
    __typename: "UserBrandSetting",
    id: string,
    categories?: Array< string | null > | null,
    subcategories?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListUserBrandSettingsQueryVariables = {
  filter?: ModelUserBrandSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserBrandSettingsQuery = {
  listUserBrandSettings?:  {
    __typename: "ModelUserBrandSettingConnection",
    items:  Array< {
      __typename: "UserBrandSetting",
      id: string,
      categories?: Array< string | null > | null,
      subcategories?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLogsPUsersQueryVariables = {
  id: string,
};

export type GetLogsPUsersQuery = {
  getLogsPUsers?:  {
    __typename: "LogsPUsers",
    id: string,
    user?: string | null,
    keyword?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListLogsPUsersQueryVariables = {
  filter?: ModelLogsPUsersFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogsPUsersQuery = {
  listLogsPUsers?:  {
    __typename: "ModelLogsPUsersConnection",
    items:  Array< {
      __typename: "LogsPUsers",
      id: string,
      user?: string | null,
      keyword?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetClipPaymentQueryVariables = {
  id: string,
};

export type GetClipPaymentQuery = {
  getClipPayment?:  {
    __typename: "ClipPayment",
    id: string,
    status?: string | null,
    requestsCount?: number | null,
    payment_request_id?: string | null,
    purchase_description?: string | null,
    orderId: string,
    clientId: string,
    userId: string,
    creator?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListClipPaymentsQueryVariables = {
  filter?: ModelClipPaymentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListClipPaymentsQuery = {
  listClipPayments?:  {
    __typename: "ModelClipPaymentConnection",
    items:  Array< {
      __typename: "ClipPayment",
      id: string,
      status?: string | null,
      requestsCount?: number | null,
      payment_request_id?: string | null,
      purchase_description?: string | null,
      orderId: string,
      clientId: string,
      userId: string,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOrderProcessQueryVariables = {
  id: string,
};

export type GetOrderProcessQuery = {
  getOrderProcess?:  {
    __typename: "OrderProcess",
    id: string,
    type?: string | null,
    status?: boolean | null,
    tcdPayment?: boolean | null,
    name: string,
    duration?: string | null,
    descripcion?: string | null,
    position: number,
    responsible?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    cards?:  Array< {
      __typename: "OrderCards",
      id?: string | null,
      name?: string | null,
      permissions?:  Array< {
        __typename: "OrderCardPermissions",
        idCard: string,
        rol: string,
        thirdContent?: boolean | null,
        visible?: boolean | null,
      } | null > | null,
    } | null > | null,
    subprocesses?:  {
      __typename: "ModelOrderSubprocessConnection",
      items:  Array< {
        __typename: "OrderSubprocess",
        id: string,
        type?: string | null,
        status?: boolean | null,
        name: string,
        position: number,
        descripcion: string,
        action: number,
        process?:  {
          __typename: "OrderProcess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          tcdPayment?: boolean | null,
          name: string,
          duration?: string | null,
          descripcion?: string | null,
          position: number,
          responsible?: number | null,
          clientId?: string | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null,
        processId: string,
        clientId: string,
        messages?:  Array< {
          __typename: "MessageSubprocess",
          description?: string | null,
          rol?: string | null,
          visibleAction?: boolean | null,
        } | null > | null,
        notifications?:  Array< {
          __typename: "NotificationSubprocesses",
          group?: string | null,
          enabledEmail?: boolean | null,
          enabledPopUp?: boolean | null,
        } | null > | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    clientId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListOrderProcessesQueryVariables = {
  filter?: ModelOrderProcessFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrderProcessesQuery = {
  listOrderProcesses?:  {
    __typename: "ModelOrderProcessConnection",
    items:  Array< {
      __typename: "OrderProcess",
      id: string,
      type?: string | null,
      status?: boolean | null,
      tcdPayment?: boolean | null,
      name: string,
      duration?: string | null,
      descripcion?: string | null,
      position: number,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  {
        __typename: "ModelOrderSubprocessConnection",
        items:  Array< {
          __typename: "OrderSubprocess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          name: string,
          position: number,
          descripcion: string,
          action: number,
          processId: string,
          clientId: string,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      clientId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOrderSubprocessQueryVariables = {
  id: string,
};

export type GetOrderSubprocessQuery = {
  getOrderSubprocess?:  {
    __typename: "OrderSubprocess",
    id: string,
    type?: string | null,
    status?: boolean | null,
    name: string,
    position: number,
    descripcion: string,
    action: number,
    process?:  {
      __typename: "OrderProcess",
      id: string,
      type?: string | null,
      status?: boolean | null,
      tcdPayment?: boolean | null,
      name: string,
      duration?: string | null,
      descripcion?: string | null,
      position: number,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  {
        __typename: "ModelOrderSubprocessConnection",
        items:  Array< {
          __typename: "OrderSubprocess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          name: string,
          position: number,
          descripcion: string,
          action: number,
          processId: string,
          clientId: string,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      clientId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null,
    processId: string,
    clientId: string,
    messages?:  Array< {
      __typename: "MessageSubprocess",
      description?: string | null,
      rol?: string | null,
      visibleAction?: boolean | null,
    } | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListOrderSubprocessesQueryVariables = {
  filter?: ModelOrderSubprocessFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrderSubprocessesQuery = {
  listOrderSubprocesses?:  {
    __typename: "ModelOrderSubprocessConnection",
    items:  Array< {
      __typename: "OrderSubprocess",
      id: string,
      type?: string | null,
      status?: boolean | null,
      name: string,
      position: number,
      descripcion: string,
      action: number,
      process?:  {
        __typename: "OrderProcess",
        id: string,
        type?: string | null,
        status?: boolean | null,
        tcdPayment?: boolean | null,
        name: string,
        duration?: string | null,
        descripcion?: string | null,
        position: number,
        responsible?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        cards?:  Array< {
          __typename: "OrderCards",
          id?: string | null,
          name?: string | null,
        } | null > | null,
        subprocesses?:  {
          __typename: "ModelOrderSubprocessConnection",
          nextToken?: string | null,
        } | null,
        clientId?: string | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null,
      processId: string,
      clientId: string,
      messages?:  Array< {
        __typename: "MessageSubprocess",
        description?: string | null,
        rol?: string | null,
        visibleAction?: boolean | null,
      } | null > | null,
      notifications?:  Array< {
        __typename: "NotificationSubprocesses",
        group?: string | null,
        enabledEmail?: boolean | null,
        enabledPopUp?: boolean | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPremiumOrderQueryVariables = {
  id: string,
};

export type GetPremiumOrderQuery = {
  getPremiumOrder?:  {
    __typename: "PremiumOrder",
    id: string,
    requirement?: string | null,
    bank_reference?: string | null,
    hasVat?: boolean | null,
    billingData?:  {
      __typename: "BillingData",
      name?: string | null,
      rfc?: string | null,
      regimen?: string | null,
      cfdi_use?: string | null,
      cp?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
    } | null,
    orderId: number,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    logs?:  Array< {
      __typename: "Log",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      role?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_fee?: number | null,
    delivery_discount?: number | null,
    delivery_time?: number | null,
    delivery_date?: string | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    taxSituationFile?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clipUrl?: string | null,
    clipStatus?: string | null,
    listProviders?:  Array< {
      __typename: "ListProvidersOrder",
      provider_id: string,
      order_id: string,
      payment_date?: number | null,
      gr_code?: string | null,
      order_confirmation?: boolean | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      delivered?: boolean | null,
      deliveredFormat?: boolean | null,
    } | null > | null,
    providers?:  {
      __typename: "ModelOrderProvidersConnection",
      items:  Array< {
        __typename: "OrderProviders",
        id: string,
        provider_id: string,
        clientId?: string | null,
        orderId?: number | null,
        orderProvidersPremiumOrderId: string,
        payment_date?: number | null,
        gr_code?: string | null,
        invoice?: boolean | null,
        invoiceRequested?: boolean | null,
        uploadedGr?: boolean | null,
        uploadedBill?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    listsProducts:  Array< {
      __typename: "ProductInOrder",
      product_id: string,
      provider_id?: string | null,
      index?: number | null,
      print?: number | null,
      printPrice?: number | null,
      product_name: string,
      description?: string | null,
      category?: string | null,
      unspsc?: string | null,
      price?: number | null,
      originalPrice?: number | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      sample_authorize?: boolean | null,
      sample_authorized?: boolean | null,
      quality_requested?: boolean | null,
      quality_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      isExternal?: boolean | null,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      sku?: string | null,
      qualityForm?:  {
        __typename: "ProductInOrderQualityPGForm",
        initiativeDescription?: string | null,
        targetUser?: string | null,
        retailBrandName?: string | null,
        itemCategory?: string | null,
        itemPicture?: string | null,
        originCountry?: string | null,
        quantityPerCountryOfDist?: string | null,
        initiativeDates?: string | null,
        isPartOfAnMSOCustOrSpecPack?: string | null,
        incluesClientLogo?: string | null,
        isAReorderWithinTwelveMonths?: string | null,
        isReorder?: string | null,
        PGPLContactName?: string | null,
        ulTracking?: string | null,
        PLContactName?: string | null,
        contactEmailAddress?: string | null,
        PGPurchaseOrderNumber?: string | null,
        EBBSorSupplierProvidedProjectNumber?: string | null,
        vendorCompanyName?: string | null,
        vendorContactName?: string | null,
        vendorEmailAddress?: string | null,
        vendorJobTitle?: string | null,
        vendorTelephone?: string | null,
        vendorMailingAddress?: string | null,
        vendorCity?: string | null,
        vendorState?: string | null,
        vendorCountry?: string | null,
        vendorPC?: string | null,
        physicalItemDescription?: string | null,
        SampleOrMaterialComponentSubmitted?: string | null,
        toWhom?: string | null,
        descriptionOfItemPackagingAndArtwork?: string | null,
        regulatoryAndLegislativeProductCertification?: string | null,
        dateFinalApprovalRequestedSubmittedToPG?: string | null,
        DateOfDeclarationOfConformity?: string | null,
        dateOfApprovalExpirationOfPremiumItem?: string | null,
        itemClasification?: string | null,
        PGRepresentativeMarketingDesign?: string | null,
        PGProjectLeaderRequestor?: string | null,
        PGRestrictedItemsLocalPGLegal?: string | null,
        PGLocalCategoryGM?: string | null,
        PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
        idProduct?: string | null,
        pathDocument?: string | null,
      } | null,
      fee?: number | null,
      increment?: number | null,
      discount?: number | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
    } >,
    cotizationsList:  Array< {
      __typename: "PremiumOrderCotizationsLog",
      id: number,
      created: number,
      createdBy: string,
      products:  Array< {
        __typename: "ProductInOrder",
        product_id: string,
        provider_id?: string | null,
        index?: number | null,
        print?: number | null,
        printPrice?: number | null,
        product_name: string,
        description?: string | null,
        category?: string | null,
        unspsc?: string | null,
        price?: number | null,
        originalPrice?: number | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        sample_authorize?: boolean | null,
        sample_authorized?: boolean | null,
        quality_requested?: boolean | null,
        quality_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        isExternal?: boolean | null,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        sku?: string | null,
        qualityForm?:  {
          __typename: "ProductInOrderQualityPGForm",
          initiativeDescription?: string | null,
          targetUser?: string | null,
          retailBrandName?: string | null,
          itemCategory?: string | null,
          itemPicture?: string | null,
          originCountry?: string | null,
          quantityPerCountryOfDist?: string | null,
          initiativeDates?: string | null,
          isPartOfAnMSOCustOrSpecPack?: string | null,
          incluesClientLogo?: string | null,
          isAReorderWithinTwelveMonths?: string | null,
          isReorder?: string | null,
          PGPLContactName?: string | null,
          ulTracking?: string | null,
          PLContactName?: string | null,
          contactEmailAddress?: string | null,
          PGPurchaseOrderNumber?: string | null,
          EBBSorSupplierProvidedProjectNumber?: string | null,
          vendorCompanyName?: string | null,
          vendorContactName?: string | null,
          vendorEmailAddress?: string | null,
          vendorJobTitle?: string | null,
          vendorTelephone?: string | null,
          vendorMailingAddress?: string | null,
          vendorCity?: string | null,
          vendorState?: string | null,
          vendorCountry?: string | null,
          vendorPC?: string | null,
          physicalItemDescription?: string | null,
          SampleOrMaterialComponentSubmitted?: string | null,
          toWhom?: string | null,
          descriptionOfItemPackagingAndArtwork?: string | null,
          regulatoryAndLegislativeProductCertification?: string | null,
          dateFinalApprovalRequestedSubmittedToPG?: string | null,
          DateOfDeclarationOfConformity?: string | null,
          dateOfApprovalExpirationOfPremiumItem?: string | null,
          itemClasification?: string | null,
          PGRepresentativeMarketingDesign?: string | null,
          PGProjectLeaderRequestor?: string | null,
          PGRestrictedItemsLocalPGLegal?: string | null,
          PGLocalCategoryGM?: string | null,
          PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
          idProduct?: string | null,
          pathDocument?: string | null,
        } | null,
        fee?: number | null,
        increment?: number | null,
        discount?: number | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        sellMode?: ProductMaskSellMode | null,
        kitPieces?: number | null,
      } >,
    } | null >,
    orderCreatorId: string,
    creator:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    },
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    invoiceContact?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    premiumOrderClientId?: string | null,
    client?:  {
      __typename: "Client",
      id: string,
      status?: boolean | null,
      business_name: string,
      comertial_name: string,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      biography?: string | null,
      plan?: string | null,
      fee?: number | null,
      increment?: number | null,
      mercadoFee?: number | null,
      mercadoIncrement?: number | null,
      popFee?: number | null,
      popIncrement?: number | null,
      printedFee?: number | null,
      printedIncrement?: number | null,
      users?: Array< string | null > | null,
      restrictedUsers?: Array< string | null > | null,
      nonRestrictedUsers?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      popProviders?: Array< string | null > | null,
      printedProviders?: Array< string | null > | null,
      logisticFrequency?: number | null,
      agents?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      administrators?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      signDocument?:  Array< {
        __typename: "Sign",
        url?: string | null,
        enabled?: boolean | null,
      } | null > | null,
      legal_representative?: string | null,
      legal_representative_email?: string | null,
      legal_representative_address?: string | null,
      tcdUsers?: Array< string | null > | null,
      billingUsers?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt?: string | null,
    } | null,
    userBrandId?: string | null,
    userBrand?:  {
      __typename: "UsersBrands",
      id: string,
      name: string,
      description?: string | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      status?: string | null,
      clientId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subtotal?: number | null,
    fee?: number | null,
    printedPrice?: number | null,
    total?: number | null,
    discountAmount?: number | null,
    syncWithCrm?: boolean | null,
    crmIssueKey?: string | null,
    sentToAlendum?: boolean | null,
    alendumProjectId?: string | null,
    syncWithFms?: string | null,
    fmsInvoiceId?: string | null,
    syncWithWms?: boolean | null,
    wmsProjectId?: string | null,
    isCoupa?: boolean | null,
    sentToCoupa?: boolean | null,
    isRfq?: boolean | null,
    requireSamples?: boolean | null,
    requestedSamples?: boolean | null,
    approvedSamples?: boolean | null,
    authorizedQA?: boolean | null,
    active?: string | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    processes?:  Array< {
      __typename: "OrderProcessStructure",
      id?: string | null,
      name?: string | null,
      descripcion?: string | null,
      duration?: string | null,
      position?: number | null,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      madeBy?: string | null,
      madeAt?: number | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  Array< {
        __typename: "OrderSubprocessStructure",
        id?: string | null,
        name?: string | null,
        position?: number | null,
        descripcion?: string | null,
        action?: number | null,
        process?: string | null,
        madeBy?: string | null,
        madeAt?: number | null,
        messages?:  Array< {
          __typename: "MessageSubprocess",
          description?: string | null,
          rol?: string | null,
          visibleAction?: boolean | null,
        } | null > | null,
        notifications?:  Array< {
          __typename: "NotificationSubprocesses",
          group?: string | null,
          enabledEmail?: boolean | null,
          enabledPopUp?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    updatedAt?: string | null,
    created: number,
    updated?: number | null,
    logistic?:  Array< {
      __typename: "LogisticPremiumOrder",
      premiumOrderId?: string | null,
      tracking_number?: string | null,
      destiny_latitude?: string | null,
      destiny_longitude?: string | null,
      status?: string | null,
      status_activity?: string | null,
      status_description?: string | null,
      origin_latitude?: string | null,
      origin_longitude?: string | null,
      carrier?: string | null,
      clave_sat?: string | null,
      customer_delivery_start_date?: string | null,
      customer_email?: string | null,
      customer_external_number?: string | null,
      customer_first_name?: string | null,
      customer_last_name?: string | null,
      customer_mobile_number?: string | null,
      customer_postcode?: string | null,
      customer_settlement?: string | null,
      customer_street?: string | null,
      descripcion_sat?: string | null,
      peligroso?: string | null,
      primary_client?: string | null,
      purchase_order_number?: string | null,
      shipping_method?: string | null,
      shipping_option?: string | null,
      created: number,
    } | null > | null,
    createdAt: string,
  } | null,
};

export type ListPremiumOrdersQueryVariables = {
  filter?: ModelPremiumOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPremiumOrdersQuery = {
  listPremiumOrders?:  {
    __typename: "ModelPremiumOrderConnection",
    items:  Array< {
      __typename: "PremiumOrder",
      id: string,
      requirement?: string | null,
      bank_reference?: string | null,
      hasVat?: boolean | null,
      billingData?:  {
        __typename: "BillingData",
        name?: string | null,
        rfc?: string | null,
        regimen?: string | null,
        cfdi_use?: string | null,
        cp?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
      } | null,
      orderId: number,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      logs?:  Array< {
        __typename: "Log",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        role?: string | null,
      } | null > | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_fee?: number | null,
      delivery_discount?: number | null,
      delivery_time?: number | null,
      delivery_date?: string | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      taxSituationFile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      clipUrl?: string | null,
      clipStatus?: string | null,
      listProviders?:  Array< {
        __typename: "ListProvidersOrder",
        provider_id: string,
        order_id: string,
        payment_date?: number | null,
        gr_code?: string | null,
        order_confirmation?: boolean | null,
        invoice?: boolean | null,
        invoiceRequested?: boolean | null,
        uploadedGr?: boolean | null,
        uploadedBill?: boolean | null,
        delivered?: boolean | null,
        deliveredFormat?: boolean | null,
      } | null > | null,
      providers?:  {
        __typename: "ModelOrderProvidersConnection",
        items:  Array< {
          __typename: "OrderProviders",
          id: string,
          provider_id: string,
          clientId?: string | null,
          orderId?: number | null,
          orderProvidersPremiumOrderId: string,
          payment_date?: number | null,
          gr_code?: string | null,
          invoice?: boolean | null,
          invoiceRequested?: boolean | null,
          uploadedGr?: boolean | null,
          uploadedBill?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      listsProducts:  Array< {
        __typename: "ProductInOrder",
        product_id: string,
        provider_id?: string | null,
        index?: number | null,
        print?: number | null,
        printPrice?: number | null,
        product_name: string,
        description?: string | null,
        category?: string | null,
        unspsc?: string | null,
        price?: number | null,
        originalPrice?: number | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        sample_authorize?: boolean | null,
        sample_authorized?: boolean | null,
        quality_requested?: boolean | null,
        quality_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        isExternal?: boolean | null,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        sku?: string | null,
        qualityForm?:  {
          __typename: "ProductInOrderQualityPGForm",
          initiativeDescription?: string | null,
          targetUser?: string | null,
          retailBrandName?: string | null,
          itemCategory?: string | null,
          itemPicture?: string | null,
          originCountry?: string | null,
          quantityPerCountryOfDist?: string | null,
          initiativeDates?: string | null,
          isPartOfAnMSOCustOrSpecPack?: string | null,
          incluesClientLogo?: string | null,
          isAReorderWithinTwelveMonths?: string | null,
          isReorder?: string | null,
          PGPLContactName?: string | null,
          ulTracking?: string | null,
          PLContactName?: string | null,
          contactEmailAddress?: string | null,
          PGPurchaseOrderNumber?: string | null,
          EBBSorSupplierProvidedProjectNumber?: string | null,
          vendorCompanyName?: string | null,
          vendorContactName?: string | null,
          vendorEmailAddress?: string | null,
          vendorJobTitle?: string | null,
          vendorTelephone?: string | null,
          vendorMailingAddress?: string | null,
          vendorCity?: string | null,
          vendorState?: string | null,
          vendorCountry?: string | null,
          vendorPC?: string | null,
          physicalItemDescription?: string | null,
          SampleOrMaterialComponentSubmitted?: string | null,
          toWhom?: string | null,
          descriptionOfItemPackagingAndArtwork?: string | null,
          regulatoryAndLegislativeProductCertification?: string | null,
          dateFinalApprovalRequestedSubmittedToPG?: string | null,
          DateOfDeclarationOfConformity?: string | null,
          dateOfApprovalExpirationOfPremiumItem?: string | null,
          itemClasification?: string | null,
          PGRepresentativeMarketingDesign?: string | null,
          PGProjectLeaderRequestor?: string | null,
          PGRestrictedItemsLocalPGLegal?: string | null,
          PGLocalCategoryGM?: string | null,
          PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
          idProduct?: string | null,
          pathDocument?: string | null,
        } | null,
        fee?: number | null,
        increment?: number | null,
        discount?: number | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        sellMode?: ProductMaskSellMode | null,
        kitPieces?: number | null,
      } >,
      cotizationsList:  Array< {
        __typename: "PremiumOrderCotizationsLog",
        id: number,
        created: number,
        createdBy: string,
        products:  Array< {
          __typename: "ProductInOrder",
          product_id: string,
          provider_id?: string | null,
          index?: number | null,
          print?: number | null,
          printPrice?: number | null,
          product_name: string,
          description?: string | null,
          category?: string | null,
          unspsc?: string | null,
          price?: number | null,
          originalPrice?: number | null,
          sample_requested?: boolean | null,
          sample_request?: boolean | null,
          sample_authorize?: boolean | null,
          sample_authorized?: boolean | null,
          quality_requested?: boolean | null,
          quality_request?: boolean | null,
          uploadedSample?: boolean | null,
          quantity: number,
          isExternal?: boolean | null,
          sku?: string | null,
          fee?: number | null,
          increment?: number | null,
          discount?: number | null,
          sellMode?: ProductMaskSellMode | null,
          kitPieces?: number | null,
        } >,
      } | null >,
      orderCreatorId: string,
      creator:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      },
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      invoiceContact?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      premiumOrderClientId?: string | null,
      client?:  {
        __typename: "Client",
        id: string,
        status?: boolean | null,
        business_name: string,
        comertial_name: string,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        buyerInfo?:  {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null,
        buyersInfo?:  Array< {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null > | null,
        biography?: string | null,
        plan?: string | null,
        fee?: number | null,
        increment?: number | null,
        mercadoFee?: number | null,
        mercadoIncrement?: number | null,
        popFee?: number | null,
        popIncrement?: number | null,
        printedFee?: number | null,
        printedIncrement?: number | null,
        users?: Array< string | null > | null,
        restrictedUsers?: Array< string | null > | null,
        nonRestrictedUsers?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        providers?: Array< string | null > | null,
        popProviders?: Array< string | null > | null,
        printedProviders?: Array< string | null > | null,
        logisticFrequency?: number | null,
        agents?:  Array< {
          __typename: "Agent",
          id?: string | null,
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
        } | null > | null,
        administrators?:  Array< {
          __typename: "Agent",
          id?: string | null,
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
        } | null > | null,
        signDocument?:  Array< {
          __typename: "Sign",
          url?: string | null,
          enabled?: boolean | null,
        } | null > | null,
        legal_representative?: string | null,
        legal_representative_email?: string | null,
        legal_representative_address?: string | null,
        tcdUsers?: Array< string | null > | null,
        billingUsers?:  Array< {
          __typename: "Agent",
          id?: string | null,
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
        } | null > | null,
        createdAt: string,
        updatedAt?: string | null,
      } | null,
      userBrandId?: string | null,
      userBrand?:  {
        __typename: "UsersBrands",
        id: string,
        name: string,
        description?: string | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        status?: string | null,
        clientId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subtotal?: number | null,
      fee?: number | null,
      printedPrice?: number | null,
      total?: number | null,
      discountAmount?: number | null,
      syncWithCrm?: boolean | null,
      crmIssueKey?: string | null,
      sentToAlendum?: boolean | null,
      alendumProjectId?: string | null,
      syncWithFms?: string | null,
      fmsInvoiceId?: string | null,
      syncWithWms?: boolean | null,
      wmsProjectId?: string | null,
      isCoupa?: boolean | null,
      sentToCoupa?: boolean | null,
      isRfq?: boolean | null,
      requireSamples?: boolean | null,
      requestedSamples?: boolean | null,
      approvedSamples?: boolean | null,
      authorizedQA?: boolean | null,
      active?: string | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      processes?:  Array< {
        __typename: "OrderProcessStructure",
        id?: string | null,
        name?: string | null,
        descripcion?: string | null,
        duration?: string | null,
        position?: number | null,
        responsible?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        madeBy?: string | null,
        madeAt?: number | null,
        cards?:  Array< {
          __typename: "OrderCards",
          id?: string | null,
          name?: string | null,
        } | null > | null,
        subprocesses?:  Array< {
          __typename: "OrderSubprocessStructure",
          id?: string | null,
          name?: string | null,
          position?: number | null,
          descripcion?: string | null,
          action?: number | null,
          process?: string | null,
          madeBy?: string | null,
          madeAt?: number | null,
        } | null > | null,
      } | null > | null,
      updatedAt?: string | null,
      created: number,
      updated?: number | null,
      logistic?:  Array< {
        __typename: "LogisticPremiumOrder",
        premiumOrderId?: string | null,
        tracking_number?: string | null,
        destiny_latitude?: string | null,
        destiny_longitude?: string | null,
        status?: string | null,
        status_activity?: string | null,
        status_description?: string | null,
        origin_latitude?: string | null,
        origin_longitude?: string | null,
        carrier?: string | null,
        clave_sat?: string | null,
        customer_delivery_start_date?: string | null,
        customer_email?: string | null,
        customer_external_number?: string | null,
        customer_first_name?: string | null,
        customer_last_name?: string | null,
        customer_mobile_number?: string | null,
        customer_postcode?: string | null,
        customer_settlement?: string | null,
        customer_street?: string | null,
        descripcion_sat?: string | null,
        peligroso?: string | null,
        primary_client?: string | null,
        purchase_order_number?: string | null,
        shipping_method?: string | null,
        shipping_option?: string | null,
        created: number,
      } | null > | null,
      createdAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPrintedCartQueryVariables = {
  id: string,
};

export type GetPrintedCartQuery = {
  getPrintedCart?:  {
    __typename: "PrintedCart",
    id: string,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    files?:  Array< {
      __typename: "PrintedListFiles",
      created?: number | null,
      creator_id?: string | null,
      file?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      status?: string | null,
      name?: string | null,
      type?: string | null,
      tracking_code?: string | null,
      provider_id?: string | null,
      product_id?: string | null,
      description?: string | null,
    } | null > | null,
    printedProducts?:  Array< {
      __typename: "PrintedProductInOrder",
      product_id: string,
      provider_id?: string | null,
      visible?: boolean | null,
      product_name: string,
      price?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
    } | null > | null,
    creator: string,
    created?: number | null,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPrintedCartsQueryVariables = {
  filter?: ModelPrintedCartFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrintedCartsQuery = {
  listPrintedCarts?:  {
    __typename: "ModelPrintedCartConnection",
    items:  Array< {
      __typename: "PrintedCart",
      id: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      files?:  Array< {
        __typename: "PrintedListFiles",
        created?: number | null,
        creator_id?: string | null,
        file?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        status?: string | null,
        name?: string | null,
        type?: string | null,
        tracking_code?: string | null,
        provider_id?: string | null,
        product_id?: string | null,
        description?: string | null,
      } | null > | null,
      printedProducts?:  Array< {
        __typename: "PrintedProductInOrder",
        product_id: string,
        provider_id?: string | null,
        visible?: boolean | null,
        product_name: string,
        price?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
      } | null > | null,
      creator: string,
      created?: number | null,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPrintedCategoryQueryVariables = {
  id: string,
};

export type GetPrintedCategoryQuery = {
  getPrintedCategory?:  {
    __typename: "PrintedCategory",
    id: string,
    name: string,
    image:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    },
    route: string,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    printedSubcategories?:  {
      __typename: "ModelPrintedSubcategoryConnection",
      items:  Array< {
        __typename: "PrintedSubcategory",
        id: string,
        name: string,
        printedCategoryId: string,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        parent:  {
          __typename: "PrintedCategory",
          id: string,
          name: string,
          route: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          region?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        },
        created: number,
        printedProducts?:  {
          __typename: "ModelPrintedProductsConnection",
          nextToken?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        region?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    printedProducts?:  {
      __typename: "ModelPrintedProductsConnection",
      items:  Array< {
        __typename: "PrintedProducts",
        id: string,
        status: string,
        position: string,
        name: string,
        width: number,
        height: number,
        images:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } >,
        price: number,
        long_description?: string | null,
        short_description?: string | null,
        creator?: string | null,
        providerId: string,
        finalDimensions?: number | null,
        pagesNumber?: number | null,
        finishes?: string | null,
        inksFourByCero?: string | null,
        inksFourByFour?: string | null,
        paperKind?: string | null,
        grammage?: string | null,
        hasBarniz?: boolean | null,
        hasRebase?: boolean | null,
        orientation?: string | null,
        specialInstructions?: string | null,
        PrintedSubcategoryId: string,
        printedCategoryId: string,
        created: number,
        variants?:  Array< {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null > | null,
        visibleFor?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    created: number,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPrintedCategoriesQueryVariables = {
  filter?: ModelPrintedCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrintedCategoriesQuery = {
  listPrintedCategories?:  {
    __typename: "ModelPrintedCategoryConnection",
    items:  Array< {
      __typename: "PrintedCategory",
      id: string,
      name: string,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      route: string,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      printedSubcategories?:  {
        __typename: "ModelPrintedSubcategoryConnection",
        items:  Array< {
          __typename: "PrintedSubcategory",
          id: string,
          name: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          region?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      printedProducts?:  {
        __typename: "ModelPrintedProductsConnection",
        items:  Array< {
          __typename: "PrintedProducts",
          id: string,
          status: string,
          position: string,
          name: string,
          width: number,
          height: number,
          price: number,
          long_description?: string | null,
          short_description?: string | null,
          creator?: string | null,
          providerId: string,
          finalDimensions?: number | null,
          pagesNumber?: number | null,
          finishes?: string | null,
          inksFourByCero?: string | null,
          inksFourByFour?: string | null,
          paperKind?: string | null,
          grammage?: string | null,
          hasBarniz?: boolean | null,
          hasRebase?: boolean | null,
          orientation?: string | null,
          specialInstructions?: string | null,
          PrintedSubcategoryId: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          regions?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      created: number,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPrintedSubcategoryQueryVariables = {
  id: string,
};

export type GetPrintedSubcategoryQuery = {
  getPrintedSubcategory?:  {
    __typename: "PrintedSubcategory",
    id: string,
    name: string,
    printedCategoryId: string,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    parent:  {
      __typename: "PrintedCategory",
      id: string,
      name: string,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      route: string,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      printedSubcategories?:  {
        __typename: "ModelPrintedSubcategoryConnection",
        items:  Array< {
          __typename: "PrintedSubcategory",
          id: string,
          name: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          region?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      printedProducts?:  {
        __typename: "ModelPrintedProductsConnection",
        items:  Array< {
          __typename: "PrintedProducts",
          id: string,
          status: string,
          position: string,
          name: string,
          width: number,
          height: number,
          price: number,
          long_description?: string | null,
          short_description?: string | null,
          creator?: string | null,
          providerId: string,
          finalDimensions?: number | null,
          pagesNumber?: number | null,
          finishes?: string | null,
          inksFourByCero?: string | null,
          inksFourByFour?: string | null,
          paperKind?: string | null,
          grammage?: string | null,
          hasBarniz?: boolean | null,
          hasRebase?: boolean | null,
          orientation?: string | null,
          specialInstructions?: string | null,
          PrintedSubcategoryId: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          regions?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      created: number,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    },
    created: number,
    printedProducts?:  {
      __typename: "ModelPrintedProductsConnection",
      items:  Array< {
        __typename: "PrintedProducts",
        id: string,
        status: string,
        position: string,
        name: string,
        width: number,
        height: number,
        images:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } >,
        price: number,
        long_description?: string | null,
        short_description?: string | null,
        creator?: string | null,
        providerId: string,
        finalDimensions?: number | null,
        pagesNumber?: number | null,
        finishes?: string | null,
        inksFourByCero?: string | null,
        inksFourByFour?: string | null,
        paperKind?: string | null,
        grammage?: string | null,
        hasBarniz?: boolean | null,
        hasRebase?: boolean | null,
        orientation?: string | null,
        specialInstructions?: string | null,
        PrintedSubcategoryId: string,
        printedCategoryId: string,
        created: number,
        variants?:  Array< {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null > | null,
        visibleFor?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPrintedSubcategoriesQueryVariables = {
  filter?: ModelPrintedSubcategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrintedSubcategoriesQuery = {
  listPrintedSubcategories?:  {
    __typename: "ModelPrintedSubcategoryConnection",
    items:  Array< {
      __typename: "PrintedSubcategory",
      id: string,
      name: string,
      printedCategoryId: string,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      parent:  {
        __typename: "PrintedCategory",
        id: string,
        name: string,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        route: string,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        printedSubcategories?:  {
          __typename: "ModelPrintedSubcategoryConnection",
          nextToken?: string | null,
        } | null,
        printedProducts?:  {
          __typename: "ModelPrintedProductsConnection",
          nextToken?: string | null,
        } | null,
        created: number,
        visibleFor?: Array< string | null > | null,
        region?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      },
      created: number,
      printedProducts?:  {
        __typename: "ModelPrintedProductsConnection",
        items:  Array< {
          __typename: "PrintedProducts",
          id: string,
          status: string,
          position: string,
          name: string,
          width: number,
          height: number,
          price: number,
          long_description?: string | null,
          short_description?: string | null,
          creator?: string | null,
          providerId: string,
          finalDimensions?: number | null,
          pagesNumber?: number | null,
          finishes?: string | null,
          inksFourByCero?: string | null,
          inksFourByFour?: string | null,
          paperKind?: string | null,
          grammage?: string | null,
          hasBarniz?: boolean | null,
          hasRebase?: boolean | null,
          orientation?: string | null,
          specialInstructions?: string | null,
          PrintedSubcategoryId: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          regions?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPrintedProductsQueryVariables = {
  id: string,
};

export type GetPrintedProductsQuery = {
  getPrintedProducts?:  {
    __typename: "PrintedProducts",
    id: string,
    status: string,
    position: string,
    name: string,
    width: number,
    height: number,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    price: number,
    long_description?: string | null,
    short_description?: string | null,
    creator?: string | null,
    providerId: string,
    finalDimensions?: number | null,
    pagesNumber?: number | null,
    finishes?: string | null,
    inksFourByCero?: string | null,
    inksFourByFour?: string | null,
    paperKind?: string | null,
    grammage?: string | null,
    hasBarniz?: boolean | null,
    hasRebase?: boolean | null,
    orientation?: string | null,
    specialInstructions?: string | null,
    PrintedSubcategoryId: string,
    printedCategoryId: string,
    created: number,
    variants?:  Array< {
      __typename: "Variants",
      sku?: string | null,
      name?: string | null,
      description?: string | null,
      colors?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock_available?: number | null,
      price?: number | null,
      size?: string | null,
      logoType?: string | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPrintedProductsQueryVariables = {
  filter?: ModelPrintedProductsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrintedProductsQuery = {
  listPrintedProducts?:  {
    __typename: "ModelPrintedProductsConnection",
    items:  Array< {
      __typename: "PrintedProducts",
      id: string,
      status: string,
      position: string,
      name: string,
      width: number,
      height: number,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      price: number,
      long_description?: string | null,
      short_description?: string | null,
      creator?: string | null,
      providerId: string,
      finalDimensions?: number | null,
      pagesNumber?: number | null,
      finishes?: string | null,
      inksFourByCero?: string | null,
      inksFourByFour?: string | null,
      paperKind?: string | null,
      grammage?: string | null,
      hasBarniz?: boolean | null,
      hasRebase?: boolean | null,
      orientation?: string | null,
      specialInstructions?: string | null,
      PrintedSubcategoryId: string,
      printedCategoryId: string,
      created: number,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPrintedRfqQueryVariables = {
  id: string,
};

export type GetPrintedRfqQuery = {
  getPrintedRfq?:  {
    __typename: "PrintedRfq",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    limit_time: number,
    proposals?:  {
      __typename: "ModelPrintedProposalConnection",
      items:  Array< {
        __typename: "PrintedProposal",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        products?:  Array< {
          __typename: "PrintedProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name: string,
          description: string,
          priceUnit: number,
          pieces: number,
          total: number,
          idProducto: number,
        } | null > | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "PrintedRfq",
          id: string,
          nombre: string,
          requerimiento: string,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          estatus: string,
          printedOrderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
        } | null,
        printedProposalRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    estatus: string,
    printedOrderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    providers?:  Array< {
      __typename: "RfqPrintedProviders",
      idProvider?: string | null,
    } | null > | null,
    printedProductsRfq:  Array< {
      __typename: "PrintedProductUnitRfq",
      name: string,
      description: string,
      pieces: number,
      createdId: number,
    } | null >,
  } | null,
};

export type ListPrintedRfqsQueryVariables = {
  filter?: ModelPrintedRfqFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrintedRfqsQuery = {
  listPrintedRfqs?:  {
    __typename: "ModelPrintedRfqConnection",
    items:  Array< {
      __typename: "PrintedRfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      proposals?:  {
        __typename: "ModelPrintedProposalConnection",
        items:  Array< {
          __typename: "PrintedProposal",
          id: string,
          provider_id: string,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          hidden?: boolean | null,
          printedProposalRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      printedOrderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      providers?:  Array< {
        __typename: "RfqPrintedProviders",
        idProvider?: string | null,
      } | null > | null,
      printedProductsRfq:  Array< {
        __typename: "PrintedProductUnitRfq",
        name: string,
        description: string,
        pieces: number,
        createdId: number,
      } | null >,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPrintedProductoRfqQueryVariables = {
  id: string,
};

export type GetPrintedProductoRfqQuery = {
  getPrintedProductoRfq?:  {
    __typename: "PrintedProductoRfq",
    id: string,
    name: string,
    description: string,
    category_id: string,
    provider_id: string,
    price?: number | null,
    category?: string | null,
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    estatus?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPrintedProductoRfqsQueryVariables = {
  filter?: ModelPrintedProductoRfqFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrintedProductoRfqsQuery = {
  listPrintedProductoRfqs?:  {
    __typename: "ModelPrintedProductoRfqConnection",
    items:  Array< {
      __typename: "PrintedProductoRfq",
      id: string,
      name: string,
      description: string,
      category_id: string,
      provider_id: string,
      price?: number | null,
      category?: string | null,
      images?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      estatus?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPrintedProposalQueryVariables = {
  id: string,
};

export type GetPrintedProposalQuery = {
  getPrintedProposal?:  {
    __typename: "PrintedProposal",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    products?:  Array< {
      __typename: "PrintedProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name: string,
      description: string,
      priceUnit: number,
      pieces: number,
      total: number,
      idProducto: number,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "PrintedRfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      proposals?:  {
        __typename: "ModelPrintedProposalConnection",
        items:  Array< {
          __typename: "PrintedProposal",
          id: string,
          provider_id: string,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          hidden?: boolean | null,
          printedProposalRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      printedOrderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      providers?:  Array< {
        __typename: "RfqPrintedProviders",
        idProvider?: string | null,
      } | null > | null,
      printedProductsRfq:  Array< {
        __typename: "PrintedProductUnitRfq",
        name: string,
        description: string,
        pieces: number,
        createdId: number,
      } | null >,
    } | null,
    printedProposalRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPrintedProposalsQueryVariables = {
  filter?: ModelPrintedProposalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrintedProposalsQuery = {
  listPrintedProposals?:  {
    __typename: "ModelPrintedProposalConnection",
    items:  Array< {
      __typename: "PrintedProposal",
      id: string,
      provider_id: string,
      delivery_time:  {
        __typename: "Range",
        lower: number,
        upper: number,
      },
      price: number,
      validity_days?: number | null,
      description?: string | null,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      created: number,
      updated?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      products?:  Array< {
        __typename: "PrintedProductsProposals",
        productUnitRfqIndex?: number | null,
        selected?: boolean | null,
        name: string,
        description: string,
        priceUnit: number,
        pieces: number,
        total: number,
        idProducto: number,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
      } | null > | null,
      hidden?: boolean | null,
      rfq?:  {
        __typename: "PrintedRfq",
        id: string,
        nombre: string,
        requerimiento: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        compras?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        limit_time: number,
        proposals?:  {
          __typename: "ModelPrintedProposalConnection",
          nextToken?: string | null,
        } | null,
        creator?: string | null,
        creatorInfo?:  {
          __typename: "OrderCreator",
          name: string,
          email: string,
          user_id: string,
        } | null,
        clientId: string,
        winner?:  {
          __typename: "Winner",
          proveeedor_id: string,
          date: number,
        } | null,
        logs?:  Array< {
          __typename: "Logs",
          creatorId: string,
          description: string,
          date: number,
          status?: string | null,
          provider_id?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        estatus: string,
        printedOrderId?: number | null,
        start_time: number,
        delivery_time?: number | null,
        created: number,
        saving?: number | null,
        saving_percentage?: number | null,
        saving_real?: number | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        updated?: number | null,
        providers?:  Array< {
          __typename: "RfqPrintedProviders",
          idProvider?: string | null,
        } | null > | null,
        printedProductsRfq:  Array< {
          __typename: "PrintedProductUnitRfq",
          name: string,
          description: string,
          pieces: number,
          createdId: number,
        } | null >,
      } | null,
      printedProposalRfqId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPrintedOrderQueryVariables = {
  id: string,
};

export type GetPrintedOrderQuery = {
  getPrintedOrder?:  {
    __typename: "PrintedOrder",
    id: string,
    orderId: number,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_time?: number | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    listProviders?:  Array< {
      __typename: "ListProvidersOrder",
      provider_id: string,
      order_id: string,
      payment_date?: number | null,
      gr_code?: string | null,
      order_confirmation?: boolean | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      delivered?: boolean | null,
      deliveredFormat?: boolean | null,
    } | null > | null,
    listProvidersKey?: Array< string | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    listPrintedProducts:  Array< {
      __typename: "PrintedProductInOrder",
      product_id: string,
      provider_id?: string | null,
      visible?: boolean | null,
      product_name: string,
      price?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
    } >,
    cotizationsList:  Array< {
      __typename: "PrintedOrderCotizationsLog",
      id: number,
      created: number,
      createdBy: string,
      products:  Array< {
        __typename: "PrintedProductInOrder",
        product_id: string,
        provider_id?: string | null,
        visible?: boolean | null,
        product_name: string,
        price?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
      } >,
    } | null >,
    orderCreatorId: string,
    creator:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    },
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    printedOrderClientId?: string | null,
    subtotal?: number | null,
    total?: number | null,
    isCoupa?: boolean | null,
    sentToCoupa?: boolean | null,
    isRfq?: boolean | null,
    status?: string | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    updatedAt?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
  } | null,
};

export type ListPrintedOrdersQueryVariables = {
  filter?: ModelPrintedOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrintedOrdersQuery = {
  listPrintedOrders?:  {
    __typename: "ModelPrintedOrderConnection",
    items:  Array< {
      __typename: "PrintedOrder",
      id: string,
      orderId: number,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      listProviders?:  Array< {
        __typename: "ListProvidersOrder",
        provider_id: string,
        order_id: string,
        payment_date?: number | null,
        gr_code?: string | null,
        order_confirmation?: boolean | null,
        invoice?: boolean | null,
        invoiceRequested?: boolean | null,
        uploadedGr?: boolean | null,
        uploadedBill?: boolean | null,
        delivered?: boolean | null,
        deliveredFormat?: boolean | null,
      } | null > | null,
      listProvidersKey?: Array< string | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      listPrintedProducts:  Array< {
        __typename: "PrintedProductInOrder",
        product_id: string,
        provider_id?: string | null,
        visible?: boolean | null,
        product_name: string,
        price?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
      } >,
      cotizationsList:  Array< {
        __typename: "PrintedOrderCotizationsLog",
        id: number,
        created: number,
        createdBy: string,
        products:  Array< {
          __typename: "PrintedProductInOrder",
          product_id: string,
          provider_id?: string | null,
          visible?: boolean | null,
          product_name: string,
          price?: number | null,
          sample_requested?: boolean | null,
          sample_request?: boolean | null,
          uploadedSample?: boolean | null,
          quantity: number,
        } >,
      } | null >,
      orderCreatorId: string,
      creator:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      },
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      printedOrderClientId?: string | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa?: boolean | null,
      sentToCoupa?: boolean | null,
      isRfq?: boolean | null,
      status?: string | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      updatedAt?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPrintedOrderProvidersQueryVariables = {
  id: string,
};

export type GetPrintedOrderProvidersQuery = {
  getPrintedOrderProviders?:  {
    __typename: "PrintedOrderProviders",
    id: string,
    provider_id: string,
    orderId?: number | null,
    printedOrderProvidersPrintedOrderId: string,
    payment_date?: number | null,
    gr_code?: string | null,
    invoice?: boolean | null,
    invoiceRequested?: boolean | null,
    uploadedGr?: boolean | null,
    uploadedBill?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPrintedOrderProvidersQueryVariables = {
  filter?: ModelPrintedOrderProvidersFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrintedOrderProvidersQuery = {
  listPrintedOrderProviders?:  {
    __typename: "ModelPrintedOrderProvidersConnection",
    items:  Array< {
      __typename: "PrintedOrderProviders",
      id: string,
      provider_id: string,
      orderId?: number | null,
      printedOrderProvidersPrintedOrderId: string,
      payment_date?: number | null,
      gr_code?: string | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPayOnBehalfRequestsQueryVariables = {
  id: string,
};

export type GetPayOnBehalfRequestsQuery = {
  getPayOnBehalfRequests?:  {
    __typename: "PayOnBehalfRequests",
    id: string,
    clientId?: string | null,
    companyName?: string | null,
    purchaseOrder?: string | null,
    paymentTerms?: string | null,
    currency?: string | null,
    amount?: number | null,
    selectedVa?: boolean | null,
    iva?: number | null,
    vat?: number | null,
    total?: number | null,
    rfc?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bankStatement?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    supplierQuote?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPayOnBehalfRequestsQueryVariables = {
  filter?: ModelPayOnBehalfRequestsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPayOnBehalfRequestsQuery = {
  listPayOnBehalfRequests?:  {
    __typename: "ModelPayOnBehalfRequestsConnection",
    items:  Array< {
      __typename: "PayOnBehalfRequests",
      id: string,
      clientId?: string | null,
      companyName?: string | null,
      purchaseOrder?: string | null,
      paymentTerms?: string | null,
      currency?: string | null,
      amount?: number | null,
      selectedVa?: boolean | null,
      iva?: number | null,
      vat?: number | null,
      total?: number | null,
      rfc?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      bankStatement?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      supplierQuote?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      created: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBuyerContactClientQueryVariables = {
  id: string,
};

export type GetBuyerContactClientQuery = {
  getBuyerContactClient?:  {
    __typename: "BuyerContactClient",
    id: string,
    companyId: string,
    status?: boolean | null,
    defaultContact?: boolean | null,
    name?: string | null,
    email?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListBuyerContactClientsQueryVariables = {
  filter?: ModelBuyerContactClientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBuyerContactClientsQuery = {
  listBuyerContactClients?:  {
    __typename: "ModelBuyerContactClientConnection",
    items:  Array< {
      __typename: "BuyerContactClient",
      id: string,
      companyId: string,
      status?: boolean | null,
      defaultContact?: boolean | null,
      name?: string | null,
      email?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBrandFactoryRfqEmailsQueryVariables = {
  id: string,
};

export type GetBrandFactoryRfqEmailsQuery = {
  getBrandFactoryRfqEmails?:  {
    __typename: "BrandFactoryRfqEmails",
    id: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBrandFactoryRfqEmailsQueryVariables = {
  filter?: ModelBrandFactoryRfqEmailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBrandFactoryRfqEmailsQuery = {
  listBrandFactoryRfqEmails?:  {
    __typename: "ModelBrandFactoryRfqEmailsConnection",
    items:  Array< {
      __typename: "BrandFactoryRfqEmails",
      id: string,
      status: boolean,
      name: string,
      email: string,
      created: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAutomobilesEmailsQueryVariables = {
  id: string,
};

export type GetAutomobilesEmailsQuery = {
  getAutomobilesEmails?:  {
    __typename: "AutomobilesEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAutomobilesEmailsQueryVariables = {
  filter?: ModelAutomobilesEmailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAutomobilesEmailsQuery = {
  listAutomobilesEmails?:  {
    __typename: "ModelAutomobilesEmailsConnection",
    items:  Array< {
      __typename: "AutomobilesEmails",
      id: string,
      companyId: string,
      status: boolean,
      name: string,
      email: string,
      created: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetQAEmailsQueryVariables = {
  id: string,
};

export type GetQAEmailsQuery = {
  getQAEmails?:  {
    __typename: "QAEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListQAEmailsQueryVariables = {
  filter?: ModelQAEmailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListQAEmailsQuery = {
  listQAEmails?:  {
    __typename: "ModelQAEmailsConnection",
    items:  Array< {
      __typename: "QAEmails",
      id: string,
      companyId: string,
      status: boolean,
      name: string,
      email: string,
      created: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOrderPopAdminEmailsQueryVariables = {
  id: string,
};

export type GetOrderPopAdminEmailsQuery = {
  getOrderPopAdminEmails?:  {
    __typename: "OrderPopAdminEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListOrderPopAdminEmailsQueryVariables = {
  filter?: ModelOrderPopAdminEmailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrderPopAdminEmailsQuery = {
  listOrderPopAdminEmails?:  {
    __typename: "ModelOrderPopAdminEmailsConnection",
    items:  Array< {
      __typename: "OrderPopAdminEmails",
      id: string,
      companyId: string,
      status: boolean,
      name: string,
      email: string,
      created: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOrderPopCheckoutEmailsQueryVariables = {
  id: string,
};

export type GetOrderPopCheckoutEmailsQuery = {
  getOrderPopCheckoutEmails?:  {
    __typename: "OrderPopCheckoutEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListOrderPopCheckoutEmailsQueryVariables = {
  filter?: ModelOrderPopCheckoutEmailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOrderPopCheckoutEmailsQuery = {
  listOrderPopCheckoutEmails?:  {
    __typename: "ModelOrderPopCheckoutEmailsConnection",
    items:  Array< {
      __typename: "OrderPopCheckoutEmails",
      id: string,
      companyId: string,
      status: boolean,
      name: string,
      email: string,
      created: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetGREmailsQueryVariables = {
  id: string,
};

export type GetGREmailsQuery = {
  getGREmails?:  {
    __typename: "GREmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListGREmailsQueryVariables = {
  filter?: ModelGREmailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListGREmailsQuery = {
  listGREmails?:  {
    __typename: "ModelGREmailsConnection",
    items:  Array< {
      __typename: "GREmails",
      id: string,
      companyId: string,
      status: boolean,
      name: string,
      email: string,
      created: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRegionsQueryVariables = {
  id: string,
};

export type GetRegionsQuery = {
  getRegions?:  {
    __typename: "Regions",
    id: string,
    status: boolean,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListRegionsQueryVariables = {
  filter?: ModelRegionsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRegionsQuery = {
  listRegions?:  {
    __typename: "ModelRegionsConnection",
    items:  Array< {
      __typename: "Regions",
      id: string,
      status: boolean,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDefaultAddressQueryVariables = {
  id: string,
};

export type GetDefaultAddressQuery = {
  getDefaultAddress?:  {
    __typename: "DefaultAddress",
    id: string,
    companyId: string,
    userId?: string | null,
    status: boolean,
    address:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    },
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListDefaultAddressesQueryVariables = {
  filter?: ModelDefaultAddressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDefaultAddressesQuery = {
  listDefaultAddresses?:  {
    __typename: "ModelDefaultAddressConnection",
    items:  Array< {
      __typename: "DefaultAddress",
      id: string,
      companyId: string,
      userId?: string | null,
      status: boolean,
      address:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      },
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDefaultDeliveryContactQueryVariables = {
  id: string,
};

export type GetDefaultDeliveryContactQuery = {
  getDefaultDeliveryContact?:  {
    __typename: "DefaultDeliveryContact",
    id: string,
    companyId?: string | null,
    userId?: string | null,
    status?: boolean | null,
    name?: string | null,
    phoneNumber?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListDefaultDeliveryContactsQueryVariables = {
  filter?: ModelDefaultDeliveryContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDefaultDeliveryContactsQuery = {
  listDefaultDeliveryContacts?:  {
    __typename: "ModelDefaultDeliveryContactConnection",
    items:  Array< {
      __typename: "DefaultDeliveryContact",
      id: string,
      companyId?: string | null,
      userId?: string | null,
      status?: boolean | null,
      name?: string | null,
      phoneNumber?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPopCategoriesQueryVariables = {
  id: string,
};

export type GetPopCategoriesQuery = {
  getPopCategories?:  {
    __typename: "PopCategories",
    id: string,
    materialId: string,
    name: string,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPopCategoriesQueryVariables = {
  filter?: ModelPopCategoriesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPopCategoriesQuery = {
  listPopCategories?:  {
    __typename: "ModelPopCategoriesConnection",
    items:  Array< {
      __typename: "PopCategories",
      id: string,
      materialId: string,
      name: string,
      visibleFor?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      created: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRfpQueryVariables = {
  id: string,
};

export type GetRfpQuery = {
  getRfp?:  {
    __typename: "Rfp",
    id: string,
    clientId?: string | null,
    status?: string | null,
    name?: string | null,
    nombre?: string | null,
    requerimiento?: string | null,
    estatus?: string | null,
    descripcion?: string | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    url?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    proposals?:  {
      __typename: "ModelRfpProposalsConnection",
      items:  Array< {
        __typename: "RfpProposals",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        name?: string | null,
        description?: string | null,
        validity_days?: number | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfp?:  {
          __typename: "Rfp",
          id: string,
          clientId?: string | null,
          status?: string | null,
          name?: string | null,
          nombre?: string | null,
          requerimiento?: string | null,
          estatus?: string | null,
          descripcion?: string | null,
          url?: string | null,
          limit_time: number,
          creator?: string | null,
          start_time: number,
          delivery_time?: number | null,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          created: number,
          createdAt?: string | null,
          updated?: number | null,
          updatedAt: string,
        } | null,
        rfpProposalsRfpId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    limit_time: number,
    creator?: string | null,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    providers?:  Array< {
      __typename: "RfpProviders",
      idProvider?: string | null,
    } | null > | null,
    start_time: number,
    delivery_time?: number | null,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    created: number,
    createdAt?: string | null,
    updated?: number | null,
    updatedAt: string,
  } | null,
};

export type ListRfpsQueryVariables = {
  filter?: ModelRfpFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRfpsQuery = {
  listRfps?:  {
    __typename: "ModelRfpConnection",
    items:  Array< {
      __typename: "Rfp",
      id: string,
      clientId?: string | null,
      status?: string | null,
      name?: string | null,
      nombre?: string | null,
      requerimiento?: string | null,
      estatus?: string | null,
      descripcion?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      url?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      proposals?:  {
        __typename: "ModelRfpProposalsConnection",
        items:  Array< {
          __typename: "RfpProposals",
          id: string,
          provider_id: string,
          price: number,
          name?: string | null,
          description?: string | null,
          validity_days?: number | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          rfpProposalsRfpId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      creator?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfpProviders",
        idProvider?: string | null,
      } | null > | null,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRfpProposalsQueryVariables = {
  id: string,
};

export type GetRfpProposalsQuery = {
  getRfpProposals?:  {
    __typename: "RfpProposals",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    name?: string | null,
    description?: string | null,
    validity_days?: number | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfp?:  {
      __typename: "Rfp",
      id: string,
      clientId?: string | null,
      status?: string | null,
      name?: string | null,
      nombre?: string | null,
      requerimiento?: string | null,
      estatus?: string | null,
      descripcion?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      url?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      proposals?:  {
        __typename: "ModelRfpProposalsConnection",
        items:  Array< {
          __typename: "RfpProposals",
          id: string,
          provider_id: string,
          price: number,
          name?: string | null,
          description?: string | null,
          validity_days?: number | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          rfpProposalsRfpId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      creator?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfpProviders",
        idProvider?: string | null,
      } | null > | null,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null,
    rfpProposalsRfpId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListRfpProposalsQueryVariables = {
  filter?: ModelRfpProposalsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRfpProposalsQuery = {
  listRfpProposals?:  {
    __typename: "ModelRfpProposalsConnection",
    items:  Array< {
      __typename: "RfpProposals",
      id: string,
      provider_id: string,
      delivery_time:  {
        __typename: "Range",
        lower: number,
        upper: number,
      },
      price: number,
      name?: string | null,
      description?: string | null,
      validity_days?: number | null,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      created: number,
      updated?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      products?:  Array< {
        __typename: "ProductsProposals",
        productUnitRfqIndex?: number | null,
        selected?: boolean | null,
        name?: string | null,
        description?: string | null,
        priceUnit?: number | null,
        pieces?: number | null,
        total?: number | null,
        idProducto?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
      } | null > | null,
      multipleProducts?: boolean | null,
      hidden?: boolean | null,
      rfp?:  {
        __typename: "Rfp",
        id: string,
        clientId?: string | null,
        status?: string | null,
        name?: string | null,
        nombre?: string | null,
        requerimiento?: string | null,
        estatus?: string | null,
        descripcion?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        url?: string | null,
        creatorInfo?:  {
          __typename: "OrderCreator",
          name: string,
          email: string,
          user_id: string,
        } | null,
        proposals?:  {
          __typename: "ModelRfpProposalsConnection",
          nextToken?: string | null,
        } | null,
        compras?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        limit_time: number,
        creator?: string | null,
        winner?:  {
          __typename: "Winner",
          proveeedor_id: string,
          date: number,
        } | null,
        logs?:  Array< {
          __typename: "Logs",
          creatorId: string,
          description: string,
          date: number,
          status?: string | null,
          provider_id?: string | null,
        } | null > | null,
        providers?:  Array< {
          __typename: "RfpProviders",
          idProvider?: string | null,
        } | null > | null,
        start_time: number,
        delivery_time?: number | null,
        saving?: number | null,
        saving_percentage?: number | null,
        saving_real?: number | null,
        created: number,
        createdAt?: string | null,
        updated?: number | null,
        updatedAt: string,
      } | null,
      rfpProposalsRfpId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEvaluationProvidersQueryVariables = {
  id: string,
};

export type GetEvaluationProvidersQuery = {
  getEvaluationProviders?:  {
    __typename: "EvaluationProviders",
    id: string,
    providerId?: string | null,
    creratorId?: string | null,
    orderId?: string | null,
    time?: number | null,
    price?: number | null,
    quality?: number | null,
    att?: number | null,
    comments?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEvaluationProvidersQueryVariables = {
  filter?: ModelEvaluationProvidersFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEvaluationProvidersQuery = {
  listEvaluationProviders?:  {
    __typename: "ModelEvaluationProvidersConnection",
    items:  Array< {
      __typename: "EvaluationProviders",
      id: string,
      providerId?: string | null,
      creratorId?: string | null,
      orderId?: string | null,
      time?: number | null,
      price?: number | null,
      quality?: number | null,
      att?: number | null,
      comments?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLogProductQueryVariables = {
  id: string,
};

export type GetLogProductQuery = {
  getLogProduct?:  {
    __typename: "LogProduct",
    id: string,
    status?: string | null,
    creator?: string | null,
    created?: string | null,
    productId?: string | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLogProductsQueryVariables = {
  filter?: ModelLogProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogProductsQuery = {
  listLogProducts?:  {
    __typename: "ModelLogProductConnection",
    items:  Array< {
      __typename: "LogProduct",
      id: string,
      status?: string | null,
      creator?: string | null,
      created?: string | null,
      productId?: string | null,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLogRfqQueryVariables = {
  id: string,
};

export type GetLogRfqQuery = {
  getLogRfq?:  {
    __typename: "LogRfq",
    id: string,
    status?: string | null,
    creator?: string | null,
    rfqId: string,
    description?: string | null,
    provider_id?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListLogRfqsQueryVariables = {
  filter?: ModelLogRfqFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogRfqsQuery = {
  listLogRfqs?:  {
    __typename: "ModelLogRfqConnection",
    items:  Array< {
      __typename: "LogRfq",
      id: string,
      status?: string | null,
      creator?: string | null,
      rfqId: string,
      description?: string | null,
      provider_id?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLogProductLabelQueryVariables = {
  id: string,
};

export type GetLogProductLabelQuery = {
  getLogProductLabel?:  {
    __typename: "LogProductLabel",
    id: string,
    status?: string | null,
    creator?: string | null,
    created?: string | null,
    productLabelId?: string | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLogProductLabelsQueryVariables = {
  filter?: ModelLogProductLabelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogProductLabelsQuery = {
  listLogProductLabels?:  {
    __typename: "ModelLogProductLabelConnection",
    items:  Array< {
      __typename: "LogProductLabel",
      id: string,
      status?: string | null,
      creator?: string | null,
      created?: string | null,
      productLabelId?: string | null,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLogGanadorAutoQueryVariables = {
  id: string,
};

export type GetLogGanadorAutoQuery = {
  getLogGanadorAuto?:  {
    __typename: "LogGanadorAuto",
    id: string,
    id_auto?: string | null,
    id_user?: string | null,
    fecha_rifa?: number | null,
    email?: string | null,
    nombre?: string | null,
    a_paterno?: string | null,
    a_materno?: string | null,
    status_buyer?: boolean | null,
    date_buyer?: number | null,
    winner?: number | null,
    refused?: number | null,
    since?: string | null,
    process_buyer?: boolean | null,
    reactive?: boolean | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLogGanadorAutosQueryVariables = {
  filter?: ModelLogGanadorAutoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogGanadorAutosQuery = {
  listLogGanadorAutos?:  {
    __typename: "ModelLogGanadorAutoConnection",
    items:  Array< {
      __typename: "LogGanadorAuto",
      id: string,
      id_auto?: string | null,
      id_user?: string | null,
      fecha_rifa?: number | null,
      email?: string | null,
      nombre?: string | null,
      a_paterno?: string | null,
      a_materno?: string | null,
      status_buyer?: boolean | null,
      date_buyer?: number | null,
      winner?: number | null,
      refused?: number | null,
      since?: string | null,
      process_buyer?: boolean | null,
      reactive?: boolean | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetNotificationQueryVariables = {
  id: string,
};

export type GetNotificationQuery = {
  getNotification?:  {
    __typename: "Notification",
    id: string,
    type: string,
    remember?: string | null,
    stared?: string | null,
    important?: string | null,
    status?: string | null,
    isChat?: string | null,
    creatorName: string,
    creatorEmail: string,
    creatorRole?: string | null,
    creatorId: string,
    receipentName: string,
    receipentRole?: string | null,
    receipentEmail?: string | null,
    receipentId: string,
    showPopUp?: boolean | null,
    sendEmail?: boolean | null,
    title: string,
    subtitle: string,
    description: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    path?: string | null,
    idParent?: string | null,
    createdAt?: string | null,
    seenAt?: number | null,
    updatedAt: string,
  } | null,
};

export type ListNotificationsQueryVariables = {
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListNotificationsQuery = {
  listNotifications?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      type: string,
      remember?: string | null,
      stared?: string | null,
      important?: string | null,
      status?: string | null,
      isChat?: string | null,
      creatorName: string,
      creatorEmail: string,
      creatorRole?: string | null,
      creatorId: string,
      receipentName: string,
      receipentRole?: string | null,
      receipentEmail?: string | null,
      receipentId: string,
      showPopUp?: boolean | null,
      sendEmail?: boolean | null,
      title: string,
      subtitle: string,
      description: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      path?: string | null,
      idParent?: string | null,
      createdAt?: string | null,
      seenAt?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMercadoCategoriesQueryVariables = {
  id: string,
};

export type GetMercadoCategoriesQuery = {
  getMercadoCategories?:  {
    __typename: "MercadoCategories",
    id: string,
    idMercado?: string | null,
    status?: string | null,
    name?: string | null,
    rulesClients?:  Array< {
      __typename: "MercadoCategoryClientRule",
      clientID?: string | null,
      enabled?: boolean | null,
      isUnrestricted?: boolean | null,
      isRestricted?: boolean | null,
      increment?: number | null,
      fee?: number | null,
    } | null > | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    parentCategory?: string | null,
    childrenCategories?: Array< string | null > | null,
    items?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMercadoCategoriesQueryVariables = {
  filter?: ModelMercadoCategoriesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMercadoCategoriesQuery = {
  listMercadoCategories?:  {
    __typename: "ModelMercadoCategoriesConnection",
    items:  Array< {
      __typename: "MercadoCategories",
      id: string,
      idMercado?: string | null,
      status?: string | null,
      name?: string | null,
      rulesClients?:  Array< {
        __typename: "MercadoCategoryClientRule",
        clientID?: string | null,
        enabled?: boolean | null,
        isUnrestricted?: boolean | null,
        isRestricted?: boolean | null,
        increment?: number | null,
        fee?: number | null,
      } | null > | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      parentCategory?: string | null,
      childrenCategories?: Array< string | null > | null,
      items?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMercadoProductCategoryClientQueryVariables = {
  id: string,
};

export type GetMercadoProductCategoryClientQuery = {
  getMercadoProductCategoryClient?:  {
    __typename: "MercadoProductCategoryClient",
    id: string,
    idClient?: string | null,
    idMercadoCategory?: string | null,
    unrestrictedProducts?: Array< string | null > | null,
    restrictedProducts?: Array< string | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMercadoProductCategoryClientsQueryVariables = {
  filter?: ModelMercadoProductCategoryClientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMercadoProductCategoryClientsQuery = {
  listMercadoProductCategoryClients?:  {
    __typename: "ModelMercadoProductCategoryClientConnection",
    items:  Array< {
      __typename: "MercadoProductCategoryClient",
      id: string,
      idClient?: string | null,
      idMercadoCategory?: string | null,
      unrestrictedProducts?: Array< string | null > | null,
      restrictedProducts?: Array< string | null > | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetExternalApisQueryVariables = {
  id: string,
};

export type GetExternalApisQuery = {
  getExternalApis?:  {
    __typename: "ExternalApis",
    id: string,
    status?: string | null,
    name?: string | null,
    nameExternal?: string | null,
    region?: Array< string | null > | null,
    increment?: number | null,
    discount?: number | null,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListExternalApisQueryVariables = {
  filter?: ModelExternalApisFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListExternalApisQuery = {
  listExternalApis?:  {
    __typename: "ModelExternalApisConnection",
    items:  Array< {
      __typename: "ExternalApis",
      id: string,
      status?: string | null,
      name?: string | null,
      nameExternal?: string | null,
      region?: Array< string | null > | null,
      increment?: number | null,
      discount?: number | null,
      visibleFor?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPrintPricesQueryVariables = {
  id: string,
};

export type GetPrintPricesQuery = {
  getPrintPrices?:  {
    __typename: "PrintPrices",
    id: string,
    identifier?: number | null,
    status?: string | null,
    creator?: string | null,
    description?: string | null,
    price?: number | null,
    minUnits?: number | null,
    maxUnits?: number | null,
    ranges?:  Array< {
      __typename: "PrintPriceRange",
      price?: number | null,
      minUnits?: number | null,
      maxUnits?: number | null,
    } | null > | null,
    clientPrintPrices?:  Array< {
      __typename: "ClientPrintPrice",
      clientId?: string | null,
      price?: number | null,
      minUnits?: number | null,
      maxUnits?: number | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPrintPricesQueryVariables = {
  filter?: ModelPrintPricesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrintPricesQuery = {
  listPrintPrices?:  {
    __typename: "ModelPrintPricesConnection",
    items:  Array< {
      __typename: "PrintPrices",
      id: string,
      identifier?: number | null,
      status?: string | null,
      creator?: string | null,
      description?: string | null,
      price?: number | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      ranges?:  Array< {
        __typename: "PrintPriceRange",
        price?: number | null,
        minUnits?: number | null,
        maxUnits?: number | null,
      } | null > | null,
      clientPrintPrices?:  Array< {
        __typename: "ClientPrintPrice",
        clientId?: string | null,
        price?: number | null,
        minUnits?: number | null,
        maxUnits?: number | null,
      } | null > | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPrintLogosQueryVariables = {
  id: string,
};

export type GetPrintLogosQuery = {
  getPrintLogos?:  {
    __typename: "PrintLogos",
    id: string,
    status?: string | null,
    creator?: string | null,
    description?: string | null,
    identifier?: number | null,
    clientId?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type ListPrintLogosQueryVariables = {
  filter?: ModelPrintLogosFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrintLogosQuery = {
  listPrintLogos?:  {
    __typename: "ModelPrintLogosConnection",
    items:  Array< {
      __typename: "PrintLogos",
      id: string,
      status?: string | null,
      creator?: string | null,
      description?: string | null,
      identifier?: number | null,
      clientId?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      createdAt: string,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLogisticPostalCodeQueryVariables = {
  id: string,
};

export type GetLogisticPostalCodeQuery = {
  getLogisticPostalCode?:  {
    __typename: "LogisticPostalCode",
    id: string,
    cpFrom: string,
    cpTo: string,
    zone: number,
    state: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLogisticPostalCodesQueryVariables = {
  filter?: ModelLogisticPostalCodeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogisticPostalCodesQuery = {
  listLogisticPostalCodes?:  {
    __typename: "ModelLogisticPostalCodeConnection",
    items:  Array< {
      __typename: "LogisticPostalCode",
      id: string,
      cpFrom: string,
      cpTo: string,
      zone: number,
      state: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLogisticPieceRangeQueryVariables = {
  id: string,
};

export type GetLogisticPieceRangeQuery = {
  getLogisticPieceRange?:  {
    __typename: "LogisticPieceRange",
    id: string,
    piecesRange: number,
    min: number,
    max: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLogisticPieceRangesQueryVariables = {
  filter?: ModelLogisticPieceRangeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogisticPieceRangesQuery = {
  listLogisticPieceRanges?:  {
    __typename: "ModelLogisticPieceRangeConnection",
    items:  Array< {
      __typename: "LogisticPieceRange",
      id: string,
      piecesRange: number,
      min: number,
      max: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLogisticWeightRangeQueryVariables = {
  id: string,
};

export type GetLogisticWeightRangeQuery = {
  getLogisticWeightRange?:  {
    __typename: "LogisticWeightRange",
    id: string,
    weightRange: number,
    min: number,
    max: number,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLogisticWeightRangesQueryVariables = {
  filter?: ModelLogisticWeightRangeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogisticWeightRangesQuery = {
  listLogisticWeightRanges?:  {
    __typename: "ModelLogisticWeightRangeConnection",
    items:  Array< {
      __typename: "LogisticWeightRange",
      id: string,
      weightRange: number,
      min: number,
      max: number,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLogisticWeightBoxQueryVariables = {
  id: string,
};

export type GetLogisticWeightBoxQuery = {
  getLogisticWeightBox?:  {
    __typename: "LogisticWeightBox",
    id: string,
    boxId?: string | null,
    shippingPrices?:  Array< {
      __typename: "LogisticWeightPrice",
      weightRangeId?: string | null,
      price: number,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLogisticWeightBoxesQueryVariables = {
  filter?: ModelLogisticWeightBoxFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogisticWeightBoxesQuery = {
  listLogisticWeightBoxes?:  {
    __typename: "ModelLogisticWeightBoxConnection",
    items:  Array< {
      __typename: "LogisticWeightBox",
      id: string,
      boxId?: string | null,
      shippingPrices?:  Array< {
        __typename: "LogisticWeightPrice",
        weightRangeId?: string | null,
        price: number,
      } | null > | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLogisticZoneQueryVariables = {
  id: string,
};

export type GetLogisticZoneQuery = {
  getLogisticZone?:  {
    __typename: "LogisticZone",
    id: string,
    zoneName: string,
    shippingPrices?:  Array< {
      __typename: "LogisticShippingPrice",
      piecesRangeId?: string | null,
      price: number,
    } | null > | null,
    clientsRanges?:  Array< {
      __typename: "LogisticPieceRangeClient",
      id: string,
      clientId: string,
      piecesRange: string,
      price: number,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLogisticZonesQueryVariables = {
  filter?: ModelLogisticZoneFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogisticZonesQuery = {
  listLogisticZones?:  {
    __typename: "ModelLogisticZoneConnection",
    items:  Array< {
      __typename: "LogisticZone",
      id: string,
      zoneName: string,
      shippingPrices?:  Array< {
        __typename: "LogisticShippingPrice",
        piecesRangeId?: string | null,
        price: number,
      } | null > | null,
      clientsRanges?:  Array< {
        __typename: "LogisticPieceRangeClient",
        id: string,
        clientId: string,
        piecesRange: string,
        price: number,
      } | null > | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLogisticBoxQueryVariables = {
  id: string,
};

export type GetLogisticBoxQuery = {
  getLogisticBox?:  {
    __typename: "LogisticBox",
    id: string,
    status?: string | null,
    name?: string | null,
    description?: string | null,
    price?: number | null,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    volumetricWeight?: number | null,
    maxWeight?: number | null,
    maxPayload?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListLogisticBoxesQueryVariables = {
  filter?: ModelLogisticBoxFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogisticBoxesQuery = {
  listLogisticBoxes?:  {
    __typename: "ModelLogisticBoxConnection",
    items:  Array< {
      __typename: "LogisticBox",
      id: string,
      status?: string | null,
      name?: string | null,
      description?: string | null,
      price?: number | null,
      width?: number | null,
      height?: number | null,
      depth?: number | null,
      volumetricWeight?: number | null,
      maxWeight?: number | null,
      maxPayload?: number | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLogisticVehiclesQueryVariables = {
  id: string,
};

export type GetLogisticVehiclesQuery = {
  getLogisticVehicles?:  {
    __typename: "LogisticVehicles",
    id: string,
    status?: string | null,
    licensePlate?: string | null,
    hasInsurancePolicy?: string | null,
    fuelCapacity?: number | null,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    maxWeight?: number | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLogisticVehiclesQueryVariables = {
  filter?: ModelLogisticVehiclesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogisticVehiclesQuery = {
  listLogisticVehicles?:  {
    __typename: "ModelLogisticVehiclesConnection",
    items:  Array< {
      __typename: "LogisticVehicles",
      id: string,
      status?: string | null,
      licensePlate?: string | null,
      hasInsurancePolicy?: string | null,
      fuelCapacity?: number | null,
      width?: number | null,
      height?: number | null,
      depth?: number | null,
      maxWeight?: number | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPakmailCarrierQueryVariables = {
  id: string,
};

export type GetPakmailCarrierQuery = {
  getPakmailCarrier?:  {
    __typename: "PakmailCarrier",
    id: string,
    status?: string | null,
    identifier?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListPakmailCarriersQueryVariables = {
  filter?: ModelPakmailCarrierFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPakmailCarriersQuery = {
  listPakmailCarriers?:  {
    __typename: "ModelPakmailCarrierConnection",
    items:  Array< {
      __typename: "PakmailCarrier",
      id: string,
      status?: string | null,
      identifier?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPakmailServiceQueryVariables = {
  id: string,
};

export type GetPakmailServiceQuery = {
  getPakmailService?:  {
    __typename: "PakmailService",
    id: string,
    status?: string | null,
    identifier?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    isNational?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListPakmailServicesQueryVariables = {
  filter?: ModelPakmailServiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPakmailServicesQuery = {
  listPakmailServices?:  {
    __typename: "ModelPakmailServiceConnection",
    items:  Array< {
      __typename: "PakmailService",
      id: string,
      status?: string | null,
      identifier?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      isNational?: boolean | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPakmailShipmentStatusQueryVariables = {
  id: string,
};

export type GetPakmailShipmentStatusQuery = {
  getPakmailShipmentStatus?:  {
    __typename: "PakmailShipmentStatus",
    id: string,
    status?: string | null,
    identifier?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListPakmailShipmentStatusesQueryVariables = {
  filter?: ModelPakmailShipmentStatusFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPakmailShipmentStatusesQuery = {
  listPakmailShipmentStatuses?:  {
    __typename: "ModelPakmailShipmentStatusConnection",
    items:  Array< {
      __typename: "PakmailShipmentStatus",
      id: string,
      status?: string | null,
      identifier?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      notifications?:  Array< {
        __typename: "NotificationSubprocesses",
        group?: string | null,
        enabledEmail?: boolean | null,
        enabledPopUp?: boolean | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPakmailShipmentEventQueryVariables = {
  id: string,
};

export type GetPakmailShipmentEventQuery = {
  getPakmailShipmentEvent?:  {
    __typename: "PakmailShipmentEvent",
    id: string,
    status?: string | null,
    identifier?: string | null,
    visibleFor?: Array< string | null > | null,
    color?: string | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListPakmailShipmentEventsQueryVariables = {
  filter?: ModelPakmailShipmentEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPakmailShipmentEventsQuery = {
  listPakmailShipmentEvents?:  {
    __typename: "ModelPakmailShipmentEventConnection",
    items:  Array< {
      __typename: "PakmailShipmentEvent",
      id: string,
      status?: string | null,
      identifier?: string | null,
      visibleFor?: Array< string | null > | null,
      color?: string | null,
      notifications?:  Array< {
        __typename: "NotificationSubprocesses",
        group?: string | null,
        enabledEmail?: boolean | null,
        enabledPopUp?: boolean | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPakmailPickupStatusQueryVariables = {
  id: string,
};

export type GetPakmailPickupStatusQuery = {
  getPakmailPickupStatus?:  {
    __typename: "PakmailPickupStatus",
    id: string,
    status?: string | null,
    identifier?: number | null,
    visibleFor?: Array< string | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListPakmailPickupStatusesQueryVariables = {
  filter?: ModelPakmailPickupStatusFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPakmailPickupStatusesQuery = {
  listPakmailPickupStatuses?:  {
    __typename: "ModelPakmailPickupStatusConnection",
    items:  Array< {
      __typename: "PakmailPickupStatus",
      id: string,
      status?: string | null,
      identifier?: number | null,
      visibleFor?: Array< string | null > | null,
      notifications?:  Array< {
        __typename: "NotificationSubprocesses",
        group?: string | null,
        enabledEmail?: boolean | null,
        enabledPopUp?: boolean | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPremiumOrderLogisticGuideQueryVariables = {
  id: string,
};

export type GetPremiumOrderLogisticGuideQuery = {
  getPremiumOrderLogisticGuide?:  {
    __typename: "PremiumOrderLogisticGuide",
    id: string,
    type: LogisticGuideType,
    pakmailId?: string | null,
    premiumOrderId: string,
    clientId: string,
    creatorId: string,
    originAddressId?: string | null,
    destinationAddressId?: string | null,
    originAddress?: string | null,
    destinationAddress?: string | null,
    products?:  Array< {
      __typename: "LogisticGuideProduct",
      indexProduct: number,
      productId: string,
      quantity: number,
      unitWidth: number,
      unitHeight: number,
      unitDepth: number,
      unitWeight: number,
    } | null > | null,
    price?: number | null,
    increment?: number | null,
    fee?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListPremiumOrderLogisticGuidesQueryVariables = {
  filter?: ModelPremiumOrderLogisticGuideFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPremiumOrderLogisticGuidesQuery = {
  listPremiumOrderLogisticGuides?:  {
    __typename: "ModelPremiumOrderLogisticGuideConnection",
    items:  Array< {
      __typename: "PremiumOrderLogisticGuide",
      id: string,
      type: LogisticGuideType,
      pakmailId?: string | null,
      premiumOrderId: string,
      clientId: string,
      creatorId: string,
      originAddressId?: string | null,
      destinationAddressId?: string | null,
      originAddress?: string | null,
      destinationAddress?: string | null,
      products?:  Array< {
        __typename: "LogisticGuideProduct",
        indexProduct: number,
        productId: string,
        quantity: number,
        unitWidth: number,
        unitHeight: number,
        unitDepth: number,
        unitWeight: number,
      } | null > | null,
      price?: number | null,
      increment?: number | null,
      fee?: number | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProductLabelItemQueryVariables = {
  id: string,
};

export type GetProductLabelItemQuery = {
  getProductLabelItem?:  {
    __typename: "ProductLabelItem",
    id: string,
    productId?: string | null,
    productLabelId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListProductLabelItemsQueryVariables = {
  filter?: ModelProductLabelItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProductLabelItemsQuery = {
  listProductLabelItems?:  {
    __typename: "ModelProductLabelItemConnection",
    items:  Array< {
      __typename: "ProductLabelItem",
      id: string,
      productId?: string | null,
      productLabelId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProductLabelQueryVariables = {
  id: string,
};

export type GetProductLabelQuery = {
  getProductLabel?:  {
    __typename: "ProductLabel",
    id: string,
    name?: string | null,
    translation?: string | null,
    status?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListProductLabelsQueryVariables = {
  filter?: ModelProductLabelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProductLabelsQuery = {
  listProductLabels?:  {
    __typename: "ModelProductLabelConnection",
    items:  Array< {
      __typename: "ProductLabel",
      id: string,
      name?: string | null,
      translation?: string | null,
      status?: string | null,
      visibleFor?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProductTextItemQueryVariables = {
  id: string,
};

export type GetProductTextItemQuery = {
  getProductTextItem?:  {
    __typename: "ProductTextItem",
    id: string,
    productId?: string | null,
    productTextId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListProductTextItemsQueryVariables = {
  filter?: ModelProductTextItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProductTextItemsQuery = {
  listProductTextItems?:  {
    __typename: "ModelProductTextItemConnection",
    items:  Array< {
      __typename: "ProductTextItem",
      id: string,
      productId?: string | null,
      productTextId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProductTextQueryVariables = {
  id: string,
};

export type GetProductTextQuery = {
  getProductText?:  {
    __typename: "ProductText",
    id: string,
    name?: string | null,
    status?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListProductTextsQueryVariables = {
  filter?: ModelProductTextFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProductTextsQuery = {
  listProductTexts?:  {
    __typename: "ModelProductTextConnection",
    items:  Array< {
      __typename: "ProductText",
      id: string,
      name?: string | null,
      status?: string | null,
      visibleFor?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProductMaskQueryVariables = {
  id: string,
};

export type GetProductMaskQuery = {
  getProductMask?:  {
    __typename: "ProductMask",
    id: string,
    name?: string | null,
    sku?: string | null,
    productId?: string | null,
    clientId?: string | null,
    filterColors?: Array< string | null > | null,
    mainImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    increment?: number | null,
    fee?: number | null,
    discount?: number | null,
    stock?: number | null,
    categoryId?: string | null,
    sellMode?: ProductMaskSellMode | null,
    kitPieces?: number | null,
    kitIncrement?: number | null,
    kitFee?: number | null,
    stockMode?: ProductMaskStockMode | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListProductMasksQueryVariables = {
  filter?: ModelProductMaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProductMasksQuery = {
  listProductMasks?:  {
    __typename: "ModelProductMaskConnection",
    items:  Array< {
      __typename: "ProductMask",
      id: string,
      name?: string | null,
      sku?: string | null,
      productId?: string | null,
      clientId?: string | null,
      filterColors?: Array< string | null > | null,
      mainImage?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      increment?: number | null,
      fee?: number | null,
      discount?: number | null,
      stock?: number | null,
      categoryId?: string | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
      kitIncrement?: number | null,
      kitFee?: number | null,
      stockMode?: ProductMaskStockMode | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetVariantMaskQueryVariables = {
  id: string,
};

export type GetVariantMaskQuery = {
  getVariantMask?:  {
    __typename: "VariantMask",
    id: string,
    filterColors?: Array< string | null > | null,
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    stock?: number | null,
    stockMode?: VariantMaskStockMode | null,
    productMaskId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListVariantMasksQueryVariables = {
  filter?: ModelVariantMaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVariantMasksQuery = {
  listVariantMasks?:  {
    __typename: "ModelVariantMaskConnection",
    items:  Array< {
      __typename: "VariantMask",
      id: string,
      filterColors?: Array< string | null > | null,
      images?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock?: number | null,
      stockMode?: VariantMaskStockMode | null,
      productMaskId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProductMaskDescriptionQueryVariables = {
  id: string,
};

export type GetProductMaskDescriptionQuery = {
  getProductMaskDescription?:  {
    __typename: "ProductMaskDescription",
    id: string,
    long_description?: string | null,
    short_description?: string | null,
    productDescriptionItem?:  Array< {
      __typename: "ProductDescriptionItem",
      index?: number | null,
      status?: boolean | null,
      key?: string | null,
      description?: string | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListProductMaskDescriptionsQueryVariables = {
  filter?: ModelProductMaskDescriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProductMaskDescriptionsQuery = {
  listProductMaskDescriptions?:  {
    __typename: "ModelProductMaskDescriptionConnection",
    items:  Array< {
      __typename: "ProductMaskDescription",
      id: string,
      long_description?: string | null,
      short_description?: string | null,
      productDescriptionItem?:  Array< {
        __typename: "ProductDescriptionItem",
        index?: number | null,
        status?: boolean | null,
        key?: string | null,
        description?: string | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCouponQueryVariables = {
  id: string,
};

export type GetCouponQuery = {
  getCoupon?:  {
    __typename: "Coupon",
    id: string,
    code: string,
    name: string,
    description?: string | null,
    discountAmount?: number | null,
    discountPercentage?: number | null,
    minAmount?: number | null,
    maxAmount?: number | null,
    startDate: string,
    endDate: string,
    maxRedemptions?: number | null,
    maxRedemptionsPerUser?: number | null,
    applicableProducts?: Array< string | null > | null,
    applicableCategories?: Array< string | null > | null,
    excludedProducts?: Array< string | null > | null,
    status: string,
    createdBy: string,
    redemptions?:  {
      __typename: "ModelCouponRedemptionConnection",
      items:  Array< {
        __typename: "CouponRedemption",
        id: string,
        couponId: string,
        couponCode: string,
        userId: string,
        clientId?: string | null,
        orderId?: string | null,
        cartId?: string | null,
        discountApplied: number,
        originalAmount: number,
        finalAmount: number,
        appliedAt: string,
        ipAddress?: string | null,
        userAgent?: string | null,
        coupon:  {
          __typename: "Coupon",
          id: string,
          code: string,
          name: string,
          description?: string | null,
          discountAmount?: number | null,
          discountPercentage?: number | null,
          minAmount?: number | null,
          maxAmount?: number | null,
          startDate: string,
          endDate: string,
          maxRedemptions?: number | null,
          maxRedemptionsPerUser?: number | null,
          applicableProducts?: Array< string | null > | null,
          applicableCategories?: Array< string | null > | null,
          excludedProducts?: Array< string | null > | null,
          status: string,
          createdBy: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCouponsQueryVariables = {
  filter?: ModelCouponFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCouponsQuery = {
  listCoupons?:  {
    __typename: "ModelCouponConnection",
    items:  Array< {
      __typename: "Coupon",
      id: string,
      code: string,
      name: string,
      description?: string | null,
      discountAmount?: number | null,
      discountPercentage?: number | null,
      minAmount?: number | null,
      maxAmount?: number | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      applicableProducts?: Array< string | null > | null,
      applicableCategories?: Array< string | null > | null,
      excludedProducts?: Array< string | null > | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelCouponRedemptionConnection",
        items:  Array< {
          __typename: "CouponRedemption",
          id: string,
          couponId: string,
          couponCode: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          discountApplied: number,
          originalAmount: number,
          finalAmount: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCouponRedemptionQueryVariables = {
  id: string,
};

export type GetCouponRedemptionQuery = {
  getCouponRedemption?:  {
    __typename: "CouponRedemption",
    id: string,
    couponId: string,
    couponCode: string,
    userId: string,
    clientId?: string | null,
    orderId?: string | null,
    cartId?: string | null,
    discountApplied: number,
    originalAmount: number,
    finalAmount: number,
    appliedAt: string,
    ipAddress?: string | null,
    userAgent?: string | null,
    coupon:  {
      __typename: "Coupon",
      id: string,
      code: string,
      name: string,
      description?: string | null,
      discountAmount?: number | null,
      discountPercentage?: number | null,
      minAmount?: number | null,
      maxAmount?: number | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      applicableProducts?: Array< string | null > | null,
      applicableCategories?: Array< string | null > | null,
      excludedProducts?: Array< string | null > | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelCouponRedemptionConnection",
        items:  Array< {
          __typename: "CouponRedemption",
          id: string,
          couponId: string,
          couponCode: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          discountApplied: number,
          originalAmount: number,
          finalAmount: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCouponRedemptionsQueryVariables = {
  filter?: ModelCouponRedemptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCouponRedemptionsQuery = {
  listCouponRedemptions?:  {
    __typename: "ModelCouponRedemptionConnection",
    items:  Array< {
      __typename: "CouponRedemption",
      id: string,
      couponId: string,
      couponCode: string,
      userId: string,
      clientId?: string | null,
      orderId?: string | null,
      cartId?: string | null,
      discountApplied: number,
      originalAmount: number,
      finalAmount: number,
      appliedAt: string,
      ipAddress?: string | null,
      userAgent?: string | null,
      coupon:  {
        __typename: "Coupon",
        id: string,
        code: string,
        name: string,
        description?: string | null,
        discountAmount?: number | null,
        discountPercentage?: number | null,
        minAmount?: number | null,
        maxAmount?: number | null,
        startDate: string,
        endDate: string,
        maxRedemptions?: number | null,
        maxRedemptionsPerUser?: number | null,
        applicableProducts?: Array< string | null > | null,
        applicableCategories?: Array< string | null > | null,
        excludedProducts?: Array< string | null > | null,
        status: string,
        createdBy: string,
        redemptions?:  {
          __typename: "ModelCouponRedemptionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPromotionQueryVariables = {
  id: string,
};

export type GetPromotionQuery = {
  getPromotion?:  {
    __typename: "Promotion",
    id: string,
    name: string,
    description?: string | null,
    triggerProductIds: Array< string | null >,
    minQuantity: number,
    minAmount?: number | null,
    triggerRule: PromotionTriggerRule,
    giftProductId: string,
    giftQuantity: number,
    isStackable?: boolean | null,
    applicableClientIds?: Array< string | null > | null,
    startDate: string,
    endDate: string,
    maxRedemptions?: number | null,
    maxRedemptionsPerUser?: number | null,
    status: string,
    createdBy: string,
    redemptions?:  {
      __typename: "ModelPromotionRedemptionConnection",
      items:  Array< {
        __typename: "PromotionRedemption",
        id: string,
        promotionId: string,
        userId: string,
        clientId?: string | null,
        orderId?: string | null,
        cartId?: string | null,
        triggerQuantity: number,
        giftQuantityApplied: number,
        appliedAt: string,
        ipAddress?: string | null,
        userAgent?: string | null,
        promotion:  {
          __typename: "Promotion",
          id: string,
          name: string,
          description?: string | null,
          triggerProductIds: Array< string | null >,
          minQuantity: number,
          minAmount?: number | null,
          triggerRule: PromotionTriggerRule,
          giftProductId: string,
          giftQuantity: number,
          isStackable?: boolean | null,
          applicableClientIds?: Array< string | null > | null,
          startDate: string,
          endDate: string,
          maxRedemptions?: number | null,
          maxRedemptionsPerUser?: number | null,
          status: string,
          createdBy: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPromotionsQueryVariables = {
  filter?: ModelPromotionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPromotionsQuery = {
  listPromotions?:  {
    __typename: "ModelPromotionConnection",
    items:  Array< {
      __typename: "Promotion",
      id: string,
      name: string,
      description?: string | null,
      triggerProductIds: Array< string | null >,
      minQuantity: number,
      minAmount?: number | null,
      triggerRule: PromotionTriggerRule,
      giftProductId: string,
      giftQuantity: number,
      isStackable?: boolean | null,
      applicableClientIds?: Array< string | null > | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelPromotionRedemptionConnection",
        items:  Array< {
          __typename: "PromotionRedemption",
          id: string,
          promotionId: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          triggerQuantity: number,
          giftQuantityApplied: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPromotionRedemptionQueryVariables = {
  id: string,
};

export type GetPromotionRedemptionQuery = {
  getPromotionRedemption?:  {
    __typename: "PromotionRedemption",
    id: string,
    promotionId: string,
    userId: string,
    clientId?: string | null,
    orderId?: string | null,
    cartId?: string | null,
    triggerQuantity: number,
    giftQuantityApplied: number,
    appliedAt: string,
    ipAddress?: string | null,
    userAgent?: string | null,
    promotion:  {
      __typename: "Promotion",
      id: string,
      name: string,
      description?: string | null,
      triggerProductIds: Array< string | null >,
      minQuantity: number,
      minAmount?: number | null,
      triggerRule: PromotionTriggerRule,
      giftProductId: string,
      giftQuantity: number,
      isStackable?: boolean | null,
      applicableClientIds?: Array< string | null > | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelPromotionRedemptionConnection",
        items:  Array< {
          __typename: "PromotionRedemption",
          id: string,
          promotionId: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          triggerQuantity: number,
          giftQuantityApplied: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPromotionRedemptionsQueryVariables = {
  filter?: ModelPromotionRedemptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPromotionRedemptionsQuery = {
  listPromotionRedemptions?:  {
    __typename: "ModelPromotionRedemptionConnection",
    items:  Array< {
      __typename: "PromotionRedemption",
      id: string,
      promotionId: string,
      userId: string,
      clientId?: string | null,
      orderId?: string | null,
      cartId?: string | null,
      triggerQuantity: number,
      giftQuantityApplied: number,
      appliedAt: string,
      ipAddress?: string | null,
      userAgent?: string | null,
      promotion:  {
        __typename: "Promotion",
        id: string,
        name: string,
        description?: string | null,
        triggerProductIds: Array< string | null >,
        minQuantity: number,
        minAmount?: number | null,
        triggerRule: PromotionTriggerRule,
        giftProductId: string,
        giftQuantity: number,
        isStackable?: boolean | null,
        applicableClientIds?: Array< string | null > | null,
        startDate: string,
        endDate: string,
        maxRedemptions?: number | null,
        maxRedemptionsPerUser?: number | null,
        status: string,
        createdBy: string,
        redemptions?:  {
          __typename: "ModelPromotionRedemptionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetWalletBalanceQueryVariables = {
  id: string,
};

export type GetWalletBalanceQuery = {
  getWalletBalance?:  {
    __typename: "WalletBalance",
    id: string,
    balance?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type ListWalletBalancesQueryVariables = {
  filter?: ModelWalletBalanceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListWalletBalancesQuery = {
  listWalletBalances?:  {
    __typename: "ModelWalletBalanceConnection",
    items:  Array< {
      __typename: "WalletBalance",
      id: string,
      balance?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetWalletMovementQueryVariables = {
  id: string,
};

export type GetWalletMovementQuery = {
  getWalletMovement?:  {
    __typename: "WalletMovement",
    id: string,
    userId: string,
    type: WalletMovementType,
    amount: number,
    orderId?: string | null,
    createdByUserId?: string | null,
    couponId?: string | null,
    couponCode?: string | null,
    availableUntil?: string | null,
    isValidated?: boolean | null,
    validatedAt?: string | null,
    validatedBy?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListWalletMovementsQueryVariables = {
  filter?: ModelWalletMovementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListWalletMovementsQuery = {
  listWalletMovements?:  {
    __typename: "ModelWalletMovementConnection",
    items:  Array< {
      __typename: "WalletMovement",
      id: string,
      userId: string,
      type: WalletMovementType,
      amount: number,
      orderId?: string | null,
      createdByUserId?: string | null,
      couponId?: string | null,
      couponCode?: string | null,
      availableUntil?: string | null,
      isValidated?: boolean | null,
      validatedAt?: string | null,
      validatedBy?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListClientSettingsByDomainQueryVariables = {
  domain: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelClientSettingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListClientSettingsByDomainQuery = {
  ListClientSettingsByDomain?:  {
    __typename: "ModelClientSettingConnection",
    items:  Array< {
      __typename: "ClientSetting",
      id: string,
      crmJiraId?: string | null,
      orderBudget?: number | null,
      domain?: string | null,
      filterColors?: Array< string | null > | null,
      primaryColors?: Array< string | null > | null,
      accentColors?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListColorsPositionQueryVariables = {
  status: string,
  position?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelColorsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListColorsPositionQuery = {
  ListColorsPosition?:  {
    __typename: "ModelColorsConnection",
    items:  Array< {
      __typename: "Colors",
      id: string,
      status: string,
      name: string,
      rgb: string,
      hex: string,
      position?: number | null,
      variantNames?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductsByProviderStatusQueryVariables = {
  providerId: string,
  status?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductsByProviderStatusQuery = {
  productsByProviderStatus?:  {
    __typename: "ModelProductoConnection",
    items:  Array< {
      __typename: "Producto",
      id: string,
      providerId: string,
      categoryId: string,
      name: string,
      status?: string | null,
      bestSeller?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      order?: number | null,
      sku: string,
      brand?: string | null,
      colors?: Array< string | null > | null,
      pgClasitication?: string | null,
      delivery_time?: string | null,
      delivery_time_units?: string | null,
      stock?: number | null,
      minRequest?: number | null,
      maxRequest?: number | null,
      article_of_clothing?: boolean | null,
      size?: string | null,
      price: number,
      long_description: string,
      short_description: string,
      creator?: string | null,
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      category:  {
        __typename: "Category",
        id: string,
        name: string,
        description?: string | null,
        unspsc?: string | null,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        imageMobile?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        visibleForUserBrand?: Array< string | null > | null,
        region?: Array< string | null > | null,
        tags?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        hasAllowables?: boolean | null,
        hasPreapproveds?: boolean | null,
        hasRestricted?: boolean | null,
        isPublic?: boolean | null,
        isTop?: boolean | null,
        createdAt?: string | null,
        slug?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        path?: string | null,
        status?: string | null,
        pathIds?: Array< string | null > | null,
        source?: string | null,
        trazoCategoryId?: string | null,
        nameExternal?: string | null,
        depth?: number | null,
        childrenCount?: number | null,
        isLeaf?: boolean | null,
        oldVersion?: string | null,
        productLine?: string | null,
        updatedAt: string,
      },
      isExternal?: boolean | null,
      isAllowable?: boolean | null,
      isRestricted?: boolean | null,
      isAutoSkipped?: string | null,
      isAutoAllowed?: string | null,
      isPurse?: boolean | null,
      massiveLayout?: string | null,
      hasBaseAmmount?: boolean | null,
      isFreeAmmount?: boolean | null,
      isCard?: boolean | null,
      isByRequest?: boolean | null,
      isMultiPrice?: boolean | null,
      cardBaseAmmount?: number | null,
      minCardBaseAmmount?: number | null,
      maxCardBaseAmmount?: number | null,
      nameExternal?: string | null,
      unspsc?: string | null,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientIncrementPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      productDescriptionItem?:  Array< {
        __typename: "ProductDescriptionItem",
        index?: number | null,
        status?: boolean | null,
        key?: string | null,
        description?: string | null,
      } | null > | null,
      source?: string | null,
      trazoProductId?: string | null,
      trazoCategoryId?: string | null,
      stockUpdatedAt?: string | null,
      priceUpdatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductsByProviderCategoryQueryVariables = {
  providerId: string,
  categoryId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductsByProviderCategoryQuery = {
  productsByProviderCategory?:  {
    __typename: "ModelProductoConnection",
    items:  Array< {
      __typename: "Producto",
      id: string,
      providerId: string,
      categoryId: string,
      name: string,
      status?: string | null,
      bestSeller?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      order?: number | null,
      sku: string,
      brand?: string | null,
      colors?: Array< string | null > | null,
      pgClasitication?: string | null,
      delivery_time?: string | null,
      delivery_time_units?: string | null,
      stock?: number | null,
      minRequest?: number | null,
      maxRequest?: number | null,
      article_of_clothing?: boolean | null,
      size?: string | null,
      price: number,
      long_description: string,
      short_description: string,
      creator?: string | null,
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      category:  {
        __typename: "Category",
        id: string,
        name: string,
        description?: string | null,
        unspsc?: string | null,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        imageMobile?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        visibleForUserBrand?: Array< string | null > | null,
        region?: Array< string | null > | null,
        tags?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        hasAllowables?: boolean | null,
        hasPreapproveds?: boolean | null,
        hasRestricted?: boolean | null,
        isPublic?: boolean | null,
        isTop?: boolean | null,
        createdAt?: string | null,
        slug?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        path?: string | null,
        status?: string | null,
        pathIds?: Array< string | null > | null,
        source?: string | null,
        trazoCategoryId?: string | null,
        nameExternal?: string | null,
        depth?: number | null,
        childrenCount?: number | null,
        isLeaf?: boolean | null,
        oldVersion?: string | null,
        productLine?: string | null,
        updatedAt: string,
      },
      isExternal?: boolean | null,
      isAllowable?: boolean | null,
      isRestricted?: boolean | null,
      isAutoSkipped?: string | null,
      isAutoAllowed?: string | null,
      isPurse?: boolean | null,
      massiveLayout?: string | null,
      hasBaseAmmount?: boolean | null,
      isFreeAmmount?: boolean | null,
      isCard?: boolean | null,
      isByRequest?: boolean | null,
      isMultiPrice?: boolean | null,
      cardBaseAmmount?: number | null,
      minCardBaseAmmount?: number | null,
      maxCardBaseAmmount?: number | null,
      nameExternal?: string | null,
      unspsc?: string | null,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientIncrementPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      productDescriptionItem?:  Array< {
        __typename: "ProductDescriptionItem",
        index?: number | null,
        status?: boolean | null,
        key?: string | null,
        description?: string | null,
      } | null > | null,
      source?: string | null,
      trazoProductId?: string | null,
      trazoCategoryId?: string | null,
      stockUpdatedAt?: string | null,
      priceUpdatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductsByCategoryProviderPriceQueryVariables = {
  categoryId: string,
  providerIdPrice?: ModelProductoByCategoryProviderPriceCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductsByCategoryProviderPriceQuery = {
  ProductsByCategoryProviderPrice?:  {
    __typename: "ModelProductoConnection",
    items:  Array< {
      __typename: "Producto",
      id: string,
      providerId: string,
      categoryId: string,
      name: string,
      status?: string | null,
      bestSeller?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      order?: number | null,
      sku: string,
      brand?: string | null,
      colors?: Array< string | null > | null,
      pgClasitication?: string | null,
      delivery_time?: string | null,
      delivery_time_units?: string | null,
      stock?: number | null,
      minRequest?: number | null,
      maxRequest?: number | null,
      article_of_clothing?: boolean | null,
      size?: string | null,
      price: number,
      long_description: string,
      short_description: string,
      creator?: string | null,
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      category:  {
        __typename: "Category",
        id: string,
        name: string,
        description?: string | null,
        unspsc?: string | null,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        imageMobile?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        visibleForUserBrand?: Array< string | null > | null,
        region?: Array< string | null > | null,
        tags?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        hasAllowables?: boolean | null,
        hasPreapproveds?: boolean | null,
        hasRestricted?: boolean | null,
        isPublic?: boolean | null,
        isTop?: boolean | null,
        createdAt?: string | null,
        slug?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        path?: string | null,
        status?: string | null,
        pathIds?: Array< string | null > | null,
        source?: string | null,
        trazoCategoryId?: string | null,
        nameExternal?: string | null,
        depth?: number | null,
        childrenCount?: number | null,
        isLeaf?: boolean | null,
        oldVersion?: string | null,
        productLine?: string | null,
        updatedAt: string,
      },
      isExternal?: boolean | null,
      isAllowable?: boolean | null,
      isRestricted?: boolean | null,
      isAutoSkipped?: string | null,
      isAutoAllowed?: string | null,
      isPurse?: boolean | null,
      massiveLayout?: string | null,
      hasBaseAmmount?: boolean | null,
      isFreeAmmount?: boolean | null,
      isCard?: boolean | null,
      isByRequest?: boolean | null,
      isMultiPrice?: boolean | null,
      cardBaseAmmount?: number | null,
      minCardBaseAmmount?: number | null,
      maxCardBaseAmmount?: number | null,
      nameExternal?: string | null,
      unspsc?: string | null,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientIncrementPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      productDescriptionItem?:  Array< {
        __typename: "ProductDescriptionItem",
        index?: number | null,
        status?: boolean | null,
        key?: string | null,
        description?: string | null,
      } | null > | null,
      source?: string | null,
      trazoProductId?: string | null,
      trazoCategoryId?: string | null,
      stockUpdatedAt?: string | null,
      priceUpdatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductsByCategoryPriceQueryVariables = {
  categoryId: string,
  price?: ModelFloatKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductsByCategoryPriceQuery = {
  productsByCategoryPrice?:  {
    __typename: "ModelProductoConnection",
    items:  Array< {
      __typename: "Producto",
      id: string,
      providerId: string,
      categoryId: string,
      name: string,
      status?: string | null,
      bestSeller?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      order?: number | null,
      sku: string,
      brand?: string | null,
      colors?: Array< string | null > | null,
      pgClasitication?: string | null,
      delivery_time?: string | null,
      delivery_time_units?: string | null,
      stock?: number | null,
      minRequest?: number | null,
      maxRequest?: number | null,
      article_of_clothing?: boolean | null,
      size?: string | null,
      price: number,
      long_description: string,
      short_description: string,
      creator?: string | null,
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      category:  {
        __typename: "Category",
        id: string,
        name: string,
        description?: string | null,
        unspsc?: string | null,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        imageMobile?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        visibleForUserBrand?: Array< string | null > | null,
        region?: Array< string | null > | null,
        tags?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        hasAllowables?: boolean | null,
        hasPreapproveds?: boolean | null,
        hasRestricted?: boolean | null,
        isPublic?: boolean | null,
        isTop?: boolean | null,
        createdAt?: string | null,
        slug?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        path?: string | null,
        status?: string | null,
        pathIds?: Array< string | null > | null,
        source?: string | null,
        trazoCategoryId?: string | null,
        nameExternal?: string | null,
        depth?: number | null,
        childrenCount?: number | null,
        isLeaf?: boolean | null,
        oldVersion?: string | null,
        productLine?: string | null,
        updatedAt: string,
      },
      isExternal?: boolean | null,
      isAllowable?: boolean | null,
      isRestricted?: boolean | null,
      isAutoSkipped?: string | null,
      isAutoAllowed?: string | null,
      isPurse?: boolean | null,
      massiveLayout?: string | null,
      hasBaseAmmount?: boolean | null,
      isFreeAmmount?: boolean | null,
      isCard?: boolean | null,
      isByRequest?: boolean | null,
      isMultiPrice?: boolean | null,
      cardBaseAmmount?: number | null,
      minCardBaseAmmount?: number | null,
      maxCardBaseAmmount?: number | null,
      nameExternal?: string | null,
      unspsc?: string | null,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientIncrementPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      productDescriptionItem?:  Array< {
        __typename: "ProductDescriptionItem",
        index?: number | null,
        status?: boolean | null,
        key?: string | null,
        description?: string | null,
      } | null > | null,
      source?: string | null,
      trazoProductId?: string | null,
      trazoCategoryId?: string | null,
      stockUpdatedAt?: string | null,
      priceUpdatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductsByCategoryQueryVariables = {
  categoryId: string,
  order?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductsByCategoryQuery = {
  productsByCategory?:  {
    __typename: "ModelProductoConnection",
    items:  Array< {
      __typename: "Producto",
      id: string,
      providerId: string,
      categoryId: string,
      name: string,
      status?: string | null,
      bestSeller?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      order?: number | null,
      sku: string,
      brand?: string | null,
      colors?: Array< string | null > | null,
      pgClasitication?: string | null,
      delivery_time?: string | null,
      delivery_time_units?: string | null,
      stock?: number | null,
      minRequest?: number | null,
      maxRequest?: number | null,
      article_of_clothing?: boolean | null,
      size?: string | null,
      price: number,
      long_description: string,
      short_description: string,
      creator?: string | null,
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      category:  {
        __typename: "Category",
        id: string,
        name: string,
        description?: string | null,
        unspsc?: string | null,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        imageMobile?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        visibleForUserBrand?: Array< string | null > | null,
        region?: Array< string | null > | null,
        tags?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        hasAllowables?: boolean | null,
        hasPreapproveds?: boolean | null,
        hasRestricted?: boolean | null,
        isPublic?: boolean | null,
        isTop?: boolean | null,
        createdAt?: string | null,
        slug?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        path?: string | null,
        status?: string | null,
        pathIds?: Array< string | null > | null,
        source?: string | null,
        trazoCategoryId?: string | null,
        nameExternal?: string | null,
        depth?: number | null,
        childrenCount?: number | null,
        isLeaf?: boolean | null,
        oldVersion?: string | null,
        productLine?: string | null,
        updatedAt: string,
      },
      isExternal?: boolean | null,
      isAllowable?: boolean | null,
      isRestricted?: boolean | null,
      isAutoSkipped?: string | null,
      isAutoAllowed?: string | null,
      isPurse?: boolean | null,
      massiveLayout?: string | null,
      hasBaseAmmount?: boolean | null,
      isFreeAmmount?: boolean | null,
      isCard?: boolean | null,
      isByRequest?: boolean | null,
      isMultiPrice?: boolean | null,
      cardBaseAmmount?: number | null,
      minCardBaseAmmount?: number | null,
      maxCardBaseAmmount?: number | null,
      nameExternal?: string | null,
      unspsc?: string | null,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientIncrementPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      productDescriptionItem?:  Array< {
        __typename: "ProductDescriptionItem",
        index?: number | null,
        status?: boolean | null,
        key?: string | null,
        description?: string | null,
      } | null > | null,
      source?: string | null,
      trazoProductId?: string | null,
      trazoCategoryId?: string | null,
      stockUpdatedAt?: string | null,
      priceUpdatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductsByNameQueryVariables = {
  name: string,
  price?: ModelFloatKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductsByNameQuery = {
  ProductsByName?:  {
    __typename: "ModelProductoConnection",
    items:  Array< {
      __typename: "Producto",
      id: string,
      providerId: string,
      categoryId: string,
      name: string,
      status?: string | null,
      bestSeller?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      order?: number | null,
      sku: string,
      brand?: string | null,
      colors?: Array< string | null > | null,
      pgClasitication?: string | null,
      delivery_time?: string | null,
      delivery_time_units?: string | null,
      stock?: number | null,
      minRequest?: number | null,
      maxRequest?: number | null,
      article_of_clothing?: boolean | null,
      size?: string | null,
      price: number,
      long_description: string,
      short_description: string,
      creator?: string | null,
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      category:  {
        __typename: "Category",
        id: string,
        name: string,
        description?: string | null,
        unspsc?: string | null,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        imageMobile?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        visibleForUserBrand?: Array< string | null > | null,
        region?: Array< string | null > | null,
        tags?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        hasAllowables?: boolean | null,
        hasPreapproveds?: boolean | null,
        hasRestricted?: boolean | null,
        isPublic?: boolean | null,
        isTop?: boolean | null,
        createdAt?: string | null,
        slug?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        path?: string | null,
        status?: string | null,
        pathIds?: Array< string | null > | null,
        source?: string | null,
        trazoCategoryId?: string | null,
        nameExternal?: string | null,
        depth?: number | null,
        childrenCount?: number | null,
        isLeaf?: boolean | null,
        oldVersion?: string | null,
        productLine?: string | null,
        updatedAt: string,
      },
      isExternal?: boolean | null,
      isAllowable?: boolean | null,
      isRestricted?: boolean | null,
      isAutoSkipped?: string | null,
      isAutoAllowed?: string | null,
      isPurse?: boolean | null,
      massiveLayout?: string | null,
      hasBaseAmmount?: boolean | null,
      isFreeAmmount?: boolean | null,
      isCard?: boolean | null,
      isByRequest?: boolean | null,
      isMultiPrice?: boolean | null,
      cardBaseAmmount?: number | null,
      minCardBaseAmmount?: number | null,
      maxCardBaseAmmount?: number | null,
      nameExternal?: string | null,
      unspsc?: string | null,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientIncrementPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      productDescriptionItem?:  Array< {
        __typename: "ProductDescriptionItem",
        index?: number | null,
        status?: boolean | null,
        key?: string | null,
        description?: string | null,
      } | null > | null,
      source?: string | null,
      trazoProductId?: string | null,
      trazoCategoryId?: string | null,
      stockUpdatedAt?: string | null,
      priceUpdatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductsByBestSellersQueryVariables = {
  bestSeller: string,
  price?: ModelFloatKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductsByBestSellersQuery = {
  productsByBestSellers?:  {
    __typename: "ModelProductoConnection",
    items:  Array< {
      __typename: "Producto",
      id: string,
      providerId: string,
      categoryId: string,
      name: string,
      status?: string | null,
      bestSeller?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      order?: number | null,
      sku: string,
      brand?: string | null,
      colors?: Array< string | null > | null,
      pgClasitication?: string | null,
      delivery_time?: string | null,
      delivery_time_units?: string | null,
      stock?: number | null,
      minRequest?: number | null,
      maxRequest?: number | null,
      article_of_clothing?: boolean | null,
      size?: string | null,
      price: number,
      long_description: string,
      short_description: string,
      creator?: string | null,
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      category:  {
        __typename: "Category",
        id: string,
        name: string,
        description?: string | null,
        unspsc?: string | null,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        imageMobile?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        visibleForUserBrand?: Array< string | null > | null,
        region?: Array< string | null > | null,
        tags?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        hasAllowables?: boolean | null,
        hasPreapproveds?: boolean | null,
        hasRestricted?: boolean | null,
        isPublic?: boolean | null,
        isTop?: boolean | null,
        createdAt?: string | null,
        slug?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        path?: string | null,
        status?: string | null,
        pathIds?: Array< string | null > | null,
        source?: string | null,
        trazoCategoryId?: string | null,
        nameExternal?: string | null,
        depth?: number | null,
        childrenCount?: number | null,
        isLeaf?: boolean | null,
        oldVersion?: string | null,
        productLine?: string | null,
        updatedAt: string,
      },
      isExternal?: boolean | null,
      isAllowable?: boolean | null,
      isRestricted?: boolean | null,
      isAutoSkipped?: string | null,
      isAutoAllowed?: string | null,
      isPurse?: boolean | null,
      massiveLayout?: string | null,
      hasBaseAmmount?: boolean | null,
      isFreeAmmount?: boolean | null,
      isCard?: boolean | null,
      isByRequest?: boolean | null,
      isMultiPrice?: boolean | null,
      cardBaseAmmount?: number | null,
      minCardBaseAmmount?: number | null,
      maxCardBaseAmmount?: number | null,
      nameExternal?: string | null,
      unspsc?: string | null,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientIncrementPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      productDescriptionItem?:  Array< {
        __typename: "ProductDescriptionItem",
        index?: number | null,
        status?: boolean | null,
        key?: string | null,
        description?: string | null,
      } | null > | null,
      source?: string | null,
      trazoProductId?: string | null,
      trazoCategoryId?: string | null,
      stockUpdatedAt?: string | null,
      priceUpdatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductBySkuQueryVariables = {
  sku: string,
  order?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductBySkuQuery = {
  productBySku?:  {
    __typename: "ModelProductoConnection",
    items:  Array< {
      __typename: "Producto",
      id: string,
      providerId: string,
      categoryId: string,
      name: string,
      status?: string | null,
      bestSeller?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      order?: number | null,
      sku: string,
      brand?: string | null,
      colors?: Array< string | null > | null,
      pgClasitication?: string | null,
      delivery_time?: string | null,
      delivery_time_units?: string | null,
      stock?: number | null,
      minRequest?: number | null,
      maxRequest?: number | null,
      article_of_clothing?: boolean | null,
      size?: string | null,
      price: number,
      long_description: string,
      short_description: string,
      creator?: string | null,
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      category:  {
        __typename: "Category",
        id: string,
        name: string,
        description?: string | null,
        unspsc?: string | null,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        imageMobile?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        visibleForUserBrand?: Array< string | null > | null,
        region?: Array< string | null > | null,
        tags?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        hasAllowables?: boolean | null,
        hasPreapproveds?: boolean | null,
        hasRestricted?: boolean | null,
        isPublic?: boolean | null,
        isTop?: boolean | null,
        createdAt?: string | null,
        slug?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        path?: string | null,
        status?: string | null,
        pathIds?: Array< string | null > | null,
        source?: string | null,
        trazoCategoryId?: string | null,
        nameExternal?: string | null,
        depth?: number | null,
        childrenCount?: number | null,
        isLeaf?: boolean | null,
        oldVersion?: string | null,
        productLine?: string | null,
        updatedAt: string,
      },
      isExternal?: boolean | null,
      isAllowable?: boolean | null,
      isRestricted?: boolean | null,
      isAutoSkipped?: string | null,
      isAutoAllowed?: string | null,
      isPurse?: boolean | null,
      massiveLayout?: string | null,
      hasBaseAmmount?: boolean | null,
      isFreeAmmount?: boolean | null,
      isCard?: boolean | null,
      isByRequest?: boolean | null,
      isMultiPrice?: boolean | null,
      cardBaseAmmount?: number | null,
      minCardBaseAmmount?: number | null,
      maxCardBaseAmmount?: number | null,
      nameExternal?: string | null,
      unspsc?: string | null,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientIncrementPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      productDescriptionItem?:  Array< {
        __typename: "ProductDescriptionItem",
        index?: number | null,
        status?: boolean | null,
        key?: string | null,
        description?: string | null,
      } | null > | null,
      source?: string | null,
      trazoProductId?: string | null,
      trazoCategoryId?: string | null,
      stockUpdatedAt?: string | null,
      priceUpdatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductsByAutoSkippedQueryVariables = {
  isAutoSkipped: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductsByAutoSkippedQuery = {
  productsByAutoSkipped?:  {
    __typename: "ModelProductoConnection",
    items:  Array< {
      __typename: "Producto",
      id: string,
      providerId: string,
      categoryId: string,
      name: string,
      status?: string | null,
      bestSeller?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      order?: number | null,
      sku: string,
      brand?: string | null,
      colors?: Array< string | null > | null,
      pgClasitication?: string | null,
      delivery_time?: string | null,
      delivery_time_units?: string | null,
      stock?: number | null,
      minRequest?: number | null,
      maxRequest?: number | null,
      article_of_clothing?: boolean | null,
      size?: string | null,
      price: number,
      long_description: string,
      short_description: string,
      creator?: string | null,
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      category:  {
        __typename: "Category",
        id: string,
        name: string,
        description?: string | null,
        unspsc?: string | null,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        imageMobile?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        visibleForUserBrand?: Array< string | null > | null,
        region?: Array< string | null > | null,
        tags?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        hasAllowables?: boolean | null,
        hasPreapproveds?: boolean | null,
        hasRestricted?: boolean | null,
        isPublic?: boolean | null,
        isTop?: boolean | null,
        createdAt?: string | null,
        slug?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        path?: string | null,
        status?: string | null,
        pathIds?: Array< string | null > | null,
        source?: string | null,
        trazoCategoryId?: string | null,
        nameExternal?: string | null,
        depth?: number | null,
        childrenCount?: number | null,
        isLeaf?: boolean | null,
        oldVersion?: string | null,
        productLine?: string | null,
        updatedAt: string,
      },
      isExternal?: boolean | null,
      isAllowable?: boolean | null,
      isRestricted?: boolean | null,
      isAutoSkipped?: string | null,
      isAutoAllowed?: string | null,
      isPurse?: boolean | null,
      massiveLayout?: string | null,
      hasBaseAmmount?: boolean | null,
      isFreeAmmount?: boolean | null,
      isCard?: boolean | null,
      isByRequest?: boolean | null,
      isMultiPrice?: boolean | null,
      cardBaseAmmount?: number | null,
      minCardBaseAmmount?: number | null,
      maxCardBaseAmmount?: number | null,
      nameExternal?: string | null,
      unspsc?: string | null,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientIncrementPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      productDescriptionItem?:  Array< {
        __typename: "ProductDescriptionItem",
        index?: number | null,
        status?: boolean | null,
        key?: string | null,
        description?: string | null,
      } | null > | null,
      source?: string | null,
      trazoProductId?: string | null,
      trazoCategoryId?: string | null,
      stockUpdatedAt?: string | null,
      priceUpdatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductsByAutoAllowedQueryVariables = {
  isAutoAllowed: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductsByAutoAllowedQuery = {
  productsByAutoAllowed?:  {
    __typename: "ModelProductoConnection",
    items:  Array< {
      __typename: "Producto",
      id: string,
      providerId: string,
      categoryId: string,
      name: string,
      status?: string | null,
      bestSeller?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      order?: number | null,
      sku: string,
      brand?: string | null,
      colors?: Array< string | null > | null,
      pgClasitication?: string | null,
      delivery_time?: string | null,
      delivery_time_units?: string | null,
      stock?: number | null,
      minRequest?: number | null,
      maxRequest?: number | null,
      article_of_clothing?: boolean | null,
      size?: string | null,
      price: number,
      long_description: string,
      short_description: string,
      creator?: string | null,
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      category:  {
        __typename: "Category",
        id: string,
        name: string,
        description?: string | null,
        unspsc?: string | null,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        imageMobile?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        visibleForUserBrand?: Array< string | null > | null,
        region?: Array< string | null > | null,
        tags?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        hasAllowables?: boolean | null,
        hasPreapproveds?: boolean | null,
        hasRestricted?: boolean | null,
        isPublic?: boolean | null,
        isTop?: boolean | null,
        createdAt?: string | null,
        slug?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        path?: string | null,
        status?: string | null,
        pathIds?: Array< string | null > | null,
        source?: string | null,
        trazoCategoryId?: string | null,
        nameExternal?: string | null,
        depth?: number | null,
        childrenCount?: number | null,
        isLeaf?: boolean | null,
        oldVersion?: string | null,
        productLine?: string | null,
        updatedAt: string,
      },
      isExternal?: boolean | null,
      isAllowable?: boolean | null,
      isRestricted?: boolean | null,
      isAutoSkipped?: string | null,
      isAutoAllowed?: string | null,
      isPurse?: boolean | null,
      massiveLayout?: string | null,
      hasBaseAmmount?: boolean | null,
      isFreeAmmount?: boolean | null,
      isCard?: boolean | null,
      isByRequest?: boolean | null,
      isMultiPrice?: boolean | null,
      cardBaseAmmount?: number | null,
      minCardBaseAmmount?: number | null,
      maxCardBaseAmmount?: number | null,
      nameExternal?: string | null,
      unspsc?: string | null,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientIncrementPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      productDescriptionItem?:  Array< {
        __typename: "ProductDescriptionItem",
        index?: number | null,
        status?: boolean | null,
        key?: string | null,
        description?: string | null,
      } | null > | null,
      source?: string | null,
      trazoProductId?: string | null,
      trazoCategoryId?: string | null,
      stockUpdatedAt?: string | null,
      priceUpdatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductsByMassiveLayoutQueryVariables = {
  massiveLayout: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductsByMassiveLayoutQuery = {
  ProductsByMassiveLayout?:  {
    __typename: "ModelProductoConnection",
    items:  Array< {
      __typename: "Producto",
      id: string,
      providerId: string,
      categoryId: string,
      name: string,
      status?: string | null,
      bestSeller?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      order?: number | null,
      sku: string,
      brand?: string | null,
      colors?: Array< string | null > | null,
      pgClasitication?: string | null,
      delivery_time?: string | null,
      delivery_time_units?: string | null,
      stock?: number | null,
      minRequest?: number | null,
      maxRequest?: number | null,
      article_of_clothing?: boolean | null,
      size?: string | null,
      price: number,
      long_description: string,
      short_description: string,
      creator?: string | null,
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      category:  {
        __typename: "Category",
        id: string,
        name: string,
        description?: string | null,
        unspsc?: string | null,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        imageMobile?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        visibleForUserBrand?: Array< string | null > | null,
        region?: Array< string | null > | null,
        tags?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        hasAllowables?: boolean | null,
        hasPreapproveds?: boolean | null,
        hasRestricted?: boolean | null,
        isPublic?: boolean | null,
        isTop?: boolean | null,
        createdAt?: string | null,
        slug?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        path?: string | null,
        status?: string | null,
        pathIds?: Array< string | null > | null,
        source?: string | null,
        trazoCategoryId?: string | null,
        nameExternal?: string | null,
        depth?: number | null,
        childrenCount?: number | null,
        isLeaf?: boolean | null,
        oldVersion?: string | null,
        productLine?: string | null,
        updatedAt: string,
      },
      isExternal?: boolean | null,
      isAllowable?: boolean | null,
      isRestricted?: boolean | null,
      isAutoSkipped?: string | null,
      isAutoAllowed?: string | null,
      isPurse?: boolean | null,
      massiveLayout?: string | null,
      hasBaseAmmount?: boolean | null,
      isFreeAmmount?: boolean | null,
      isCard?: boolean | null,
      isByRequest?: boolean | null,
      isMultiPrice?: boolean | null,
      cardBaseAmmount?: number | null,
      minCardBaseAmmount?: number | null,
      maxCardBaseAmmount?: number | null,
      nameExternal?: string | null,
      unspsc?: string | null,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientIncrementPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      productDescriptionItem?:  Array< {
        __typename: "ProductDescriptionItem",
        index?: number | null,
        status?: boolean | null,
        key?: string | null,
        description?: string | null,
      } | null > | null,
      source?: string | null,
      trazoProductId?: string | null,
      trazoCategoryId?: string | null,
      stockUpdatedAt?: string | null,
      priceUpdatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductsByNameExternalQueryVariables = {
  nameExternal: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductsByNameExternalQuery = {
  ProductsByNameExternal?:  {
    __typename: "ModelProductoConnection",
    items:  Array< {
      __typename: "Producto",
      id: string,
      providerId: string,
      categoryId: string,
      name: string,
      status?: string | null,
      bestSeller?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      order?: number | null,
      sku: string,
      brand?: string | null,
      colors?: Array< string | null > | null,
      pgClasitication?: string | null,
      delivery_time?: string | null,
      delivery_time_units?: string | null,
      stock?: number | null,
      minRequest?: number | null,
      maxRequest?: number | null,
      article_of_clothing?: boolean | null,
      size?: string | null,
      price: number,
      long_description: string,
      short_description: string,
      creator?: string | null,
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      category:  {
        __typename: "Category",
        id: string,
        name: string,
        description?: string | null,
        unspsc?: string | null,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        imageMobile?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        visibleForUserBrand?: Array< string | null > | null,
        region?: Array< string | null > | null,
        tags?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        hasAllowables?: boolean | null,
        hasPreapproveds?: boolean | null,
        hasRestricted?: boolean | null,
        isPublic?: boolean | null,
        isTop?: boolean | null,
        createdAt?: string | null,
        slug?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        path?: string | null,
        status?: string | null,
        pathIds?: Array< string | null > | null,
        source?: string | null,
        trazoCategoryId?: string | null,
        nameExternal?: string | null,
        depth?: number | null,
        childrenCount?: number | null,
        isLeaf?: boolean | null,
        oldVersion?: string | null,
        productLine?: string | null,
        updatedAt: string,
      },
      isExternal?: boolean | null,
      isAllowable?: boolean | null,
      isRestricted?: boolean | null,
      isAutoSkipped?: string | null,
      isAutoAllowed?: string | null,
      isPurse?: boolean | null,
      massiveLayout?: string | null,
      hasBaseAmmount?: boolean | null,
      isFreeAmmount?: boolean | null,
      isCard?: boolean | null,
      isByRequest?: boolean | null,
      isMultiPrice?: boolean | null,
      cardBaseAmmount?: number | null,
      minCardBaseAmmount?: number | null,
      maxCardBaseAmmount?: number | null,
      nameExternal?: string | null,
      unspsc?: string | null,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientIncrementPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      productDescriptionItem?:  Array< {
        __typename: "ProductDescriptionItem",
        index?: number | null,
        status?: boolean | null,
        key?: string | null,
        description?: string | null,
      } | null > | null,
      source?: string | null,
      trazoProductId?: string | null,
      trazoCategoryId?: string | null,
      stockUpdatedAt?: string | null,
      priceUpdatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductsBySourceQueryVariables = {
  source: string,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductsBySourceQuery = {
  productsBySource?:  {
    __typename: "ModelProductoConnection",
    items:  Array< {
      __typename: "Producto",
      id: string,
      providerId: string,
      categoryId: string,
      name: string,
      status?: string | null,
      bestSeller?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      order?: number | null,
      sku: string,
      brand?: string | null,
      colors?: Array< string | null > | null,
      pgClasitication?: string | null,
      delivery_time?: string | null,
      delivery_time_units?: string | null,
      stock?: number | null,
      minRequest?: number | null,
      maxRequest?: number | null,
      article_of_clothing?: boolean | null,
      size?: string | null,
      price: number,
      long_description: string,
      short_description: string,
      creator?: string | null,
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      category:  {
        __typename: "Category",
        id: string,
        name: string,
        description?: string | null,
        unspsc?: string | null,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        imageMobile?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        visibleForUserBrand?: Array< string | null > | null,
        region?: Array< string | null > | null,
        tags?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        hasAllowables?: boolean | null,
        hasPreapproveds?: boolean | null,
        hasRestricted?: boolean | null,
        isPublic?: boolean | null,
        isTop?: boolean | null,
        createdAt?: string | null,
        slug?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        path?: string | null,
        status?: string | null,
        pathIds?: Array< string | null > | null,
        source?: string | null,
        trazoCategoryId?: string | null,
        nameExternal?: string | null,
        depth?: number | null,
        childrenCount?: number | null,
        isLeaf?: boolean | null,
        oldVersion?: string | null,
        productLine?: string | null,
        updatedAt: string,
      },
      isExternal?: boolean | null,
      isAllowable?: boolean | null,
      isRestricted?: boolean | null,
      isAutoSkipped?: string | null,
      isAutoAllowed?: string | null,
      isPurse?: boolean | null,
      massiveLayout?: string | null,
      hasBaseAmmount?: boolean | null,
      isFreeAmmount?: boolean | null,
      isCard?: boolean | null,
      isByRequest?: boolean | null,
      isMultiPrice?: boolean | null,
      cardBaseAmmount?: number | null,
      minCardBaseAmmount?: number | null,
      maxCardBaseAmmount?: number | null,
      nameExternal?: string | null,
      unspsc?: string | null,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientIncrementPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      productDescriptionItem?:  Array< {
        __typename: "ProductDescriptionItem",
        index?: number | null,
        status?: boolean | null,
        key?: string | null,
        description?: string | null,
      } | null > | null,
      source?: string | null,
      trazoProductId?: string | null,
      trazoCategoryId?: string | null,
      stockUpdatedAt?: string | null,
      priceUpdatedAt?: string | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductVariantsByProductIdQueryVariables = {
  productId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductVariantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductVariantsByProductIdQuery = {
  ProductVariantsByProductId?:  {
    __typename: "ModelProductVariantConnection",
    items:  Array< {
      __typename: "ProductVariant",
      id: string,
      productId?: string | null,
      sku?: string | null,
      name?: string | null,
      description?: string | null,
      colors?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock_available?: number | null,
      price?: number | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductOptionsByOwnOrderQueryVariables = {
  ownOrder: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductOptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductOptionsByOwnOrderQuery = {
  ProductOptionsByOwnOrder?:  {
    __typename: "ModelProductOptionConnection",
    items:  Array< {
      __typename: "ProductOption",
      id: string,
      ownOrder?: string | null,
      isPangga?: string | null,
      volumetricWeight?: string | null,
      isEvaluated?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPanggaProductsQueryVariables = {
  isPangga: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductOptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPanggaProductsQuery = {
  ListPanggaProducts?:  {
    __typename: "ModelProductOptionConnection",
    items:  Array< {
      __typename: "ProductOption",
      id: string,
      ownOrder?: string | null,
      isPangga?: string | null,
      volumetricWeight?: string | null,
      isEvaluated?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListVolumetricWeightProductsQueryVariables = {
  volumetricWeight: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductOptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVolumetricWeightProductsQuery = {
  ListVolumetricWeightProducts?:  {
    __typename: "ModelProductOptionConnection",
    items:  Array< {
      __typename: "ProductOption",
      id: string,
      ownOrder?: string | null,
      isPangga?: string | null,
      volumetricWeight?: string | null,
      isEvaluated?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAIEvaluatedProductsQueryVariables = {
  isEvaluated: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductOptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAIEvaluatedProductsQuery = {
  ListAIEvaluatedProducts?:  {
    __typename: "ModelProductOptionConnection",
    items:  Array< {
      __typename: "ProductOption",
      id: string,
      ownOrder?: string | null,
      isPangga?: string | null,
      volumetricWeight?: string | null,
      isEvaluated?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MassiveLayoutsByTypeQueryVariables = {
  type: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMassiveChangeLayoutsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MassiveLayoutsByTypeQuery = {
  MassiveLayoutsByType?:  {
    __typename: "ModelMassiveChangeLayoutsConnection",
    items:  Array< {
      __typename: "MassiveChangeLayouts",
      id: string,
      type?: string | null,
      status?: string | null,
      providerId?: string | null,
      creatorId?: string | null,
      creatorRole?: string | null,
      productsNumber?: number | null,
      file?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MassiveLayoutsByStatusQueryVariables = {
  status: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMassiveChangeLayoutsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MassiveLayoutsByStatusQuery = {
  MassiveLayoutsByStatus?:  {
    __typename: "ModelMassiveChangeLayoutsConnection",
    items:  Array< {
      __typename: "MassiveChangeLayouts",
      id: string,
      type?: string | null,
      status?: string | null,
      providerId?: string | null,
      creatorId?: string | null,
      creatorRole?: string | null,
      productsNumber?: number | null,
      file?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MassiveLayoutsByProviderQueryVariables = {
  providerId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMassiveChangeLayoutsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MassiveLayoutsByProviderQuery = {
  MassiveLayoutsByProvider?:  {
    __typename: "ModelMassiveChangeLayoutsConnection",
    items:  Array< {
      __typename: "MassiveChangeLayouts",
      id: string,
      type?: string | null,
      status?: string | null,
      providerId?: string | null,
      creatorId?: string | null,
      creatorRole?: string | null,
      productsNumber?: number | null,
      file?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MassiveLayoutsByCreatorQueryVariables = {
  creatorId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMassiveChangeLayoutsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MassiveLayoutsByCreatorQuery = {
  MassiveLayoutsByCreator?:  {
    __typename: "ModelMassiveChangeLayoutsConnection",
    items:  Array< {
      __typename: "MassiveChangeLayouts",
      id: string,
      type?: string | null,
      status?: string | null,
      providerId?: string | null,
      creatorId?: string | null,
      creatorRole?: string | null,
      productsNumber?: number | null,
      file?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCategoriesByParentCategoryQueryVariables = {
  parentId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCategoriesByParentCategoryQuery = {
  listCategoriesByParentCategory?:  {
    __typename: "ModelCategoryConnection",
    items:  Array< {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCategoriesByRootAndPathQueryVariables = {
  rootId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCategoriesByRootAndPathQuery = {
  listCategoriesByRootAndPath?:  {
    __typename: "ModelCategoryConnection",
    items:  Array< {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCategoriesByPathQueryVariables = {
  path: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCategoriesByPathQuery = {
  listCategoriesByPath?:  {
    __typename: "ModelCategoryConnection",
    items:  Array< {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCategoriesByNameExternalQueryVariables = {
  nameExternal: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCategoriesByNameExternalQuery = {
  listCategoriesByNameExternal?:  {
    __typename: "ModelCategoryConnection",
    items:  Array< {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCategoriesByProductLineQueryVariables = {
  productLine: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCategoriesByProductLineQuery = {
  ListCategoriesByProductLine?:  {
    __typename: "ModelCategoryConnection",
    items:  Array< {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductBrandsByStatusQueryVariables = {
  status: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductBrandFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductBrandsByStatusQuery = {
  ProductBrandsByStatus?:  {
    __typename: "ModelProductBrandConnection",
    items:  Array< {
      __typename: "ProductBrand",
      id: string,
      name: string,
      status?: string | null,
      description?: string | null,
      route: string,
      unspsc?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserByRolQueryVariables = {
  role: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetUserByRolQuery = {
  GetUserByRol?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      name: string,
      role: string,
      email: string,
      jiraId?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      companyId?: string | null,
      brandId?: string | null,
      failedLogins?: number | null,
      agents?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      notificationsOf?: Array< string | null > | null,
      status?: boolean | null,
      isLogistic?: boolean | null,
      isCoupa?: boolean | null,
      isManagement?: boolean | null,
      isAdministration?: boolean | null,
      hasNotifications?: boolean | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserByEmailQueryVariables = {
  email: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetUserByEmailQuery = {
  GetUserByEmail?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      name: string,
      role: string,
      email: string,
      jiraId?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      companyId?: string | null,
      brandId?: string | null,
      failedLogins?: number | null,
      agents?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      notificationsOf?: Array< string | null > | null,
      status?: boolean | null,
      isLogistic?: boolean | null,
      isCoupa?: boolean | null,
      isManagement?: boolean | null,
      isAdministration?: boolean | null,
      hasNotifications?: boolean | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserByJiraIdQueryVariables = {
  jiraId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetUserByJiraIdQuery = {
  GetUserByJiraId?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      name: string,
      role: string,
      email: string,
      jiraId?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      companyId?: string | null,
      brandId?: string | null,
      failedLogins?: number | null,
      agents?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      notificationsOf?: Array< string | null > | null,
      status?: boolean | null,
      isLogistic?: boolean | null,
      isCoupa?: boolean | null,
      isManagement?: boolean | null,
      isAdministration?: boolean | null,
      hasNotifications?: boolean | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserByCompanyIdQueryVariables = {
  companyId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetUserByCompanyIdQuery = {
  GetUserByCompanyId?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      name: string,
      role: string,
      email: string,
      jiraId?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      companyId?: string | null,
      brandId?: string | null,
      failedLogins?: number | null,
      agents?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      notificationsOf?: Array< string | null > | null,
      status?: boolean | null,
      isLogistic?: boolean | null,
      isCoupa?: boolean | null,
      isManagement?: boolean | null,
      isAdministration?: boolean | null,
      hasNotifications?: boolean | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUsersByBrandIdQueryVariables = {
  brandId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetUsersByBrandIdQuery = {
  GetUsersByBrandId?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      name: string,
      role: string,
      email: string,
      jiraId?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      companyId?: string | null,
      brandId?: string | null,
      failedLogins?: number | null,
      agents?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      notificationsOf?: Array< string | null > | null,
      status?: boolean | null,
      isLogistic?: boolean | null,
      isCoupa?: boolean | null,
      isManagement?: boolean | null,
      isAdministration?: boolean | null,
      hasNotifications?: boolean | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAutosByCreatedQueryVariables = {
  id: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAutomobileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetAutosByCreatedQuery = {
  getAutosByCreated?:  {
    __typename: "ModelAutomobileConnection",
    items:  Array< {
      __typename: "Automobile",
      id: string,
      clientId?: string | null,
      status?: boolean | null,
      bought?: boolean | null,
      buyerId?: string | null,
      buyerName?: string | null,
      price: number,
      brand: string,
      brandId?: string | null,
      model?: string | null,
      version: string,
      year: number,
      color?: string | null,
      km: number,
      transmission?: string | null,
      motor?: string | null,
      passengers?: number | null,
      state: string,
      objeto?: string | null,
      placa?: string | null,
      serialNumber?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      star_time?: number | null,
      end_time?: number | null,
      usersInteresting?:  Array< {
        __typename: "ListUsers",
        iduser?: string | null,
        nombre?: string | null,
        email?: string | null,
        fecha_compra?: string | null,
        veces_rechazo?: string | null,
        winner?: boolean | null,
        fecha_notificacion?: string | null,
        buyer?: boolean | null,
        process_buyer?: boolean | null,
        d_winner_date?: number | null,
        created?: number | null,
      } | null > | null,
      comentario?: string | null,
      penalizacion?: string | null,
      haveWinner?: boolean | null,
      ppostulacion?: boolean | null,
      logsGanadoresAutos?:  {
        __typename: "ModelLogGanadorAutoConnection",
        items:  Array< {
          __typename: "LogGanadorAuto",
          id: string,
          id_auto?: string | null,
          id_user?: string | null,
          fecha_rifa?: number | null,
          email?: string | null,
          nombre?: string | null,
          a_paterno?: string | null,
          a_materno?: string | null,
          status_buyer?: boolean | null,
          date_buyer?: number | null,
          winner?: number | null,
          refused?: number | null,
          since?: string | null,
          process_buyer?: boolean | null,
          reactive?: boolean | null,
          created: number,
          updated?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAutosByClientIdQueryVariables = {
  clientId: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAutomobileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetAutosByClientIdQuery = {
  getAutosByClientId?:  {
    __typename: "ModelAutomobileConnection",
    items:  Array< {
      __typename: "Automobile",
      id: string,
      clientId?: string | null,
      status?: boolean | null,
      bought?: boolean | null,
      buyerId?: string | null,
      buyerName?: string | null,
      price: number,
      brand: string,
      brandId?: string | null,
      model?: string | null,
      version: string,
      year: number,
      color?: string | null,
      km: number,
      transmission?: string | null,
      motor?: string | null,
      passengers?: number | null,
      state: string,
      objeto?: string | null,
      placa?: string | null,
      serialNumber?: string | null,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      star_time?: number | null,
      end_time?: number | null,
      usersInteresting?:  Array< {
        __typename: "ListUsers",
        iduser?: string | null,
        nombre?: string | null,
        email?: string | null,
        fecha_compra?: string | null,
        veces_rechazo?: string | null,
        winner?: boolean | null,
        fecha_notificacion?: string | null,
        buyer?: boolean | null,
        process_buyer?: boolean | null,
        d_winner_date?: number | null,
        created?: number | null,
      } | null > | null,
      comentario?: string | null,
      penalizacion?: string | null,
      haveWinner?: boolean | null,
      ppostulacion?: boolean | null,
      logsGanadoresAutos?:  {
        __typename: "ModelLogGanadorAutoConnection",
        items:  Array< {
          __typename: "LogGanadorAuto",
          id: string,
          id_auto?: string | null,
          id_user?: string | null,
          fecha_rifa?: number | null,
          email?: string | null,
          nombre?: string | null,
          a_paterno?: string | null,
          a_materno?: string | null,
          status_buyer?: boolean | null,
          date_buyer?: number | null,
          winner?: number | null,
          refused?: number | null,
          since?: string | null,
          process_buyer?: boolean | null,
          reactive?: boolean | null,
          created: number,
          updated?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRfqsByCreatedQueryVariables = {
  estatus: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRfqFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRfqsByCreatedQuery = {
  listRfqsByCreated?:  {
    __typename: "ModelRfqConnection",
    items:  Array< {
      __typename: "Rfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsConnection",
        items:  Array< {
          __typename: "Proposals",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      premiumOrderId?: string | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRfqsByClientQueryVariables = {
  estatus: string,
  clientId?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRfqFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRfqsByClientQuery = {
  listRfqsByClient?:  {
    __typename: "ModelRfqConnection",
    items:  Array< {
      __typename: "Rfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsConnection",
        items:  Array< {
          __typename: "Proposals",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      premiumOrderId?: string | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRfqsByClientCreatedQueryVariables = {
  estatus: string,
  clientIdCreated?: ModelRfqByEstatusClientCreatedCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRfqFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRfqsByClientCreatedQuery = {
  listRfqsByClientCreated?:  {
    __typename: "ModelRfqConnection",
    items:  Array< {
      __typename: "Rfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsConnection",
        items:  Array< {
          __typename: "Proposals",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      premiumOrderId?: string | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRfqsAmazonByCreatedQueryVariables = {
  estatus: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRfqAmazonFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRfqsAmazonByCreatedQuery = {
  listRfqsAmazonByCreated?:  {
    __typename: "ModelRfqAmazonConnection",
    items:  Array< {
      __typename: "RfqAmazon",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsAmazonConnection",
        items:  Array< {
          __typename: "ProposalsAmazon",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRfqsByAmazonByClientQueryVariables = {
  estatus: string,
  clientId?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRfqAmazonFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRfqsByAmazonByClientQuery = {
  listRfqsByAmazonByClient?:  {
    __typename: "ModelRfqAmazonConnection",
    items:  Array< {
      __typename: "RfqAmazon",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsAmazonConnection",
        items:  Array< {
          __typename: "ProposalsAmazon",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRfqsAmazonByClientCQueryVariables = {
  estatus: string,
  clientIdCreated?: ModelRfqAmazonByEstatusClientACreatedCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRfqAmazonFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRfqsAmazonByClientCQuery = {
  listRfqsAmazonByClientC?:  {
    __typename: "ModelRfqAmazonConnection",
    items:  Array< {
      __typename: "RfqAmazon",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsAmazonConnection",
        items:  Array< {
          __typename: "ProposalsAmazon",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListProductosRfqPriceQueryVariables = {
  category_id: string,
  price?: ModelFloatKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductoRfqFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProductosRfqPriceQuery = {
  listProductosRfqPrice?:  {
    __typename: "ModelProductoRfqConnection",
    items:  Array< {
      __typename: "ProductoRfq",
      id: string,
      name: string,
      request: string,
      category_id: string,
      provider_id: string,
      price?: number | null,
      category?:  {
        __typename: "Category",
        id: string,
        name: string,
        description?: string | null,
        unspsc?: string | null,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        imageMobile?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        visibleForUserBrand?: Array< string | null > | null,
        region?: Array< string | null > | null,
        tags?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        hasAllowables?: boolean | null,
        hasPreapproveds?: boolean | null,
        hasRestricted?: boolean | null,
        isPublic?: boolean | null,
        isTop?: boolean | null,
        createdAt?: string | null,
        slug?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        path?: string | null,
        status?: string | null,
        pathIds?: Array< string | null > | null,
        source?: string | null,
        trazoCategoryId?: string | null,
        nameExternal?: string | null,
        depth?: number | null,
        childrenCount?: number | null,
        isLeaf?: boolean | null,
        oldVersion?: string | null,
        productLine?: string | null,
        updatedAt: string,
      } | null,
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      images?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      estatus?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OrdersByProviderQueryVariables = {
  provider_id: string,
  orderId?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderProvidersFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OrdersByProviderQuery = {
  ordersByProvider?:  {
    __typename: "ModelOrderProvidersConnection",
    items:  Array< {
      __typename: "OrderProviders",
      id: string,
      provider_id: string,
      clientId?: string | null,
      orderId?: number | null,
      orderProvidersPremiumOrderId: string,
      payment_date?: number | null,
      gr_code?: string | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OrdersProvidersByClientIdQueryVariables = {
  clientId: string,
  orderId?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderProvidersFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OrdersProvidersByClientIdQuery = {
  OrdersProvidersByClientId?:  {
    __typename: "ModelOrderProvidersConnection",
    items:  Array< {
      __typename: "OrderProviders",
      id: string,
      provider_id: string,
      clientId?: string | null,
      orderId?: number | null,
      orderProvidersPremiumOrderId: string,
      payment_date?: number | null,
      gr_code?: string | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OrderProviderByPremiumOrderIdQueryVariables = {
  orderProvidersPremiumOrderId: string,
  orderId?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderProvidersFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OrderProviderByPremiumOrderIdQuery = {
  OrderProviderByPremiumOrderId?:  {
    __typename: "ModelOrderProvidersConnection",
    items:  Array< {
      __typename: "OrderProviders",
      id: string,
      provider_id: string,
      clientId?: string | null,
      orderId?: number | null,
      orderProvidersPremiumOrderId: string,
      payment_date?: number | null,
      gr_code?: string | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type VehicleTypesByPopMaterialIdQueryVariables = {
  popMaterialId: string,
  id?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVehicleTypeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type VehicleTypesByPopMaterialIdQuery = {
  VehicleTypesByPopMaterialId?:  {
    __typename: "ModelVehicleTypeConnection",
    items:  Array< {
      __typename: "VehicleType",
      id: string,
      name: string,
      popMaterialId: string,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      popMaterial?:  {
        __typename: "PopMaterial",
        id: string,
        name: string,
        route: string,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        year?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type VehiclesByBestSellersQueryVariables = {
  bestSeller: string,
  unitPrice?: ModelFloatKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVehicleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type VehiclesByBestSellersQuery = {
  VehiclesByBestSellers?:  {
    __typename: "ModelVehicleConnection",
    items:  Array< {
      __typename: "Vehicle",
      id: string,
      status?: string | null,
      isSustainable?: boolean | null,
      multiProvider?: boolean | null,
      itemName?: string | null,
      bestSeller?: string | null,
      name: string,
      brand: string,
      channel: string,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      description: string,
      size: string,
      materialDetail?: string | null,
      print?: string | null,
      finish?: string | null,
      packaging?: string | null,
      quantity: number,
      unitPrice: number,
      prototypePrice: number,
      productionTime: string,
      vehicleTypeId: string,
      popMaterialId: string,
      popCategoryId?: string | null,
      providerId: string,
      isRfq?: boolean | null,
      historicCost?: string | null,
      historicTime?: string | null,
      contact?: string | null,
      providerName?: string | null,
      variantsUnits?:  Array< {
        __typename: "VariantsUnits",
        min_units?: number | null,
        max_units?: number | null,
        price?: number | null,
        production_time?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      massiveLayout?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type VehiclesByTypeQueryVariables = {
  vehicleTypeId: string,
  id?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVehicleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type VehiclesByTypeQuery = {
  vehiclesByType?:  {
    __typename: "ModelVehicleConnection",
    items:  Array< {
      __typename: "Vehicle",
      id: string,
      status?: string | null,
      isSustainable?: boolean | null,
      multiProvider?: boolean | null,
      itemName?: string | null,
      bestSeller?: string | null,
      name: string,
      brand: string,
      channel: string,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      description: string,
      size: string,
      materialDetail?: string | null,
      print?: string | null,
      finish?: string | null,
      packaging?: string | null,
      quantity: number,
      unitPrice: number,
      prototypePrice: number,
      productionTime: string,
      vehicleTypeId: string,
      popMaterialId: string,
      popCategoryId?: string | null,
      providerId: string,
      isRfq?: boolean | null,
      historicCost?: string | null,
      historicTime?: string | null,
      contact?: string | null,
      providerName?: string | null,
      variantsUnits?:  Array< {
        __typename: "VariantsUnits",
        min_units?: number | null,
        max_units?: number | null,
        price?: number | null,
        production_time?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      massiveLayout?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type VehiclesByMaterialQueryVariables = {
  popMaterialId: string,
  id?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVehicleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type VehiclesByMaterialQuery = {
  vehiclesByMaterial?:  {
    __typename: "ModelVehicleConnection",
    items:  Array< {
      __typename: "Vehicle",
      id: string,
      status?: string | null,
      isSustainable?: boolean | null,
      multiProvider?: boolean | null,
      itemName?: string | null,
      bestSeller?: string | null,
      name: string,
      brand: string,
      channel: string,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      description: string,
      size: string,
      materialDetail?: string | null,
      print?: string | null,
      finish?: string | null,
      packaging?: string | null,
      quantity: number,
      unitPrice: number,
      prototypePrice: number,
      productionTime: string,
      vehicleTypeId: string,
      popMaterialId: string,
      popCategoryId?: string | null,
      providerId: string,
      isRfq?: boolean | null,
      historicCost?: string | null,
      historicTime?: string | null,
      contact?: string | null,
      providerName?: string | null,
      variantsUnits?:  Array< {
        __typename: "VariantsUnits",
        min_units?: number | null,
        max_units?: number | null,
        price?: number | null,
        production_time?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      massiveLayout?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type VehiclesbyChanelQueryVariables = {
  popMaterialId: string,
  channel?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVehicleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type VehiclesbyChanelQuery = {
  VehiclesbyChanel?:  {
    __typename: "ModelVehicleConnection",
    items:  Array< {
      __typename: "Vehicle",
      id: string,
      status?: string | null,
      isSustainable?: boolean | null,
      multiProvider?: boolean | null,
      itemName?: string | null,
      bestSeller?: string | null,
      name: string,
      brand: string,
      channel: string,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      description: string,
      size: string,
      materialDetail?: string | null,
      print?: string | null,
      finish?: string | null,
      packaging?: string | null,
      quantity: number,
      unitPrice: number,
      prototypePrice: number,
      productionTime: string,
      vehicleTypeId: string,
      popMaterialId: string,
      popCategoryId?: string | null,
      providerId: string,
      isRfq?: boolean | null,
      historicCost?: string | null,
      historicTime?: string | null,
      contact?: string | null,
      providerName?: string | null,
      variantsUnits?:  Array< {
        __typename: "VariantsUnits",
        min_units?: number | null,
        max_units?: number | null,
        price?: number | null,
        production_time?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      massiveLayout?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type VehiclesbyPopCategoryQueryVariables = {
  popCategoryId: string,
  id?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVehicleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type VehiclesbyPopCategoryQuery = {
  VehiclesbyPopCategory?:  {
    __typename: "ModelVehicleConnection",
    items:  Array< {
      __typename: "Vehicle",
      id: string,
      status?: string | null,
      isSustainable?: boolean | null,
      multiProvider?: boolean | null,
      itemName?: string | null,
      bestSeller?: string | null,
      name: string,
      brand: string,
      channel: string,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      description: string,
      size: string,
      materialDetail?: string | null,
      print?: string | null,
      finish?: string | null,
      packaging?: string | null,
      quantity: number,
      unitPrice: number,
      prototypePrice: number,
      productionTime: string,
      vehicleTypeId: string,
      popMaterialId: string,
      popCategoryId?: string | null,
      providerId: string,
      isRfq?: boolean | null,
      historicCost?: string | null,
      historicTime?: string | null,
      contact?: string | null,
      providerName?: string | null,
      variantsUnits?:  Array< {
        __typename: "VariantsUnits",
        min_units?: number | null,
        max_units?: number | null,
        price?: number | null,
        production_time?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      massiveLayout?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type VehiclesByProviderQueryVariables = {
  providerId: string,
  id?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVehicleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type VehiclesByProviderQuery = {
  vehiclesByProvider?:  {
    __typename: "ModelVehicleConnection",
    items:  Array< {
      __typename: "Vehicle",
      id: string,
      status?: string | null,
      isSustainable?: boolean | null,
      multiProvider?: boolean | null,
      itemName?: string | null,
      bestSeller?: string | null,
      name: string,
      brand: string,
      channel: string,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      description: string,
      size: string,
      materialDetail?: string | null,
      print?: string | null,
      finish?: string | null,
      packaging?: string | null,
      quantity: number,
      unitPrice: number,
      prototypePrice: number,
      productionTime: string,
      vehicleTypeId: string,
      popMaterialId: string,
      popCategoryId?: string | null,
      providerId: string,
      isRfq?: boolean | null,
      historicCost?: string | null,
      historicTime?: string | null,
      contact?: string | null,
      providerName?: string | null,
      variantsUnits?:  Array< {
        __typename: "VariantsUnits",
        min_units?: number | null,
        max_units?: number | null,
        price?: number | null,
        production_time?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      massiveLayout?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type VehiclesByMassiveLayoutQueryVariables = {
  massiveLayout: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVehicleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type VehiclesByMassiveLayoutQuery = {
  VehiclesByMassiveLayout?:  {
    __typename: "ModelVehicleConnection",
    items:  Array< {
      __typename: "Vehicle",
      id: string,
      status?: string | null,
      isSustainable?: boolean | null,
      multiProvider?: boolean | null,
      itemName?: string | null,
      bestSeller?: string | null,
      name: string,
      brand: string,
      channel: string,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      description: string,
      size: string,
      materialDetail?: string | null,
      print?: string | null,
      finish?: string | null,
      packaging?: string | null,
      quantity: number,
      unitPrice: number,
      prototypePrice: number,
      productionTime: string,
      vehicleTypeId: string,
      popMaterialId: string,
      popCategoryId?: string | null,
      providerId: string,
      isRfq?: boolean | null,
      historicCost?: string | null,
      historicTime?: string | null,
      contact?: string | null,
      providerName?: string | null,
      variantsUnits?:  Array< {
        __typename: "VariantsUnits",
        min_units?: number | null,
        max_units?: number | null,
        price?: number | null,
        production_time?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      massiveLayout?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PopOrderByCreatedAtQueryVariables = {
  estatus: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPopOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PopOrderByCreatedAtQuery = {
  popOrderByCreatedAt?:  {
    __typename: "ModelPopOrderConnection",
    items:  Array< {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PopOrdersByCreatedAtQueryVariables = {
  active: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPopOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PopOrdersByCreatedAtQuery = {
  popOrdersByCreatedAt?:  {
    __typename: "ModelPopOrderConnection",
    items:  Array< {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PopOrdersByBuyerQueryVariables = {
  orderCreatorId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPopOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PopOrdersByBuyerQuery = {
  PopOrdersByBuyer?:  {
    __typename: "ModelPopOrderConnection",
    items:  Array< {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PopOrdersByClientQueryVariables = {
  clientId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPopOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PopOrdersByClientQuery = {
  popOrdersByClient?:  {
    __typename: "ModelPopOrderConnection",
    items:  Array< {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PopOrderVehiclesByPopOrderQueryVariables = {
  orderId: string,
  vehicleId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPopOrderVehicleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PopOrderVehiclesByPopOrderQuery = {
  PopOrderVehiclesByPopOrder?:  {
    __typename: "ModelPopOrderVehicleConnection",
    items:  Array< {
      __typename: "PopOrderVehicle",
      id: string,
      orderId: string,
      vehicleId: string,
      providerId: string,
      unitPrice: number,
      prototypePrice: number,
      quantity: number,
      approved: boolean,
      hasQrCode?: boolean | null,
      vehicle:  {
        __typename: "Vehicle",
        id: string,
        status?: string | null,
        isSustainable?: boolean | null,
        multiProvider?: boolean | null,
        itemName?: string | null,
        bestSeller?: string | null,
        name: string,
        brand: string,
        channel: string,
        images:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } >,
        description: string,
        size: string,
        materialDetail?: string | null,
        print?: string | null,
        finish?: string | null,
        packaging?: string | null,
        quantity: number,
        unitPrice: number,
        prototypePrice: number,
        productionTime: string,
        vehicleTypeId: string,
        popMaterialId: string,
        popCategoryId?: string | null,
        providerId: string,
        isRfq?: boolean | null,
        historicCost?: string | null,
        historicTime?: string | null,
        contact?: string | null,
        providerName?: string | null,
        variantsUnits?:  Array< {
          __typename: "VariantsUnits",
          min_units?: number | null,
          max_units?: number | null,
          price?: number | null,
          production_time?: number | null,
        } | null > | null,
        visibleFor?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        providers?: Array< string | null > | null,
        massiveLayout?: string | null,
        created: number,
        updated?: number | null,
        createdAt: string,
        updatedAt: string,
      },
      order:  {
        __typename: "PopOrder",
        id: string,
        estatus: string,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        orderId?: number | null,
        requirement?: string | null,
        budget?: number | null,
        delivery_addresses?:  Array< {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null > | null,
        delivery_cost?: number | null,
        delivery_time?: number | null,
        files?:  Array< {
          __typename: "ListFiles",
          created: number,
          creator_id: string,
          status?: string | null,
          statusFile?: string | null,
          name: string,
          provider_id?: string | null,
          product_id?: string | null,
          tracking_code?: string | null,
          gr_code?: string | null,
          coupa_order?: string | null,
          description?: string | null,
        } | null > | null,
        contact?:  {
          __typename: "OrderContact",
          name: string,
          tel: string,
        } | null,
        subtotal?: number | null,
        total?: number | null,
        isCoupa: boolean,
        sentToCoupa?: boolean | null,
        coupaOrder?: string | null,
        active?: string | null,
        vehicles?:  {
          __typename: "ModelPopOrderVehicleConnection",
          nextToken?: string | null,
        } | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        orderAgents?:  Array< {
          __typename: "OrderAgent",
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
          user_id?: string | null,
        } | null > | null,
        orderAgentIds?: Array< string | null > | null,
        buyerInfo?:  {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null,
        buyersInfo?:  Array< {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null > | null,
        gr?: string | null,
        orderCreatorId: string,
        providers?:  {
          __typename: "ModelPopOrderProviderConnection",
          nextToken?: string | null,
        } | null,
        creator?:  {
          __typename: "OrderCreator",
          name: string,
          email: string,
          user_id: string,
        } | null,
        prequoteApproved?: boolean | null,
        quoteApproved?: boolean | null,
        prototypeApproved?: boolean | null,
        samplesDocsUploaded?: boolean | null,
        samplesApproved?: boolean | null,
        auditRequired?: boolean | null,
        drivePath?: string | null,
        auditDocsUploaded?: boolean | null,
        deliveryDateRequested?: boolean | null,
        deliveryDate?: number | null,
        deliveryCode?: string | null,
        deliveryFilesUploaded?: boolean | null,
        deliveryDocsApproved?: boolean | null,
        grUploaded?: boolean | null,
        grApproved?: boolean | null,
        grCode?: string | null,
        qrCode?: boolean | null,
        brandfactoryCheck?: boolean | null,
        step?: number | null,
        prototype?: boolean | null,
        dateKickoff?: number | null,
        paymentDate?: number | null,
        currentProcess?: string | null,
        currentSubprocess?: string | null,
        clientId?: string | null,
      },
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      sampleTestDate?: number | null,
      sampleTestDateApproved?: boolean | null,
      prototypeDate?: number | null,
      prototypeDateApproved?: boolean | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PopOrderProviderByPopOrderQueryVariables = {
  orderId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPopOrderProviderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PopOrderProviderByPopOrderQuery = {
  popOrderProviderByPopOrder?:  {
    __typename: "ModelPopOrderProviderConnection",
    items:  Array< {
      __typename: "PopOrderProvider",
      id: string,
      orderId: string,
      providerId: string,
      deliveryDateRequested?: boolean | null,
      grRequested?: boolean | null,
      invoiceUploaded?: boolean | null,
      order:  {
        __typename: "PopOrder",
        id: string,
        estatus: string,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        orderId?: number | null,
        requirement?: string | null,
        budget?: number | null,
        delivery_addresses?:  Array< {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null > | null,
        delivery_cost?: number | null,
        delivery_time?: number | null,
        files?:  Array< {
          __typename: "ListFiles",
          created: number,
          creator_id: string,
          status?: string | null,
          statusFile?: string | null,
          name: string,
          provider_id?: string | null,
          product_id?: string | null,
          tracking_code?: string | null,
          gr_code?: string | null,
          coupa_order?: string | null,
          description?: string | null,
        } | null > | null,
        contact?:  {
          __typename: "OrderContact",
          name: string,
          tel: string,
        } | null,
        subtotal?: number | null,
        total?: number | null,
        isCoupa: boolean,
        sentToCoupa?: boolean | null,
        coupaOrder?: string | null,
        active?: string | null,
        vehicles?:  {
          __typename: "ModelPopOrderVehicleConnection",
          nextToken?: string | null,
        } | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        orderAgents?:  Array< {
          __typename: "OrderAgent",
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
          user_id?: string | null,
        } | null > | null,
        orderAgentIds?: Array< string | null > | null,
        buyerInfo?:  {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null,
        buyersInfo?:  Array< {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null > | null,
        gr?: string | null,
        orderCreatorId: string,
        providers?:  {
          __typename: "ModelPopOrderProviderConnection",
          nextToken?: string | null,
        } | null,
        creator?:  {
          __typename: "OrderCreator",
          name: string,
          email: string,
          user_id: string,
        } | null,
        prequoteApproved?: boolean | null,
        quoteApproved?: boolean | null,
        prototypeApproved?: boolean | null,
        samplesDocsUploaded?: boolean | null,
        samplesApproved?: boolean | null,
        auditRequired?: boolean | null,
        drivePath?: string | null,
        auditDocsUploaded?: boolean | null,
        deliveryDateRequested?: boolean | null,
        deliveryDate?: number | null,
        deliveryCode?: string | null,
        deliveryFilesUploaded?: boolean | null,
        deliveryDocsApproved?: boolean | null,
        grUploaded?: boolean | null,
        grApproved?: boolean | null,
        grCode?: string | null,
        qrCode?: boolean | null,
        brandfactoryCheck?: boolean | null,
        step?: number | null,
        prototype?: boolean | null,
        dateKickoff?: number | null,
        paymentDate?: number | null,
        currentProcess?: string | null,
        currentSubprocess?: string | null,
        clientId?: string | null,
      },
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PopOrderProviderByCreatedAtQueryVariables = {
  providerId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPopOrderProviderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PopOrderProviderByCreatedAtQuery = {
  popOrderProviderByCreatedAt?:  {
    __typename: "ModelPopOrderProviderConnection",
    items:  Array< {
      __typename: "PopOrderProvider",
      id: string,
      orderId: string,
      providerId: string,
      deliveryDateRequested?: boolean | null,
      grRequested?: boolean | null,
      invoiceUploaded?: boolean | null,
      order:  {
        __typename: "PopOrder",
        id: string,
        estatus: string,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        orderId?: number | null,
        requirement?: string | null,
        budget?: number | null,
        delivery_addresses?:  Array< {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null > | null,
        delivery_cost?: number | null,
        delivery_time?: number | null,
        files?:  Array< {
          __typename: "ListFiles",
          created: number,
          creator_id: string,
          status?: string | null,
          statusFile?: string | null,
          name: string,
          provider_id?: string | null,
          product_id?: string | null,
          tracking_code?: string | null,
          gr_code?: string | null,
          coupa_order?: string | null,
          description?: string | null,
        } | null > | null,
        contact?:  {
          __typename: "OrderContact",
          name: string,
          tel: string,
        } | null,
        subtotal?: number | null,
        total?: number | null,
        isCoupa: boolean,
        sentToCoupa?: boolean | null,
        coupaOrder?: string | null,
        active?: string | null,
        vehicles?:  {
          __typename: "ModelPopOrderVehicleConnection",
          nextToken?: string | null,
        } | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        orderAgents?:  Array< {
          __typename: "OrderAgent",
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
          user_id?: string | null,
        } | null > | null,
        orderAgentIds?: Array< string | null > | null,
        buyerInfo?:  {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null,
        buyersInfo?:  Array< {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null > | null,
        gr?: string | null,
        orderCreatorId: string,
        providers?:  {
          __typename: "ModelPopOrderProviderConnection",
          nextToken?: string | null,
        } | null,
        creator?:  {
          __typename: "OrderCreator",
          name: string,
          email: string,
          user_id: string,
        } | null,
        prequoteApproved?: boolean | null,
        quoteApproved?: boolean | null,
        prototypeApproved?: boolean | null,
        samplesDocsUploaded?: boolean | null,
        samplesApproved?: boolean | null,
        auditRequired?: boolean | null,
        drivePath?: string | null,
        auditDocsUploaded?: boolean | null,
        deliveryDateRequested?: boolean | null,
        deliveryDate?: number | null,
        deliveryCode?: string | null,
        deliveryFilesUploaded?: boolean | null,
        deliveryDocsApproved?: boolean | null,
        grUploaded?: boolean | null,
        grApproved?: boolean | null,
        grCode?: string | null,
        qrCode?: boolean | null,
        brandfactoryCheck?: boolean | null,
        step?: number | null,
        prototype?: boolean | null,
        dateKickoff?: number | null,
        paymentDate?: number | null,
        currentProcess?: string | null,
        currentSubprocess?: string | null,
        clientId?: string | null,
      },
      provider:  {
        __typename: "Provider",
        id: string,
        isApproved?: boolean | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comertial_name?: string | null,
        bussiness_name?:  {
          __typename: "BusinessName",
          rfc?: string | null,
          name?: string | null,
        } | null,
        idProcter?: string | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        biography?: string | null,
        constancia?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        comprobante?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        experience?: string | null,
        pros?: Array< string | null > | null,
        cons?: Array< string | null > | null,
        cte_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        shopping_rating?:  Array< {
          __typename: "Rating",
          name?: string | null,
          rating?: number | null,
        } | null > | null,
        video?: string | null,
        tags?: Array< string | null > | null,
        money_filter_c?: boolean | null,
        money_filter_d?: boolean | null,
        users?: Array< string | null > | null,
        bank?: string | null,
        account?: string | null,
        clabe?: string | null,
        cuenta_correo?: string | null,
        edocuenta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        ife?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        poderes?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        acta?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        isProvider?: boolean | null,
        sameAddress?: boolean | null,
        isPop?: boolean | null,
        isPrinted?: boolean | null,
        hasLogistic?: boolean | null,
        created?: number | null,
        updated?: number | null,
        addFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        signFiles?:  Array< {
          __typename: "SignFile",
          key?: string | null,
          url?: string | null,
          sign?: string | null,
          status?: string | null,
        } | null > | null,
        representante_legal?: string | null,
        escritura_constitucion?: string | null,
        notario_a?: string | null,
        constituido_down_edo?: string | null,
        rrpp?: string | null,
        isPremium?: boolean | null,
        isTrustProvider?: boolean | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PopOrderLogsByOrderQueryVariables = {
  orderId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPopOrderLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PopOrderLogsByOrderQuery = {
  PopOrderLogsByOrder?:  {
    __typename: "ModelPopOrderLogConnection",
    items:  Array< {
      __typename: "PopOrderLog",
      id: string,
      orderId: string,
      creatorId: string,
      order?:  {
        __typename: "PopOrder",
        id: string,
        estatus: string,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        orderId?: number | null,
        requirement?: string | null,
        budget?: number | null,
        delivery_addresses?:  Array< {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null > | null,
        delivery_cost?: number | null,
        delivery_time?: number | null,
        files?:  Array< {
          __typename: "ListFiles",
          created: number,
          creator_id: string,
          status?: string | null,
          statusFile?: string | null,
          name: string,
          provider_id?: string | null,
          product_id?: string | null,
          tracking_code?: string | null,
          gr_code?: string | null,
          coupa_order?: string | null,
          description?: string | null,
        } | null > | null,
        contact?:  {
          __typename: "OrderContact",
          name: string,
          tel: string,
        } | null,
        subtotal?: number | null,
        total?: number | null,
        isCoupa: boolean,
        sentToCoupa?: boolean | null,
        coupaOrder?: string | null,
        active?: string | null,
        vehicles?:  {
          __typename: "ModelPopOrderVehicleConnection",
          nextToken?: string | null,
        } | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        orderAgents?:  Array< {
          __typename: "OrderAgent",
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
          user_id?: string | null,
        } | null > | null,
        orderAgentIds?: Array< string | null > | null,
        buyerInfo?:  {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null,
        buyersInfo?:  Array< {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null > | null,
        gr?: string | null,
        orderCreatorId: string,
        providers?:  {
          __typename: "ModelPopOrderProviderConnection",
          nextToken?: string | null,
        } | null,
        creator?:  {
          __typename: "OrderCreator",
          name: string,
          email: string,
          user_id: string,
        } | null,
        prequoteApproved?: boolean | null,
        quoteApproved?: boolean | null,
        prototypeApproved?: boolean | null,
        samplesDocsUploaded?: boolean | null,
        samplesApproved?: boolean | null,
        auditRequired?: boolean | null,
        drivePath?: string | null,
        auditDocsUploaded?: boolean | null,
        deliveryDateRequested?: boolean | null,
        deliveryDate?: number | null,
        deliveryCode?: string | null,
        deliveryFilesUploaded?: boolean | null,
        deliveryDocsApproved?: boolean | null,
        grUploaded?: boolean | null,
        grApproved?: boolean | null,
        grCode?: string | null,
        qrCode?: boolean | null,
        brandfactoryCheck?: boolean | null,
        step?: number | null,
        prototype?: boolean | null,
        dateKickoff?: number | null,
        paymentDate?: number | null,
        currentProcess?: string | null,
        currentSubprocess?: string | null,
        clientId?: string | null,
      } | null,
      createdAt?: string | null,
      text: string,
      orderStatus: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRfqsPopByCreatedQueryVariables = {
  estatus: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRfqPopFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRfqsPopByCreatedQuery = {
  listRfqsPopByCreated?:  {
    __typename: "ModelRfqPopConnection",
    items:  Array< {
      __typename: "RfqPop",
      id: string,
      nombre: string,
      requerimiento: string,
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      vehiclesRfq?:  Array< {
        __typename: "VehicleUnitRfq",
        vehicleTypeId?: string | null,
        popMaterialId?: string | null,
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      proposals?:  {
        __typename: "ModelProposalsPopConnection",
        items:  Array< {
          __typename: "ProposalsPop",
          id: string,
          provider_id: string,
          price: number,
          created: number,
          validity_days?: number | null,
          description?: string | null,
          updated?: number | null,
          proposalsPopRfqId?: string | null,
          prototypePrice: number,
          hidden?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      clientId?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfqPopProviders",
        idProvider?: string | null,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      popOrderId?: string | null,
      orderId?: number | null,
      estatus: string,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      budget?: number | null,
      hasQrCode?: boolean | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPopRfqsByClientQueryVariables = {
  estatus: string,
  clientId?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRfqPopFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPopRfqsByClientQuery = {
  ListPopRfqsByClient?:  {
    __typename: "ModelRfqPopConnection",
    items:  Array< {
      __typename: "RfqPop",
      id: string,
      nombre: string,
      requerimiento: string,
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      vehiclesRfq?:  Array< {
        __typename: "VehicleUnitRfq",
        vehicleTypeId?: string | null,
        popMaterialId?: string | null,
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      proposals?:  {
        __typename: "ModelProposalsPopConnection",
        items:  Array< {
          __typename: "ProposalsPop",
          id: string,
          provider_id: string,
          price: number,
          created: number,
          validity_days?: number | null,
          description?: string | null,
          updated?: number | null,
          proposalsPopRfqId?: string | null,
          prototypePrice: number,
          hidden?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      clientId?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfqPopProviders",
        idProvider?: string | null,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      popOrderId?: string | null,
      orderId?: number | null,
      estatus: string,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      budget?: number | null,
      hasQrCode?: boolean | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRfqsPopByCreatorQueryVariables = {
  estatus: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRfqPopFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRfqsPopByCreatorQuery = {
  ListRfqsPopByCreator?:  {
    __typename: "ModelRfqPopConnection",
    items:  Array< {
      __typename: "RfqPop",
      id: string,
      nombre: string,
      requerimiento: string,
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      vehiclesRfq?:  Array< {
        __typename: "VehicleUnitRfq",
        vehicleTypeId?: string | null,
        popMaterialId?: string | null,
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      proposals?:  {
        __typename: "ModelProposalsPopConnection",
        items:  Array< {
          __typename: "ProposalsPop",
          id: string,
          provider_id: string,
          price: number,
          created: number,
          validity_days?: number | null,
          description?: string | null,
          updated?: number | null,
          proposalsPopRfqId?: string | null,
          prototypePrice: number,
          hidden?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      clientId?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfqPopProviders",
        idProvider?: string | null,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      popOrderId?: string | null,
      orderId?: number | null,
      estatus: string,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      budget?: number | null,
      hasQrCode?: boolean | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUsersBrandByClientIdQueryVariables = {
  clientId: string,
  status?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUsersBrandsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetUsersBrandByClientIdQuery = {
  GetUsersBrandByClientId?:  {
    __typename: "ModelUsersBrandsConnection",
    items:  Array< {
      __typename: "UsersBrands",
      id: string,
      name: string,
      description?: string | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      status?: string | null,
      clientId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type LogsPUserByUserEmailQueryVariables = {
  user: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLogsPUsersFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type LogsPUserByUserEmailQuery = {
  LogsPUserByUserEmail?:  {
    __typename: "ModelLogsPUsersConnection",
    items:  Array< {
      __typename: "LogsPUsers",
      id: string,
      user?: string | null,
      keyword?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ClipPaymentsByPremiumOrderQueryVariables = {
  orderId: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelClipPaymentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ClipPaymentsByPremiumOrderQuery = {
  ClipPaymentsByPremiumOrder?:  {
    __typename: "ModelClipPaymentConnection",
    items:  Array< {
      __typename: "ClipPayment",
      id: string,
      status?: string | null,
      requestsCount?: number | null,
      payment_request_id?: string | null,
      purchase_description?: string | null,
      orderId: string,
      clientId: string,
      userId: string,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ClipPaymentsByClientQueryVariables = {
  clientId: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelClipPaymentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ClipPaymentsByClientQuery = {
  ClipPaymentsByClient?:  {
    __typename: "ModelClipPaymentConnection",
    items:  Array< {
      __typename: "ClipPayment",
      id: string,
      status?: string | null,
      requestsCount?: number | null,
      payment_request_id?: string | null,
      purchase_description?: string | null,
      orderId: string,
      clientId: string,
      userId: string,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ClipPaymentsByUserQueryVariables = {
  userId: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelClipPaymentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ClipPaymentsByUserQuery = {
  ClipPaymentsByUser?:  {
    __typename: "ModelClipPaymentConnection",
    items:  Array< {
      __typename: "ClipPayment",
      id: string,
      status?: string | null,
      requestsCount?: number | null,
      payment_request_id?: string | null,
      purchase_description?: string | null,
      orderId: string,
      clientId: string,
      userId: string,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OrderProcessesByTypeQueryVariables = {
  type: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderProcessFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OrderProcessesByTypeQuery = {
  OrderProcessesByType?:  {
    __typename: "ModelOrderProcessConnection",
    items:  Array< {
      __typename: "OrderProcess",
      id: string,
      type?: string | null,
      status?: boolean | null,
      tcdPayment?: boolean | null,
      name: string,
      duration?: string | null,
      descripcion?: string | null,
      position: number,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  {
        __typename: "ModelOrderSubprocessConnection",
        items:  Array< {
          __typename: "OrderSubprocess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          name: string,
          position: number,
          descripcion: string,
          action: number,
          processId: string,
          clientId: string,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      clientId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OrderProcessByClientQueryVariables = {
  clientId: string,
  position?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderProcessFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OrderProcessByClientQuery = {
  OrderProcessByClient?:  {
    __typename: "ModelOrderProcessConnection",
    items:  Array< {
      __typename: "OrderProcess",
      id: string,
      type?: string | null,
      status?: boolean | null,
      tcdPayment?: boolean | null,
      name: string,
      duration?: string | null,
      descripcion?: string | null,
      position: number,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  {
        __typename: "ModelOrderSubprocessConnection",
        items:  Array< {
          __typename: "OrderSubprocess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          name: string,
          position: number,
          descripcion: string,
          action: number,
          processId: string,
          clientId: string,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      clientId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OrderSubprocessesByTypeQueryVariables = {
  type: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderSubprocessFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OrderSubprocessesByTypeQuery = {
  OrderSubprocessesByType?:  {
    __typename: "ModelOrderSubprocessConnection",
    items:  Array< {
      __typename: "OrderSubprocess",
      id: string,
      type?: string | null,
      status?: boolean | null,
      name: string,
      position: number,
      descripcion: string,
      action: number,
      process?:  {
        __typename: "OrderProcess",
        id: string,
        type?: string | null,
        status?: boolean | null,
        tcdPayment?: boolean | null,
        name: string,
        duration?: string | null,
        descripcion?: string | null,
        position: number,
        responsible?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        cards?:  Array< {
          __typename: "OrderCards",
          id?: string | null,
          name?: string | null,
        } | null > | null,
        subprocesses?:  {
          __typename: "ModelOrderSubprocessConnection",
          nextToken?: string | null,
        } | null,
        clientId?: string | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null,
      processId: string,
      clientId: string,
      messages?:  Array< {
        __typename: "MessageSubprocess",
        description?: string | null,
        rol?: string | null,
        visibleAction?: boolean | null,
      } | null > | null,
      notifications?:  Array< {
        __typename: "NotificationSubprocesses",
        group?: string | null,
        enabledEmail?: boolean | null,
        enabledPopUp?: boolean | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OrderSubprocessesByProcessQueryVariables = {
  processId: string,
  position?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderSubprocessFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OrderSubprocessesByProcessQuery = {
  OrderSubprocessesByProcess?:  {
    __typename: "ModelOrderSubprocessConnection",
    items:  Array< {
      __typename: "OrderSubprocess",
      id: string,
      type?: string | null,
      status?: boolean | null,
      name: string,
      position: number,
      descripcion: string,
      action: number,
      process?:  {
        __typename: "OrderProcess",
        id: string,
        type?: string | null,
        status?: boolean | null,
        tcdPayment?: boolean | null,
        name: string,
        duration?: string | null,
        descripcion?: string | null,
        position: number,
        responsible?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        cards?:  Array< {
          __typename: "OrderCards",
          id?: string | null,
          name?: string | null,
        } | null > | null,
        subprocesses?:  {
          __typename: "ModelOrderSubprocessConnection",
          nextToken?: string | null,
        } | null,
        clientId?: string | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null,
      processId: string,
      clientId: string,
      messages?:  Array< {
        __typename: "MessageSubprocess",
        description?: string | null,
        rol?: string | null,
        visibleAction?: boolean | null,
      } | null > | null,
      notifications?:  Array< {
        __typename: "NotificationSubprocesses",
        group?: string | null,
        enabledEmail?: boolean | null,
        enabledPopUp?: boolean | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OrderSubprocessesByClientQueryVariables = {
  clientId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderSubprocessFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OrderSubprocessesByClientQuery = {
  OrderSubprocessesByClient?:  {
    __typename: "ModelOrderSubprocessConnection",
    items:  Array< {
      __typename: "OrderSubprocess",
      id: string,
      type?: string | null,
      status?: boolean | null,
      name: string,
      position: number,
      descripcion: string,
      action: number,
      process?:  {
        __typename: "OrderProcess",
        id: string,
        type?: string | null,
        status?: boolean | null,
        tcdPayment?: boolean | null,
        name: string,
        duration?: string | null,
        descripcion?: string | null,
        position: number,
        responsible?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        cards?:  Array< {
          __typename: "OrderCards",
          id?: string | null,
          name?: string | null,
        } | null > | null,
        subprocesses?:  {
          __typename: "ModelOrderSubprocessConnection",
          nextToken?: string | null,
        } | null,
        clientId?: string | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null,
      processId: string,
      clientId: string,
      messages?:  Array< {
        __typename: "MessageSubprocess",
        description?: string | null,
        rol?: string | null,
        visibleAction?: boolean | null,
      } | null > | null,
      notifications?:  Array< {
        __typename: "NotificationSubprocesses",
        group?: string | null,
        enabledEmail?: boolean | null,
        enabledPopUp?: boolean | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PremiumOrdersByBuyerQueryVariables = {
  orderCreatorId: string,
  orderId?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPremiumOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PremiumOrdersByBuyerQuery = {
  PremiumOrdersByBuyer?:  {
    __typename: "ModelPremiumOrderConnection",
    items:  Array< {
      __typename: "PremiumOrder",
      id: string,
      requirement?: string | null,
      bank_reference?: string | null,
      hasVat?: boolean | null,
      billingData?:  {
        __typename: "BillingData",
        name?: string | null,
        rfc?: string | null,
        regimen?: string | null,
        cfdi_use?: string | null,
        cp?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
      } | null,
      orderId: number,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      logs?:  Array< {
        __typename: "Log",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        role?: string | null,
      } | null > | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_fee?: number | null,
      delivery_discount?: number | null,
      delivery_time?: number | null,
      delivery_date?: string | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      taxSituationFile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      clipUrl?: string | null,
      clipStatus?: string | null,
      listProviders?:  Array< {
        __typename: "ListProvidersOrder",
        provider_id: string,
        order_id: string,
        payment_date?: number | null,
        gr_code?: string | null,
        order_confirmation?: boolean | null,
        invoice?: boolean | null,
        invoiceRequested?: boolean | null,
        uploadedGr?: boolean | null,
        uploadedBill?: boolean | null,
        delivered?: boolean | null,
        deliveredFormat?: boolean | null,
      } | null > | null,
      providers?:  {
        __typename: "ModelOrderProvidersConnection",
        items:  Array< {
          __typename: "OrderProviders",
          id: string,
          provider_id: string,
          clientId?: string | null,
          orderId?: number | null,
          orderProvidersPremiumOrderId: string,
          payment_date?: number | null,
          gr_code?: string | null,
          invoice?: boolean | null,
          invoiceRequested?: boolean | null,
          uploadedGr?: boolean | null,
          uploadedBill?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      listsProducts:  Array< {
        __typename: "ProductInOrder",
        product_id: string,
        provider_id?: string | null,
        index?: number | null,
        print?: number | null,
        printPrice?: number | null,
        product_name: string,
        description?: string | null,
        category?: string | null,
        unspsc?: string | null,
        price?: number | null,
        originalPrice?: number | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        sample_authorize?: boolean | null,
        sample_authorized?: boolean | null,
        quality_requested?: boolean | null,
        quality_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        isExternal?: boolean | null,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        sku?: string | null,
        qualityForm?:  {
          __typename: "ProductInOrderQualityPGForm",
          initiativeDescription?: string | null,
          targetUser?: string | null,
          retailBrandName?: string | null,
          itemCategory?: string | null,
          itemPicture?: string | null,
          originCountry?: string | null,
          quantityPerCountryOfDist?: string | null,
          initiativeDates?: string | null,
          isPartOfAnMSOCustOrSpecPack?: string | null,
          incluesClientLogo?: string | null,
          isAReorderWithinTwelveMonths?: string | null,
          isReorder?: string | null,
          PGPLContactName?: string | null,
          ulTracking?: string | null,
          PLContactName?: string | null,
          contactEmailAddress?: string | null,
          PGPurchaseOrderNumber?: string | null,
          EBBSorSupplierProvidedProjectNumber?: string | null,
          vendorCompanyName?: string | null,
          vendorContactName?: string | null,
          vendorEmailAddress?: string | null,
          vendorJobTitle?: string | null,
          vendorTelephone?: string | null,
          vendorMailingAddress?: string | null,
          vendorCity?: string | null,
          vendorState?: string | null,
          vendorCountry?: string | null,
          vendorPC?: string | null,
          physicalItemDescription?: string | null,
          SampleOrMaterialComponentSubmitted?: string | null,
          toWhom?: string | null,
          descriptionOfItemPackagingAndArtwork?: string | null,
          regulatoryAndLegislativeProductCertification?: string | null,
          dateFinalApprovalRequestedSubmittedToPG?: string | null,
          DateOfDeclarationOfConformity?: string | null,
          dateOfApprovalExpirationOfPremiumItem?: string | null,
          itemClasification?: string | null,
          PGRepresentativeMarketingDesign?: string | null,
          PGProjectLeaderRequestor?: string | null,
          PGRestrictedItemsLocalPGLegal?: string | null,
          PGLocalCategoryGM?: string | null,
          PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
          idProduct?: string | null,
          pathDocument?: string | null,
        } | null,
        fee?: number | null,
        increment?: number | null,
        discount?: number | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        sellMode?: ProductMaskSellMode | null,
        kitPieces?: number | null,
      } >,
      cotizationsList:  Array< {
        __typename: "PremiumOrderCotizationsLog",
        id: number,
        created: number,
        createdBy: string,
        products:  Array< {
          __typename: "ProductInOrder",
          product_id: string,
          provider_id?: string | null,
          index?: number | null,
          print?: number | null,
          printPrice?: number | null,
          product_name: string,
          description?: string | null,
          category?: string | null,
          unspsc?: string | null,
          price?: number | null,
          originalPrice?: number | null,
          sample_requested?: boolean | null,
          sample_request?: boolean | null,
          sample_authorize?: boolean | null,
          sample_authorized?: boolean | null,
          quality_requested?: boolean | null,
          quality_request?: boolean | null,
          uploadedSample?: boolean | null,
          quantity: number,
          isExternal?: boolean | null,
          sku?: string | null,
          fee?: number | null,
          increment?: number | null,
          discount?: number | null,
          sellMode?: ProductMaskSellMode | null,
          kitPieces?: number | null,
        } >,
      } | null >,
      orderCreatorId: string,
      creator:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      },
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      invoiceContact?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      premiumOrderClientId?: string | null,
      client?:  {
        __typename: "Client",
        id: string,
        status?: boolean | null,
        business_name: string,
        comertial_name: string,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        buyerInfo?:  {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null,
        buyersInfo?:  Array< {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null > | null,
        biography?: string | null,
        plan?: string | null,
        fee?: number | null,
        increment?: number | null,
        mercadoFee?: number | null,
        mercadoIncrement?: number | null,
        popFee?: number | null,
        popIncrement?: number | null,
        printedFee?: number | null,
        printedIncrement?: number | null,
        users?: Array< string | null > | null,
        restrictedUsers?: Array< string | null > | null,
        nonRestrictedUsers?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        providers?: Array< string | null > | null,
        popProviders?: Array< string | null > | null,
        printedProviders?: Array< string | null > | null,
        logisticFrequency?: number | null,
        agents?:  Array< {
          __typename: "Agent",
          id?: string | null,
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
        } | null > | null,
        administrators?:  Array< {
          __typename: "Agent",
          id?: string | null,
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
        } | null > | null,
        signDocument?:  Array< {
          __typename: "Sign",
          url?: string | null,
          enabled?: boolean | null,
        } | null > | null,
        legal_representative?: string | null,
        legal_representative_email?: string | null,
        legal_representative_address?: string | null,
        tcdUsers?: Array< string | null > | null,
        billingUsers?:  Array< {
          __typename: "Agent",
          id?: string | null,
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
        } | null > | null,
        createdAt: string,
        updatedAt?: string | null,
      } | null,
      userBrandId?: string | null,
      userBrand?:  {
        __typename: "UsersBrands",
        id: string,
        name: string,
        description?: string | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        status?: string | null,
        clientId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subtotal?: number | null,
      fee?: number | null,
      printedPrice?: number | null,
      total?: number | null,
      discountAmount?: number | null,
      syncWithCrm?: boolean | null,
      crmIssueKey?: string | null,
      sentToAlendum?: boolean | null,
      alendumProjectId?: string | null,
      syncWithFms?: string | null,
      fmsInvoiceId?: string | null,
      syncWithWms?: boolean | null,
      wmsProjectId?: string | null,
      isCoupa?: boolean | null,
      sentToCoupa?: boolean | null,
      isRfq?: boolean | null,
      requireSamples?: boolean | null,
      requestedSamples?: boolean | null,
      approvedSamples?: boolean | null,
      authorizedQA?: boolean | null,
      active?: string | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      processes?:  Array< {
        __typename: "OrderProcessStructure",
        id?: string | null,
        name?: string | null,
        descripcion?: string | null,
        duration?: string | null,
        position?: number | null,
        responsible?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        madeBy?: string | null,
        madeAt?: number | null,
        cards?:  Array< {
          __typename: "OrderCards",
          id?: string | null,
          name?: string | null,
        } | null > | null,
        subprocesses?:  Array< {
          __typename: "OrderSubprocessStructure",
          id?: string | null,
          name?: string | null,
          position?: number | null,
          descripcion?: string | null,
          action?: number | null,
          process?: string | null,
          madeBy?: string | null,
          madeAt?: number | null,
        } | null > | null,
      } | null > | null,
      updatedAt?: string | null,
      created: number,
      updated?: number | null,
      logistic?:  Array< {
        __typename: "LogisticPremiumOrder",
        premiumOrderId?: string | null,
        tracking_number?: string | null,
        destiny_latitude?: string | null,
        destiny_longitude?: string | null,
        status?: string | null,
        status_activity?: string | null,
        status_description?: string | null,
        origin_latitude?: string | null,
        origin_longitude?: string | null,
        carrier?: string | null,
        clave_sat?: string | null,
        customer_delivery_start_date?: string | null,
        customer_email?: string | null,
        customer_external_number?: string | null,
        customer_first_name?: string | null,
        customer_last_name?: string | null,
        customer_mobile_number?: string | null,
        customer_postcode?: string | null,
        customer_settlement?: string | null,
        customer_street?: string | null,
        descripcion_sat?: string | null,
        peligroso?: string | null,
        primary_client?: string | null,
        purchase_order_number?: string | null,
        shipping_method?: string | null,
        shipping_option?: string | null,
        created: number,
      } | null > | null,
      createdAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PremiumOrdersByClientQueryVariables = {
  premiumOrderClientId: string,
  orderId?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPremiumOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PremiumOrdersByClientQuery = {
  PremiumOrdersByClient?:  {
    __typename: "ModelPremiumOrderConnection",
    items:  Array< {
      __typename: "PremiumOrder",
      id: string,
      requirement?: string | null,
      bank_reference?: string | null,
      hasVat?: boolean | null,
      billingData?:  {
        __typename: "BillingData",
        name?: string | null,
        rfc?: string | null,
        regimen?: string | null,
        cfdi_use?: string | null,
        cp?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
      } | null,
      orderId: number,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      logs?:  Array< {
        __typename: "Log",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        role?: string | null,
      } | null > | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_fee?: number | null,
      delivery_discount?: number | null,
      delivery_time?: number | null,
      delivery_date?: string | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      taxSituationFile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      clipUrl?: string | null,
      clipStatus?: string | null,
      listProviders?:  Array< {
        __typename: "ListProvidersOrder",
        provider_id: string,
        order_id: string,
        payment_date?: number | null,
        gr_code?: string | null,
        order_confirmation?: boolean | null,
        invoice?: boolean | null,
        invoiceRequested?: boolean | null,
        uploadedGr?: boolean | null,
        uploadedBill?: boolean | null,
        delivered?: boolean | null,
        deliveredFormat?: boolean | null,
      } | null > | null,
      providers?:  {
        __typename: "ModelOrderProvidersConnection",
        items:  Array< {
          __typename: "OrderProviders",
          id: string,
          provider_id: string,
          clientId?: string | null,
          orderId?: number | null,
          orderProvidersPremiumOrderId: string,
          payment_date?: number | null,
          gr_code?: string | null,
          invoice?: boolean | null,
          invoiceRequested?: boolean | null,
          uploadedGr?: boolean | null,
          uploadedBill?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      listsProducts:  Array< {
        __typename: "ProductInOrder",
        product_id: string,
        provider_id?: string | null,
        index?: number | null,
        print?: number | null,
        printPrice?: number | null,
        product_name: string,
        description?: string | null,
        category?: string | null,
        unspsc?: string | null,
        price?: number | null,
        originalPrice?: number | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        sample_authorize?: boolean | null,
        sample_authorized?: boolean | null,
        quality_requested?: boolean | null,
        quality_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        isExternal?: boolean | null,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        sku?: string | null,
        qualityForm?:  {
          __typename: "ProductInOrderQualityPGForm",
          initiativeDescription?: string | null,
          targetUser?: string | null,
          retailBrandName?: string | null,
          itemCategory?: string | null,
          itemPicture?: string | null,
          originCountry?: string | null,
          quantityPerCountryOfDist?: string | null,
          initiativeDates?: string | null,
          isPartOfAnMSOCustOrSpecPack?: string | null,
          incluesClientLogo?: string | null,
          isAReorderWithinTwelveMonths?: string | null,
          isReorder?: string | null,
          PGPLContactName?: string | null,
          ulTracking?: string | null,
          PLContactName?: string | null,
          contactEmailAddress?: string | null,
          PGPurchaseOrderNumber?: string | null,
          EBBSorSupplierProvidedProjectNumber?: string | null,
          vendorCompanyName?: string | null,
          vendorContactName?: string | null,
          vendorEmailAddress?: string | null,
          vendorJobTitle?: string | null,
          vendorTelephone?: string | null,
          vendorMailingAddress?: string | null,
          vendorCity?: string | null,
          vendorState?: string | null,
          vendorCountry?: string | null,
          vendorPC?: string | null,
          physicalItemDescription?: string | null,
          SampleOrMaterialComponentSubmitted?: string | null,
          toWhom?: string | null,
          descriptionOfItemPackagingAndArtwork?: string | null,
          regulatoryAndLegislativeProductCertification?: string | null,
          dateFinalApprovalRequestedSubmittedToPG?: string | null,
          DateOfDeclarationOfConformity?: string | null,
          dateOfApprovalExpirationOfPremiumItem?: string | null,
          itemClasification?: string | null,
          PGRepresentativeMarketingDesign?: string | null,
          PGProjectLeaderRequestor?: string | null,
          PGRestrictedItemsLocalPGLegal?: string | null,
          PGLocalCategoryGM?: string | null,
          PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
          idProduct?: string | null,
          pathDocument?: string | null,
        } | null,
        fee?: number | null,
        increment?: number | null,
        discount?: number | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        sellMode?: ProductMaskSellMode | null,
        kitPieces?: number | null,
      } >,
      cotizationsList:  Array< {
        __typename: "PremiumOrderCotizationsLog",
        id: number,
        created: number,
        createdBy: string,
        products:  Array< {
          __typename: "ProductInOrder",
          product_id: string,
          provider_id?: string | null,
          index?: number | null,
          print?: number | null,
          printPrice?: number | null,
          product_name: string,
          description?: string | null,
          category?: string | null,
          unspsc?: string | null,
          price?: number | null,
          originalPrice?: number | null,
          sample_requested?: boolean | null,
          sample_request?: boolean | null,
          sample_authorize?: boolean | null,
          sample_authorized?: boolean | null,
          quality_requested?: boolean | null,
          quality_request?: boolean | null,
          uploadedSample?: boolean | null,
          quantity: number,
          isExternal?: boolean | null,
          sku?: string | null,
          fee?: number | null,
          increment?: number | null,
          discount?: number | null,
          sellMode?: ProductMaskSellMode | null,
          kitPieces?: number | null,
        } >,
      } | null >,
      orderCreatorId: string,
      creator:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      },
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      invoiceContact?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      premiumOrderClientId?: string | null,
      client?:  {
        __typename: "Client",
        id: string,
        status?: boolean | null,
        business_name: string,
        comertial_name: string,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        buyerInfo?:  {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null,
        buyersInfo?:  Array< {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null > | null,
        biography?: string | null,
        plan?: string | null,
        fee?: number | null,
        increment?: number | null,
        mercadoFee?: number | null,
        mercadoIncrement?: number | null,
        popFee?: number | null,
        popIncrement?: number | null,
        printedFee?: number | null,
        printedIncrement?: number | null,
        users?: Array< string | null > | null,
        restrictedUsers?: Array< string | null > | null,
        nonRestrictedUsers?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        providers?: Array< string | null > | null,
        popProviders?: Array< string | null > | null,
        printedProviders?: Array< string | null > | null,
        logisticFrequency?: number | null,
        agents?:  Array< {
          __typename: "Agent",
          id?: string | null,
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
        } | null > | null,
        administrators?:  Array< {
          __typename: "Agent",
          id?: string | null,
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
        } | null > | null,
        signDocument?:  Array< {
          __typename: "Sign",
          url?: string | null,
          enabled?: boolean | null,
        } | null > | null,
        legal_representative?: string | null,
        legal_representative_email?: string | null,
        legal_representative_address?: string | null,
        tcdUsers?: Array< string | null > | null,
        billingUsers?:  Array< {
          __typename: "Agent",
          id?: string | null,
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
        } | null > | null,
        createdAt: string,
        updatedAt?: string | null,
      } | null,
      userBrandId?: string | null,
      userBrand?:  {
        __typename: "UsersBrands",
        id: string,
        name: string,
        description?: string | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        status?: string | null,
        clientId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subtotal?: number | null,
      fee?: number | null,
      printedPrice?: number | null,
      total?: number | null,
      discountAmount?: number | null,
      syncWithCrm?: boolean | null,
      crmIssueKey?: string | null,
      sentToAlendum?: boolean | null,
      alendumProjectId?: string | null,
      syncWithFms?: string | null,
      fmsInvoiceId?: string | null,
      syncWithWms?: boolean | null,
      wmsProjectId?: string | null,
      isCoupa?: boolean | null,
      sentToCoupa?: boolean | null,
      isRfq?: boolean | null,
      requireSamples?: boolean | null,
      requestedSamples?: boolean | null,
      approvedSamples?: boolean | null,
      authorizedQA?: boolean | null,
      active?: string | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      processes?:  Array< {
        __typename: "OrderProcessStructure",
        id?: string | null,
        name?: string | null,
        descripcion?: string | null,
        duration?: string | null,
        position?: number | null,
        responsible?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        madeBy?: string | null,
        madeAt?: number | null,
        cards?:  Array< {
          __typename: "OrderCards",
          id?: string | null,
          name?: string | null,
        } | null > | null,
        subprocesses?:  Array< {
          __typename: "OrderSubprocessStructure",
          id?: string | null,
          name?: string | null,
          position?: number | null,
          descripcion?: string | null,
          action?: number | null,
          process?: string | null,
          madeBy?: string | null,
          madeAt?: number | null,
        } | null > | null,
      } | null > | null,
      updatedAt?: string | null,
      created: number,
      updated?: number | null,
      logistic?:  Array< {
        __typename: "LogisticPremiumOrder",
        premiumOrderId?: string | null,
        tracking_number?: string | null,
        destiny_latitude?: string | null,
        destiny_longitude?: string | null,
        status?: string | null,
        status_activity?: string | null,
        status_description?: string | null,
        origin_latitude?: string | null,
        origin_longitude?: string | null,
        carrier?: string | null,
        clave_sat?: string | null,
        customer_delivery_start_date?: string | null,
        customer_email?: string | null,
        customer_external_number?: string | null,
        customer_first_name?: string | null,
        customer_last_name?: string | null,
        customer_mobile_number?: string | null,
        customer_postcode?: string | null,
        customer_settlement?: string | null,
        customer_street?: string | null,
        descripcion_sat?: string | null,
        peligroso?: string | null,
        primary_client?: string | null,
        purchase_order_number?: string | null,
        shipping_method?: string | null,
        shipping_option?: string | null,
        created: number,
      } | null > | null,
      createdAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PremiumOrdersByUserBrandQueryVariables = {
  userBrandId: string,
  orderId?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPremiumOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PremiumOrdersByUserBrandQuery = {
  PremiumOrdersByUserBrand?:  {
    __typename: "ModelPremiumOrderConnection",
    items:  Array< {
      __typename: "PremiumOrder",
      id: string,
      requirement?: string | null,
      bank_reference?: string | null,
      hasVat?: boolean | null,
      billingData?:  {
        __typename: "BillingData",
        name?: string | null,
        rfc?: string | null,
        regimen?: string | null,
        cfdi_use?: string | null,
        cp?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
      } | null,
      orderId: number,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      logs?:  Array< {
        __typename: "Log",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        role?: string | null,
      } | null > | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_fee?: number | null,
      delivery_discount?: number | null,
      delivery_time?: number | null,
      delivery_date?: string | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      taxSituationFile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      clipUrl?: string | null,
      clipStatus?: string | null,
      listProviders?:  Array< {
        __typename: "ListProvidersOrder",
        provider_id: string,
        order_id: string,
        payment_date?: number | null,
        gr_code?: string | null,
        order_confirmation?: boolean | null,
        invoice?: boolean | null,
        invoiceRequested?: boolean | null,
        uploadedGr?: boolean | null,
        uploadedBill?: boolean | null,
        delivered?: boolean | null,
        deliveredFormat?: boolean | null,
      } | null > | null,
      providers?:  {
        __typename: "ModelOrderProvidersConnection",
        items:  Array< {
          __typename: "OrderProviders",
          id: string,
          provider_id: string,
          clientId?: string | null,
          orderId?: number | null,
          orderProvidersPremiumOrderId: string,
          payment_date?: number | null,
          gr_code?: string | null,
          invoice?: boolean | null,
          invoiceRequested?: boolean | null,
          uploadedGr?: boolean | null,
          uploadedBill?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      listsProducts:  Array< {
        __typename: "ProductInOrder",
        product_id: string,
        provider_id?: string | null,
        index?: number | null,
        print?: number | null,
        printPrice?: number | null,
        product_name: string,
        description?: string | null,
        category?: string | null,
        unspsc?: string | null,
        price?: number | null,
        originalPrice?: number | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        sample_authorize?: boolean | null,
        sample_authorized?: boolean | null,
        quality_requested?: boolean | null,
        quality_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        isExternal?: boolean | null,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        sku?: string | null,
        qualityForm?:  {
          __typename: "ProductInOrderQualityPGForm",
          initiativeDescription?: string | null,
          targetUser?: string | null,
          retailBrandName?: string | null,
          itemCategory?: string | null,
          itemPicture?: string | null,
          originCountry?: string | null,
          quantityPerCountryOfDist?: string | null,
          initiativeDates?: string | null,
          isPartOfAnMSOCustOrSpecPack?: string | null,
          incluesClientLogo?: string | null,
          isAReorderWithinTwelveMonths?: string | null,
          isReorder?: string | null,
          PGPLContactName?: string | null,
          ulTracking?: string | null,
          PLContactName?: string | null,
          contactEmailAddress?: string | null,
          PGPurchaseOrderNumber?: string | null,
          EBBSorSupplierProvidedProjectNumber?: string | null,
          vendorCompanyName?: string | null,
          vendorContactName?: string | null,
          vendorEmailAddress?: string | null,
          vendorJobTitle?: string | null,
          vendorTelephone?: string | null,
          vendorMailingAddress?: string | null,
          vendorCity?: string | null,
          vendorState?: string | null,
          vendorCountry?: string | null,
          vendorPC?: string | null,
          physicalItemDescription?: string | null,
          SampleOrMaterialComponentSubmitted?: string | null,
          toWhom?: string | null,
          descriptionOfItemPackagingAndArtwork?: string | null,
          regulatoryAndLegislativeProductCertification?: string | null,
          dateFinalApprovalRequestedSubmittedToPG?: string | null,
          DateOfDeclarationOfConformity?: string | null,
          dateOfApprovalExpirationOfPremiumItem?: string | null,
          itemClasification?: string | null,
          PGRepresentativeMarketingDesign?: string | null,
          PGProjectLeaderRequestor?: string | null,
          PGRestrictedItemsLocalPGLegal?: string | null,
          PGLocalCategoryGM?: string | null,
          PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
          idProduct?: string | null,
          pathDocument?: string | null,
        } | null,
        fee?: number | null,
        increment?: number | null,
        discount?: number | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        sellMode?: ProductMaskSellMode | null,
        kitPieces?: number | null,
      } >,
      cotizationsList:  Array< {
        __typename: "PremiumOrderCotizationsLog",
        id: number,
        created: number,
        createdBy: string,
        products:  Array< {
          __typename: "ProductInOrder",
          product_id: string,
          provider_id?: string | null,
          index?: number | null,
          print?: number | null,
          printPrice?: number | null,
          product_name: string,
          description?: string | null,
          category?: string | null,
          unspsc?: string | null,
          price?: number | null,
          originalPrice?: number | null,
          sample_requested?: boolean | null,
          sample_request?: boolean | null,
          sample_authorize?: boolean | null,
          sample_authorized?: boolean | null,
          quality_requested?: boolean | null,
          quality_request?: boolean | null,
          uploadedSample?: boolean | null,
          quantity: number,
          isExternal?: boolean | null,
          sku?: string | null,
          fee?: number | null,
          increment?: number | null,
          discount?: number | null,
          sellMode?: ProductMaskSellMode | null,
          kitPieces?: number | null,
        } >,
      } | null >,
      orderCreatorId: string,
      creator:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      },
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      invoiceContact?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      premiumOrderClientId?: string | null,
      client?:  {
        __typename: "Client",
        id: string,
        status?: boolean | null,
        business_name: string,
        comertial_name: string,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        buyerInfo?:  {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null,
        buyersInfo?:  Array< {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null > | null,
        biography?: string | null,
        plan?: string | null,
        fee?: number | null,
        increment?: number | null,
        mercadoFee?: number | null,
        mercadoIncrement?: number | null,
        popFee?: number | null,
        popIncrement?: number | null,
        printedFee?: number | null,
        printedIncrement?: number | null,
        users?: Array< string | null > | null,
        restrictedUsers?: Array< string | null > | null,
        nonRestrictedUsers?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        providers?: Array< string | null > | null,
        popProviders?: Array< string | null > | null,
        printedProviders?: Array< string | null > | null,
        logisticFrequency?: number | null,
        agents?:  Array< {
          __typename: "Agent",
          id?: string | null,
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
        } | null > | null,
        administrators?:  Array< {
          __typename: "Agent",
          id?: string | null,
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
        } | null > | null,
        signDocument?:  Array< {
          __typename: "Sign",
          url?: string | null,
          enabled?: boolean | null,
        } | null > | null,
        legal_representative?: string | null,
        legal_representative_email?: string | null,
        legal_representative_address?: string | null,
        tcdUsers?: Array< string | null > | null,
        billingUsers?:  Array< {
          __typename: "Agent",
          id?: string | null,
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
        } | null > | null,
        createdAt: string,
        updatedAt?: string | null,
      } | null,
      userBrandId?: string | null,
      userBrand?:  {
        __typename: "UsersBrands",
        id: string,
        name: string,
        description?: string | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        status?: string | null,
        clientId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subtotal?: number | null,
      fee?: number | null,
      printedPrice?: number | null,
      total?: number | null,
      discountAmount?: number | null,
      syncWithCrm?: boolean | null,
      crmIssueKey?: string | null,
      sentToAlendum?: boolean | null,
      alendumProjectId?: string | null,
      syncWithFms?: string | null,
      fmsInvoiceId?: string | null,
      syncWithWms?: boolean | null,
      wmsProjectId?: string | null,
      isCoupa?: boolean | null,
      sentToCoupa?: boolean | null,
      isRfq?: boolean | null,
      requireSamples?: boolean | null,
      requestedSamples?: boolean | null,
      approvedSamples?: boolean | null,
      authorizedQA?: boolean | null,
      active?: string | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      processes?:  Array< {
        __typename: "OrderProcessStructure",
        id?: string | null,
        name?: string | null,
        descripcion?: string | null,
        duration?: string | null,
        position?: number | null,
        responsible?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        madeBy?: string | null,
        madeAt?: number | null,
        cards?:  Array< {
          __typename: "OrderCards",
          id?: string | null,
          name?: string | null,
        } | null > | null,
        subprocesses?:  Array< {
          __typename: "OrderSubprocessStructure",
          id?: string | null,
          name?: string | null,
          position?: number | null,
          descripcion?: string | null,
          action?: number | null,
          process?: string | null,
          madeBy?: string | null,
          madeAt?: number | null,
        } | null > | null,
      } | null > | null,
      updatedAt?: string | null,
      created: number,
      updated?: number | null,
      logistic?:  Array< {
        __typename: "LogisticPremiumOrder",
        premiumOrderId?: string | null,
        tracking_number?: string | null,
        destiny_latitude?: string | null,
        destiny_longitude?: string | null,
        status?: string | null,
        status_activity?: string | null,
        status_description?: string | null,
        origin_latitude?: string | null,
        origin_longitude?: string | null,
        carrier?: string | null,
        clave_sat?: string | null,
        customer_delivery_start_date?: string | null,
        customer_email?: string | null,
        customer_external_number?: string | null,
        customer_first_name?: string | null,
        customer_last_name?: string | null,
        customer_mobile_number?: string | null,
        customer_postcode?: string | null,
        customer_settlement?: string | null,
        customer_street?: string | null,
        descripcion_sat?: string | null,
        peligroso?: string | null,
        primary_client?: string | null,
        purchase_order_number?: string | null,
        shipping_method?: string | null,
        shipping_option?: string | null,
        created: number,
      } | null > | null,
      createdAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PremiumOrdersByOrderIdQueryVariables = {
  active: string,
  orderId?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPremiumOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PremiumOrdersByOrderIdQuery = {
  PremiumOrdersByOrderId?:  {
    __typename: "ModelPremiumOrderConnection",
    items:  Array< {
      __typename: "PremiumOrder",
      id: string,
      requirement?: string | null,
      bank_reference?: string | null,
      hasVat?: boolean | null,
      billingData?:  {
        __typename: "BillingData",
        name?: string | null,
        rfc?: string | null,
        regimen?: string | null,
        cfdi_use?: string | null,
        cp?: string | null,
        email?: string | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
      } | null,
      orderId: number,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      logs?:  Array< {
        __typename: "Log",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        role?: string | null,
      } | null > | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_fee?: number | null,
      delivery_discount?: number | null,
      delivery_time?: number | null,
      delivery_date?: string | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      taxSituationFile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      clipUrl?: string | null,
      clipStatus?: string | null,
      listProviders?:  Array< {
        __typename: "ListProvidersOrder",
        provider_id: string,
        order_id: string,
        payment_date?: number | null,
        gr_code?: string | null,
        order_confirmation?: boolean | null,
        invoice?: boolean | null,
        invoiceRequested?: boolean | null,
        uploadedGr?: boolean | null,
        uploadedBill?: boolean | null,
        delivered?: boolean | null,
        deliveredFormat?: boolean | null,
      } | null > | null,
      providers?:  {
        __typename: "ModelOrderProvidersConnection",
        items:  Array< {
          __typename: "OrderProviders",
          id: string,
          provider_id: string,
          clientId?: string | null,
          orderId?: number | null,
          orderProvidersPremiumOrderId: string,
          payment_date?: number | null,
          gr_code?: string | null,
          invoice?: boolean | null,
          invoiceRequested?: boolean | null,
          uploadedGr?: boolean | null,
          uploadedBill?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      listsProducts:  Array< {
        __typename: "ProductInOrder",
        product_id: string,
        provider_id?: string | null,
        index?: number | null,
        print?: number | null,
        printPrice?: number | null,
        product_name: string,
        description?: string | null,
        category?: string | null,
        unspsc?: string | null,
        price?: number | null,
        originalPrice?: number | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        sample_authorize?: boolean | null,
        sample_authorized?: boolean | null,
        quality_requested?: boolean | null,
        quality_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        isExternal?: boolean | null,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        sku?: string | null,
        qualityForm?:  {
          __typename: "ProductInOrderQualityPGForm",
          initiativeDescription?: string | null,
          targetUser?: string | null,
          retailBrandName?: string | null,
          itemCategory?: string | null,
          itemPicture?: string | null,
          originCountry?: string | null,
          quantityPerCountryOfDist?: string | null,
          initiativeDates?: string | null,
          isPartOfAnMSOCustOrSpecPack?: string | null,
          incluesClientLogo?: string | null,
          isAReorderWithinTwelveMonths?: string | null,
          isReorder?: string | null,
          PGPLContactName?: string | null,
          ulTracking?: string | null,
          PLContactName?: string | null,
          contactEmailAddress?: string | null,
          PGPurchaseOrderNumber?: string | null,
          EBBSorSupplierProvidedProjectNumber?: string | null,
          vendorCompanyName?: string | null,
          vendorContactName?: string | null,
          vendorEmailAddress?: string | null,
          vendorJobTitle?: string | null,
          vendorTelephone?: string | null,
          vendorMailingAddress?: string | null,
          vendorCity?: string | null,
          vendorState?: string | null,
          vendorCountry?: string | null,
          vendorPC?: string | null,
          physicalItemDescription?: string | null,
          SampleOrMaterialComponentSubmitted?: string | null,
          toWhom?: string | null,
          descriptionOfItemPackagingAndArtwork?: string | null,
          regulatoryAndLegislativeProductCertification?: string | null,
          dateFinalApprovalRequestedSubmittedToPG?: string | null,
          DateOfDeclarationOfConformity?: string | null,
          dateOfApprovalExpirationOfPremiumItem?: string | null,
          itemClasification?: string | null,
          PGRepresentativeMarketingDesign?: string | null,
          PGProjectLeaderRequestor?: string | null,
          PGRestrictedItemsLocalPGLegal?: string | null,
          PGLocalCategoryGM?: string | null,
          PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
          idProduct?: string | null,
          pathDocument?: string | null,
        } | null,
        fee?: number | null,
        increment?: number | null,
        discount?: number | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        sellMode?: ProductMaskSellMode | null,
        kitPieces?: number | null,
      } >,
      cotizationsList:  Array< {
        __typename: "PremiumOrderCotizationsLog",
        id: number,
        created: number,
        createdBy: string,
        products:  Array< {
          __typename: "ProductInOrder",
          product_id: string,
          provider_id?: string | null,
          index?: number | null,
          print?: number | null,
          printPrice?: number | null,
          product_name: string,
          description?: string | null,
          category?: string | null,
          unspsc?: string | null,
          price?: number | null,
          originalPrice?: number | null,
          sample_requested?: boolean | null,
          sample_request?: boolean | null,
          sample_authorize?: boolean | null,
          sample_authorized?: boolean | null,
          quality_requested?: boolean | null,
          quality_request?: boolean | null,
          uploadedSample?: boolean | null,
          quantity: number,
          isExternal?: boolean | null,
          sku?: string | null,
          fee?: number | null,
          increment?: number | null,
          discount?: number | null,
          sellMode?: ProductMaskSellMode | null,
          kitPieces?: number | null,
        } >,
      } | null >,
      orderCreatorId: string,
      creator:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      },
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      invoiceContact?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      premiumOrderClientId?: string | null,
      client?:  {
        __typename: "Client",
        id: string,
        status?: boolean | null,
        business_name: string,
        comertial_name: string,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        grayLogo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        contact?:  {
          __typename: "Contact",
          first_name?: string | null,
          last_name?: string | null,
          email?: string | null,
          mobile_phone?: string | null,
          local_phone?: string | null,
        } | null,
        address?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        buyerInfo?:  {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null,
        buyersInfo?:  Array< {
          __typename: "OrderBuyer",
          name: string,
          email: string,
          authorized?: boolean | null,
        } | null > | null,
        biography?: string | null,
        plan?: string | null,
        fee?: number | null,
        increment?: number | null,
        mercadoFee?: number | null,
        mercadoIncrement?: number | null,
        popFee?: number | null,
        popIncrement?: number | null,
        printedFee?: number | null,
        printedIncrement?: number | null,
        users?: Array< string | null > | null,
        restrictedUsers?: Array< string | null > | null,
        nonRestrictedUsers?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        providers?: Array< string | null > | null,
        popProviders?: Array< string | null > | null,
        printedProviders?: Array< string | null > | null,
        logisticFrequency?: number | null,
        agents?:  Array< {
          __typename: "Agent",
          id?: string | null,
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
        } | null > | null,
        administrators?:  Array< {
          __typename: "Agent",
          id?: string | null,
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
        } | null > | null,
        signDocument?:  Array< {
          __typename: "Sign",
          url?: string | null,
          enabled?: boolean | null,
        } | null > | null,
        legal_representative?: string | null,
        legal_representative_email?: string | null,
        legal_representative_address?: string | null,
        tcdUsers?: Array< string | null > | null,
        billingUsers?:  Array< {
          __typename: "Agent",
          id?: string | null,
          name?: string | null,
          email?: string | null,
          phoneNumber?: string | null,
        } | null > | null,
        createdAt: string,
        updatedAt?: string | null,
      } | null,
      userBrandId?: string | null,
      userBrand?:  {
        __typename: "UsersBrands",
        id: string,
        name: string,
        description?: string | null,
        logo?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        status?: string | null,
        clientId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subtotal?: number | null,
      fee?: number | null,
      printedPrice?: number | null,
      total?: number | null,
      discountAmount?: number | null,
      syncWithCrm?: boolean | null,
      crmIssueKey?: string | null,
      sentToAlendum?: boolean | null,
      alendumProjectId?: string | null,
      syncWithFms?: string | null,
      fmsInvoiceId?: string | null,
      syncWithWms?: boolean | null,
      wmsProjectId?: string | null,
      isCoupa?: boolean | null,
      sentToCoupa?: boolean | null,
      isRfq?: boolean | null,
      requireSamples?: boolean | null,
      requestedSamples?: boolean | null,
      approvedSamples?: boolean | null,
      authorizedQA?: boolean | null,
      active?: string | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      processes?:  Array< {
        __typename: "OrderProcessStructure",
        id?: string | null,
        name?: string | null,
        descripcion?: string | null,
        duration?: string | null,
        position?: number | null,
        responsible?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        madeBy?: string | null,
        madeAt?: number | null,
        cards?:  Array< {
          __typename: "OrderCards",
          id?: string | null,
          name?: string | null,
        } | null > | null,
        subprocesses?:  Array< {
          __typename: "OrderSubprocessStructure",
          id?: string | null,
          name?: string | null,
          position?: number | null,
          descripcion?: string | null,
          action?: number | null,
          process?: string | null,
          madeBy?: string | null,
          madeAt?: number | null,
        } | null > | null,
      } | null > | null,
      updatedAt?: string | null,
      created: number,
      updated?: number | null,
      logistic?:  Array< {
        __typename: "LogisticPremiumOrder",
        premiumOrderId?: string | null,
        tracking_number?: string | null,
        destiny_latitude?: string | null,
        destiny_longitude?: string | null,
        status?: string | null,
        status_activity?: string | null,
        status_description?: string | null,
        origin_latitude?: string | null,
        origin_longitude?: string | null,
        carrier?: string | null,
        clave_sat?: string | null,
        customer_delivery_start_date?: string | null,
        customer_email?: string | null,
        customer_external_number?: string | null,
        customer_first_name?: string | null,
        customer_last_name?: string | null,
        customer_mobile_number?: string | null,
        customer_postcode?: string | null,
        customer_settlement?: string | null,
        customer_street?: string | null,
        descripcion_sat?: string | null,
        peligroso?: string | null,
        primary_client?: string | null,
        purchase_order_number?: string | null,
        shipping_method?: string | null,
        shipping_option?: string | null,
        created: number,
      } | null > | null,
      createdAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PrintedSubcategoriesByCategoryQueryVariables = {
  printedCategoryId: string,
  name?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrintedSubcategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PrintedSubcategoriesByCategoryQuery = {
  PrintedSubcategoriesByCategory?:  {
    __typename: "ModelPrintedSubcategoryConnection",
    items:  Array< {
      __typename: "PrintedSubcategory",
      id: string,
      name: string,
      printedCategoryId: string,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      parent:  {
        __typename: "PrintedCategory",
        id: string,
        name: string,
        image:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        route: string,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        printedSubcategories?:  {
          __typename: "ModelPrintedSubcategoryConnection",
          nextToken?: string | null,
        } | null,
        printedProducts?:  {
          __typename: "ModelPrintedProductsConnection",
          nextToken?: string | null,
        } | null,
        created: number,
        visibleFor?: Array< string | null > | null,
        region?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      },
      created: number,
      printedProducts?:  {
        __typename: "ModelPrintedProductsConnection",
        items:  Array< {
          __typename: "PrintedProducts",
          id: string,
          status: string,
          position: string,
          name: string,
          width: number,
          height: number,
          price: number,
          long_description?: string | null,
          short_description?: string | null,
          creator?: string | null,
          providerId: string,
          finalDimensions?: number | null,
          pagesNumber?: number | null,
          finishes?: string | null,
          inksFourByCero?: string | null,
          inksFourByFour?: string | null,
          paperKind?: string | null,
          grammage?: string | null,
          hasBarniz?: boolean | null,
          hasRebase?: boolean | null,
          orientation?: string | null,
          specialInstructions?: string | null,
          PrintedSubcategoryId: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          regions?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PrintedProductsBySubcategoryPositionQueryVariables = {
  PrintedSubcategoryId: string,
  position?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrintedProductsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PrintedProductsBySubcategoryPositionQuery = {
  PrintedProductsBySubcategoryPosition?:  {
    __typename: "ModelPrintedProductsConnection",
    items:  Array< {
      __typename: "PrintedProducts",
      id: string,
      status: string,
      position: string,
      name: string,
      width: number,
      height: number,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      price: number,
      long_description?: string | null,
      short_description?: string | null,
      creator?: string | null,
      providerId: string,
      finalDimensions?: number | null,
      pagesNumber?: number | null,
      finishes?: string | null,
      inksFourByCero?: string | null,
      inksFourByFour?: string | null,
      paperKind?: string | null,
      grammage?: string | null,
      hasBarniz?: boolean | null,
      hasRebase?: boolean | null,
      orientation?: string | null,
      specialInstructions?: string | null,
      PrintedSubcategoryId: string,
      printedCategoryId: string,
      created: number,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PrintedProductsBySubcategoryCreatedQueryVariables = {
  PrintedSubcategoryId: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrintedProductsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PrintedProductsBySubcategoryCreatedQuery = {
  PrintedProductsBySubcategoryCreated?:  {
    __typename: "ModelPrintedProductsConnection",
    items:  Array< {
      __typename: "PrintedProducts",
      id: string,
      status: string,
      position: string,
      name: string,
      width: number,
      height: number,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      price: number,
      long_description?: string | null,
      short_description?: string | null,
      creator?: string | null,
      providerId: string,
      finalDimensions?: number | null,
      pagesNumber?: number | null,
      finishes?: string | null,
      inksFourByCero?: string | null,
      inksFourByFour?: string | null,
      paperKind?: string | null,
      grammage?: string | null,
      hasBarniz?: boolean | null,
      hasRebase?: boolean | null,
      orientation?: string | null,
      specialInstructions?: string | null,
      PrintedSubcategoryId: string,
      printedCategoryId: string,
      created: number,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PrintedProductsByCategoryPositionQueryVariables = {
  printedCategoryId: string,
  position?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrintedProductsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PrintedProductsByCategoryPositionQuery = {
  PrintedProductsByCategoryPosition?:  {
    __typename: "ModelPrintedProductsConnection",
    items:  Array< {
      __typename: "PrintedProducts",
      id: string,
      status: string,
      position: string,
      name: string,
      width: number,
      height: number,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      price: number,
      long_description?: string | null,
      short_description?: string | null,
      creator?: string | null,
      providerId: string,
      finalDimensions?: number | null,
      pagesNumber?: number | null,
      finishes?: string | null,
      inksFourByCero?: string | null,
      inksFourByFour?: string | null,
      paperKind?: string | null,
      grammage?: string | null,
      hasBarniz?: boolean | null,
      hasRebase?: boolean | null,
      orientation?: string | null,
      specialInstructions?: string | null,
      PrintedSubcategoryId: string,
      printedCategoryId: string,
      created: number,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PrintedProductsByCategoryCreatedQueryVariables = {
  printedCategoryId: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrintedProductsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PrintedProductsByCategoryCreatedQuery = {
  PrintedProductsByCategoryCreated?:  {
    __typename: "ModelPrintedProductsConnection",
    items:  Array< {
      __typename: "PrintedProducts",
      id: string,
      status: string,
      position: string,
      name: string,
      width: number,
      height: number,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      price: number,
      long_description?: string | null,
      short_description?: string | null,
      creator?: string | null,
      providerId: string,
      finalDimensions?: number | null,
      pagesNumber?: number | null,
      finishes?: string | null,
      inksFourByCero?: string | null,
      inksFourByFour?: string | null,
      paperKind?: string | null,
      grammage?: string | null,
      hasBarniz?: boolean | null,
      hasRebase?: boolean | null,
      orientation?: string | null,
      specialInstructions?: string | null,
      PrintedSubcategoryId: string,
      printedCategoryId: string,
      created: number,
      variants?:  Array< {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRfqsPrintedByCreatedQueryVariables = {
  estatus: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrintedRfqFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRfqsPrintedByCreatedQuery = {
  ListRfqsPrintedByCreated?:  {
    __typename: "ModelPrintedRfqConnection",
    items:  Array< {
      __typename: "PrintedRfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      proposals?:  {
        __typename: "ModelPrintedProposalConnection",
        items:  Array< {
          __typename: "PrintedProposal",
          id: string,
          provider_id: string,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          hidden?: boolean | null,
          printedProposalRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      printedOrderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      providers?:  Array< {
        __typename: "RfqPrintedProviders",
        idProvider?: string | null,
      } | null > | null,
      printedProductsRfq:  Array< {
        __typename: "PrintedProductUnitRfq",
        name: string,
        description: string,
        pieces: number,
        createdId: number,
      } | null >,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPrintedProductosRfqPriceQueryVariables = {
  category_id: string,
  price?: ModelFloatKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrintedProductoRfqFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrintedProductosRfqPriceQuery = {
  ListPrintedProductosRfqPrice?:  {
    __typename: "ModelPrintedProductoRfqConnection",
    items:  Array< {
      __typename: "PrintedProductoRfq",
      id: string,
      name: string,
      description: string,
      category_id: string,
      provider_id: string,
      price?: number | null,
      category?: string | null,
      images?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      estatus?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PrintedOrdersByBuyerQueryVariables = {
  orderCreatorId: string,
  orderId?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrintedOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PrintedOrdersByBuyerQuery = {
  PrintedOrdersByBuyer?:  {
    __typename: "ModelPrintedOrderConnection",
    items:  Array< {
      __typename: "PrintedOrder",
      id: string,
      orderId: number,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      listProviders?:  Array< {
        __typename: "ListProvidersOrder",
        provider_id: string,
        order_id: string,
        payment_date?: number | null,
        gr_code?: string | null,
        order_confirmation?: boolean | null,
        invoice?: boolean | null,
        invoiceRequested?: boolean | null,
        uploadedGr?: boolean | null,
        uploadedBill?: boolean | null,
        delivered?: boolean | null,
        deliveredFormat?: boolean | null,
      } | null > | null,
      listProvidersKey?: Array< string | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      listPrintedProducts:  Array< {
        __typename: "PrintedProductInOrder",
        product_id: string,
        provider_id?: string | null,
        visible?: boolean | null,
        product_name: string,
        price?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
      } >,
      cotizationsList:  Array< {
        __typename: "PrintedOrderCotizationsLog",
        id: number,
        created: number,
        createdBy: string,
        products:  Array< {
          __typename: "PrintedProductInOrder",
          product_id: string,
          provider_id?: string | null,
          visible?: boolean | null,
          product_name: string,
          price?: number | null,
          sample_requested?: boolean | null,
          sample_request?: boolean | null,
          uploadedSample?: boolean | null,
          quantity: number,
        } >,
      } | null >,
      orderCreatorId: string,
      creator:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      },
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      printedOrderClientId?: string | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa?: boolean | null,
      sentToCoupa?: boolean | null,
      isRfq?: boolean | null,
      status?: string | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      updatedAt?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PrintedOrdersByClientQueryVariables = {
  printedOrderClientId: string,
  orderId?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrintedOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PrintedOrdersByClientQuery = {
  PrintedOrdersByClient?:  {
    __typename: "ModelPrintedOrderConnection",
    items:  Array< {
      __typename: "PrintedOrder",
      id: string,
      orderId: number,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      listProviders?:  Array< {
        __typename: "ListProvidersOrder",
        provider_id: string,
        order_id: string,
        payment_date?: number | null,
        gr_code?: string | null,
        order_confirmation?: boolean | null,
        invoice?: boolean | null,
        invoiceRequested?: boolean | null,
        uploadedGr?: boolean | null,
        uploadedBill?: boolean | null,
        delivered?: boolean | null,
        deliveredFormat?: boolean | null,
      } | null > | null,
      listProvidersKey?: Array< string | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      listPrintedProducts:  Array< {
        __typename: "PrintedProductInOrder",
        product_id: string,
        provider_id?: string | null,
        visible?: boolean | null,
        product_name: string,
        price?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
      } >,
      cotizationsList:  Array< {
        __typename: "PrintedOrderCotizationsLog",
        id: number,
        created: number,
        createdBy: string,
        products:  Array< {
          __typename: "PrintedProductInOrder",
          product_id: string,
          provider_id?: string | null,
          visible?: boolean | null,
          product_name: string,
          price?: number | null,
          sample_requested?: boolean | null,
          sample_request?: boolean | null,
          uploadedSample?: boolean | null,
          quantity: number,
        } >,
      } | null >,
      orderCreatorId: string,
      creator:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      },
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      printedOrderClientId?: string | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa?: boolean | null,
      sentToCoupa?: boolean | null,
      isRfq?: boolean | null,
      status?: string | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      updatedAt?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PrintedOrdersByOrderIdQueryVariables = {
  status: string,
  orderId?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrintedOrderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PrintedOrdersByOrderIdQuery = {
  PrintedOrdersByOrderId?:  {
    __typename: "ModelPrintedOrderConnection",
    items:  Array< {
      __typename: "PrintedOrder",
      id: string,
      orderId: number,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      listProviders?:  Array< {
        __typename: "ListProvidersOrder",
        provider_id: string,
        order_id: string,
        payment_date?: number | null,
        gr_code?: string | null,
        order_confirmation?: boolean | null,
        invoice?: boolean | null,
        invoiceRequested?: boolean | null,
        uploadedGr?: boolean | null,
        uploadedBill?: boolean | null,
        delivered?: boolean | null,
        deliveredFormat?: boolean | null,
      } | null > | null,
      listProvidersKey?: Array< string | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      listPrintedProducts:  Array< {
        __typename: "PrintedProductInOrder",
        product_id: string,
        provider_id?: string | null,
        visible?: boolean | null,
        product_name: string,
        price?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
      } >,
      cotizationsList:  Array< {
        __typename: "PrintedOrderCotizationsLog",
        id: number,
        created: number,
        createdBy: string,
        products:  Array< {
          __typename: "PrintedProductInOrder",
          product_id: string,
          provider_id?: string | null,
          visible?: boolean | null,
          product_name: string,
          price?: number | null,
          sample_requested?: boolean | null,
          sample_request?: boolean | null,
          uploadedSample?: boolean | null,
          quantity: number,
        } >,
      } | null >,
      orderCreatorId: string,
      creator:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      },
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      printedOrderClientId?: string | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa?: boolean | null,
      sentToCoupa?: boolean | null,
      isRfq?: boolean | null,
      status?: string | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      updatedAt?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PrintedOrdersByProviderQueryVariables = {
  provider_id: string,
  orderId?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrintedOrderProvidersFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PrintedOrdersByProviderQuery = {
  PrintedOrdersByProvider?:  {
    __typename: "ModelPrintedOrderProvidersConnection",
    items:  Array< {
      __typename: "PrintedOrderProviders",
      id: string,
      provider_id: string,
      orderId?: number | null,
      printedOrderProvidersPrintedOrderId: string,
      payment_date?: number | null,
      gr_code?: string | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type BuyerContactsClientByCompanyIdQueryVariables = {
  companyId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBuyerContactClientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type BuyerContactsClientByCompanyIdQuery = {
  BuyerContactsClientByCompanyId?:  {
    __typename: "ModelBuyerContactClientConnection",
    items:  Array< {
      __typename: "BuyerContactClient",
      id: string,
      companyId: string,
      status?: boolean | null,
      defaultContact?: boolean | null,
      name?: string | null,
      email?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AutomobilesEmailsByCompanyIdQueryVariables = {
  companyId: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAutomobilesEmailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AutomobilesEmailsByCompanyIdQuery = {
  AutomobilesEmailsByCompanyId?:  {
    __typename: "ModelAutomobilesEmailsConnection",
    items:  Array< {
      __typename: "AutomobilesEmails",
      id: string,
      companyId: string,
      status: boolean,
      name: string,
      email: string,
      created: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type QAEmailsByCompanyIdQueryVariables = {
  companyId: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelQAEmailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type QAEmailsByCompanyIdQuery = {
  QAEmailsByCompanyId?:  {
    __typename: "ModelQAEmailsConnection",
    items:  Array< {
      __typename: "QAEmails",
      id: string,
      companyId: string,
      status: boolean,
      name: string,
      email: string,
      created: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OrderPopAdminEmailsByCompanyIdQueryVariables = {
  companyId: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderPopAdminEmailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OrderPopAdminEmailsByCompanyIdQuery = {
  OrderPopAdminEmailsByCompanyId?:  {
    __typename: "ModelOrderPopAdminEmailsConnection",
    items:  Array< {
      __typename: "OrderPopAdminEmails",
      id: string,
      companyId: string,
      status: boolean,
      name: string,
      email: string,
      created: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OrderPopCheckoutEmailsByCompanyIdQueryVariables = {
  companyId: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOrderPopCheckoutEmailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OrderPopCheckoutEmailsByCompanyIdQuery = {
  OrderPopCheckoutEmailsByCompanyId?:  {
    __typename: "ModelOrderPopCheckoutEmailsConnection",
    items:  Array< {
      __typename: "OrderPopCheckoutEmails",
      id: string,
      companyId: string,
      status: boolean,
      name: string,
      email: string,
      created: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GREmailsByCompanyIdQueryVariables = {
  companyId: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelGREmailsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GREmailsByCompanyIdQuery = {
  GREmailsByCompanyId?:  {
    __typename: "ModelGREmailsConnection",
    items:  Array< {
      __typename: "GREmails",
      id: string,
      companyId: string,
      status: boolean,
      name: string,
      email: string,
      created: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DefaultAddressByCompanyIdQueryVariables = {
  companyId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDefaultAddressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DefaultAddressByCompanyIdQuery = {
  DefaultAddressByCompanyId?:  {
    __typename: "ModelDefaultAddressConnection",
    items:  Array< {
      __typename: "DefaultAddress",
      id: string,
      companyId: string,
      userId?: string | null,
      status: boolean,
      address:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      },
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DefaultAddressByUserIdQueryVariables = {
  userId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDefaultAddressFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DefaultAddressByUserIdQuery = {
  DefaultAddressByUserId?:  {
    __typename: "ModelDefaultAddressConnection",
    items:  Array< {
      __typename: "DefaultAddress",
      id: string,
      companyId: string,
      userId?: string | null,
      status: boolean,
      address:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      },
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DefaultDeliveryContactByCompanyIdQueryVariables = {
  companyId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDefaultDeliveryContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DefaultDeliveryContactByCompanyIdQuery = {
  DefaultDeliveryContactByCompanyId?:  {
    __typename: "ModelDefaultDeliveryContactConnection",
    items:  Array< {
      __typename: "DefaultDeliveryContact",
      id: string,
      companyId?: string | null,
      userId?: string | null,
      status?: boolean | null,
      name?: string | null,
      phoneNumber?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DefaultDeliveryContactByUserIdQueryVariables = {
  userId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDefaultDeliveryContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DefaultDeliveryContactByUserIdQuery = {
  DefaultDeliveryContactByUserId?:  {
    __typename: "ModelDefaultDeliveryContactConnection",
    items:  Array< {
      __typename: "DefaultDeliveryContact",
      id: string,
      companyId?: string | null,
      userId?: string | null,
      status?: boolean | null,
      name?: string | null,
      phoneNumber?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PopCategoriesByMaterialQueryVariables = {
  materialId: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPopCategoriesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PopCategoriesByMaterialQuery = {
  PopCategoriesByMaterial?:  {
    __typename: "ModelPopCategoriesConnection",
    items:  Array< {
      __typename: "PopCategories",
      id: string,
      materialId: string,
      name: string,
      visibleFor?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      created: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRfpsByCreatedQueryVariables = {
  status: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRfpFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRfpsByCreatedQuery = {
  ListRfpsByCreated?:  {
    __typename: "ModelRfpConnection",
    items:  Array< {
      __typename: "Rfp",
      id: string,
      clientId?: string | null,
      status?: string | null,
      name?: string | null,
      nombre?: string | null,
      requerimiento?: string | null,
      estatus?: string | null,
      descripcion?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      url?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      proposals?:  {
        __typename: "ModelRfpProposalsConnection",
        items:  Array< {
          __typename: "RfpProposals",
          id: string,
          provider_id: string,
          price: number,
          name?: string | null,
          description?: string | null,
          validity_days?: number | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          rfpProposalsRfpId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      creator?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfpProviders",
        idProvider?: string | null,
      } | null > | null,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRfpsByCreatedAtQueryVariables = {
  estatus: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRfpFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRfpsByCreatedAtQuery = {
  ListRfpsByCreatedAt?:  {
    __typename: "ModelRfpConnection",
    items:  Array< {
      __typename: "Rfp",
      id: string,
      clientId?: string | null,
      status?: string | null,
      name?: string | null,
      nombre?: string | null,
      requerimiento?: string | null,
      estatus?: string | null,
      descripcion?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      url?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      proposals?:  {
        __typename: "ModelRfpProposalsConnection",
        items:  Array< {
          __typename: "RfpProposals",
          id: string,
          provider_id: string,
          price: number,
          name?: string | null,
          description?: string | null,
          validity_days?: number | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          rfpProposalsRfpId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      creator?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfpProviders",
        idProvider?: string | null,
      } | null > | null,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLogsByProductQueryVariables = {
  productId: string,
  created?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLogProductFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogsByProductQuery = {
  ListLogsByProduct?:  {
    __typename: "ModelLogProductConnection",
    items:  Array< {
      __typename: "LogProduct",
      id: string,
      status?: string | null,
      creator?: string | null,
      created?: string | null,
      productId?: string | null,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLogsByRfqQueryVariables = {
  rfqId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLogRfqFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogsByRfqQuery = {
  ListLogsByRfq?:  {
    __typename: "ModelLogRfqConnection",
    items:  Array< {
      __typename: "LogRfq",
      id: string,
      status?: string | null,
      creator?: string | null,
      rfqId: string,
      description?: string | null,
      provider_id?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLogsByProviderQueryVariables = {
  provider_id: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLogRfqFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogsByProviderQuery = {
  ListLogsByProvider?:  {
    __typename: "ModelLogRfqConnection",
    items:  Array< {
      __typename: "LogRfq",
      id: string,
      status?: string | null,
      creator?: string | null,
      rfqId: string,
      description?: string | null,
      provider_id?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLogsByProductLabelQueryVariables = {
  productLabelId: string,
  created?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLogProductLabelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogsByProductLabelQuery = {
  listLogsByProductLabel?:  {
    __typename: "ModelLogProductLabelConnection",
    items:  Array< {
      __typename: "LogProductLabel",
      id: string,
      status?: string | null,
      creator?: string | null,
      created?: string | null,
      productLabelId?: string | null,
      description?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListLogsByAutoQueryVariables = {
  id_auto: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLogGanadorAutoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogsByAutoQuery = {
  ListLogsByAuto?:  {
    __typename: "ModelLogGanadorAutoConnection",
    items:  Array< {
      __typename: "LogGanadorAuto",
      id: string,
      id_auto?: string | null,
      id_user?: string | null,
      fecha_rifa?: number | null,
      email?: string | null,
      nombre?: string | null,
      a_paterno?: string | null,
      a_materno?: string | null,
      status_buyer?: boolean | null,
      date_buyer?: number | null,
      winner?: number | null,
      refused?: number | null,
      since?: string | null,
      process_buyer?: boolean | null,
      reactive?: boolean | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type LogsGanadorAutoByUserQueryVariables = {
  id_user: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLogGanadorAutoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type LogsGanadorAutoByUserQuery = {
  LogsGanadorAutoByUser?:  {
    __typename: "ModelLogGanadorAutoConnection",
    items:  Array< {
      __typename: "LogGanadorAuto",
      id: string,
      id_auto?: string | null,
      id_user?: string | null,
      fecha_rifa?: number | null,
      email?: string | null,
      nombre?: string | null,
      a_paterno?: string | null,
      a_materno?: string | null,
      status_buyer?: boolean | null,
      date_buyer?: number | null,
      winner?: number | null,
      refused?: number | null,
      since?: string | null,
      process_buyer?: boolean | null,
      reactive?: boolean | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type NotificationsByTypeQueryVariables = {
  type: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NotificationsByTypeQuery = {
  NotificationsByType?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      type: string,
      remember?: string | null,
      stared?: string | null,
      important?: string | null,
      status?: string | null,
      isChat?: string | null,
      creatorName: string,
      creatorEmail: string,
      creatorRole?: string | null,
      creatorId: string,
      receipentName: string,
      receipentRole?: string | null,
      receipentEmail?: string | null,
      receipentId: string,
      showPopUp?: boolean | null,
      sendEmail?: boolean | null,
      title: string,
      subtitle: string,
      description: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      path?: string | null,
      idParent?: string | null,
      createdAt?: string | null,
      seenAt?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type NotificationsByRememberQueryVariables = {
  remember: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NotificationsByRememberQuery = {
  NotificationsByRemember?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      type: string,
      remember?: string | null,
      stared?: string | null,
      important?: string | null,
      status?: string | null,
      isChat?: string | null,
      creatorName: string,
      creatorEmail: string,
      creatorRole?: string | null,
      creatorId: string,
      receipentName: string,
      receipentRole?: string | null,
      receipentEmail?: string | null,
      receipentId: string,
      showPopUp?: boolean | null,
      sendEmail?: boolean | null,
      title: string,
      subtitle: string,
      description: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      path?: string | null,
      idParent?: string | null,
      createdAt?: string | null,
      seenAt?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type NotificationsByStaredQueryVariables = {
  stared: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NotificationsByStaredQuery = {
  NotificationsByStared?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      type: string,
      remember?: string | null,
      stared?: string | null,
      important?: string | null,
      status?: string | null,
      isChat?: string | null,
      creatorName: string,
      creatorEmail: string,
      creatorRole?: string | null,
      creatorId: string,
      receipentName: string,
      receipentRole?: string | null,
      receipentEmail?: string | null,
      receipentId: string,
      showPopUp?: boolean | null,
      sendEmail?: boolean | null,
      title: string,
      subtitle: string,
      description: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      path?: string | null,
      idParent?: string | null,
      createdAt?: string | null,
      seenAt?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type NotificationsByImportantQueryVariables = {
  important: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NotificationsByImportantQuery = {
  NotificationsByImportant?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      type: string,
      remember?: string | null,
      stared?: string | null,
      important?: string | null,
      status?: string | null,
      isChat?: string | null,
      creatorName: string,
      creatorEmail: string,
      creatorRole?: string | null,
      creatorId: string,
      receipentName: string,
      receipentRole?: string | null,
      receipentEmail?: string | null,
      receipentId: string,
      showPopUp?: boolean | null,
      sendEmail?: boolean | null,
      title: string,
      subtitle: string,
      description: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      path?: string | null,
      idParent?: string | null,
      createdAt?: string | null,
      seenAt?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type NotificationsByStatusQueryVariables = {
  status: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NotificationsByStatusQuery = {
  NotificationsByStatus?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      type: string,
      remember?: string | null,
      stared?: string | null,
      important?: string | null,
      status?: string | null,
      isChat?: string | null,
      creatorName: string,
      creatorEmail: string,
      creatorRole?: string | null,
      creatorId: string,
      receipentName: string,
      receipentRole?: string | null,
      receipentEmail?: string | null,
      receipentId: string,
      showPopUp?: boolean | null,
      sendEmail?: boolean | null,
      title: string,
      subtitle: string,
      description: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      path?: string | null,
      idParent?: string | null,
      createdAt?: string | null,
      seenAt?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type NotificationsByChatQueryVariables = {
  isChat: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NotificationsByChatQuery = {
  NotificationsByChat?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      type: string,
      remember?: string | null,
      stared?: string | null,
      important?: string | null,
      status?: string | null,
      isChat?: string | null,
      creatorName: string,
      creatorEmail: string,
      creatorRole?: string | null,
      creatorId: string,
      receipentName: string,
      receipentRole?: string | null,
      receipentEmail?: string | null,
      receipentId: string,
      showPopUp?: boolean | null,
      sendEmail?: boolean | null,
      title: string,
      subtitle: string,
      description: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      path?: string | null,
      idParent?: string | null,
      createdAt?: string | null,
      seenAt?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type NotificationsByReceipentQueryVariables = {
  receipentEmail: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NotificationsByReceipentQuery = {
  NotificationsByReceipent?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      type: string,
      remember?: string | null,
      stared?: string | null,
      important?: string | null,
      status?: string | null,
      isChat?: string | null,
      creatorName: string,
      creatorEmail: string,
      creatorRole?: string | null,
      creatorId: string,
      receipentName: string,
      receipentRole?: string | null,
      receipentEmail?: string | null,
      receipentId: string,
      showPopUp?: boolean | null,
      sendEmail?: boolean | null,
      title: string,
      subtitle: string,
      description: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      path?: string | null,
      idParent?: string | null,
      createdAt?: string | null,
      seenAt?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type NotificationsByReceipentIdQueryVariables = {
  receipentId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NotificationsByReceipentIdQuery = {
  NotificationsByReceipentId?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      type: string,
      remember?: string | null,
      stared?: string | null,
      important?: string | null,
      status?: string | null,
      isChat?: string | null,
      creatorName: string,
      creatorEmail: string,
      creatorRole?: string | null,
      creatorId: string,
      receipentName: string,
      receipentRole?: string | null,
      receipentEmail?: string | null,
      receipentId: string,
      showPopUp?: boolean | null,
      sendEmail?: boolean | null,
      title: string,
      subtitle: string,
      description: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      path?: string | null,
      idParent?: string | null,
      createdAt?: string | null,
      seenAt?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type NotificationsBySubtitleQueryVariables = {
  subtitle: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NotificationsBySubtitleQuery = {
  NotificationsBySubtitle?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      type: string,
      remember?: string | null,
      stared?: string | null,
      important?: string | null,
      status?: string | null,
      isChat?: string | null,
      creatorName: string,
      creatorEmail: string,
      creatorRole?: string | null,
      creatorId: string,
      receipentName: string,
      receipentRole?: string | null,
      receipentEmail?: string | null,
      receipentId: string,
      showPopUp?: boolean | null,
      sendEmail?: boolean | null,
      title: string,
      subtitle: string,
      description: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      path?: string | null,
      idParent?: string | null,
      createdAt?: string | null,
      seenAt?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type NotificationsByIdParentQueryVariables = {
  idParent: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NotificationsByIdParentQuery = {
  NotificationsByIdParent?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      type: string,
      remember?: string | null,
      stared?: string | null,
      important?: string | null,
      status?: string | null,
      isChat?: string | null,
      creatorName: string,
      creatorEmail: string,
      creatorRole?: string | null,
      creatorId: string,
      receipentName: string,
      receipentRole?: string | null,
      receipentEmail?: string | null,
      receipentId: string,
      showPopUp?: boolean | null,
      sendEmail?: boolean | null,
      title: string,
      subtitle: string,
      description: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      path?: string | null,
      idParent?: string | null,
      createdAt?: string | null,
      seenAt?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MercadoProductsByClientQueryVariables = {
  idClient: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMercadoProductCategoryClientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MercadoProductsByClientQuery = {
  MercadoProductsByClient?:  {
    __typename: "ModelMercadoProductCategoryClientConnection",
    items:  Array< {
      __typename: "MercadoProductCategoryClient",
      id: string,
      idClient?: string | null,
      idMercadoCategory?: string | null,
      unrestrictedProducts?: Array< string | null > | null,
      restrictedProducts?: Array< string | null > | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MercadoProductsByCategoryQueryVariables = {
  idMercadoCategory: string,
  created?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMercadoProductCategoryClientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MercadoProductsByCategoryQuery = {
  MercadoProductsByCategory?:  {
    __typename: "ModelMercadoProductCategoryClientConnection",
    items:  Array< {
      __typename: "MercadoProductCategoryClient",
      id: string,
      idClient?: string | null,
      idMercadoCategory?: string | null,
      unrestrictedProducts?: Array< string | null > | null,
      restrictedProducts?: Array< string | null > | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPrintLogosByClientQueryVariables = {
  clientId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPrintLogosFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPrintLogosByClientQuery = {
  ListPrintLogosByClient?:  {
    __typename: "ModelPrintLogosConnection",
    items:  Array< {
      __typename: "PrintLogos",
      id: string,
      status?: string | null,
      creator?: string | null,
      description?: string | null,
      identifier?: number | null,
      clientId?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      createdAt: string,
      updatedAt?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PakmailCarriersByStatusQueryVariables = {
  status: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPakmailCarrierFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PakmailCarriersByStatusQuery = {
  PakmailCarriersByStatus?:  {
    __typename: "ModelPakmailCarrierConnection",
    items:  Array< {
      __typename: "PakmailCarrier",
      id: string,
      status?: string | null,
      identifier?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PakmailCarrierByIdentifierQueryVariables = {
  identifier: number,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPakmailCarrierFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PakmailCarrierByIdentifierQuery = {
  PakmailCarrierByIdentifier?:  {
    __typename: "ModelPakmailCarrierConnection",
    items:  Array< {
      __typename: "PakmailCarrier",
      id: string,
      status?: string | null,
      identifier?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PakmailServicesByStatusQueryVariables = {
  status: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPakmailServiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PakmailServicesByStatusQuery = {
  PakmailServicesByStatus?:  {
    __typename: "ModelPakmailServiceConnection",
    items:  Array< {
      __typename: "PakmailService",
      id: string,
      status?: string | null,
      identifier?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      isNational?: boolean | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PakmailServicesByIdentifierQueryVariables = {
  identifier: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPakmailServiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PakmailServicesByIdentifierQuery = {
  PakmailServicesByIdentifier?:  {
    __typename: "ModelPakmailServiceConnection",
    items:  Array< {
      __typename: "PakmailService",
      id: string,
      status?: string | null,
      identifier?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      isNational?: boolean | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PakmailShipmentStatusesByStatusQueryVariables = {
  status: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPakmailShipmentStatusFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PakmailShipmentStatusesByStatusQuery = {
  PakmailShipmentStatusesByStatus?:  {
    __typename: "ModelPakmailShipmentStatusConnection",
    items:  Array< {
      __typename: "PakmailShipmentStatus",
      id: string,
      status?: string | null,
      identifier?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      notifications?:  Array< {
        __typename: "NotificationSubprocesses",
        group?: string | null,
        enabledEmail?: boolean | null,
        enabledPopUp?: boolean | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PakmailShipmentStatusesByIdentifierQueryVariables = {
  identifier: number,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPakmailShipmentStatusFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PakmailShipmentStatusesByIdentifierQuery = {
  PakmailShipmentStatusesByIdentifier?:  {
    __typename: "ModelPakmailShipmentStatusConnection",
    items:  Array< {
      __typename: "PakmailShipmentStatus",
      id: string,
      status?: string | null,
      identifier?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      notifications?:  Array< {
        __typename: "NotificationSubprocesses",
        group?: string | null,
        enabledEmail?: boolean | null,
        enabledPopUp?: boolean | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PakmailShipmentEventsByStatusQueryVariables = {
  status: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPakmailShipmentEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PakmailShipmentEventsByStatusQuery = {
  PakmailShipmentEventsByStatus?:  {
    __typename: "ModelPakmailShipmentEventConnection",
    items:  Array< {
      __typename: "PakmailShipmentEvent",
      id: string,
      status?: string | null,
      identifier?: string | null,
      visibleFor?: Array< string | null > | null,
      color?: string | null,
      notifications?:  Array< {
        __typename: "NotificationSubprocesses",
        group?: string | null,
        enabledEmail?: boolean | null,
        enabledPopUp?: boolean | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PakmailShipmentEventsByIdentifierQueryVariables = {
  identifier: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPakmailShipmentEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PakmailShipmentEventsByIdentifierQuery = {
  PakmailShipmentEventsByIdentifier?:  {
    __typename: "ModelPakmailShipmentEventConnection",
    items:  Array< {
      __typename: "PakmailShipmentEvent",
      id: string,
      status?: string | null,
      identifier?: string | null,
      visibleFor?: Array< string | null > | null,
      color?: string | null,
      notifications?:  Array< {
        __typename: "NotificationSubprocesses",
        group?: string | null,
        enabledEmail?: boolean | null,
        enabledPopUp?: boolean | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PakmailPickupStatusesByStatusQueryVariables = {
  status: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPakmailPickupStatusFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PakmailPickupStatusesByStatusQuery = {
  PakmailPickupStatusesByStatus?:  {
    __typename: "ModelPakmailPickupStatusConnection",
    items:  Array< {
      __typename: "PakmailPickupStatus",
      id: string,
      status?: string | null,
      identifier?: number | null,
      visibleFor?: Array< string | null > | null,
      notifications?:  Array< {
        __typename: "NotificationSubprocesses",
        group?: string | null,
        enabledEmail?: boolean | null,
        enabledPopUp?: boolean | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PakmailPickupStatusesByIdentifierQueryVariables = {
  identifier: number,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPakmailPickupStatusFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PakmailPickupStatusesByIdentifierQuery = {
  PakmailPickupStatusesByIdentifier?:  {
    __typename: "ModelPakmailPickupStatusConnection",
    items:  Array< {
      __typename: "PakmailPickupStatus",
      id: string,
      status?: string | null,
      identifier?: number | null,
      visibleFor?: Array< string | null > | null,
      notifications?:  Array< {
        __typename: "NotificationSubprocesses",
        group?: string | null,
        enabledEmail?: boolean | null,
        enabledPopUp?: boolean | null,
      } | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PremiumOrderLogisticGuidesByTypeQueryVariables = {
  type: LogisticGuideType,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPremiumOrderLogisticGuideFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PremiumOrderLogisticGuidesByTypeQuery = {
  PremiumOrderLogisticGuidesByType?:  {
    __typename: "ModelPremiumOrderLogisticGuideConnection",
    items:  Array< {
      __typename: "PremiumOrderLogisticGuide",
      id: string,
      type: LogisticGuideType,
      pakmailId?: string | null,
      premiumOrderId: string,
      clientId: string,
      creatorId: string,
      originAddressId?: string | null,
      destinationAddressId?: string | null,
      originAddress?: string | null,
      destinationAddress?: string | null,
      products?:  Array< {
        __typename: "LogisticGuideProduct",
        indexProduct: number,
        productId: string,
        quantity: number,
        unitWidth: number,
        unitHeight: number,
        unitDepth: number,
        unitWeight: number,
      } | null > | null,
      price?: number | null,
      increment?: number | null,
      fee?: number | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PremiumOrderLogisticGuidesByPakmailIdQueryVariables = {
  pakmailId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPremiumOrderLogisticGuideFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PremiumOrderLogisticGuidesByPakmailIdQuery = {
  PremiumOrderLogisticGuidesByPakmailId?:  {
    __typename: "ModelPremiumOrderLogisticGuideConnection",
    items:  Array< {
      __typename: "PremiumOrderLogisticGuide",
      id: string,
      type: LogisticGuideType,
      pakmailId?: string | null,
      premiumOrderId: string,
      clientId: string,
      creatorId: string,
      originAddressId?: string | null,
      destinationAddressId?: string | null,
      originAddress?: string | null,
      destinationAddress?: string | null,
      products?:  Array< {
        __typename: "LogisticGuideProduct",
        indexProduct: number,
        productId: string,
        quantity: number,
        unitWidth: number,
        unitHeight: number,
        unitDepth: number,
        unitWeight: number,
      } | null > | null,
      price?: number | null,
      increment?: number | null,
      fee?: number | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PremiumOrderLogisticGuidesByPremiumOrderQueryVariables = {
  premiumOrderId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPremiumOrderLogisticGuideFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PremiumOrderLogisticGuidesByPremiumOrderQuery = {
  PremiumOrderLogisticGuidesByPremiumOrder?:  {
    __typename: "ModelPremiumOrderLogisticGuideConnection",
    items:  Array< {
      __typename: "PremiumOrderLogisticGuide",
      id: string,
      type: LogisticGuideType,
      pakmailId?: string | null,
      premiumOrderId: string,
      clientId: string,
      creatorId: string,
      originAddressId?: string | null,
      destinationAddressId?: string | null,
      originAddress?: string | null,
      destinationAddress?: string | null,
      products?:  Array< {
        __typename: "LogisticGuideProduct",
        indexProduct: number,
        productId: string,
        quantity: number,
        unitWidth: number,
        unitHeight: number,
        unitDepth: number,
        unitWeight: number,
      } | null > | null,
      price?: number | null,
      increment?: number | null,
      fee?: number | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PremiumOrderLogisticGuidesByClientQueryVariables = {
  clientId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPremiumOrderLogisticGuideFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PremiumOrderLogisticGuidesByClientQuery = {
  PremiumOrderLogisticGuidesByClient?:  {
    __typename: "ModelPremiumOrderLogisticGuideConnection",
    items:  Array< {
      __typename: "PremiumOrderLogisticGuide",
      id: string,
      type: LogisticGuideType,
      pakmailId?: string | null,
      premiumOrderId: string,
      clientId: string,
      creatorId: string,
      originAddressId?: string | null,
      destinationAddressId?: string | null,
      originAddress?: string | null,
      destinationAddress?: string | null,
      products?:  Array< {
        __typename: "LogisticGuideProduct",
        indexProduct: number,
        productId: string,
        quantity: number,
        unitWidth: number,
        unitHeight: number,
        unitDepth: number,
        unitWeight: number,
      } | null > | null,
      price?: number | null,
      increment?: number | null,
      fee?: number | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PremiumOrderLogisticGuidesByCreatorQueryVariables = {
  creatorId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPremiumOrderLogisticGuideFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PremiumOrderLogisticGuidesByCreatorQuery = {
  PremiumOrderLogisticGuidesByCreator?:  {
    __typename: "ModelPremiumOrderLogisticGuideConnection",
    items:  Array< {
      __typename: "PremiumOrderLogisticGuide",
      id: string,
      type: LogisticGuideType,
      pakmailId?: string | null,
      premiumOrderId: string,
      clientId: string,
      creatorId: string,
      originAddressId?: string | null,
      destinationAddressId?: string | null,
      originAddress?: string | null,
      destinationAddress?: string | null,
      products?:  Array< {
        __typename: "LogisticGuideProduct",
        indexProduct: number,
        productId: string,
        quantity: number,
        unitWidth: number,
        unitHeight: number,
        unitDepth: number,
        unitWeight: number,
      } | null > | null,
      price?: number | null,
      increment?: number | null,
      fee?: number | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductLabelItemsByProductIdQueryVariables = {
  productId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductLabelItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductLabelItemsByProductIdQuery = {
  ProductLabelItemsByProductId?:  {
    __typename: "ModelProductLabelItemConnection",
    items:  Array< {
      __typename: "ProductLabelItem",
      id: string,
      productId?: string | null,
      productLabelId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductLabelItemsByProductLabelIdQueryVariables = {
  productLabelId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductLabelItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductLabelItemsByProductLabelIdQuery = {
  ProductLabelItemsByProductLabelId?:  {
    __typename: "ModelProductLabelItemConnection",
    items:  Array< {
      __typename: "ProductLabelItem",
      id: string,
      productId?: string | null,
      productLabelId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductLabelsByNameQueryVariables = {
  name: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductLabelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductLabelsByNameQuery = {
  ProductLabelsByName?:  {
    __typename: "ModelProductLabelConnection",
    items:  Array< {
      __typename: "ProductLabel",
      id: string,
      name?: string | null,
      translation?: string | null,
      status?: string | null,
      visibleFor?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductLabelsByTranslationQueryVariables = {
  translation: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductLabelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductLabelsByTranslationQuery = {
  ProductLabelsByTranslation?:  {
    __typename: "ModelProductLabelConnection",
    items:  Array< {
      __typename: "ProductLabel",
      id: string,
      name?: string | null,
      translation?: string | null,
      status?: string | null,
      visibleFor?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductLabelsByStatusQueryVariables = {
  status: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductLabelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductLabelsByStatusQuery = {
  ProductLabelsByStatus?:  {
    __typename: "ModelProductLabelConnection",
    items:  Array< {
      __typename: "ProductLabel",
      id: string,
      name?: string | null,
      translation?: string | null,
      status?: string | null,
      visibleFor?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductTextItemsByProductIdQueryVariables = {
  productId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductTextItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductTextItemsByProductIdQuery = {
  ProductTextItemsByProductId?:  {
    __typename: "ModelProductTextItemConnection",
    items:  Array< {
      __typename: "ProductTextItem",
      id: string,
      productId?: string | null,
      productTextId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductTextItemsByProductTextIdQueryVariables = {
  productTextId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductTextItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductTextItemsByProductTextIdQuery = {
  ProductTextItemsByProductTextId?:  {
    __typename: "ModelProductTextItemConnection",
    items:  Array< {
      __typename: "ProductTextItem",
      id: string,
      productId?: string | null,
      productTextId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductTextsByNameQueryVariables = {
  name: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductTextFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductTextsByNameQuery = {
  ProductTextsByName?:  {
    __typename: "ModelProductTextConnection",
    items:  Array< {
      __typename: "ProductText",
      id: string,
      name?: string | null,
      status?: string | null,
      visibleFor?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductTextsByStatusQueryVariables = {
  status: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductTextFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductTextsByStatusQuery = {
  ProductTextsByStatus?:  {
    __typename: "ModelProductTextConnection",
    items:  Array< {
      __typename: "ProductText",
      id: string,
      name?: string | null,
      status?: string | null,
      visibleFor?: Array< string | null > | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductMasksByProductIdQueryVariables = {
  productId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductMaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductMasksByProductIdQuery = {
  ProductMasksByProductId?:  {
    __typename: "ModelProductMaskConnection",
    items:  Array< {
      __typename: "ProductMask",
      id: string,
      name?: string | null,
      sku?: string | null,
      productId?: string | null,
      clientId?: string | null,
      filterColors?: Array< string | null > | null,
      mainImage?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      increment?: number | null,
      fee?: number | null,
      discount?: number | null,
      stock?: number | null,
      categoryId?: string | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
      kitIncrement?: number | null,
      kitFee?: number | null,
      stockMode?: ProductMaskStockMode | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductMasksByClientIdQueryVariables = {
  clientId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductMaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductMasksByClientIdQuery = {
  ProductMasksByClientId?:  {
    __typename: "ModelProductMaskConnection",
    items:  Array< {
      __typename: "ProductMask",
      id: string,
      name?: string | null,
      sku?: string | null,
      productId?: string | null,
      clientId?: string | null,
      filterColors?: Array< string | null > | null,
      mainImage?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      increment?: number | null,
      fee?: number | null,
      discount?: number | null,
      stock?: number | null,
      categoryId?: string | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
      kitIncrement?: number | null,
      kitFee?: number | null,
      stockMode?: ProductMaskStockMode | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProductMasksByCategoryIdQueryVariables = {
  categoryId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProductMaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProductMasksByCategoryIdQuery = {
  ProductMasksByCategoryId?:  {
    __typename: "ModelProductMaskConnection",
    items:  Array< {
      __typename: "ProductMask",
      id: string,
      name?: string | null,
      sku?: string | null,
      productId?: string | null,
      clientId?: string | null,
      filterColors?: Array< string | null > | null,
      mainImage?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      increment?: number | null,
      fee?: number | null,
      discount?: number | null,
      stock?: number | null,
      categoryId?: string | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
      kitIncrement?: number | null,
      kitFee?: number | null,
      stockMode?: ProductMaskStockMode | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type VariantMasksByProductMaskIdQueryVariables = {
  productMaskId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVariantMaskFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type VariantMasksByProductMaskIdQuery = {
  VariantMasksByProductMaskId?:  {
    __typename: "ModelVariantMaskConnection",
    items:  Array< {
      __typename: "VariantMask",
      id: string,
      filterColors?: Array< string | null > | null,
      images?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock?: number | null,
      stockMode?: VariantMaskStockMode | null,
      productMaskId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CouponsByCodeQueryVariables = {
  code: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCouponFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CouponsByCodeQuery = {
  couponsByCode?:  {
    __typename: "ModelCouponConnection",
    items:  Array< {
      __typename: "Coupon",
      id: string,
      code: string,
      name: string,
      description?: string | null,
      discountAmount?: number | null,
      discountPercentage?: number | null,
      minAmount?: number | null,
      maxAmount?: number | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      applicableProducts?: Array< string | null > | null,
      applicableCategories?: Array< string | null > | null,
      excludedProducts?: Array< string | null > | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelCouponRedemptionConnection",
        items:  Array< {
          __typename: "CouponRedemption",
          id: string,
          couponId: string,
          couponCode: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          discountApplied: number,
          originalAmount: number,
          finalAmount: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CouponsByStatusQueryVariables = {
  status: string,
  endDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCouponFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CouponsByStatusQuery = {
  couponsByStatus?:  {
    __typename: "ModelCouponConnection",
    items:  Array< {
      __typename: "Coupon",
      id: string,
      code: string,
      name: string,
      description?: string | null,
      discountAmount?: number | null,
      discountPercentage?: number | null,
      minAmount?: number | null,
      maxAmount?: number | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      applicableProducts?: Array< string | null > | null,
      applicableCategories?: Array< string | null > | null,
      excludedProducts?: Array< string | null > | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelCouponRedemptionConnection",
        items:  Array< {
          __typename: "CouponRedemption",
          id: string,
          couponId: string,
          couponCode: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          discountApplied: number,
          originalAmount: number,
          finalAmount: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CouponsByCreatedByQueryVariables = {
  createdBy: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCouponFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CouponsByCreatedByQuery = {
  couponsByCreatedBy?:  {
    __typename: "ModelCouponConnection",
    items:  Array< {
      __typename: "Coupon",
      id: string,
      code: string,
      name: string,
      description?: string | null,
      discountAmount?: number | null,
      discountPercentage?: number | null,
      minAmount?: number | null,
      maxAmount?: number | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      applicableProducts?: Array< string | null > | null,
      applicableCategories?: Array< string | null > | null,
      excludedProducts?: Array< string | null > | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelCouponRedemptionConnection",
        items:  Array< {
          __typename: "CouponRedemption",
          id: string,
          couponId: string,
          couponCode: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          discountApplied: number,
          originalAmount: number,
          finalAmount: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RedemptionsByCouponQueryVariables = {
  couponId: string,
  appliedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCouponRedemptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RedemptionsByCouponQuery = {
  redemptionsByCoupon?:  {
    __typename: "ModelCouponRedemptionConnection",
    items:  Array< {
      __typename: "CouponRedemption",
      id: string,
      couponId: string,
      couponCode: string,
      userId: string,
      clientId?: string | null,
      orderId?: string | null,
      cartId?: string | null,
      discountApplied: number,
      originalAmount: number,
      finalAmount: number,
      appliedAt: string,
      ipAddress?: string | null,
      userAgent?: string | null,
      coupon:  {
        __typename: "Coupon",
        id: string,
        code: string,
        name: string,
        description?: string | null,
        discountAmount?: number | null,
        discountPercentage?: number | null,
        minAmount?: number | null,
        maxAmount?: number | null,
        startDate: string,
        endDate: string,
        maxRedemptions?: number | null,
        maxRedemptionsPerUser?: number | null,
        applicableProducts?: Array< string | null > | null,
        applicableCategories?: Array< string | null > | null,
        excludedProducts?: Array< string | null > | null,
        status: string,
        createdBy: string,
        redemptions?:  {
          __typename: "ModelCouponRedemptionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RedemptionsByCouponCodeQueryVariables = {
  couponCode: string,
  appliedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCouponRedemptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RedemptionsByCouponCodeQuery = {
  redemptionsByCouponCode?:  {
    __typename: "ModelCouponRedemptionConnection",
    items:  Array< {
      __typename: "CouponRedemption",
      id: string,
      couponId: string,
      couponCode: string,
      userId: string,
      clientId?: string | null,
      orderId?: string | null,
      cartId?: string | null,
      discountApplied: number,
      originalAmount: number,
      finalAmount: number,
      appliedAt: string,
      ipAddress?: string | null,
      userAgent?: string | null,
      coupon:  {
        __typename: "Coupon",
        id: string,
        code: string,
        name: string,
        description?: string | null,
        discountAmount?: number | null,
        discountPercentage?: number | null,
        minAmount?: number | null,
        maxAmount?: number | null,
        startDate: string,
        endDate: string,
        maxRedemptions?: number | null,
        maxRedemptionsPerUser?: number | null,
        applicableProducts?: Array< string | null > | null,
        applicableCategories?: Array< string | null > | null,
        excludedProducts?: Array< string | null > | null,
        status: string,
        createdBy: string,
        redemptions?:  {
          __typename: "ModelCouponRedemptionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RedemptionsByUserQueryVariables = {
  userId: string,
  appliedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCouponRedemptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RedemptionsByUserQuery = {
  redemptionsByUser?:  {
    __typename: "ModelCouponRedemptionConnection",
    items:  Array< {
      __typename: "CouponRedemption",
      id: string,
      couponId: string,
      couponCode: string,
      userId: string,
      clientId?: string | null,
      orderId?: string | null,
      cartId?: string | null,
      discountApplied: number,
      originalAmount: number,
      finalAmount: number,
      appliedAt: string,
      ipAddress?: string | null,
      userAgent?: string | null,
      coupon:  {
        __typename: "Coupon",
        id: string,
        code: string,
        name: string,
        description?: string | null,
        discountAmount?: number | null,
        discountPercentage?: number | null,
        minAmount?: number | null,
        maxAmount?: number | null,
        startDate: string,
        endDate: string,
        maxRedemptions?: number | null,
        maxRedemptionsPerUser?: number | null,
        applicableProducts?: Array< string | null > | null,
        applicableCategories?: Array< string | null > | null,
        excludedProducts?: Array< string | null > | null,
        status: string,
        createdBy: string,
        redemptions?:  {
          __typename: "ModelCouponRedemptionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PromotionsByStatusQueryVariables = {
  status: string,
  endDate?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPromotionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PromotionsByStatusQuery = {
  promotionsByStatus?:  {
    __typename: "ModelPromotionConnection",
    items:  Array< {
      __typename: "Promotion",
      id: string,
      name: string,
      description?: string | null,
      triggerProductIds: Array< string | null >,
      minQuantity: number,
      minAmount?: number | null,
      triggerRule: PromotionTriggerRule,
      giftProductId: string,
      giftQuantity: number,
      isStackable?: boolean | null,
      applicableClientIds?: Array< string | null > | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelPromotionRedemptionConnection",
        items:  Array< {
          __typename: "PromotionRedemption",
          id: string,
          promotionId: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          triggerQuantity: number,
          giftQuantityApplied: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PromotionsByCreatedByQueryVariables = {
  createdBy: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPromotionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PromotionsByCreatedByQuery = {
  promotionsByCreatedBy?:  {
    __typename: "ModelPromotionConnection",
    items:  Array< {
      __typename: "Promotion",
      id: string,
      name: string,
      description?: string | null,
      triggerProductIds: Array< string | null >,
      minQuantity: number,
      minAmount?: number | null,
      triggerRule: PromotionTriggerRule,
      giftProductId: string,
      giftQuantity: number,
      isStackable?: boolean | null,
      applicableClientIds?: Array< string | null > | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelPromotionRedemptionConnection",
        items:  Array< {
          __typename: "PromotionRedemption",
          id: string,
          promotionId: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          triggerQuantity: number,
          giftQuantityApplied: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RedemptionsByPromotionQueryVariables = {
  promotionId: string,
  appliedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPromotionRedemptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RedemptionsByPromotionQuery = {
  redemptionsByPromotion?:  {
    __typename: "ModelPromotionRedemptionConnection",
    items:  Array< {
      __typename: "PromotionRedemption",
      id: string,
      promotionId: string,
      userId: string,
      clientId?: string | null,
      orderId?: string | null,
      cartId?: string | null,
      triggerQuantity: number,
      giftQuantityApplied: number,
      appliedAt: string,
      ipAddress?: string | null,
      userAgent?: string | null,
      promotion:  {
        __typename: "Promotion",
        id: string,
        name: string,
        description?: string | null,
        triggerProductIds: Array< string | null >,
        minQuantity: number,
        minAmount?: number | null,
        triggerRule: PromotionTriggerRule,
        giftProductId: string,
        giftQuantity: number,
        isStackable?: boolean | null,
        applicableClientIds?: Array< string | null > | null,
        startDate: string,
        endDate: string,
        maxRedemptions?: number | null,
        maxRedemptionsPerUser?: number | null,
        status: string,
        createdBy: string,
        redemptions?:  {
          __typename: "ModelPromotionRedemptionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PromotionRedemptionsByUserQueryVariables = {
  userId: string,
  appliedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPromotionRedemptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PromotionRedemptionsByUserQuery = {
  promotionRedemptionsByUser?:  {
    __typename: "ModelPromotionRedemptionConnection",
    items:  Array< {
      __typename: "PromotionRedemption",
      id: string,
      promotionId: string,
      userId: string,
      clientId?: string | null,
      orderId?: string | null,
      cartId?: string | null,
      triggerQuantity: number,
      giftQuantityApplied: number,
      appliedAt: string,
      ipAddress?: string | null,
      userAgent?: string | null,
      promotion:  {
        __typename: "Promotion",
        id: string,
        name: string,
        description?: string | null,
        triggerProductIds: Array< string | null >,
        minQuantity: number,
        minAmount?: number | null,
        triggerRule: PromotionTriggerRule,
        giftProductId: string,
        giftQuantity: number,
        isStackable?: boolean | null,
        applicableClientIds?: Array< string | null > | null,
        startDate: string,
        endDate: string,
        maxRedemptions?: number | null,
        maxRedemptionsPerUser?: number | null,
        status: string,
        createdBy: string,
        redemptions?:  {
          __typename: "ModelPromotionRedemptionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PromotionRedemptionsByClientQueryVariables = {
  clientId: string,
  appliedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPromotionRedemptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PromotionRedemptionsByClientQuery = {
  promotionRedemptionsByClient?:  {
    __typename: "ModelPromotionRedemptionConnection",
    items:  Array< {
      __typename: "PromotionRedemption",
      id: string,
      promotionId: string,
      userId: string,
      clientId?: string | null,
      orderId?: string | null,
      cartId?: string | null,
      triggerQuantity: number,
      giftQuantityApplied: number,
      appliedAt: string,
      ipAddress?: string | null,
      userAgent?: string | null,
      promotion:  {
        __typename: "Promotion",
        id: string,
        name: string,
        description?: string | null,
        triggerProductIds: Array< string | null >,
        minQuantity: number,
        minAmount?: number | null,
        triggerRule: PromotionTriggerRule,
        giftProductId: string,
        giftQuantity: number,
        isStackable?: boolean | null,
        applicableClientIds?: Array< string | null > | null,
        startDate: string,
        endDate: string,
        maxRedemptions?: number | null,
        maxRedemptionsPerUser?: number | null,
        status: string,
        createdBy: string,
        redemptions?:  {
          __typename: "ModelPromotionRedemptionConnection",
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type WalletMovementsByUserIdQueryVariables = {
  userId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelWalletMovementFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type WalletMovementsByUserIdQuery = {
  WalletMovementsByUserId?:  {
    __typename: "ModelWalletMovementConnection",
    items:  Array< {
      __typename: "WalletMovement",
      id: string,
      userId: string,
      type: WalletMovementType,
      amount: number,
      orderId?: string | null,
      createdByUserId?: string | null,
      couponId?: string | null,
      couponCode?: string | null,
      availableUntil?: string | null,
      isValidated?: boolean | null,
      validatedAt?: string | null,
      validatedBy?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OnCreateClientSubscriptionVariables = {
  filter?: ModelSubscriptionClientFilterInput | null,
};

export type OnCreateClientSubscription = {
  onCreateClient?:  {
    __typename: "Client",
    id: string,
    status?: boolean | null,
    business_name: string,
    comertial_name: string,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    grayLogo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    contact?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    biography?: string | null,
    plan?: string | null,
    fee?: number | null,
    increment?: number | null,
    mercadoFee?: number | null,
    mercadoIncrement?: number | null,
    popFee?: number | null,
    popIncrement?: number | null,
    printedFee?: number | null,
    printedIncrement?: number | null,
    users?: Array< string | null > | null,
    restrictedUsers?: Array< string | null > | null,
    nonRestrictedUsers?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    providers?: Array< string | null > | null,
    popProviders?: Array< string | null > | null,
    printedProviders?: Array< string | null > | null,
    logisticFrequency?: number | null,
    agents?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    administrators?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    signDocument?:  Array< {
      __typename: "Sign",
      url?: string | null,
      enabled?: boolean | null,
    } | null > | null,
    legal_representative?: string | null,
    legal_representative_email?: string | null,
    legal_representative_address?: string | null,
    tcdUsers?: Array< string | null > | null,
    billingUsers?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateClientSubscriptionVariables = {
  filter?: ModelSubscriptionClientFilterInput | null,
};

export type OnUpdateClientSubscription = {
  onUpdateClient?:  {
    __typename: "Client",
    id: string,
    status?: boolean | null,
    business_name: string,
    comertial_name: string,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    grayLogo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    contact?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    biography?: string | null,
    plan?: string | null,
    fee?: number | null,
    increment?: number | null,
    mercadoFee?: number | null,
    mercadoIncrement?: number | null,
    popFee?: number | null,
    popIncrement?: number | null,
    printedFee?: number | null,
    printedIncrement?: number | null,
    users?: Array< string | null > | null,
    restrictedUsers?: Array< string | null > | null,
    nonRestrictedUsers?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    providers?: Array< string | null > | null,
    popProviders?: Array< string | null > | null,
    printedProviders?: Array< string | null > | null,
    logisticFrequency?: number | null,
    agents?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    administrators?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    signDocument?:  Array< {
      __typename: "Sign",
      url?: string | null,
      enabled?: boolean | null,
    } | null > | null,
    legal_representative?: string | null,
    legal_representative_email?: string | null,
    legal_representative_address?: string | null,
    tcdUsers?: Array< string | null > | null,
    billingUsers?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteClientSubscriptionVariables = {
  filter?: ModelSubscriptionClientFilterInput | null,
};

export type OnDeleteClientSubscription = {
  onDeleteClient?:  {
    __typename: "Client",
    id: string,
    status?: boolean | null,
    business_name: string,
    comertial_name: string,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    grayLogo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    contact?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    biography?: string | null,
    plan?: string | null,
    fee?: number | null,
    increment?: number | null,
    mercadoFee?: number | null,
    mercadoIncrement?: number | null,
    popFee?: number | null,
    popIncrement?: number | null,
    printedFee?: number | null,
    printedIncrement?: number | null,
    users?: Array< string | null > | null,
    restrictedUsers?: Array< string | null > | null,
    nonRestrictedUsers?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    providers?: Array< string | null > | null,
    popProviders?: Array< string | null > | null,
    printedProviders?: Array< string | null > | null,
    logisticFrequency?: number | null,
    agents?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    administrators?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    signDocument?:  Array< {
      __typename: "Sign",
      url?: string | null,
      enabled?: boolean | null,
    } | null > | null,
    legal_representative?: string | null,
    legal_representative_email?: string | null,
    legal_representative_address?: string | null,
    tcdUsers?: Array< string | null > | null,
    billingUsers?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateClientSettingSubscriptionVariables = {
  filter?: ModelSubscriptionClientSettingFilterInput | null,
};

export type OnCreateClientSettingSubscription = {
  onCreateClientSetting?:  {
    __typename: "ClientSetting",
    id: string,
    crmJiraId?: string | null,
    orderBudget?: number | null,
    domain?: string | null,
    filterColors?: Array< string | null > | null,
    primaryColors?: Array< string | null > | null,
    accentColors?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateClientSettingSubscriptionVariables = {
  filter?: ModelSubscriptionClientSettingFilterInput | null,
};

export type OnUpdateClientSettingSubscription = {
  onUpdateClientSetting?:  {
    __typename: "ClientSetting",
    id: string,
    crmJiraId?: string | null,
    orderBudget?: number | null,
    domain?: string | null,
    filterColors?: Array< string | null > | null,
    primaryColors?: Array< string | null > | null,
    accentColors?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteClientSettingSubscriptionVariables = {
  filter?: ModelSubscriptionClientSettingFilterInput | null,
};

export type OnDeleteClientSettingSubscription = {
  onDeleteClientSetting?:  {
    __typename: "ClientSetting",
    id: string,
    crmJiraId?: string | null,
    orderBudget?: number | null,
    domain?: string | null,
    filterColors?: Array< string | null > | null,
    primaryColors?: Array< string | null > | null,
    accentColors?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateClientOptionSubscriptionVariables = {
  filter?: ModelSubscriptionClientOptionFilterInput | null,
};

export type OnCreateClientOptionSubscription = {
  onCreateClientOption?:  {
    __typename: "ClientOption",
    id: string,
    pakmail?: boolean | null,
    orderVat?: boolean | null,
    hasMercado?: boolean | null,
    hasAmazon?: boolean | null,
    hasAutomobiles?: boolean | null,
    publicDashboards?: boolean | null,
    printPrices?: boolean | null,
    logisticPrices?: boolean | null,
    hidePricesAndFlow?: boolean | null,
    showPhones?: boolean | null,
    fullCoupaDescriptions?: boolean | null,
    isPremium?: boolean | null,
    isPop?: boolean | null,
    isPrinted?: boolean | null,
    allPremiumRfqs?: boolean | null,
    allPopRfqs?: boolean | null,
    allPrintedRfqs?: boolean | null,
    autoUpdateHomePage?: boolean | null,
    showVat?: boolean | null,
    requiredDeliveryInfo?: boolean | null,
    restrictedCatalogue?: boolean | null,
    excludeCoupa?: boolean | null,
    tcdPayment?: boolean | null,
    automaticLogisticGuides?: boolean | null,
    transferencePayment?: boolean | null,
    customCatalogue?: boolean | null,
    disableProjectDescriptions?: boolean | null,
    showBranding?: boolean | null,
    customCostCenter?: boolean | null,
    couponsEnabled?: boolean | null,
    showChat?: boolean | null,
    hasCrmSync?: boolean | null,
    onlyQuotes?: boolean | null,
    autoSaveDeliveryInfo?: boolean | null,
    limitMaxRequestOnDiscounts?: boolean | null,
    freeLocalShipping?: boolean | null,
    discountShipping?: boolean | null,
    printingBreakdown?: boolean | null,
    skipAlendum?: boolean | null,
    skipFMS?: boolean | null,
    clientReminders?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateClientOptionSubscriptionVariables = {
  filter?: ModelSubscriptionClientOptionFilterInput | null,
};

export type OnUpdateClientOptionSubscription = {
  onUpdateClientOption?:  {
    __typename: "ClientOption",
    id: string,
    pakmail?: boolean | null,
    orderVat?: boolean | null,
    hasMercado?: boolean | null,
    hasAmazon?: boolean | null,
    hasAutomobiles?: boolean | null,
    publicDashboards?: boolean | null,
    printPrices?: boolean | null,
    logisticPrices?: boolean | null,
    hidePricesAndFlow?: boolean | null,
    showPhones?: boolean | null,
    fullCoupaDescriptions?: boolean | null,
    isPremium?: boolean | null,
    isPop?: boolean | null,
    isPrinted?: boolean | null,
    allPremiumRfqs?: boolean | null,
    allPopRfqs?: boolean | null,
    allPrintedRfqs?: boolean | null,
    autoUpdateHomePage?: boolean | null,
    showVat?: boolean | null,
    requiredDeliveryInfo?: boolean | null,
    restrictedCatalogue?: boolean | null,
    excludeCoupa?: boolean | null,
    tcdPayment?: boolean | null,
    automaticLogisticGuides?: boolean | null,
    transferencePayment?: boolean | null,
    customCatalogue?: boolean | null,
    disableProjectDescriptions?: boolean | null,
    showBranding?: boolean | null,
    customCostCenter?: boolean | null,
    couponsEnabled?: boolean | null,
    showChat?: boolean | null,
    hasCrmSync?: boolean | null,
    onlyQuotes?: boolean | null,
    autoSaveDeliveryInfo?: boolean | null,
    limitMaxRequestOnDiscounts?: boolean | null,
    freeLocalShipping?: boolean | null,
    discountShipping?: boolean | null,
    printingBreakdown?: boolean | null,
    skipAlendum?: boolean | null,
    skipFMS?: boolean | null,
    clientReminders?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteClientOptionSubscriptionVariables = {
  filter?: ModelSubscriptionClientOptionFilterInput | null,
};

export type OnDeleteClientOptionSubscription = {
  onDeleteClientOption?:  {
    __typename: "ClientOption",
    id: string,
    pakmail?: boolean | null,
    orderVat?: boolean | null,
    hasMercado?: boolean | null,
    hasAmazon?: boolean | null,
    hasAutomobiles?: boolean | null,
    publicDashboards?: boolean | null,
    printPrices?: boolean | null,
    logisticPrices?: boolean | null,
    hidePricesAndFlow?: boolean | null,
    showPhones?: boolean | null,
    fullCoupaDescriptions?: boolean | null,
    isPremium?: boolean | null,
    isPop?: boolean | null,
    isPrinted?: boolean | null,
    allPremiumRfqs?: boolean | null,
    allPopRfqs?: boolean | null,
    allPrintedRfqs?: boolean | null,
    autoUpdateHomePage?: boolean | null,
    showVat?: boolean | null,
    requiredDeliveryInfo?: boolean | null,
    restrictedCatalogue?: boolean | null,
    excludeCoupa?: boolean | null,
    tcdPayment?: boolean | null,
    automaticLogisticGuides?: boolean | null,
    transferencePayment?: boolean | null,
    customCatalogue?: boolean | null,
    disableProjectDescriptions?: boolean | null,
    showBranding?: boolean | null,
    customCostCenter?: boolean | null,
    couponsEnabled?: boolean | null,
    showChat?: boolean | null,
    hasCrmSync?: boolean | null,
    onlyQuotes?: boolean | null,
    autoSaveDeliveryInfo?: boolean | null,
    limitMaxRequestOnDiscounts?: boolean | null,
    freeLocalShipping?: boolean | null,
    discountShipping?: boolean | null,
    printingBreakdown?: boolean | null,
    skipAlendum?: boolean | null,
    skipFMS?: boolean | null,
    clientReminders?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateProviderSubscriptionVariables = {
  filter?: ModelSubscriptionProviderFilterInput | null,
};

export type OnCreateProviderSubscription = {
  onCreateProvider?:  {
    __typename: "Provider",
    id: string,
    isApproved?: boolean | null,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    grayLogo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comertial_name?: string | null,
    bussiness_name?:  {
      __typename: "BusinessName",
      tax_residence?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      rfc?: string | null,
      name?: string | null,
    } | null,
    idProcter?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    contact?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null,
    biography?: string | null,
    constancia?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comprobante?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    experience?: string | null,
    pros?: Array< string | null > | null,
    cons?: Array< string | null > | null,
    cte_rating?:  Array< {
      __typename: "Rating",
      name?: string | null,
      rating?: number | null,
    } | null > | null,
    shopping_rating?:  Array< {
      __typename: "Rating",
      name?: string | null,
      rating?: number | null,
    } | null > | null,
    video?: string | null,
    tags?: Array< string | null > | null,
    money_filter_c?: boolean | null,
    money_filter_d?: boolean | null,
    users?: Array< string | null > | null,
    bank?: string | null,
    account?: string | null,
    clabe?: string | null,
    cuenta_correo?: string | null,
    edocuenta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    ife?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    poderes?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    acta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    isProvider?: boolean | null,
    sameAddress?: boolean | null,
    isPop?: boolean | null,
    isPrinted?: boolean | null,
    hasLogistic?: boolean | null,
    created?: number | null,
    updated?: number | null,
    addFiles?:  Array< {
      __typename: "SignFile",
      key?: string | null,
      url?: string | null,
      sign?: string | null,
      status?: string | null,
    } | null > | null,
    signFiles?:  Array< {
      __typename: "SignFile",
      key?: string | null,
      url?: string | null,
      sign?: string | null,
      status?: string | null,
    } | null > | null,
    representante_legal?: string | null,
    escritura_constitucion?: string | null,
    notario_a?: string | null,
    constituido_down_edo?: string | null,
    rrpp?: string | null,
    isPremium?: boolean | null,
    isTrustProvider?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateProviderSubscriptionVariables = {
  filter?: ModelSubscriptionProviderFilterInput | null,
};

export type OnUpdateProviderSubscription = {
  onUpdateProvider?:  {
    __typename: "Provider",
    id: string,
    isApproved?: boolean | null,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    grayLogo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comertial_name?: string | null,
    bussiness_name?:  {
      __typename: "BusinessName",
      tax_residence?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      rfc?: string | null,
      name?: string | null,
    } | null,
    idProcter?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    contact?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null,
    biography?: string | null,
    constancia?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comprobante?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    experience?: string | null,
    pros?: Array< string | null > | null,
    cons?: Array< string | null > | null,
    cte_rating?:  Array< {
      __typename: "Rating",
      name?: string | null,
      rating?: number | null,
    } | null > | null,
    shopping_rating?:  Array< {
      __typename: "Rating",
      name?: string | null,
      rating?: number | null,
    } | null > | null,
    video?: string | null,
    tags?: Array< string | null > | null,
    money_filter_c?: boolean | null,
    money_filter_d?: boolean | null,
    users?: Array< string | null > | null,
    bank?: string | null,
    account?: string | null,
    clabe?: string | null,
    cuenta_correo?: string | null,
    edocuenta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    ife?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    poderes?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    acta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    isProvider?: boolean | null,
    sameAddress?: boolean | null,
    isPop?: boolean | null,
    isPrinted?: boolean | null,
    hasLogistic?: boolean | null,
    created?: number | null,
    updated?: number | null,
    addFiles?:  Array< {
      __typename: "SignFile",
      key?: string | null,
      url?: string | null,
      sign?: string | null,
      status?: string | null,
    } | null > | null,
    signFiles?:  Array< {
      __typename: "SignFile",
      key?: string | null,
      url?: string | null,
      sign?: string | null,
      status?: string | null,
    } | null > | null,
    representante_legal?: string | null,
    escritura_constitucion?: string | null,
    notario_a?: string | null,
    constituido_down_edo?: string | null,
    rrpp?: string | null,
    isPremium?: boolean | null,
    isTrustProvider?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteProviderSubscriptionVariables = {
  filter?: ModelSubscriptionProviderFilterInput | null,
};

export type OnDeleteProviderSubscription = {
  onDeleteProvider?:  {
    __typename: "Provider",
    id: string,
    isApproved?: boolean | null,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    grayLogo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comertial_name?: string | null,
    bussiness_name?:  {
      __typename: "BusinessName",
      tax_residence?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      rfc?: string | null,
      name?: string | null,
    } | null,
    idProcter?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    contact?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    address?:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null,
    biography?: string | null,
    constancia?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comprobante?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    experience?: string | null,
    pros?: Array< string | null > | null,
    cons?: Array< string | null > | null,
    cte_rating?:  Array< {
      __typename: "Rating",
      name?: string | null,
      rating?: number | null,
    } | null > | null,
    shopping_rating?:  Array< {
      __typename: "Rating",
      name?: string | null,
      rating?: number | null,
    } | null > | null,
    video?: string | null,
    tags?: Array< string | null > | null,
    money_filter_c?: boolean | null,
    money_filter_d?: boolean | null,
    users?: Array< string | null > | null,
    bank?: string | null,
    account?: string | null,
    clabe?: string | null,
    cuenta_correo?: string | null,
    edocuenta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    ife?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    poderes?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    acta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    isProvider?: boolean | null,
    sameAddress?: boolean | null,
    isPop?: boolean | null,
    isPrinted?: boolean | null,
    hasLogistic?: boolean | null,
    created?: number | null,
    updated?: number | null,
    addFiles?:  Array< {
      __typename: "SignFile",
      key?: string | null,
      url?: string | null,
      sign?: string | null,
      status?: string | null,
    } | null > | null,
    signFiles?:  Array< {
      __typename: "SignFile",
      key?: string | null,
      url?: string | null,
      sign?: string | null,
      status?: string | null,
    } | null > | null,
    representante_legal?: string | null,
    escritura_constitucion?: string | null,
    notario_a?: string | null,
    constituido_down_edo?: string | null,
    rrpp?: string | null,
    isPremium?: boolean | null,
    isTrustProvider?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateProviderSettingSubscriptionVariables = {
  filter?: ModelSubscriptionProviderSettingFilterInput | null,
};

export type OnCreateProviderSettingSubscription = {
  onCreateProviderSetting?:  {
    __typename: "ProviderSetting",
    id: string,
    primaryColors?: Array< string | null > | null,
    accentColors?: Array< string | null > | null,
    categories?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateProviderSettingSubscriptionVariables = {
  filter?: ModelSubscriptionProviderSettingFilterInput | null,
};

export type OnUpdateProviderSettingSubscription = {
  onUpdateProviderSetting?:  {
    __typename: "ProviderSetting",
    id: string,
    primaryColors?: Array< string | null > | null,
    accentColors?: Array< string | null > | null,
    categories?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteProviderSettingSubscriptionVariables = {
  filter?: ModelSubscriptionProviderSettingFilterInput | null,
};

export type OnDeleteProviderSettingSubscription = {
  onDeleteProviderSetting?:  {
    __typename: "ProviderSetting",
    id: string,
    primaryColors?: Array< string | null > | null,
    accentColors?: Array< string | null > | null,
    categories?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateProviderFileSubscriptionVariables = {
  filter?: ModelSubscriptionProviderFileFilterInput | null,
};

export type OnCreateProviderFileSubscription = {
  onCreateProviderFile?:  {
    __typename: "ProviderFile",
    id: string,
    acta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    constancia?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comprobante?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    edocuenta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    ife?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    poderes?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateProviderFileSubscriptionVariables = {
  filter?: ModelSubscriptionProviderFileFilterInput | null,
};

export type OnUpdateProviderFileSubscription = {
  onUpdateProviderFile?:  {
    __typename: "ProviderFile",
    id: string,
    acta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    constancia?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comprobante?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    edocuenta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    ife?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    poderes?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteProviderFileSubscriptionVariables = {
  filter?: ModelSubscriptionProviderFileFilterInput | null,
};

export type OnDeleteProviderFileSubscription = {
  onDeleteProviderFile?:  {
    __typename: "ProviderFile",
    id: string,
    acta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    constancia?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    comprobante?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    edocuenta?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    ife?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    poderes?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateColorsSubscriptionVariables = {
  filter?: ModelSubscriptionColorsFilterInput | null,
};

export type OnCreateColorsSubscription = {
  onCreateColors?:  {
    __typename: "Colors",
    id: string,
    status: string,
    name: string,
    rgb: string,
    hex: string,
    position?: number | null,
    variantNames?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateColorsSubscriptionVariables = {
  filter?: ModelSubscriptionColorsFilterInput | null,
};

export type OnUpdateColorsSubscription = {
  onUpdateColors?:  {
    __typename: "Colors",
    id: string,
    status: string,
    name: string,
    rgb: string,
    hex: string,
    position?: number | null,
    variantNames?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteColorsSubscriptionVariables = {
  filter?: ModelSubscriptionColorsFilterInput | null,
};

export type OnDeleteColorsSubscription = {
  onDeleteColors?:  {
    __typename: "Colors",
    id: string,
    status: string,
    name: string,
    rgb: string,
    hex: string,
    position?: number | null,
    variantNames?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateHomePageCarouselBannerSubscriptionVariables = {
  filter?: ModelSubscriptionHomePageCarouselBannerFilterInput | null,
};

export type OnCreateHomePageCarouselBannerSubscription = {
  onCreateHomePageCarouselBanner?:  {
    __typename: "HomePageCarouselBanner",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    title?: string | null,
    subtitle?: string | null,
    copy?: string | null,
    path?: string | null,
    bgImage?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    position?: number | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateHomePageCarouselBannerSubscriptionVariables = {
  filter?: ModelSubscriptionHomePageCarouselBannerFilterInput | null,
};

export type OnUpdateHomePageCarouselBannerSubscription = {
  onUpdateHomePageCarouselBanner?:  {
    __typename: "HomePageCarouselBanner",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    title?: string | null,
    subtitle?: string | null,
    copy?: string | null,
    path?: string | null,
    bgImage?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    position?: number | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteHomePageCarouselBannerSubscriptionVariables = {
  filter?: ModelSubscriptionHomePageCarouselBannerFilterInput | null,
};

export type OnDeleteHomePageCarouselBannerSubscription = {
  onDeleteHomePageCarouselBanner?:  {
    __typename: "HomePageCarouselBanner",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    title?: string | null,
    subtitle?: string | null,
    copy?: string | null,
    path?: string | null,
    bgImage?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    position?: number | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateHomePageSubscriptionVariables = {
  filter?: ModelSubscriptionHomePageFilterInput | null,
};

export type OnCreateHomePageSubscription = {
  onCreateHomePage?:  {
    __typename: "HomePage",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    showArrow?: boolean | null,
    showNumeration?: boolean | null,
    icon?: string | null,
    title?: string | null,
    subtitle?: string | null,
    body?: string | null,
    route?: string | null,
    titlePosition?: string | null,
    textAlign?: string | null,
    bgImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bgColor?: string | null,
    borderColor?: string | null,
    textColor?: string | null,
    position?: number | null,
    verticalLine?: boolean | null,
    browseButton?: boolean | null,
    visibleFor?: Array< string | null > | null,
    visibleForUserBrand?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateHomePageSubscriptionVariables = {
  filter?: ModelSubscriptionHomePageFilterInput | null,
};

export type OnUpdateHomePageSubscription = {
  onUpdateHomePage?:  {
    __typename: "HomePage",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    showArrow?: boolean | null,
    showNumeration?: boolean | null,
    icon?: string | null,
    title?: string | null,
    subtitle?: string | null,
    body?: string | null,
    route?: string | null,
    titlePosition?: string | null,
    textAlign?: string | null,
    bgImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bgColor?: string | null,
    borderColor?: string | null,
    textColor?: string | null,
    position?: number | null,
    verticalLine?: boolean | null,
    browseButton?: boolean | null,
    visibleFor?: Array< string | null > | null,
    visibleForUserBrand?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteHomePageSubscriptionVariables = {
  filter?: ModelSubscriptionHomePageFilterInput | null,
};

export type OnDeleteHomePageSubscription = {
  onDeleteHomePage?:  {
    __typename: "HomePage",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    showArrow?: boolean | null,
    showNumeration?: boolean | null,
    icon?: string | null,
    title?: string | null,
    subtitle?: string | null,
    body?: string | null,
    route?: string | null,
    titlePosition?: string | null,
    textAlign?: string | null,
    bgImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bgColor?: string | null,
    borderColor?: string | null,
    textColor?: string | null,
    position?: number | null,
    verticalLine?: boolean | null,
    browseButton?: boolean | null,
    visibleFor?: Array< string | null > | null,
    visibleForUserBrand?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateHomePageBottomBannerSubscriptionVariables = {
  filter?: ModelSubscriptionHomePageBottomBannerFilterInput | null,
};

export type OnCreateHomePageBottomBannerSubscription = {
  onCreateHomePageBottomBanner?:  {
    __typename: "HomePageBottomBanner",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    title?: string | null,
    subtitle?: string | null,
    icon?: string | null,
    route?: string | null,
    showArrow?: boolean | null,
    bannerImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bgColor?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateHomePageBottomBannerSubscriptionVariables = {
  filter?: ModelSubscriptionHomePageBottomBannerFilterInput | null,
};

export type OnUpdateHomePageBottomBannerSubscription = {
  onUpdateHomePageBottomBanner?:  {
    __typename: "HomePageBottomBanner",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    title?: string | null,
    subtitle?: string | null,
    icon?: string | null,
    route?: string | null,
    showArrow?: boolean | null,
    bannerImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bgColor?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteHomePageBottomBannerSubscriptionVariables = {
  filter?: ModelSubscriptionHomePageBottomBannerFilterInput | null,
};

export type OnDeleteHomePageBottomBannerSubscription = {
  onDeleteHomePageBottomBanner?:  {
    __typename: "HomePageBottomBanner",
    id: string,
    status?: boolean | null,
    isPublic?: boolean | null,
    title?: string | null,
    subtitle?: string | null,
    icon?: string | null,
    route?: string | null,
    showArrow?: boolean | null,
    bannerImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bgColor?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateProductoSubscriptionVariables = {
  filter?: ModelSubscriptionProductoFilterInput | null,
};

export type OnCreateProductoSubscription = {
  onCreateProducto?:  {
    __typename: "Producto",
    id: string,
    providerId: string,
    categoryId: string,
    name: string,
    status?: string | null,
    bestSeller?: string | null,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    order?: number | null,
    sku: string,
    brand?: string | null,
    colors?: Array< string | null > | null,
    pgClasitication?: string | null,
    delivery_time?: string | null,
    delivery_time_units?: string | null,
    stock?: number | null,
    minRequest?: number | null,
    maxRequest?: number | null,
    article_of_clothing?: boolean | null,
    size?: string | null,
    price: number,
    long_description: string,
    short_description: string,
    creator?: string | null,
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    category:  {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    },
    isExternal?: boolean | null,
    isAllowable?: boolean | null,
    isRestricted?: boolean | null,
    isAutoSkipped?: string | null,
    isAutoAllowed?: string | null,
    isPurse?: boolean | null,
    massiveLayout?: string | null,
    hasBaseAmmount?: boolean | null,
    isFreeAmmount?: boolean | null,
    isCard?: boolean | null,
    isByRequest?: boolean | null,
    isMultiPrice?: boolean | null,
    cardBaseAmmount?: number | null,
    minCardBaseAmmount?: number | null,
    maxCardBaseAmmount?: number | null,
    nameExternal?: string | null,
    unspsc?: string | null,
    variants?:  Array< {
      __typename: "Variants",
      sku?: string | null,
      name?: string | null,
      description?: string | null,
      colors?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock_available?: number | null,
      price?: number | null,
      size?: string | null,
      logoType?: string | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientIncrementPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    productDescriptionItem?:  Array< {
      __typename: "ProductDescriptionItem",
      index?: number | null,
      status?: boolean | null,
      key?: string | null,
      description?: string | null,
    } | null > | null,
    source?: string | null,
    trazoProductId?: string | null,
    trazoCategoryId?: string | null,
    stockUpdatedAt?: string | null,
    priceUpdatedAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateProductoSubscriptionVariables = {
  filter?: ModelSubscriptionProductoFilterInput | null,
};

export type OnUpdateProductoSubscription = {
  onUpdateProducto?:  {
    __typename: "Producto",
    id: string,
    providerId: string,
    categoryId: string,
    name: string,
    status?: string | null,
    bestSeller?: string | null,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    order?: number | null,
    sku: string,
    brand?: string | null,
    colors?: Array< string | null > | null,
    pgClasitication?: string | null,
    delivery_time?: string | null,
    delivery_time_units?: string | null,
    stock?: number | null,
    minRequest?: number | null,
    maxRequest?: number | null,
    article_of_clothing?: boolean | null,
    size?: string | null,
    price: number,
    long_description: string,
    short_description: string,
    creator?: string | null,
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    category:  {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    },
    isExternal?: boolean | null,
    isAllowable?: boolean | null,
    isRestricted?: boolean | null,
    isAutoSkipped?: string | null,
    isAutoAllowed?: string | null,
    isPurse?: boolean | null,
    massiveLayout?: string | null,
    hasBaseAmmount?: boolean | null,
    isFreeAmmount?: boolean | null,
    isCard?: boolean | null,
    isByRequest?: boolean | null,
    isMultiPrice?: boolean | null,
    cardBaseAmmount?: number | null,
    minCardBaseAmmount?: number | null,
    maxCardBaseAmmount?: number | null,
    nameExternal?: string | null,
    unspsc?: string | null,
    variants?:  Array< {
      __typename: "Variants",
      sku?: string | null,
      name?: string | null,
      description?: string | null,
      colors?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock_available?: number | null,
      price?: number | null,
      size?: string | null,
      logoType?: string | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientIncrementPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    productDescriptionItem?:  Array< {
      __typename: "ProductDescriptionItem",
      index?: number | null,
      status?: boolean | null,
      key?: string | null,
      description?: string | null,
    } | null > | null,
    source?: string | null,
    trazoProductId?: string | null,
    trazoCategoryId?: string | null,
    stockUpdatedAt?: string | null,
    priceUpdatedAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteProductoSubscriptionVariables = {
  filter?: ModelSubscriptionProductoFilterInput | null,
};

export type OnDeleteProductoSubscription = {
  onDeleteProducto?:  {
    __typename: "Producto",
    id: string,
    providerId: string,
    categoryId: string,
    name: string,
    status?: string | null,
    bestSeller?: string | null,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    order?: number | null,
    sku: string,
    brand?: string | null,
    colors?: Array< string | null > | null,
    pgClasitication?: string | null,
    delivery_time?: string | null,
    delivery_time_units?: string | null,
    stock?: number | null,
    minRequest?: number | null,
    maxRequest?: number | null,
    article_of_clothing?: boolean | null,
    size?: string | null,
    price: number,
    long_description: string,
    short_description: string,
    creator?: string | null,
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    category:  {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    },
    isExternal?: boolean | null,
    isAllowable?: boolean | null,
    isRestricted?: boolean | null,
    isAutoSkipped?: string | null,
    isAutoAllowed?: string | null,
    isPurse?: boolean | null,
    massiveLayout?: string | null,
    hasBaseAmmount?: boolean | null,
    isFreeAmmount?: boolean | null,
    isCard?: boolean | null,
    isByRequest?: boolean | null,
    isMultiPrice?: boolean | null,
    cardBaseAmmount?: number | null,
    minCardBaseAmmount?: number | null,
    maxCardBaseAmmount?: number | null,
    nameExternal?: string | null,
    unspsc?: string | null,
    variants?:  Array< {
      __typename: "Variants",
      sku?: string | null,
      name?: string | null,
      description?: string | null,
      colors?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock_available?: number | null,
      price?: number | null,
      size?: string | null,
      logoType?: string | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientIncrementPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    productDescriptionItem?:  Array< {
      __typename: "ProductDescriptionItem",
      index?: number | null,
      status?: boolean | null,
      key?: string | null,
      description?: string | null,
    } | null > | null,
    source?: string | null,
    trazoProductId?: string | null,
    trazoCategoryId?: string | null,
    stockUpdatedAt?: string | null,
    priceUpdatedAt?: string | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateProductVariantSubscriptionVariables = {
  filter?: ModelSubscriptionProductVariantFilterInput | null,
};

export type OnCreateProductVariantSubscription = {
  onCreateProductVariant?:  {
    __typename: "ProductVariant",
    id: string,
    productId?: string | null,
    sku?: string | null,
    name?: string | null,
    description?: string | null,
    colors?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    image?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    stock_available?: number | null,
    price?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateProductVariantSubscriptionVariables = {
  filter?: ModelSubscriptionProductVariantFilterInput | null,
};

export type OnUpdateProductVariantSubscription = {
  onUpdateProductVariant?:  {
    __typename: "ProductVariant",
    id: string,
    productId?: string | null,
    sku?: string | null,
    name?: string | null,
    description?: string | null,
    colors?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    image?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    stock_available?: number | null,
    price?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteProductVariantSubscriptionVariables = {
  filter?: ModelSubscriptionProductVariantFilterInput | null,
};

export type OnDeleteProductVariantSubscription = {
  onDeleteProductVariant?:  {
    __typename: "ProductVariant",
    id: string,
    productId?: string | null,
    sku?: string | null,
    name?: string | null,
    description?: string | null,
    colors?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    image?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    stock_available?: number | null,
    price?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateProductOptionSubscriptionVariables = {
  filter?: ModelSubscriptionProductOptionFilterInput | null,
};

export type OnCreateProductOptionSubscription = {
  onCreateProductOption?:  {
    __typename: "ProductOption",
    id: string,
    ownOrder?: string | null,
    isPangga?: string | null,
    volumetricWeight?: string | null,
    isEvaluated?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateProductOptionSubscriptionVariables = {
  filter?: ModelSubscriptionProductOptionFilterInput | null,
};

export type OnUpdateProductOptionSubscription = {
  onUpdateProductOption?:  {
    __typename: "ProductOption",
    id: string,
    ownOrder?: string | null,
    isPangga?: string | null,
    volumetricWeight?: string | null,
    isEvaluated?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteProductOptionSubscriptionVariables = {
  filter?: ModelSubscriptionProductOptionFilterInput | null,
};

export type OnDeleteProductOptionSubscription = {
  onDeleteProductOption?:  {
    __typename: "ProductOption",
    id: string,
    ownOrder?: string | null,
    isPangga?: string | null,
    volumetricWeight?: string | null,
    isEvaluated?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateProductDimentionSubscriptionVariables = {
  filter?: ModelSubscriptionProductDimentionFilterInput | null,
};

export type OnCreateProductDimentionSubscription = {
  onCreateProductDimention?:  {
    __typename: "ProductDimention",
    id: string,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    weight?: number | null,
    boxWidth?: number | null,
    boxHeight?: number | null,
    boxDepth?: number | null,
    boxWeight?: number | null,
    boxQuantity?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateProductDimentionSubscriptionVariables = {
  filter?: ModelSubscriptionProductDimentionFilterInput | null,
};

export type OnUpdateProductDimentionSubscription = {
  onUpdateProductDimention?:  {
    __typename: "ProductDimention",
    id: string,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    weight?: number | null,
    boxWidth?: number | null,
    boxHeight?: number | null,
    boxDepth?: number | null,
    boxWeight?: number | null,
    boxQuantity?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteProductDimentionSubscriptionVariables = {
  filter?: ModelSubscriptionProductDimentionFilterInput | null,
};

export type OnDeleteProductDimentionSubscription = {
  onDeleteProductDimention?:  {
    __typename: "ProductDimention",
    id: string,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    weight?: number | null,
    boxWidth?: number | null,
    boxHeight?: number | null,
    boxDepth?: number | null,
    boxWeight?: number | null,
    boxQuantity?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateMassiveChangeLayoutsSubscriptionVariables = {
  filter?: ModelSubscriptionMassiveChangeLayoutsFilterInput | null,
};

export type OnCreateMassiveChangeLayoutsSubscription = {
  onCreateMassiveChangeLayouts?:  {
    __typename: "MassiveChangeLayouts",
    id: string,
    type?: string | null,
    status?: string | null,
    providerId?: string | null,
    creatorId?: string | null,
    creatorRole?: string | null,
    productsNumber?: number | null,
    file?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateMassiveChangeLayoutsSubscriptionVariables = {
  filter?: ModelSubscriptionMassiveChangeLayoutsFilterInput | null,
};

export type OnUpdateMassiveChangeLayoutsSubscription = {
  onUpdateMassiveChangeLayouts?:  {
    __typename: "MassiveChangeLayouts",
    id: string,
    type?: string | null,
    status?: string | null,
    providerId?: string | null,
    creatorId?: string | null,
    creatorRole?: string | null,
    productsNumber?: number | null,
    file?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteMassiveChangeLayoutsSubscriptionVariables = {
  filter?: ModelSubscriptionMassiveChangeLayoutsFilterInput | null,
};

export type OnDeleteMassiveChangeLayoutsSubscription = {
  onDeleteMassiveChangeLayouts?:  {
    __typename: "MassiveChangeLayouts",
    id: string,
    type?: string | null,
    status?: string | null,
    providerId?: string | null,
    creatorId?: string | null,
    creatorRole?: string | null,
    productsNumber?: number | null,
    file?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateCategorySubscriptionVariables = {
  filter?: ModelSubscriptionCategoryFilterInput | null,
};

export type OnCreateCategorySubscription = {
  onCreateCategory?:  {
    __typename: "Category",
    id: string,
    name: string,
    description?: string | null,
    unspsc?: string | null,
    image:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    },
    imageMobile?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    visibleForUserBrand?: Array< string | null > | null,
    region?: Array< string | null > | null,
    tags?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    hasAllowables?: boolean | null,
    hasPreapproveds?: boolean | null,
    hasRestricted?: boolean | null,
    isPublic?: boolean | null,
    isTop?: boolean | null,
    createdAt?: string | null,
    slug?: string | null,
    parentId?: string | null,
    rootId?: string | null,
    path?: string | null,
    status?: string | null,
    pathIds?: Array< string | null > | null,
    source?: string | null,
    trazoCategoryId?: string | null,
    nameExternal?: string | null,
    depth?: number | null,
    childrenCount?: number | null,
    isLeaf?: boolean | null,
    oldVersion?: string | null,
    productLine?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateCategorySubscriptionVariables = {
  filter?: ModelSubscriptionCategoryFilterInput | null,
};

export type OnUpdateCategorySubscription = {
  onUpdateCategory?:  {
    __typename: "Category",
    id: string,
    name: string,
    description?: string | null,
    unspsc?: string | null,
    image:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    },
    imageMobile?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    visibleForUserBrand?: Array< string | null > | null,
    region?: Array< string | null > | null,
    tags?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    hasAllowables?: boolean | null,
    hasPreapproveds?: boolean | null,
    hasRestricted?: boolean | null,
    isPublic?: boolean | null,
    isTop?: boolean | null,
    createdAt?: string | null,
    slug?: string | null,
    parentId?: string | null,
    rootId?: string | null,
    path?: string | null,
    status?: string | null,
    pathIds?: Array< string | null > | null,
    source?: string | null,
    trazoCategoryId?: string | null,
    nameExternal?: string | null,
    depth?: number | null,
    childrenCount?: number | null,
    isLeaf?: boolean | null,
    oldVersion?: string | null,
    productLine?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteCategorySubscriptionVariables = {
  filter?: ModelSubscriptionCategoryFilterInput | null,
};

export type OnDeleteCategorySubscription = {
  onDeleteCategory?:  {
    __typename: "Category",
    id: string,
    name: string,
    description?: string | null,
    unspsc?: string | null,
    image:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    },
    imageMobile?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    visibleForUserBrand?: Array< string | null > | null,
    region?: Array< string | null > | null,
    tags?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    hasAllowables?: boolean | null,
    hasPreapproveds?: boolean | null,
    hasRestricted?: boolean | null,
    isPublic?: boolean | null,
    isTop?: boolean | null,
    createdAt?: string | null,
    slug?: string | null,
    parentId?: string | null,
    rootId?: string | null,
    path?: string | null,
    status?: string | null,
    pathIds?: Array< string | null > | null,
    source?: string | null,
    trazoCategoryId?: string | null,
    nameExternal?: string | null,
    depth?: number | null,
    childrenCount?: number | null,
    isLeaf?: boolean | null,
    oldVersion?: string | null,
    productLine?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateProductBrandSubscriptionVariables = {
  filter?: ModelSubscriptionProductBrandFilterInput | null,
};

export type OnCreateProductBrandSubscription = {
  onCreateProductBrand?:  {
    __typename: "ProductBrand",
    id: string,
    name: string,
    status?: string | null,
    description?: string | null,
    route: string,
    unspsc?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    hasAllowables?: boolean | null,
    hasPreapproveds?: boolean | null,
    hasRestricted?: boolean | null,
    isTop?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateProductBrandSubscriptionVariables = {
  filter?: ModelSubscriptionProductBrandFilterInput | null,
};

export type OnUpdateProductBrandSubscription = {
  onUpdateProductBrand?:  {
    __typename: "ProductBrand",
    id: string,
    name: string,
    status?: string | null,
    description?: string | null,
    route: string,
    unspsc?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    hasAllowables?: boolean | null,
    hasPreapproveds?: boolean | null,
    hasRestricted?: boolean | null,
    isTop?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteProductBrandSubscriptionVariables = {
  filter?: ModelSubscriptionProductBrandFilterInput | null,
};

export type OnDeleteProductBrandSubscription = {
  onDeleteProductBrand?:  {
    __typename: "ProductBrand",
    id: string,
    name: string,
    status?: string | null,
    description?: string | null,
    route: string,
    unspsc?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    hasAllowables?: boolean | null,
    hasPreapproveds?: boolean | null,
    hasRestricted?: boolean | null,
    isTop?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateCartSubscriptionVariables = {
  filter?: ModelSubscriptionCartFilterInput | null,
};

export type OnCreateCartSubscription = {
  onCreateCart?:  {
    __typename: "Cart",
    id: string,
    requirement?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    products:  Array< {
      __typename: "ProductInOrder",
      product_id: string,
      provider_id?: string | null,
      index?: number | null,
      print?: number | null,
      printPrice?: number | null,
      product_name: string,
      description?: string | null,
      category?: string | null,
      unspsc?: string | null,
      price?: number | null,
      originalPrice?: number | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      sample_authorize?: boolean | null,
      sample_authorized?: boolean | null,
      quality_requested?: boolean | null,
      quality_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      isExternal?: boolean | null,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      sku?: string | null,
      qualityForm?:  {
        __typename: "ProductInOrderQualityPGForm",
        initiativeDescription?: string | null,
        targetUser?: string | null,
        retailBrandName?: string | null,
        itemCategory?: string | null,
        itemPicture?: string | null,
        originCountry?: string | null,
        quantityPerCountryOfDist?: string | null,
        initiativeDates?: string | null,
        isPartOfAnMSOCustOrSpecPack?: string | null,
        incluesClientLogo?: string | null,
        isAReorderWithinTwelveMonths?: string | null,
        isReorder?: string | null,
        PGPLContactName?: string | null,
        ulTracking?: string | null,
        PLContactName?: string | null,
        contactEmailAddress?: string | null,
        PGPurchaseOrderNumber?: string | null,
        EBBSorSupplierProvidedProjectNumber?: string | null,
        vendorCompanyName?: string | null,
        vendorContactName?: string | null,
        vendorEmailAddress?: string | null,
        vendorJobTitle?: string | null,
        vendorTelephone?: string | null,
        vendorMailingAddress?: string | null,
        vendorCity?: string | null,
        vendorState?: string | null,
        vendorCountry?: string | null,
        vendorPC?: string | null,
        physicalItemDescription?: string | null,
        SampleOrMaterialComponentSubmitted?: string | null,
        toWhom?: string | null,
        descriptionOfItemPackagingAndArtwork?: string | null,
        regulatoryAndLegislativeProductCertification?: string | null,
        dateFinalApprovalRequestedSubmittedToPG?: string | null,
        DateOfDeclarationOfConformity?: string | null,
        dateOfApprovalExpirationOfPremiumItem?: string | null,
        itemClasification?: string | null,
        PGRepresentativeMarketingDesign?: string | null,
        PGProjectLeaderRequestor?: string | null,
        PGRestrictedItemsLocalPGLegal?: string | null,
        PGLocalCategoryGM?: string | null,
        PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
        idProduct?: string | null,
        pathDocument?: string | null,
      } | null,
      fee?: number | null,
      increment?: number | null,
      discount?: number | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
    } >,
    creator: string,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCartSubscriptionVariables = {
  filter?: ModelSubscriptionCartFilterInput | null,
};

export type OnUpdateCartSubscription = {
  onUpdateCart?:  {
    __typename: "Cart",
    id: string,
    requirement?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    products:  Array< {
      __typename: "ProductInOrder",
      product_id: string,
      provider_id?: string | null,
      index?: number | null,
      print?: number | null,
      printPrice?: number | null,
      product_name: string,
      description?: string | null,
      category?: string | null,
      unspsc?: string | null,
      price?: number | null,
      originalPrice?: number | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      sample_authorize?: boolean | null,
      sample_authorized?: boolean | null,
      quality_requested?: boolean | null,
      quality_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      isExternal?: boolean | null,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      sku?: string | null,
      qualityForm?:  {
        __typename: "ProductInOrderQualityPGForm",
        initiativeDescription?: string | null,
        targetUser?: string | null,
        retailBrandName?: string | null,
        itemCategory?: string | null,
        itemPicture?: string | null,
        originCountry?: string | null,
        quantityPerCountryOfDist?: string | null,
        initiativeDates?: string | null,
        isPartOfAnMSOCustOrSpecPack?: string | null,
        incluesClientLogo?: string | null,
        isAReorderWithinTwelveMonths?: string | null,
        isReorder?: string | null,
        PGPLContactName?: string | null,
        ulTracking?: string | null,
        PLContactName?: string | null,
        contactEmailAddress?: string | null,
        PGPurchaseOrderNumber?: string | null,
        EBBSorSupplierProvidedProjectNumber?: string | null,
        vendorCompanyName?: string | null,
        vendorContactName?: string | null,
        vendorEmailAddress?: string | null,
        vendorJobTitle?: string | null,
        vendorTelephone?: string | null,
        vendorMailingAddress?: string | null,
        vendorCity?: string | null,
        vendorState?: string | null,
        vendorCountry?: string | null,
        vendorPC?: string | null,
        physicalItemDescription?: string | null,
        SampleOrMaterialComponentSubmitted?: string | null,
        toWhom?: string | null,
        descriptionOfItemPackagingAndArtwork?: string | null,
        regulatoryAndLegislativeProductCertification?: string | null,
        dateFinalApprovalRequestedSubmittedToPG?: string | null,
        DateOfDeclarationOfConformity?: string | null,
        dateOfApprovalExpirationOfPremiumItem?: string | null,
        itemClasification?: string | null,
        PGRepresentativeMarketingDesign?: string | null,
        PGProjectLeaderRequestor?: string | null,
        PGRestrictedItemsLocalPGLegal?: string | null,
        PGLocalCategoryGM?: string | null,
        PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
        idProduct?: string | null,
        pathDocument?: string | null,
      } | null,
      fee?: number | null,
      increment?: number | null,
      discount?: number | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
    } >,
    creator: string,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCartSubscriptionVariables = {
  filter?: ModelSubscriptionCartFilterInput | null,
};

export type OnDeleteCartSubscription = {
  onDeleteCart?:  {
    __typename: "Cart",
    id: string,
    requirement?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    products:  Array< {
      __typename: "ProductInOrder",
      product_id: string,
      provider_id?: string | null,
      index?: number | null,
      print?: number | null,
      printPrice?: number | null,
      product_name: string,
      description?: string | null,
      category?: string | null,
      unspsc?: string | null,
      price?: number | null,
      originalPrice?: number | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      sample_authorize?: boolean | null,
      sample_authorized?: boolean | null,
      quality_requested?: boolean | null,
      quality_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      isExternal?: boolean | null,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      sku?: string | null,
      qualityForm?:  {
        __typename: "ProductInOrderQualityPGForm",
        initiativeDescription?: string | null,
        targetUser?: string | null,
        retailBrandName?: string | null,
        itemCategory?: string | null,
        itemPicture?: string | null,
        originCountry?: string | null,
        quantityPerCountryOfDist?: string | null,
        initiativeDates?: string | null,
        isPartOfAnMSOCustOrSpecPack?: string | null,
        incluesClientLogo?: string | null,
        isAReorderWithinTwelveMonths?: string | null,
        isReorder?: string | null,
        PGPLContactName?: string | null,
        ulTracking?: string | null,
        PLContactName?: string | null,
        contactEmailAddress?: string | null,
        PGPurchaseOrderNumber?: string | null,
        EBBSorSupplierProvidedProjectNumber?: string | null,
        vendorCompanyName?: string | null,
        vendorContactName?: string | null,
        vendorEmailAddress?: string | null,
        vendorJobTitle?: string | null,
        vendorTelephone?: string | null,
        vendorMailingAddress?: string | null,
        vendorCity?: string | null,
        vendorState?: string | null,
        vendorCountry?: string | null,
        vendorPC?: string | null,
        physicalItemDescription?: string | null,
        SampleOrMaterialComponentSubmitted?: string | null,
        toWhom?: string | null,
        descriptionOfItemPackagingAndArtwork?: string | null,
        regulatoryAndLegislativeProductCertification?: string | null,
        dateFinalApprovalRequestedSubmittedToPG?: string | null,
        DateOfDeclarationOfConformity?: string | null,
        dateOfApprovalExpirationOfPremiumItem?: string | null,
        itemClasification?: string | null,
        PGRepresentativeMarketingDesign?: string | null,
        PGProjectLeaderRequestor?: string | null,
        PGRestrictedItemsLocalPGLegal?: string | null,
        PGLocalCategoryGM?: string | null,
        PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
        idProduct?: string | null,
        pathDocument?: string | null,
      } | null,
      fee?: number | null,
      increment?: number | null,
      discount?: number | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
    } >,
    creator: string,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    id: string,
    name: string,
    role: string,
    email: string,
    jiraId?: string | null,
    phoneNumber?: string | null,
    avatar?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    companyId?: string | null,
    brandId?: string | null,
    failedLogins?: number | null,
    agents?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    notificationsOf?: Array< string | null > | null,
    status?: boolean | null,
    isLogistic?: boolean | null,
    isCoupa?: boolean | null,
    isManagement?: boolean | null,
    isAdministration?: boolean | null,
    hasNotifications?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    id: string,
    name: string,
    role: string,
    email: string,
    jiraId?: string | null,
    phoneNumber?: string | null,
    avatar?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    companyId?: string | null,
    brandId?: string | null,
    failedLogins?: number | null,
    agents?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    notificationsOf?: Array< string | null > | null,
    status?: boolean | null,
    isLogistic?: boolean | null,
    isCoupa?: boolean | null,
    isManagement?: boolean | null,
    isAdministration?: boolean | null,
    hasNotifications?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    id: string,
    name: string,
    role: string,
    email: string,
    jiraId?: string | null,
    phoneNumber?: string | null,
    avatar?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    companyId?: string | null,
    brandId?: string | null,
    failedLogins?: number | null,
    agents?:  Array< {
      __typename: "Agent",
      id?: string | null,
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
    } | null > | null,
    notificationsOf?: Array< string | null > | null,
    status?: boolean | null,
    isLogistic?: boolean | null,
    isCoupa?: boolean | null,
    isManagement?: boolean | null,
    isAdministration?: boolean | null,
    hasNotifications?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateAutomobileSubscriptionVariables = {
  filter?: ModelSubscriptionAutomobileFilterInput | null,
};

export type OnCreateAutomobileSubscription = {
  onCreateAutomobile?:  {
    __typename: "Automobile",
    id: string,
    clientId?: string | null,
    status?: boolean | null,
    bought?: boolean | null,
    buyerId?: string | null,
    buyerName?: string | null,
    price: number,
    brand: string,
    brandId?: string | null,
    model?: string | null,
    version: string,
    year: number,
    color?: string | null,
    km: number,
    transmission?: string | null,
    motor?: string | null,
    passengers?: number | null,
    state: string,
    objeto?: string | null,
    placa?: string | null,
    serialNumber?: string | null,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    star_time?: number | null,
    end_time?: number | null,
    usersInteresting?:  Array< {
      __typename: "ListUsers",
      iduser?: string | null,
      nombre?: string | null,
      email?: string | null,
      fecha_compra?: string | null,
      veces_rechazo?: string | null,
      winner?: boolean | null,
      fecha_notificacion?: string | null,
      buyer?: boolean | null,
      process_buyer?: boolean | null,
      d_winner_date?: number | null,
      created?: number | null,
    } | null > | null,
    comentario?: string | null,
    penalizacion?: string | null,
    haveWinner?: boolean | null,
    ppostulacion?: boolean | null,
    logsGanadoresAutos?:  {
      __typename: "ModelLogGanadorAutoConnection",
      items:  Array< {
        __typename: "LogGanadorAuto",
        id: string,
        id_auto?: string | null,
        id_user?: string | null,
        fecha_rifa?: number | null,
        email?: string | null,
        nombre?: string | null,
        a_paterno?: string | null,
        a_materno?: string | null,
        status_buyer?: boolean | null,
        date_buyer?: number | null,
        winner?: number | null,
        refused?: number | null,
        since?: string | null,
        process_buyer?: boolean | null,
        reactive?: boolean | null,
        created: number,
        updated?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAutomobileSubscriptionVariables = {
  filter?: ModelSubscriptionAutomobileFilterInput | null,
};

export type OnUpdateAutomobileSubscription = {
  onUpdateAutomobile?:  {
    __typename: "Automobile",
    id: string,
    clientId?: string | null,
    status?: boolean | null,
    bought?: boolean | null,
    buyerId?: string | null,
    buyerName?: string | null,
    price: number,
    brand: string,
    brandId?: string | null,
    model?: string | null,
    version: string,
    year: number,
    color?: string | null,
    km: number,
    transmission?: string | null,
    motor?: string | null,
    passengers?: number | null,
    state: string,
    objeto?: string | null,
    placa?: string | null,
    serialNumber?: string | null,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    star_time?: number | null,
    end_time?: number | null,
    usersInteresting?:  Array< {
      __typename: "ListUsers",
      iduser?: string | null,
      nombre?: string | null,
      email?: string | null,
      fecha_compra?: string | null,
      veces_rechazo?: string | null,
      winner?: boolean | null,
      fecha_notificacion?: string | null,
      buyer?: boolean | null,
      process_buyer?: boolean | null,
      d_winner_date?: number | null,
      created?: number | null,
    } | null > | null,
    comentario?: string | null,
    penalizacion?: string | null,
    haveWinner?: boolean | null,
    ppostulacion?: boolean | null,
    logsGanadoresAutos?:  {
      __typename: "ModelLogGanadorAutoConnection",
      items:  Array< {
        __typename: "LogGanadorAuto",
        id: string,
        id_auto?: string | null,
        id_user?: string | null,
        fecha_rifa?: number | null,
        email?: string | null,
        nombre?: string | null,
        a_paterno?: string | null,
        a_materno?: string | null,
        status_buyer?: boolean | null,
        date_buyer?: number | null,
        winner?: number | null,
        refused?: number | null,
        since?: string | null,
        process_buyer?: boolean | null,
        reactive?: boolean | null,
        created: number,
        updated?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAutomobileSubscriptionVariables = {
  filter?: ModelSubscriptionAutomobileFilterInput | null,
};

export type OnDeleteAutomobileSubscription = {
  onDeleteAutomobile?:  {
    __typename: "Automobile",
    id: string,
    clientId?: string | null,
    status?: boolean | null,
    bought?: boolean | null,
    buyerId?: string | null,
    buyerName?: string | null,
    price: number,
    brand: string,
    brandId?: string | null,
    model?: string | null,
    version: string,
    year: number,
    color?: string | null,
    km: number,
    transmission?: string | null,
    motor?: string | null,
    passengers?: number | null,
    state: string,
    objeto?: string | null,
    placa?: string | null,
    serialNumber?: string | null,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    star_time?: number | null,
    end_time?: number | null,
    usersInteresting?:  Array< {
      __typename: "ListUsers",
      iduser?: string | null,
      nombre?: string | null,
      email?: string | null,
      fecha_compra?: string | null,
      veces_rechazo?: string | null,
      winner?: boolean | null,
      fecha_notificacion?: string | null,
      buyer?: boolean | null,
      process_buyer?: boolean | null,
      d_winner_date?: number | null,
      created?: number | null,
    } | null > | null,
    comentario?: string | null,
    penalizacion?: string | null,
    haveWinner?: boolean | null,
    ppostulacion?: boolean | null,
    logsGanadoresAutos?:  {
      __typename: "ModelLogGanadorAutoConnection",
      items:  Array< {
        __typename: "LogGanadorAuto",
        id: string,
        id_auto?: string | null,
        id_user?: string | null,
        fecha_rifa?: number | null,
        email?: string | null,
        nombre?: string | null,
        a_paterno?: string | null,
        a_materno?: string | null,
        status_buyer?: boolean | null,
        date_buyer?: number | null,
        winner?: number | null,
        refused?: number | null,
        since?: string | null,
        process_buyer?: boolean | null,
        reactive?: boolean | null,
        created: number,
        updated?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateBrandSubscriptionVariables = {
  filter?: ModelSubscriptionBrandFilterInput | null,
};

export type OnCreateBrandSubscription = {
  onCreateBrand?:  {
    __typename: "Brand",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateBrandSubscriptionVariables = {
  filter?: ModelSubscriptionBrandFilterInput | null,
};

export type OnUpdateBrandSubscription = {
  onUpdateBrand?:  {
    __typename: "Brand",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteBrandSubscriptionVariables = {
  filter?: ModelSubscriptionBrandFilterInput | null,
};

export type OnDeleteBrandSubscription = {
  onDeleteBrand?:  {
    __typename: "Brand",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateRfqSubscriptionVariables = {
  filter?: ModelSubscriptionRfqFilterInput | null,
};

export type OnCreateRfqSubscription = {
  onCreateRfq?:  {
    __typename: "Rfq",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    proposals?:  {
      __typename: "ModelProposalsConnection",
      items:  Array< {
        __typename: "Proposals",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        priceUnit?: number | null,
        pieces?: number | null,
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "Rfq",
          id: string,
          nombre: string,
          requerimiento: string,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          orderAgentIds?: Array< string | null > | null,
          premiumOrderId?: string | null,
          estatus: string,
          orderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
          multipleProducts?: boolean | null,
          providers?: Array< string | null > | null,
        } | null,
        proposalsRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    premiumOrderId?: string | null,
    estatus: string,
    orderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    multipleProducts?: boolean | null,
    providers?: Array< string | null > | null,
    productsRfq?:  Array< {
      __typename: "ProductUnitRfq",
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
  } | null,
};

export type OnUpdateRfqSubscriptionVariables = {
  filter?: ModelSubscriptionRfqFilterInput | null,
};

export type OnUpdateRfqSubscription = {
  onUpdateRfq?:  {
    __typename: "Rfq",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    proposals?:  {
      __typename: "ModelProposalsConnection",
      items:  Array< {
        __typename: "Proposals",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        priceUnit?: number | null,
        pieces?: number | null,
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "Rfq",
          id: string,
          nombre: string,
          requerimiento: string,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          orderAgentIds?: Array< string | null > | null,
          premiumOrderId?: string | null,
          estatus: string,
          orderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
          multipleProducts?: boolean | null,
          providers?: Array< string | null > | null,
        } | null,
        proposalsRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    premiumOrderId?: string | null,
    estatus: string,
    orderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    multipleProducts?: boolean | null,
    providers?: Array< string | null > | null,
    productsRfq?:  Array< {
      __typename: "ProductUnitRfq",
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
  } | null,
};

export type OnDeleteRfqSubscriptionVariables = {
  filter?: ModelSubscriptionRfqFilterInput | null,
};

export type OnDeleteRfqSubscription = {
  onDeleteRfq?:  {
    __typename: "Rfq",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    proposals?:  {
      __typename: "ModelProposalsConnection",
      items:  Array< {
        __typename: "Proposals",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        priceUnit?: number | null,
        pieces?: number | null,
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "Rfq",
          id: string,
          nombre: string,
          requerimiento: string,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          orderAgentIds?: Array< string | null > | null,
          premiumOrderId?: string | null,
          estatus: string,
          orderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
          multipleProducts?: boolean | null,
          providers?: Array< string | null > | null,
        } | null,
        proposalsRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    premiumOrderId?: string | null,
    estatus: string,
    orderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    multipleProducts?: boolean | null,
    providers?: Array< string | null > | null,
    productsRfq?:  Array< {
      __typename: "ProductUnitRfq",
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
  } | null,
};

export type OnCreateRfqAmazonSubscriptionVariables = {
  filter?: ModelSubscriptionRfqAmazonFilterInput | null,
};

export type OnCreateRfqAmazonSubscription = {
  onCreateRfqAmazon?:  {
    __typename: "RfqAmazon",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    proposals?:  {
      __typename: "ModelProposalsAmazonConnection",
      items:  Array< {
        __typename: "ProposalsAmazon",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        priceUnit?: number | null,
        pieces?: number | null,
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "RfqAmazon",
          id: string,
          nombre: string,
          requerimiento: string,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          estatus: string,
          orderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
          multipleProducts?: boolean | null,
          providers?: Array< string | null > | null,
        } | null,
        proposalsRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    estatus: string,
    orderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    multipleProducts?: boolean | null,
    providers?: Array< string | null > | null,
    productsRfq?:  Array< {
      __typename: "ProductUnitRfq",
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
  } | null,
};

export type OnUpdateRfqAmazonSubscriptionVariables = {
  filter?: ModelSubscriptionRfqAmazonFilterInput | null,
};

export type OnUpdateRfqAmazonSubscription = {
  onUpdateRfqAmazon?:  {
    __typename: "RfqAmazon",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    proposals?:  {
      __typename: "ModelProposalsAmazonConnection",
      items:  Array< {
        __typename: "ProposalsAmazon",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        priceUnit?: number | null,
        pieces?: number | null,
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "RfqAmazon",
          id: string,
          nombre: string,
          requerimiento: string,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          estatus: string,
          orderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
          multipleProducts?: boolean | null,
          providers?: Array< string | null > | null,
        } | null,
        proposalsRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    estatus: string,
    orderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    multipleProducts?: boolean | null,
    providers?: Array< string | null > | null,
    productsRfq?:  Array< {
      __typename: "ProductUnitRfq",
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
  } | null,
};

export type OnDeleteRfqAmazonSubscriptionVariables = {
  filter?: ModelSubscriptionRfqAmazonFilterInput | null,
};

export type OnDeleteRfqAmazonSubscription = {
  onDeleteRfqAmazon?:  {
    __typename: "RfqAmazon",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    proposals?:  {
      __typename: "ModelProposalsAmazonConnection",
      items:  Array< {
        __typename: "ProposalsAmazon",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        priceUnit?: number | null,
        pieces?: number | null,
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "RfqAmazon",
          id: string,
          nombre: string,
          requerimiento: string,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          estatus: string,
          orderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
          multipleProducts?: boolean | null,
          providers?: Array< string | null > | null,
        } | null,
        proposalsRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    estatus: string,
    orderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    multipleProducts?: boolean | null,
    providers?: Array< string | null > | null,
    productsRfq?:  Array< {
      __typename: "ProductUnitRfq",
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
  } | null,
};

export type OnCreateProposalsSubscriptionVariables = {
  filter?: ModelSubscriptionProposalsFilterInput | null,
};

export type OnCreateProposalsSubscription = {
  onCreateProposals?:  {
    __typename: "Proposals",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    priceUnit?: number | null,
    pieces?: number | null,
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "Rfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsConnection",
        items:  Array< {
          __typename: "Proposals",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      premiumOrderId?: string | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null,
    proposalsRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateProposalsSubscriptionVariables = {
  filter?: ModelSubscriptionProposalsFilterInput | null,
};

export type OnUpdateProposalsSubscription = {
  onUpdateProposals?:  {
    __typename: "Proposals",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    priceUnit?: number | null,
    pieces?: number | null,
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "Rfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsConnection",
        items:  Array< {
          __typename: "Proposals",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      premiumOrderId?: string | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null,
    proposalsRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteProposalsSubscriptionVariables = {
  filter?: ModelSubscriptionProposalsFilterInput | null,
};

export type OnDeleteProposalsSubscription = {
  onDeleteProposals?:  {
    __typename: "Proposals",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    priceUnit?: number | null,
    pieces?: number | null,
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "Rfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsConnection",
        items:  Array< {
          __typename: "Proposals",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      premiumOrderId?: string | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null,
    proposalsRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateProposalsAmazonSubscriptionVariables = {
  filter?: ModelSubscriptionProposalsAmazonFilterInput | null,
};

export type OnCreateProposalsAmazonSubscription = {
  onCreateProposalsAmazon?:  {
    __typename: "ProposalsAmazon",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    priceUnit?: number | null,
    pieces?: number | null,
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "RfqAmazon",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsAmazonConnection",
        items:  Array< {
          __typename: "ProposalsAmazon",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null,
    proposalsRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateProposalsAmazonSubscriptionVariables = {
  filter?: ModelSubscriptionProposalsAmazonFilterInput | null,
};

export type OnUpdateProposalsAmazonSubscription = {
  onUpdateProposalsAmazon?:  {
    __typename: "ProposalsAmazon",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    priceUnit?: number | null,
    pieces?: number | null,
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "RfqAmazon",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsAmazonConnection",
        items:  Array< {
          __typename: "ProposalsAmazon",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null,
    proposalsRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteProposalsAmazonSubscriptionVariables = {
  filter?: ModelSubscriptionProposalsAmazonFilterInput | null,
};

export type OnDeleteProposalsAmazonSubscription = {
  onDeleteProposalsAmazon?:  {
    __typename: "ProposalsAmazon",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    priceUnit?: number | null,
    pieces?: number | null,
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "RfqAmazon",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      proposals?:  {
        __typename: "ModelProposalsAmazonConnection",
        items:  Array< {
          __typename: "ProposalsAmazon",
          id: string,
          provider_id: string,
          priceUnit?: number | null,
          pieces?: number | null,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          proposalsRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      orderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      multipleProducts?: boolean | null,
      providers?: Array< string | null > | null,
      productsRfq?:  Array< {
        __typename: "ProductUnitRfq",
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
    } | null,
    proposalsRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateProductoRfqSubscriptionVariables = {
  filter?: ModelSubscriptionProductoRfqFilterInput | null,
};

export type OnCreateProductoRfqSubscription = {
  onCreateProductoRfq?:  {
    __typename: "ProductoRfq",
    id: string,
    name: string,
    request: string,
    category_id: string,
    provider_id: string,
    price?: number | null,
    category?:  {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    } | null,
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    estatus?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateProductoRfqSubscriptionVariables = {
  filter?: ModelSubscriptionProductoRfqFilterInput | null,
};

export type OnUpdateProductoRfqSubscription = {
  onUpdateProductoRfq?:  {
    __typename: "ProductoRfq",
    id: string,
    name: string,
    request: string,
    category_id: string,
    provider_id: string,
    price?: number | null,
    category?:  {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    } | null,
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    estatus?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteProductoRfqSubscriptionVariables = {
  filter?: ModelSubscriptionProductoRfqFilterInput | null,
};

export type OnDeleteProductoRfqSubscription = {
  onDeleteProductoRfq?:  {
    __typename: "ProductoRfq",
    id: string,
    name: string,
    request: string,
    category_id: string,
    provider_id: string,
    price?: number | null,
    category?:  {
      __typename: "Category",
      id: string,
      name: string,
      description?: string | null,
      unspsc?: string | null,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      imageMobile?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      visibleForUserBrand?: Array< string | null > | null,
      region?: Array< string | null > | null,
      tags?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      hasAllowables?: boolean | null,
      hasPreapproveds?: boolean | null,
      hasRestricted?: boolean | null,
      isPublic?: boolean | null,
      isTop?: boolean | null,
      createdAt?: string | null,
      slug?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      path?: string | null,
      status?: string | null,
      pathIds?: Array< string | null > | null,
      source?: string | null,
      trazoCategoryId?: string | null,
      nameExternal?: string | null,
      depth?: number | null,
      childrenCount?: number | null,
      isLeaf?: boolean | null,
      oldVersion?: string | null,
      productLine?: string | null,
      updatedAt: string,
    } | null,
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    estatus?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateOrderProvidersSubscriptionVariables = {
  filter?: ModelSubscriptionOrderProvidersFilterInput | null,
};

export type OnCreateOrderProvidersSubscription = {
  onCreateOrderProviders?:  {
    __typename: "OrderProviders",
    id: string,
    provider_id: string,
    clientId?: string | null,
    orderId?: number | null,
    orderProvidersPremiumOrderId: string,
    payment_date?: number | null,
    gr_code?: string | null,
    invoice?: boolean | null,
    invoiceRequested?: boolean | null,
    uploadedGr?: boolean | null,
    uploadedBill?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateOrderProvidersSubscriptionVariables = {
  filter?: ModelSubscriptionOrderProvidersFilterInput | null,
};

export type OnUpdateOrderProvidersSubscription = {
  onUpdateOrderProviders?:  {
    __typename: "OrderProviders",
    id: string,
    provider_id: string,
    clientId?: string | null,
    orderId?: number | null,
    orderProvidersPremiumOrderId: string,
    payment_date?: number | null,
    gr_code?: string | null,
    invoice?: boolean | null,
    invoiceRequested?: boolean | null,
    uploadedGr?: boolean | null,
    uploadedBill?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteOrderProvidersSubscriptionVariables = {
  filter?: ModelSubscriptionOrderProvidersFilterInput | null,
};

export type OnDeleteOrderProvidersSubscription = {
  onDeleteOrderProviders?:  {
    __typename: "OrderProviders",
    id: string,
    provider_id: string,
    clientId?: string | null,
    orderId?: number | null,
    orderProvidersPremiumOrderId: string,
    payment_date?: number | null,
    gr_code?: string | null,
    invoice?: boolean | null,
    invoiceRequested?: boolean | null,
    uploadedGr?: boolean | null,
    uploadedBill?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePopMaterialSubscriptionVariables = {
  filter?: ModelSubscriptionPopMaterialFilterInput | null,
};

export type OnCreatePopMaterialSubscription = {
  onCreatePopMaterial?:  {
    __typename: "PopMaterial",
    id: string,
    name: string,
    route: string,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    year?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePopMaterialSubscriptionVariables = {
  filter?: ModelSubscriptionPopMaterialFilterInput | null,
};

export type OnUpdatePopMaterialSubscription = {
  onUpdatePopMaterial?:  {
    __typename: "PopMaterial",
    id: string,
    name: string,
    route: string,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    year?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePopMaterialSubscriptionVariables = {
  filter?: ModelSubscriptionPopMaterialFilterInput | null,
};

export type OnDeletePopMaterialSubscription = {
  onDeletePopMaterial?:  {
    __typename: "PopMaterial",
    id: string,
    name: string,
    route: string,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    year?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateVehicleTypeSubscriptionVariables = {
  filter?: ModelSubscriptionVehicleTypeFilterInput | null,
};

export type OnCreateVehicleTypeSubscription = {
  onCreateVehicleType?:  {
    __typename: "VehicleType",
    id: string,
    name: string,
    popMaterialId: string,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    popMaterial?:  {
      __typename: "PopMaterial",
      id: string,
      name: string,
      route: string,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      year?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateVehicleTypeSubscriptionVariables = {
  filter?: ModelSubscriptionVehicleTypeFilterInput | null,
};

export type OnUpdateVehicleTypeSubscription = {
  onUpdateVehicleType?:  {
    __typename: "VehicleType",
    id: string,
    name: string,
    popMaterialId: string,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    popMaterial?:  {
      __typename: "PopMaterial",
      id: string,
      name: string,
      route: string,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      year?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteVehicleTypeSubscriptionVariables = {
  filter?: ModelSubscriptionVehicleTypeFilterInput | null,
};

export type OnDeleteVehicleTypeSubscription = {
  onDeleteVehicleType?:  {
    __typename: "VehicleType",
    id: string,
    name: string,
    popMaterialId: string,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    popMaterial?:  {
      __typename: "PopMaterial",
      id: string,
      name: string,
      route: string,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      visibleFor?: Array< string | null > | null,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      year?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateVehicleSubscriptionVariables = {
  filter?: ModelSubscriptionVehicleFilterInput | null,
};

export type OnCreateVehicleSubscription = {
  onCreateVehicle?:  {
    __typename: "Vehicle",
    id: string,
    status?: string | null,
    isSustainable?: boolean | null,
    multiProvider?: boolean | null,
    itemName?: string | null,
    bestSeller?: string | null,
    name: string,
    brand: string,
    channel: string,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    description: string,
    size: string,
    materialDetail?: string | null,
    print?: string | null,
    finish?: string | null,
    packaging?: string | null,
    quantity: number,
    unitPrice: number,
    prototypePrice: number,
    productionTime: string,
    vehicleTypeId: string,
    popMaterialId: string,
    popCategoryId?: string | null,
    providerId: string,
    isRfq?: boolean | null,
    historicCost?: string | null,
    historicTime?: string | null,
    contact?: string | null,
    providerName?: string | null,
    variantsUnits?:  Array< {
      __typename: "VariantsUnits",
      min_units?: number | null,
      max_units?: number | null,
      price?: number | null,
      production_time?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    providers?: Array< string | null > | null,
    massiveLayout?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateVehicleSubscriptionVariables = {
  filter?: ModelSubscriptionVehicleFilterInput | null,
};

export type OnUpdateVehicleSubscription = {
  onUpdateVehicle?:  {
    __typename: "Vehicle",
    id: string,
    status?: string | null,
    isSustainable?: boolean | null,
    multiProvider?: boolean | null,
    itemName?: string | null,
    bestSeller?: string | null,
    name: string,
    brand: string,
    channel: string,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    description: string,
    size: string,
    materialDetail?: string | null,
    print?: string | null,
    finish?: string | null,
    packaging?: string | null,
    quantity: number,
    unitPrice: number,
    prototypePrice: number,
    productionTime: string,
    vehicleTypeId: string,
    popMaterialId: string,
    popCategoryId?: string | null,
    providerId: string,
    isRfq?: boolean | null,
    historicCost?: string | null,
    historicTime?: string | null,
    contact?: string | null,
    providerName?: string | null,
    variantsUnits?:  Array< {
      __typename: "VariantsUnits",
      min_units?: number | null,
      max_units?: number | null,
      price?: number | null,
      production_time?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    providers?: Array< string | null > | null,
    massiveLayout?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteVehicleSubscriptionVariables = {
  filter?: ModelSubscriptionVehicleFilterInput | null,
};

export type OnDeleteVehicleSubscription = {
  onDeleteVehicle?:  {
    __typename: "Vehicle",
    id: string,
    status?: string | null,
    isSustainable?: boolean | null,
    multiProvider?: boolean | null,
    itemName?: string | null,
    bestSeller?: string | null,
    name: string,
    brand: string,
    channel: string,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    description: string,
    size: string,
    materialDetail?: string | null,
    print?: string | null,
    finish?: string | null,
    packaging?: string | null,
    quantity: number,
    unitPrice: number,
    prototypePrice: number,
    productionTime: string,
    vehicleTypeId: string,
    popMaterialId: string,
    popCategoryId?: string | null,
    providerId: string,
    isRfq?: boolean | null,
    historicCost?: string | null,
    historicTime?: string | null,
    contact?: string | null,
    providerName?: string | null,
    variantsUnits?:  Array< {
      __typename: "VariantsUnits",
      min_units?: number | null,
      max_units?: number | null,
      price?: number | null,
      production_time?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    providers?: Array< string | null > | null,
    massiveLayout?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePopOrderSubscriptionVariables = {
  filter?: ModelSubscriptionPopOrderFilterInput | null,
};

export type OnCreatePopOrderSubscription = {
  onCreatePopOrder?:  {
    __typename: "PopOrder",
    id: string,
    estatus: string,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    orderId?: number | null,
    requirement?: string | null,
    budget?: number | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_time?: number | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    subtotal?: number | null,
    total?: number | null,
    isCoupa: boolean,
    sentToCoupa?: boolean | null,
    coupaOrder?: string | null,
    active?: string | null,
    vehicles?:  {
      __typename: "ModelPopOrderVehicleConnection",
      items:  Array< {
        __typename: "PopOrderVehicle",
        id: string,
        orderId: string,
        vehicleId: string,
        providerId: string,
        unitPrice: number,
        prototypePrice: number,
        quantity: number,
        approved: boolean,
        hasQrCode?: boolean | null,
        vehicle:  {
          __typename: "Vehicle",
          id: string,
          status?: string | null,
          isSustainable?: boolean | null,
          multiProvider?: boolean | null,
          itemName?: string | null,
          bestSeller?: string | null,
          name: string,
          brand: string,
          channel: string,
          description: string,
          size: string,
          materialDetail?: string | null,
          print?: string | null,
          finish?: string | null,
          packaging?: string | null,
          quantity: number,
          unitPrice: number,
          prototypePrice: number,
          productionTime: string,
          vehicleTypeId: string,
          popMaterialId: string,
          popCategoryId?: string | null,
          providerId: string,
          isRfq?: boolean | null,
          historicCost?: string | null,
          historicTime?: string | null,
          contact?: string | null,
          providerName?: string | null,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          providers?: Array< string | null > | null,
          massiveLayout?: string | null,
          created: number,
          updated?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        order:  {
          __typename: "PopOrder",
          id: string,
          estatus: string,
          orderId?: number | null,
          requirement?: string | null,
          budget?: number | null,
          delivery_cost?: number | null,
          delivery_time?: number | null,
          subtotal?: number | null,
          total?: number | null,
          isCoupa: boolean,
          sentToCoupa?: boolean | null,
          coupaOrder?: string | null,
          active?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          orderAgentIds?: Array< string | null > | null,
          gr?: string | null,
          orderCreatorId: string,
          prequoteApproved?: boolean | null,
          quoteApproved?: boolean | null,
          prototypeApproved?: boolean | null,
          samplesDocsUploaded?: boolean | null,
          samplesApproved?: boolean | null,
          auditRequired?: boolean | null,
          drivePath?: string | null,
          auditDocsUploaded?: boolean | null,
          deliveryDateRequested?: boolean | null,
          deliveryDate?: number | null,
          deliveryCode?: string | null,
          deliveryFilesUploaded?: boolean | null,
          deliveryDocsApproved?: boolean | null,
          grUploaded?: boolean | null,
          grApproved?: boolean | null,
          grCode?: string | null,
          qrCode?: boolean | null,
          brandfactoryCheck?: boolean | null,
          step?: number | null,
          prototype?: boolean | null,
          dateKickoff?: number | null,
          paymentDate?: number | null,
          currentProcess?: string | null,
          currentSubprocess?: string | null,
          clientId?: string | null,
        },
        provider:  {
          __typename: "Provider",
          id: string,
          isApproved?: boolean | null,
          comertial_name?: string | null,
          idProcter?: string | null,
          biography?: string | null,
          experience?: string | null,
          pros?: Array< string | null > | null,
          cons?: Array< string | null > | null,
          video?: string | null,
          tags?: Array< string | null > | null,
          money_filter_c?: boolean | null,
          money_filter_d?: boolean | null,
          users?: Array< string | null > | null,
          bank?: string | null,
          account?: string | null,
          clabe?: string | null,
          cuenta_correo?: string | null,
          isProvider?: boolean | null,
          sameAddress?: boolean | null,
          isPop?: boolean | null,
          isPrinted?: boolean | null,
          hasLogistic?: boolean | null,
          created?: number | null,
          updated?: number | null,
          representante_legal?: string | null,
          escritura_constitucion?: string | null,
          notario_a?: string | null,
          constituido_down_edo?: string | null,
          rrpp?: string | null,
          isPremium?: boolean | null,
          isTrustProvider?: boolean | null,
          createdAt: string,
          updatedAt: string,
        },
        sampleTestDate?: number | null,
        sampleTestDateApproved?: boolean | null,
        prototypeDate?: number | null,
        prototypeDateApproved?: boolean | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    gr?: string | null,
    orderCreatorId: string,
    providers?:  {
      __typename: "ModelPopOrderProviderConnection",
      items:  Array< {
        __typename: "PopOrderProvider",
        id: string,
        orderId: string,
        providerId: string,
        deliveryDateRequested?: boolean | null,
        grRequested?: boolean | null,
        invoiceUploaded?: boolean | null,
        order:  {
          __typename: "PopOrder",
          id: string,
          estatus: string,
          orderId?: number | null,
          requirement?: string | null,
          budget?: number | null,
          delivery_cost?: number | null,
          delivery_time?: number | null,
          subtotal?: number | null,
          total?: number | null,
          isCoupa: boolean,
          sentToCoupa?: boolean | null,
          coupaOrder?: string | null,
          active?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          orderAgentIds?: Array< string | null > | null,
          gr?: string | null,
          orderCreatorId: string,
          prequoteApproved?: boolean | null,
          quoteApproved?: boolean | null,
          prototypeApproved?: boolean | null,
          samplesDocsUploaded?: boolean | null,
          samplesApproved?: boolean | null,
          auditRequired?: boolean | null,
          drivePath?: string | null,
          auditDocsUploaded?: boolean | null,
          deliveryDateRequested?: boolean | null,
          deliveryDate?: number | null,
          deliveryCode?: string | null,
          deliveryFilesUploaded?: boolean | null,
          deliveryDocsApproved?: boolean | null,
          grUploaded?: boolean | null,
          grApproved?: boolean | null,
          grCode?: string | null,
          qrCode?: boolean | null,
          brandfactoryCheck?: boolean | null,
          step?: number | null,
          prototype?: boolean | null,
          dateKickoff?: number | null,
          paymentDate?: number | null,
          currentProcess?: string | null,
          currentSubprocess?: string | null,
          clientId?: string | null,
        },
        provider:  {
          __typename: "Provider",
          id: string,
          isApproved?: boolean | null,
          comertial_name?: string | null,
          idProcter?: string | null,
          biography?: string | null,
          experience?: string | null,
          pros?: Array< string | null > | null,
          cons?: Array< string | null > | null,
          video?: string | null,
          tags?: Array< string | null > | null,
          money_filter_c?: boolean | null,
          money_filter_d?: boolean | null,
          users?: Array< string | null > | null,
          bank?: string | null,
          account?: string | null,
          clabe?: string | null,
          cuenta_correo?: string | null,
          isProvider?: boolean | null,
          sameAddress?: boolean | null,
          isPop?: boolean | null,
          isPrinted?: boolean | null,
          hasLogistic?: boolean | null,
          created?: number | null,
          updated?: number | null,
          representante_legal?: string | null,
          escritura_constitucion?: string | null,
          notario_a?: string | null,
          constituido_down_edo?: string | null,
          rrpp?: string | null,
          isPremium?: boolean | null,
          isTrustProvider?: boolean | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    prequoteApproved?: boolean | null,
    quoteApproved?: boolean | null,
    prototypeApproved?: boolean | null,
    samplesDocsUploaded?: boolean | null,
    samplesApproved?: boolean | null,
    auditRequired?: boolean | null,
    drivePath?: string | null,
    auditDocsUploaded?: boolean | null,
    deliveryDateRequested?: boolean | null,
    deliveryDate?: number | null,
    deliveryCode?: string | null,
    deliveryFilesUploaded?: boolean | null,
    deliveryDocsApproved?: boolean | null,
    grUploaded?: boolean | null,
    grApproved?: boolean | null,
    grCode?: string | null,
    qrCode?: boolean | null,
    brandfactoryCheck?: boolean | null,
    step?: number | null,
    prototype?: boolean | null,
    dateKickoff?: number | null,
    paymentDate?: number | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    clientId?: string | null,
  } | null,
};

export type OnUpdatePopOrderSubscriptionVariables = {
  filter?: ModelSubscriptionPopOrderFilterInput | null,
};

export type OnUpdatePopOrderSubscription = {
  onUpdatePopOrder?:  {
    __typename: "PopOrder",
    id: string,
    estatus: string,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    orderId?: number | null,
    requirement?: string | null,
    budget?: number | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_time?: number | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    subtotal?: number | null,
    total?: number | null,
    isCoupa: boolean,
    sentToCoupa?: boolean | null,
    coupaOrder?: string | null,
    active?: string | null,
    vehicles?:  {
      __typename: "ModelPopOrderVehicleConnection",
      items:  Array< {
        __typename: "PopOrderVehicle",
        id: string,
        orderId: string,
        vehicleId: string,
        providerId: string,
        unitPrice: number,
        prototypePrice: number,
        quantity: number,
        approved: boolean,
        hasQrCode?: boolean | null,
        vehicle:  {
          __typename: "Vehicle",
          id: string,
          status?: string | null,
          isSustainable?: boolean | null,
          multiProvider?: boolean | null,
          itemName?: string | null,
          bestSeller?: string | null,
          name: string,
          brand: string,
          channel: string,
          description: string,
          size: string,
          materialDetail?: string | null,
          print?: string | null,
          finish?: string | null,
          packaging?: string | null,
          quantity: number,
          unitPrice: number,
          prototypePrice: number,
          productionTime: string,
          vehicleTypeId: string,
          popMaterialId: string,
          popCategoryId?: string | null,
          providerId: string,
          isRfq?: boolean | null,
          historicCost?: string | null,
          historicTime?: string | null,
          contact?: string | null,
          providerName?: string | null,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          providers?: Array< string | null > | null,
          massiveLayout?: string | null,
          created: number,
          updated?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        order:  {
          __typename: "PopOrder",
          id: string,
          estatus: string,
          orderId?: number | null,
          requirement?: string | null,
          budget?: number | null,
          delivery_cost?: number | null,
          delivery_time?: number | null,
          subtotal?: number | null,
          total?: number | null,
          isCoupa: boolean,
          sentToCoupa?: boolean | null,
          coupaOrder?: string | null,
          active?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          orderAgentIds?: Array< string | null > | null,
          gr?: string | null,
          orderCreatorId: string,
          prequoteApproved?: boolean | null,
          quoteApproved?: boolean | null,
          prototypeApproved?: boolean | null,
          samplesDocsUploaded?: boolean | null,
          samplesApproved?: boolean | null,
          auditRequired?: boolean | null,
          drivePath?: string | null,
          auditDocsUploaded?: boolean | null,
          deliveryDateRequested?: boolean | null,
          deliveryDate?: number | null,
          deliveryCode?: string | null,
          deliveryFilesUploaded?: boolean | null,
          deliveryDocsApproved?: boolean | null,
          grUploaded?: boolean | null,
          grApproved?: boolean | null,
          grCode?: string | null,
          qrCode?: boolean | null,
          brandfactoryCheck?: boolean | null,
          step?: number | null,
          prototype?: boolean | null,
          dateKickoff?: number | null,
          paymentDate?: number | null,
          currentProcess?: string | null,
          currentSubprocess?: string | null,
          clientId?: string | null,
        },
        provider:  {
          __typename: "Provider",
          id: string,
          isApproved?: boolean | null,
          comertial_name?: string | null,
          idProcter?: string | null,
          biography?: string | null,
          experience?: string | null,
          pros?: Array< string | null > | null,
          cons?: Array< string | null > | null,
          video?: string | null,
          tags?: Array< string | null > | null,
          money_filter_c?: boolean | null,
          money_filter_d?: boolean | null,
          users?: Array< string | null > | null,
          bank?: string | null,
          account?: string | null,
          clabe?: string | null,
          cuenta_correo?: string | null,
          isProvider?: boolean | null,
          sameAddress?: boolean | null,
          isPop?: boolean | null,
          isPrinted?: boolean | null,
          hasLogistic?: boolean | null,
          created?: number | null,
          updated?: number | null,
          representante_legal?: string | null,
          escritura_constitucion?: string | null,
          notario_a?: string | null,
          constituido_down_edo?: string | null,
          rrpp?: string | null,
          isPremium?: boolean | null,
          isTrustProvider?: boolean | null,
          createdAt: string,
          updatedAt: string,
        },
        sampleTestDate?: number | null,
        sampleTestDateApproved?: boolean | null,
        prototypeDate?: number | null,
        prototypeDateApproved?: boolean | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    gr?: string | null,
    orderCreatorId: string,
    providers?:  {
      __typename: "ModelPopOrderProviderConnection",
      items:  Array< {
        __typename: "PopOrderProvider",
        id: string,
        orderId: string,
        providerId: string,
        deliveryDateRequested?: boolean | null,
        grRequested?: boolean | null,
        invoiceUploaded?: boolean | null,
        order:  {
          __typename: "PopOrder",
          id: string,
          estatus: string,
          orderId?: number | null,
          requirement?: string | null,
          budget?: number | null,
          delivery_cost?: number | null,
          delivery_time?: number | null,
          subtotal?: number | null,
          total?: number | null,
          isCoupa: boolean,
          sentToCoupa?: boolean | null,
          coupaOrder?: string | null,
          active?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          orderAgentIds?: Array< string | null > | null,
          gr?: string | null,
          orderCreatorId: string,
          prequoteApproved?: boolean | null,
          quoteApproved?: boolean | null,
          prototypeApproved?: boolean | null,
          samplesDocsUploaded?: boolean | null,
          samplesApproved?: boolean | null,
          auditRequired?: boolean | null,
          drivePath?: string | null,
          auditDocsUploaded?: boolean | null,
          deliveryDateRequested?: boolean | null,
          deliveryDate?: number | null,
          deliveryCode?: string | null,
          deliveryFilesUploaded?: boolean | null,
          deliveryDocsApproved?: boolean | null,
          grUploaded?: boolean | null,
          grApproved?: boolean | null,
          grCode?: string | null,
          qrCode?: boolean | null,
          brandfactoryCheck?: boolean | null,
          step?: number | null,
          prototype?: boolean | null,
          dateKickoff?: number | null,
          paymentDate?: number | null,
          currentProcess?: string | null,
          currentSubprocess?: string | null,
          clientId?: string | null,
        },
        provider:  {
          __typename: "Provider",
          id: string,
          isApproved?: boolean | null,
          comertial_name?: string | null,
          idProcter?: string | null,
          biography?: string | null,
          experience?: string | null,
          pros?: Array< string | null > | null,
          cons?: Array< string | null > | null,
          video?: string | null,
          tags?: Array< string | null > | null,
          money_filter_c?: boolean | null,
          money_filter_d?: boolean | null,
          users?: Array< string | null > | null,
          bank?: string | null,
          account?: string | null,
          clabe?: string | null,
          cuenta_correo?: string | null,
          isProvider?: boolean | null,
          sameAddress?: boolean | null,
          isPop?: boolean | null,
          isPrinted?: boolean | null,
          hasLogistic?: boolean | null,
          created?: number | null,
          updated?: number | null,
          representante_legal?: string | null,
          escritura_constitucion?: string | null,
          notario_a?: string | null,
          constituido_down_edo?: string | null,
          rrpp?: string | null,
          isPremium?: boolean | null,
          isTrustProvider?: boolean | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    prequoteApproved?: boolean | null,
    quoteApproved?: boolean | null,
    prototypeApproved?: boolean | null,
    samplesDocsUploaded?: boolean | null,
    samplesApproved?: boolean | null,
    auditRequired?: boolean | null,
    drivePath?: string | null,
    auditDocsUploaded?: boolean | null,
    deliveryDateRequested?: boolean | null,
    deliveryDate?: number | null,
    deliveryCode?: string | null,
    deliveryFilesUploaded?: boolean | null,
    deliveryDocsApproved?: boolean | null,
    grUploaded?: boolean | null,
    grApproved?: boolean | null,
    grCode?: string | null,
    qrCode?: boolean | null,
    brandfactoryCheck?: boolean | null,
    step?: number | null,
    prototype?: boolean | null,
    dateKickoff?: number | null,
    paymentDate?: number | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    clientId?: string | null,
  } | null,
};

export type OnDeletePopOrderSubscriptionVariables = {
  filter?: ModelSubscriptionPopOrderFilterInput | null,
};

export type OnDeletePopOrderSubscription = {
  onDeletePopOrder?:  {
    __typename: "PopOrder",
    id: string,
    estatus: string,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    orderId?: number | null,
    requirement?: string | null,
    budget?: number | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_time?: number | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    subtotal?: number | null,
    total?: number | null,
    isCoupa: boolean,
    sentToCoupa?: boolean | null,
    coupaOrder?: string | null,
    active?: string | null,
    vehicles?:  {
      __typename: "ModelPopOrderVehicleConnection",
      items:  Array< {
        __typename: "PopOrderVehicle",
        id: string,
        orderId: string,
        vehicleId: string,
        providerId: string,
        unitPrice: number,
        prototypePrice: number,
        quantity: number,
        approved: boolean,
        hasQrCode?: boolean | null,
        vehicle:  {
          __typename: "Vehicle",
          id: string,
          status?: string | null,
          isSustainable?: boolean | null,
          multiProvider?: boolean | null,
          itemName?: string | null,
          bestSeller?: string | null,
          name: string,
          brand: string,
          channel: string,
          description: string,
          size: string,
          materialDetail?: string | null,
          print?: string | null,
          finish?: string | null,
          packaging?: string | null,
          quantity: number,
          unitPrice: number,
          prototypePrice: number,
          productionTime: string,
          vehicleTypeId: string,
          popMaterialId: string,
          popCategoryId?: string | null,
          providerId: string,
          isRfq?: boolean | null,
          historicCost?: string | null,
          historicTime?: string | null,
          contact?: string | null,
          providerName?: string | null,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          providers?: Array< string | null > | null,
          massiveLayout?: string | null,
          created: number,
          updated?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        order:  {
          __typename: "PopOrder",
          id: string,
          estatus: string,
          orderId?: number | null,
          requirement?: string | null,
          budget?: number | null,
          delivery_cost?: number | null,
          delivery_time?: number | null,
          subtotal?: number | null,
          total?: number | null,
          isCoupa: boolean,
          sentToCoupa?: boolean | null,
          coupaOrder?: string | null,
          active?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          orderAgentIds?: Array< string | null > | null,
          gr?: string | null,
          orderCreatorId: string,
          prequoteApproved?: boolean | null,
          quoteApproved?: boolean | null,
          prototypeApproved?: boolean | null,
          samplesDocsUploaded?: boolean | null,
          samplesApproved?: boolean | null,
          auditRequired?: boolean | null,
          drivePath?: string | null,
          auditDocsUploaded?: boolean | null,
          deliveryDateRequested?: boolean | null,
          deliveryDate?: number | null,
          deliveryCode?: string | null,
          deliveryFilesUploaded?: boolean | null,
          deliveryDocsApproved?: boolean | null,
          grUploaded?: boolean | null,
          grApproved?: boolean | null,
          grCode?: string | null,
          qrCode?: boolean | null,
          brandfactoryCheck?: boolean | null,
          step?: number | null,
          prototype?: boolean | null,
          dateKickoff?: number | null,
          paymentDate?: number | null,
          currentProcess?: string | null,
          currentSubprocess?: string | null,
          clientId?: string | null,
        },
        provider:  {
          __typename: "Provider",
          id: string,
          isApproved?: boolean | null,
          comertial_name?: string | null,
          idProcter?: string | null,
          biography?: string | null,
          experience?: string | null,
          pros?: Array< string | null > | null,
          cons?: Array< string | null > | null,
          video?: string | null,
          tags?: Array< string | null > | null,
          money_filter_c?: boolean | null,
          money_filter_d?: boolean | null,
          users?: Array< string | null > | null,
          bank?: string | null,
          account?: string | null,
          clabe?: string | null,
          cuenta_correo?: string | null,
          isProvider?: boolean | null,
          sameAddress?: boolean | null,
          isPop?: boolean | null,
          isPrinted?: boolean | null,
          hasLogistic?: boolean | null,
          created?: number | null,
          updated?: number | null,
          representante_legal?: string | null,
          escritura_constitucion?: string | null,
          notario_a?: string | null,
          constituido_down_edo?: string | null,
          rrpp?: string | null,
          isPremium?: boolean | null,
          isTrustProvider?: boolean | null,
          createdAt: string,
          updatedAt: string,
        },
        sampleTestDate?: number | null,
        sampleTestDateApproved?: boolean | null,
        prototypeDate?: number | null,
        prototypeDateApproved?: boolean | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    gr?: string | null,
    orderCreatorId: string,
    providers?:  {
      __typename: "ModelPopOrderProviderConnection",
      items:  Array< {
        __typename: "PopOrderProvider",
        id: string,
        orderId: string,
        providerId: string,
        deliveryDateRequested?: boolean | null,
        grRequested?: boolean | null,
        invoiceUploaded?: boolean | null,
        order:  {
          __typename: "PopOrder",
          id: string,
          estatus: string,
          orderId?: number | null,
          requirement?: string | null,
          budget?: number | null,
          delivery_cost?: number | null,
          delivery_time?: number | null,
          subtotal?: number | null,
          total?: number | null,
          isCoupa: boolean,
          sentToCoupa?: boolean | null,
          coupaOrder?: string | null,
          active?: string | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          orderAgentIds?: Array< string | null > | null,
          gr?: string | null,
          orderCreatorId: string,
          prequoteApproved?: boolean | null,
          quoteApproved?: boolean | null,
          prototypeApproved?: boolean | null,
          samplesDocsUploaded?: boolean | null,
          samplesApproved?: boolean | null,
          auditRequired?: boolean | null,
          drivePath?: string | null,
          auditDocsUploaded?: boolean | null,
          deliveryDateRequested?: boolean | null,
          deliveryDate?: number | null,
          deliveryCode?: string | null,
          deliveryFilesUploaded?: boolean | null,
          deliveryDocsApproved?: boolean | null,
          grUploaded?: boolean | null,
          grApproved?: boolean | null,
          grCode?: string | null,
          qrCode?: boolean | null,
          brandfactoryCheck?: boolean | null,
          step?: number | null,
          prototype?: boolean | null,
          dateKickoff?: number | null,
          paymentDate?: number | null,
          currentProcess?: string | null,
          currentSubprocess?: string | null,
          clientId?: string | null,
        },
        provider:  {
          __typename: "Provider",
          id: string,
          isApproved?: boolean | null,
          comertial_name?: string | null,
          idProcter?: string | null,
          biography?: string | null,
          experience?: string | null,
          pros?: Array< string | null > | null,
          cons?: Array< string | null > | null,
          video?: string | null,
          tags?: Array< string | null > | null,
          money_filter_c?: boolean | null,
          money_filter_d?: boolean | null,
          users?: Array< string | null > | null,
          bank?: string | null,
          account?: string | null,
          clabe?: string | null,
          cuenta_correo?: string | null,
          isProvider?: boolean | null,
          sameAddress?: boolean | null,
          isPop?: boolean | null,
          isPrinted?: boolean | null,
          hasLogistic?: boolean | null,
          created?: number | null,
          updated?: number | null,
          representante_legal?: string | null,
          escritura_constitucion?: string | null,
          notario_a?: string | null,
          constituido_down_edo?: string | null,
          rrpp?: string | null,
          isPremium?: boolean | null,
          isTrustProvider?: boolean | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    prequoteApproved?: boolean | null,
    quoteApproved?: boolean | null,
    prototypeApproved?: boolean | null,
    samplesDocsUploaded?: boolean | null,
    samplesApproved?: boolean | null,
    auditRequired?: boolean | null,
    drivePath?: string | null,
    auditDocsUploaded?: boolean | null,
    deliveryDateRequested?: boolean | null,
    deliveryDate?: number | null,
    deliveryCode?: string | null,
    deliveryFilesUploaded?: boolean | null,
    deliveryDocsApproved?: boolean | null,
    grUploaded?: boolean | null,
    grApproved?: boolean | null,
    grCode?: string | null,
    qrCode?: boolean | null,
    brandfactoryCheck?: boolean | null,
    step?: number | null,
    prototype?: boolean | null,
    dateKickoff?: number | null,
    paymentDate?: number | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    clientId?: string | null,
  } | null,
};

export type OnCreateOrderFileSubscriptionVariables = {
  filter?: ModelSubscriptionOrderFileFilterInput | null,
};

export type OnCreateOrderFileSubscription = {
  onCreateOrderFile?:  {
    __typename: "OrderFile",
    id: string,
    createdAt?: string | null,
    creatorId: string,
    orderId: string,
    key?: string | null,
    url?: string | null,
    orderStatus: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateOrderFileSubscriptionVariables = {
  filter?: ModelSubscriptionOrderFileFilterInput | null,
};

export type OnUpdateOrderFileSubscription = {
  onUpdateOrderFile?:  {
    __typename: "OrderFile",
    id: string,
    createdAt?: string | null,
    creatorId: string,
    orderId: string,
    key?: string | null,
    url?: string | null,
    orderStatus: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteOrderFileSubscriptionVariables = {
  filter?: ModelSubscriptionOrderFileFilterInput | null,
};

export type OnDeleteOrderFileSubscription = {
  onDeleteOrderFile?:  {
    __typename: "OrderFile",
    id: string,
    createdAt?: string | null,
    creatorId: string,
    orderId: string,
    key?: string | null,
    url?: string | null,
    orderStatus: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePopOrderVehicleSubscriptionVariables = {
  filter?: ModelSubscriptionPopOrderVehicleFilterInput | null,
};

export type OnCreatePopOrderVehicleSubscription = {
  onCreatePopOrderVehicle?:  {
    __typename: "PopOrderVehicle",
    id: string,
    orderId: string,
    vehicleId: string,
    providerId: string,
    unitPrice: number,
    prototypePrice: number,
    quantity: number,
    approved: boolean,
    hasQrCode?: boolean | null,
    vehicle:  {
      __typename: "Vehicle",
      id: string,
      status?: string | null,
      isSustainable?: boolean | null,
      multiProvider?: boolean | null,
      itemName?: string | null,
      bestSeller?: string | null,
      name: string,
      brand: string,
      channel: string,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      description: string,
      size: string,
      materialDetail?: string | null,
      print?: string | null,
      finish?: string | null,
      packaging?: string | null,
      quantity: number,
      unitPrice: number,
      prototypePrice: number,
      productionTime: string,
      vehicleTypeId: string,
      popMaterialId: string,
      popCategoryId?: string | null,
      providerId: string,
      isRfq?: boolean | null,
      historicCost?: string | null,
      historicTime?: string | null,
      contact?: string | null,
      providerName?: string | null,
      variantsUnits?:  Array< {
        __typename: "VariantsUnits",
        min_units?: number | null,
        max_units?: number | null,
        price?: number | null,
        production_time?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      massiveLayout?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    order:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    },
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    sampleTestDate?: number | null,
    sampleTestDateApproved?: boolean | null,
    prototypeDate?: number | null,
    prototypeDateApproved?: boolean | null,
    logs?:  Array< {
      __typename: "ProductInOrderLog",
      product_id: string,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePopOrderVehicleSubscriptionVariables = {
  filter?: ModelSubscriptionPopOrderVehicleFilterInput | null,
};

export type OnUpdatePopOrderVehicleSubscription = {
  onUpdatePopOrderVehicle?:  {
    __typename: "PopOrderVehicle",
    id: string,
    orderId: string,
    vehicleId: string,
    providerId: string,
    unitPrice: number,
    prototypePrice: number,
    quantity: number,
    approved: boolean,
    hasQrCode?: boolean | null,
    vehicle:  {
      __typename: "Vehicle",
      id: string,
      status?: string | null,
      isSustainable?: boolean | null,
      multiProvider?: boolean | null,
      itemName?: string | null,
      bestSeller?: string | null,
      name: string,
      brand: string,
      channel: string,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      description: string,
      size: string,
      materialDetail?: string | null,
      print?: string | null,
      finish?: string | null,
      packaging?: string | null,
      quantity: number,
      unitPrice: number,
      prototypePrice: number,
      productionTime: string,
      vehicleTypeId: string,
      popMaterialId: string,
      popCategoryId?: string | null,
      providerId: string,
      isRfq?: boolean | null,
      historicCost?: string | null,
      historicTime?: string | null,
      contact?: string | null,
      providerName?: string | null,
      variantsUnits?:  Array< {
        __typename: "VariantsUnits",
        min_units?: number | null,
        max_units?: number | null,
        price?: number | null,
        production_time?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      massiveLayout?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    order:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    },
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    sampleTestDate?: number | null,
    sampleTestDateApproved?: boolean | null,
    prototypeDate?: number | null,
    prototypeDateApproved?: boolean | null,
    logs?:  Array< {
      __typename: "ProductInOrderLog",
      product_id: string,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePopOrderVehicleSubscriptionVariables = {
  filter?: ModelSubscriptionPopOrderVehicleFilterInput | null,
};

export type OnDeletePopOrderVehicleSubscription = {
  onDeletePopOrderVehicle?:  {
    __typename: "PopOrderVehicle",
    id: string,
    orderId: string,
    vehicleId: string,
    providerId: string,
    unitPrice: number,
    prototypePrice: number,
    quantity: number,
    approved: boolean,
    hasQrCode?: boolean | null,
    vehicle:  {
      __typename: "Vehicle",
      id: string,
      status?: string | null,
      isSustainable?: boolean | null,
      multiProvider?: boolean | null,
      itemName?: string | null,
      bestSeller?: string | null,
      name: string,
      brand: string,
      channel: string,
      images:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } >,
      description: string,
      size: string,
      materialDetail?: string | null,
      print?: string | null,
      finish?: string | null,
      packaging?: string | null,
      quantity: number,
      unitPrice: number,
      prototypePrice: number,
      productionTime: string,
      vehicleTypeId: string,
      popMaterialId: string,
      popCategoryId?: string | null,
      providerId: string,
      isRfq?: boolean | null,
      historicCost?: string | null,
      historicTime?: string | null,
      contact?: string | null,
      providerName?: string | null,
      variantsUnits?:  Array< {
        __typename: "VariantsUnits",
        min_units?: number | null,
        max_units?: number | null,
        price?: number | null,
        production_time?: number | null,
      } | null > | null,
      visibleFor?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      massiveLayout?: string | null,
      created: number,
      updated?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    order:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    },
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    sampleTestDate?: number | null,
    sampleTestDateApproved?: boolean | null,
    prototypeDate?: number | null,
    prototypeDateApproved?: boolean | null,
    logs?:  Array< {
      __typename: "ProductInOrderLog",
      product_id: string,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePopOrderAuthorizerSubscriptionVariables = {
  filter?: ModelSubscriptionPopOrderAuthorizerFilterInput | null,
};

export type OnCreatePopOrderAuthorizerSubscription = {
  onCreatePopOrderAuthorizer?:  {
    __typename: "PopOrderAuthorizer",
    id: string,
    userId: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePopOrderAuthorizerSubscriptionVariables = {
  filter?: ModelSubscriptionPopOrderAuthorizerFilterInput | null,
};

export type OnUpdatePopOrderAuthorizerSubscription = {
  onUpdatePopOrderAuthorizer?:  {
    __typename: "PopOrderAuthorizer",
    id: string,
    userId: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePopOrderAuthorizerSubscriptionVariables = {
  filter?: ModelSubscriptionPopOrderAuthorizerFilterInput | null,
};

export type OnDeletePopOrderAuthorizerSubscription = {
  onDeletePopOrderAuthorizer?:  {
    __typename: "PopOrderAuthorizer",
    id: string,
    userId: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePopOrderProviderSubscriptionVariables = {
  filter?: ModelSubscriptionPopOrderProviderFilterInput | null,
};

export type OnCreatePopOrderProviderSubscription = {
  onCreatePopOrderProvider?:  {
    __typename: "PopOrderProvider",
    id: string,
    orderId: string,
    providerId: string,
    deliveryDateRequested?: boolean | null,
    grRequested?: boolean | null,
    invoiceUploaded?: boolean | null,
    order:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    },
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdatePopOrderProviderSubscriptionVariables = {
  filter?: ModelSubscriptionPopOrderProviderFilterInput | null,
};

export type OnUpdatePopOrderProviderSubscription = {
  onUpdatePopOrderProvider?:  {
    __typename: "PopOrderProvider",
    id: string,
    orderId: string,
    providerId: string,
    deliveryDateRequested?: boolean | null,
    grRequested?: boolean | null,
    invoiceUploaded?: boolean | null,
    order:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    },
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeletePopOrderProviderSubscriptionVariables = {
  filter?: ModelSubscriptionPopOrderProviderFilterInput | null,
};

export type OnDeletePopOrderProviderSubscription = {
  onDeletePopOrderProvider?:  {
    __typename: "PopOrderProvider",
    id: string,
    orderId: string,
    providerId: string,
    deliveryDateRequested?: boolean | null,
    grRequested?: boolean | null,
    invoiceUploaded?: boolean | null,
    order:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    },
    provider:  {
      __typename: "Provider",
      id: string,
      isApproved?: boolean | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comertial_name?: string | null,
      bussiness_name?:  {
        __typename: "BusinessName",
        tax_residence?:  {
          __typename: "Address",
          street?: string | null,
          outdoor_number?: string | null,
          inside_number?: string | null,
          colony?: string | null,
          delegation?: string | null,
          state?: string | null,
          city?: string | null,
          postal_code?: string | null,
          chain?: string | null,
          name?: string | null,
          description?: string | null,
        } | null,
        rfc?: string | null,
        name?: string | null,
      } | null,
      idProcter?: string | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      biography?: string | null,
      constancia?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      comprobante?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      experience?: string | null,
      pros?: Array< string | null > | null,
      cons?: Array< string | null > | null,
      cte_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      shopping_rating?:  Array< {
        __typename: "Rating",
        name?: string | null,
        rating?: number | null,
      } | null > | null,
      video?: string | null,
      tags?: Array< string | null > | null,
      money_filter_c?: boolean | null,
      money_filter_d?: boolean | null,
      users?: Array< string | null > | null,
      bank?: string | null,
      account?: string | null,
      clabe?: string | null,
      cuenta_correo?: string | null,
      edocuenta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      ife?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      poderes?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      acta?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      isProvider?: boolean | null,
      sameAddress?: boolean | null,
      isPop?: boolean | null,
      isPrinted?: boolean | null,
      hasLogistic?: boolean | null,
      created?: number | null,
      updated?: number | null,
      addFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      signFiles?:  Array< {
        __typename: "SignFile",
        key?: string | null,
        url?: string | null,
        sign?: string | null,
        status?: string | null,
      } | null > | null,
      representante_legal?: string | null,
      escritura_constitucion?: string | null,
      notario_a?: string | null,
      constituido_down_edo?: string | null,
      rrpp?: string | null,
      isPremium?: boolean | null,
      isTrustProvider?: boolean | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreatePopOrderLogSubscriptionVariables = {
  filter?: ModelSubscriptionPopOrderLogFilterInput | null,
};

export type OnCreatePopOrderLogSubscription = {
  onCreatePopOrderLog?:  {
    __typename: "PopOrderLog",
    id: string,
    orderId: string,
    creatorId: string,
    order?:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    } | null,
    createdAt?: string | null,
    text: string,
    orderStatus: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePopOrderLogSubscriptionVariables = {
  filter?: ModelSubscriptionPopOrderLogFilterInput | null,
};

export type OnUpdatePopOrderLogSubscription = {
  onUpdatePopOrderLog?:  {
    __typename: "PopOrderLog",
    id: string,
    orderId: string,
    creatorId: string,
    order?:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    } | null,
    createdAt?: string | null,
    text: string,
    orderStatus: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePopOrderLogSubscriptionVariables = {
  filter?: ModelSubscriptionPopOrderLogFilterInput | null,
};

export type OnDeletePopOrderLogSubscription = {
  onDeletePopOrderLog?:  {
    __typename: "PopOrderLog",
    id: string,
    orderId: string,
    creatorId: string,
    order?:  {
      __typename: "PopOrder",
      id: string,
      estatus: string,
      comments?:  Array< {
        __typename: "Comment",
        text: string,
        created: number,
        creator_id: string,
        creator_name: string,
        creator_email: string,
        isSourceDataUser: boolean,
        creator_avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          comertial_name: string,
          id: string,
        } | null,
        replyTo?: string | null,
        role?: string | null,
        text_request?: string | null,
        nameUserReply?: string | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        jiraKey?: string | null,
      } | null > | null,
      orderId?: number | null,
      requirement?: string | null,
      budget?: number | null,
      delivery_addresses?:  Array< {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null > | null,
      delivery_cost?: number | null,
      delivery_time?: number | null,
      files?:  Array< {
        __typename: "ListFiles",
        created: number,
        creator_id: string,
        file:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        },
        status?: string | null,
        statusFile?: string | null,
        name: string,
        provider_id?: string | null,
        product_id?: string | null,
        tracking_code?: string | null,
        gr_code?: string | null,
        coupa_order?: string | null,
        description?: string | null,
      } | null > | null,
      contact?:  {
        __typename: "OrderContact",
        name: string,
        tel: string,
      } | null,
      subtotal?: number | null,
      total?: number | null,
      isCoupa: boolean,
      sentToCoupa?: boolean | null,
      coupaOrder?: string | null,
      active?: string | null,
      vehicles?:  {
        __typename: "ModelPopOrderVehicleConnection",
        items:  Array< {
          __typename: "PopOrderVehicle",
          id: string,
          orderId: string,
          vehicleId: string,
          providerId: string,
          unitPrice: number,
          prototypePrice: number,
          quantity: number,
          approved: boolean,
          hasQrCode?: boolean | null,
          sampleTestDate?: number | null,
          sampleTestDateApproved?: boolean | null,
          prototypeDate?: number | null,
          prototypeDateApproved?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      gr?: string | null,
      orderCreatorId: string,
      providers?:  {
        __typename: "ModelPopOrderProviderConnection",
        items:  Array< {
          __typename: "PopOrderProvider",
          id: string,
          orderId: string,
          providerId: string,
          deliveryDateRequested?: boolean | null,
          grRequested?: boolean | null,
          invoiceUploaded?: boolean | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      prequoteApproved?: boolean | null,
      quoteApproved?: boolean | null,
      prototypeApproved?: boolean | null,
      samplesDocsUploaded?: boolean | null,
      samplesApproved?: boolean | null,
      auditRequired?: boolean | null,
      drivePath?: string | null,
      auditDocsUploaded?: boolean | null,
      deliveryDateRequested?: boolean | null,
      deliveryDate?: number | null,
      deliveryCode?: string | null,
      deliveryFilesUploaded?: boolean | null,
      deliveryDocsApproved?: boolean | null,
      grUploaded?: boolean | null,
      grApproved?: boolean | null,
      grCode?: string | null,
      qrCode?: boolean | null,
      brandfactoryCheck?: boolean | null,
      step?: number | null,
      prototype?: boolean | null,
      dateKickoff?: number | null,
      paymentDate?: number | null,
      currentProcess?: string | null,
      currentSubprocess?: string | null,
      clientId?: string | null,
    } | null,
    createdAt?: string | null,
    text: string,
    orderStatus: string,
    updatedAt: string,
  } | null,
};

export type OnCreateRfqPopSubscriptionVariables = {
  filter?: ModelSubscriptionRfqPopFilterInput | null,
};

export type OnCreateRfqPopSubscription = {
  onCreateRfqPop?:  {
    __typename: "RfqPop",
    id: string,
    nombre: string,
    requerimiento: string,
    vehicleTypeId?: string | null,
    popMaterialId?: string | null,
    vehiclesRfq?:  Array< {
      __typename: "VehicleUnitRfq",
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    proposals?:  {
      __typename: "ModelProposalsPopConnection",
      items:  Array< {
        __typename: "ProposalsPop",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        created: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        vehicles?:  Array< {
          __typename: "VehiclesProposalsPop",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          popMaterialId?: string | null,
          vehicleTypeId?: string | null,
          brand?: string | null,
          size?: string | null,
          description?: string | null,
          quantity?: number | null,
          packaging?: string | null,
          materialDetail?: string | null,
          print?: string | null,
          unitPrice?: number | null,
          pieces?: number | null,
          priceUnit?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        rfq?:  {
          __typename: "RfqPop",
          id: string,
          nombre: string,
          requerimiento: string,
          vehicleTypeId?: string | null,
          popMaterialId?: string | null,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId?: string | null,
          orderAgentIds?: Array< string | null > | null,
          popOrderId?: string | null,
          orderId?: number | null,
          estatus: string,
          start_time: number,
          delivery_time?: number | null,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          budget?: number | null,
          hasQrCode?: boolean | null,
          created: number,
          createdAt?: string | null,
          updated?: number | null,
          updatedAt: string,
        } | null,
        proposalsPopRfqId?: string | null,
        prototypePrice: number,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    clientId?: string | null,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    providers?:  Array< {
      __typename: "RfqPopProviders",
      idProvider?: string | null,
    } | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    popOrderId?: string | null,
    orderId?: number | null,
    estatus: string,
    start_time: number,
    delivery_time?: number | null,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    budget?: number | null,
    hasQrCode?: boolean | null,
    created: number,
    createdAt?: string | null,
    updated?: number | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateRfqPopSubscriptionVariables = {
  filter?: ModelSubscriptionRfqPopFilterInput | null,
};

export type OnUpdateRfqPopSubscription = {
  onUpdateRfqPop?:  {
    __typename: "RfqPop",
    id: string,
    nombre: string,
    requerimiento: string,
    vehicleTypeId?: string | null,
    popMaterialId?: string | null,
    vehiclesRfq?:  Array< {
      __typename: "VehicleUnitRfq",
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    proposals?:  {
      __typename: "ModelProposalsPopConnection",
      items:  Array< {
        __typename: "ProposalsPop",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        created: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        vehicles?:  Array< {
          __typename: "VehiclesProposalsPop",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          popMaterialId?: string | null,
          vehicleTypeId?: string | null,
          brand?: string | null,
          size?: string | null,
          description?: string | null,
          quantity?: number | null,
          packaging?: string | null,
          materialDetail?: string | null,
          print?: string | null,
          unitPrice?: number | null,
          pieces?: number | null,
          priceUnit?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        rfq?:  {
          __typename: "RfqPop",
          id: string,
          nombre: string,
          requerimiento: string,
          vehicleTypeId?: string | null,
          popMaterialId?: string | null,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId?: string | null,
          orderAgentIds?: Array< string | null > | null,
          popOrderId?: string | null,
          orderId?: number | null,
          estatus: string,
          start_time: number,
          delivery_time?: number | null,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          budget?: number | null,
          hasQrCode?: boolean | null,
          created: number,
          createdAt?: string | null,
          updated?: number | null,
          updatedAt: string,
        } | null,
        proposalsPopRfqId?: string | null,
        prototypePrice: number,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    clientId?: string | null,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    providers?:  Array< {
      __typename: "RfqPopProviders",
      idProvider?: string | null,
    } | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    popOrderId?: string | null,
    orderId?: number | null,
    estatus: string,
    start_time: number,
    delivery_time?: number | null,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    budget?: number | null,
    hasQrCode?: boolean | null,
    created: number,
    createdAt?: string | null,
    updated?: number | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteRfqPopSubscriptionVariables = {
  filter?: ModelSubscriptionRfqPopFilterInput | null,
};

export type OnDeleteRfqPopSubscription = {
  onDeleteRfqPop?:  {
    __typename: "RfqPop",
    id: string,
    nombre: string,
    requerimiento: string,
    vehicleTypeId?: string | null,
    popMaterialId?: string | null,
    vehiclesRfq?:  Array< {
      __typename: "VehicleUnitRfq",
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      name?: string | null,
      description?: string | null,
      pieces?: number | null,
      createdId?: number | null,
    } | null > | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    cantidad: number,
    limit_time: number,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    proposals?:  {
      __typename: "ModelProposalsPopConnection",
      items:  Array< {
        __typename: "ProposalsPop",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        created: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        vehicles?:  Array< {
          __typename: "VehiclesProposalsPop",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          popMaterialId?: string | null,
          vehicleTypeId?: string | null,
          brand?: string | null,
          size?: string | null,
          description?: string | null,
          quantity?: number | null,
          packaging?: string | null,
          materialDetail?: string | null,
          print?: string | null,
          unitPrice?: number | null,
          pieces?: number | null,
          priceUnit?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        rfq?:  {
          __typename: "RfqPop",
          id: string,
          nombre: string,
          requerimiento: string,
          vehicleTypeId?: string | null,
          popMaterialId?: string | null,
          cantidad: number,
          limit_time: number,
          creator?: string | null,
          clientId?: string | null,
          orderAgentIds?: Array< string | null > | null,
          popOrderId?: string | null,
          orderId?: number | null,
          estatus: string,
          start_time: number,
          delivery_time?: number | null,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          budget?: number | null,
          hasQrCode?: boolean | null,
          created: number,
          createdAt?: string | null,
          updated?: number | null,
          updatedAt: string,
        } | null,
        proposalsPopRfqId?: string | null,
        prototypePrice: number,
        hidden?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    clientId?: string | null,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    providers?:  Array< {
      __typename: "RfqPopProviders",
      idProvider?: string | null,
    } | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    popOrderId?: string | null,
    orderId?: number | null,
    estatus: string,
    start_time: number,
    delivery_time?: number | null,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    budget?: number | null,
    hasQrCode?: boolean | null,
    created: number,
    createdAt?: string | null,
    updated?: number | null,
    updatedAt: string,
  } | null,
};

export type OnCreateProposalsPopSubscriptionVariables = {
  filter?: ModelSubscriptionProposalsPopFilterInput | null,
};

export type OnCreateProposalsPopSubscription = {
  onCreateProposalsPop?:  {
    __typename: "ProposalsPop",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    created: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    vehicles?:  Array< {
      __typename: "VehiclesProposalsPop",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      popMaterialId?: string | null,
      vehicleTypeId?: string | null,
      brand?: string | null,
      size?: string | null,
      description?: string | null,
      quantity?: number | null,
      packaging?: string | null,
      materialDetail?: string | null,
      print?: string | null,
      unitPrice?: number | null,
      pieces?: number | null,
      priceUnit?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    rfq?:  {
      __typename: "RfqPop",
      id: string,
      nombre: string,
      requerimiento: string,
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      vehiclesRfq?:  Array< {
        __typename: "VehicleUnitRfq",
        vehicleTypeId?: string | null,
        popMaterialId?: string | null,
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      proposals?:  {
        __typename: "ModelProposalsPopConnection",
        items:  Array< {
          __typename: "ProposalsPop",
          id: string,
          provider_id: string,
          price: number,
          created: number,
          validity_days?: number | null,
          description?: string | null,
          updated?: number | null,
          proposalsPopRfqId?: string | null,
          prototypePrice: number,
          hidden?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      clientId?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfqPopProviders",
        idProvider?: string | null,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      popOrderId?: string | null,
      orderId?: number | null,
      estatus: string,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      budget?: number | null,
      hasQrCode?: boolean | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null,
    proposalsPopRfqId?: string | null,
    prototypePrice: number,
    hidden?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateProposalsPopSubscriptionVariables = {
  filter?: ModelSubscriptionProposalsPopFilterInput | null,
};

export type OnUpdateProposalsPopSubscription = {
  onUpdateProposalsPop?:  {
    __typename: "ProposalsPop",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    created: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    vehicles?:  Array< {
      __typename: "VehiclesProposalsPop",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      popMaterialId?: string | null,
      vehicleTypeId?: string | null,
      brand?: string | null,
      size?: string | null,
      description?: string | null,
      quantity?: number | null,
      packaging?: string | null,
      materialDetail?: string | null,
      print?: string | null,
      unitPrice?: number | null,
      pieces?: number | null,
      priceUnit?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    rfq?:  {
      __typename: "RfqPop",
      id: string,
      nombre: string,
      requerimiento: string,
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      vehiclesRfq?:  Array< {
        __typename: "VehicleUnitRfq",
        vehicleTypeId?: string | null,
        popMaterialId?: string | null,
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      proposals?:  {
        __typename: "ModelProposalsPopConnection",
        items:  Array< {
          __typename: "ProposalsPop",
          id: string,
          provider_id: string,
          price: number,
          created: number,
          validity_days?: number | null,
          description?: string | null,
          updated?: number | null,
          proposalsPopRfqId?: string | null,
          prototypePrice: number,
          hidden?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      clientId?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfqPopProviders",
        idProvider?: string | null,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      popOrderId?: string | null,
      orderId?: number | null,
      estatus: string,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      budget?: number | null,
      hasQrCode?: boolean | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null,
    proposalsPopRfqId?: string | null,
    prototypePrice: number,
    hidden?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteProposalsPopSubscriptionVariables = {
  filter?: ModelSubscriptionProposalsPopFilterInput | null,
};

export type OnDeleteProposalsPopSubscription = {
  onDeleteProposalsPop?:  {
    __typename: "ProposalsPop",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    created: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    vehicles?:  Array< {
      __typename: "VehiclesProposalsPop",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      popMaterialId?: string | null,
      vehicleTypeId?: string | null,
      brand?: string | null,
      size?: string | null,
      description?: string | null,
      quantity?: number | null,
      packaging?: string | null,
      materialDetail?: string | null,
      print?: string | null,
      unitPrice?: number | null,
      pieces?: number | null,
      priceUnit?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    rfq?:  {
      __typename: "RfqPop",
      id: string,
      nombre: string,
      requerimiento: string,
      vehicleTypeId?: string | null,
      popMaterialId?: string | null,
      vehiclesRfq?:  Array< {
        __typename: "VehicleUnitRfq",
        vehicleTypeId?: string | null,
        popMaterialId?: string | null,
        name?: string | null,
        description?: string | null,
        pieces?: number | null,
        createdId?: number | null,
      } | null > | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      cantidad: number,
      limit_time: number,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      proposals?:  {
        __typename: "ModelProposalsPopConnection",
        items:  Array< {
          __typename: "ProposalsPop",
          id: string,
          provider_id: string,
          price: number,
          created: number,
          validity_days?: number | null,
          description?: string | null,
          updated?: number | null,
          proposalsPopRfqId?: string | null,
          prototypePrice: number,
          hidden?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      clientId?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfqPopProviders",
        idProvider?: string | null,
      } | null > | null,
      orderAgents?:  Array< {
        __typename: "OrderAgent",
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id?: string | null,
      } | null > | null,
      orderAgentIds?: Array< string | null > | null,
      popOrderId?: string | null,
      orderId?: number | null,
      estatus: string,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      budget?: number | null,
      hasQrCode?: boolean | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null,
    proposalsPopRfqId?: string | null,
    prototypePrice: number,
    hidden?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUsersBrandsSubscriptionVariables = {
  filter?: ModelSubscriptionUsersBrandsFilterInput | null,
};

export type OnCreateUsersBrandsSubscription = {
  onCreateUsersBrands?:  {
    __typename: "UsersBrands",
    id: string,
    name: string,
    description?: string | null,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    status?: string | null,
    clientId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUsersBrandsSubscriptionVariables = {
  filter?: ModelSubscriptionUsersBrandsFilterInput | null,
};

export type OnUpdateUsersBrandsSubscription = {
  onUpdateUsersBrands?:  {
    __typename: "UsersBrands",
    id: string,
    name: string,
    description?: string | null,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    status?: string | null,
    clientId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUsersBrandsSubscriptionVariables = {
  filter?: ModelSubscriptionUsersBrandsFilterInput | null,
};

export type OnDeleteUsersBrandsSubscription = {
  onDeleteUsersBrands?:  {
    __typename: "UsersBrands",
    id: string,
    name: string,
    description?: string | null,
    logo?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    status?: string | null,
    clientId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserBrandSettingSubscriptionVariables = {
  filter?: ModelSubscriptionUserBrandSettingFilterInput | null,
};

export type OnCreateUserBrandSettingSubscription = {
  onCreateUserBrandSetting?:  {
    __typename: "UserBrandSetting",
    id: string,
    categories?: Array< string | null > | null,
    subcategories?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserBrandSettingSubscriptionVariables = {
  filter?: ModelSubscriptionUserBrandSettingFilterInput | null,
};

export type OnUpdateUserBrandSettingSubscription = {
  onUpdateUserBrandSetting?:  {
    __typename: "UserBrandSetting",
    id: string,
    categories?: Array< string | null > | null,
    subcategories?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserBrandSettingSubscriptionVariables = {
  filter?: ModelSubscriptionUserBrandSettingFilterInput | null,
};

export type OnDeleteUserBrandSettingSubscription = {
  onDeleteUserBrandSetting?:  {
    __typename: "UserBrandSetting",
    id: string,
    categories?: Array< string | null > | null,
    subcategories?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateLogsPUsersSubscriptionVariables = {
  filter?: ModelSubscriptionLogsPUsersFilterInput | null,
};

export type OnCreateLogsPUsersSubscription = {
  onCreateLogsPUsers?:  {
    __typename: "LogsPUsers",
    id: string,
    user?: string | null,
    keyword?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateLogsPUsersSubscriptionVariables = {
  filter?: ModelSubscriptionLogsPUsersFilterInput | null,
};

export type OnUpdateLogsPUsersSubscription = {
  onUpdateLogsPUsers?:  {
    __typename: "LogsPUsers",
    id: string,
    user?: string | null,
    keyword?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteLogsPUsersSubscriptionVariables = {
  filter?: ModelSubscriptionLogsPUsersFilterInput | null,
};

export type OnDeleteLogsPUsersSubscription = {
  onDeleteLogsPUsers?:  {
    __typename: "LogsPUsers",
    id: string,
    user?: string | null,
    keyword?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateClipPaymentSubscriptionVariables = {
  filter?: ModelSubscriptionClipPaymentFilterInput | null,
};

export type OnCreateClipPaymentSubscription = {
  onCreateClipPayment?:  {
    __typename: "ClipPayment",
    id: string,
    status?: string | null,
    requestsCount?: number | null,
    payment_request_id?: string | null,
    purchase_description?: string | null,
    orderId: string,
    clientId: string,
    userId: string,
    creator?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateClipPaymentSubscriptionVariables = {
  filter?: ModelSubscriptionClipPaymentFilterInput | null,
};

export type OnUpdateClipPaymentSubscription = {
  onUpdateClipPayment?:  {
    __typename: "ClipPayment",
    id: string,
    status?: string | null,
    requestsCount?: number | null,
    payment_request_id?: string | null,
    purchase_description?: string | null,
    orderId: string,
    clientId: string,
    userId: string,
    creator?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteClipPaymentSubscriptionVariables = {
  filter?: ModelSubscriptionClipPaymentFilterInput | null,
};

export type OnDeleteClipPaymentSubscription = {
  onDeleteClipPayment?:  {
    __typename: "ClipPayment",
    id: string,
    status?: string | null,
    requestsCount?: number | null,
    payment_request_id?: string | null,
    purchase_description?: string | null,
    orderId: string,
    clientId: string,
    userId: string,
    creator?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateOrderProcessSubscriptionVariables = {
  filter?: ModelSubscriptionOrderProcessFilterInput | null,
};

export type OnCreateOrderProcessSubscription = {
  onCreateOrderProcess?:  {
    __typename: "OrderProcess",
    id: string,
    type?: string | null,
    status?: boolean | null,
    tcdPayment?: boolean | null,
    name: string,
    duration?: string | null,
    descripcion?: string | null,
    position: number,
    responsible?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    cards?:  Array< {
      __typename: "OrderCards",
      id?: string | null,
      name?: string | null,
      permissions?:  Array< {
        __typename: "OrderCardPermissions",
        idCard: string,
        rol: string,
        thirdContent?: boolean | null,
        visible?: boolean | null,
      } | null > | null,
    } | null > | null,
    subprocesses?:  {
      __typename: "ModelOrderSubprocessConnection",
      items:  Array< {
        __typename: "OrderSubprocess",
        id: string,
        type?: string | null,
        status?: boolean | null,
        name: string,
        position: number,
        descripcion: string,
        action: number,
        process?:  {
          __typename: "OrderProcess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          tcdPayment?: boolean | null,
          name: string,
          duration?: string | null,
          descripcion?: string | null,
          position: number,
          responsible?: number | null,
          clientId?: string | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null,
        processId: string,
        clientId: string,
        messages?:  Array< {
          __typename: "MessageSubprocess",
          description?: string | null,
          rol?: string | null,
          visibleAction?: boolean | null,
        } | null > | null,
        notifications?:  Array< {
          __typename: "NotificationSubprocesses",
          group?: string | null,
          enabledEmail?: boolean | null,
          enabledPopUp?: boolean | null,
        } | null > | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    clientId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateOrderProcessSubscriptionVariables = {
  filter?: ModelSubscriptionOrderProcessFilterInput | null,
};

export type OnUpdateOrderProcessSubscription = {
  onUpdateOrderProcess?:  {
    __typename: "OrderProcess",
    id: string,
    type?: string | null,
    status?: boolean | null,
    tcdPayment?: boolean | null,
    name: string,
    duration?: string | null,
    descripcion?: string | null,
    position: number,
    responsible?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    cards?:  Array< {
      __typename: "OrderCards",
      id?: string | null,
      name?: string | null,
      permissions?:  Array< {
        __typename: "OrderCardPermissions",
        idCard: string,
        rol: string,
        thirdContent?: boolean | null,
        visible?: boolean | null,
      } | null > | null,
    } | null > | null,
    subprocesses?:  {
      __typename: "ModelOrderSubprocessConnection",
      items:  Array< {
        __typename: "OrderSubprocess",
        id: string,
        type?: string | null,
        status?: boolean | null,
        name: string,
        position: number,
        descripcion: string,
        action: number,
        process?:  {
          __typename: "OrderProcess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          tcdPayment?: boolean | null,
          name: string,
          duration?: string | null,
          descripcion?: string | null,
          position: number,
          responsible?: number | null,
          clientId?: string | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null,
        processId: string,
        clientId: string,
        messages?:  Array< {
          __typename: "MessageSubprocess",
          description?: string | null,
          rol?: string | null,
          visibleAction?: boolean | null,
        } | null > | null,
        notifications?:  Array< {
          __typename: "NotificationSubprocesses",
          group?: string | null,
          enabledEmail?: boolean | null,
          enabledPopUp?: boolean | null,
        } | null > | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    clientId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteOrderProcessSubscriptionVariables = {
  filter?: ModelSubscriptionOrderProcessFilterInput | null,
};

export type OnDeleteOrderProcessSubscription = {
  onDeleteOrderProcess?:  {
    __typename: "OrderProcess",
    id: string,
    type?: string | null,
    status?: boolean | null,
    tcdPayment?: boolean | null,
    name: string,
    duration?: string | null,
    descripcion?: string | null,
    position: number,
    responsible?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    cards?:  Array< {
      __typename: "OrderCards",
      id?: string | null,
      name?: string | null,
      permissions?:  Array< {
        __typename: "OrderCardPermissions",
        idCard: string,
        rol: string,
        thirdContent?: boolean | null,
        visible?: boolean | null,
      } | null > | null,
    } | null > | null,
    subprocesses?:  {
      __typename: "ModelOrderSubprocessConnection",
      items:  Array< {
        __typename: "OrderSubprocess",
        id: string,
        type?: string | null,
        status?: boolean | null,
        name: string,
        position: number,
        descripcion: string,
        action: number,
        process?:  {
          __typename: "OrderProcess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          tcdPayment?: boolean | null,
          name: string,
          duration?: string | null,
          descripcion?: string | null,
          position: number,
          responsible?: number | null,
          clientId?: string | null,
          createdAt?: string | null,
          updatedAt: string,
        } | null,
        processId: string,
        clientId: string,
        messages?:  Array< {
          __typename: "MessageSubprocess",
          description?: string | null,
          rol?: string | null,
          visibleAction?: boolean | null,
        } | null > | null,
        notifications?:  Array< {
          __typename: "NotificationSubprocesses",
          group?: string | null,
          enabledEmail?: boolean | null,
          enabledPopUp?: boolean | null,
        } | null > | null,
        createdAt?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    clientId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateOrderSubprocessSubscriptionVariables = {
  filter?: ModelSubscriptionOrderSubprocessFilterInput | null,
};

export type OnCreateOrderSubprocessSubscription = {
  onCreateOrderSubprocess?:  {
    __typename: "OrderSubprocess",
    id: string,
    type?: string | null,
    status?: boolean | null,
    name: string,
    position: number,
    descripcion: string,
    action: number,
    process?:  {
      __typename: "OrderProcess",
      id: string,
      type?: string | null,
      status?: boolean | null,
      tcdPayment?: boolean | null,
      name: string,
      duration?: string | null,
      descripcion?: string | null,
      position: number,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  {
        __typename: "ModelOrderSubprocessConnection",
        items:  Array< {
          __typename: "OrderSubprocess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          name: string,
          position: number,
          descripcion: string,
          action: number,
          processId: string,
          clientId: string,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      clientId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null,
    processId: string,
    clientId: string,
    messages?:  Array< {
      __typename: "MessageSubprocess",
      description?: string | null,
      rol?: string | null,
      visibleAction?: boolean | null,
    } | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateOrderSubprocessSubscriptionVariables = {
  filter?: ModelSubscriptionOrderSubprocessFilterInput | null,
};

export type OnUpdateOrderSubprocessSubscription = {
  onUpdateOrderSubprocess?:  {
    __typename: "OrderSubprocess",
    id: string,
    type?: string | null,
    status?: boolean | null,
    name: string,
    position: number,
    descripcion: string,
    action: number,
    process?:  {
      __typename: "OrderProcess",
      id: string,
      type?: string | null,
      status?: boolean | null,
      tcdPayment?: boolean | null,
      name: string,
      duration?: string | null,
      descripcion?: string | null,
      position: number,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  {
        __typename: "ModelOrderSubprocessConnection",
        items:  Array< {
          __typename: "OrderSubprocess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          name: string,
          position: number,
          descripcion: string,
          action: number,
          processId: string,
          clientId: string,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      clientId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null,
    processId: string,
    clientId: string,
    messages?:  Array< {
      __typename: "MessageSubprocess",
      description?: string | null,
      rol?: string | null,
      visibleAction?: boolean | null,
    } | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteOrderSubprocessSubscriptionVariables = {
  filter?: ModelSubscriptionOrderSubprocessFilterInput | null,
};

export type OnDeleteOrderSubprocessSubscription = {
  onDeleteOrderSubprocess?:  {
    __typename: "OrderSubprocess",
    id: string,
    type?: string | null,
    status?: boolean | null,
    name: string,
    position: number,
    descripcion: string,
    action: number,
    process?:  {
      __typename: "OrderProcess",
      id: string,
      type?: string | null,
      status?: boolean | null,
      tcdPayment?: boolean | null,
      name: string,
      duration?: string | null,
      descripcion?: string | null,
      position: number,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  {
        __typename: "ModelOrderSubprocessConnection",
        items:  Array< {
          __typename: "OrderSubprocess",
          id: string,
          type?: string | null,
          status?: boolean | null,
          name: string,
          position: number,
          descripcion: string,
          action: number,
          processId: string,
          clientId: string,
          createdAt?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      clientId?: string | null,
      createdAt?: string | null,
      updatedAt: string,
    } | null,
    processId: string,
    clientId: string,
    messages?:  Array< {
      __typename: "MessageSubprocess",
      description?: string | null,
      rol?: string | null,
      visibleAction?: boolean | null,
    } | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreatePremiumOrderSubscriptionVariables = {
  filter?: ModelSubscriptionPremiumOrderFilterInput | null,
};

export type OnCreatePremiumOrderSubscription = {
  onCreatePremiumOrder?:  {
    __typename: "PremiumOrder",
    id: string,
    requirement?: string | null,
    bank_reference?: string | null,
    hasVat?: boolean | null,
    billingData?:  {
      __typename: "BillingData",
      name?: string | null,
      rfc?: string | null,
      regimen?: string | null,
      cfdi_use?: string | null,
      cp?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
    } | null,
    orderId: number,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    logs?:  Array< {
      __typename: "Log",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      role?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_fee?: number | null,
    delivery_discount?: number | null,
    delivery_time?: number | null,
    delivery_date?: string | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    taxSituationFile?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clipUrl?: string | null,
    clipStatus?: string | null,
    listProviders?:  Array< {
      __typename: "ListProvidersOrder",
      provider_id: string,
      order_id: string,
      payment_date?: number | null,
      gr_code?: string | null,
      order_confirmation?: boolean | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      delivered?: boolean | null,
      deliveredFormat?: boolean | null,
    } | null > | null,
    providers?:  {
      __typename: "ModelOrderProvidersConnection",
      items:  Array< {
        __typename: "OrderProviders",
        id: string,
        provider_id: string,
        clientId?: string | null,
        orderId?: number | null,
        orderProvidersPremiumOrderId: string,
        payment_date?: number | null,
        gr_code?: string | null,
        invoice?: boolean | null,
        invoiceRequested?: boolean | null,
        uploadedGr?: boolean | null,
        uploadedBill?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    listsProducts:  Array< {
      __typename: "ProductInOrder",
      product_id: string,
      provider_id?: string | null,
      index?: number | null,
      print?: number | null,
      printPrice?: number | null,
      product_name: string,
      description?: string | null,
      category?: string | null,
      unspsc?: string | null,
      price?: number | null,
      originalPrice?: number | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      sample_authorize?: boolean | null,
      sample_authorized?: boolean | null,
      quality_requested?: boolean | null,
      quality_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      isExternal?: boolean | null,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      sku?: string | null,
      qualityForm?:  {
        __typename: "ProductInOrderQualityPGForm",
        initiativeDescription?: string | null,
        targetUser?: string | null,
        retailBrandName?: string | null,
        itemCategory?: string | null,
        itemPicture?: string | null,
        originCountry?: string | null,
        quantityPerCountryOfDist?: string | null,
        initiativeDates?: string | null,
        isPartOfAnMSOCustOrSpecPack?: string | null,
        incluesClientLogo?: string | null,
        isAReorderWithinTwelveMonths?: string | null,
        isReorder?: string | null,
        PGPLContactName?: string | null,
        ulTracking?: string | null,
        PLContactName?: string | null,
        contactEmailAddress?: string | null,
        PGPurchaseOrderNumber?: string | null,
        EBBSorSupplierProvidedProjectNumber?: string | null,
        vendorCompanyName?: string | null,
        vendorContactName?: string | null,
        vendorEmailAddress?: string | null,
        vendorJobTitle?: string | null,
        vendorTelephone?: string | null,
        vendorMailingAddress?: string | null,
        vendorCity?: string | null,
        vendorState?: string | null,
        vendorCountry?: string | null,
        vendorPC?: string | null,
        physicalItemDescription?: string | null,
        SampleOrMaterialComponentSubmitted?: string | null,
        toWhom?: string | null,
        descriptionOfItemPackagingAndArtwork?: string | null,
        regulatoryAndLegislativeProductCertification?: string | null,
        dateFinalApprovalRequestedSubmittedToPG?: string | null,
        DateOfDeclarationOfConformity?: string | null,
        dateOfApprovalExpirationOfPremiumItem?: string | null,
        itemClasification?: string | null,
        PGRepresentativeMarketingDesign?: string | null,
        PGProjectLeaderRequestor?: string | null,
        PGRestrictedItemsLocalPGLegal?: string | null,
        PGLocalCategoryGM?: string | null,
        PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
        idProduct?: string | null,
        pathDocument?: string | null,
      } | null,
      fee?: number | null,
      increment?: number | null,
      discount?: number | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
    } >,
    cotizationsList:  Array< {
      __typename: "PremiumOrderCotizationsLog",
      id: number,
      created: number,
      createdBy: string,
      products:  Array< {
        __typename: "ProductInOrder",
        product_id: string,
        provider_id?: string | null,
        index?: number | null,
        print?: number | null,
        printPrice?: number | null,
        product_name: string,
        description?: string | null,
        category?: string | null,
        unspsc?: string | null,
        price?: number | null,
        originalPrice?: number | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        sample_authorize?: boolean | null,
        sample_authorized?: boolean | null,
        quality_requested?: boolean | null,
        quality_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        isExternal?: boolean | null,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        sku?: string | null,
        qualityForm?:  {
          __typename: "ProductInOrderQualityPGForm",
          initiativeDescription?: string | null,
          targetUser?: string | null,
          retailBrandName?: string | null,
          itemCategory?: string | null,
          itemPicture?: string | null,
          originCountry?: string | null,
          quantityPerCountryOfDist?: string | null,
          initiativeDates?: string | null,
          isPartOfAnMSOCustOrSpecPack?: string | null,
          incluesClientLogo?: string | null,
          isAReorderWithinTwelveMonths?: string | null,
          isReorder?: string | null,
          PGPLContactName?: string | null,
          ulTracking?: string | null,
          PLContactName?: string | null,
          contactEmailAddress?: string | null,
          PGPurchaseOrderNumber?: string | null,
          EBBSorSupplierProvidedProjectNumber?: string | null,
          vendorCompanyName?: string | null,
          vendorContactName?: string | null,
          vendorEmailAddress?: string | null,
          vendorJobTitle?: string | null,
          vendorTelephone?: string | null,
          vendorMailingAddress?: string | null,
          vendorCity?: string | null,
          vendorState?: string | null,
          vendorCountry?: string | null,
          vendorPC?: string | null,
          physicalItemDescription?: string | null,
          SampleOrMaterialComponentSubmitted?: string | null,
          toWhom?: string | null,
          descriptionOfItemPackagingAndArtwork?: string | null,
          regulatoryAndLegislativeProductCertification?: string | null,
          dateFinalApprovalRequestedSubmittedToPG?: string | null,
          DateOfDeclarationOfConformity?: string | null,
          dateOfApprovalExpirationOfPremiumItem?: string | null,
          itemClasification?: string | null,
          PGRepresentativeMarketingDesign?: string | null,
          PGProjectLeaderRequestor?: string | null,
          PGRestrictedItemsLocalPGLegal?: string | null,
          PGLocalCategoryGM?: string | null,
          PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
          idProduct?: string | null,
          pathDocument?: string | null,
        } | null,
        fee?: number | null,
        increment?: number | null,
        discount?: number | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        sellMode?: ProductMaskSellMode | null,
        kitPieces?: number | null,
      } >,
    } | null >,
    orderCreatorId: string,
    creator:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    },
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    invoiceContact?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    premiumOrderClientId?: string | null,
    client?:  {
      __typename: "Client",
      id: string,
      status?: boolean | null,
      business_name: string,
      comertial_name: string,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      biography?: string | null,
      plan?: string | null,
      fee?: number | null,
      increment?: number | null,
      mercadoFee?: number | null,
      mercadoIncrement?: number | null,
      popFee?: number | null,
      popIncrement?: number | null,
      printedFee?: number | null,
      printedIncrement?: number | null,
      users?: Array< string | null > | null,
      restrictedUsers?: Array< string | null > | null,
      nonRestrictedUsers?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      popProviders?: Array< string | null > | null,
      printedProviders?: Array< string | null > | null,
      logisticFrequency?: number | null,
      agents?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      administrators?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      signDocument?:  Array< {
        __typename: "Sign",
        url?: string | null,
        enabled?: boolean | null,
      } | null > | null,
      legal_representative?: string | null,
      legal_representative_email?: string | null,
      legal_representative_address?: string | null,
      tcdUsers?: Array< string | null > | null,
      billingUsers?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt?: string | null,
    } | null,
    userBrandId?: string | null,
    userBrand?:  {
      __typename: "UsersBrands",
      id: string,
      name: string,
      description?: string | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      status?: string | null,
      clientId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subtotal?: number | null,
    fee?: number | null,
    printedPrice?: number | null,
    total?: number | null,
    discountAmount?: number | null,
    syncWithCrm?: boolean | null,
    crmIssueKey?: string | null,
    sentToAlendum?: boolean | null,
    alendumProjectId?: string | null,
    syncWithFms?: string | null,
    fmsInvoiceId?: string | null,
    syncWithWms?: boolean | null,
    wmsProjectId?: string | null,
    isCoupa?: boolean | null,
    sentToCoupa?: boolean | null,
    isRfq?: boolean | null,
    requireSamples?: boolean | null,
    requestedSamples?: boolean | null,
    approvedSamples?: boolean | null,
    authorizedQA?: boolean | null,
    active?: string | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    processes?:  Array< {
      __typename: "OrderProcessStructure",
      id?: string | null,
      name?: string | null,
      descripcion?: string | null,
      duration?: string | null,
      position?: number | null,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      madeBy?: string | null,
      madeAt?: number | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  Array< {
        __typename: "OrderSubprocessStructure",
        id?: string | null,
        name?: string | null,
        position?: number | null,
        descripcion?: string | null,
        action?: number | null,
        process?: string | null,
        madeBy?: string | null,
        madeAt?: number | null,
        messages?:  Array< {
          __typename: "MessageSubprocess",
          description?: string | null,
          rol?: string | null,
          visibleAction?: boolean | null,
        } | null > | null,
        notifications?:  Array< {
          __typename: "NotificationSubprocesses",
          group?: string | null,
          enabledEmail?: boolean | null,
          enabledPopUp?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    updatedAt?: string | null,
    created: number,
    updated?: number | null,
    logistic?:  Array< {
      __typename: "LogisticPremiumOrder",
      premiumOrderId?: string | null,
      tracking_number?: string | null,
      destiny_latitude?: string | null,
      destiny_longitude?: string | null,
      status?: string | null,
      status_activity?: string | null,
      status_description?: string | null,
      origin_latitude?: string | null,
      origin_longitude?: string | null,
      carrier?: string | null,
      clave_sat?: string | null,
      customer_delivery_start_date?: string | null,
      customer_email?: string | null,
      customer_external_number?: string | null,
      customer_first_name?: string | null,
      customer_last_name?: string | null,
      customer_mobile_number?: string | null,
      customer_postcode?: string | null,
      customer_settlement?: string | null,
      customer_street?: string | null,
      descripcion_sat?: string | null,
      peligroso?: string | null,
      primary_client?: string | null,
      purchase_order_number?: string | null,
      shipping_method?: string | null,
      shipping_option?: string | null,
      created: number,
    } | null > | null,
    createdAt: string,
  } | null,
};

export type OnUpdatePremiumOrderSubscriptionVariables = {
  filter?: ModelSubscriptionPremiumOrderFilterInput | null,
};

export type OnUpdatePremiumOrderSubscription = {
  onUpdatePremiumOrder?:  {
    __typename: "PremiumOrder",
    id: string,
    requirement?: string | null,
    bank_reference?: string | null,
    hasVat?: boolean | null,
    billingData?:  {
      __typename: "BillingData",
      name?: string | null,
      rfc?: string | null,
      regimen?: string | null,
      cfdi_use?: string | null,
      cp?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
    } | null,
    orderId: number,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    logs?:  Array< {
      __typename: "Log",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      role?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_fee?: number | null,
    delivery_discount?: number | null,
    delivery_time?: number | null,
    delivery_date?: string | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    taxSituationFile?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clipUrl?: string | null,
    clipStatus?: string | null,
    listProviders?:  Array< {
      __typename: "ListProvidersOrder",
      provider_id: string,
      order_id: string,
      payment_date?: number | null,
      gr_code?: string | null,
      order_confirmation?: boolean | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      delivered?: boolean | null,
      deliveredFormat?: boolean | null,
    } | null > | null,
    providers?:  {
      __typename: "ModelOrderProvidersConnection",
      items:  Array< {
        __typename: "OrderProviders",
        id: string,
        provider_id: string,
        clientId?: string | null,
        orderId?: number | null,
        orderProvidersPremiumOrderId: string,
        payment_date?: number | null,
        gr_code?: string | null,
        invoice?: boolean | null,
        invoiceRequested?: boolean | null,
        uploadedGr?: boolean | null,
        uploadedBill?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    listsProducts:  Array< {
      __typename: "ProductInOrder",
      product_id: string,
      provider_id?: string | null,
      index?: number | null,
      print?: number | null,
      printPrice?: number | null,
      product_name: string,
      description?: string | null,
      category?: string | null,
      unspsc?: string | null,
      price?: number | null,
      originalPrice?: number | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      sample_authorize?: boolean | null,
      sample_authorized?: boolean | null,
      quality_requested?: boolean | null,
      quality_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      isExternal?: boolean | null,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      sku?: string | null,
      qualityForm?:  {
        __typename: "ProductInOrderQualityPGForm",
        initiativeDescription?: string | null,
        targetUser?: string | null,
        retailBrandName?: string | null,
        itemCategory?: string | null,
        itemPicture?: string | null,
        originCountry?: string | null,
        quantityPerCountryOfDist?: string | null,
        initiativeDates?: string | null,
        isPartOfAnMSOCustOrSpecPack?: string | null,
        incluesClientLogo?: string | null,
        isAReorderWithinTwelveMonths?: string | null,
        isReorder?: string | null,
        PGPLContactName?: string | null,
        ulTracking?: string | null,
        PLContactName?: string | null,
        contactEmailAddress?: string | null,
        PGPurchaseOrderNumber?: string | null,
        EBBSorSupplierProvidedProjectNumber?: string | null,
        vendorCompanyName?: string | null,
        vendorContactName?: string | null,
        vendorEmailAddress?: string | null,
        vendorJobTitle?: string | null,
        vendorTelephone?: string | null,
        vendorMailingAddress?: string | null,
        vendorCity?: string | null,
        vendorState?: string | null,
        vendorCountry?: string | null,
        vendorPC?: string | null,
        physicalItemDescription?: string | null,
        SampleOrMaterialComponentSubmitted?: string | null,
        toWhom?: string | null,
        descriptionOfItemPackagingAndArtwork?: string | null,
        regulatoryAndLegislativeProductCertification?: string | null,
        dateFinalApprovalRequestedSubmittedToPG?: string | null,
        DateOfDeclarationOfConformity?: string | null,
        dateOfApprovalExpirationOfPremiumItem?: string | null,
        itemClasification?: string | null,
        PGRepresentativeMarketingDesign?: string | null,
        PGProjectLeaderRequestor?: string | null,
        PGRestrictedItemsLocalPGLegal?: string | null,
        PGLocalCategoryGM?: string | null,
        PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
        idProduct?: string | null,
        pathDocument?: string | null,
      } | null,
      fee?: number | null,
      increment?: number | null,
      discount?: number | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
    } >,
    cotizationsList:  Array< {
      __typename: "PremiumOrderCotizationsLog",
      id: number,
      created: number,
      createdBy: string,
      products:  Array< {
        __typename: "ProductInOrder",
        product_id: string,
        provider_id?: string | null,
        index?: number | null,
        print?: number | null,
        printPrice?: number | null,
        product_name: string,
        description?: string | null,
        category?: string | null,
        unspsc?: string | null,
        price?: number | null,
        originalPrice?: number | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        sample_authorize?: boolean | null,
        sample_authorized?: boolean | null,
        quality_requested?: boolean | null,
        quality_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        isExternal?: boolean | null,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        sku?: string | null,
        qualityForm?:  {
          __typename: "ProductInOrderQualityPGForm",
          initiativeDescription?: string | null,
          targetUser?: string | null,
          retailBrandName?: string | null,
          itemCategory?: string | null,
          itemPicture?: string | null,
          originCountry?: string | null,
          quantityPerCountryOfDist?: string | null,
          initiativeDates?: string | null,
          isPartOfAnMSOCustOrSpecPack?: string | null,
          incluesClientLogo?: string | null,
          isAReorderWithinTwelveMonths?: string | null,
          isReorder?: string | null,
          PGPLContactName?: string | null,
          ulTracking?: string | null,
          PLContactName?: string | null,
          contactEmailAddress?: string | null,
          PGPurchaseOrderNumber?: string | null,
          EBBSorSupplierProvidedProjectNumber?: string | null,
          vendorCompanyName?: string | null,
          vendorContactName?: string | null,
          vendorEmailAddress?: string | null,
          vendorJobTitle?: string | null,
          vendorTelephone?: string | null,
          vendorMailingAddress?: string | null,
          vendorCity?: string | null,
          vendorState?: string | null,
          vendorCountry?: string | null,
          vendorPC?: string | null,
          physicalItemDescription?: string | null,
          SampleOrMaterialComponentSubmitted?: string | null,
          toWhom?: string | null,
          descriptionOfItemPackagingAndArtwork?: string | null,
          regulatoryAndLegislativeProductCertification?: string | null,
          dateFinalApprovalRequestedSubmittedToPG?: string | null,
          DateOfDeclarationOfConformity?: string | null,
          dateOfApprovalExpirationOfPremiumItem?: string | null,
          itemClasification?: string | null,
          PGRepresentativeMarketingDesign?: string | null,
          PGProjectLeaderRequestor?: string | null,
          PGRestrictedItemsLocalPGLegal?: string | null,
          PGLocalCategoryGM?: string | null,
          PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
          idProduct?: string | null,
          pathDocument?: string | null,
        } | null,
        fee?: number | null,
        increment?: number | null,
        discount?: number | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        sellMode?: ProductMaskSellMode | null,
        kitPieces?: number | null,
      } >,
    } | null >,
    orderCreatorId: string,
    creator:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    },
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    invoiceContact?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    premiumOrderClientId?: string | null,
    client?:  {
      __typename: "Client",
      id: string,
      status?: boolean | null,
      business_name: string,
      comertial_name: string,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      biography?: string | null,
      plan?: string | null,
      fee?: number | null,
      increment?: number | null,
      mercadoFee?: number | null,
      mercadoIncrement?: number | null,
      popFee?: number | null,
      popIncrement?: number | null,
      printedFee?: number | null,
      printedIncrement?: number | null,
      users?: Array< string | null > | null,
      restrictedUsers?: Array< string | null > | null,
      nonRestrictedUsers?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      popProviders?: Array< string | null > | null,
      printedProviders?: Array< string | null > | null,
      logisticFrequency?: number | null,
      agents?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      administrators?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      signDocument?:  Array< {
        __typename: "Sign",
        url?: string | null,
        enabled?: boolean | null,
      } | null > | null,
      legal_representative?: string | null,
      legal_representative_email?: string | null,
      legal_representative_address?: string | null,
      tcdUsers?: Array< string | null > | null,
      billingUsers?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt?: string | null,
    } | null,
    userBrandId?: string | null,
    userBrand?:  {
      __typename: "UsersBrands",
      id: string,
      name: string,
      description?: string | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      status?: string | null,
      clientId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subtotal?: number | null,
    fee?: number | null,
    printedPrice?: number | null,
    total?: number | null,
    discountAmount?: number | null,
    syncWithCrm?: boolean | null,
    crmIssueKey?: string | null,
    sentToAlendum?: boolean | null,
    alendumProjectId?: string | null,
    syncWithFms?: string | null,
    fmsInvoiceId?: string | null,
    syncWithWms?: boolean | null,
    wmsProjectId?: string | null,
    isCoupa?: boolean | null,
    sentToCoupa?: boolean | null,
    isRfq?: boolean | null,
    requireSamples?: boolean | null,
    requestedSamples?: boolean | null,
    approvedSamples?: boolean | null,
    authorizedQA?: boolean | null,
    active?: string | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    processes?:  Array< {
      __typename: "OrderProcessStructure",
      id?: string | null,
      name?: string | null,
      descripcion?: string | null,
      duration?: string | null,
      position?: number | null,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      madeBy?: string | null,
      madeAt?: number | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  Array< {
        __typename: "OrderSubprocessStructure",
        id?: string | null,
        name?: string | null,
        position?: number | null,
        descripcion?: string | null,
        action?: number | null,
        process?: string | null,
        madeBy?: string | null,
        madeAt?: number | null,
        messages?:  Array< {
          __typename: "MessageSubprocess",
          description?: string | null,
          rol?: string | null,
          visibleAction?: boolean | null,
        } | null > | null,
        notifications?:  Array< {
          __typename: "NotificationSubprocesses",
          group?: string | null,
          enabledEmail?: boolean | null,
          enabledPopUp?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    updatedAt?: string | null,
    created: number,
    updated?: number | null,
    logistic?:  Array< {
      __typename: "LogisticPremiumOrder",
      premiumOrderId?: string | null,
      tracking_number?: string | null,
      destiny_latitude?: string | null,
      destiny_longitude?: string | null,
      status?: string | null,
      status_activity?: string | null,
      status_description?: string | null,
      origin_latitude?: string | null,
      origin_longitude?: string | null,
      carrier?: string | null,
      clave_sat?: string | null,
      customer_delivery_start_date?: string | null,
      customer_email?: string | null,
      customer_external_number?: string | null,
      customer_first_name?: string | null,
      customer_last_name?: string | null,
      customer_mobile_number?: string | null,
      customer_postcode?: string | null,
      customer_settlement?: string | null,
      customer_street?: string | null,
      descripcion_sat?: string | null,
      peligroso?: string | null,
      primary_client?: string | null,
      purchase_order_number?: string | null,
      shipping_method?: string | null,
      shipping_option?: string | null,
      created: number,
    } | null > | null,
    createdAt: string,
  } | null,
};

export type OnDeletePremiumOrderSubscriptionVariables = {
  filter?: ModelSubscriptionPremiumOrderFilterInput | null,
};

export type OnDeletePremiumOrderSubscription = {
  onDeletePremiumOrder?:  {
    __typename: "PremiumOrder",
    id: string,
    requirement?: string | null,
    bank_reference?: string | null,
    hasVat?: boolean | null,
    billingData?:  {
      __typename: "BillingData",
      name?: string | null,
      rfc?: string | null,
      regimen?: string | null,
      cfdi_use?: string | null,
      cp?: string | null,
      email?: string | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
    } | null,
    orderId: number,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    logs?:  Array< {
      __typename: "Log",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      role?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_fee?: number | null,
    delivery_discount?: number | null,
    delivery_time?: number | null,
    delivery_date?: string | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    taxSituationFile?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clipUrl?: string | null,
    clipStatus?: string | null,
    listProviders?:  Array< {
      __typename: "ListProvidersOrder",
      provider_id: string,
      order_id: string,
      payment_date?: number | null,
      gr_code?: string | null,
      order_confirmation?: boolean | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      delivered?: boolean | null,
      deliveredFormat?: boolean | null,
    } | null > | null,
    providers?:  {
      __typename: "ModelOrderProvidersConnection",
      items:  Array< {
        __typename: "OrderProviders",
        id: string,
        provider_id: string,
        clientId?: string | null,
        orderId?: number | null,
        orderProvidersPremiumOrderId: string,
        payment_date?: number | null,
        gr_code?: string | null,
        invoice?: boolean | null,
        invoiceRequested?: boolean | null,
        uploadedGr?: boolean | null,
        uploadedBill?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    listsProducts:  Array< {
      __typename: "ProductInOrder",
      product_id: string,
      provider_id?: string | null,
      index?: number | null,
      print?: number | null,
      printPrice?: number | null,
      product_name: string,
      description?: string | null,
      category?: string | null,
      unspsc?: string | null,
      price?: number | null,
      originalPrice?: number | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      sample_authorize?: boolean | null,
      sample_authorized?: boolean | null,
      quality_requested?: boolean | null,
      quality_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      isExternal?: boolean | null,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      sku?: string | null,
      qualityForm?:  {
        __typename: "ProductInOrderQualityPGForm",
        initiativeDescription?: string | null,
        targetUser?: string | null,
        retailBrandName?: string | null,
        itemCategory?: string | null,
        itemPicture?: string | null,
        originCountry?: string | null,
        quantityPerCountryOfDist?: string | null,
        initiativeDates?: string | null,
        isPartOfAnMSOCustOrSpecPack?: string | null,
        incluesClientLogo?: string | null,
        isAReorderWithinTwelveMonths?: string | null,
        isReorder?: string | null,
        PGPLContactName?: string | null,
        ulTracking?: string | null,
        PLContactName?: string | null,
        contactEmailAddress?: string | null,
        PGPurchaseOrderNumber?: string | null,
        EBBSorSupplierProvidedProjectNumber?: string | null,
        vendorCompanyName?: string | null,
        vendorContactName?: string | null,
        vendorEmailAddress?: string | null,
        vendorJobTitle?: string | null,
        vendorTelephone?: string | null,
        vendorMailingAddress?: string | null,
        vendorCity?: string | null,
        vendorState?: string | null,
        vendorCountry?: string | null,
        vendorPC?: string | null,
        physicalItemDescription?: string | null,
        SampleOrMaterialComponentSubmitted?: string | null,
        toWhom?: string | null,
        descriptionOfItemPackagingAndArtwork?: string | null,
        regulatoryAndLegislativeProductCertification?: string | null,
        dateFinalApprovalRequestedSubmittedToPG?: string | null,
        DateOfDeclarationOfConformity?: string | null,
        dateOfApprovalExpirationOfPremiumItem?: string | null,
        itemClasification?: string | null,
        PGRepresentativeMarketingDesign?: string | null,
        PGProjectLeaderRequestor?: string | null,
        PGRestrictedItemsLocalPGLegal?: string | null,
        PGLocalCategoryGM?: string | null,
        PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
        idProduct?: string | null,
        pathDocument?: string | null,
      } | null,
      fee?: number | null,
      increment?: number | null,
      discount?: number | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      sellMode?: ProductMaskSellMode | null,
      kitPieces?: number | null,
    } >,
    cotizationsList:  Array< {
      __typename: "PremiumOrderCotizationsLog",
      id: number,
      created: number,
      createdBy: string,
      products:  Array< {
        __typename: "ProductInOrder",
        product_id: string,
        provider_id?: string | null,
        index?: number | null,
        print?: number | null,
        printPrice?: number | null,
        product_name: string,
        description?: string | null,
        category?: string | null,
        unspsc?: string | null,
        price?: number | null,
        originalPrice?: number | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        sample_authorize?: boolean | null,
        sample_authorized?: boolean | null,
        quality_requested?: boolean | null,
        quality_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        isExternal?: boolean | null,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        sku?: string | null,
        qualityForm?:  {
          __typename: "ProductInOrderQualityPGForm",
          initiativeDescription?: string | null,
          targetUser?: string | null,
          retailBrandName?: string | null,
          itemCategory?: string | null,
          itemPicture?: string | null,
          originCountry?: string | null,
          quantityPerCountryOfDist?: string | null,
          initiativeDates?: string | null,
          isPartOfAnMSOCustOrSpecPack?: string | null,
          incluesClientLogo?: string | null,
          isAReorderWithinTwelveMonths?: string | null,
          isReorder?: string | null,
          PGPLContactName?: string | null,
          ulTracking?: string | null,
          PLContactName?: string | null,
          contactEmailAddress?: string | null,
          PGPurchaseOrderNumber?: string | null,
          EBBSorSupplierProvidedProjectNumber?: string | null,
          vendorCompanyName?: string | null,
          vendorContactName?: string | null,
          vendorEmailAddress?: string | null,
          vendorJobTitle?: string | null,
          vendorTelephone?: string | null,
          vendorMailingAddress?: string | null,
          vendorCity?: string | null,
          vendorState?: string | null,
          vendorCountry?: string | null,
          vendorPC?: string | null,
          physicalItemDescription?: string | null,
          SampleOrMaterialComponentSubmitted?: string | null,
          toWhom?: string | null,
          descriptionOfItemPackagingAndArtwork?: string | null,
          regulatoryAndLegislativeProductCertification?: string | null,
          dateFinalApprovalRequestedSubmittedToPG?: string | null,
          DateOfDeclarationOfConformity?: string | null,
          dateOfApprovalExpirationOfPremiumItem?: string | null,
          itemClasification?: string | null,
          PGRepresentativeMarketingDesign?: string | null,
          PGProjectLeaderRequestor?: string | null,
          PGRestrictedItemsLocalPGLegal?: string | null,
          PGLocalCategoryGM?: string | null,
          PGLocalCategoryJoanAbbinanteNissenNotPowered?: string | null,
          idProduct?: string | null,
          pathDocument?: string | null,
        } | null,
        fee?: number | null,
        increment?: number | null,
        discount?: number | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        sellMode?: ProductMaskSellMode | null,
        kitPieces?: number | null,
      } >,
    } | null >,
    orderCreatorId: string,
    creator:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    },
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    invoiceContact?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    premiumOrderClientId?: string | null,
    client?:  {
      __typename: "Client",
      id: string,
      status?: boolean | null,
      business_name: string,
      comertial_name: string,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      grayLogo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      contact?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      address?:  {
        __typename: "Address",
        street?: string | null,
        outdoor_number?: string | null,
        inside_number?: string | null,
        colony?: string | null,
        delegation?: string | null,
        state?: string | null,
        city?: string | null,
        postal_code?: string | null,
        chain?: string | null,
        name?: string | null,
        description?: string | null,
      } | null,
      buyerInfo?:  {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null,
      buyersInfo?:  Array< {
        __typename: "OrderBuyer",
        name: string,
        email: string,
        authorized?: boolean | null,
      } | null > | null,
      biography?: string | null,
      plan?: string | null,
      fee?: number | null,
      increment?: number | null,
      mercadoFee?: number | null,
      mercadoIncrement?: number | null,
      popFee?: number | null,
      popIncrement?: number | null,
      printedFee?: number | null,
      printedIncrement?: number | null,
      users?: Array< string | null > | null,
      restrictedUsers?: Array< string | null > | null,
      nonRestrictedUsers?: Array< string | null > | null,
      regions?: Array< string | null > | null,
      providers?: Array< string | null > | null,
      popProviders?: Array< string | null > | null,
      printedProviders?: Array< string | null > | null,
      logisticFrequency?: number | null,
      agents?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      administrators?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      signDocument?:  Array< {
        __typename: "Sign",
        url?: string | null,
        enabled?: boolean | null,
      } | null > | null,
      legal_representative?: string | null,
      legal_representative_email?: string | null,
      legal_representative_address?: string | null,
      tcdUsers?: Array< string | null > | null,
      billingUsers?:  Array< {
        __typename: "Agent",
        id?: string | null,
        name?: string | null,
        email?: string | null,
        phoneNumber?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt?: string | null,
    } | null,
    userBrandId?: string | null,
    userBrand?:  {
      __typename: "UsersBrands",
      id: string,
      name: string,
      description?: string | null,
      logo?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      status?: string | null,
      clientId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subtotal?: number | null,
    fee?: number | null,
    printedPrice?: number | null,
    total?: number | null,
    discountAmount?: number | null,
    syncWithCrm?: boolean | null,
    crmIssueKey?: string | null,
    sentToAlendum?: boolean | null,
    alendumProjectId?: string | null,
    syncWithFms?: string | null,
    fmsInvoiceId?: string | null,
    syncWithWms?: boolean | null,
    wmsProjectId?: string | null,
    isCoupa?: boolean | null,
    sentToCoupa?: boolean | null,
    isRfq?: boolean | null,
    requireSamples?: boolean | null,
    requestedSamples?: boolean | null,
    approvedSamples?: boolean | null,
    authorizedQA?: boolean | null,
    active?: string | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    processes?:  Array< {
      __typename: "OrderProcessStructure",
      id?: string | null,
      name?: string | null,
      descripcion?: string | null,
      duration?: string | null,
      position?: number | null,
      responsible?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      madeBy?: string | null,
      madeAt?: number | null,
      cards?:  Array< {
        __typename: "OrderCards",
        id?: string | null,
        name?: string | null,
        permissions?:  Array< {
          __typename: "OrderCardPermissions",
          idCard: string,
          rol: string,
          thirdContent?: boolean | null,
          visible?: boolean | null,
        } | null > | null,
      } | null > | null,
      subprocesses?:  Array< {
        __typename: "OrderSubprocessStructure",
        id?: string | null,
        name?: string | null,
        position?: number | null,
        descripcion?: string | null,
        action?: number | null,
        process?: string | null,
        madeBy?: string | null,
        madeAt?: number | null,
        messages?:  Array< {
          __typename: "MessageSubprocess",
          description?: string | null,
          rol?: string | null,
          visibleAction?: boolean | null,
        } | null > | null,
        notifications?:  Array< {
          __typename: "NotificationSubprocesses",
          group?: string | null,
          enabledEmail?: boolean | null,
          enabledPopUp?: boolean | null,
        } | null > | null,
      } | null > | null,
    } | null > | null,
    updatedAt?: string | null,
    created: number,
    updated?: number | null,
    logistic?:  Array< {
      __typename: "LogisticPremiumOrder",
      premiumOrderId?: string | null,
      tracking_number?: string | null,
      destiny_latitude?: string | null,
      destiny_longitude?: string | null,
      status?: string | null,
      status_activity?: string | null,
      status_description?: string | null,
      origin_latitude?: string | null,
      origin_longitude?: string | null,
      carrier?: string | null,
      clave_sat?: string | null,
      customer_delivery_start_date?: string | null,
      customer_email?: string | null,
      customer_external_number?: string | null,
      customer_first_name?: string | null,
      customer_last_name?: string | null,
      customer_mobile_number?: string | null,
      customer_postcode?: string | null,
      customer_settlement?: string | null,
      customer_street?: string | null,
      descripcion_sat?: string | null,
      peligroso?: string | null,
      primary_client?: string | null,
      purchase_order_number?: string | null,
      shipping_method?: string | null,
      shipping_option?: string | null,
      created: number,
    } | null > | null,
    createdAt: string,
  } | null,
};

export type OnCreatePrintedCartSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedCartFilterInput | null,
};

export type OnCreatePrintedCartSubscription = {
  onCreatePrintedCart?:  {
    __typename: "PrintedCart",
    id: string,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    files?:  Array< {
      __typename: "PrintedListFiles",
      created?: number | null,
      creator_id?: string | null,
      file?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      status?: string | null,
      name?: string | null,
      type?: string | null,
      tracking_code?: string | null,
      provider_id?: string | null,
      product_id?: string | null,
      description?: string | null,
    } | null > | null,
    printedProducts?:  Array< {
      __typename: "PrintedProductInOrder",
      product_id: string,
      provider_id?: string | null,
      visible?: boolean | null,
      product_name: string,
      price?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
    } | null > | null,
    creator: string,
    created?: number | null,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePrintedCartSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedCartFilterInput | null,
};

export type OnUpdatePrintedCartSubscription = {
  onUpdatePrintedCart?:  {
    __typename: "PrintedCart",
    id: string,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    files?:  Array< {
      __typename: "PrintedListFiles",
      created?: number | null,
      creator_id?: string | null,
      file?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      status?: string | null,
      name?: string | null,
      type?: string | null,
      tracking_code?: string | null,
      provider_id?: string | null,
      product_id?: string | null,
      description?: string | null,
    } | null > | null,
    printedProducts?:  Array< {
      __typename: "PrintedProductInOrder",
      product_id: string,
      provider_id?: string | null,
      visible?: boolean | null,
      product_name: string,
      price?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
    } | null > | null,
    creator: string,
    created?: number | null,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePrintedCartSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedCartFilterInput | null,
};

export type OnDeletePrintedCartSubscription = {
  onDeletePrintedCart?:  {
    __typename: "PrintedCart",
    id: string,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    files?:  Array< {
      __typename: "PrintedListFiles",
      created?: number | null,
      creator_id?: string | null,
      file?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      status?: string | null,
      name?: string | null,
      type?: string | null,
      tracking_code?: string | null,
      provider_id?: string | null,
      product_id?: string | null,
      description?: string | null,
    } | null > | null,
    printedProducts?:  Array< {
      __typename: "PrintedProductInOrder",
      product_id: string,
      provider_id?: string | null,
      visible?: boolean | null,
      product_name: string,
      price?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
    } | null > | null,
    creator: string,
    created?: number | null,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePrintedCategorySubscriptionVariables = {
  filter?: ModelSubscriptionPrintedCategoryFilterInput | null,
};

export type OnCreatePrintedCategorySubscription = {
  onCreatePrintedCategory?:  {
    __typename: "PrintedCategory",
    id: string,
    name: string,
    image:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    },
    route: string,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    printedSubcategories?:  {
      __typename: "ModelPrintedSubcategoryConnection",
      items:  Array< {
        __typename: "PrintedSubcategory",
        id: string,
        name: string,
        printedCategoryId: string,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        parent:  {
          __typename: "PrintedCategory",
          id: string,
          name: string,
          route: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          region?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        },
        created: number,
        printedProducts?:  {
          __typename: "ModelPrintedProductsConnection",
          nextToken?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        region?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    printedProducts?:  {
      __typename: "ModelPrintedProductsConnection",
      items:  Array< {
        __typename: "PrintedProducts",
        id: string,
        status: string,
        position: string,
        name: string,
        width: number,
        height: number,
        images:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } >,
        price: number,
        long_description?: string | null,
        short_description?: string | null,
        creator?: string | null,
        providerId: string,
        finalDimensions?: number | null,
        pagesNumber?: number | null,
        finishes?: string | null,
        inksFourByCero?: string | null,
        inksFourByFour?: string | null,
        paperKind?: string | null,
        grammage?: string | null,
        hasBarniz?: boolean | null,
        hasRebase?: boolean | null,
        orientation?: string | null,
        specialInstructions?: string | null,
        PrintedSubcategoryId: string,
        printedCategoryId: string,
        created: number,
        variants?:  Array< {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null > | null,
        visibleFor?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    created: number,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePrintedCategorySubscriptionVariables = {
  filter?: ModelSubscriptionPrintedCategoryFilterInput | null,
};

export type OnUpdatePrintedCategorySubscription = {
  onUpdatePrintedCategory?:  {
    __typename: "PrintedCategory",
    id: string,
    name: string,
    image:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    },
    route: string,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    printedSubcategories?:  {
      __typename: "ModelPrintedSubcategoryConnection",
      items:  Array< {
        __typename: "PrintedSubcategory",
        id: string,
        name: string,
        printedCategoryId: string,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        parent:  {
          __typename: "PrintedCategory",
          id: string,
          name: string,
          route: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          region?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        },
        created: number,
        printedProducts?:  {
          __typename: "ModelPrintedProductsConnection",
          nextToken?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        region?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    printedProducts?:  {
      __typename: "ModelPrintedProductsConnection",
      items:  Array< {
        __typename: "PrintedProducts",
        id: string,
        status: string,
        position: string,
        name: string,
        width: number,
        height: number,
        images:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } >,
        price: number,
        long_description?: string | null,
        short_description?: string | null,
        creator?: string | null,
        providerId: string,
        finalDimensions?: number | null,
        pagesNumber?: number | null,
        finishes?: string | null,
        inksFourByCero?: string | null,
        inksFourByFour?: string | null,
        paperKind?: string | null,
        grammage?: string | null,
        hasBarniz?: boolean | null,
        hasRebase?: boolean | null,
        orientation?: string | null,
        specialInstructions?: string | null,
        PrintedSubcategoryId: string,
        printedCategoryId: string,
        created: number,
        variants?:  Array< {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null > | null,
        visibleFor?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    created: number,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePrintedCategorySubscriptionVariables = {
  filter?: ModelSubscriptionPrintedCategoryFilterInput | null,
};

export type OnDeletePrintedCategorySubscription = {
  onDeletePrintedCategory?:  {
    __typename: "PrintedCategory",
    id: string,
    name: string,
    image:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    },
    route: string,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    printedSubcategories?:  {
      __typename: "ModelPrintedSubcategoryConnection",
      items:  Array< {
        __typename: "PrintedSubcategory",
        id: string,
        name: string,
        printedCategoryId: string,
        clientDiscounts?:  Array< {
          __typename: "ClientDiscountPercents",
          index?: number | null,
          clientId?: string | null,
          minUnits?: number | null,
          maxUnits?: number | null,
          percent?: number | null,
        } | null > | null,
        clientFeeIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        clientIncrements?:  Array< {
          __typename: "ClientFeePercents",
          index?: number | null,
          clientId?: string | null,
          percent?: number | null,
        } | null > | null,
        parent:  {
          __typename: "PrintedCategory",
          id: string,
          name: string,
          route: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          region?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        },
        created: number,
        printedProducts?:  {
          __typename: "ModelPrintedProductsConnection",
          nextToken?: string | null,
        } | null,
        visibleFor?: Array< string | null > | null,
        region?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    printedProducts?:  {
      __typename: "ModelPrintedProductsConnection",
      items:  Array< {
        __typename: "PrintedProducts",
        id: string,
        status: string,
        position: string,
        name: string,
        width: number,
        height: number,
        images:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } >,
        price: number,
        long_description?: string | null,
        short_description?: string | null,
        creator?: string | null,
        providerId: string,
        finalDimensions?: number | null,
        pagesNumber?: number | null,
        finishes?: string | null,
        inksFourByCero?: string | null,
        inksFourByFour?: string | null,
        paperKind?: string | null,
        grammage?: string | null,
        hasBarniz?: boolean | null,
        hasRebase?: boolean | null,
        orientation?: string | null,
        specialInstructions?: string | null,
        PrintedSubcategoryId: string,
        printedCategoryId: string,
        created: number,
        variants?:  Array< {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null > | null,
        visibleFor?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    created: number,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePrintedSubcategorySubscriptionVariables = {
  filter?: ModelSubscriptionPrintedSubcategoryFilterInput | null,
};

export type OnCreatePrintedSubcategorySubscription = {
  onCreatePrintedSubcategory?:  {
    __typename: "PrintedSubcategory",
    id: string,
    name: string,
    printedCategoryId: string,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    parent:  {
      __typename: "PrintedCategory",
      id: string,
      name: string,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      route: string,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      printedSubcategories?:  {
        __typename: "ModelPrintedSubcategoryConnection",
        items:  Array< {
          __typename: "PrintedSubcategory",
          id: string,
          name: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          region?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      printedProducts?:  {
        __typename: "ModelPrintedProductsConnection",
        items:  Array< {
          __typename: "PrintedProducts",
          id: string,
          status: string,
          position: string,
          name: string,
          width: number,
          height: number,
          price: number,
          long_description?: string | null,
          short_description?: string | null,
          creator?: string | null,
          providerId: string,
          finalDimensions?: number | null,
          pagesNumber?: number | null,
          finishes?: string | null,
          inksFourByCero?: string | null,
          inksFourByFour?: string | null,
          paperKind?: string | null,
          grammage?: string | null,
          hasBarniz?: boolean | null,
          hasRebase?: boolean | null,
          orientation?: string | null,
          specialInstructions?: string | null,
          PrintedSubcategoryId: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          regions?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      created: number,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    },
    created: number,
    printedProducts?:  {
      __typename: "ModelPrintedProductsConnection",
      items:  Array< {
        __typename: "PrintedProducts",
        id: string,
        status: string,
        position: string,
        name: string,
        width: number,
        height: number,
        images:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } >,
        price: number,
        long_description?: string | null,
        short_description?: string | null,
        creator?: string | null,
        providerId: string,
        finalDimensions?: number | null,
        pagesNumber?: number | null,
        finishes?: string | null,
        inksFourByCero?: string | null,
        inksFourByFour?: string | null,
        paperKind?: string | null,
        grammage?: string | null,
        hasBarniz?: boolean | null,
        hasRebase?: boolean | null,
        orientation?: string | null,
        specialInstructions?: string | null,
        PrintedSubcategoryId: string,
        printedCategoryId: string,
        created: number,
        variants?:  Array< {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null > | null,
        visibleFor?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePrintedSubcategorySubscriptionVariables = {
  filter?: ModelSubscriptionPrintedSubcategoryFilterInput | null,
};

export type OnUpdatePrintedSubcategorySubscription = {
  onUpdatePrintedSubcategory?:  {
    __typename: "PrintedSubcategory",
    id: string,
    name: string,
    printedCategoryId: string,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    parent:  {
      __typename: "PrintedCategory",
      id: string,
      name: string,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      route: string,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      printedSubcategories?:  {
        __typename: "ModelPrintedSubcategoryConnection",
        items:  Array< {
          __typename: "PrintedSubcategory",
          id: string,
          name: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          region?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      printedProducts?:  {
        __typename: "ModelPrintedProductsConnection",
        items:  Array< {
          __typename: "PrintedProducts",
          id: string,
          status: string,
          position: string,
          name: string,
          width: number,
          height: number,
          price: number,
          long_description?: string | null,
          short_description?: string | null,
          creator?: string | null,
          providerId: string,
          finalDimensions?: number | null,
          pagesNumber?: number | null,
          finishes?: string | null,
          inksFourByCero?: string | null,
          inksFourByFour?: string | null,
          paperKind?: string | null,
          grammage?: string | null,
          hasBarniz?: boolean | null,
          hasRebase?: boolean | null,
          orientation?: string | null,
          specialInstructions?: string | null,
          PrintedSubcategoryId: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          regions?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      created: number,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    },
    created: number,
    printedProducts?:  {
      __typename: "ModelPrintedProductsConnection",
      items:  Array< {
        __typename: "PrintedProducts",
        id: string,
        status: string,
        position: string,
        name: string,
        width: number,
        height: number,
        images:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } >,
        price: number,
        long_description?: string | null,
        short_description?: string | null,
        creator?: string | null,
        providerId: string,
        finalDimensions?: number | null,
        pagesNumber?: number | null,
        finishes?: string | null,
        inksFourByCero?: string | null,
        inksFourByFour?: string | null,
        paperKind?: string | null,
        grammage?: string | null,
        hasBarniz?: boolean | null,
        hasRebase?: boolean | null,
        orientation?: string | null,
        specialInstructions?: string | null,
        PrintedSubcategoryId: string,
        printedCategoryId: string,
        created: number,
        variants?:  Array< {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null > | null,
        visibleFor?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePrintedSubcategorySubscriptionVariables = {
  filter?: ModelSubscriptionPrintedSubcategoryFilterInput | null,
};

export type OnDeletePrintedSubcategorySubscription = {
  onDeletePrintedSubcategory?:  {
    __typename: "PrintedSubcategory",
    id: string,
    name: string,
    printedCategoryId: string,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    parent:  {
      __typename: "PrintedCategory",
      id: string,
      name: string,
      image:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      route: string,
      clientDiscounts?:  Array< {
        __typename: "ClientDiscountPercents",
        index?: number | null,
        clientId?: string | null,
        minUnits?: number | null,
        maxUnits?: number | null,
        percent?: number | null,
      } | null > | null,
      clientFeeIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      clientIncrements?:  Array< {
        __typename: "ClientFeePercents",
        index?: number | null,
        clientId?: string | null,
        percent?: number | null,
      } | null > | null,
      printedSubcategories?:  {
        __typename: "ModelPrintedSubcategoryConnection",
        items:  Array< {
          __typename: "PrintedSubcategory",
          id: string,
          name: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          region?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      printedProducts?:  {
        __typename: "ModelPrintedProductsConnection",
        items:  Array< {
          __typename: "PrintedProducts",
          id: string,
          status: string,
          position: string,
          name: string,
          width: number,
          height: number,
          price: number,
          long_description?: string | null,
          short_description?: string | null,
          creator?: string | null,
          providerId: string,
          finalDimensions?: number | null,
          pagesNumber?: number | null,
          finishes?: string | null,
          inksFourByCero?: string | null,
          inksFourByFour?: string | null,
          paperKind?: string | null,
          grammage?: string | null,
          hasBarniz?: boolean | null,
          hasRebase?: boolean | null,
          orientation?: string | null,
          specialInstructions?: string | null,
          PrintedSubcategoryId: string,
          printedCategoryId: string,
          created: number,
          visibleFor?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          regions?: Array< string | null > | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      created: number,
      visibleFor?: Array< string | null > | null,
      region?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    },
    created: number,
    printedProducts?:  {
      __typename: "ModelPrintedProductsConnection",
      items:  Array< {
        __typename: "PrintedProducts",
        id: string,
        status: string,
        position: string,
        name: string,
        width: number,
        height: number,
        images:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } >,
        price: number,
        long_description?: string | null,
        short_description?: string | null,
        creator?: string | null,
        providerId: string,
        finalDimensions?: number | null,
        pagesNumber?: number | null,
        finishes?: string | null,
        inksFourByCero?: string | null,
        inksFourByFour?: string | null,
        paperKind?: string | null,
        grammage?: string | null,
        hasBarniz?: boolean | null,
        hasRebase?: boolean | null,
        orientation?: string | null,
        specialInstructions?: string | null,
        PrintedSubcategoryId: string,
        printedCategoryId: string,
        created: number,
        variants?:  Array< {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null > | null,
        visibleFor?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        regions?: Array< string | null > | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePrintedProductsSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedProductsFilterInput | null,
};

export type OnCreatePrintedProductsSubscription = {
  onCreatePrintedProducts?:  {
    __typename: "PrintedProducts",
    id: string,
    status: string,
    position: string,
    name: string,
    width: number,
    height: number,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    price: number,
    long_description?: string | null,
    short_description?: string | null,
    creator?: string | null,
    providerId: string,
    finalDimensions?: number | null,
    pagesNumber?: number | null,
    finishes?: string | null,
    inksFourByCero?: string | null,
    inksFourByFour?: string | null,
    paperKind?: string | null,
    grammage?: string | null,
    hasBarniz?: boolean | null,
    hasRebase?: boolean | null,
    orientation?: string | null,
    specialInstructions?: string | null,
    PrintedSubcategoryId: string,
    printedCategoryId: string,
    created: number,
    variants?:  Array< {
      __typename: "Variants",
      sku?: string | null,
      name?: string | null,
      description?: string | null,
      colors?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock_available?: number | null,
      price?: number | null,
      size?: string | null,
      logoType?: string | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePrintedProductsSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedProductsFilterInput | null,
};

export type OnUpdatePrintedProductsSubscription = {
  onUpdatePrintedProducts?:  {
    __typename: "PrintedProducts",
    id: string,
    status: string,
    position: string,
    name: string,
    width: number,
    height: number,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    price: number,
    long_description?: string | null,
    short_description?: string | null,
    creator?: string | null,
    providerId: string,
    finalDimensions?: number | null,
    pagesNumber?: number | null,
    finishes?: string | null,
    inksFourByCero?: string | null,
    inksFourByFour?: string | null,
    paperKind?: string | null,
    grammage?: string | null,
    hasBarniz?: boolean | null,
    hasRebase?: boolean | null,
    orientation?: string | null,
    specialInstructions?: string | null,
    PrintedSubcategoryId: string,
    printedCategoryId: string,
    created: number,
    variants?:  Array< {
      __typename: "Variants",
      sku?: string | null,
      name?: string | null,
      description?: string | null,
      colors?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock_available?: number | null,
      price?: number | null,
      size?: string | null,
      logoType?: string | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePrintedProductsSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedProductsFilterInput | null,
};

export type OnDeletePrintedProductsSubscription = {
  onDeletePrintedProducts?:  {
    __typename: "PrintedProducts",
    id: string,
    status: string,
    position: string,
    name: string,
    width: number,
    height: number,
    images:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } >,
    price: number,
    long_description?: string | null,
    short_description?: string | null,
    creator?: string | null,
    providerId: string,
    finalDimensions?: number | null,
    pagesNumber?: number | null,
    finishes?: string | null,
    inksFourByCero?: string | null,
    inksFourByFour?: string | null,
    paperKind?: string | null,
    grammage?: string | null,
    hasBarniz?: boolean | null,
    hasRebase?: boolean | null,
    orientation?: string | null,
    specialInstructions?: string | null,
    PrintedSubcategoryId: string,
    printedCategoryId: string,
    created: number,
    variants?:  Array< {
      __typename: "Variants",
      sku?: string | null,
      name?: string | null,
      description?: string | null,
      colors?: Array< string | null > | null,
      filterColors?: Array< string | null > | null,
      image?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      stock_available?: number | null,
      price?: number | null,
      size?: string | null,
      logoType?: string | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    filterColors?: Array< string | null > | null,
    regions?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePrintedRfqSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedRfqFilterInput | null,
};

export type OnCreatePrintedRfqSubscription = {
  onCreatePrintedRfq?:  {
    __typename: "PrintedRfq",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    limit_time: number,
    proposals?:  {
      __typename: "ModelPrintedProposalConnection",
      items:  Array< {
        __typename: "PrintedProposal",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        products?:  Array< {
          __typename: "PrintedProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name: string,
          description: string,
          priceUnit: number,
          pieces: number,
          total: number,
          idProducto: number,
        } | null > | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "PrintedRfq",
          id: string,
          nombre: string,
          requerimiento: string,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          estatus: string,
          printedOrderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
        } | null,
        printedProposalRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    estatus: string,
    printedOrderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    providers?:  Array< {
      __typename: "RfqPrintedProviders",
      idProvider?: string | null,
    } | null > | null,
    printedProductsRfq:  Array< {
      __typename: "PrintedProductUnitRfq",
      name: string,
      description: string,
      pieces: number,
      createdId: number,
    } | null >,
  } | null,
};

export type OnUpdatePrintedRfqSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedRfqFilterInput | null,
};

export type OnUpdatePrintedRfqSubscription = {
  onUpdatePrintedRfq?:  {
    __typename: "PrintedRfq",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    limit_time: number,
    proposals?:  {
      __typename: "ModelPrintedProposalConnection",
      items:  Array< {
        __typename: "PrintedProposal",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        products?:  Array< {
          __typename: "PrintedProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name: string,
          description: string,
          priceUnit: number,
          pieces: number,
          total: number,
          idProducto: number,
        } | null > | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "PrintedRfq",
          id: string,
          nombre: string,
          requerimiento: string,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          estatus: string,
          printedOrderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
        } | null,
        printedProposalRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    estatus: string,
    printedOrderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    providers?:  Array< {
      __typename: "RfqPrintedProviders",
      idProvider?: string | null,
    } | null > | null,
    printedProductsRfq:  Array< {
      __typename: "PrintedProductUnitRfq",
      name: string,
      description: string,
      pieces: number,
      createdId: number,
    } | null >,
  } | null,
};

export type OnDeletePrintedRfqSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedRfqFilterInput | null,
};

export type OnDeletePrintedRfqSubscription = {
  onDeletePrintedRfq?:  {
    __typename: "PrintedRfq",
    id: string,
    nombre: string,
    requerimiento: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    limit_time: number,
    proposals?:  {
      __typename: "ModelPrintedProposalConnection",
      items:  Array< {
        __typename: "PrintedProposal",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        validity_days?: number | null,
        description?: string | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        products?:  Array< {
          __typename: "PrintedProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name: string,
          description: string,
          priceUnit: number,
          pieces: number,
          total: number,
          idProducto: number,
        } | null > | null,
        hidden?: boolean | null,
        rfq?:  {
          __typename: "PrintedRfq",
          id: string,
          nombre: string,
          requerimiento: string,
          limit_time: number,
          creator?: string | null,
          clientId: string,
          estatus: string,
          printedOrderId?: number | null,
          start_time: number,
          delivery_time?: number | null,
          created: number,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          createdAt?: string | null,
          updatedAt?: string | null,
          updated?: number | null,
        } | null,
        printedProposalRfqId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    creator?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    clientId: string,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    estatus: string,
    printedOrderId?: number | null,
    start_time: number,
    delivery_time?: number | null,
    created: number,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
    updated?: number | null,
    providers?:  Array< {
      __typename: "RfqPrintedProviders",
      idProvider?: string | null,
    } | null > | null,
    printedProductsRfq:  Array< {
      __typename: "PrintedProductUnitRfq",
      name: string,
      description: string,
      pieces: number,
      createdId: number,
    } | null >,
  } | null,
};

export type OnCreatePrintedProductoRfqSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedProductoRfqFilterInput | null,
};

export type OnCreatePrintedProductoRfqSubscription = {
  onCreatePrintedProductoRfq?:  {
    __typename: "PrintedProductoRfq",
    id: string,
    name: string,
    description: string,
    category_id: string,
    provider_id: string,
    price?: number | null,
    category?: string | null,
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    estatus?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePrintedProductoRfqSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedProductoRfqFilterInput | null,
};

export type OnUpdatePrintedProductoRfqSubscription = {
  onUpdatePrintedProductoRfq?:  {
    __typename: "PrintedProductoRfq",
    id: string,
    name: string,
    description: string,
    category_id: string,
    provider_id: string,
    price?: number | null,
    category?: string | null,
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    estatus?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePrintedProductoRfqSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedProductoRfqFilterInput | null,
};

export type OnDeletePrintedProductoRfqSubscription = {
  onDeletePrintedProductoRfq?:  {
    __typename: "PrintedProductoRfq",
    id: string,
    name: string,
    description: string,
    category_id: string,
    provider_id: string,
    price?: number | null,
    category?: string | null,
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    estatus?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePrintedProposalSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedProposalFilterInput | null,
};

export type OnCreatePrintedProposalSubscription = {
  onCreatePrintedProposal?:  {
    __typename: "PrintedProposal",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    products?:  Array< {
      __typename: "PrintedProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name: string,
      description: string,
      priceUnit: number,
      pieces: number,
      total: number,
      idProducto: number,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "PrintedRfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      proposals?:  {
        __typename: "ModelPrintedProposalConnection",
        items:  Array< {
          __typename: "PrintedProposal",
          id: string,
          provider_id: string,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          hidden?: boolean | null,
          printedProposalRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      printedOrderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      providers?:  Array< {
        __typename: "RfqPrintedProviders",
        idProvider?: string | null,
      } | null > | null,
      printedProductsRfq:  Array< {
        __typename: "PrintedProductUnitRfq",
        name: string,
        description: string,
        pieces: number,
        createdId: number,
      } | null >,
    } | null,
    printedProposalRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePrintedProposalSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedProposalFilterInput | null,
};

export type OnUpdatePrintedProposalSubscription = {
  onUpdatePrintedProposal?:  {
    __typename: "PrintedProposal",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    products?:  Array< {
      __typename: "PrintedProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name: string,
      description: string,
      priceUnit: number,
      pieces: number,
      total: number,
      idProducto: number,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "PrintedRfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      proposals?:  {
        __typename: "ModelPrintedProposalConnection",
        items:  Array< {
          __typename: "PrintedProposal",
          id: string,
          provider_id: string,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          hidden?: boolean | null,
          printedProposalRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      printedOrderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      providers?:  Array< {
        __typename: "RfqPrintedProviders",
        idProvider?: string | null,
      } | null > | null,
      printedProductsRfq:  Array< {
        __typename: "PrintedProductUnitRfq",
        name: string,
        description: string,
        pieces: number,
        createdId: number,
      } | null >,
    } | null,
    printedProposalRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePrintedProposalSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedProposalFilterInput | null,
};

export type OnDeletePrintedProposalSubscription = {
  onDeletePrintedProposal?:  {
    __typename: "PrintedProposal",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    validity_days?: number | null,
    description?: string | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    products?:  Array< {
      __typename: "PrintedProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name: string,
      description: string,
      priceUnit: number,
      pieces: number,
      total: number,
      idProducto: number,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    hidden?: boolean | null,
    rfq?:  {
      __typename: "PrintedRfq",
      id: string,
      nombre: string,
      requerimiento: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      proposals?:  {
        __typename: "ModelPrintedProposalConnection",
        items:  Array< {
          __typename: "PrintedProposal",
          id: string,
          provider_id: string,
          price: number,
          validity_days?: number | null,
          description?: string | null,
          created: number,
          updated?: number | null,
          hidden?: boolean | null,
          printedProposalRfqId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      creator?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      clientId: string,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      estatus: string,
      printedOrderId?: number | null,
      start_time: number,
      delivery_time?: number | null,
      created: number,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      createdAt?: string | null,
      updatedAt?: string | null,
      updated?: number | null,
      providers?:  Array< {
        __typename: "RfqPrintedProviders",
        idProvider?: string | null,
      } | null > | null,
      printedProductsRfq:  Array< {
        __typename: "PrintedProductUnitRfq",
        name: string,
        description: string,
        pieces: number,
        createdId: number,
      } | null >,
    } | null,
    printedProposalRfqId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePrintedOrderSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedOrderFilterInput | null,
};

export type OnCreatePrintedOrderSubscription = {
  onCreatePrintedOrder?:  {
    __typename: "PrintedOrder",
    id: string,
    orderId: number,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_time?: number | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    listProviders?:  Array< {
      __typename: "ListProvidersOrder",
      provider_id: string,
      order_id: string,
      payment_date?: number | null,
      gr_code?: string | null,
      order_confirmation?: boolean | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      delivered?: boolean | null,
      deliveredFormat?: boolean | null,
    } | null > | null,
    listProvidersKey?: Array< string | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    listPrintedProducts:  Array< {
      __typename: "PrintedProductInOrder",
      product_id: string,
      provider_id?: string | null,
      visible?: boolean | null,
      product_name: string,
      price?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
    } >,
    cotizationsList:  Array< {
      __typename: "PrintedOrderCotizationsLog",
      id: number,
      created: number,
      createdBy: string,
      products:  Array< {
        __typename: "PrintedProductInOrder",
        product_id: string,
        provider_id?: string | null,
        visible?: boolean | null,
        product_name: string,
        price?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
      } >,
    } | null >,
    orderCreatorId: string,
    creator:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    },
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    printedOrderClientId?: string | null,
    subtotal?: number | null,
    total?: number | null,
    isCoupa?: boolean | null,
    sentToCoupa?: boolean | null,
    isRfq?: boolean | null,
    status?: string | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    updatedAt?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
  } | null,
};

export type OnUpdatePrintedOrderSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedOrderFilterInput | null,
};

export type OnUpdatePrintedOrderSubscription = {
  onUpdatePrintedOrder?:  {
    __typename: "PrintedOrder",
    id: string,
    orderId: number,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_time?: number | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    listProviders?:  Array< {
      __typename: "ListProvidersOrder",
      provider_id: string,
      order_id: string,
      payment_date?: number | null,
      gr_code?: string | null,
      order_confirmation?: boolean | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      delivered?: boolean | null,
      deliveredFormat?: boolean | null,
    } | null > | null,
    listProvidersKey?: Array< string | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    listPrintedProducts:  Array< {
      __typename: "PrintedProductInOrder",
      product_id: string,
      provider_id?: string | null,
      visible?: boolean | null,
      product_name: string,
      price?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
    } >,
    cotizationsList:  Array< {
      __typename: "PrintedOrderCotizationsLog",
      id: number,
      created: number,
      createdBy: string,
      products:  Array< {
        __typename: "PrintedProductInOrder",
        product_id: string,
        provider_id?: string | null,
        visible?: boolean | null,
        product_name: string,
        price?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
      } >,
    } | null >,
    orderCreatorId: string,
    creator:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    },
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    printedOrderClientId?: string | null,
    subtotal?: number | null,
    total?: number | null,
    isCoupa?: boolean | null,
    sentToCoupa?: boolean | null,
    isRfq?: boolean | null,
    status?: string | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    updatedAt?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
  } | null,
};

export type OnDeletePrintedOrderSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedOrderFilterInput | null,
};

export type OnDeletePrintedOrderSubscription = {
  onDeletePrintedOrder?:  {
    __typename: "PrintedOrder",
    id: string,
    orderId: number,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    delivery_addresses?:  Array< {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    } | null > | null,
    delivery_cost?: number | null,
    delivery_time?: number | null,
    files?:  Array< {
      __typename: "ListFiles",
      created: number,
      creator_id: string,
      file:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      },
      status?: string | null,
      statusFile?: string | null,
      name: string,
      provider_id?: string | null,
      product_id?: string | null,
      tracking_code?: string | null,
      gr_code?: string | null,
      coupa_order?: string | null,
      description?: string | null,
    } | null > | null,
    listProviders?:  Array< {
      __typename: "ListProvidersOrder",
      provider_id: string,
      order_id: string,
      payment_date?: number | null,
      gr_code?: string | null,
      order_confirmation?: boolean | null,
      invoice?: boolean | null,
      invoiceRequested?: boolean | null,
      uploadedGr?: boolean | null,
      uploadedBill?: boolean | null,
      delivered?: boolean | null,
      deliveredFormat?: boolean | null,
    } | null > | null,
    listProvidersKey?: Array< string | null > | null,
    orderAgents?:  Array< {
      __typename: "OrderAgent",
      name?: string | null,
      email?: string | null,
      phoneNumber?: string | null,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id?: string | null,
    } | null > | null,
    orderAgentIds?: Array< string | null > | null,
    listPrintedProducts:  Array< {
      __typename: "PrintedProductInOrder",
      product_id: string,
      provider_id?: string | null,
      visible?: boolean | null,
      product_name: string,
      price?: number | null,
      image?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      sample_requested?: boolean | null,
      sample_request?: boolean | null,
      uploadedSample?: boolean | null,
      quantity: number,
      variant?:  {
        __typename: "Variants",
        sku?: string | null,
        name?: string | null,
        description?: string | null,
        colors?: Array< string | null > | null,
        filterColors?: Array< string | null > | null,
        image?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        stock_available?: number | null,
        price?: number | null,
        size?: string | null,
        logoType?: string | null,
      } | null,
      logs?:  Array< {
        __typename: "ProductInOrderLog",
        product_id: string,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
    } >,
    cotizationsList:  Array< {
      __typename: "PrintedOrderCotizationsLog",
      id: number,
      created: number,
      createdBy: string,
      products:  Array< {
        __typename: "PrintedProductInOrder",
        product_id: string,
        provider_id?: string | null,
        visible?: boolean | null,
        product_name: string,
        price?: number | null,
        image?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        sample_requested?: boolean | null,
        sample_request?: boolean | null,
        uploadedSample?: boolean | null,
        quantity: number,
        variant?:  {
          __typename: "Variants",
          sku?: string | null,
          name?: string | null,
          description?: string | null,
          colors?: Array< string | null > | null,
          filterColors?: Array< string | null > | null,
          stock_available?: number | null,
          price?: number | null,
          size?: string | null,
          logoType?: string | null,
        } | null,
        logs?:  Array< {
          __typename: "ProductInOrderLog",
          product_id: string,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
      } >,
    } | null >,
    orderCreatorId: string,
    creator:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    },
    buyerInfo?:  {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null,
    buyersInfo?:  Array< {
      __typename: "OrderBuyer",
      name: string,
      email: string,
      authorized?: boolean | null,
    } | null > | null,
    contact?:  {
      __typename: "OrderContact",
      name: string,
      tel: string,
    } | null,
    printedOrderClientId?: string | null,
    subtotal?: number | null,
    total?: number | null,
    isCoupa?: boolean | null,
    sentToCoupa?: boolean | null,
    isRfq?: boolean | null,
    status?: string | null,
    currentProcess?: string | null,
    currentSubprocess?: string | null,
    updatedAt?: string | null,
    created: number,
    updated?: number | null,
    createdAt: string,
  } | null,
};

export type OnCreatePrintedOrderProvidersSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedOrderProvidersFilterInput | null,
};

export type OnCreatePrintedOrderProvidersSubscription = {
  onCreatePrintedOrderProviders?:  {
    __typename: "PrintedOrderProviders",
    id: string,
    provider_id: string,
    orderId?: number | null,
    printedOrderProvidersPrintedOrderId: string,
    payment_date?: number | null,
    gr_code?: string | null,
    invoice?: boolean | null,
    invoiceRequested?: boolean | null,
    uploadedGr?: boolean | null,
    uploadedBill?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePrintedOrderProvidersSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedOrderProvidersFilterInput | null,
};

export type OnUpdatePrintedOrderProvidersSubscription = {
  onUpdatePrintedOrderProviders?:  {
    __typename: "PrintedOrderProviders",
    id: string,
    provider_id: string,
    orderId?: number | null,
    printedOrderProvidersPrintedOrderId: string,
    payment_date?: number | null,
    gr_code?: string | null,
    invoice?: boolean | null,
    invoiceRequested?: boolean | null,
    uploadedGr?: boolean | null,
    uploadedBill?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePrintedOrderProvidersSubscriptionVariables = {
  filter?: ModelSubscriptionPrintedOrderProvidersFilterInput | null,
};

export type OnDeletePrintedOrderProvidersSubscription = {
  onDeletePrintedOrderProviders?:  {
    __typename: "PrintedOrderProviders",
    id: string,
    provider_id: string,
    orderId?: number | null,
    printedOrderProvidersPrintedOrderId: string,
    payment_date?: number | null,
    gr_code?: string | null,
    invoice?: boolean | null,
    invoiceRequested?: boolean | null,
    uploadedGr?: boolean | null,
    uploadedBill?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePayOnBehalfRequestsSubscriptionVariables = {
  filter?: ModelSubscriptionPayOnBehalfRequestsFilterInput | null,
};

export type OnCreatePayOnBehalfRequestsSubscription = {
  onCreatePayOnBehalfRequests?:  {
    __typename: "PayOnBehalfRequests",
    id: string,
    clientId?: string | null,
    companyName?: string | null,
    purchaseOrder?: string | null,
    paymentTerms?: string | null,
    currency?: string | null,
    amount?: number | null,
    selectedVa?: boolean | null,
    iva?: number | null,
    vat?: number | null,
    total?: number | null,
    rfc?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bankStatement?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    supplierQuote?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePayOnBehalfRequestsSubscriptionVariables = {
  filter?: ModelSubscriptionPayOnBehalfRequestsFilterInput | null,
};

export type OnUpdatePayOnBehalfRequestsSubscription = {
  onUpdatePayOnBehalfRequests?:  {
    __typename: "PayOnBehalfRequests",
    id: string,
    clientId?: string | null,
    companyName?: string | null,
    purchaseOrder?: string | null,
    paymentTerms?: string | null,
    currency?: string | null,
    amount?: number | null,
    selectedVa?: boolean | null,
    iva?: number | null,
    vat?: number | null,
    total?: number | null,
    rfc?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bankStatement?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    supplierQuote?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePayOnBehalfRequestsSubscriptionVariables = {
  filter?: ModelSubscriptionPayOnBehalfRequestsFilterInput | null,
};

export type OnDeletePayOnBehalfRequestsSubscription = {
  onDeletePayOnBehalfRequests?:  {
    __typename: "PayOnBehalfRequests",
    id: string,
    clientId?: string | null,
    companyName?: string | null,
    purchaseOrder?: string | null,
    paymentTerms?: string | null,
    currency?: string | null,
    amount?: number | null,
    selectedVa?: boolean | null,
    iva?: number | null,
    vat?: number | null,
    total?: number | null,
    rfc?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    bankStatement?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    supplierQuote?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateBuyerContactClientSubscriptionVariables = {
  filter?: ModelSubscriptionBuyerContactClientFilterInput | null,
};

export type OnCreateBuyerContactClientSubscription = {
  onCreateBuyerContactClient?:  {
    __typename: "BuyerContactClient",
    id: string,
    companyId: string,
    status?: boolean | null,
    defaultContact?: boolean | null,
    name?: string | null,
    email?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateBuyerContactClientSubscriptionVariables = {
  filter?: ModelSubscriptionBuyerContactClientFilterInput | null,
};

export type OnUpdateBuyerContactClientSubscription = {
  onUpdateBuyerContactClient?:  {
    __typename: "BuyerContactClient",
    id: string,
    companyId: string,
    status?: boolean | null,
    defaultContact?: boolean | null,
    name?: string | null,
    email?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteBuyerContactClientSubscriptionVariables = {
  filter?: ModelSubscriptionBuyerContactClientFilterInput | null,
};

export type OnDeleteBuyerContactClientSubscription = {
  onDeleteBuyerContactClient?:  {
    __typename: "BuyerContactClient",
    id: string,
    companyId: string,
    status?: boolean | null,
    defaultContact?: boolean | null,
    name?: string | null,
    email?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateBrandFactoryRfqEmailsSubscriptionVariables = {
  filter?: ModelSubscriptionBrandFactoryRfqEmailsFilterInput | null,
};

export type OnCreateBrandFactoryRfqEmailsSubscription = {
  onCreateBrandFactoryRfqEmails?:  {
    __typename: "BrandFactoryRfqEmails",
    id: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateBrandFactoryRfqEmailsSubscriptionVariables = {
  filter?: ModelSubscriptionBrandFactoryRfqEmailsFilterInput | null,
};

export type OnUpdateBrandFactoryRfqEmailsSubscription = {
  onUpdateBrandFactoryRfqEmails?:  {
    __typename: "BrandFactoryRfqEmails",
    id: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteBrandFactoryRfqEmailsSubscriptionVariables = {
  filter?: ModelSubscriptionBrandFactoryRfqEmailsFilterInput | null,
};

export type OnDeleteBrandFactoryRfqEmailsSubscription = {
  onDeleteBrandFactoryRfqEmails?:  {
    __typename: "BrandFactoryRfqEmails",
    id: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAutomobilesEmailsSubscriptionVariables = {
  filter?: ModelSubscriptionAutomobilesEmailsFilterInput | null,
};

export type OnCreateAutomobilesEmailsSubscription = {
  onCreateAutomobilesEmails?:  {
    __typename: "AutomobilesEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAutomobilesEmailsSubscriptionVariables = {
  filter?: ModelSubscriptionAutomobilesEmailsFilterInput | null,
};

export type OnUpdateAutomobilesEmailsSubscription = {
  onUpdateAutomobilesEmails?:  {
    __typename: "AutomobilesEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAutomobilesEmailsSubscriptionVariables = {
  filter?: ModelSubscriptionAutomobilesEmailsFilterInput | null,
};

export type OnDeleteAutomobilesEmailsSubscription = {
  onDeleteAutomobilesEmails?:  {
    __typename: "AutomobilesEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateQAEmailsSubscriptionVariables = {
  filter?: ModelSubscriptionQAEmailsFilterInput | null,
};

export type OnCreateQAEmailsSubscription = {
  onCreateQAEmails?:  {
    __typename: "QAEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateQAEmailsSubscriptionVariables = {
  filter?: ModelSubscriptionQAEmailsFilterInput | null,
};

export type OnUpdateQAEmailsSubscription = {
  onUpdateQAEmails?:  {
    __typename: "QAEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteQAEmailsSubscriptionVariables = {
  filter?: ModelSubscriptionQAEmailsFilterInput | null,
};

export type OnDeleteQAEmailsSubscription = {
  onDeleteQAEmails?:  {
    __typename: "QAEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateOrderPopAdminEmailsSubscriptionVariables = {
  filter?: ModelSubscriptionOrderPopAdminEmailsFilterInput | null,
};

export type OnCreateOrderPopAdminEmailsSubscription = {
  onCreateOrderPopAdminEmails?:  {
    __typename: "OrderPopAdminEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateOrderPopAdminEmailsSubscriptionVariables = {
  filter?: ModelSubscriptionOrderPopAdminEmailsFilterInput | null,
};

export type OnUpdateOrderPopAdminEmailsSubscription = {
  onUpdateOrderPopAdminEmails?:  {
    __typename: "OrderPopAdminEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteOrderPopAdminEmailsSubscriptionVariables = {
  filter?: ModelSubscriptionOrderPopAdminEmailsFilterInput | null,
};

export type OnDeleteOrderPopAdminEmailsSubscription = {
  onDeleteOrderPopAdminEmails?:  {
    __typename: "OrderPopAdminEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateOrderPopCheckoutEmailsSubscriptionVariables = {
  filter?: ModelSubscriptionOrderPopCheckoutEmailsFilterInput | null,
};

export type OnCreateOrderPopCheckoutEmailsSubscription = {
  onCreateOrderPopCheckoutEmails?:  {
    __typename: "OrderPopCheckoutEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateOrderPopCheckoutEmailsSubscriptionVariables = {
  filter?: ModelSubscriptionOrderPopCheckoutEmailsFilterInput | null,
};

export type OnUpdateOrderPopCheckoutEmailsSubscription = {
  onUpdateOrderPopCheckoutEmails?:  {
    __typename: "OrderPopCheckoutEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteOrderPopCheckoutEmailsSubscriptionVariables = {
  filter?: ModelSubscriptionOrderPopCheckoutEmailsFilterInput | null,
};

export type OnDeleteOrderPopCheckoutEmailsSubscription = {
  onDeleteOrderPopCheckoutEmails?:  {
    __typename: "OrderPopCheckoutEmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateGREmailsSubscriptionVariables = {
  filter?: ModelSubscriptionGREmailsFilterInput | null,
};

export type OnCreateGREmailsSubscription = {
  onCreateGREmails?:  {
    __typename: "GREmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateGREmailsSubscriptionVariables = {
  filter?: ModelSubscriptionGREmailsFilterInput | null,
};

export type OnUpdateGREmailsSubscription = {
  onUpdateGREmails?:  {
    __typename: "GREmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteGREmailsSubscriptionVariables = {
  filter?: ModelSubscriptionGREmailsFilterInput | null,
};

export type OnDeleteGREmailsSubscription = {
  onDeleteGREmails?:  {
    __typename: "GREmails",
    id: string,
    companyId: string,
    status: boolean,
    name: string,
    email: string,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateRegionsSubscriptionVariables = {
  filter?: ModelSubscriptionRegionsFilterInput | null,
};

export type OnCreateRegionsSubscription = {
  onCreateRegions?:  {
    __typename: "Regions",
    id: string,
    status: boolean,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRegionsSubscriptionVariables = {
  filter?: ModelSubscriptionRegionsFilterInput | null,
};

export type OnUpdateRegionsSubscription = {
  onUpdateRegions?:  {
    __typename: "Regions",
    id: string,
    status: boolean,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteRegionsSubscriptionVariables = {
  filter?: ModelSubscriptionRegionsFilterInput | null,
};

export type OnDeleteRegionsSubscription = {
  onDeleteRegions?:  {
    __typename: "Regions",
    id: string,
    status: boolean,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateDefaultAddressSubscriptionVariables = {
  filter?: ModelSubscriptionDefaultAddressFilterInput | null,
};

export type OnCreateDefaultAddressSubscription = {
  onCreateDefaultAddress?:  {
    __typename: "DefaultAddress",
    id: string,
    companyId: string,
    userId?: string | null,
    status: boolean,
    address:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    },
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateDefaultAddressSubscriptionVariables = {
  filter?: ModelSubscriptionDefaultAddressFilterInput | null,
};

export type OnUpdateDefaultAddressSubscription = {
  onUpdateDefaultAddress?:  {
    __typename: "DefaultAddress",
    id: string,
    companyId: string,
    userId?: string | null,
    status: boolean,
    address:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    },
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteDefaultAddressSubscriptionVariables = {
  filter?: ModelSubscriptionDefaultAddressFilterInput | null,
};

export type OnDeleteDefaultAddressSubscription = {
  onDeleteDefaultAddress?:  {
    __typename: "DefaultAddress",
    id: string,
    companyId: string,
    userId?: string | null,
    status: boolean,
    address:  {
      __typename: "Address",
      street?: string | null,
      outdoor_number?: string | null,
      inside_number?: string | null,
      colony?: string | null,
      delegation?: string | null,
      state?: string | null,
      city?: string | null,
      postal_code?: string | null,
      chain?: string | null,
      name?: string | null,
      description?: string | null,
    },
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateDefaultDeliveryContactSubscriptionVariables = {
  filter?: ModelSubscriptionDefaultDeliveryContactFilterInput | null,
};

export type OnCreateDefaultDeliveryContactSubscription = {
  onCreateDefaultDeliveryContact?:  {
    __typename: "DefaultDeliveryContact",
    id: string,
    companyId?: string | null,
    userId?: string | null,
    status?: boolean | null,
    name?: string | null,
    phoneNumber?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateDefaultDeliveryContactSubscriptionVariables = {
  filter?: ModelSubscriptionDefaultDeliveryContactFilterInput | null,
};

export type OnUpdateDefaultDeliveryContactSubscription = {
  onUpdateDefaultDeliveryContact?:  {
    __typename: "DefaultDeliveryContact",
    id: string,
    companyId?: string | null,
    userId?: string | null,
    status?: boolean | null,
    name?: string | null,
    phoneNumber?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteDefaultDeliveryContactSubscriptionVariables = {
  filter?: ModelSubscriptionDefaultDeliveryContactFilterInput | null,
};

export type OnDeleteDefaultDeliveryContactSubscription = {
  onDeleteDefaultDeliveryContact?:  {
    __typename: "DefaultDeliveryContact",
    id: string,
    companyId?: string | null,
    userId?: string | null,
    status?: boolean | null,
    name?: string | null,
    phoneNumber?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreatePopCategoriesSubscriptionVariables = {
  filter?: ModelSubscriptionPopCategoriesFilterInput | null,
};

export type OnCreatePopCategoriesSubscription = {
  onCreatePopCategories?:  {
    __typename: "PopCategories",
    id: string,
    materialId: string,
    name: string,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePopCategoriesSubscriptionVariables = {
  filter?: ModelSubscriptionPopCategoriesFilterInput | null,
};

export type OnUpdatePopCategoriesSubscription = {
  onUpdatePopCategories?:  {
    __typename: "PopCategories",
    id: string,
    materialId: string,
    name: string,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePopCategoriesSubscriptionVariables = {
  filter?: ModelSubscriptionPopCategoriesFilterInput | null,
};

export type OnDeletePopCategoriesSubscription = {
  onDeletePopCategories?:  {
    __typename: "PopCategories",
    id: string,
    materialId: string,
    name: string,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    created: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateRfpSubscriptionVariables = {
  filter?: ModelSubscriptionRfpFilterInput | null,
};

export type OnCreateRfpSubscription = {
  onCreateRfp?:  {
    __typename: "Rfp",
    id: string,
    clientId?: string | null,
    status?: string | null,
    name?: string | null,
    nombre?: string | null,
    requerimiento?: string | null,
    estatus?: string | null,
    descripcion?: string | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    url?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    proposals?:  {
      __typename: "ModelRfpProposalsConnection",
      items:  Array< {
        __typename: "RfpProposals",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        name?: string | null,
        description?: string | null,
        validity_days?: number | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfp?:  {
          __typename: "Rfp",
          id: string,
          clientId?: string | null,
          status?: string | null,
          name?: string | null,
          nombre?: string | null,
          requerimiento?: string | null,
          estatus?: string | null,
          descripcion?: string | null,
          url?: string | null,
          limit_time: number,
          creator?: string | null,
          start_time: number,
          delivery_time?: number | null,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          created: number,
          createdAt?: string | null,
          updated?: number | null,
          updatedAt: string,
        } | null,
        rfpProposalsRfpId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    limit_time: number,
    creator?: string | null,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    providers?:  Array< {
      __typename: "RfpProviders",
      idProvider?: string | null,
    } | null > | null,
    start_time: number,
    delivery_time?: number | null,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    created: number,
    createdAt?: string | null,
    updated?: number | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateRfpSubscriptionVariables = {
  filter?: ModelSubscriptionRfpFilterInput | null,
};

export type OnUpdateRfpSubscription = {
  onUpdateRfp?:  {
    __typename: "Rfp",
    id: string,
    clientId?: string | null,
    status?: string | null,
    name?: string | null,
    nombre?: string | null,
    requerimiento?: string | null,
    estatus?: string | null,
    descripcion?: string | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    url?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    proposals?:  {
      __typename: "ModelRfpProposalsConnection",
      items:  Array< {
        __typename: "RfpProposals",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        name?: string | null,
        description?: string | null,
        validity_days?: number | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfp?:  {
          __typename: "Rfp",
          id: string,
          clientId?: string | null,
          status?: string | null,
          name?: string | null,
          nombre?: string | null,
          requerimiento?: string | null,
          estatus?: string | null,
          descripcion?: string | null,
          url?: string | null,
          limit_time: number,
          creator?: string | null,
          start_time: number,
          delivery_time?: number | null,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          created: number,
          createdAt?: string | null,
          updated?: number | null,
          updatedAt: string,
        } | null,
        rfpProposalsRfpId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    limit_time: number,
    creator?: string | null,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    providers?:  Array< {
      __typename: "RfpProviders",
      idProvider?: string | null,
    } | null > | null,
    start_time: number,
    delivery_time?: number | null,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    created: number,
    createdAt?: string | null,
    updated?: number | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteRfpSubscriptionVariables = {
  filter?: ModelSubscriptionRfpFilterInput | null,
};

export type OnDeleteRfpSubscription = {
  onDeleteRfp?:  {
    __typename: "Rfp",
    id: string,
    clientId?: string | null,
    status?: string | null,
    name?: string | null,
    nombre?: string | null,
    requerimiento?: string | null,
    estatus?: string | null,
    descripcion?: string | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    url?: string | null,
    creatorInfo?:  {
      __typename: "OrderCreator",
      name: string,
      email: string,
      avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      user_id: string,
    } | null,
    proposals?:  {
      __typename: "ModelRfpProposalsConnection",
      items:  Array< {
        __typename: "RfpProposals",
        id: string,
        provider_id: string,
        delivery_time:  {
          __typename: "Range",
          lower: number,
          upper: number,
        },
        price: number,
        name?: string | null,
        description?: string | null,
        validity_days?: number | null,
        comments?:  Array< {
          __typename: "Comment",
          text: string,
          created: number,
          creator_id: string,
          creator_name: string,
          creator_email: string,
          isSourceDataUser: boolean,
          replyTo?: string | null,
          role?: string | null,
          text_request?: string | null,
          nameUserReply?: string | null,
          jiraKey?: string | null,
        } | null > | null,
        chat?:  Array< {
          __typename: "RfqChat",
          role: string,
          is_reply?: boolean | null,
          to_user_id?: string | null,
          user_id: string,
          text: string,
          created: string,
        } | null > | null,
        created: number,
        updated?: number | null,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        products?:  Array< {
          __typename: "ProductsProposals",
          productUnitRfqIndex?: number | null,
          selected?: boolean | null,
          name?: string | null,
          description?: string | null,
          priceUnit?: number | null,
          pieces?: number | null,
          total?: number | null,
          idProducto?: number | null,
        } | null > | null,
        multipleProducts?: boolean | null,
        hidden?: boolean | null,
        rfp?:  {
          __typename: "Rfp",
          id: string,
          clientId?: string | null,
          status?: string | null,
          name?: string | null,
          nombre?: string | null,
          requerimiento?: string | null,
          estatus?: string | null,
          descripcion?: string | null,
          url?: string | null,
          limit_time: number,
          creator?: string | null,
          start_time: number,
          delivery_time?: number | null,
          saving?: number | null,
          saving_percentage?: number | null,
          saving_real?: number | null,
          created: number,
          createdAt?: string | null,
          updated?: number | null,
          updatedAt: string,
        } | null,
        rfpProposalsRfpId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    compras?:  {
      __typename: "Contact",
      first_name?: string | null,
      last_name?: string | null,
      email?: string | null,
      mobile_phone?: string | null,
      local_phone?: string | null,
    } | null,
    limit_time: number,
    creator?: string | null,
    winner?:  {
      __typename: "Winner",
      proveeedor_id: string,
      date: number,
    } | null,
    logs?:  Array< {
      __typename: "Logs",
      creatorId: string,
      description: string,
      date: number,
      status?: string | null,
      provider_id?: string | null,
    } | null > | null,
    providers?:  Array< {
      __typename: "RfpProviders",
      idProvider?: string | null,
    } | null > | null,
    start_time: number,
    delivery_time?: number | null,
    saving?: number | null,
    saving_percentage?: number | null,
    saving_real?: number | null,
    created: number,
    createdAt?: string | null,
    updated?: number | null,
    updatedAt: string,
  } | null,
};

export type OnCreateRfpProposalsSubscriptionVariables = {
  filter?: ModelSubscriptionRfpProposalsFilterInput | null,
};

export type OnCreateRfpProposalsSubscription = {
  onCreateRfpProposals?:  {
    __typename: "RfpProposals",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    name?: string | null,
    description?: string | null,
    validity_days?: number | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfp?:  {
      __typename: "Rfp",
      id: string,
      clientId?: string | null,
      status?: string | null,
      name?: string | null,
      nombre?: string | null,
      requerimiento?: string | null,
      estatus?: string | null,
      descripcion?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      url?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      proposals?:  {
        __typename: "ModelRfpProposalsConnection",
        items:  Array< {
          __typename: "RfpProposals",
          id: string,
          provider_id: string,
          price: number,
          name?: string | null,
          description?: string | null,
          validity_days?: number | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          rfpProposalsRfpId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      creator?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfpProviders",
        idProvider?: string | null,
      } | null > | null,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null,
    rfpProposalsRfpId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRfpProposalsSubscriptionVariables = {
  filter?: ModelSubscriptionRfpProposalsFilterInput | null,
};

export type OnUpdateRfpProposalsSubscription = {
  onUpdateRfpProposals?:  {
    __typename: "RfpProposals",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    name?: string | null,
    description?: string | null,
    validity_days?: number | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfp?:  {
      __typename: "Rfp",
      id: string,
      clientId?: string | null,
      status?: string | null,
      name?: string | null,
      nombre?: string | null,
      requerimiento?: string | null,
      estatus?: string | null,
      descripcion?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      url?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      proposals?:  {
        __typename: "ModelRfpProposalsConnection",
        items:  Array< {
          __typename: "RfpProposals",
          id: string,
          provider_id: string,
          price: number,
          name?: string | null,
          description?: string | null,
          validity_days?: number | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          rfpProposalsRfpId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      creator?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfpProviders",
        idProvider?: string | null,
      } | null > | null,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null,
    rfpProposalsRfpId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteRfpProposalsSubscriptionVariables = {
  filter?: ModelSubscriptionRfpProposalsFilterInput | null,
};

export type OnDeleteRfpProposalsSubscription = {
  onDeleteRfpProposals?:  {
    __typename: "RfpProposals",
    id: string,
    provider_id: string,
    delivery_time:  {
      __typename: "Range",
      lower: number,
      upper: number,
    },
    price: number,
    name?: string | null,
    description?: string | null,
    validity_days?: number | null,
    comments?:  Array< {
      __typename: "Comment",
      text: string,
      created: number,
      creator_id: string,
      creator_name: string,
      creator_email: string,
      isSourceDataUser: boolean,
      creator_avatar?:  {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        comertial_name: string,
        id: string,
      } | null,
      replyTo?: string | null,
      role?: string | null,
      text_request?: string | null,
      nameUserReply?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      jiraKey?: string | null,
    } | null > | null,
    chat?:  Array< {
      __typename: "RfqChat",
      role: string,
      is_reply?: boolean | null,
      to_user_id?: string | null,
      user_id: string,
      text: string,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      created: string,
    } | null > | null,
    created: number,
    updated?: number | null,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    products?:  Array< {
      __typename: "ProductsProposals",
      productUnitRfqIndex?: number | null,
      selected?: boolean | null,
      name?: string | null,
      description?: string | null,
      priceUnit?: number | null,
      pieces?: number | null,
      total?: number | null,
      idProducto?: number | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
    } | null > | null,
    multipleProducts?: boolean | null,
    hidden?: boolean | null,
    rfp?:  {
      __typename: "Rfp",
      id: string,
      clientId?: string | null,
      status?: string | null,
      name?: string | null,
      nombre?: string | null,
      requerimiento?: string | null,
      estatus?: string | null,
      descripcion?: string | null,
      files?:  Array< {
        __typename: "File",
        key?: string | null,
        url?: string | null,
        color?: string | null,
        palette?: string | null,
        colorName?: string | null,
      } | null > | null,
      chat?:  Array< {
        __typename: "RfqChat",
        role: string,
        is_reply?: boolean | null,
        to_user_id?: string | null,
        user_id: string,
        text: string,
        files?:  Array< {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null > | null,
        created: string,
      } | null > | null,
      url?: string | null,
      creatorInfo?:  {
        __typename: "OrderCreator",
        name: string,
        email: string,
        avatar?:  {
          __typename: "File",
          key?: string | null,
          url?: string | null,
          color?: string | null,
          palette?: string | null,
          colorName?: string | null,
        } | null,
        user_id: string,
      } | null,
      proposals?:  {
        __typename: "ModelRfpProposalsConnection",
        items:  Array< {
          __typename: "RfpProposals",
          id: string,
          provider_id: string,
          price: number,
          name?: string | null,
          description?: string | null,
          validity_days?: number | null,
          created: number,
          updated?: number | null,
          multipleProducts?: boolean | null,
          hidden?: boolean | null,
          rfpProposalsRfpId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      compras?:  {
        __typename: "Contact",
        first_name?: string | null,
        last_name?: string | null,
        email?: string | null,
        mobile_phone?: string | null,
        local_phone?: string | null,
      } | null,
      limit_time: number,
      creator?: string | null,
      winner?:  {
        __typename: "Winner",
        proveeedor_id: string,
        date: number,
      } | null,
      logs?:  Array< {
        __typename: "Logs",
        creatorId: string,
        description: string,
        date: number,
        status?: string | null,
        provider_id?: string | null,
      } | null > | null,
      providers?:  Array< {
        __typename: "RfpProviders",
        idProvider?: string | null,
      } | null > | null,
      start_time: number,
      delivery_time?: number | null,
      saving?: number | null,
      saving_percentage?: number | null,
      saving_real?: number | null,
      created: number,
      createdAt?: string | null,
      updated?: number | null,
      updatedAt: string,
    } | null,
    rfpProposalsRfpId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateEvaluationProvidersSubscriptionVariables = {
  filter?: ModelSubscriptionEvaluationProvidersFilterInput | null,
};

export type OnCreateEvaluationProvidersSubscription = {
  onCreateEvaluationProviders?:  {
    __typename: "EvaluationProviders",
    id: string,
    providerId?: string | null,
    creratorId?: string | null,
    orderId?: string | null,
    time?: number | null,
    price?: number | null,
    quality?: number | null,
    att?: number | null,
    comments?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEvaluationProvidersSubscriptionVariables = {
  filter?: ModelSubscriptionEvaluationProvidersFilterInput | null,
};

export type OnUpdateEvaluationProvidersSubscription = {
  onUpdateEvaluationProviders?:  {
    __typename: "EvaluationProviders",
    id: string,
    providerId?: string | null,
    creratorId?: string | null,
    orderId?: string | null,
    time?: number | null,
    price?: number | null,
    quality?: number | null,
    att?: number | null,
    comments?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEvaluationProvidersSubscriptionVariables = {
  filter?: ModelSubscriptionEvaluationProvidersFilterInput | null,
};

export type OnDeleteEvaluationProvidersSubscription = {
  onDeleteEvaluationProviders?:  {
    __typename: "EvaluationProviders",
    id: string,
    providerId?: string | null,
    creratorId?: string | null,
    orderId?: string | null,
    time?: number | null,
    price?: number | null,
    quality?: number | null,
    att?: number | null,
    comments?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLogProductSubscriptionVariables = {
  filter?: ModelSubscriptionLogProductFilterInput | null,
};

export type OnCreateLogProductSubscription = {
  onCreateLogProduct?:  {
    __typename: "LogProduct",
    id: string,
    status?: string | null,
    creator?: string | null,
    created?: string | null,
    productId?: string | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLogProductSubscriptionVariables = {
  filter?: ModelSubscriptionLogProductFilterInput | null,
};

export type OnUpdateLogProductSubscription = {
  onUpdateLogProduct?:  {
    __typename: "LogProduct",
    id: string,
    status?: string | null,
    creator?: string | null,
    created?: string | null,
    productId?: string | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLogProductSubscriptionVariables = {
  filter?: ModelSubscriptionLogProductFilterInput | null,
};

export type OnDeleteLogProductSubscription = {
  onDeleteLogProduct?:  {
    __typename: "LogProduct",
    id: string,
    status?: string | null,
    creator?: string | null,
    created?: string | null,
    productId?: string | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLogRfqSubscriptionVariables = {
  filter?: ModelSubscriptionLogRfqFilterInput | null,
};

export type OnCreateLogRfqSubscription = {
  onCreateLogRfq?:  {
    __typename: "LogRfq",
    id: string,
    status?: string | null,
    creator?: string | null,
    rfqId: string,
    description?: string | null,
    provider_id?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateLogRfqSubscriptionVariables = {
  filter?: ModelSubscriptionLogRfqFilterInput | null,
};

export type OnUpdateLogRfqSubscription = {
  onUpdateLogRfq?:  {
    __typename: "LogRfq",
    id: string,
    status?: string | null,
    creator?: string | null,
    rfqId: string,
    description?: string | null,
    provider_id?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteLogRfqSubscriptionVariables = {
  filter?: ModelSubscriptionLogRfqFilterInput | null,
};

export type OnDeleteLogRfqSubscription = {
  onDeleteLogRfq?:  {
    __typename: "LogRfq",
    id: string,
    status?: string | null,
    creator?: string | null,
    rfqId: string,
    description?: string | null,
    provider_id?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateLogProductLabelSubscriptionVariables = {
  filter?: ModelSubscriptionLogProductLabelFilterInput | null,
};

export type OnCreateLogProductLabelSubscription = {
  onCreateLogProductLabel?:  {
    __typename: "LogProductLabel",
    id: string,
    status?: string | null,
    creator?: string | null,
    created?: string | null,
    productLabelId?: string | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLogProductLabelSubscriptionVariables = {
  filter?: ModelSubscriptionLogProductLabelFilterInput | null,
};

export type OnUpdateLogProductLabelSubscription = {
  onUpdateLogProductLabel?:  {
    __typename: "LogProductLabel",
    id: string,
    status?: string | null,
    creator?: string | null,
    created?: string | null,
    productLabelId?: string | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLogProductLabelSubscriptionVariables = {
  filter?: ModelSubscriptionLogProductLabelFilterInput | null,
};

export type OnDeleteLogProductLabelSubscription = {
  onDeleteLogProductLabel?:  {
    __typename: "LogProductLabel",
    id: string,
    status?: string | null,
    creator?: string | null,
    created?: string | null,
    productLabelId?: string | null,
    description?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLogGanadorAutoSubscriptionVariables = {
  filter?: ModelSubscriptionLogGanadorAutoFilterInput | null,
};

export type OnCreateLogGanadorAutoSubscription = {
  onCreateLogGanadorAuto?:  {
    __typename: "LogGanadorAuto",
    id: string,
    id_auto?: string | null,
    id_user?: string | null,
    fecha_rifa?: number | null,
    email?: string | null,
    nombre?: string | null,
    a_paterno?: string | null,
    a_materno?: string | null,
    status_buyer?: boolean | null,
    date_buyer?: number | null,
    winner?: number | null,
    refused?: number | null,
    since?: string | null,
    process_buyer?: boolean | null,
    reactive?: boolean | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLogGanadorAutoSubscriptionVariables = {
  filter?: ModelSubscriptionLogGanadorAutoFilterInput | null,
};

export type OnUpdateLogGanadorAutoSubscription = {
  onUpdateLogGanadorAuto?:  {
    __typename: "LogGanadorAuto",
    id: string,
    id_auto?: string | null,
    id_user?: string | null,
    fecha_rifa?: number | null,
    email?: string | null,
    nombre?: string | null,
    a_paterno?: string | null,
    a_materno?: string | null,
    status_buyer?: boolean | null,
    date_buyer?: number | null,
    winner?: number | null,
    refused?: number | null,
    since?: string | null,
    process_buyer?: boolean | null,
    reactive?: boolean | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLogGanadorAutoSubscriptionVariables = {
  filter?: ModelSubscriptionLogGanadorAutoFilterInput | null,
};

export type OnDeleteLogGanadorAutoSubscription = {
  onDeleteLogGanadorAuto?:  {
    __typename: "LogGanadorAuto",
    id: string,
    id_auto?: string | null,
    id_user?: string | null,
    fecha_rifa?: number | null,
    email?: string | null,
    nombre?: string | null,
    a_paterno?: string | null,
    a_materno?: string | null,
    status_buyer?: boolean | null,
    date_buyer?: number | null,
    winner?: number | null,
    refused?: number | null,
    since?: string | null,
    process_buyer?: boolean | null,
    reactive?: boolean | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionNotificationFilterInput | null,
};

export type OnCreateNotificationSubscription = {
  onCreateNotification?:  {
    __typename: "Notification",
    id: string,
    type: string,
    remember?: string | null,
    stared?: string | null,
    important?: string | null,
    status?: string | null,
    isChat?: string | null,
    creatorName: string,
    creatorEmail: string,
    creatorRole?: string | null,
    creatorId: string,
    receipentName: string,
    receipentRole?: string | null,
    receipentEmail?: string | null,
    receipentId: string,
    showPopUp?: boolean | null,
    sendEmail?: boolean | null,
    title: string,
    subtitle: string,
    description: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    path?: string | null,
    idParent?: string | null,
    createdAt?: string | null,
    seenAt?: number | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionNotificationFilterInput | null,
};

export type OnUpdateNotificationSubscription = {
  onUpdateNotification?:  {
    __typename: "Notification",
    id: string,
    type: string,
    remember?: string | null,
    stared?: string | null,
    important?: string | null,
    status?: string | null,
    isChat?: string | null,
    creatorName: string,
    creatorEmail: string,
    creatorRole?: string | null,
    creatorId: string,
    receipentName: string,
    receipentRole?: string | null,
    receipentEmail?: string | null,
    receipentId: string,
    showPopUp?: boolean | null,
    sendEmail?: boolean | null,
    title: string,
    subtitle: string,
    description: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    path?: string | null,
    idParent?: string | null,
    createdAt?: string | null,
    seenAt?: number | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionNotificationFilterInput | null,
};

export type OnDeleteNotificationSubscription = {
  onDeleteNotification?:  {
    __typename: "Notification",
    id: string,
    type: string,
    remember?: string | null,
    stared?: string | null,
    important?: string | null,
    status?: string | null,
    isChat?: string | null,
    creatorName: string,
    creatorEmail: string,
    creatorRole?: string | null,
    creatorId: string,
    receipentName: string,
    receipentRole?: string | null,
    receipentEmail?: string | null,
    receipentId: string,
    showPopUp?: boolean | null,
    sendEmail?: boolean | null,
    title: string,
    subtitle: string,
    description: string,
    files?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    path?: string | null,
    idParent?: string | null,
    createdAt?: string | null,
    seenAt?: number | null,
    updatedAt: string,
  } | null,
};

export type OnCreateMercadoCategoriesSubscriptionVariables = {
  filter?: ModelSubscriptionMercadoCategoriesFilterInput | null,
};

export type OnCreateMercadoCategoriesSubscription = {
  onCreateMercadoCategories?:  {
    __typename: "MercadoCategories",
    id: string,
    idMercado?: string | null,
    status?: string | null,
    name?: string | null,
    rulesClients?:  Array< {
      __typename: "MercadoCategoryClientRule",
      clientID?: string | null,
      enabled?: boolean | null,
      isUnrestricted?: boolean | null,
      isRestricted?: boolean | null,
      increment?: number | null,
      fee?: number | null,
    } | null > | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    parentCategory?: string | null,
    childrenCategories?: Array< string | null > | null,
    items?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMercadoCategoriesSubscriptionVariables = {
  filter?: ModelSubscriptionMercadoCategoriesFilterInput | null,
};

export type OnUpdateMercadoCategoriesSubscription = {
  onUpdateMercadoCategories?:  {
    __typename: "MercadoCategories",
    id: string,
    idMercado?: string | null,
    status?: string | null,
    name?: string | null,
    rulesClients?:  Array< {
      __typename: "MercadoCategoryClientRule",
      clientID?: string | null,
      enabled?: boolean | null,
      isUnrestricted?: boolean | null,
      isRestricted?: boolean | null,
      increment?: number | null,
      fee?: number | null,
    } | null > | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    parentCategory?: string | null,
    childrenCategories?: Array< string | null > | null,
    items?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMercadoCategoriesSubscriptionVariables = {
  filter?: ModelSubscriptionMercadoCategoriesFilterInput | null,
};

export type OnDeleteMercadoCategoriesSubscription = {
  onDeleteMercadoCategories?:  {
    __typename: "MercadoCategories",
    id: string,
    idMercado?: string | null,
    status?: string | null,
    name?: string | null,
    rulesClients?:  Array< {
      __typename: "MercadoCategoryClientRule",
      clientID?: string | null,
      enabled?: boolean | null,
      isUnrestricted?: boolean | null,
      isRestricted?: boolean | null,
      increment?: number | null,
      fee?: number | null,
    } | null > | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    parentCategory?: string | null,
    childrenCategories?: Array< string | null > | null,
    items?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateMercadoProductCategoryClientSubscriptionVariables = {
  filter?: ModelSubscriptionMercadoProductCategoryClientFilterInput | null,
};

export type OnCreateMercadoProductCategoryClientSubscription = {
  onCreateMercadoProductCategoryClient?:  {
    __typename: "MercadoProductCategoryClient",
    id: string,
    idClient?: string | null,
    idMercadoCategory?: string | null,
    unrestrictedProducts?: Array< string | null > | null,
    restrictedProducts?: Array< string | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMercadoProductCategoryClientSubscriptionVariables = {
  filter?: ModelSubscriptionMercadoProductCategoryClientFilterInput | null,
};

export type OnUpdateMercadoProductCategoryClientSubscription = {
  onUpdateMercadoProductCategoryClient?:  {
    __typename: "MercadoProductCategoryClient",
    id: string,
    idClient?: string | null,
    idMercadoCategory?: string | null,
    unrestrictedProducts?: Array< string | null > | null,
    restrictedProducts?: Array< string | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMercadoProductCategoryClientSubscriptionVariables = {
  filter?: ModelSubscriptionMercadoProductCategoryClientFilterInput | null,
};

export type OnDeleteMercadoProductCategoryClientSubscription = {
  onDeleteMercadoProductCategoryClient?:  {
    __typename: "MercadoProductCategoryClient",
    id: string,
    idClient?: string | null,
    idMercadoCategory?: string | null,
    unrestrictedProducts?: Array< string | null > | null,
    restrictedProducts?: Array< string | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateExternalApisSubscriptionVariables = {
  filter?: ModelSubscriptionExternalApisFilterInput | null,
};

export type OnCreateExternalApisSubscription = {
  onCreateExternalApis?:  {
    __typename: "ExternalApis",
    id: string,
    status?: string | null,
    name?: string | null,
    nameExternal?: string | null,
    region?: Array< string | null > | null,
    increment?: number | null,
    discount?: number | null,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateExternalApisSubscriptionVariables = {
  filter?: ModelSubscriptionExternalApisFilterInput | null,
};

export type OnUpdateExternalApisSubscription = {
  onUpdateExternalApis?:  {
    __typename: "ExternalApis",
    id: string,
    status?: string | null,
    name?: string | null,
    nameExternal?: string | null,
    region?: Array< string | null > | null,
    increment?: number | null,
    discount?: number | null,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteExternalApisSubscriptionVariables = {
  filter?: ModelSubscriptionExternalApisFilterInput | null,
};

export type OnDeleteExternalApisSubscription = {
  onDeleteExternalApis?:  {
    __typename: "ExternalApis",
    id: string,
    status?: string | null,
    name?: string | null,
    nameExternal?: string | null,
    region?: Array< string | null > | null,
    increment?: number | null,
    discount?: number | null,
    visibleFor?: Array< string | null > | null,
    clientDiscounts?:  Array< {
      __typename: "ClientDiscountPercents",
      index?: number | null,
      clientId?: string | null,
      minUnits?: number | null,
      maxUnits?: number | null,
      percent?: number | null,
    } | null > | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePrintPricesSubscriptionVariables = {
  filter?: ModelSubscriptionPrintPricesFilterInput | null,
};

export type OnCreatePrintPricesSubscription = {
  onCreatePrintPrices?:  {
    __typename: "PrintPrices",
    id: string,
    identifier?: number | null,
    status?: string | null,
    creator?: string | null,
    description?: string | null,
    price?: number | null,
    minUnits?: number | null,
    maxUnits?: number | null,
    ranges?:  Array< {
      __typename: "PrintPriceRange",
      price?: number | null,
      minUnits?: number | null,
      maxUnits?: number | null,
    } | null > | null,
    clientPrintPrices?:  Array< {
      __typename: "ClientPrintPrice",
      clientId?: string | null,
      price?: number | null,
      minUnits?: number | null,
      maxUnits?: number | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePrintPricesSubscriptionVariables = {
  filter?: ModelSubscriptionPrintPricesFilterInput | null,
};

export type OnUpdatePrintPricesSubscription = {
  onUpdatePrintPrices?:  {
    __typename: "PrintPrices",
    id: string,
    identifier?: number | null,
    status?: string | null,
    creator?: string | null,
    description?: string | null,
    price?: number | null,
    minUnits?: number | null,
    maxUnits?: number | null,
    ranges?:  Array< {
      __typename: "PrintPriceRange",
      price?: number | null,
      minUnits?: number | null,
      maxUnits?: number | null,
    } | null > | null,
    clientPrintPrices?:  Array< {
      __typename: "ClientPrintPrice",
      clientId?: string | null,
      price?: number | null,
      minUnits?: number | null,
      maxUnits?: number | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePrintPricesSubscriptionVariables = {
  filter?: ModelSubscriptionPrintPricesFilterInput | null,
};

export type OnDeletePrintPricesSubscription = {
  onDeletePrintPrices?:  {
    __typename: "PrintPrices",
    id: string,
    identifier?: number | null,
    status?: string | null,
    creator?: string | null,
    description?: string | null,
    price?: number | null,
    minUnits?: number | null,
    maxUnits?: number | null,
    ranges?:  Array< {
      __typename: "PrintPriceRange",
      price?: number | null,
      minUnits?: number | null,
      maxUnits?: number | null,
    } | null > | null,
    clientPrintPrices?:  Array< {
      __typename: "ClientPrintPrice",
      clientId?: string | null,
      price?: number | null,
      minUnits?: number | null,
      maxUnits?: number | null,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePrintLogosSubscriptionVariables = {
  filter?: ModelSubscriptionPrintLogosFilterInput | null,
};

export type OnCreatePrintLogosSubscription = {
  onCreatePrintLogos?:  {
    __typename: "PrintLogos",
    id: string,
    status?: string | null,
    creator?: string | null,
    description?: string | null,
    identifier?: number | null,
    clientId?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdatePrintLogosSubscriptionVariables = {
  filter?: ModelSubscriptionPrintLogosFilterInput | null,
};

export type OnUpdatePrintLogosSubscription = {
  onUpdatePrintLogos?:  {
    __typename: "PrintLogos",
    id: string,
    status?: string | null,
    creator?: string | null,
    description?: string | null,
    identifier?: number | null,
    clientId?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type OnDeletePrintLogosSubscriptionVariables = {
  filter?: ModelSubscriptionPrintLogosFilterInput | null,
};

export type OnDeletePrintLogosSubscription = {
  onDeletePrintLogos?:  {
    __typename: "PrintLogos",
    id: string,
    status?: string | null,
    creator?: string | null,
    description?: string | null,
    identifier?: number | null,
    clientId?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    createdAt: string,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateLogisticPostalCodeSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticPostalCodeFilterInput | null,
};

export type OnCreateLogisticPostalCodeSubscription = {
  onCreateLogisticPostalCode?:  {
    __typename: "LogisticPostalCode",
    id: string,
    cpFrom: string,
    cpTo: string,
    zone: number,
    state: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLogisticPostalCodeSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticPostalCodeFilterInput | null,
};

export type OnUpdateLogisticPostalCodeSubscription = {
  onUpdateLogisticPostalCode?:  {
    __typename: "LogisticPostalCode",
    id: string,
    cpFrom: string,
    cpTo: string,
    zone: number,
    state: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLogisticPostalCodeSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticPostalCodeFilterInput | null,
};

export type OnDeleteLogisticPostalCodeSubscription = {
  onDeleteLogisticPostalCode?:  {
    __typename: "LogisticPostalCode",
    id: string,
    cpFrom: string,
    cpTo: string,
    zone: number,
    state: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLogisticPieceRangeSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticPieceRangeFilterInput | null,
};

export type OnCreateLogisticPieceRangeSubscription = {
  onCreateLogisticPieceRange?:  {
    __typename: "LogisticPieceRange",
    id: string,
    piecesRange: number,
    min: number,
    max: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLogisticPieceRangeSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticPieceRangeFilterInput | null,
};

export type OnUpdateLogisticPieceRangeSubscription = {
  onUpdateLogisticPieceRange?:  {
    __typename: "LogisticPieceRange",
    id: string,
    piecesRange: number,
    min: number,
    max: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLogisticPieceRangeSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticPieceRangeFilterInput | null,
};

export type OnDeleteLogisticPieceRangeSubscription = {
  onDeleteLogisticPieceRange?:  {
    __typename: "LogisticPieceRange",
    id: string,
    piecesRange: number,
    min: number,
    max: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLogisticWeightRangeSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticWeightRangeFilterInput | null,
};

export type OnCreateLogisticWeightRangeSubscription = {
  onCreateLogisticWeightRange?:  {
    __typename: "LogisticWeightRange",
    id: string,
    weightRange: number,
    min: number,
    max: number,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLogisticWeightRangeSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticWeightRangeFilterInput | null,
};

export type OnUpdateLogisticWeightRangeSubscription = {
  onUpdateLogisticWeightRange?:  {
    __typename: "LogisticWeightRange",
    id: string,
    weightRange: number,
    min: number,
    max: number,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLogisticWeightRangeSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticWeightRangeFilterInput | null,
};

export type OnDeleteLogisticWeightRangeSubscription = {
  onDeleteLogisticWeightRange?:  {
    __typename: "LogisticWeightRange",
    id: string,
    weightRange: number,
    min: number,
    max: number,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLogisticWeightBoxSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticWeightBoxFilterInput | null,
};

export type OnCreateLogisticWeightBoxSubscription = {
  onCreateLogisticWeightBox?:  {
    __typename: "LogisticWeightBox",
    id: string,
    boxId?: string | null,
    shippingPrices?:  Array< {
      __typename: "LogisticWeightPrice",
      weightRangeId?: string | null,
      price: number,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLogisticWeightBoxSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticWeightBoxFilterInput | null,
};

export type OnUpdateLogisticWeightBoxSubscription = {
  onUpdateLogisticWeightBox?:  {
    __typename: "LogisticWeightBox",
    id: string,
    boxId?: string | null,
    shippingPrices?:  Array< {
      __typename: "LogisticWeightPrice",
      weightRangeId?: string | null,
      price: number,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLogisticWeightBoxSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticWeightBoxFilterInput | null,
};

export type OnDeleteLogisticWeightBoxSubscription = {
  onDeleteLogisticWeightBox?:  {
    __typename: "LogisticWeightBox",
    id: string,
    boxId?: string | null,
    shippingPrices?:  Array< {
      __typename: "LogisticWeightPrice",
      weightRangeId?: string | null,
      price: number,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLogisticZoneSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticZoneFilterInput | null,
};

export type OnCreateLogisticZoneSubscription = {
  onCreateLogisticZone?:  {
    __typename: "LogisticZone",
    id: string,
    zoneName: string,
    shippingPrices?:  Array< {
      __typename: "LogisticShippingPrice",
      piecesRangeId?: string | null,
      price: number,
    } | null > | null,
    clientsRanges?:  Array< {
      __typename: "LogisticPieceRangeClient",
      id: string,
      clientId: string,
      piecesRange: string,
      price: number,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLogisticZoneSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticZoneFilterInput | null,
};

export type OnUpdateLogisticZoneSubscription = {
  onUpdateLogisticZone?:  {
    __typename: "LogisticZone",
    id: string,
    zoneName: string,
    shippingPrices?:  Array< {
      __typename: "LogisticShippingPrice",
      piecesRangeId?: string | null,
      price: number,
    } | null > | null,
    clientsRanges?:  Array< {
      __typename: "LogisticPieceRangeClient",
      id: string,
      clientId: string,
      piecesRange: string,
      price: number,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLogisticZoneSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticZoneFilterInput | null,
};

export type OnDeleteLogisticZoneSubscription = {
  onDeleteLogisticZone?:  {
    __typename: "LogisticZone",
    id: string,
    zoneName: string,
    shippingPrices?:  Array< {
      __typename: "LogisticShippingPrice",
      piecesRangeId?: string | null,
      price: number,
    } | null > | null,
    clientsRanges?:  Array< {
      __typename: "LogisticPieceRangeClient",
      id: string,
      clientId: string,
      piecesRange: string,
      price: number,
    } | null > | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLogisticBoxSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticBoxFilterInput | null,
};

export type OnCreateLogisticBoxSubscription = {
  onCreateLogisticBox?:  {
    __typename: "LogisticBox",
    id: string,
    status?: string | null,
    name?: string | null,
    description?: string | null,
    price?: number | null,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    volumetricWeight?: number | null,
    maxWeight?: number | null,
    maxPayload?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateLogisticBoxSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticBoxFilterInput | null,
};

export type OnUpdateLogisticBoxSubscription = {
  onUpdateLogisticBox?:  {
    __typename: "LogisticBox",
    id: string,
    status?: string | null,
    name?: string | null,
    description?: string | null,
    price?: number | null,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    volumetricWeight?: number | null,
    maxWeight?: number | null,
    maxPayload?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteLogisticBoxSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticBoxFilterInput | null,
};

export type OnDeleteLogisticBoxSubscription = {
  onDeleteLogisticBox?:  {
    __typename: "LogisticBox",
    id: string,
    status?: string | null,
    name?: string | null,
    description?: string | null,
    price?: number | null,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    volumetricWeight?: number | null,
    maxWeight?: number | null,
    maxPayload?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateLogisticVehiclesSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticVehiclesFilterInput | null,
};

export type OnCreateLogisticVehiclesSubscription = {
  onCreateLogisticVehicles?:  {
    __typename: "LogisticVehicles",
    id: string,
    status?: string | null,
    licensePlate?: string | null,
    hasInsurancePolicy?: string | null,
    fuelCapacity?: number | null,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    maxWeight?: number | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLogisticVehiclesSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticVehiclesFilterInput | null,
};

export type OnUpdateLogisticVehiclesSubscription = {
  onUpdateLogisticVehicles?:  {
    __typename: "LogisticVehicles",
    id: string,
    status?: string | null,
    licensePlate?: string | null,
    hasInsurancePolicy?: string | null,
    fuelCapacity?: number | null,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    maxWeight?: number | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLogisticVehiclesSubscriptionVariables = {
  filter?: ModelSubscriptionLogisticVehiclesFilterInput | null,
};

export type OnDeleteLogisticVehiclesSubscription = {
  onDeleteLogisticVehicles?:  {
    __typename: "LogisticVehicles",
    id: string,
    status?: string | null,
    licensePlate?: string | null,
    hasInsurancePolicy?: string | null,
    fuelCapacity?: number | null,
    width?: number | null,
    height?: number | null,
    depth?: number | null,
    maxWeight?: number | null,
    created: number,
    updated?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePakmailCarrierSubscriptionVariables = {
  filter?: ModelSubscriptionPakmailCarrierFilterInput | null,
};

export type OnCreatePakmailCarrierSubscription = {
  onCreatePakmailCarrier?:  {
    __typename: "PakmailCarrier",
    id: string,
    status?: string | null,
    identifier?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdatePakmailCarrierSubscriptionVariables = {
  filter?: ModelSubscriptionPakmailCarrierFilterInput | null,
};

export type OnUpdatePakmailCarrierSubscription = {
  onUpdatePakmailCarrier?:  {
    __typename: "PakmailCarrier",
    id: string,
    status?: string | null,
    identifier?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeletePakmailCarrierSubscriptionVariables = {
  filter?: ModelSubscriptionPakmailCarrierFilterInput | null,
};

export type OnDeletePakmailCarrierSubscription = {
  onDeletePakmailCarrier?:  {
    __typename: "PakmailCarrier",
    id: string,
    status?: string | null,
    identifier?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreatePakmailServiceSubscriptionVariables = {
  filter?: ModelSubscriptionPakmailServiceFilterInput | null,
};

export type OnCreatePakmailServiceSubscription = {
  onCreatePakmailService?:  {
    __typename: "PakmailService",
    id: string,
    status?: string | null,
    identifier?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    isNational?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdatePakmailServiceSubscriptionVariables = {
  filter?: ModelSubscriptionPakmailServiceFilterInput | null,
};

export type OnUpdatePakmailServiceSubscription = {
  onUpdatePakmailService?:  {
    __typename: "PakmailService",
    id: string,
    status?: string | null,
    identifier?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    isNational?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeletePakmailServiceSubscriptionVariables = {
  filter?: ModelSubscriptionPakmailServiceFilterInput | null,
};

export type OnDeletePakmailServiceSubscription = {
  onDeletePakmailService?:  {
    __typename: "PakmailService",
    id: string,
    status?: string | null,
    identifier?: string | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    clientFeeIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    clientIncrements?:  Array< {
      __typename: "ClientFeePercents",
      index?: number | null,
      clientId?: string | null,
      percent?: number | null,
    } | null > | null,
    visibleFor?: Array< string | null > | null,
    region?: Array< string | null > | null,
    isNational?: boolean | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreatePakmailShipmentStatusSubscriptionVariables = {
  filter?: ModelSubscriptionPakmailShipmentStatusFilterInput | null,
};

export type OnCreatePakmailShipmentStatusSubscription = {
  onCreatePakmailShipmentStatus?:  {
    __typename: "PakmailShipmentStatus",
    id: string,
    status?: string | null,
    identifier?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdatePakmailShipmentStatusSubscriptionVariables = {
  filter?: ModelSubscriptionPakmailShipmentStatusFilterInput | null,
};

export type OnUpdatePakmailShipmentStatusSubscription = {
  onUpdatePakmailShipmentStatus?:  {
    __typename: "PakmailShipmentStatus",
    id: string,
    status?: string | null,
    identifier?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeletePakmailShipmentStatusSubscriptionVariables = {
  filter?: ModelSubscriptionPakmailShipmentStatusFilterInput | null,
};

export type OnDeletePakmailShipmentStatusSubscription = {
  onDeletePakmailShipmentStatus?:  {
    __typename: "PakmailShipmentStatus",
    id: string,
    status?: string | null,
    identifier?: number | null,
    image?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    visibleFor?: Array< string | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreatePakmailShipmentEventSubscriptionVariables = {
  filter?: ModelSubscriptionPakmailShipmentEventFilterInput | null,
};

export type OnCreatePakmailShipmentEventSubscription = {
  onCreatePakmailShipmentEvent?:  {
    __typename: "PakmailShipmentEvent",
    id: string,
    status?: string | null,
    identifier?: string | null,
    visibleFor?: Array< string | null > | null,
    color?: string | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdatePakmailShipmentEventSubscriptionVariables = {
  filter?: ModelSubscriptionPakmailShipmentEventFilterInput | null,
};

export type OnUpdatePakmailShipmentEventSubscription = {
  onUpdatePakmailShipmentEvent?:  {
    __typename: "PakmailShipmentEvent",
    id: string,
    status?: string | null,
    identifier?: string | null,
    visibleFor?: Array< string | null > | null,
    color?: string | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeletePakmailShipmentEventSubscriptionVariables = {
  filter?: ModelSubscriptionPakmailShipmentEventFilterInput | null,
};

export type OnDeletePakmailShipmentEventSubscription = {
  onDeletePakmailShipmentEvent?:  {
    __typename: "PakmailShipmentEvent",
    id: string,
    status?: string | null,
    identifier?: string | null,
    visibleFor?: Array< string | null > | null,
    color?: string | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreatePakmailPickupStatusSubscriptionVariables = {
  filter?: ModelSubscriptionPakmailPickupStatusFilterInput | null,
};

export type OnCreatePakmailPickupStatusSubscription = {
  onCreatePakmailPickupStatus?:  {
    __typename: "PakmailPickupStatus",
    id: string,
    status?: string | null,
    identifier?: number | null,
    visibleFor?: Array< string | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdatePakmailPickupStatusSubscriptionVariables = {
  filter?: ModelSubscriptionPakmailPickupStatusFilterInput | null,
};

export type OnUpdatePakmailPickupStatusSubscription = {
  onUpdatePakmailPickupStatus?:  {
    __typename: "PakmailPickupStatus",
    id: string,
    status?: string | null,
    identifier?: number | null,
    visibleFor?: Array< string | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeletePakmailPickupStatusSubscriptionVariables = {
  filter?: ModelSubscriptionPakmailPickupStatusFilterInput | null,
};

export type OnDeletePakmailPickupStatusSubscription = {
  onDeletePakmailPickupStatus?:  {
    __typename: "PakmailPickupStatus",
    id: string,
    status?: string | null,
    identifier?: number | null,
    visibleFor?: Array< string | null > | null,
    notifications?:  Array< {
      __typename: "NotificationSubprocesses",
      group?: string | null,
      enabledEmail?: boolean | null,
      enabledPopUp?: boolean | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreatePremiumOrderLogisticGuideSubscriptionVariables = {
  filter?: ModelSubscriptionPremiumOrderLogisticGuideFilterInput | null,
};

export type OnCreatePremiumOrderLogisticGuideSubscription = {
  onCreatePremiumOrderLogisticGuide?:  {
    __typename: "PremiumOrderLogisticGuide",
    id: string,
    type: LogisticGuideType,
    pakmailId?: string | null,
    premiumOrderId: string,
    clientId: string,
    creatorId: string,
    originAddressId?: string | null,
    destinationAddressId?: string | null,
    originAddress?: string | null,
    destinationAddress?: string | null,
    products?:  Array< {
      __typename: "LogisticGuideProduct",
      indexProduct: number,
      productId: string,
      quantity: number,
      unitWidth: number,
      unitHeight: number,
      unitDepth: number,
      unitWeight: number,
    } | null > | null,
    price?: number | null,
    increment?: number | null,
    fee?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdatePremiumOrderLogisticGuideSubscriptionVariables = {
  filter?: ModelSubscriptionPremiumOrderLogisticGuideFilterInput | null,
};

export type OnUpdatePremiumOrderLogisticGuideSubscription = {
  onUpdatePremiumOrderLogisticGuide?:  {
    __typename: "PremiumOrderLogisticGuide",
    id: string,
    type: LogisticGuideType,
    pakmailId?: string | null,
    premiumOrderId: string,
    clientId: string,
    creatorId: string,
    originAddressId?: string | null,
    destinationAddressId?: string | null,
    originAddress?: string | null,
    destinationAddress?: string | null,
    products?:  Array< {
      __typename: "LogisticGuideProduct",
      indexProduct: number,
      productId: string,
      quantity: number,
      unitWidth: number,
      unitHeight: number,
      unitDepth: number,
      unitWeight: number,
    } | null > | null,
    price?: number | null,
    increment?: number | null,
    fee?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeletePremiumOrderLogisticGuideSubscriptionVariables = {
  filter?: ModelSubscriptionPremiumOrderLogisticGuideFilterInput | null,
};

export type OnDeletePremiumOrderLogisticGuideSubscription = {
  onDeletePremiumOrderLogisticGuide?:  {
    __typename: "PremiumOrderLogisticGuide",
    id: string,
    type: LogisticGuideType,
    pakmailId?: string | null,
    premiumOrderId: string,
    clientId: string,
    creatorId: string,
    originAddressId?: string | null,
    destinationAddressId?: string | null,
    originAddress?: string | null,
    destinationAddress?: string | null,
    products?:  Array< {
      __typename: "LogisticGuideProduct",
      indexProduct: number,
      productId: string,
      quantity: number,
      unitWidth: number,
      unitHeight: number,
      unitDepth: number,
      unitWeight: number,
    } | null > | null,
    price?: number | null,
    increment?: number | null,
    fee?: number | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateProductLabelItemSubscriptionVariables = {
  filter?: ModelSubscriptionProductLabelItemFilterInput | null,
};

export type OnCreateProductLabelItemSubscription = {
  onCreateProductLabelItem?:  {
    __typename: "ProductLabelItem",
    id: string,
    productId?: string | null,
    productLabelId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateProductLabelItemSubscriptionVariables = {
  filter?: ModelSubscriptionProductLabelItemFilterInput | null,
};

export type OnUpdateProductLabelItemSubscription = {
  onUpdateProductLabelItem?:  {
    __typename: "ProductLabelItem",
    id: string,
    productId?: string | null,
    productLabelId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteProductLabelItemSubscriptionVariables = {
  filter?: ModelSubscriptionProductLabelItemFilterInput | null,
};

export type OnDeleteProductLabelItemSubscription = {
  onDeleteProductLabelItem?:  {
    __typename: "ProductLabelItem",
    id: string,
    productId?: string | null,
    productLabelId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateProductLabelSubscriptionVariables = {
  filter?: ModelSubscriptionProductLabelFilterInput | null,
};

export type OnCreateProductLabelSubscription = {
  onCreateProductLabel?:  {
    __typename: "ProductLabel",
    id: string,
    name?: string | null,
    translation?: string | null,
    status?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateProductLabelSubscriptionVariables = {
  filter?: ModelSubscriptionProductLabelFilterInput | null,
};

export type OnUpdateProductLabelSubscription = {
  onUpdateProductLabel?:  {
    __typename: "ProductLabel",
    id: string,
    name?: string | null,
    translation?: string | null,
    status?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteProductLabelSubscriptionVariables = {
  filter?: ModelSubscriptionProductLabelFilterInput | null,
};

export type OnDeleteProductLabelSubscription = {
  onDeleteProductLabel?:  {
    __typename: "ProductLabel",
    id: string,
    name?: string | null,
    translation?: string | null,
    status?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateProductTextItemSubscriptionVariables = {
  filter?: ModelSubscriptionProductTextItemFilterInput | null,
};

export type OnCreateProductTextItemSubscription = {
  onCreateProductTextItem?:  {
    __typename: "ProductTextItem",
    id: string,
    productId?: string | null,
    productTextId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateProductTextItemSubscriptionVariables = {
  filter?: ModelSubscriptionProductTextItemFilterInput | null,
};

export type OnUpdateProductTextItemSubscription = {
  onUpdateProductTextItem?:  {
    __typename: "ProductTextItem",
    id: string,
    productId?: string | null,
    productTextId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteProductTextItemSubscriptionVariables = {
  filter?: ModelSubscriptionProductTextItemFilterInput | null,
};

export type OnDeleteProductTextItemSubscription = {
  onDeleteProductTextItem?:  {
    __typename: "ProductTextItem",
    id: string,
    productId?: string | null,
    productTextId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateProductTextSubscriptionVariables = {
  filter?: ModelSubscriptionProductTextFilterInput | null,
};

export type OnCreateProductTextSubscription = {
  onCreateProductText?:  {
    __typename: "ProductText",
    id: string,
    name?: string | null,
    status?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateProductTextSubscriptionVariables = {
  filter?: ModelSubscriptionProductTextFilterInput | null,
};

export type OnUpdateProductTextSubscription = {
  onUpdateProductText?:  {
    __typename: "ProductText",
    id: string,
    name?: string | null,
    status?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteProductTextSubscriptionVariables = {
  filter?: ModelSubscriptionProductTextFilterInput | null,
};

export type OnDeleteProductTextSubscription = {
  onDeleteProductText?:  {
    __typename: "ProductText",
    id: string,
    name?: string | null,
    status?: string | null,
    visibleFor?: Array< string | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateProductMaskSubscriptionVariables = {
  filter?: ModelSubscriptionProductMaskFilterInput | null,
};

export type OnCreateProductMaskSubscription = {
  onCreateProductMask?:  {
    __typename: "ProductMask",
    id: string,
    name?: string | null,
    sku?: string | null,
    productId?: string | null,
    clientId?: string | null,
    filterColors?: Array< string | null > | null,
    mainImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    increment?: number | null,
    fee?: number | null,
    discount?: number | null,
    stock?: number | null,
    categoryId?: string | null,
    sellMode?: ProductMaskSellMode | null,
    kitPieces?: number | null,
    kitIncrement?: number | null,
    kitFee?: number | null,
    stockMode?: ProductMaskStockMode | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateProductMaskSubscriptionVariables = {
  filter?: ModelSubscriptionProductMaskFilterInput | null,
};

export type OnUpdateProductMaskSubscription = {
  onUpdateProductMask?:  {
    __typename: "ProductMask",
    id: string,
    name?: string | null,
    sku?: string | null,
    productId?: string | null,
    clientId?: string | null,
    filterColors?: Array< string | null > | null,
    mainImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    increment?: number | null,
    fee?: number | null,
    discount?: number | null,
    stock?: number | null,
    categoryId?: string | null,
    sellMode?: ProductMaskSellMode | null,
    kitPieces?: number | null,
    kitIncrement?: number | null,
    kitFee?: number | null,
    stockMode?: ProductMaskStockMode | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteProductMaskSubscriptionVariables = {
  filter?: ModelSubscriptionProductMaskFilterInput | null,
};

export type OnDeleteProductMaskSubscription = {
  onDeleteProductMask?:  {
    __typename: "ProductMask",
    id: string,
    name?: string | null,
    sku?: string | null,
    productId?: string | null,
    clientId?: string | null,
    filterColors?: Array< string | null > | null,
    mainImage?:  {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null,
    increment?: number | null,
    fee?: number | null,
    discount?: number | null,
    stock?: number | null,
    categoryId?: string | null,
    sellMode?: ProductMaskSellMode | null,
    kitPieces?: number | null,
    kitIncrement?: number | null,
    kitFee?: number | null,
    stockMode?: ProductMaskStockMode | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateVariantMaskSubscriptionVariables = {
  filter?: ModelSubscriptionVariantMaskFilterInput | null,
};

export type OnCreateVariantMaskSubscription = {
  onCreateVariantMask?:  {
    __typename: "VariantMask",
    id: string,
    filterColors?: Array< string | null > | null,
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    stock?: number | null,
    stockMode?: VariantMaskStockMode | null,
    productMaskId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateVariantMaskSubscriptionVariables = {
  filter?: ModelSubscriptionVariantMaskFilterInput | null,
};

export type OnUpdateVariantMaskSubscription = {
  onUpdateVariantMask?:  {
    __typename: "VariantMask",
    id: string,
    filterColors?: Array< string | null > | null,
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    stock?: number | null,
    stockMode?: VariantMaskStockMode | null,
    productMaskId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteVariantMaskSubscriptionVariables = {
  filter?: ModelSubscriptionVariantMaskFilterInput | null,
};

export type OnDeleteVariantMaskSubscription = {
  onDeleteVariantMask?:  {
    __typename: "VariantMask",
    id: string,
    filterColors?: Array< string | null > | null,
    images?:  Array< {
      __typename: "File",
      key?: string | null,
      url?: string | null,
      color?: string | null,
      palette?: string | null,
      colorName?: string | null,
    } | null > | null,
    stock?: number | null,
    stockMode?: VariantMaskStockMode | null,
    productMaskId?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateProductMaskDescriptionSubscriptionVariables = {
  filter?: ModelSubscriptionProductMaskDescriptionFilterInput | null,
};

export type OnCreateProductMaskDescriptionSubscription = {
  onCreateProductMaskDescription?:  {
    __typename: "ProductMaskDescription",
    id: string,
    long_description?: string | null,
    short_description?: string | null,
    productDescriptionItem?:  Array< {
      __typename: "ProductDescriptionItem",
      index?: number | null,
      status?: boolean | null,
      key?: string | null,
      description?: string | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateProductMaskDescriptionSubscriptionVariables = {
  filter?: ModelSubscriptionProductMaskDescriptionFilterInput | null,
};

export type OnUpdateProductMaskDescriptionSubscription = {
  onUpdateProductMaskDescription?:  {
    __typename: "ProductMaskDescription",
    id: string,
    long_description?: string | null,
    short_description?: string | null,
    productDescriptionItem?:  Array< {
      __typename: "ProductDescriptionItem",
      index?: number | null,
      status?: boolean | null,
      key?: string | null,
      description?: string | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteProductMaskDescriptionSubscriptionVariables = {
  filter?: ModelSubscriptionProductMaskDescriptionFilterInput | null,
};

export type OnDeleteProductMaskDescriptionSubscription = {
  onDeleteProductMaskDescription?:  {
    __typename: "ProductMaskDescription",
    id: string,
    long_description?: string | null,
    short_description?: string | null,
    productDescriptionItem?:  Array< {
      __typename: "ProductDescriptionItem",
      index?: number | null,
      status?: boolean | null,
      key?: string | null,
      description?: string | null,
    } | null > | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateCouponSubscriptionVariables = {
  filter?: ModelSubscriptionCouponFilterInput | null,
};

export type OnCreateCouponSubscription = {
  onCreateCoupon?:  {
    __typename: "Coupon",
    id: string,
    code: string,
    name: string,
    description?: string | null,
    discountAmount?: number | null,
    discountPercentage?: number | null,
    minAmount?: number | null,
    maxAmount?: number | null,
    startDate: string,
    endDate: string,
    maxRedemptions?: number | null,
    maxRedemptionsPerUser?: number | null,
    applicableProducts?: Array< string | null > | null,
    applicableCategories?: Array< string | null > | null,
    excludedProducts?: Array< string | null > | null,
    status: string,
    createdBy: string,
    redemptions?:  {
      __typename: "ModelCouponRedemptionConnection",
      items:  Array< {
        __typename: "CouponRedemption",
        id: string,
        couponId: string,
        couponCode: string,
        userId: string,
        clientId?: string | null,
        orderId?: string | null,
        cartId?: string | null,
        discountApplied: number,
        originalAmount: number,
        finalAmount: number,
        appliedAt: string,
        ipAddress?: string | null,
        userAgent?: string | null,
        coupon:  {
          __typename: "Coupon",
          id: string,
          code: string,
          name: string,
          description?: string | null,
          discountAmount?: number | null,
          discountPercentage?: number | null,
          minAmount?: number | null,
          maxAmount?: number | null,
          startDate: string,
          endDate: string,
          maxRedemptions?: number | null,
          maxRedemptionsPerUser?: number | null,
          applicableProducts?: Array< string | null > | null,
          applicableCategories?: Array< string | null > | null,
          excludedProducts?: Array< string | null > | null,
          status: string,
          createdBy: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCouponSubscriptionVariables = {
  filter?: ModelSubscriptionCouponFilterInput | null,
};

export type OnUpdateCouponSubscription = {
  onUpdateCoupon?:  {
    __typename: "Coupon",
    id: string,
    code: string,
    name: string,
    description?: string | null,
    discountAmount?: number | null,
    discountPercentage?: number | null,
    minAmount?: number | null,
    maxAmount?: number | null,
    startDate: string,
    endDate: string,
    maxRedemptions?: number | null,
    maxRedemptionsPerUser?: number | null,
    applicableProducts?: Array< string | null > | null,
    applicableCategories?: Array< string | null > | null,
    excludedProducts?: Array< string | null > | null,
    status: string,
    createdBy: string,
    redemptions?:  {
      __typename: "ModelCouponRedemptionConnection",
      items:  Array< {
        __typename: "CouponRedemption",
        id: string,
        couponId: string,
        couponCode: string,
        userId: string,
        clientId?: string | null,
        orderId?: string | null,
        cartId?: string | null,
        discountApplied: number,
        originalAmount: number,
        finalAmount: number,
        appliedAt: string,
        ipAddress?: string | null,
        userAgent?: string | null,
        coupon:  {
          __typename: "Coupon",
          id: string,
          code: string,
          name: string,
          description?: string | null,
          discountAmount?: number | null,
          discountPercentage?: number | null,
          minAmount?: number | null,
          maxAmount?: number | null,
          startDate: string,
          endDate: string,
          maxRedemptions?: number | null,
          maxRedemptionsPerUser?: number | null,
          applicableProducts?: Array< string | null > | null,
          applicableCategories?: Array< string | null > | null,
          excludedProducts?: Array< string | null > | null,
          status: string,
          createdBy: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCouponSubscriptionVariables = {
  filter?: ModelSubscriptionCouponFilterInput | null,
};

export type OnDeleteCouponSubscription = {
  onDeleteCoupon?:  {
    __typename: "Coupon",
    id: string,
    code: string,
    name: string,
    description?: string | null,
    discountAmount?: number | null,
    discountPercentage?: number | null,
    minAmount?: number | null,
    maxAmount?: number | null,
    startDate: string,
    endDate: string,
    maxRedemptions?: number | null,
    maxRedemptionsPerUser?: number | null,
    applicableProducts?: Array< string | null > | null,
    applicableCategories?: Array< string | null > | null,
    excludedProducts?: Array< string | null > | null,
    status: string,
    createdBy: string,
    redemptions?:  {
      __typename: "ModelCouponRedemptionConnection",
      items:  Array< {
        __typename: "CouponRedemption",
        id: string,
        couponId: string,
        couponCode: string,
        userId: string,
        clientId?: string | null,
        orderId?: string | null,
        cartId?: string | null,
        discountApplied: number,
        originalAmount: number,
        finalAmount: number,
        appliedAt: string,
        ipAddress?: string | null,
        userAgent?: string | null,
        coupon:  {
          __typename: "Coupon",
          id: string,
          code: string,
          name: string,
          description?: string | null,
          discountAmount?: number | null,
          discountPercentage?: number | null,
          minAmount?: number | null,
          maxAmount?: number | null,
          startDate: string,
          endDate: string,
          maxRedemptions?: number | null,
          maxRedemptionsPerUser?: number | null,
          applicableProducts?: Array< string | null > | null,
          applicableCategories?: Array< string | null > | null,
          excludedProducts?: Array< string | null > | null,
          status: string,
          createdBy: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCouponRedemptionSubscriptionVariables = {
  filter?: ModelSubscriptionCouponRedemptionFilterInput | null,
};

export type OnCreateCouponRedemptionSubscription = {
  onCreateCouponRedemption?:  {
    __typename: "CouponRedemption",
    id: string,
    couponId: string,
    couponCode: string,
    userId: string,
    clientId?: string | null,
    orderId?: string | null,
    cartId?: string | null,
    discountApplied: number,
    originalAmount: number,
    finalAmount: number,
    appliedAt: string,
    ipAddress?: string | null,
    userAgent?: string | null,
    coupon:  {
      __typename: "Coupon",
      id: string,
      code: string,
      name: string,
      description?: string | null,
      discountAmount?: number | null,
      discountPercentage?: number | null,
      minAmount?: number | null,
      maxAmount?: number | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      applicableProducts?: Array< string | null > | null,
      applicableCategories?: Array< string | null > | null,
      excludedProducts?: Array< string | null > | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelCouponRedemptionConnection",
        items:  Array< {
          __typename: "CouponRedemption",
          id: string,
          couponId: string,
          couponCode: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          discountApplied: number,
          originalAmount: number,
          finalAmount: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCouponRedemptionSubscriptionVariables = {
  filter?: ModelSubscriptionCouponRedemptionFilterInput | null,
};

export type OnUpdateCouponRedemptionSubscription = {
  onUpdateCouponRedemption?:  {
    __typename: "CouponRedemption",
    id: string,
    couponId: string,
    couponCode: string,
    userId: string,
    clientId?: string | null,
    orderId?: string | null,
    cartId?: string | null,
    discountApplied: number,
    originalAmount: number,
    finalAmount: number,
    appliedAt: string,
    ipAddress?: string | null,
    userAgent?: string | null,
    coupon:  {
      __typename: "Coupon",
      id: string,
      code: string,
      name: string,
      description?: string | null,
      discountAmount?: number | null,
      discountPercentage?: number | null,
      minAmount?: number | null,
      maxAmount?: number | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      applicableProducts?: Array< string | null > | null,
      applicableCategories?: Array< string | null > | null,
      excludedProducts?: Array< string | null > | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelCouponRedemptionConnection",
        items:  Array< {
          __typename: "CouponRedemption",
          id: string,
          couponId: string,
          couponCode: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          discountApplied: number,
          originalAmount: number,
          finalAmount: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCouponRedemptionSubscriptionVariables = {
  filter?: ModelSubscriptionCouponRedemptionFilterInput | null,
};

export type OnDeleteCouponRedemptionSubscription = {
  onDeleteCouponRedemption?:  {
    __typename: "CouponRedemption",
    id: string,
    couponId: string,
    couponCode: string,
    userId: string,
    clientId?: string | null,
    orderId?: string | null,
    cartId?: string | null,
    discountApplied: number,
    originalAmount: number,
    finalAmount: number,
    appliedAt: string,
    ipAddress?: string | null,
    userAgent?: string | null,
    coupon:  {
      __typename: "Coupon",
      id: string,
      code: string,
      name: string,
      description?: string | null,
      discountAmount?: number | null,
      discountPercentage?: number | null,
      minAmount?: number | null,
      maxAmount?: number | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      applicableProducts?: Array< string | null > | null,
      applicableCategories?: Array< string | null > | null,
      excludedProducts?: Array< string | null > | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelCouponRedemptionConnection",
        items:  Array< {
          __typename: "CouponRedemption",
          id: string,
          couponId: string,
          couponCode: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          discountApplied: number,
          originalAmount: number,
          finalAmount: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePromotionSubscriptionVariables = {
  filter?: ModelSubscriptionPromotionFilterInput | null,
};

export type OnCreatePromotionSubscription = {
  onCreatePromotion?:  {
    __typename: "Promotion",
    id: string,
    name: string,
    description?: string | null,
    triggerProductIds: Array< string | null >,
    minQuantity: number,
    minAmount?: number | null,
    triggerRule: PromotionTriggerRule,
    giftProductId: string,
    giftQuantity: number,
    isStackable?: boolean | null,
    applicableClientIds?: Array< string | null > | null,
    startDate: string,
    endDate: string,
    maxRedemptions?: number | null,
    maxRedemptionsPerUser?: number | null,
    status: string,
    createdBy: string,
    redemptions?:  {
      __typename: "ModelPromotionRedemptionConnection",
      items:  Array< {
        __typename: "PromotionRedemption",
        id: string,
        promotionId: string,
        userId: string,
        clientId?: string | null,
        orderId?: string | null,
        cartId?: string | null,
        triggerQuantity: number,
        giftQuantityApplied: number,
        appliedAt: string,
        ipAddress?: string | null,
        userAgent?: string | null,
        promotion:  {
          __typename: "Promotion",
          id: string,
          name: string,
          description?: string | null,
          triggerProductIds: Array< string | null >,
          minQuantity: number,
          minAmount?: number | null,
          triggerRule: PromotionTriggerRule,
          giftProductId: string,
          giftQuantity: number,
          isStackable?: boolean | null,
          applicableClientIds?: Array< string | null > | null,
          startDate: string,
          endDate: string,
          maxRedemptions?: number | null,
          maxRedemptionsPerUser?: number | null,
          status: string,
          createdBy: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePromotionSubscriptionVariables = {
  filter?: ModelSubscriptionPromotionFilterInput | null,
};

export type OnUpdatePromotionSubscription = {
  onUpdatePromotion?:  {
    __typename: "Promotion",
    id: string,
    name: string,
    description?: string | null,
    triggerProductIds: Array< string | null >,
    minQuantity: number,
    minAmount?: number | null,
    triggerRule: PromotionTriggerRule,
    giftProductId: string,
    giftQuantity: number,
    isStackable?: boolean | null,
    applicableClientIds?: Array< string | null > | null,
    startDate: string,
    endDate: string,
    maxRedemptions?: number | null,
    maxRedemptionsPerUser?: number | null,
    status: string,
    createdBy: string,
    redemptions?:  {
      __typename: "ModelPromotionRedemptionConnection",
      items:  Array< {
        __typename: "PromotionRedemption",
        id: string,
        promotionId: string,
        userId: string,
        clientId?: string | null,
        orderId?: string | null,
        cartId?: string | null,
        triggerQuantity: number,
        giftQuantityApplied: number,
        appliedAt: string,
        ipAddress?: string | null,
        userAgent?: string | null,
        promotion:  {
          __typename: "Promotion",
          id: string,
          name: string,
          description?: string | null,
          triggerProductIds: Array< string | null >,
          minQuantity: number,
          minAmount?: number | null,
          triggerRule: PromotionTriggerRule,
          giftProductId: string,
          giftQuantity: number,
          isStackable?: boolean | null,
          applicableClientIds?: Array< string | null > | null,
          startDate: string,
          endDate: string,
          maxRedemptions?: number | null,
          maxRedemptionsPerUser?: number | null,
          status: string,
          createdBy: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePromotionSubscriptionVariables = {
  filter?: ModelSubscriptionPromotionFilterInput | null,
};

export type OnDeletePromotionSubscription = {
  onDeletePromotion?:  {
    __typename: "Promotion",
    id: string,
    name: string,
    description?: string | null,
    triggerProductIds: Array< string | null >,
    minQuantity: number,
    minAmount?: number | null,
    triggerRule: PromotionTriggerRule,
    giftProductId: string,
    giftQuantity: number,
    isStackable?: boolean | null,
    applicableClientIds?: Array< string | null > | null,
    startDate: string,
    endDate: string,
    maxRedemptions?: number | null,
    maxRedemptionsPerUser?: number | null,
    status: string,
    createdBy: string,
    redemptions?:  {
      __typename: "ModelPromotionRedemptionConnection",
      items:  Array< {
        __typename: "PromotionRedemption",
        id: string,
        promotionId: string,
        userId: string,
        clientId?: string | null,
        orderId?: string | null,
        cartId?: string | null,
        triggerQuantity: number,
        giftQuantityApplied: number,
        appliedAt: string,
        ipAddress?: string | null,
        userAgent?: string | null,
        promotion:  {
          __typename: "Promotion",
          id: string,
          name: string,
          description?: string | null,
          triggerProductIds: Array< string | null >,
          minQuantity: number,
          minAmount?: number | null,
          triggerRule: PromotionTriggerRule,
          giftProductId: string,
          giftQuantity: number,
          isStackable?: boolean | null,
          applicableClientIds?: Array< string | null > | null,
          startDate: string,
          endDate: string,
          maxRedemptions?: number | null,
          maxRedemptionsPerUser?: number | null,
          status: string,
          createdBy: string,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePromotionRedemptionSubscriptionVariables = {
  filter?: ModelSubscriptionPromotionRedemptionFilterInput | null,
};

export type OnCreatePromotionRedemptionSubscription = {
  onCreatePromotionRedemption?:  {
    __typename: "PromotionRedemption",
    id: string,
    promotionId: string,
    userId: string,
    clientId?: string | null,
    orderId?: string | null,
    cartId?: string | null,
    triggerQuantity: number,
    giftQuantityApplied: number,
    appliedAt: string,
    ipAddress?: string | null,
    userAgent?: string | null,
    promotion:  {
      __typename: "Promotion",
      id: string,
      name: string,
      description?: string | null,
      triggerProductIds: Array< string | null >,
      minQuantity: number,
      minAmount?: number | null,
      triggerRule: PromotionTriggerRule,
      giftProductId: string,
      giftQuantity: number,
      isStackable?: boolean | null,
      applicableClientIds?: Array< string | null > | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelPromotionRedemptionConnection",
        items:  Array< {
          __typename: "PromotionRedemption",
          id: string,
          promotionId: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          triggerQuantity: number,
          giftQuantityApplied: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePromotionRedemptionSubscriptionVariables = {
  filter?: ModelSubscriptionPromotionRedemptionFilterInput | null,
};

export type OnUpdatePromotionRedemptionSubscription = {
  onUpdatePromotionRedemption?:  {
    __typename: "PromotionRedemption",
    id: string,
    promotionId: string,
    userId: string,
    clientId?: string | null,
    orderId?: string | null,
    cartId?: string | null,
    triggerQuantity: number,
    giftQuantityApplied: number,
    appliedAt: string,
    ipAddress?: string | null,
    userAgent?: string | null,
    promotion:  {
      __typename: "Promotion",
      id: string,
      name: string,
      description?: string | null,
      triggerProductIds: Array< string | null >,
      minQuantity: number,
      minAmount?: number | null,
      triggerRule: PromotionTriggerRule,
      giftProductId: string,
      giftQuantity: number,
      isStackable?: boolean | null,
      applicableClientIds?: Array< string | null > | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelPromotionRedemptionConnection",
        items:  Array< {
          __typename: "PromotionRedemption",
          id: string,
          promotionId: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          triggerQuantity: number,
          giftQuantityApplied: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePromotionRedemptionSubscriptionVariables = {
  filter?: ModelSubscriptionPromotionRedemptionFilterInput | null,
};

export type OnDeletePromotionRedemptionSubscription = {
  onDeletePromotionRedemption?:  {
    __typename: "PromotionRedemption",
    id: string,
    promotionId: string,
    userId: string,
    clientId?: string | null,
    orderId?: string | null,
    cartId?: string | null,
    triggerQuantity: number,
    giftQuantityApplied: number,
    appliedAt: string,
    ipAddress?: string | null,
    userAgent?: string | null,
    promotion:  {
      __typename: "Promotion",
      id: string,
      name: string,
      description?: string | null,
      triggerProductIds: Array< string | null >,
      minQuantity: number,
      minAmount?: number | null,
      triggerRule: PromotionTriggerRule,
      giftProductId: string,
      giftQuantity: number,
      isStackable?: boolean | null,
      applicableClientIds?: Array< string | null > | null,
      startDate: string,
      endDate: string,
      maxRedemptions?: number | null,
      maxRedemptionsPerUser?: number | null,
      status: string,
      createdBy: string,
      redemptions?:  {
        __typename: "ModelPromotionRedemptionConnection",
        items:  Array< {
          __typename: "PromotionRedemption",
          id: string,
          promotionId: string,
          userId: string,
          clientId?: string | null,
          orderId?: string | null,
          cartId?: string | null,
          triggerQuantity: number,
          giftQuantityApplied: number,
          appliedAt: string,
          ipAddress?: string | null,
          userAgent?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateWalletBalanceSubscriptionVariables = {
  filter?: ModelSubscriptionWalletBalanceFilterInput | null,
};

export type OnCreateWalletBalanceSubscription = {
  onCreateWalletBalance?:  {
    __typename: "WalletBalance",
    id: string,
    balance?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnUpdateWalletBalanceSubscriptionVariables = {
  filter?: ModelSubscriptionWalletBalanceFilterInput | null,
};

export type OnUpdateWalletBalanceSubscription = {
  onUpdateWalletBalance?:  {
    __typename: "WalletBalance",
    id: string,
    balance?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnDeleteWalletBalanceSubscriptionVariables = {
  filter?: ModelSubscriptionWalletBalanceFilterInput | null,
};

export type OnDeleteWalletBalanceSubscription = {
  onDeleteWalletBalance?:  {
    __typename: "WalletBalance",
    id: string,
    balance?: number | null,
    createdAt?: string | null,
    updatedAt?: string | null,
  } | null,
};

export type OnCreateWalletMovementSubscriptionVariables = {
  filter?: ModelSubscriptionWalletMovementFilterInput | null,
};

export type OnCreateWalletMovementSubscription = {
  onCreateWalletMovement?:  {
    __typename: "WalletMovement",
    id: string,
    userId: string,
    type: WalletMovementType,
    amount: number,
    orderId?: string | null,
    createdByUserId?: string | null,
    couponId?: string | null,
    couponCode?: string | null,
    availableUntil?: string | null,
    isValidated?: boolean | null,
    validatedAt?: string | null,
    validatedBy?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateWalletMovementSubscriptionVariables = {
  filter?: ModelSubscriptionWalletMovementFilterInput | null,
};

export type OnUpdateWalletMovementSubscription = {
  onUpdateWalletMovement?:  {
    __typename: "WalletMovement",
    id: string,
    userId: string,
    type: WalletMovementType,
    amount: number,
    orderId?: string | null,
    createdByUserId?: string | null,
    couponId?: string | null,
    couponCode?: string | null,
    availableUntil?: string | null,
    isValidated?: boolean | null,
    validatedAt?: string | null,
    validatedBy?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteWalletMovementSubscriptionVariables = {
  filter?: ModelSubscriptionWalletMovementFilterInput | null,
};

export type OnDeleteWalletMovementSubscription = {
  onDeleteWalletMovement?:  {
    __typename: "WalletMovement",
    id: string,
    userId: string,
    type: WalletMovementType,
    amount: number,
    orderId?: string | null,
    createdByUserId?: string | null,
    couponId?: string | null,
    couponCode?: string | null,
    availableUntil?: string | null,
    isValidated?: boolean | null,
    validatedAt?: string | null,
    validatedBy?: string | null,
    createdAt?: string | null,
    updatedAt: string,
  } | null,
};
